// Ultimate Card Game (UCG) - High-Definition (24x24) Unit Sprites
//
// ── ARCHITECTURAL PARADIGM: 24×24 HD-FIRST ──────────────────────────────────────
// 24×24 is the canonical sprite grid and primary render standard for UCG.
// All new units, factions, and future races (e.g. Alien, Cybernetic, Void)
// must be authored natively in 24×24 resolution within this module.
//
// Runtime Behavior:
// - HD mode (24×24) is ENABLED BY DEFAULT everywhere with no URL parameter needed.
// - Legacy SD mode (14×14 / 16×16) is available as an opt-out via:
//     ?sd=1   or   ?sprites=sd
// - Backward compatibility is preserved: units without an HD definition automatically
//   fall back seamlessly to their legacy SD sprite grids in unitSprites.js.
// ─────────────────────────────────────────────────────────────────────────────

// ── FAITHFUL HD REFERENCE (Marine & HyperMarine 24x24) ──────

function getHD_Marine_Torso() {
  const g = 24, grid = makeGrid();

  // 1. Heavy Rear Life Support Backpack (x: 1..5, y: 3..11) - wider & chunkier
  for (let y = 3; y <= 11; y++) {
    grid[y][1] = '#0f172a'; grid[y][2] = '#1e293b'; grid[y][3] = '#334155'; grid[y][4] = '#1e293b';
  }
  grid[4][1] = '#38bdf8'; grid[4][2] = '#00f0ff';
  grid[5][1] = '#38bdf8'; grid[5][2] = '#00f0ff';
  grid[6][1] = '#0284c7'; grid[6][2] = '#38bdf8';
  grid[7][1] = '#0f172a'; grid[7][2] = '#1e293b';

  // 2. Helmet & Visor - Broad & Solid (x: 5..13, y: 1..6)
  // Top Dome (y: 1, x: 6..12)
  grid[1][6] = '#1e293b'; grid[1][7] = '#2563eb'; grid[1][8] = '#60a5fa';
  grid[1][9] = '#93c5fd'; grid[1][10] = '#60a5fa'; grid[1][11] = '#2563eb'; grid[1][12] = '#1e293b';

  // Upper Brow & Golden Visor (y: 2, x: 5..13)
  grid[2][5] = '#1e293b'; grid[2][6] = '#2563eb'; grid[2][7] = '#3b82f6'; grid[2][8] = '#60a5fa';
  grid[2][9] = '#fde047'; grid[2][10] = '#fde047'; grid[2][11] = '#facc15'; grid[2][12] = '#2563eb'; grid[2][13] = '#1e293b';

  // Mid Visor & Tactical HUD (y: 3, x: 5..14)
  grid[3][5] = '#1e293b'; grid[3][6] = '#2563eb'; grid[3][7] = '#3b82f6'; grid[3][8] = '#facc15';
  grid[3][9] = '#fde047'; grid[3][10] = '#fde047'; grid[3][11] = '#facc15'; grid[3][12] = '#ca8a04';
  grid[3][13] = '#00f0ff'; grid[3][14] = '#1e293b';

  // Lower Visor & Cheeks (y: 4, x: 5..13)
  grid[4][5] = '#1e293b'; grid[4][6] = '#2563eb'; grid[4][7] = '#2563eb'; grid[4][8] = '#eab308';
  grid[4][9] = '#facc15'; grid[4][10] = '#facc15'; grid[4][11] = '#ca8a04'; grid[4][12] = '#1e293b'; grid[4][13] = '#38bdf8';

  // Chin / Respirator (y: 5, x: 6..12)
  grid[5][6] = '#1e293b'; grid[5][7] = '#334155'; grid[5][8] = '#2563eb'; grid[5][9] = '#1e293b';
  grid[5][10] = '#1d4ed8'; grid[5][11] = '#334155'; grid[5][12] = '#1e293b';

  // Neck / Heavy Collar ring (y: 6, x: 5..12)
  grid[6][5] = '#0f172a'; grid[6][6] = '#1e293b'; grid[6][7] = '#334155'; grid[6][8] = '#334155';
  grid[6][9] = '#334155'; grid[6][10] = '#334155'; grid[6][11] = '#1e293b'; grid[6][12] = '#0f172a';

  // 3. MASSIVE CHUNKY PAULDRONS & ARMORED CHESTPLATE (x: 3..14, y: 6..12)
  // Broad Left Pauldron (x: 3..6, y: 6..10)
  for (let y = 6; y <= 10; y++) {
    grid[y][3] = '#0f172a'; grid[y][4] = '#1e293b'; grid[y][5] = '#2563eb';
  }
  grid[6][5] = '#3b82f6'; grid[6][6] = '#60a5fa';
  grid[7][4] = '#2563eb'; grid[7][5] = '#3b82f6'; grid[7][6] = '#60a5fa';
  grid[8][3] = '#1e293b'; grid[8][4] = '#2563eb'; grid[8][5] = '#3b82f6';

  // Chestplate Center & TEAM Insignia (x: 6..14, y: 7..12) - Broader 4x3 TEAM field!
  for (let y = 7; y <= 12; y++) {
    for (let x = 6; x <= 13; x++) {
      grid[y][x] = '#2563eb';
    }
  }
  // TEAM colors
  grid[8][7] = 'TEAM'; grid[8][8] = 'TEAM'; grid[8][9] = 'TEAM'; grid[8][10] = 'TEAM';
  grid[9][7] = 'TEAM'; grid[9][8] = 'TEAM'; grid[9][9] = 'TEAM'; grid[9][10] = 'TEAM';
  grid[10][7] = 'TEAM'; grid[10][8] = 'TEAM'; grid[10][9] = 'TEAM'; grid[10][10] = 'TEAM';

  // Chest shading & highlight
  grid[7][7] = '#60a5fa'; grid[7][8] = '#93c5fd'; grid[7][9] = '#60a5fa';
  grid[8][6] = '#60a5fa'; grid[8][11] = '#3b82f6'; grid[8][12] = '#2563eb'; grid[8][13] = '#1e293b';
  grid[9][6] = '#3b82f6'; grid[9][11] = '#3b82f6'; grid[9][12] = '#2563eb'; grid[9][13] = '#1e293b';
  grid[10][6] = '#2563eb'; grid[10][11] = '#2563eb'; grid[10][12] = '#1e293b';
  grid[11][5] = '#1e293b'; grid[11][6] = '#334155'; grid[11][11] = '#334155'; grid[11][12] = '#1e293b';

  return { grid, gridSize: g };
}

function getHD_Marine_Gun() {
  const g = 24, grid = makeGrid();
  // Gauss Rifle held across chest extending forward
  grid[8][9] = '#3b82f6'; grid[8][10] = '#60a5fa';
  grid[9][9] = '#2563eb'; grid[9][10] = '#3b82f6'; grid[9][11] = '#334155';
  grid[8][11] = '#1e293b'; grid[8][12] = '#0f172a'; grid[8][13] = '#1e293b';
  grid[9][12] = '#0f172a'; grid[9][13] = '#1e293b';
  grid[10][12] = '#0f172a'; grid[10][13] = '#1e293b'; grid[10][14] = '#0f172a';
  grid[11][13] = '#0f172a'; grid[11][14] = '#1e293b';
  grid[8][14] = '#475569'; grid[8][15] = '#64748b'; grid[8][16] = '#94a3b8'; grid[8][17] = '#94a3b8'; grid[8][18] = '#cbd5e1'; grid[8][19] = '#cbd5e1';
  grid[9][14] = '#334155'; grid[9][15] = '#475569'; grid[9][16] = '#64748b'; grid[9][17] = '#94a3b8'; grid[9][18] = '#cbd5e1'; grid[9][19] = '#ffffff'; grid[9][20] = '#ffffff';
  grid[10][15] = '#1e293b'; grid[10][16] = '#334155'; grid[10][17] = '#475569';
  return { grid, gridSize: g };
}

function getHD_Marine_Legs() {
  const g = 24, grid = makeGrid();
  grid[11][7] = '#1e293b'; grid[11][8] = '#1e293b'; grid[11][9] = '#64748b'; grid[11][10] = '#94a3b8'; grid[11][11] = '#64748b'; grid[11][12] = '#1e293b'; grid[11][13] = '#1e293b'; grid[11][14] = '#1e293b'; grid[11][15] = '#1e293b';
  grid[12][7] = '#1e293b'; grid[12][8] = '#1e293b'; grid[12][9] = '#64748b'; grid[12][10] = '#94a3b8'; grid[12][11] = '#64748b'; grid[12][12] = '#1e293b'; grid[12][13] = '#1e293b'; grid[12][14] = '#1e293b'; grid[12][15] = '#1e293b';
  grid[13][5] = '#1e293b'; grid[13][6] = '#1e293b'; grid[13][7] = '#2563eb'; grid[13][8] = '#2563eb'; grid[13][9] = '#3b82f6'; grid[13][12] = '#1e293b'; grid[13][13] = '#1e293b'; grid[13][14] = '#2563eb'; grid[13][15] = '#2563eb'; grid[13][16] = '#3b82f6'; grid[13][17] = '#3b82f6';
  grid[14][5] = '#1e293b'; grid[14][6] = '#1e293b'; grid[14][7] = '#2563eb'; grid[14][8] = '#2563eb'; grid[14][9] = '#3b82f6'; grid[14][12] = '#1e293b'; grid[14][13] = '#1e293b'; grid[14][14] = '#2563eb'; grid[14][15] = '#2563eb'; grid[14][16] = '#3b82f6'; grid[14][17] = '#3b82f6';
  grid[15][5] = '#1e293b'; grid[15][6] = '#1e293b'; grid[15][7] = '#60a5fa'; grid[15][8] = '#93c5fd'; grid[15][9] = '#3b82f6'; grid[15][12] = '#1e293b'; grid[15][13] = '#1e293b'; grid[15][14] = '#60a5fa'; grid[15][15] = '#93c5fd'; grid[15][16] = '#3b82f6'; grid[15][17] = '#3b82f6';
  grid[16][5] = '#1e293b'; grid[16][6] = '#1e293b'; grid[16][7] = '#60a5fa'; grid[16][8] = '#93c5fd'; grid[16][9] = '#3b82f6'; grid[16][12] = '#1e293b'; grid[16][13] = '#1e293b'; grid[16][14] = '#60a5fa'; grid[16][15] = '#93c5fd'; grid[16][16] = '#3b82f6'; grid[16][17] = '#3b82f6';
  grid[17][5] = '#1e293b'; grid[17][6] = '#1e293b'; grid[17][7] = '#2563eb'; grid[17][8] = '#2563eb'; grid[17][9] = '#3b82f6'; grid[17][12] = '#1e293b'; grid[17][13] = '#1e293b'; grid[17][14] = '#2563eb'; grid[17][15] = '#2563eb'; grid[17][16] = '#3b82f6'; grid[17][17] = '#3b82f6';
  grid[18][3] = '#1e293b'; grid[18][4] = '#1e293b'; grid[18][5] = '#334155'; grid[18][6] = '#334155'; grid[18][7] = '#475569'; grid[18][8] = '#475569'; grid[18][9] = '#1e293b'; grid[18][10] = '#1e293b'; grid[18][11] = '#1e293b'; grid[18][12] = '#334155'; grid[18][13] = '#334155'; grid[18][14] = '#475569'; grid[18][15] = '#475569'; grid[18][16] = '#1e293b'; grid[18][17] = '#1e293b';
  grid[19][3] = '#1e293b'; grid[19][4] = '#1e293b'; grid[19][5] = '#334155'; grid[19][6] = '#334155'; grid[19][7] = '#475569'; grid[19][8] = '#475569'; grid[19][9] = '#1e293b'; grid[19][10] = '#1e293b'; grid[19][11] = '#1e293b'; grid[19][12] = '#334155'; grid[19][13] = '#334155'; grid[19][14] = '#475569'; grid[19][15] = '#475569'; grid[19][16] = '#1e293b'; grid[19][17] = '#1e293b';
  grid[20][3] = '#0f172a'; grid[20][4] = '#0f172a'; grid[20][5] = '#1e293b'; grid[20][6] = '#1e293b'; grid[20][7] = '#334155'; grid[20][8] = '#334155'; grid[20][9] = '#0f172a'; grid[20][10] = '#0f172a'; grid[20][11] = '#0f172a'; grid[20][12] = '#1e293b'; grid[20][13] = '#1e293b'; grid[20][14] = '#334155'; grid[20][15] = '#334155'; grid[20][16] = '#0f172a'; grid[20][17] = '#0f172a';
  return { grid, gridSize: g };
}

function getHD_Marine_Legs_Walk1() {
  const g = 24, grid = makeGrid();
  grid[11][7] = '#1e293b'; grid[11][8] = '#1e293b'; grid[11][9] = '#64748b'; grid[11][10] = '#94a3b8'; grid[11][11] = '#64748b'; grid[11][12] = '#1e293b'; grid[11][13] = '#1e293b'; grid[11][14] = '#1e293b'; grid[11][15] = '#1e293b';
  grid[12][7] = '#1e293b'; grid[12][8] = '#1e293b'; grid[12][9] = '#64748b'; grid[12][10] = '#94a3b8'; grid[12][11] = '#64748b'; grid[12][12] = '#1e293b'; grid[12][13] = '#1e293b'; grid[12][14] = '#1e293b'; grid[12][15] = '#1e293b';
  grid[13][7] = '#1e293b'; grid[13][8] = '#1e293b'; grid[13][9] = '#2563eb'; grid[13][10] = '#1e293b'; grid[13][11] = '#1e293b'; grid[13][12] = '#2563eb'; grid[13][13] = '#2563eb'; grid[13][14] = '#3b82f6'; grid[13][15] = '#3b82f6';
  grid[14][7] = '#1e293b'; grid[14][8] = '#1e293b'; grid[14][9] = '#2563eb'; grid[14][10] = '#1e293b'; grid[14][11] = '#1e293b'; grid[14][12] = '#2563eb'; grid[14][13] = '#2563eb'; grid[14][14] = '#3b82f6'; grid[14][15] = '#3b82f6';
  grid[15][5] = '#1e293b'; grid[15][6] = '#1e293b'; grid[15][7] = '#2563eb'; grid[15][8] = '#2563eb'; grid[15][9] = '#60a5fa'; grid[15][12] = '#2563eb'; grid[15][13] = '#2563eb'; grid[15][14] = '#60a5fa'; grid[15][15] = '#93c5fd'; grid[15][16] = '#3b82f6'; grid[15][17] = '#3b82f6';
  grid[16][5] = '#1e293b'; grid[16][6] = '#1e293b'; grid[16][7] = '#2563eb'; grid[16][8] = '#2563eb'; grid[16][9] = '#60a5fa'; grid[16][12] = '#2563eb'; grid[16][13] = '#2563eb'; grid[16][14] = '#60a5fa'; grid[16][15] = '#93c5fd'; grid[16][16] = '#3b82f6'; grid[16][17] = '#3b82f6';
  grid[17][3] = '#0f172a'; grid[17][4] = '#0f172a'; grid[17][5] = '#1e293b'; grid[17][6] = '#1e293b'; grid[17][7] = '#334155'; grid[17][8] = '#334155'; grid[17][14] = '#1e293b'; grid[17][15] = '#1e293b'; grid[17][16] = '#2563eb'; grid[17][17] = '#2563eb'; grid[17][18] = '#3b82f6'; grid[17][19] = '#3b82f6';
  grid[18][1] = '#0f172a'; grid[18][2] = '#0f172a'; grid[18][3] = '#1e293b'; grid[18][4] = '#1e293b'; grid[18][5] = '#334155'; grid[18][6] = '#334155'; grid[18][14] = '#1e293b'; grid[18][15] = '#1e293b'; grid[18][16] = '#334155'; grid[18][17] = '#334155'; grid[18][18] = '#475569'; grid[18][19] = '#475569'; grid[18][20] = '#1e293b'; grid[18][21] = '#1e293b';
  grid[19][1] = '#0f172a'; grid[19][2] = '#0f172a'; grid[19][3] = '#1e293b'; grid[19][4] = '#1e293b'; grid[19][5] = '#334155'; grid[19][6] = '#334155'; grid[19][14] = '#1e293b'; grid[19][15] = '#1e293b'; grid[19][16] = '#334155'; grid[19][17] = '#334155'; grid[19][18] = '#475569'; grid[19][19] = '#475569'; grid[19][20] = '#1e293b'; grid[19][21] = '#1e293b';
  grid[20][3] = '#0f172a'; grid[20][4] = '#0f172a'; grid[20][5] = '#1e293b'; grid[20][6] = '#0f172a'; grid[20][14] = '#0f172a'; grid[20][15] = '#0f172a'; grid[20][16] = '#1e293b'; grid[20][17] = '#1e293b'; grid[20][18] = '#334155'; grid[20][19] = '#334155'; grid[20][20] = '#0f172a'; grid[20][21] = '#0f172a';
  return { grid, gridSize: g };
}

function getHD_Marine_Legs_Walk2() {
  const g = 24, grid = makeGrid();
  grid[11][7] = '#1e293b'; grid[11][8] = '#1e293b'; grid[11][9] = '#64748b'; grid[11][10] = '#94a3b8'; grid[11][11] = '#64748b'; grid[11][12] = '#1e293b'; grid[11][13] = '#1e293b'; grid[11][14] = '#1e293b'; grid[11][15] = '#1e293b';
  grid[12][7] = '#1e293b'; grid[12][8] = '#1e293b'; grid[12][9] = '#64748b'; grid[12][10] = '#94a3b8'; grid[12][11] = '#64748b'; grid[12][12] = '#1e293b'; grid[12][13] = '#1e293b'; grid[12][14] = '#1e293b'; grid[12][15] = '#1e293b';
  grid[13][5] = '#1e293b'; grid[13][6] = '#1e293b'; grid[13][7] = '#2563eb'; grid[13][8] = '#2563eb'; grid[13][9] = '#1e293b'; grid[13][10] = '#2563eb'; grid[13][11] = '#2563eb'; grid[13][12] = '#3b82f6'; grid[13][13] = '#3b82f6';
  grid[14][5] = '#1e293b'; grid[14][6] = '#1e293b'; grid[14][7] = '#2563eb'; grid[14][8] = '#2563eb'; grid[14][9] = '#1e293b'; grid[14][10] = '#2563eb'; grid[14][11] = '#2563eb'; grid[14][12] = '#3b82f6'; grid[14][13] = '#3b82f6';
  grid[15][3] = '#1e293b'; grid[15][4] = '#1e293b'; grid[15][5] = '#60a5fa'; grid[15][6] = '#93c5fd'; grid[15][7] = '#3b82f6'; grid[15][8] = '#3b82f6'; grid[15][9] = '#1e293b'; grid[15][10] = '#2563eb'; grid[15][11] = '#2563eb'; grid[15][12] = '#60a5fa'; grid[15][13] = '#93c5fd';
  grid[16][3] = '#1e293b'; grid[16][4] = '#1e293b'; grid[16][5] = '#60a5fa'; grid[16][6] = '#93c5fd'; grid[16][7] = '#3b82f6'; grid[16][8] = '#3b82f6'; grid[16][9] = '#1e293b'; grid[16][10] = '#2563eb'; grid[16][11] = '#2563eb'; grid[16][12] = '#60a5fa'; grid[16][13] = '#93c5fd';
  grid[17][3] = '#0f172a'; grid[17][4] = '#0f172a'; grid[17][5] = '#1e293b'; grid[17][6] = '#1e293b'; grid[17][7] = '#334155'; grid[17][8] = '#334155'; grid[17][9] = '#1e293b'; grid[17][10] = '#2563eb'; grid[17][11] = '#2563eb'; grid[17][12] = '#3b82f6'; grid[17][13] = '#3b82f6';
  grid[18][3] = '#0f172a'; grid[18][4] = '#0f172a'; grid[18][5] = '#1e293b'; grid[18][6] = '#1e293b'; grid[18][9] = '#1e293b'; grid[18][10] = '#334155'; grid[18][11] = '#334155'; grid[18][12] = '#475569'; grid[18][13] = '#475569'; grid[18][14] = '#1e293b'; grid[18][15] = '#1e293b';
  grid[19][3] = '#0f172a'; grid[19][4] = '#0f172a'; grid[19][5] = '#1e293b'; grid[19][6] = '#1e293b'; grid[19][9] = '#1e293b'; grid[19][10] = '#334155'; grid[19][11] = '#334155'; grid[19][12] = '#475569'; grid[19][13] = '#475569'; grid[19][14] = '#1e293b'; grid[19][15] = '#1e293b';
  grid[20][9] = '#0f172a'; grid[20][10] = '#1e293b'; grid[20][11] = '#1e293b'; grid[20][12] = '#334155'; grid[20][13] = '#334155'; grid[20][14] = '#0f172a'; grid[20][15] = '#0f172a';
  return { grid, gridSize: g };
}

function getHD_Marine_Legs_Walk3() {
  const g = 24, grid = makeGrid();
  grid[11][7] = '#1e293b'; grid[11][8] = '#1e293b'; grid[11][9] = '#64748b'; grid[11][10] = '#94a3b8'; grid[11][11] = '#64748b'; grid[11][12] = '#1e293b'; grid[11][13] = '#1e293b'; grid[11][14] = '#1e293b'; grid[11][15] = '#1e293b';
  grid[12][7] = '#1e293b'; grid[12][8] = '#1e293b'; grid[12][9] = '#64748b'; grid[12][10] = '#94a3b8'; grid[12][11] = '#64748b'; grid[12][12] = '#1e293b'; grid[12][13] = '#1e293b'; grid[12][14] = '#1e293b'; grid[12][15] = '#1e293b';
  grid[13][7] = '#1e293b'; grid[13][8] = '#1e293b'; grid[13][9] = '#2563eb'; grid[13][10] = '#3b82f6'; grid[13][11] = '#3b82f6'; grid[13][12] = '#1e293b'; grid[13][13] = '#1e293b'; grid[13][14] = '#2563eb'; grid[13][15] = '#2563eb';
  grid[14][7] = '#1e293b'; grid[14][8] = '#1e293b'; grid[14][9] = '#2563eb'; grid[14][10] = '#3b82f6'; grid[14][11] = '#3b82f6'; grid[14][12] = '#1e293b'; grid[14][13] = '#1e293b'; grid[14][14] = '#2563eb'; grid[14][15] = '#2563eb';
  grid[15][7] = '#1e293b'; grid[15][8] = '#1e293b'; grid[15][9] = '#2563eb'; grid[15][10] = '#60a5fa'; grid[15][11] = '#93c5fd'; grid[15][12] = '#60a5fa'; grid[15][13] = '#93c5fd'; grid[15][14] = '#3b82f6'; grid[15][15] = '#3b82f6'; grid[15][16] = '#60a5fa'; grid[15][17] = '#93c5fd';
  grid[16][7] = '#1e293b'; grid[16][8] = '#1e293b'; grid[16][9] = '#2563eb'; grid[16][10] = '#60a5fa'; grid[16][11] = '#93c5fd'; grid[16][12] = '#60a5fa'; grid[16][13] = '#93c5fd'; grid[16][14] = '#3b82f6'; grid[16][15] = '#3b82f6'; grid[16][16] = '#60a5fa'; grid[16][17] = '#93c5fd';
  grid[17][7] = '#1e293b'; grid[17][8] = '#1e293b'; grid[17][9] = '#2563eb'; grid[17][10] = '#3b82f6'; grid[17][11] = '#3b82f6'; grid[17][12] = '#1e293b'; grid[17][13] = '#1e293b'; grid[17][14] = '#334155'; grid[17][15] = '#334155'; grid[17][16] = '#475569'; grid[17][17] = '#475569';
  grid[18][7] = '#1e293b'; grid[18][8] = '#1e293b'; grid[18][9] = '#334155'; grid[18][10] = '#475569'; grid[18][11] = '#475569'; grid[18][12] = '#0f172a'; grid[18][13] = '#0f172a'; grid[18][14] = '#1e293b'; grid[18][15] = '#1e293b';
  grid[19][7] = '#1e293b'; grid[19][8] = '#1e293b'; grid[19][9] = '#334155'; grid[19][10] = '#475569'; grid[19][11] = '#475569'; grid[19][12] = '#0f172a'; grid[19][13] = '#0f172a'; grid[19][14] = '#1e293b'; grid[19][15] = '#1e293b';
  grid[20][7] = '#0f172a'; grid[20][8] = '#0f172a'; grid[20][9] = '#1e293b'; grid[20][10] = '#334155'; grid[20][11] = '#0f172a';
  return { grid, gridSize: g };
}

function getHD_Marine_Legs_Walk4() {
  const g = 24, grid = makeGrid();
  grid[11][7] = '#1e293b'; grid[11][8] = '#1e293b'; grid[11][9] = '#64748b'; grid[11][10] = '#94a3b8'; grid[11][11] = '#64748b'; grid[11][12] = '#1e293b'; grid[11][13] = '#1e293b'; grid[11][14] = '#1e293b'; grid[11][15] = '#1e293b';
  grid[12][7] = '#1e293b'; grid[12][8] = '#1e293b'; grid[12][9] = '#64748b'; grid[12][10] = '#94a3b8'; grid[12][11] = '#64748b'; grid[12][12] = '#1e293b'; grid[12][13] = '#1e293b'; grid[12][14] = '#1e293b'; grid[12][15] = '#1e293b';
  grid[13][7] = '#1e293b'; grid[13][8] = '#1e293b'; grid[13][9] = '#2563eb'; grid[13][10] = '#1e293b'; grid[13][11] = '#1e293b'; grid[13][12] = '#2563eb'; grid[13][13] = '#2563eb'; grid[13][14] = '#3b82f6'; grid[13][15] = '#3b82f6';
  grid[14][7] = '#1e293b'; grid[14][8] = '#1e293b'; grid[14][9] = '#2563eb'; grid[14][10] = '#1e293b'; grid[14][11] = '#1e293b'; grid[14][12] = '#2563eb'; grid[14][13] = '#2563eb'; grid[14][14] = '#3b82f6'; grid[14][15] = '#3b82f6';
  grid[15][5] = '#1e293b'; grid[15][6] = '#1e293b'; grid[15][7] = '#60a5fa'; grid[15][8] = '#93c5fd'; grid[15][9] = '#2563eb'; grid[15][12] = '#1e293b'; grid[15][13] = '#1e293b'; grid[15][14] = '#60a5fa'; grid[15][15] = '#93c5fd'; grid[15][16] = '#3b82f6'; grid[15][17] = '#3b82f6';
  grid[16][5] = '#1e293b'; grid[16][6] = '#1e293b'; grid[16][7] = '#60a5fa'; grid[16][8] = '#93c5fd'; grid[16][9] = '#2563eb'; grid[16][12] = '#1e293b'; grid[16][13] = '#1e293b'; grid[16][14] = '#60a5fa'; grid[16][15] = '#93c5fd'; grid[16][16] = '#3b82f6'; grid[16][17] = '#3b82f6';
  grid[17][3] = '#0f172a'; grid[17][4] = '#0f172a'; grid[17][5] = '#1e293b'; grid[17][6] = '#1e293b'; grid[17][7] = '#334155'; grid[17][8] = '#334155'; grid[17][12] = '#1e293b'; grid[17][13] = '#1e293b'; grid[17][14] = '#2563eb'; grid[17][15] = '#2563eb'; grid[17][16] = '#3b82f6'; grid[17][17] = '#3b82f6'; grid[17][18] = '#1e293b'; grid[17][19] = '#1e293b';
  grid[18][1] = '#0f172a'; grid[18][2] = '#0f172a'; grid[18][3] = '#1e293b'; grid[18][4] = '#1e293b'; grid[18][5] = '#334155'; grid[18][6] = '#334155'; grid[18][12] = '#1e293b'; grid[18][13] = '#1e293b'; grid[18][14] = '#334155'; grid[18][15] = '#334155'; grid[18][16] = '#475569'; grid[18][17] = '#475569'; grid[18][18] = '#1e293b'; grid[18][19] = '#1e293b';
  grid[19][1] = '#0f172a'; grid[19][2] = '#0f172a'; grid[19][3] = '#1e293b'; grid[19][4] = '#1e293b'; grid[19][5] = '#334155'; grid[19][6] = '#334155'; grid[19][12] = '#1e293b'; grid[19][13] = '#1e293b'; grid[19][14] = '#334155'; grid[19][15] = '#334155'; grid[19][16] = '#475569'; grid[19][17] = '#475569'; grid[19][18] = '#1e293b'; grid[19][19] = '#1e293b';
  grid[20][1] = '#0f172a'; grid[20][2] = '#0f172a'; grid[20][3] = '#1e293b'; grid[20][4] = '#0f172a'; grid[20][14] = '#0f172a'; grid[20][15] = '#0f172a'; grid[20][16] = '#1e293b'; grid[20][17] = '#1e293b'; grid[20][18] = '#334155'; grid[20][19] = '#0f172a';
  return { grid, gridSize: g };
}

function getHD_Marine_Legs_Walk5() {
  const g = 24, grid = makeGrid();
  grid[11][7] = '#1e293b'; grid[11][8] = '#1e293b'; grid[11][9] = '#64748b'; grid[11][10] = '#94a3b8'; grid[11][11] = '#64748b'; grid[11][12] = '#1e293b'; grid[11][13] = '#1e293b'; grid[11][14] = '#1e293b'; grid[11][15] = '#1e293b';
  grid[12][7] = '#1e293b'; grid[12][8] = '#1e293b'; grid[12][9] = '#64748b'; grid[12][10] = '#94a3b8'; grid[12][11] = '#64748b'; grid[12][12] = '#1e293b'; grid[12][13] = '#1e293b'; grid[12][14] = '#1e293b'; grid[12][15] = '#1e293b';
  grid[13][5] = '#1e293b'; grid[13][6] = '#1e293b'; grid[13][7] = '#2563eb'; grid[13][8] = '#2563eb'; grid[13][9] = '#1e293b'; grid[13][10] = '#2563eb'; grid[13][11] = '#2563eb'; grid[13][12] = '#3b82f6'; grid[13][13] = '#3b82f6';
  grid[14][5] = '#1e293b'; grid[14][6] = '#1e293b'; grid[14][7] = '#2563eb'; grid[14][8] = '#2563eb'; grid[14][9] = '#1e293b'; grid[14][10] = '#2563eb'; grid[14][11] = '#2563eb'; grid[14][12] = '#3b82f6'; grid[14][13] = '#3b82f6';
  grid[15][3] = '#1e293b'; grid[15][4] = '#1e293b'; grid[15][5] = '#60a5fa'; grid[15][6] = '#93c5fd'; grid[15][7] = '#3b82f6'; grid[15][8] = '#3b82f6'; grid[15][9] = '#1e293b'; grid[15][10] = '#2563eb'; grid[15][11] = '#2563eb'; grid[15][12] = '#60a5fa'; grid[15][13] = '#93c5fd';
  grid[16][3] = '#1e293b'; grid[16][4] = '#1e293b'; grid[16][5] = '#60a5fa'; grid[16][6] = '#93c5fd'; grid[16][7] = '#3b82f6'; grid[16][8] = '#3b82f6'; grid[16][9] = '#1e293b'; grid[16][10] = '#2563eb'; grid[16][11] = '#2563eb'; grid[16][12] = '#60a5fa'; grid[16][13] = '#93c5fd';
  grid[17][3] = '#0f172a'; grid[17][4] = '#0f172a'; grid[17][5] = '#1e293b'; grid[17][6] = '#1e293b'; grid[17][7] = '#334155'; grid[17][8] = '#334155'; grid[17][9] = '#1e293b'; grid[17][10] = '#2563eb'; grid[17][11] = '#2563eb'; grid[17][12] = '#3b82f6'; grid[17][13] = '#3b82f6';
  grid[18][3] = '#0f172a'; grid[18][4] = '#0f172a'; grid[18][5] = '#1e293b'; grid[18][6] = '#1e293b'; grid[18][9] = '#1e293b'; grid[18][10] = '#334155'; grid[18][11] = '#334155'; grid[18][12] = '#475569'; grid[18][13] = '#475569'; grid[18][14] = '#1e293b'; grid[18][15] = '#1e293b';
  grid[19][3] = '#0f172a'; grid[19][4] = '#0f172a'; grid[19][5] = '#1e293b'; grid[19][6] = '#1e293b'; grid[19][9] = '#1e293b'; grid[19][10] = '#334155'; grid[19][11] = '#334155'; grid[19][12] = '#475569'; grid[19][13] = '#475569'; grid[19][14] = '#1e293b'; grid[19][15] = '#1e293b';
  grid[20][9] = '#0f172a'; grid[20][10] = '#1e293b'; grid[20][11] = '#1e293b'; grid[20][12] = '#334155'; grid[20][13] = '#334155'; grid[20][14] = '#0f172a'; grid[20][15] = '#0f172a';
  return { grid, gridSize: g };
}

function getHD_Marine_Legs_Walk6() {
  const g = 24, grid = makeGrid();
  grid[11][7] = '#1e293b'; grid[11][8] = '#1e293b'; grid[11][9] = '#64748b'; grid[11][10] = '#94a3b8'; grid[11][11] = '#64748b'; grid[11][12] = '#1e293b'; grid[11][13] = '#1e293b'; grid[11][14] = '#1e293b'; grid[11][15] = '#1e293b';
  grid[12][7] = '#1e293b'; grid[12][8] = '#1e293b'; grid[12][9] = '#64748b'; grid[12][10] = '#94a3b8'; grid[12][11] = '#64748b'; grid[12][12] = '#1e293b'; grid[12][13] = '#1e293b'; grid[12][14] = '#1e293b'; grid[12][15] = '#1e293b';
  grid[13][7] = '#1e293b'; grid[13][8] = '#1e293b'; grid[13][9] = '#2563eb'; grid[13][10] = '#3b82f6'; grid[13][11] = '#3b82f6'; grid[13][12] = '#1e293b'; grid[13][13] = '#1e293b'; grid[13][14] = '#2563eb'; grid[13][15] = '#2563eb';
  grid[14][7] = '#1e293b'; grid[14][8] = '#1e293b'; grid[14][9] = '#2563eb'; grid[14][10] = '#3b82f6'; grid[14][11] = '#3b82f6'; grid[14][12] = '#1e293b'; grid[14][13] = '#1e293b'; grid[14][14] = '#2563eb'; grid[14][15] = '#2563eb';
  grid[15][7] = '#1e293b'; grid[15][8] = '#1e293b'; grid[15][9] = '#2563eb'; grid[15][10] = '#60a5fa'; grid[15][11] = '#93c5fd'; grid[15][12] = '#60a5fa'; grid[15][13] = '#93c5fd'; grid[15][14] = '#3b82f6'; grid[15][15] = '#3b82f6'; grid[15][16] = '#60a5fa'; grid[15][17] = '#93c5fd';
  grid[16][7] = '#1e293b'; grid[16][8] = '#1e293b'; grid[16][9] = '#2563eb'; grid[16][10] = '#60a5fa'; grid[16][11] = '#93c5fd'; grid[16][12] = '#60a5fa'; grid[16][13] = '#93c5fd'; grid[16][14] = '#3b82f6'; grid[16][15] = '#3b82f6'; grid[16][16] = '#60a5fa'; grid[16][17] = '#93c5fd';
  grid[17][7] = '#1e293b'; grid[17][8] = '#1e293b'; grid[17][9] = '#2563eb'; grid[17][10] = '#3b82f6'; grid[17][11] = '#3b82f6'; grid[17][12] = '#1e293b'; grid[17][13] = '#1e293b'; grid[17][14] = '#334155'; grid[17][15] = '#334155'; grid[17][16] = '#475569'; grid[17][17] = '#475569';
  grid[18][7] = '#1e293b'; grid[18][8] = '#1e293b'; grid[18][9] = '#334155'; grid[18][10] = '#475569'; grid[18][11] = '#475569'; grid[18][12] = '#0f172a'; grid[18][13] = '#0f172a'; grid[18][14] = '#1e293b'; grid[18][15] = '#1e293b';
  grid[19][7] = '#1e293b'; grid[19][8] = '#1e293b'; grid[19][9] = '#334155'; grid[19][10] = '#475569'; grid[19][11] = '#475569'; grid[19][12] = '#0f172a'; grid[19][13] = '#0f172a'; grid[19][14] = '#1e293b'; grid[19][15] = '#1e293b';
  grid[20][7] = '#0f172a'; grid[20][8] = '#0f172a'; grid[20][9] = '#1e293b'; grid[20][10] = '#334155'; grid[20][11] = '#0f172a';
  return { grid, gridSize: g };
}

// Convert Marine walk frames to HyperMarine colors
function makeHyperWalk(marineGrid) {
  const g = 24, grid = makeGrid();
  const mg = marineGrid.grid;
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      const c = mg[y][x];
      if (!c) continue;
      if (c === '#2563eb') grid[y][x] = '#b91c1c';
      else if (c === '#3b82f6') grid[y][x] = '#ef4444';
      else if (c === '#60a5fa') grid[y][x] = '#f87171';
      else if (c === '#93c5fd') grid[y][x] = '#fecaca';
      else if (c === '#1d4ed8') grid[y][x] = '#7f1d1d';
      else if (c === '#334155') grid[y][x] = '#450a0a';
      else if (c === '#475569') grid[y][x] = '#7f1d1d';
      else if (c === '#64748b') grid[y][x] = '#b45309';
      else if (c === '#94a3b8') grid[y][x] = '#f59e0b';
      else if (c === '#1e293b') grid[y][x] = '#1c1210';
      else if (c === '#0f172a') grid[y][x] = '#120a08';
      else grid[y][x] = c;
    }
  }
  return { grid, gridSize: g };
}

function getHD_HyperMarine_Legs() { return makeHyperWalk(getHD_Marine_Legs()); }
function getHD_HyperMarine_Legs_Walk1() { return makeHyperWalk(getHD_Marine_Legs_Walk1()); }
function getHD_HyperMarine_Legs_Walk2() { return makeHyperWalk(getHD_Marine_Legs_Walk2()); }
function getHD_HyperMarine_Legs_Walk3() { return makeHyperWalk(getHD_Marine_Legs_Walk3()); }
function getHD_HyperMarine_Legs_Walk4() { return makeHyperWalk(getHD_Marine_Legs_Walk4()); }
function getHD_HyperMarine_Legs_Walk5() { return makeHyperWalk(getHD_Marine_Legs_Walk5()); }
function getHD_HyperMarine_Legs_Walk6() { return makeHyperWalk(getHD_Marine_Legs_Walk6()); }

function getHD_Marine() {
  const g = 24, grid = makeGrid();
  const l = getHD_Marine_Legs().grid, t = getHD_Marine_Torso().grid, gn = getHD_Marine_Gun().grid;
  for (let y = 0; y < 24; y++) {
    for (let x = 0; x < 24; x++) {
      if (l[y][x]) grid[y][x] = l[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
      if (gn[y][x]) grid[y][x] = gn[y][x];
    }
  }
  return { grid, gridSize: g };
}

function getHD_HyperMarine_Torso() {
  const g = 24, grid = makeGrid();

  // 1. Heavy Rear Life Support Backpack (x: 1..5, y: 3..11)
  for (let y = 3; y <= 11; y++) {
    grid[y][1] = '#120a08'; grid[y][2] = '#1c1210'; grid[y][3] = '#450a0a'; grid[y][4] = '#1c1210';
  }
  grid[4][1] = '#fb923c'; grid[4][2] = '#ffb454';
  grid[5][1] = '#fb923c'; grid[5][2] = '#ffb454';
  grid[6][1] = '#ea580c'; grid[6][2] = '#fb923c';
  grid[7][1] = '#120a08'; grid[7][2] = '#1c1210';

  // 2. Helmet & Visor - Broad & Solid (x: 5..13, y: 1..6)
  grid[1][6] = '#1c1210'; grid[1][7] = '#b91c1c'; grid[1][8] = '#f87171';
  grid[1][9] = '#fecaca'; grid[1][10] = '#f87171'; grid[1][11] = '#b91c1c'; grid[1][12] = '#1c1210';

  grid[2][5] = '#1c1210'; grid[2][6] = '#b91c1c'; grid[2][7] = '#ef4444'; grid[2][8] = '#f87171';
  grid[2][9] = '#fde047'; grid[2][10] = '#fde047'; grid[2][11] = '#facc15'; grid[2][12] = '#b91c1c'; grid[2][13] = '#1c1210';

  grid[3][5] = '#1c1210'; grid[3][6] = '#b91c1c'; grid[3][8] = '#facc15';
  grid[3][7] = '#ef4444';
  grid[3][9] = '#fde047'; grid[3][10] = '#fde047'; grid[3][11] = '#facc15'; grid[3][12] = '#ca8a04';
  grid[3][13] = '#ffb454'; grid[3][14] = '#1c1210';

  grid[4][5] = '#1c1210'; grid[4][6] = '#b91c1c'; grid[4][7] = '#b91c1c'; grid[4][8] = '#eab308';
  grid[4][9] = '#facc15'; grid[4][10] = '#facc15'; grid[4][11] = '#ca8a04'; grid[4][12] = '#1c1210'; grid[4][13] = '#fb923c';

  grid[5][6] = '#1c1210'; grid[5][7] = '#450a0a'; grid[5][8] = '#b91c1c'; grid[5][9] = '#1c1210';
  grid[5][10] = '#7f1d1d'; grid[5][11] = '#450a0a'; grid[5][12] = '#1c1210';

  grid[6][5] = '#120a08'; grid[6][6] = '#1c1210'; grid[6][7] = '#450a0a'; grid[6][8] = '#450a0a';
  grid[6][9] = '#450a0a'; grid[6][10] = '#450a0a'; grid[6][11] = '#1c1210'; grid[6][12] = '#120a08';

  // 3. MASSIVE CHUNKY CRIMSON PAULDRONS & CHESTPLATE (x: 3..14, y: 6..12)
  for (let y = 6; y <= 10; y++) {
    grid[y][3] = '#120a08'; grid[y][4] = '#1c1210'; grid[y][5] = '#b91c1c';
  }
  grid[6][5] = '#ef4444'; grid[6][6] = '#f87171';
  grid[7][4] = '#b91c1c'; grid[7][5] = '#ef4444'; grid[7][6] = '#f87171';
  grid[8][3] = '#1c1210'; grid[8][4] = '#b91c1c'; grid[8][5] = '#ef4444';

  for (let y = 7; y <= 12; y++) {
    for (let x = 6; x <= 13; x++) {
      grid[y][x] = '#b91c1c';
    }
  }
  // TEAM colors
  grid[8][7] = 'TEAM'; grid[8][8] = 'TEAM'; grid[8][9] = 'TEAM'; grid[8][10] = 'TEAM';
  grid[9][7] = 'TEAM'; grid[9][8] = 'TEAM'; grid[9][9] = 'TEAM'; grid[9][10] = 'TEAM';
  grid[10][7] = 'TEAM'; grid[10][8] = 'TEAM'; grid[10][9] = 'TEAM'; grid[10][10] = 'TEAM';

  grid[7][7] = '#ef4444'; grid[7][8] = '#f87171'; grid[7][9] = '#ef4444';
  grid[8][6] = '#f87171'; grid[8][11] = '#ef4444'; grid[8][12] = '#b91c1c'; grid[8][13] = '#1c1210';
  grid[9][6] = '#ef4444'; grid[9][11] = '#ef4444'; grid[9][12] = '#b91c1c'; grid[9][13] = '#1c1210';
  grid[10][6] = '#b91c1c'; grid[10][11] = '#b91c1c'; grid[10][12] = '#1c1210';
  grid[11][5] = '#1c1210'; grid[11][6] = '#450a0a'; grid[11][11] = '#450a0a'; grid[11][12] = '#1c1210';

  return { grid, gridSize: g };
}

function getHD_HyperMarine_Gun() {
  const g = 24, grid = makeGrid();
  // Plasma Gun with Overcharge Coils
  grid[8][9] = '#ef4444'; grid[8][10] = '#f87171';
  grid[9][9] = '#b91c1c'; grid[9][10] = '#ef4444'; grid[9][11] = '#334155';
  grid[8][11] = '#1e293b'; grid[8][12] = '#0f172a'; grid[8][13] = '#1e293b';
  grid[9][12] = '#0f172a'; grid[9][13] = '#1e293b';
  grid[10][12] = '#0f172a'; grid[10][13] = '#1e293b'; grid[10][14] = '#0f172a';
  grid[11][13] = '#0f172a'; grid[11][14] = '#1e293b';
  // Overcharged barrel
  grid[8][14] = '#78350f'; grid[8][15] = '#b45309'; grid[8][16] = '#d97706'; grid[8][17] = '#f59e0b'; grid[8][18] = '#fbbf24'; grid[8][19] = '#fde047';
  grid[9][14] = '#b45309'; grid[9][15] = '#d97706'; grid[9][16] = '#f59e0b'; grid[9][17] = '#fbbf24'; grid[9][18] = '#fef08a'; grid[9][19] = '#ffffff'; grid[9][20] = '#ffffff';
  grid[10][15] = '#1c1210'; grid[10][16] = '#450a0a'; grid[10][17] = '#b45309';
  return { grid, gridSize: g };
}

function getHD_HyperMarine() {
  const g = 24, grid = makeGrid();
  const l = getHD_HyperMarine_Legs().grid, t = getHD_HyperMarine_Torso().grid, gn = getHD_HyperMarine_Gun().grid;
  for (let y = 0; y < 24; y++) {
    for (let x = 0; x < 24; x++) {
      if (l[y][x]) grid[y][x] = l[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
      if (gn[y][x]) grid[y][x] = gn[y][x];
    }
  }
  return { grid, gridSize: g };
}

function getHD_DevilPatrol_Legs() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  grid[14][6]='#0c0a09'; grid[14][7]='#1c1917'; grid[14][8]='#292524'; grid[14][9]='#f97316'; grid[14][10]='#fbbf24'; grid[14][11]='#292524'; grid[14][12]='#1c1917'; grid[14][13]='#0c0a09'; grid[15][7]='#1c1917'; grid[15][8]='#44403c'; grid[15][9]='#1c1917'; grid[15][10]='#44403c'; grid[15][11]='#1c1917'; grid[16][5]='#1c1917'; grid[16][6]='#44403c'; grid[16][7]='#78350f'; grid[16][8]='#1c1917'; grid[16][10]='#1c1917'; grid[16][11]='#44403c'; grid[16][12]='#78350f'; grid[16][13]='#1c1917'; grid[17][5]='#1c1917'; grid[17][6]='#b45309'; grid[17][7]='#78350f'; grid[17][8]='#1c1917'; grid[17][10]='#1c1917'; grid[17][11]='#b45309'; grid[17][12]='#fef08a'; grid[17][13]='#78350f'; grid[18][5]='#1c1917'; grid[18][6]='#44403c'; grid[18][7]='#78350f'; grid[18][8]='#1c1917'; grid[18][10]='#1c1917'; grid[18][11]='#44403c'; grid[18][12]='#78350f'; grid[18][13]='#1c1917'; grid[19][5]='#0c0a09'; grid[19][6]='#1c1917'; grid[19][7]='#44403c'; grid[19][8]='#1c1917'; grid[19][10]='#0c0a09'; grid[19][11]='#1c1917'; grid[19][12]='#44403c'; grid[19][13]='#1c1917'; grid[20][4]='#1c1917'; grid[20][5]='#292524'; grid[20][6]='#44403c'; grid[20][7]='#292524'; grid[20][8]='#1c1917'; grid[20][9]='#1c1917'; grid[20][10]='#292524'; grid[20][11]='#44403c'; grid[20][12]='#f97316'; grid[20][13]='#292524'; grid[20][14]='#1c1917'; grid[21][4]='#0c0a09'; grid[21][5]='#1c1917'; grid[21][6]='#292524'; grid[21][7]='#44403c'; grid[21][8]='#1c1917'; grid[21][9]='#0c0a09'; grid[21][10]='#1c1917'; grid[21][11]='#292524'; grid[21][12]='#44403c'; grid[21][13]='#292524'; grid[21][14]='#0c0a09'; grid[22][3]='#0c0a09'; grid[22][4]='#1c1917'; grid[22][5]='#1c1917'; grid[22][6]='#292524'; grid[22][7]='#1c1917'; grid[22][9]='#0c0a09'; grid[22][10]='#1c1917'; grid[22][11]='#1c1917'; grid[22][12]='#292524'; grid[22][13]='#292524'; grid[22][14]='#0c0a09';
  return { grid, gridSize: g };
}
function getHD_DevilPatrol_Legs_Walk1() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  grid[14][6]='#0c0a09'; grid[14][7]='#1c1917'; grid[14][8]='#292524'; grid[14][9]='#f97316'; grid[14][10]='#fbbf24'; grid[14][11]='#292524'; grid[14][12]='#1c1917'; grid[14][13]='#0c0a09'; grid[15][7]='#1c1917'; grid[15][8]='#44403c'; grid[15][9]='#1c1917'; grid[15][10]='#44403c'; grid[15][11]='#1c1917'; grid[16][4]='#0c0a09'; grid[16][5]='#1c1917'; grid[16][6]='#44403c'; grid[16][7]='#78350f'; grid[16][8]='#44403c'; grid[16][9]='#1c1917'; grid[16][10]='#78350f'; grid[16][11]='#44403c'; grid[16][12]='#1c1917'; grid[17][3]='#0c0a09'; grid[17][4]='#1c1917'; grid[17][5]='#44403c'; grid[17][6]='#78350f'; grid[17][7]='#44403c'; grid[17][8]='#1c1917'; grid[17][9]='#1c1917'; grid[17][10]='#44403c'; grid[17][11]='#78350f'; grid[17][12]='#44403c'; grid[17][13]='#1c1917'; grid[18][2]='#0c0a09'; grid[18][3]='#1c1917'; grid[18][4]='#44403c'; grid[18][5]='#78350f'; grid[18][6]='#44403c'; grid[18][7]='#1c1917'; grid[18][8]='#1c1917'; grid[18][9]='#44403c'; grid[18][10]='#b45309'; grid[18][11]='#fef08a'; grid[18][12]='#78350f'; grid[18][13]='#1c1917'; grid[19][1]='#0c0a09'; grid[19][2]='#1c1917'; grid[19][3]='#44403c'; grid[19][4]='#78350f'; grid[19][5]='#44403c'; grid[19][6]='#1c1917'; grid[19][9]='#0c0a09'; grid[19][10]='#1c1917'; grid[19][11]='#44403c'; grid[19][12]='#78350f'; grid[19][13]='#44403c'; grid[19][14]='#1c1917'; grid[20][1]='#fbbf24'; grid[20][2]='#1c1917'; grid[20][3]='#292524'; grid[20][4]='#44403c'; grid[20][5]='#f97316'; grid[20][6]='#292524'; grid[20][7]='#1c1917'; grid[20][10]='#0c0a09'; grid[20][11]='#1c1917'; grid[20][12]='#44403c'; grid[20][13]='#78350f'; grid[20][14]='#44403c'; grid[20][15]='#1c1917'; grid[21][1]='#0c0a09'; grid[21][2]='#0c0a09'; grid[21][3]='#1c1917'; grid[21][4]='#292524'; grid[21][5]='#292524'; grid[21][6]='#1c1917'; grid[21][7]='#0c0a09'; grid[21][10]='#0c0a09'; grid[21][11]='#1c1917'; grid[21][12]='#292524'; grid[21][13]='#44403c'; grid[21][14]='#f97316'; grid[21][15]='#292524'; grid[21][16]='#fbbf24'; grid[22][10]='#0c0a09'; grid[22][11]='#0c0a09'; grid[22][12]='#1c1917'; grid[22][13]='#292524'; grid[22][14]='#292524'; grid[22][15]='#1c1917'; grid[22][16]='#0c0a09';
  return { grid, gridSize: g };
}
function getHD_DevilPatrol_Legs_Walk2() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  grid[14][6]='#0c0a09'; grid[14][7]='#1c1917'; grid[14][8]='#292524'; grid[14][9]='#f97316'; grid[14][10]='#fbbf24'; grid[14][11]='#292524'; grid[14][12]='#1c1917'; grid[14][13]='#0c0a09'; grid[15][7]='#1c1917'; grid[15][8]='#44403c'; grid[15][9]='#1c1917'; grid[15][10]='#44403c'; grid[15][11]='#1c1917'; grid[16][5]='#0c0a09'; grid[16][6]='#1c1917'; grid[16][7]='#44403c'; grid[16][8]='#78350f'; grid[16][9]='#1c1917'; grid[16][10]='#78350f'; grid[16][11]='#44403c'; grid[16][12]='#1c1917'; grid[17][4]='#0c0a09'; grid[17][5]='#1c1917'; grid[17][6]='#44403c'; grid[17][7]='#78350f'; grid[17][8]='#1c1917'; grid[17][9]='#44403c'; grid[17][10]='#78350f'; grid[17][11]='#44403c'; grid[17][12]='#1c1917'; grid[18][4]='#0c0a09'; grid[18][5]='#1c1917'; grid[18][6]='#44403c'; grid[18][7]='#78350f'; grid[18][8]='#1c1917'; grid[18][9]='#b45309'; grid[18][10]='#fef08a'; grid[18][11]='#78350f'; grid[18][12]='#1c1917'; grid[19][3]='#fbbf24'; grid[19][4]='#1c1917'; grid[19][5]='#292524'; grid[19][6]='#44403c'; grid[19][7]='#f97316'; grid[19][8]='#292524'; grid[19][9]='#1c1917'; grid[19][10]='#78350f'; grid[19][11]='#44403c'; grid[19][12]='#1c1917'; grid[20][3]='#0c0a09'; grid[20][4]='#0c0a09'; grid[20][5]='#1c1917'; grid[20][6]='#292524'; grid[20][7]='#292524'; grid[20][8]='#1c1917'; grid[20][9]='#0c0a09'; grid[20][10]='#78350f'; grid[20][11]='#44403c'; grid[20][12]='#1c1917'; grid[21][7]='#0c0a09'; grid[21][8]='#1c1917'; grid[21][9]='#292524'; grid[21][10]='#44403c'; grid[21][11]='#f97316'; grid[21][12]='#292524'; grid[21][13]='#fbbf24'; grid[22][7]='#0c0a09'; grid[22][8]='#0c0a09'; grid[22][9]='#1c1917'; grid[22][10]='#292524'; grid[22][11]='#292524'; grid[22][12]='#1c1917'; grid[22][13]='#0c0a09';
  return { grid, gridSize: g };
}
function getHD_DevilPatrol_Legs_Walk3() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  grid[14][6]='#0c0a09'; grid[14][7]='#1c1917'; grid[14][8]='#292524'; grid[14][9]='#f97316'; grid[14][10]='#fbbf24'; grid[14][11]='#292524'; grid[14][12]='#1c1917'; grid[14][13]='#0c0a09'; grid[15][7]='#1c1917'; grid[15][8]='#44403c'; grid[15][9]='#1c1917'; grid[15][10]='#44403c'; grid[15][11]='#1c1917'; grid[16][4]='#0c0a09'; grid[16][5]='#1c1917'; grid[16][6]='#44403c'; grid[16][7]='#78350f'; grid[16][8]='#44403c'; grid[16][9]='#1c1917'; grid[16][10]='#0c0a09'; grid[16][11]='#1c1917'; grid[16][12]='#44403c'; grid[16][13]='#78350f'; grid[16][14]='#1c1917'; grid[17][4]='#0c0a09'; grid[17][5]='#1c1917'; grid[17][6]='#44403c'; grid[17][7]='#78350f'; grid[17][8]='#44403c'; grid[17][9]='#1c1917'; grid[17][10]='#0c0a09'; grid[17][11]='#1c1917'; grid[17][12]='#44403c'; grid[17][13]='#78350f'; grid[17][14]='#1c1917'; grid[18][4]='#1c1917'; grid[18][5]='#44403c'; grid[18][6]='#b45309'; grid[18][7]='#fef08a'; grid[18][8]='#78350f'; grid[18][9]='#1c1917'; grid[18][11]='#0c0a09'; grid[18][12]='#1c1917'; grid[18][13]='#44403c'; grid[18][14]='#78350f'; grid[18][15]='#1c1917'; grid[19][4]='#0c0a09'; grid[19][5]='#1c1917'; grid[19][6]='#44403c'; grid[19][7]='#78350f'; grid[19][8]='#44403c'; grid[19][9]='#1c1917'; grid[19][10]='#0c0a09'; grid[19][11]='#1c1917'; grid[19][12]='#292524'; grid[19][13]='#44403c'; grid[19][14]='#f97316'; grid[19][15]='#292524'; grid[19][16]='#fbbf24'; grid[20][4]='#0c0a09'; grid[20][5]='#1c1917'; grid[20][6]='#44403c'; grid[20][7]='#78350f'; grid[20][8]='#44403c'; grid[20][9]='#1c1917'; grid[20][10]='#0c0a09'; grid[20][11]='#0c0a09'; grid[20][12]='#1c1917'; grid[20][13]='#292524'; grid[20][14]='#292524'; grid[20][15]='#1c1917'; grid[20][16]='#0c0a09'; grid[21][4]='#0c0a09'; grid[21][5]='#1c1917'; grid[21][6]='#292524'; grid[21][7]='#44403c'; grid[21][8]='#f97316'; grid[21][9]='#292524'; grid[21][10]='#fbbf24'; grid[22][4]='#0c0a09'; grid[22][5]='#0c0a09'; grid[22][6]='#1c1917'; grid[22][7]='#292524'; grid[22][8]='#292524'; grid[22][9]='#1c1917'; grid[22][10]='#0c0a09';
  return { grid, gridSize: g };
}
function getHD_DevilPatrol_Legs_Walk4() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  grid[14][6]='#0c0a09'; grid[14][7]='#1c1917'; grid[14][8]='#292524'; grid[14][9]='#f97316'; grid[14][10]='#fbbf24'; grid[14][11]='#292524'; grid[14][12]='#1c1917'; grid[14][13]='#0c0a09'; grid[15][7]='#1c1917'; grid[15][8]='#44403c'; grid[15][9]='#1c1917'; grid[15][10]='#44403c'; grid[15][11]='#1c1917'; grid[16][5]='#0c0a09'; grid[16][6]='#1c1917'; grid[16][7]='#44403c'; grid[16][8]='#0c0a09'; grid[16][9]='#1c1917'; grid[16][10]='#44403c'; grid[16][11]='#78350f'; grid[16][12]='#44403c'; grid[16][13]='#1c1917'; grid[17][4]='#0c0a09'; grid[17][5]='#1c1917'; grid[17][6]='#44403c'; grid[17][7]='#78350f'; grid[17][8]='#44403c'; grid[17][9]='#0c0a09'; grid[17][10]='#1c1917'; grid[17][11]='#44403c'; grid[17][12]='#78350f'; grid[17][13]='#44403c'; grid[17][14]='#1c1917'; grid[18][4]='#1c1917'; grid[18][5]='#44403c'; grid[18][6]='#b45309'; grid[18][7]='#fef08a'; grid[18][8]='#78350f'; grid[18][9]='#1c1917'; grid[18][10]='#0c0a09'; grid[18][11]='#1c1917'; grid[18][12]='#44403c'; grid[18][13]='#78350f'; grid[18][14]='#44403c'; grid[18][15]='#1c1917'; grid[19][3]='#0c0a09'; grid[19][4]='#1c1917'; grid[19][5]='#44403c'; grid[19][6]='#78350f'; grid[19][7]='#44403c'; grid[19][8]='#1c1917'; grid[19][11]='#0c0a09'; grid[19][12]='#1c1917'; grid[19][13]='#44403c'; grid[19][14]='#78350f'; grid[19][15]='#44403c'; grid[19][16]='#1c1917'; grid[20][2]='#0c0a09'; grid[20][3]='#1c1917'; grid[20][4]='#44403c'; grid[20][5]='#78350f'; grid[20][6]='#44403c'; grid[20][7]='#1c1917'; grid[20][11]='#0c0a09'; grid[20][12]='#1c1917'; grid[20][13]='#292524'; grid[20][14]='#44403c'; grid[20][15]='#f97316'; grid[20][16]='#292524'; grid[20][17]='#fbbf24'; grid[21][2]='#fbbf24'; grid[21][3]='#1c1917'; grid[21][4]='#292524'; grid[21][5]='#44403c'; grid[21][6]='#f97316'; grid[21][7]='#292524'; grid[21][8]='#1c1917'; grid[21][11]='#0c0a09'; grid[21][12]='#0c0a09'; grid[21][13]='#1c1917'; grid[21][14]='#292524'; grid[21][15]='#292524'; grid[21][16]='#1c1917'; grid[21][17]='#0c0a09'; grid[22][2]='#0c0a09'; grid[22][3]='#0c0a09'; grid[22][4]='#1c1917'; grid[22][5]='#292524'; grid[22][6]='#292524'; grid[22][7]='#1c1917'; grid[22][8]='#0c0a09';
  return { grid, gridSize: g };
}
function getHD_DevilPatrol_Torso() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  grid[2][10]='#1c1917'; grid[2][11]='#78350f'; grid[2][12]='#b45309'; grid[2][13]='#78350f'; grid[2][14]='#1c1917'; grid[3][9]='#1c1917'; grid[3][10]='#78350f'; grid[3][11]='#b45309'; grid[3][12]='#fbbf24'; grid[3][13]='#b45309'; grid[3][14]='#78350f'; grid[3][15]='#1c1917'; grid[4][8]='#1c1917'; grid[4][9]='#78350f'; grid[4][10]='#1c1917'; grid[4][11]='#ef4444'; grid[4][12]='#f97316'; grid[4][13]='#facc15'; grid[4][14]='#fef08a'; grid[4][15]='#f97316'; grid[4][16]='#b45309'; grid[5][3]='#0c0a09'; grid[5][4]='#1c1917'; grid[5][5]='#292524'; grid[5][8]='#1c1917'; grid[5][9]='#78350f'; grid[5][10]='#b45309'; grid[5][11]='#ef4444'; grid[5][12]='#f97316'; grid[5][13]='#facc15'; grid[5][14]='#fef08a'; grid[5][15]='#b45309'; grid[6][3]='#0c0a09'; grid[6][4]='#1c1917'; grid[6][5]='#1c1917'; grid[6][8]='#1c1917'; grid[6][9]='#1c1917'; grid[6][10]='#78350f'; grid[6][11]='#f97316'; grid[6][12]='#facc15'; grid[6][13]='#f97316'; grid[6][14]='#1c1917'; grid[6][15]='#292524'; grid[7][2]='#f97316'; grid[7][3]='#b45309'; grid[7][4]='#1c1917'; grid[7][5]='#292524'; grid[7][6]='#1c1917'; grid[7][7]='#78350f'; grid[7][8]='#b45309'; grid[7][9]='#1c1917'; grid[7][10]='#292524'; grid[7][11]='#1c1917'; grid[7][12]='#44403c'; grid[7][13]='#292524'; grid[7][14]='#1c1917'; grid[8][2]='#b45309'; grid[8][3]='#ea580c'; grid[8][4]='#0c0a09'; grid[8][5]='#1c1917'; grid[8][6]='#1c1917'; grid[8][7]='#b45309'; grid[8][8]='#f97316'; grid[8][9]='#f97316'; grid[8][10]='#f97316'; grid[8][11]='#b45309'; grid[8][12]='#78350f'; grid[8][13]='#b45309'; grid[9][2]='#f97316'; grid[9][3]='#b45309'; grid[9][4]='#1c1917'; grid[9][5]='#292524'; grid[9][6]='#0c0a09'; grid[9][7]='#1c1917'; grid[9][8]='#78350f'; grid[9][9]='#b45309'; grid[9][10]='TEAM'; grid[9][11]='TEAM'; grid[9][12]='#78350f'; grid[10][2]='#b45309'; grid[10][3]='#ea580c'; grid[10][4]='#0c0a09'; grid[10][5]='#1c1917'; grid[10][6]='#0c0a09'; grid[10][7]='#1c1917'; grid[10][9]='#78350f'; grid[10][10]='TEAM'; grid[10][11]='TEAM'; grid[10][12]='#1c1917'; grid[10][13]='#78350f'; grid[11][2]='#0c0a09'; grid[11][3]='#1c1917'; grid[11][4]='#292524'; grid[11][5]='#1c1917'; grid[11][8]='#1c1917'; grid[11][9]='#78350f'; grid[11][10]='#78350f'; grid[11][11]='#b45309'; grid[11][12]='#1c1917'; grid[12][3]='#0c0a09'; grid[12][4]='#1c1917'; grid[12][5]='#1c1917'; grid[12][7]='#1c1917'; grid[12][8]='#78350f'; grid[12][9]='#b45309'; grid[12][10]='#78350f'; grid[12][11]='#1c1917'; grid[13][7]='#1c1917'; grid[13][8]='#78350f'; grid[13][9]='#78350f'; grid[13][10]='#1c1917';
  return { grid, gridSize: g };
}
function getHD_DevilPatrol_Gun() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  grid[8][14]='#1c1917'; grid[8][15]='#78350f'; grid[8][16]='#b45309'; grid[9][14]='#1c1917'; grid[9][15]='#1c1917'; grid[9][16]='#78350f'; grid[9][17]='#334155'; grid[9][18]='#475569'; grid[9][19]='#64748b'; grid[9][20]='#94a3b8'; grid[9][21]='#cbd5e1'; grid[10][14]='#78350f'; grid[10][15]='#0c0a09'; grid[10][16]='#1c1917'; grid[10][17]='#475569'; grid[10][18]='#64748b'; grid[10][19]='#94a3b8'; grid[10][20]='#cbd5e1'; grid[10][21]='#facc15'; grid[10][22]='#f97316'; grid[11][14]='#292524'; grid[11][15]='#0c0a09'; grid[11][16]='#1c1917'; grid[11][17]='#334155'; grid[11][18]='#475569'; grid[11][19]='#64748b'; grid[11][20]='#94a3b8'; grid[11][21]='#cbd5e1'; grid[11][22]='#f97316'; grid[12][14]='#0c0a09'; grid[12][15]='#1c1917'; grid[12][16]='#292524'; grid[12][17]='#1c1917'; grid[12][18]='#292524'; grid[12][19]='#475569'; grid[12][20]='#64748b'; grid[13][14]='#0c0a09'; grid[13][15]='#1c1917'; grid[13][17]='#78350f'; grid[13][18]='#b45309'; grid[13][19]='#f97316';
  return { grid, gridSize: g };
}
function getHD_DevilPatrol() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  grid[2][10]='#1c1917'; grid[2][11]='#78350f'; grid[2][12]='#b45309'; grid[2][13]='#78350f'; grid[2][14]='#1c1917'; grid[3][9]='#1c1917'; grid[3][10]='#78350f'; grid[3][11]='#b45309'; grid[3][12]='#fbbf24'; grid[3][13]='#b45309'; grid[3][14]='#78350f'; grid[3][15]='#1c1917'; grid[4][8]='#1c1917'; grid[4][9]='#78350f'; grid[4][10]='#1c1917'; grid[4][11]='#ef4444'; grid[4][12]='#f97316'; grid[4][13]='#facc15'; grid[4][14]='#fef08a'; grid[4][15]='#f97316'; grid[4][16]='#b45309'; grid[5][3]='#0c0a09'; grid[5][4]='#1c1917'; grid[5][5]='#292524'; grid[5][8]='#1c1917'; grid[5][9]='#78350f'; grid[5][10]='#b45309'; grid[5][11]='#ef4444'; grid[5][12]='#f97316'; grid[5][13]='#facc15'; grid[5][14]='#fef08a'; grid[5][15]='#b45309'; grid[6][3]='#0c0a09'; grid[6][4]='#1c1917'; grid[6][5]='#1c1917'; grid[6][8]='#1c1917'; grid[6][9]='#1c1917'; grid[6][10]='#78350f'; grid[6][11]='#f97316'; grid[6][12]='#facc15'; grid[6][13]='#f97316'; grid[6][14]='#1c1917'; grid[6][15]='#292524'; grid[7][2]='#f97316'; grid[7][3]='#b45309'; grid[7][4]='#1c1917'; grid[7][5]='#292524'; grid[7][6]='#1c1917'; grid[7][7]='#78350f'; grid[7][8]='#b45309'; grid[7][9]='#1c1917'; grid[7][10]='#292524'; grid[7][11]='#1c1917'; grid[7][12]='#44403c'; grid[7][13]='#292524'; grid[7][14]='#1c1917'; grid[8][2]='#b45309'; grid[8][3]='#ea580c'; grid[8][4]='#0c0a09'; grid[8][5]='#1c1917'; grid[8][6]='#1c1917'; grid[8][7]='#b45309'; grid[8][8]='#f97316'; grid[8][9]='#f97316'; grid[8][10]='#f97316'; grid[8][11]='#b45309'; grid[8][12]='#78350f'; grid[8][13]='#b45309'; grid[8][14]='#1c1917'; grid[8][15]='#78350f'; grid[8][16]='#b45309'; grid[9][2]='#f97316'; grid[9][3]='#b45309'; grid[9][4]='#1c1917'; grid[9][5]='#292524'; grid[9][6]='#0c0a09'; grid[9][7]='#1c1917'; grid[9][8]='#78350f'; grid[9][9]='#b45309'; grid[9][10]='TEAM'; grid[9][11]='TEAM'; grid[9][12]='#78350f'; grid[9][14]='#1c1917'; grid[9][15]='#1c1917'; grid[9][16]='#78350f'; grid[9][17]='#334155'; grid[9][18]='#475569'; grid[9][19]='#64748b'; grid[9][20]='#94a3b8'; grid[9][21]='#cbd5e1'; grid[10][2]='#b45309'; grid[10][3]='#ea580c'; grid[10][4]='#0c0a09'; grid[10][5]='#1c1917'; grid[10][6]='#0c0a09'; grid[10][7]='#1c1917'; grid[10][9]='#78350f'; grid[10][10]='TEAM'; grid[10][11]='TEAM'; grid[10][12]='#1c1917'; grid[10][13]='#78350f'; grid[10][14]='#78350f'; grid[10][15]='#0c0a09'; grid[10][16]='#1c1917'; grid[10][17]='#475569'; grid[10][18]='#64748b'; grid[10][19]='#94a3b8'; grid[10][20]='#cbd5e1'; grid[10][21]='#facc15'; grid[10][22]='#f97316'; grid[11][2]='#0c0a09'; grid[11][3]='#1c1917'; grid[11][4]='#292524'; grid[11][5]='#1c1917'; grid[11][8]='#1c1917'; grid[11][9]='#78350f'; grid[11][10]='#78350f'; grid[11][11]='#b45309'; grid[11][12]='#1c1917'; grid[11][14]='#292524'; grid[11][15]='#0c0a09'; grid[11][16]='#1c1917'; grid[11][17]='#334155'; grid[11][18]='#475569'; grid[11][19]='#64748b'; grid[11][20]='#94a3b8'; grid[11][21]='#cbd5e1'; grid[11][22]='#f97316'; grid[12][3]='#0c0a09'; grid[12][4]='#1c1917'; grid[12][5]='#1c1917'; grid[12][7]='#1c1917'; grid[12][8]='#78350f'; grid[12][9]='#b45309'; grid[12][10]='#78350f'; grid[12][11]='#1c1917'; grid[12][14]='#0c0a09'; grid[12][15]='#1c1917'; grid[12][16]='#292524'; grid[12][17]='#1c1917'; grid[12][18]='#292524'; grid[12][19]='#475569'; grid[12][20]='#64748b'; grid[13][7]='#1c1917'; grid[13][8]='#78350f'; grid[13][9]='#78350f'; grid[13][10]='#1c1917'; grid[13][14]='#0c0a09'; grid[13][15]='#1c1917'; grid[13][17]='#78350f'; grid[13][18]='#b45309'; grid[13][19]='#f97316'; grid[14][6]='#0c0a09'; grid[14][7]='#1c1917'; grid[14][8]='#292524'; grid[14][9]='#f97316'; grid[14][10]='#fbbf24'; grid[14][11]='#292524'; grid[14][12]='#1c1917'; grid[14][13]='#0c0a09'; grid[15][7]='#1c1917'; grid[15][8]='#44403c'; grid[15][9]='#1c1917'; grid[15][10]='#44403c'; grid[15][11]='#1c1917'; grid[16][5]='#1c1917'; grid[16][6]='#44403c'; grid[16][7]='#78350f'; grid[16][8]='#1c1917'; grid[16][10]='#1c1917'; grid[16][11]='#44403c'; grid[16][12]='#78350f'; grid[16][13]='#1c1917'; grid[17][5]='#1c1917'; grid[17][6]='#b45309'; grid[17][7]='#78350f'; grid[17][8]='#1c1917'; grid[17][10]='#1c1917'; grid[17][11]='#b45309'; grid[17][12]='#fef08a'; grid[17][13]='#78350f'; grid[18][5]='#1c1917'; grid[18][6]='#44403c'; grid[18][7]='#78350f'; grid[18][8]='#1c1917'; grid[18][10]='#1c1917'; grid[18][11]='#44403c'; grid[18][12]='#78350f'; grid[18][13]='#1c1917'; grid[19][5]='#0c0a09'; grid[19][6]='#1c1917'; grid[19][7]='#44403c'; grid[19][8]='#1c1917'; grid[19][10]='#0c0a09'; grid[19][11]='#1c1917'; grid[19][12]='#44403c'; grid[19][13]='#1c1917'; grid[20][4]='#1c1917'; grid[20][5]='#292524'; grid[20][6]='#44403c'; grid[20][7]='#292524'; grid[20][8]='#1c1917'; grid[20][9]='#1c1917'; grid[20][10]='#292524'; grid[20][11]='#44403c'; grid[20][12]='#f97316'; grid[20][13]='#292524'; grid[20][14]='#1c1917'; grid[21][4]='#0c0a09'; grid[21][5]='#1c1917'; grid[21][6]='#292524'; grid[21][7]='#44403c'; grid[21][8]='#1c1917'; grid[21][9]='#0c0a09'; grid[21][10]='#1c1917'; grid[21][11]='#292524'; grid[21][12]='#44403c'; grid[21][13]='#292524'; grid[21][14]='#0c0a09'; grid[22][3]='#0c0a09'; grid[22][4]='#1c1917'; grid[22][5]='#1c1917'; grid[22][6]='#292524'; grid[22][7]='#1c1917'; grid[22][9]='#0c0a09'; grid[22][10]='#1c1917'; grid[22][11]='#1c1917'; grid[22][12]='#292524'; grid[22][13]='#292524'; grid[22][14]='#0c0a09';
  return { grid, gridSize: g };
}

function _composeDevilPatrolWalk(walkNum) {
  const g = 24, grid = Array.from({ length: 24 }, () => Array(24).fill(null));
  const torso = getHD_DevilPatrol_Torso().grid;
  const gun = getHD_DevilPatrol_Gun().grid;
  const legsFunc = walkNum === 1 ? getHD_DevilPatrol_Legs_Walk1
                 : walkNum === 2 ? getHD_DevilPatrol_Legs_Walk2
                 : walkNum === 3 ? getHD_DevilPatrol_Legs_Walk3
                 : walkNum === 4 ? getHD_DevilPatrol_Legs_Walk4
                 : walkNum === 5 ? getHD_DevilPatrol_Legs_Walk2
                 : getHD_DevilPatrol_Legs_Walk3;
  const legs = legsFunc().grid;
  for (let r = 0; r < g; r++) {
    for (let c = 0; c < g; c++) {
      grid[r][c] = legs[r][c] || gun[r][c] || torso[r][c] || null;
    }
  }
  return { grid, gridSize: g };
}
function getHD_DevilPatrol_Walk1() { return _composeDevilPatrolWalk(1); }
function getHD_DevilPatrol_Walk2() { return _composeDevilPatrolWalk(2); }
function getHD_DevilPatrol_Walk3() { return _composeDevilPatrolWalk(3); }
function getHD_DevilPatrol_Walk4() { return _composeDevilPatrolWalk(4); }
function getHD_DevilPatrol_Walk5() { return _composeDevilPatrolWalk(5); }
function getHD_DevilPatrol_Walk6() { return _composeDevilPatrolWalk(6); }

function getHD_HyperDevilPatrol_Legs() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  // Row 10: Pelvis & hip armor connecting directly to torso waist
  grid[10][3]='#1c1917'; grid[10][4]='#78350f'; grid[10][5]='#b45309'; grid[10][6]='#78350f'; grid[10][7]='#1c1917';
  // Row 11: Upper thigh
  grid[11][3]='#292524'; grid[11][4]='#b45309'; grid[11][5]='#d97706'; grid[11][6]='#b45309'; grid[11][7]='#1c1917';
  // Row 12: Upper thigh & side plate
  grid[12][2]='#1c1917'; grid[12][3]='#78350f'; grid[12][4]='#b45309'; grid[12][5]='#d97706'; grid[12][6]='#78350f'; grid[12][7]='#1c1917';
  // Row 13: Mid thigh
  grid[13][2]='#1c1917'; grid[13][3]='#78350f'; grid[13][4]='#b45309'; grid[13][5]='#d97706'; grid[13][6]='#1c1917';
  // Row 14: Mid thigh / Knee guard top
  grid[14][2]='#292524'; grid[14][3]='#b45309'; grid[14][4]='#d97706'; grid[14][5]='#b45309'; grid[14][6]='#78350f';
  // Row 15: Knee guard & joint
  grid[15][1]='#1c1917'; grid[15][2]='#78350f'; grid[15][3]='#b45309'; grid[15][4]='#78350f'; grid[15][5]='#292524';
  // Row 16: Knee joint & upper shin
  grid[16][1]='#1c1917'; grid[16][2]='#292524'; grid[16][3]='#44403c'; grid[16][4]='#78350f'; grid[16][5]='#292524';
  // Row 17: Shin armor plate
  grid[17][1]='#292524'; grid[17][2]='#44403c'; grid[17][3]='#78350f'; grid[17][4]='#292524';
  // Row 18: Shin armor trailing rearward
  grid[18][0]='#1c1917'; grid[18][1]='#292524'; grid[18][2]='#44403c'; grid[18][3]='#292524'; grid[18][4]='#1c1917';
  // Row 19: Ankle & boot top
  grid[19][0]='#0c0a09'; grid[19][1]='#1c1917'; grid[19][2]='#292524'; grid[19][3]='#44403c';
  // Row 20: Flight boot
  grid[20][0]='#0c0a09'; grid[20][1]='#1c1917'; grid[20][2]='#292524'; grid[20][3]='#1c1917';
  // Row 21: Flight boot thruster / nozzle
  grid[21][0]='#0284c7'; grid[21][1]='#38bdf8'; grid[21][2]='#1c1917'; grid[21][3]='#0c0a09';
  // Row 22: Boot sole
  grid[22][2]='#0c0a09';
  return { grid, gridSize: g };
}
function getHD_HyperDevilPatrol_Torso() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  grid[0][8]='#1c1917'; grid[0][9]='#292524'; grid[0][10]='#44403c'; grid[0][11]='#292524'; grid[0][12]='#1c1917'; grid[1][7]='#1c1917'; grid[1][8]='#78350f'; grid[1][9]='#b45309'; grid[1][10]='#d97706'; grid[1][11]='#b45309'; grid[1][12]='#292524'; grid[2][4]='#b45309'; grid[2][5]='#1c1917'; grid[2][6]='#1c1917'; grid[2][7]='#292524'; grid[2][8]='#f97316'; grid[2][9]='#facc15'; grid[2][10]='#fef08a'; grid[2][11]='#1c1917'; grid[3][2]='#1c1917'; grid[3][3]='#78350f'; grid[3][6]='#1c1917'; grid[3][7]='#44403c'; grid[3][8]='#ef4444'; grid[3][9]='#f97316'; grid[3][10]='#facc15'; grid[3][11]='#1c1917'; grid[4][0]='#38bdf8'; grid[4][1]='#0284c7'; grid[4][2]='#78350f'; grid[4][7]='#292524'; grid[4][8]='#44403c'; grid[4][9]='#292524'; grid[4][10]='#1c1917'; grid[5][0]='#f97316'; grid[5][1]='#b45309'; grid[5][2]='#78350f'; grid[5][3]='#78350f'; grid[5][4]='#b45309'; grid[5][5]='#d97706'; grid[5][6]='#b45309'; grid[5][7]='#78350f'; grid[5][8]='#1c1917'; grid[6][1]='#1c1917'; grid[6][2]='#78350f'; grid[6][3]='TEAM'; grid[6][4]='#292524'; grid[6][5]='#38bdf8'; grid[6][6]='#0284c7'; grid[6][7]='#292524'; grid[6][8]='TEAM'; grid[7][1]='#b45309'; grid[7][2]='#78350f'; grid[7][3]='TEAM'; grid[7][4]='#44403c'; grid[7][5]='#0284c7'; grid[7][6]='#38bdf8'; grid[7][7]='#44403c'; grid[7][8]='TEAM'; grid[8][0]='#0284c7'; grid[8][1]='#38bdf8'; grid[8][4]='#1c1917'; grid[8][5]='#78350f'; grid[8][6]='#b45309'; grid[8][7]='#1c1917'; grid[9][2]='#1c1917'; grid[9][3]='#292524'; grid[9][4]='#292524'; grid[9][5]='#1c1917';
  return { grid, gridSize: g };
}
function getHD_HyperDevilPatrol_Gun() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  grid[5][7]='#78350f'; grid[5][8]='#b45309'; grid[5][9]='#1c1917'; grid[6][8]='#292524'; grid[6][9]='#44403c'; grid[6][10]='#1c1917'; grid[6][12]='#475569'; grid[6][13]='#64748b'; grid[6][14]='#94a3b8'; grid[6][15]='#475569'; grid[6][17]='#1e293b'; grid[7][10]='#334155'; grid[7][11]='#475569'; grid[7][12]='#64748b'; grid[7][13]='#94a3b8'; grid[7][14]='#cbd5e1'; grid[7][15]='#f8fafc'; grid[7][16]='#f97316'; grid[8][9]='#1c1917'; grid[8][10]='#334155'; grid[8][11]='#475569'; grid[8][12]='#1c1917'; grid[8][13]='#334155'; grid[8][14]='#475569'; grid[8][15]='#64748b'; grid[8][16]='#1e293b'; grid[9][8]='#1c1917'; grid[9][9]='#eab308'; grid[9][10]='#ca8a04'; grid[9][11]='#eab308'; grid[9][12]='#334155'; grid[10][8]='#334155'; grid[10][9]='#ca8a04'; grid[10][10]='#1e293b'; grid[10][11]='#ca8a04'; grid[10][12]='#475569'; grid[11][9]='#1c1917'; grid[11][10]='#334155'; grid[11][11]='#475569'; grid[11][12]='#1c1917';
  return { grid, gridSize: g };
}
function getHD_HyperDevilPatrol() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  const l=getHD_HyperDevilPatrol_Legs().grid, t=getHD_HyperDevilPatrol_Torso().grid, gn=getHD_HyperDevilPatrol_Gun().grid;
  for(let y=0;y<24;y++) for(let x=0;x<24;x++){
    if(l[y][x]) grid[y][x]=l[y][x];
    if(t[y][x]) grid[y][x]=t[y][x];
    if(gn[y][x]) grid[y][x]=gn[y][x];
  }
  return { grid, gridSize: g };
}


// ── SHADE & HYPER-SHADE (24x24 HD REFERENCE) ───────────────────

function makeGrid() {
  return Array.from({ length: 24 }, () => Array(24).fill(null));
}

function makeGrid24() {
  return makeGrid();
}

function makeGrid36() {
  return Array.from({ length: 36 }, () => Array(36).fill(null));
}

function makeGrid48() {
  return Array.from({ length: 48 }, () => Array(48).fill(null));
}

function getHD_Shade_Torso() {
  const g=24, grid=makeGrid();
  // 1. Billowing Tattered Cloak / Cape (-X rear, y: 3..14, x: 0..6)
  grid[3][4]='#090d16'; grid[3][5]='#1e293b'; grid[3][6]='#1e293b';
  grid[4][3]='#020617'; grid[4][4]='#090d16'; grid[4][5]='#0f172a'; grid[4][6]='#1e293b';
  grid[5][2]='#020617'; grid[5][3]='#090d16'; grid[5][4]='#1e293b'; grid[5][5]='#334155'; grid[5][6]='#1e293b';
  grid[6][1]='#020617'; grid[6][2]='#090d16'; grid[6][3]='#0f172a'; grid[6][4]='#1e293b'; grid[6][5]='#334155';
  grid[7][0]='#020617'; grid[7][1]='#090d16'; grid[7][2]='#0f172a'; grid[7][3]='#1e293b'; grid[7][4]='#1e293b'; grid[7][5]='#0f172a';
  grid[8][0]='#020617'; grid[8][1]='#090d16'; grid[8][2]='#0f172a'; grid[8][3]='#1e293b'; grid[8][4]='#1e293b';
  grid[9][0]='#020617'; grid[9][1]='#090d16'; grid[9][2]='#0f172a'; grid[9][3]='#1e293b';
  grid[10][1]='#020617'; grid[10][2]='#090d16'; grid[10][3]='#1e293b'; grid[10][4]='#0f172a';
  grid[11][1]='#020617'; grid[11][2]='#090d16'; grid[11][3]='#1e293b';
  grid[12][2]='#020617'; grid[12][3]='#090d16'; grid[12][4]='#0f172a';
  grid[13][2]='#020617'; grid[13][3]='#090d16';
  grid[14][3]='#020617';

  // 2. Hooded Cowl & Mask (y: 1..7, x: 7..14)
  grid[1][9]='#020617'; grid[1][10]='#0f172a'; grid[1][11]='#0f172a'; grid[1][12]='#020617';
  grid[2][8]='#020617'; grid[2][9]='#0f172a'; grid[2][10]='#1e293b'; grid[2][11]='#1e293b'; grid[2][12]='#0f172a'; grid[2][13]='#020617';
  grid[3][7]='#020617'; grid[3][8]='#0f172a'; grid[3][9]='#1e293b'; grid[3][10]='#334155'; grid[3][11]='#1e293b'; grid[3][12]='#0f172a'; grid[3][13]='#020617';
  grid[4][7]='#020617'; grid[4][8]='#0f172a'; grid[4][9]='#ef4444'; grid[4][10]='#ff0033'; grid[4][11]='#ff0033'; grid[4][12]='#ef4444'; grid[4][13]='#020617';
  grid[5][7]='#0f172a'; grid[5][8]='#020617'; grid[5][9]='#dc2626'; grid[5][10]='#ef4444'; grid[5][11]='#ef4444'; grid[5][12]='#dc2626'; grid[5][13]='#020617';
  grid[6][7]='#0f172a'; grid[6][8]='#1e293b'; grid[6][9]='#334155'; grid[6][10]='#475569'; grid[6][11]='#334155'; grid[6][12]='#1e293b'; grid[6][13]='#0f172a';
  grid[7][8]='#0f172a'; grid[7][9]='#1e293b'; grid[7][10]='#334155'; grid[7][11]='#1e293b'; grid[7][12]='#0f172a';

  // 3. Torso & Tactical Carbon Armor (y: 8..13, x: 6..13)
  grid[8][6]='#0f172a'; grid[8][7]='TEAM'; grid[8][8]='TEAM'; grid[8][9]='#1e293b'; grid[8][10]='#334155'; grid[8][11]='#475569'; grid[8][12]='#1e293b'; grid[8][13]='#0f172a';
  grid[9][6]='#0f172a'; grid[9][7]='TEAM'; grid[9][8]='TEAM'; grid[9][9]='#334155'; grid[9][10]='#475569'; grid[9][11]='#334155'; grid[9][12]='#1e293b';
  grid[10][6]='#0f172a'; grid[10][7]='#1e293b'; grid[10][8]='#334155'; grid[10][9]='#475569'; grid[10][10]='#334155'; grid[10][11]='#1e293b';
  grid[11][6]='#0f172a'; grid[11][7]='#1e293b'; grid[11][8]='#334155'; grid[11][9]='#1e293b'; grid[11][10]='#1e293b'; grid[11][11]='#0f172a';
  grid[12][6]='#0f172a'; grid[12][7]='#0f172a'; grid[12][8]='#1e293b'; grid[12][9]='#334155'; grid[12][10]='#1e293b'; grid[12][11]='#0f172a';
  grid[13][6]='#020617'; grid[13][7]='#0f172a'; grid[13][8]='#1e293b'; grid[13][9]='#1e293b'; grid[13][10]='#0f172a'; grid[13][11]='#020617';
  return { grid, gridSize: g };
}

function getHD_Shade_Gun() {
  const g=24, grid=makeGrid();
  // Operative Arms & Stealth Gloves
  grid[9][6]='#1e293b'; grid[9][7]='#334155';
  grid[10][6]='#0f172a'; grid[10][7]='#1e293b'; grid[10][8]='#334155';
  grid[11][7]='#0f172a'; grid[11][8]='#1e293b'; grid[11][9]='#334155';
  // Sniper Scope with Red Glint (y: 7..8, x: 13..18)
  grid[7][13]='#0f172a'; grid[7][14]='#1e293b'; grid[7][15]='#334155'; grid[7][16]='#475569'; grid[7][17]='#ff0033'; grid[7][18]='#ef4444';
  grid[8][13]='#020617'; grid[8][14]='#0f172a'; grid[8][15]='#1e293b'; grid[8][16]='#334155'; grid[8][17]='#0f172a';
  grid[9][14]='#020617'; grid[9][16]='#020617';
  // Receiver & Grip
  grid[10][11]='#1e293b'; grid[10][12]='#334155'; grid[10][13]='#475569'; grid[10][14]='#334155'; grid[10][15]='#1e293b';
  grid[11][11]='#0f172a'; grid[11][12]='#1e293b'; grid[11][13]='#334155';
  grid[12][13]='#020617'; grid[12][14]='#0f172a';
  // Barrel & Handguard
  grid[10][16]='#334155'; grid[10][17]='#475569'; grid[10][18]='#64748b'; grid[10][19]='#94a3b8'; grid[10][20]='#cbd5e1';
  grid[11][16]='#1e293b'; grid[11][17]='#334155'; grid[11][18]='#475569'; grid[11][19]='#64748b';
  // Heavy Suppressor
  grid[9][21]='#020617'; grid[9][22]='#0f172a';
  grid[10][21]='#0f172a'; grid[10][22]='#1e293b'; grid[10][23]='#334155';
  grid[11][21]='#0f172a'; grid[11][22]='#1e293b'; grid[11][23]='#334155';
  grid[12][21]='#020617'; grid[12][22]='#0f172a';
  // Bipod
  grid[12][18]='#0f172a'; grid[12][19]='#1e293b';
  grid[13][19]='#020617'; grid[13][20]='#0f172a';
  return { grid, gridSize: g };
}

function getHD_Shade_Legs() {
  const g=24, grid=makeGrid();
  // Belt & Pelvis (y: 13..14, x: 5..12)
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#334155'; grid[13][9]='#334155'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#334155'; grid[14][8]='#475569'; grid[14][9]='#334155'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  // Cape Tail (-X rear)
  grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#020617'; grid[15][1]='#090d16'; grid[15][2]='#0f172a'; grid[15][3]='#1e293b';
  grid[16][0]='#020617'; grid[16][1]='#090d16'; grid[16][2]='#0f172a';
  grid[17][0]='#020617'; grid[17][1]='#090d16';
  grid[18][0]='#020617'; grid[18][1]='#090d16';
  grid[19][0]='#020617';
  // Left Leg (x: 4..7)
  for(let y=15;y<=17;y++){
    grid[y][4]='#020617'; grid[y][5]='#0f172a'; grid[y][6]='#1e293b'; grid[y][7]='#020617';
  }
  grid[17][5]='#1e293b'; grid[17][6]='#334155';
  grid[18][4]='#020617'; grid[18][5]='#0f172a'; grid[18][6]='#1e293b';
  grid[19][3]='#020617'; grid[19][4]='#0f172a'; grid[19][5]='#1e293b';
  grid[20][3]='#020617'; grid[20][4]='#0f172a'; grid[20][5]='#1e293b';
  grid[21][3]='#020617'; grid[21][4]='#090d16'; grid[21][5]='#0f172a';
  grid[22][2]='#020617'; grid[22][3]='#090d16'; grid[22][4]='#090d16';
  // Right Leg (x: 9..13)
  for(let y=15;y<=17;y++){
    grid[y][9]='#020617'; grid[y][10]='#1e293b'; grid[y][11]='#334155'; grid[y][12]='#0f172a';
  }
  grid[17][10]='#334155'; grid[17][11]='#475569';
  grid[18][9]='#020617'; grid[18][10]='#1e293b'; grid[18][11]='#0f172a';
  grid[19][9]='#020617'; grid[19][10]='#1e293b'; grid[19][11]='#0f172a'; grid[19][12]='#020617';
  grid[20][9]='#020617'; grid[20][10]='#0f172a'; grid[20][11]='#1e293b'; grid[20][12]='#020617';
  grid[21][9]='#020617'; grid[21][10]='#090d16'; grid[21][11]='#0f172a'; grid[21][12]='#020617';
  grid[22][9]='#020617'; grid[22][10]='#090d16'; grid[22][11]='#090d16'; grid[22][12]='#020617';
  return { grid, gridSize: g };
}

function getHD_Shade_Legs_Walk1() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#334155'; grid[13][9]='#334155'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#334155'; grid[14][8]='#475569'; grid[14][9]='#334155'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#020617'; grid[15][1]='#090d16'; grid[15][2]='#0f172a';
  grid[16][0]='#020617'; grid[16][1]='#090d16';
  grid[17][0]='#020617';
  // Stride Forward (Right Leg)
  grid[15][10]='#020617'; grid[15][11]='#1e293b'; grid[15][12]='#334155'; grid[15][13]='#0f172a';
  grid[16][11]='#020617'; grid[16][12]='#1e293b'; grid[16][13]='#334155'; grid[16][14]='#0f172a';
  grid[17][12]='#020617'; grid[17][13]='#334155'; grid[17][14]='#475569'; grid[17][15]='#0f172a';
  grid[18][13]='#020617'; grid[18][14]='#1e293b'; grid[18][15]='#334155'; grid[18][16]='#020617';
  grid[19][13]='#020617'; grid[19][14]='#0f172a'; grid[19][15]='#1e293b'; grid[19][16]='#020617';
  grid[20][13]='#020617'; grid[20][14]='#090d16'; grid[20][15]='#0f172a'; grid[20][16]='#020617';
  grid[21][14]='#020617'; grid[21][15]='#090d16'; grid[21][16]='#0f172a';
  grid[22][14]='#020617'; grid[22][15]='#090d16'; grid[22][16]='#020617';
  // Push Back (Left Leg)
  grid[15][6]='#020617'; grid[15][7]='#0f172a'; grid[15][8]='#1e293b';
  grid[16][5]='#020617'; grid[16][6]='#0f172a'; grid[16][7]='#1e293b'; grid[16][8]='#020617';
  grid[17][4]='#020617'; grid[17][5]='#0f172a'; grid[17][6]='#334155'; grid[17][7]='#020617';
  grid[18][3]='#020617'; grid[18][4]='#0f172a'; grid[18][5]='#1e293b'; grid[18][6]='#020617';
  grid[19][2]='#020617'; grid[19][3]='#0f172a'; grid[19][4]='#1e293b';
  grid[20][2]='#020617'; grid[20][3]='#090d16'; grid[20][4]='#020617';
  grid[21][1]='#020617'; grid[21][2]='#090d16';
  return { grid, gridSize: g };
}

function getHD_Shade_Legs_Walk2() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#334155'; grid[13][9]='#334155'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#334155'; grid[14][8]='#475569'; grid[14][9]='#334155'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#020617'; grid[15][1]='#090d16'; grid[15][2]='#0f172a';
  grid[16][0]='#020617'; grid[16][1]='#090d16';
  // Support Flat Under Hip (Right Leg)
  for(let y=15;y<=17;y++) {
    grid[y][8]='#020617'; grid[y][9]='#1e293b'; grid[y][10]='#334155'; grid[y][11]='#334155'; grid[y][12]='#020617';
  }
  grid[17][9]='#334155'; grid[17][10]='#475569';
  grid[18][8]='#020617'; grid[18][9]='#0f172a'; grid[18][10]='#1e293b'; grid[18][11]='#020617';
  grid[19][8]='#020617'; grid[19][9]='#0f172a'; grid[19][10]='#1e293b'; grid[19][11]='#020617';
  grid[20][8]='#020617'; grid[20][9]='#090d16'; grid[20][10]='#0f172a'; grid[20][11]='#020617';
  grid[21][8]='#020617'; grid[21][9]='#090d16'; grid[21][10]='#090d16'; grid[21][11]='#020617';
  grid[22][8]='#020617'; grid[22][9]='#090d16'; grid[22][10]='#090d16'; grid[22][11]='#020617';
  // Left Leg Lifting Behind
  grid[15][5]='#020617'; grid[15][6]='#0f172a'; grid[15][7]='#1e293b';
  grid[16][4]='#020617'; grid[16][5]='#0f172a'; grid[16][6]='#334155'; grid[16][7]='#020617';
  grid[17][3]='#020617'; grid[17][4]='#334155'; grid[17][5]='#1e293b'; grid[17][6]='#020617';
  grid[18][3]='#020617'; grid[18][4]='#0f172a'; grid[18][5]='#1e293b'; grid[18][6]='#020617';
  grid[19][3]='#020617'; grid[19][4]='#090d16'; grid[19][5]='#0f172a';
  grid[20][3]='#020617'; grid[20][4]='#090d16';
  return { grid, gridSize: g };
}

function getHD_Shade_Legs_Walk3() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#334155'; grid[13][9]='#334155'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#334155'; grid[14][8]='#475569'; grid[14][9]='#334155'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#020617'; grid[15][1]='#090d16'; grid[15][2]='#0f172a';
  grid[16][0]='#020617'; grid[16][1]='#090d16';
  // Straight Support Leg (Left)
  for(let y=15;y<=17;y++) {
    grid[y][5]='#020617'; grid[y][6]='#0f172a'; grid[y][7]='#1e293b'; grid[y][8]='#020617';
  }
  grid[17][6]='#1e293b'; grid[17][7]='#334155';
  grid[18][5]='#020617'; grid[18][6]='#0f172a'; grid[18][7]='#1e293b'; grid[18][8]='#020617';
  grid[19][4]='#020617'; grid[19][5]='#0f172a'; grid[19][6]='#1e293b'; grid[19][7]='#020617';
  grid[20][4]='#020617'; grid[20][5]='#090d16'; grid[20][6]='#0f172a'; grid[20][7]='#020617';
  grid[21][4]='#020617'; grid[21][5]='#090d16'; grid[21][6]='#090d16'; grid[21][7]='#020617';
  grid[22][4]='#020617'; grid[22][5]='#090d16'; grid[22][6]='#090d16'; grid[22][7]='#020617';
  // Passing High Knee Forward (Right Leg)
  grid[15][10]='#020617'; grid[15][11]='#1e293b'; grid[15][12]='#334155';
  grid[16][10]='#020617'; grid[16][11]='#334155'; grid[16][12]='#475569'; grid[16][13]='#334155'; grid[16][14]='#020617';
  grid[17][10]='#020617'; grid[17][11]='#1e293b'; grid[17][12]='#334155'; grid[17][13]='#475569'; grid[17][14]='#020617';
  grid[18][11]='#020617'; grid[18][12]='#0f172a'; grid[18][13]='#1e293b'; grid[18][14]='#020617';
  grid[19][12]='#020617'; grid[19][13]='#090d16'; grid[19][14]='#020617';
  return { grid, gridSize: g };
}

function getHD_Shade_Legs_Walk4() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#334155'; grid[13][9]='#334155'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#334155'; grid[14][8]='#475569'; grid[14][9]='#334155'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#020617'; grid[15][1]='#090d16'; grid[15][2]='#0f172a';
  grid[16][0]='#020617'; grid[16][1]='#090d16';
  grid[17][0]='#020617';
  // Stride Forward (Left Leg)
  grid[15][10]='#020617'; grid[15][11]='#1e293b'; grid[15][12]='#334155'; grid[15][13]='#0f172a';
  grid[16][11]='#020617'; grid[16][12]='#1e293b'; grid[16][13]='#334155'; grid[16][14]='#0f172a';
  grid[17][12]='#020617'; grid[17][13]='#334155'; grid[17][14]='#475569'; grid[17][15]='#0f172a';
  grid[18][13]='#020617'; grid[18][14]='#1e293b'; grid[18][15]='#334155'; grid[18][16]='#020617';
  grid[19][13]='#020617'; grid[19][14]='#0f172a'; grid[19][15]='#1e293b'; grid[19][16]='#020617';
  grid[20][13]='#020617'; grid[20][14]='#090d16'; grid[20][15]='#0f172a'; grid[20][16]='#020617';
  grid[21][14]='#020617'; grid[21][15]='#090d16'; grid[21][16]='#0f172a';
  grid[22][14]='#020617'; grid[22][15]='#090d16'; grid[22][16]='#020617';
  // Push Back (Right Leg)
  grid[15][6]='#020617'; grid[15][7]='#0f172a'; grid[15][8]='#1e293b';
  grid[16][5]='#020617'; grid[16][6]='#0f172a'; grid[16][7]='#1e293b'; grid[16][8]='#020617';
  grid[17][4]='#020617'; grid[17][5]='#0f172a'; grid[17][6]='#334155'; grid[17][7]='#020617';
  grid[18][3]='#020617'; grid[18][4]='#0f172a'; grid[18][5]='#1e293b'; grid[18][6]='#020617';
  grid[19][2]='#020617'; grid[19][3]='#0f172a'; grid[19][4]='#1e293b';
  grid[20][2]='#020617'; grid[20][3]='#090d16'; grid[20][4]='#020617';
  grid[21][1]='#020617'; grid[21][2]='#090d16';
  return { grid, gridSize: g };
}

function getHD_Shade_Legs_Walk5() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#334155'; grid[13][9]='#334155'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#334155'; grid[14][8]='#475569'; grid[14][9]='#334155'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#020617'; grid[15][1]='#090d16'; grid[15][2]='#0f172a';
  grid[16][0]='#020617'; grid[16][1]='#090d16';
  // Support Flat Under Hip (Left Leg)
  for(let y=15;y<=17;y++) {
    grid[y][8]='#020617'; grid[y][9]='#1e293b'; grid[y][10]='#334155'; grid[y][11]='#334155'; grid[y][12]='#020617';
  }
  grid[17][9]='#334155'; grid[17][10]='#475569';
  grid[18][8]='#020617'; grid[18][9]='#0f172a'; grid[18][10]='#1e293b'; grid[18][11]='#020617';
  grid[19][8]='#020617'; grid[19][9]='#0f172a'; grid[19][10]='#1e293b'; grid[19][11]='#020617';
  grid[20][8]='#020617'; grid[20][9]='#090d16'; grid[20][10]='#0f172a'; grid[20][11]='#020617';
  grid[21][8]='#020617'; grid[21][9]='#090d16'; grid[21][10]='#090d16'; grid[21][11]='#020617';
  grid[22][8]='#020617'; grid[22][9]='#090d16'; grid[22][10]='#090d16'; grid[22][11]='#020617';
  // Right Leg Lifting Behind
  grid[15][5]='#020617'; grid[15][6]='#0f172a'; grid[15][7]='#1e293b';
  grid[16][4]='#020617'; grid[16][5]='#0f172a'; grid[16][6]='#334155'; grid[16][7]='#020617';
  grid[17][3]='#020617'; grid[17][4]='#334155'; grid[17][5]='#1e293b'; grid[17][6]='#020617';
  grid[18][3]='#020617'; grid[18][4]='#0f172a'; grid[18][5]='#1e293b'; grid[18][6]='#020617';
  grid[19][3]='#020617'; grid[19][4]='#090d16'; grid[19][5]='#0f172a';
  grid[20][3]='#020617'; grid[20][4]='#090d16';
  return { grid, gridSize: g };
}

function getHD_Shade_Legs_Walk6() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#334155'; grid[13][9]='#334155'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#334155'; grid[14][8]='#475569'; grid[14][9]='#334155'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#020617'; grid[15][1]='#090d16'; grid[15][2]='#0f172a';
  grid[16][0]='#020617'; grid[16][1]='#090d16';
  // Straight Support Leg (Right)
  for(let y=15;y<=17;y++) {
    grid[y][5]='#020617'; grid[y][6]='#0f172a'; grid[y][7]='#1e293b'; grid[y][8]='#020617';
  }
  grid[17][6]='#1e293b'; grid[17][7]='#334155';
  grid[18][5]='#020617'; grid[18][6]='#0f172a'; grid[18][7]='#1e293b'; grid[18][8]='#020617';
  grid[19][4]='#020617'; grid[19][5]='#0f172a'; grid[19][6]='#1e293b'; grid[19][7]='#020617';
  grid[20][4]='#020617'; grid[20][5]='#090d16'; grid[20][6]='#0f172a'; grid[20][7]='#020617';
  grid[21][4]='#020617'; grid[21][5]='#090d16'; grid[21][6]='#090d16'; grid[21][7]='#020617';
  grid[22][4]='#020617'; grid[22][5]='#090d16'; grid[22][6]='#090d16'; grid[22][7]='#020617';
  // Passing High Knee Forward (Left Leg)
  grid[15][10]='#020617'; grid[15][11]='#1e293b'; grid[15][12]='#334155';
  grid[16][10]='#020617'; grid[16][11]='#334155'; grid[16][12]='#475569'; grid[16][13]='#334155'; grid[16][14]='#020617';
  grid[17][10]='#020617'; grid[17][11]='#1e293b'; grid[17][12]='#334155'; grid[17][13]='#475569'; grid[17][14]='#020617';
  grid[18][11]='#020617'; grid[18][12]='#0f172a'; grid[18][13]='#1e293b'; grid[18][14]='#020617';
  grid[19][12]='#020617'; grid[19][13]='#090d16'; grid[19][14]='#020617';
  return { grid, gridSize: g };
}

function getHD_Shade() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  const l=getHD_Shade_Legs().grid, t=getHD_Shade_Torso().grid, gn=getHD_Shade_Gun().grid;
  for(let y=0;y<24;y++) for(let x=0;x<24;x++){
    if(l[y][x]) grid[y][x]=l[y][x];
    if(t[y][x]) grid[y][x]=t[y][x];
    if(gn[y][x]) grid[y][x]=gn[y][x];
  }
  return { grid, gridSize: g };
}

// HYPER SHADE SUITE
function getHD_HyperShade_Torso() {
  const g=24, grid=makeGrid();
  // 1. Spreading Shadow-Wing Tendrils & Cloak with Crimson Plasma Edges (y: 0..14, x: 0..6)
  grid[0][3]='#dc2626'; grid[0][4]='#020617';
  grid[1][2]='#ef4444'; grid[1][3]='#090d16'; grid[1][4]='#0f172a'; grid[1][5]='#1e293b';
  grid[2][1]='#dc2626'; grid[2][2]='#020617'; grid[2][3]='#090d16'; grid[2][4]='#090d16'; grid[2][5]='#1e293b';
  grid[3][0]='#ef4444'; grid[3][1]='#020617'; grid[3][2]='#090d16'; grid[3][3]='#020617'; grid[3][4]='#090d16'; grid[3][5]='#1e293b'; grid[3][6]='#1e293b';
  grid[4][0]='#dc2626'; grid[4][1]='#020617'; grid[4][2]='#dc2626'; grid[4][3]='#090d16'; grid[4][4]='#1e293b'; grid[4][5]='#334155'; grid[4][6]='#1e293b';
  grid[5][0]='#020617'; grid[5][1]='#090d16'; grid[5][2]='#020617'; grid[5][3]='#090d16'; grid[5][4]='#0f172a'; grid[5][5]='#1e293b'; grid[5][6]='#1e293b';
  grid[6][0]='#dc2626'; grid[6][1]='#020617'; grid[6][2]='#090d16'; grid[6][3]='#0f172a'; grid[6][4]='#1e293b'; grid[6][5]='#334155';
  grid[7][0]='#020617'; grid[7][1]='#020617'; grid[7][2]='#0f172a'; grid[7][3]='#1e293b'; grid[7][4]='#1e293b'; grid[7][5]='#0f172a';
  grid[8][0]='#ef4444'; grid[8][1]='#020617'; grid[8][2]='#0f172a'; grid[8][3]='#1e293b'; grid[8][4]='#1e293b';
  grid[9][0]='#dc2626'; grid[9][1]='#020617'; grid[9][2]='#0f172a'; grid[9][3]='#1e293b';
  grid[10][1]='#020617'; grid[10][2]='#090d16'; grid[10][3]='#1e293b'; grid[10][4]='#0f172a';
  grid[11][1]='#ef4444'; grid[11][2]='#020617'; grid[11][3]='#1e293b';
  grid[12][2]='#dc2626'; grid[12][3]='#090d16'; grid[12][4]='#0f172a';
  grid[13][2]='#020617'; grid[13][3]='#090d16';
  grid[14][3]='#020617';

  // 2. Hooded Cowl & Multi-Optic Crimson Sensor Cluster (y: 1..7, x: 7..14)
  grid[1][9]='#020617'; grid[1][10]='#0f172a'; grid[1][11]='#0f172a'; grid[1][12]='#020617';
  grid[2][8]='#020617'; grid[2][9]='#0f172a'; grid[2][10]='#ef4444'; grid[2][11]='#dc2626'; grid[2][12]='#0f172a'; grid[2][13]='#020617';
  grid[3][7]='#020617'; grid[3][8]='#0f172a'; grid[3][9]='#1e293b'; grid[3][10]='#334155'; grid[3][11]='#1e293b'; grid[3][12]='#0f172a'; grid[3][13]='#020617';
  grid[4][7]='#020617'; grid[4][8]='#0f172a'; grid[4][9]='#020617'; grid[4][10]='#dc2626';
  grid[4][11]='#ff0033'; grid[4][12]='#ff0033'; grid[4][13]='#ef4444'; grid[4][14]='#020617';
  grid[5][7]='#0f172a'; grid[5][8]='#020617'; grid[5][9]='#020617'; grid[5][10]='#dc2626';
  grid[5][11]='#ff0033'; grid[5][12]='#ef4444'; grid[5][13]='#ff0033'; grid[5][14]='#020617';
  grid[6][7]='#0f172a'; grid[6][8]='#1e293b'; grid[6][9]='#dc2626'; grid[6][10]='#ef4444'; grid[6][11]='#dc2626'; grid[6][12]='#1e293b'; grid[6][13]='#0f172a';
  grid[7][8]='#0f172a'; grid[7][9]='#1e293b'; grid[7][10]='#334155'; grid[7][11]='#1e293b'; grid[7][12]='#0f172a';

  // 3. Torso & Hyper Nanotech Armor (y: 8..13, x: 6..13)
  grid[8][6]='#0f172a'; grid[8][7]='TEAM'; grid[8][8]='TEAM'; grid[8][9]='#dc2626'; grid[8][10]='#ef4444'; grid[8][11]='#dc2626'; grid[8][12]='#1e293b'; grid[8][13]='#0f172a';
  grid[9][6]='#0f172a'; grid[9][7]='TEAM'; grid[9][8]='TEAM'; grid[9][9]='#ef4444'; grid[9][10]='#475569'; grid[9][11]='#ef4444'; grid[9][12]='#1e293b';
  grid[10][6]='#0f172a'; grid[10][7]='#1e293b'; grid[10][8]='#334155'; grid[10][9]='#dc2626'; grid[10][10]='#334155'; grid[10][11]='#1e293b';
  grid[11][6]='#0f172a'; grid[11][7]='#1e293b'; grid[11][8]='#dc2626'; grid[11][9]='#1e293b'; grid[11][10]='#1e293b'; grid[11][11]='#0f172a';
  grid[12][6]='#0f172a'; grid[12][7]='#0f172a'; grid[12][8]='#1e293b'; grid[12][9]='#dc2626'; grid[12][10]='#1e293b'; grid[12][11]='#0f172a';
  grid[13][6]='#020617'; grid[13][7]='#0f172a'; grid[13][8]='#1e293b'; grid[13][9]='#1e293b'; grid[13][10]='#0f172a'; grid[13][11]='#020617';
  return { grid, gridSize: g };
}

function getHD_HyperShade_Gun() {
  const g=24, grid=makeGrid();
  // Arms & Cybernetic Gloves with Crimson Conduits
  grid[9][6]='#1e293b'; grid[9][7]='#dc2626';
  grid[10][6]='#0f172a'; grid[10][7]='#1e293b'; grid[10][8]='#ef4444';
  grid[11][7]='#0f172a'; grid[11][8]='#1e293b'; grid[11][9]='#dc2626';
  // Multi-Optic Scope with Laser Optic
  grid[7][13]='#0f172a'; grid[7][14]='#ef4444'; grid[7][15]='#ff0033'; grid[7][16]='#f87171'; grid[7][17]='#ff0033'; grid[7][18]='#ef4444';
  grid[8][13]='#020617'; grid[8][14]='#0f172a'; grid[8][15]='#dc2626'; grid[8][16]='#ef4444'; grid[8][17]='#0f172a';
  grid[9][14]='#020617'; grid[9][16]='#020617';
  // Receiver & Crimson Power Channel
  grid[10][11]='#1e293b'; grid[10][12]='#dc2626'; grid[10][13]='#ef4444'; grid[10][14]='#dc2626'; grid[10][15]='#1e293b';
  grid[11][11]='#0f172a'; grid[11][12]='#1e293b'; grid[11][13]='#dc2626';
  grid[12][13]='#020617'; grid[12][14]='#0f172a';
  // Extended Barrel with Thermal Shroud Vents
  grid[10][16]='#475569'; grid[10][17]='#dc2626'; grid[10][18]='#64748b'; grid[10][19]='#94a3b8'; grid[10][20]='#cbd5e1';
  grid[11][16]='#1e293b'; grid[11][17]='#334155'; grid[11][18]='#dc2626'; grid[11][19]='#64748b';
  // Heavy Suppressor with Glowing Discharge Core
  grid[9][21]='#020617'; grid[9][22]='#0f172a';
  grid[10][21]='#0f172a'; grid[10][22]='#ef4444'; grid[10][23]='#ff0033';
  grid[11][21]='#0f172a'; grid[11][22]='#dc2626'; grid[11][23]='#ef4444';
  grid[12][21]='#020617'; grid[12][22]='#0f172a';
  // Heavy Bipod
  grid[12][18]='#0f172a'; grid[12][19]='#1e293b';
  grid[13][19]='#020617'; grid[13][20]='#0f172a';
  return { grid, gridSize: g };
}

function getHD_HyperShade_Legs() {
  const g=24, grid=makeGrid();
  // Belt & Pelvis with Crimson Power Nodes
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#dc2626'; grid[13][9]='#dc2626'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#ef4444'; grid[14][8]='#ff0033'; grid[14][9]='#ef4444'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  // Shadow Wing Cape Tail with Crimson Edge
  grid[14][0]='#dc2626'; grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#ef4444'; grid[15][1]='#020617'; grid[15][2]='#0f172a'; grid[15][3]='#1e293b';
  grid[16][0]='#dc2626'; grid[16][1]='#090d16'; grid[16][2]='#0f172a';
  grid[17][0]='#020617'; grid[17][1]='#090d16';
  grid[18][0]='#dc2626'; grid[18][1]='#020617';
  grid[19][0]='#020617';
  // Left Leg with Crimson Armor Tracing
  for(let y=15;y<=17;y++){
    grid[y][4]='#020617'; grid[y][5]='#0f172a'; grid[y][6]='#dc2626'; grid[y][7]='#020617';
  }
  grid[17][5]='#1e293b'; grid[17][6]='#ef4444';
  grid[18][4]='#020617'; grid[18][5]='#0f172a'; grid[18][6]='#1e293b';
  grid[19][3]='#020617'; grid[19][4]='#0f172a'; grid[19][5]='#ef4444';
  grid[20][3]='#020617'; grid[20][4]='#0f172a'; grid[20][5]='#1e293b';
  grid[21][3]='#020617'; grid[21][4]='#090d16'; grid[21][5]='#0f172a';
  grid[22][2]='#020617'; grid[22][3]='#090d16'; grid[22][4]='#090d16';
  // Right Leg with Crimson Armor Tracing
  for(let y=15;y<=17;y++){
    grid[y][9]='#020617'; grid[y][10]='#dc2626'; grid[y][11]='#ef4444'; grid[y][12]='#0f172a';
  }
  grid[17][10]='#ef4444'; grid[17][11]='#f87171';
  grid[18][9]='#020617'; grid[18][10]='#1e293b'; grid[18][11]='#0f172a';
  grid[19][9]='#020617'; grid[19][10]='#ef4444'; grid[19][11]='#0f172a'; grid[19][12]='#020617';
  grid[20][9]='#020617'; grid[20][10]='#0f172a'; grid[20][11]='#1e293b'; grid[20][12]='#020617';
  grid[21][9]='#020617'; grid[21][10]='#090d16'; grid[21][11]='#0f172a'; grid[21][12]='#020617';
  grid[22][9]='#020617'; grid[22][10]='#090d16'; grid[22][11]='#090d16'; grid[22][12]='#020617';
  return { grid, gridSize: g };
}

function getHD_HyperShade_Legs_Walk1() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#dc2626'; grid[13][9]='#dc2626'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#ef4444'; grid[14][8]='#ff0033'; grid[14][9]='#ef4444'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][0]='#dc2626'; grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#ef4444'; grid[15][1]='#020617'; grid[15][2]='#0f172a';
  grid[16][0]='#dc2626'; grid[16][1]='#090d16';
  grid[17][0]='#020617';
  // Stride Forward (Right Leg)
  grid[15][10]='#020617'; grid[15][11]='#dc2626'; grid[15][12]='#ef4444'; grid[15][13]='#0f172a';
  grid[16][11]='#020617'; grid[16][12]='#1e293b'; grid[16][13]='#ef4444'; grid[16][14]='#0f172a';
  grid[17][12]='#020617'; grid[17][13]='#ef4444'; grid[17][14]='#f87171'; grid[17][15]='#0f172a';
  grid[18][13]='#020617'; grid[18][14]='#1e293b'; grid[18][15]='#334155'; grid[18][16]='#020617';
  grid[19][13]='#020617'; grid[19][14]='#0f172a'; grid[19][15]='#ef4444'; grid[19][16]='#020617';
  grid[20][13]='#020617'; grid[20][14]='#090d16'; grid[20][15]='#0f172a'; grid[20][16]='#020617';
  grid[21][14]='#020617'; grid[21][15]='#090d16'; grid[21][16]='#0f172a';
  grid[22][14]='#020617'; grid[22][15]='#090d16'; grid[22][16]='#020617';
  // Push Back (Left Leg)
  grid[15][6]='#020617'; grid[15][7]='#0f172a'; grid[15][8]='#dc2626';
  grid[16][5]='#020617'; grid[16][6]='#0f172a'; grid[16][7]='#1e293b'; grid[16][8]='#020617';
  grid[17][4]='#020617'; grid[17][5]='#0f172a'; grid[17][6]='#ef4444'; grid[17][7]='#020617';
  grid[18][3]='#020617'; grid[18][4]='#0f172a'; grid[18][5]='#1e293b'; grid[18][6]='#020617';
  grid[19][2]='#020617'; grid[19][3]='#0f172a'; grid[19][4]='#ef4444';
  grid[20][2]='#020617'; grid[20][3]='#090d16'; grid[20][4]='#020617';
  grid[21][1]='#020617'; grid[21][2]='#090d16';
  return { grid, gridSize: g };
}

function getHD_HyperShade_Legs_Walk2() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#dc2626'; grid[13][9]='#dc2626'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#ef4444'; grid[14][8]='#ff0033'; grid[14][9]='#ef4444'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][0]='#dc2626'; grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#ef4444'; grid[15][1]='#020617'; grid[15][2]='#0f172a';
  grid[16][0]='#dc2626'; grid[16][1]='#090d16';
  // Support Flat Under Hip (Right Leg)
  for(let y=15;y<=17;y++) {
    grid[y][8]='#020617'; grid[y][9]='#1e293b'; grid[y][10]='#dc2626'; grid[y][11]='#ef4444'; grid[y][12]='#020617';
  }
  grid[17][9]='#ef4444'; grid[17][10]='#f87171';
  grid[18][8]='#020617'; grid[18][9]='#0f172a'; grid[18][10]='#1e293b'; grid[18][11]='#020617';
  grid[19][8]='#020617'; grid[19][9]='#0f172a'; grid[19][10]='#ef4444'; grid[19][11]='#020617';
  grid[20][8]='#020617'; grid[20][9]='#090d16'; grid[20][10]='#0f172a'; grid[20][11]='#020617';
  grid[21][8]='#020617'; grid[21][9]='#090d16'; grid[21][10]='#090d16'; grid[21][11]='#020617';
  grid[22][8]='#020617'; grid[22][9]='#090d16'; grid[22][10]='#090d16'; grid[22][11]='#020617';
  // Left Leg Lifting Behind
  grid[15][5]='#020617'; grid[15][6]='#0f172a'; grid[15][7]='#dc2626';
  grid[16][4]='#020617'; grid[16][5]='#0f172a'; grid[16][6]='#ef4444'; grid[16][7]='#020617';
  grid[17][3]='#020617'; grid[17][4]='#ef4444'; grid[17][5]='#1e293b'; grid[17][6]='#020617';
  grid[18][3]='#020617'; grid[18][4]='#0f172a'; grid[18][5]='#1e293b'; grid[18][6]='#020617';
  grid[19][3]='#020617'; grid[19][4]='#090d16'; grid[19][5]='#ef4444';
  grid[20][3]='#020617'; grid[20][4]='#090d16';
  return { grid, gridSize: g };
}

function getHD_HyperShade_Legs_Walk3() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#dc2626'; grid[13][9]='#dc2626'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#ef4444'; grid[14][8]='#ff0033'; grid[14][9]='#ef4444'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][0]='#dc2626'; grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#ef4444'; grid[15][1]='#020617'; grid[15][2]='#0f172a';
  grid[16][0]='#dc2626'; grid[16][1]='#090d16';
  // Straight Support Leg (Left)
  for(let y=15;y<=17;y++) {
    grid[y][5]='#020617'; grid[y][6]='#0f172a'; grid[y][7]='#dc2626'; grid[y][8]='#020617';
  }
  grid[17][6]='#1e293b'; grid[17][7]='#ef4444';
  grid[18][5]='#020617'; grid[18][6]='#0f172a'; grid[18][7]='#1e293b'; grid[18][8]='#020617';
  grid[19][4]='#020617'; grid[19][5]='#0f172a'; grid[19][6]='#ef4444'; grid[19][7]='#020617';
  grid[20][4]='#020617'; grid[20][5]='#090d16'; grid[20][6]='#0f172a'; grid[20][7]='#020617';
  grid[21][4]='#020617'; grid[21][5]='#090d16'; grid[21][6]='#090d16'; grid[21][7]='#020617';
  grid[22][4]='#020617'; grid[22][5]='#090d16'; grid[22][6]='#090d16'; grid[22][7]='#020617';
  // Passing High Knee Forward (Right Leg)
  grid[15][10]='#020617'; grid[15][11]='#1e293b'; grid[15][12]='#dc2626';
  grid[16][10]='#020617'; grid[16][11]='#ef4444'; grid[16][12]='#f87171'; grid[16][13]='#ef4444'; grid[16][14]='#020617';
  grid[17][10]='#020617'; grid[17][11]='#1e293b'; grid[17][12]='#dc2626'; grid[17][13]='#ef4444'; grid[17][14]='#020617';
  grid[18][11]='#020617'; grid[18][12]='#0f172a'; grid[18][13]='#1e293b'; grid[18][14]='#020617';
  grid[19][12]='#020617'; grid[19][13]='#090d16'; grid[19][14]='#020617';
  return { grid, gridSize: g };
}

function getHD_HyperShade_Legs_Walk4() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#dc2626'; grid[13][9]='#dc2626'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#ef4444'; grid[14][8]='#ff0033'; grid[14][9]='#ef4444'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][0]='#dc2626'; grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#ef4444'; grid[15][1]='#020617'; grid[15][2]='#0f172a';
  grid[16][0]='#dc2626'; grid[16][1]='#090d16';
  grid[17][0]='#020617';
  // Stride Forward (Left Leg)
  grid[15][10]='#020617'; grid[15][11]='#dc2626'; grid[15][12]='#ef4444'; grid[15][13]='#0f172a';
  grid[16][11]='#020617'; grid[16][12]='#1e293b'; grid[16][13]='#ef4444'; grid[16][14]='#0f172a';
  grid[17][12]='#020617'; grid[17][13]='#ef4444'; grid[17][14]='#f87171'; grid[17][15]='#0f172a';
  grid[18][13]='#020617'; grid[18][14]='#1e293b'; grid[18][15]='#334155'; grid[18][16]='#020617';
  grid[19][13]='#020617'; grid[19][14]='#0f172a'; grid[19][15]='#ef4444'; grid[19][16]='#020617';
  grid[20][13]='#020617'; grid[20][14]='#090d16'; grid[20][15]='#0f172a'; grid[20][16]='#020617';
  grid[21][14]='#020617'; grid[21][15]='#090d16'; grid[21][16]='#0f172a';
  grid[22][14]='#020617'; grid[22][15]='#090d16'; grid[22][16]='#020617';
  // Push Back (Right Leg)
  grid[15][6]='#020617'; grid[15][7]='#0f172a'; grid[15][8]='#dc2626';
  grid[16][5]='#020617'; grid[16][6]='#0f172a'; grid[16][7]='#1e293b'; grid[16][8]='#020617';
  grid[17][4]='#020617'; grid[17][5]='#0f172a'; grid[17][6]='#ef4444'; grid[17][7]='#020617';
  grid[18][3]='#020617'; grid[18][4]='#0f172a'; grid[18][5]='#1e293b'; grid[18][6]='#020617';
  grid[19][2]='#020617'; grid[19][3]='#0f172a'; grid[19][4]='#ef4444';
  grid[20][2]='#020617'; grid[20][3]='#090d16'; grid[20][4]='#020617';
  grid[21][1]='#020617'; grid[21][2]='#090d16';
  return { grid, gridSize: g };
}

function getHD_HyperShade_Legs_Walk5() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#dc2626'; grid[13][9]='#dc2626'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#ef4444'; grid[14][8]='#ff0033'; grid[14][9]='#ef4444'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][0]='#dc2626'; grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#ef4444'; grid[15][1]='#020617'; grid[15][2]='#0f172a';
  grid[16][0]='#dc2626'; grid[16][1]='#090d16';
  // Support Flat Under Hip (Left Leg)
  for(let y=15;y<=17;y++) {
    grid[y][8]='#020617'; grid[y][9]='#1e293b'; grid[y][10]='#dc2626'; grid[y][11]='#ef4444'; grid[y][12]='#020617';
  }
  grid[17][9]='#ef4444'; grid[17][10]='#f87171';
  grid[18][8]='#020617'; grid[18][9]='#0f172a'; grid[18][10]='#1e293b'; grid[18][11]='#020617';
  grid[19][8]='#020617'; grid[19][9]='#0f172a'; grid[19][10]='#ef4444'; grid[19][11]='#020617';
  grid[20][8]='#020617'; grid[20][9]='#090d16'; grid[20][10]='#0f172a'; grid[20][11]='#020617';
  grid[21][8]='#020617'; grid[21][9]='#090d16'; grid[21][10]='#090d16'; grid[21][11]='#020617';
  grid[22][8]='#020617'; grid[22][9]='#090d16'; grid[22][10]='#090d16'; grid[22][11]='#020617';
  // Right Leg Lifting Behind
  grid[15][5]='#020617'; grid[15][6]='#0f172a'; grid[15][7]='#dc2626';
  grid[16][4]='#020617'; grid[16][5]='#0f172a'; grid[16][6]='#ef4444'; grid[16][7]='#020617';
  grid[17][3]='#020617'; grid[17][4]='#ef4444'; grid[17][5]='#1e293b'; grid[17][6]='#020617';
  grid[18][3]='#020617'; grid[18][4]='#0f172a'; grid[18][5]='#1e293b'; grid[18][6]='#020617';
  grid[19][3]='#020617'; grid[19][4]='#090d16'; grid[19][5]='#ef4444';
  grid[20][3]='#020617'; grid[20][4]='#090d16';
  return { grid, gridSize: g };
}

function getHD_HyperShade_Legs_Walk6() {
  const g=24, grid=makeGrid();
  grid[13][6]='#0f172a'; grid[13][7]='#1e293b'; grid[13][8]='#dc2626'; grid[13][9]='#dc2626'; grid[13][10]='#1e293b'; grid[13][11]='#0f172a';
  grid[14][5]='#0f172a'; grid[14][6]='#020617'; grid[14][7]='#ef4444'; grid[14][8]='#ff0033'; grid[14][9]='#ef4444'; grid[14][10]='#020617'; grid[14][11]='#0f172a';
  grid[14][0]='#dc2626'; grid[14][1]='#020617'; grid[14][2]='#090d16'; grid[14][3]='#1e293b';
  grid[15][0]='#ef4444'; grid[15][1]='#020617'; grid[15][2]='#0f172a';
  grid[16][0]='#dc2626'; grid[16][1]='#090d16';
  // Straight Support Leg (Right)
  for(let y=15;y<=17;y++) {
    grid[y][5]='#020617'; grid[y][6]='#0f172a'; grid[y][7]='#dc2626'; grid[y][8]='#020617';
  }
  grid[17][6]='#1e293b'; grid[17][7]='#ef4444';
  grid[18][5]='#020617'; grid[18][6]='#0f172a'; grid[18][7]='#1e293b'; grid[18][8]='#020617';
  grid[19][4]='#020617'; grid[19][5]='#0f172a'; grid[19][6]='#ef4444'; grid[19][7]='#020617';
  grid[20][4]='#020617'; grid[20][5]='#090d16'; grid[20][6]='#0f172a'; grid[20][7]='#020617';
  grid[21][4]='#020617'; grid[21][5]='#090d16'; grid[21][6]='#090d16'; grid[21][7]='#020617';
  grid[22][4]='#020617'; grid[22][5]='#090d16'; grid[22][6]='#090d16'; grid[22][7]='#020617';
  // Passing High Knee Forward (Left Leg)
  grid[15][10]='#020617'; grid[15][11]='#1e293b'; grid[15][12]='#dc2626';
  grid[16][10]='#020617'; grid[16][11]='#ef4444'; grid[16][12]='#f87171'; grid[16][13]='#ef4444'; grid[16][14]='#020617';
  grid[17][10]='#020617'; grid[17][11]='#1e293b'; grid[17][12]='#dc2626'; grid[17][13]='#ef4444'; grid[17][14]='#020617';
  grid[18][11]='#020617'; grid[18][12]='#0f172a'; grid[18][13]='#1e293b'; grid[18][14]='#020617';
  grid[19][12]='#020617'; grid[19][13]='#090d16'; grid[19][14]='#020617';
  return { grid, gridSize: g };
}

function getHD_HyperShade() {
  const g=24, grid=Array.from({length:24},()=>Array(24).fill(null));
  const l=getHD_HyperShade_Legs().grid, t=getHD_HyperShade_Torso().grid, gn=getHD_HyperShade_Gun().grid;
  for(let y=0;y<24;y++) for(let x=0;x<24;x++){
    if(l[y][x]) grid[y][x]=l[y][x];
    if(t[y][x]) grid[y][x]=t[y][x];
    if(gn[y][x]) grid[y][x]=gn[y][x];
  }
  return { grid, gridSize: g };
}


// ── TESLA WALKER (24x24 HD REFERENCE) ───────────────────────────

function getHD_TeslaWalker_Tesla() {
  const g = 24, grid = makeGrid();
  // 1. Dual High-Voltage Discharge Horns / Electrodes (y: 0..3, x: 7..8 & 15..16)
  grid[0][7] = '#ffffff'; grid[0][8] = '#00f0ff';
  grid[0][15] = '#00f0ff'; grid[0][16] = '#ffffff';
  grid[1][7] = '#38bdf8'; grid[1][8] = '#94a3b8';
  grid[1][15] = '#94a3b8'; grid[1][16] = '#38bdf8';
  grid[2][8] = '#64748b'; grid[2][15] = '#64748b';
  grid[3][8] = '#475569'; grid[3][15] = '#475569';

  // 2. Spherical Toroid Emitter / Glowing Plasma Orb (y: 1..4, x: 9..14)
  grid[1][10] = '#38bdf8'; grid[1][11] = '#00f0ff'; grid[1][12] = '#ffffff'; grid[1][13] = '#00f0ff';
  grid[2][9] = '#0284c7'; grid[2][10] = '#38bdf8'; grid[2][11] = '#00f0ff'; grid[2][12] = '#ffffff'; grid[2][13] = '#00f0ff'; grid[2][14] = '#38bdf8';
  grid[3][9] = '#0284c7'; grid[3][10] = '#0284c7'; grid[3][11] = '#38bdf8'; grid[3][12] = '#00f0ff'; grid[3][13] = '#38bdf8'; grid[3][14] = '#0284c7';
  grid[4][10] = '#0f172a'; grid[4][11] = '#0284c7'; grid[4][12] = '#38bdf8'; grid[4][13] = '#0284c7';

  // 3. Dielectric Ceramic Insulators & Copper Coil Windings (y: 4..8, x: 6..17)
  grid[4][7] = '#1e293b'; grid[4][8] = '#334155'; grid[4][9] = '#475569';
  grid[4][14] = '#475569'; grid[4][15] = '#334155'; grid[4][16] = '#1e293b';

  // Upper Coil Ring
  grid[5][6] = '#1e293b'; grid[5][7] = '#475569'; grid[5][8] = '#64748b';
  grid[5][9] = '#f59e0b'; grid[5][10] = '#fbbf24'; grid[5][11] = '#f59e0b';
  grid[5][12] = '#fbbf24'; grid[5][13] = '#f59e0b'; grid[5][14] = '#d97706';
  grid[5][15] = '#64748b'; grid[5][16] = '#475569'; grid[5][17] = '#1e293b';

  // Mid Coil Ring
  grid[6][6] = '#1e293b'; grid[6][7] = '#334155'; grid[6][8] = '#475569';
  grid[6][9] = '#d97706'; grid[6][10] = '#f59e0b'; grid[6][11] = '#d97706';
  grid[6][12] = '#f59e0b'; grid[6][13] = '#d97706'; grid[6][14] = '#b45309';
  grid[6][15] = '#475569'; grid[6][16] = '#334155'; grid[6][17] = '#1e293b';

  // Lower Coil Ring & Ceramic Base
  grid[7][7] = '#1e293b'; grid[7][8] = '#475569';
  grid[7][9] = '#b45309'; grid[7][10] = '#d97706'; grid[7][11] = '#b45309';
  grid[7][12] = '#d97706'; grid[7][13] = '#b45309'; grid[7][14] = '#78350f';
  grid[7][15] = '#475569'; grid[7][16] = '#1e293b';

  // 4. Base Mounting Swivel Flange (y: 8..9, x: 8..15)
  grid[8][8] = '#0f172a'; grid[8][9] = '#1e293b';
  for (let x = 10; x <= 13; x++) grid[8][x] = '#334155';
  grid[8][14] = '#1e293b'; grid[8][15] = '#0f172a';

  grid[9][9] = '#0f172a';
  for (let x = 10; x <= 13; x++) grid[9][x] = '#1e293b';
  grid[9][14] = '#0f172a';

  return { gridSize: g, grid };
}

function getHD_TeslaWalker_Chassis() {
  const g = 24, grid = makeGrid();
  // 1. Top Bevel & Capacitor Housing (y: 9..11, x: 6..17)
  grid[9][7] = '#1e293b'; grid[9][8] = '#475569';
  for (let x = 9; x <= 14; x++) grid[9][x] = '#64748b';
  grid[9][15] = '#475569'; grid[9][16] = '#1e293b';

  grid[10][6] = '#1e293b'; grid[10][7] = '#334155';
  for (let x = 8; x <= 15; x++) grid[10][x] = '#475569';
  grid[10][16] = '#334155'; grid[10][17] = '#1e293b';

  // 2. Main Carapace Body Hull (y: 11..16, x: 5..18)
  for (let y = 11; y <= 16; y++) {
    for (let x = 5; x <= 18; x++) {
      if (y === 11) {
        grid[y][x] = (x === 5 || x === 18) ? '#1e293b' : (x >= 15 ? '#64748b' : '#475569');
      } else if (y === 16) {
        grid[y][x] = (x === 5 || x === 18) ? '#0f172a' : '#1e293b';
      } else if (x === 5) {
        grid[y][x] = '#0f172a';
      } else if (x === 18) {
        grid[y][x] = '#64748b';
      } else {
        grid[y][x] = '#334155';
      }
    }
  }

  // Armor highlights & seam lines
  grid[11][12] = '#64748b'; grid[11][13] = '#94a3b8'; grid[11][14] = '#64748b';
  grid[12][5] = '#0284c7'; grid[12][6] = '#38bdf8'; // Power cell vent
  grid[13][5] = '#00f0ff'; grid[13][6] = '#0284c7';
  grid[14][5] = '#0f172a'; grid[14][6] = '#1e293b';

  // 3. Team Insignia Decals (y: 12..14, x: 9..12)
  for (let y = 12; y <= 14; y++) {
    for (let x = 9; x <= 12; x++) {
      grid[y][x] = 'TEAM';
    }
  }

  // 4. Forward Optical Sensor Eye / Visor (y: 12..15, x: 16..19) facing +X
  grid[12][16] = '#1e293b'; grid[12][17] = '#0284c7'; grid[12][18] = '#38bdf8'; grid[12][19] = '#00f0ff';
  grid[13][16] = '#0284c7'; grid[13][17] = '#38bdf8'; grid[13][18] = '#00f0ff'; grid[13][19] = '#ffffff';
  grid[14][16] = '#0284c7'; grid[14][17] = '#00f0ff'; grid[14][18] = '#38bdf8'; grid[14][19] = '#0284c7';
  grid[15][16] = '#0f172a'; grid[15][17] = '#0284c7'; grid[15][18] = '#1e293b';

  return { gridSize: g, grid };
}

function getHD_TeslaWalker_Legs() {
  const g = 24, grid = makeGrid();
  // Central Under-Chassis Mount / Hip Pivot (y: 14..15, x: 7..16)
  for (let x = 7; x <= 16; x++) {
    grid[14][x] = '#1e293b';
    grid[15][x] = '#0f172a';
  }
  grid[14][11] = '#475569'; grid[14][12] = '#64748b';

  // ── Left Arm / Front-Left Limb (2px thick horizontal strut & 2px vertical shaft) ──
  grid[12][4] = '#475569'; grid[12][5] = '#334155';
  grid[13][4] = '#334155'; grid[13][5] = '#1e293b';
  grid[12][2] = '#64748b'; grid[12][3] = '#475569';
  grid[13][2] = '#475569'; grid[13][3] = '#334155';

  // Elbow joint (y: 11..12, x: 1..2)
  grid[11][1] = '#cbd5e1'; grid[11][2] = '#94a3b8';
  grid[12][1] = '#94a3b8';

  // Vertical shaft (2px wide: x: 1..2)
  for (let y = 13; y <= 20; y++) {
    grid[y][1] = (y % 2 === 0) ? '#64748b' : '#475569';
    grid[y][2] = (y % 2 === 0) ? '#475569' : '#334155';
  }

  // Foot pad
  grid[21][0] = '#475569'; grid[21][1] = '#94a3b8'; grid[21][2] = '#64748b';
  grid[22][0] = '#64748b'; grid[22][1] = '#cbd5e1'; grid[22][2] = '#94a3b8';
  grid[23][0] = '#0f172a'; grid[23][1] = '#94a3b8'; grid[23][2] = '#475569';

  // ── Right Arm / Front-Right Limb (2px thick horizontal strut & 2px vertical shaft) ──
  grid[12][18] = '#334155'; grid[12][19] = '#475569';
  grid[13][18] = '#1e293b'; grid[13][19] = '#334155';
  grid[12][20] = '#475569'; grid[12][21] = '#64748b';
  grid[13][20] = '#334155'; grid[13][21] = '#475569';

  // Elbow joint (y: 11..12, x: 21..22)
  grid[11][21] = '#94a3b8'; grid[11][22] = '#cbd5e1';
  grid[12][22] = '#94a3b8';

  // Vertical shaft (2px wide: x: 21..22)
  for (let y = 13; y <= 20; y++) {
    grid[y][21] = (y % 2 === 0) ? '#475569' : '#334155';
    grid[y][22] = (y % 2 === 0) ? '#64748b' : '#475569';
  }

  // Foot pad
  grid[21][21] = '#64748b'; grid[21][22] = '#94a3b8'; grid[21][23] = '#475569';
  grid[22][21] = '#94a3b8'; grid[22][22] = '#cbd5e1'; grid[22][23] = '#64748b';
  grid[23][21] = '#475569'; grid[23][22] = '#94a3b8'; grid[23][23] = '#0f172a';

  // ── Rear-Left Leg (2px wide: x: 6..7) ──
  grid[15][7] = '#1e293b'; grid[15][6] = '#0f172a';
  for (let y = 16; y <= 21; y++) {
    grid[y][6] = (y % 2 === 0) ? '#475569' : '#334155';
    grid[y][7] = (y % 2 === 0) ? '#64748b' : '#475569';
  }
  grid[22][5] = '#64748b'; grid[22][6] = '#94a3b8'; grid[22][7] = '#64748b';
  grid[23][5] = '#0f172a'; grid[23][6] = '#cbd5e1'; grid[23][7] = '#475569';

  // ── Rear-Right Leg (2px wide: x: 16..17) ──
  grid[15][16] = '#1e293b'; grid[15][17] = '#0f172a';
  for (let y = 16; y <= 21; y++) {
    grid[y][16] = (y % 2 === 0) ? '#64748b' : '#475569';
    grid[y][17] = (y % 2 === 0) ? '#475569' : '#334155';
  }
  grid[22][16] = '#64748b'; grid[22][17] = '#94a3b8'; grid[22][18] = '#64748b';
  grid[23][16] = '#475569'; grid[23][17] = '#cbd5e1'; grid[23][18] = '#0f172a';

  return { gridSize: g, grid };
}

function getHD_TeslaWalker_Legs_Walk1() {
  const g = 24, grid = makeGrid();
  for (let x = 7; x <= 16; x++) { grid[14][x] = '#1e293b'; grid[15][x] = '#0f172a'; }
  grid[14][11] = '#475569'; grid[14][12] = '#64748b';

  // Front-Right Leg Lunges Extended Forward (+X)
  grid[12][18] = '#334155'; grid[12][19] = '#475569';
  grid[13][18] = '#1e293b'; grid[13][19] = '#334155';
  grid[11][20] = '#64748b'; grid[11][21] = '#94a3b8';
  grid[10][21] = '#94a3b8'; grid[10][22] = '#cbd5e1';
  grid[11][22] = '#94a3b8'; grid[11][23] = '#cbd5e1';
  for (let y = 12; y <= 16; y++) {
    grid[y][22] = (y % 2 === 0) ? '#64748b' : '#475569';
    grid[y][23] = (y % 2 === 0) ? '#475569' : '#334155';
  }
  grid[17][22] = '#475569'; grid[17][23] = '#94a3b8';
  grid[18][22] = '#64748b'; grid[18][23] = '#cbd5e1';
  grid[19][22] = '#334155'; grid[19][23] = '#ffffff';

  // Rear-Left Leg Steps Forward
  grid[15][7] = '#1e293b'; grid[15][8] = '#334155';
  for (let y = 16; y <= 20; y++) {
    grid[y][7] = (y % 2 === 0) ? '#334155' : '#475569';
    grid[y][8] = (y % 2 === 0) ? '#475569' : '#64748b';
  }
  grid[21][7] = '#475569'; grid[21][8] = '#94a3b8';
  grid[22][7] = '#64748b'; grid[22][8] = '#cbd5e1';
  grid[23][7] = '#334155'; grid[23][8] = '#ffffff';

  // Front-Left Leg Planted Solidly
  grid[12][4] = '#475569'; grid[12][5] = '#334155';
  grid[13][4] = '#334155'; grid[13][5] = '#1e293b';
  grid[12][2] = '#64748b'; grid[12][3] = '#475569';
  grid[13][2] = '#475569'; grid[13][3] = '#334155';
  grid[11][1] = '#cbd5e1'; grid[11][2] = '#94a3b8';
  grid[12][1] = '#94a3b8';
  for (let y = 13; y <= 18; y++) {
    grid[y][1] = (y % 2 === 0) ? '#64748b' : '#475569';
    grid[y][2] = (y % 2 === 0) ? '#475569' : '#334155';
  }
  grid[19][0] = '#334155'; grid[19][1] = '#475569';
  grid[20][0] = '#475569'; grid[20][1] = '#64748b';
  grid[21][0] = '#64748b'; grid[21][1] = '#94a3b8';
  grid[22][0] = '#94a3b8'; grid[22][1] = '#cbd5e1';
  grid[23][0] = '#0f172a'; grid[23][1] = '#64748b';

  // Rear-Right Leg Planted Back
  grid[15][16] = '#1e293b'; grid[15][15] = '#0f172a';
  for (let y = 16; y <= 20; y++) {
    grid[y][15] = (y % 2 === 0) ? '#64748b' : '#475569';
    grid[y][16] = (y % 2 === 0) ? '#475569' : '#334155';
  }
  grid[21][14] = '#475569'; grid[21][15] = '#64748b';
  grid[22][14] = '#64748b'; grid[22][15] = '#94a3b8';
  grid[23][14] = '#0f172a'; grid[23][15] = '#cbd5e1';

  return { gridSize: g, grid };
}

function getHD_TeslaWalker_Legs_Walk2() {
  const g = 24, grid = makeGrid();
  for (let x = 7; x <= 16; x++) { grid[14][x] = '#1e293b'; grid[15][x] = '#0f172a'; }
  grid[14][11] = '#475569'; grid[14][12] = '#64748b';

  // Front-Left Leg
  grid[12][4] = '#475569'; grid[12][5] = '#334155';
  grid[13][4] = '#334155'; grid[13][5] = '#1e293b';
  grid[12][2] = '#64748b'; grid[12][3] = '#475569';
  grid[13][2] = '#475569'; grid[13][3] = '#334155';
  grid[11][1] = '#cbd5e1'; grid[11][2] = '#94a3b8';
  grid[12][1] = '#94a3b8';
  for (let y = 13; y <= 20; y++) {
    grid[y][1] = (y % 2 === 0) ? '#64748b' : '#475569';
    grid[y][2] = (y % 2 === 0) ? '#475569' : '#334155';
  }
  grid[21][0] = '#475569'; grid[21][1] = '#94a3b8'; grid[21][2] = '#64748b';
  grid[22][0] = '#64748b'; grid[22][1] = '#cbd5e1'; grid[22][2] = '#94a3b8';
  grid[23][0] = '#0f172a'; grid[23][1] = '#94a3b8'; grid[23][2] = '#cbd5e1';

  // Front-Right Leg
  grid[12][18] = '#334155'; grid[12][19] = '#475569';
  grid[13][18] = '#1e293b'; grid[13][19] = '#334155';
  grid[12][20] = '#475569'; grid[12][21] = '#64748b';
  grid[13][20] = '#334155'; grid[13][21] = '#475569';
  grid[11][21] = '#94a3b8'; grid[11][22] = '#cbd5e1';
  grid[12][22] = '#94a3b8';
  for (let y = 13; y <= 20; y++) {
    grid[y][21] = (y % 2 === 0) ? '#475569' : '#334155';
    grid[y][22] = (y % 2 === 0) ? '#64748b' : '#475569';
  }
  grid[21][21] = '#64748b'; grid[21][22] = '#94a3b8'; grid[21][23] = '#475569';
  grid[22][21] = '#94a3b8'; grid[22][22] = '#cbd5e1'; grid[22][23] = '#64748b';
  grid[23][21] = '#0f172a'; grid[23][22] = '#94a3b8'; grid[23][23] = '#cbd5e1';

  // Rear-Left Leg
  grid[15][7] = '#1e293b'; grid[15][6] = '#0f172a';
  for (let y = 16; y <= 21; y++) {
    grid[y][6] = (y % 2 === 0) ? '#475569' : '#334155';
    grid[y][7] = (y % 2 === 0) ? '#64748b' : '#475569';
  }
  grid[22][6] = '#64748b'; grid[22][7] = '#94a3b8';
  grid[23][6] = '#0f172a'; grid[23][7] = '#cbd5e1';

  // Rear-Right Leg
  grid[15][16] = '#1e293b'; grid[15][17] = '#0f172a';
  for (let y = 16; y <= 21; y++) {
    grid[y][16] = (y % 2 === 0) ? '#64748b' : '#475569';
    grid[y][17] = (y % 2 === 0) ? '#475569' : '#334155';
  }
  grid[22][16] = '#94a3b8'; grid[22][17] = '#64748b';
  grid[23][16] = '#cbd5e1'; grid[23][17] = '#0f172a';

  return { gridSize: g, grid };
}

function getHD_TeslaWalker_Legs_Walk3() {
  const g = 24, grid = makeGrid();
  for (let x = 7; x <= 16; x++) { grid[14][x] = '#1e293b'; grid[15][x] = '#0f172a'; }
  grid[14][11] = '#475569'; grid[14][12] = '#64748b';

  // Front-Left Leg Lunges Extended Forward / Reaches High
  grid[12][4] = '#475569'; grid[12][5] = '#334155';
  grid[13][4] = '#334155'; grid[13][5] = '#1e293b';
  grid[11][2] = '#94a3b8'; grid[11][3] = '#64748b';
  grid[10][1] = '#cbd5e1'; grid[10][2] = '#94a3b8';
  grid[11][0] = '#cbd5e1'; grid[11][1] = '#94a3b8';
  for (let y = 12; y <= 16; y++) {
    grid[y][0] = (y % 2 === 0) ? '#64748b' : '#475569';
    grid[y][1] = (y % 2 === 0) ? '#475569' : '#334155';
  }
  grid[17][0] = '#94a3b8'; grid[17][1] = '#475569';
  grid[18][0] = '#cbd5e1'; grid[18][1] = '#64748b';
  grid[19][0] = '#ffffff'; grid[19][1] = '#334155';

  // Rear-Right Leg Steps Forward
  grid[15][16] = '#1e293b'; grid[15][15] = '#334155';
  for (let y = 16; y <= 20; y++) {
    grid[y][15] = (y % 2 === 0) ? '#475569' : '#64748b';
    grid[y][16] = (y % 2 === 0) ? '#334155' : '#475569';
  }
  grid[21][15] = '#94a3b8'; grid[21][16] = '#475569';
  grid[22][15] = '#cbd5e1'; grid[22][16] = '#64748b';
  grid[23][15] = '#ffffff'; grid[23][16] = '#334155';

  // Front-Right Leg Planted Back
  grid[12][18] = '#334155'; grid[12][19] = '#475569';
  grid[13][18] = '#1e293b'; grid[13][19] = '#334155';
  grid[12][20] = '#475569'; grid[12][21] = '#64748b';
  grid[13][20] = '#334155'; grid[13][21] = '#475569';
  grid[11][21] = '#94a3b8'; grid[11][22] = '#cbd5e1';
  grid[12][22] = '#94a3b8';
  for (let y = 13; y <= 18; y++) {
    grid[y][21] = (y % 2 === 0) ? '#475569' : '#334155';
    grid[y][22] = (y % 2 === 0) ? '#64748b' : '#475569';
  }
  grid[19][22] = '#475569'; grid[19][23] = '#334155';
  grid[20][22] = '#64748b'; grid[20][23] = '#475569';
  grid[21][22] = '#94a3b8'; grid[21][23] = '#64748b';
  grid[22][22] = '#cbd5e1'; grid[22][23] = '#94a3b8';
  grid[23][22] = '#64748b'; grid[23][23] = '#0f172a';

  // Rear-Left Leg Planted Back
  grid[15][7] = '#1e293b'; grid[15][8] = '#0f172a';
  for (let y = 16; y <= 20; y++) {
    grid[y][7] = (y % 2 === 0) ? '#334155' : '#475569';
    grid[y][8] = (y % 2 === 0) ? '#475569' : '#64748b';
  }
  grid[21][8] = '#64748b'; grid[21][9] = '#475569';
  grid[22][8] = '#94a3b8'; grid[22][9] = '#64748b';
  grid[23][8] = '#cbd5e1'; grid[23][9] = '#0f172a';

  return { gridSize: g, grid };
}

function getHD_TeslaWalker_Legs_Walk4() {
  return getHD_TeslaWalker_Legs_Walk2();
}

function getHD_TeslaWalker() {
  const g = 24, grid = makeGrid();
  const l = getHD_TeslaWalker_Legs().grid;
  const c = getHD_TeslaWalker_Chassis().grid;
  const t = getHD_TeslaWalker_Tesla().grid;

  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (l[y][x]) grid[y][x] = l[y][x];
      if (c[y][x]) grid[y][x] = c[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
    }
  }
  return { gridSize: g, grid };
}

function _composeTeslaWalkerWalk(walkNum) {
  const g = 24, grid = makeGrid();
  const legsFunc = walkNum === 1 ? getHD_TeslaWalker_Legs_Walk1
                 : walkNum === 2 ? getHD_TeslaWalker_Legs_Walk2
                 : walkNum === 3 ? getHD_TeslaWalker_Legs_Walk3
                 : getHD_TeslaWalker_Legs_Walk4;
  const l = legsFunc().grid;
  const c = getHD_TeslaWalker_Chassis().grid;
  const t = getHD_TeslaWalker_Tesla().grid;
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (l[y][x]) grid[y][x] = l[y][x];
      if (c[y][x]) grid[y][x] = c[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
    }
  }
  return { gridSize: g, grid };
}
function getHD_TeslaWalker_Walk1() { return _composeTeslaWalkerWalk(1); }
function getHD_TeslaWalker_Walk2() { return _composeTeslaWalkerWalk(2); }
function getHD_TeslaWalker_Walk3() { return _composeTeslaWalkerWalk(3); }
function getHD_TeslaWalker_Walk4() { return _composeTeslaWalkerWalk(4); }


// ── HYPER TESLA WALKER (24x24 HD REFERENCE) ─────────────────────

function getHD_HyperTeslaWalker_Tail() {
  const g = 24, grid = makeGrid();
  // ⚡ Arched Segmented Scorpion Tail & Copper-Wound Tesla Coil Emitter (y: 0..15, x: 1..23)

  // 1. Tail Root & Swivel Base (x: 2..7, y: 11..15)
  grid[13][3] = '#0f172a'; grid[13][4] = '#334155'; grid[13][5] = '#1e293b';
  grid[12][2] = '#1e293b'; grid[12][3] = '#d97706'; grid[12][4] = '#f59e0b'; grid[12][5] = '#b45309'; grid[12][6] = '#1e293b';
  grid[11][2] = '#334155'; grid[11][3] = '#475569'; grid[11][4] = '#64748b'; grid[11][5] = '#475569'; grid[11][6] = '#334155';
  grid[10][2] = '#1e293b'; grid[10][3] = '#475569'; grid[10][4] = '#d97706'; grid[10][5] = '#1e293b';

  // 2. Curving Armored Tail Segments (x: 1..8, y: 2..10)
  grid[9][1] = '#1e293b'; grid[9][2] = '#475569'; grid[9][3] = '#64748b'; grid[9][4] = '#d97706';
  grid[8][1] = '#334155'; grid[8][2] = '#64748b'; grid[8][3] = '#94a3b8'; grid[8][4] = '#475569';
  grid[7][1] = '#1e293b'; grid[7][2] = '#475569'; grid[7][3] = '#64748b'; grid[7][4] = '#d97706';
  grid[6][1] = '#334155'; grid[6][2] = '#64748b'; grid[6][3] = '#94a3b8';
  grid[5][1] = '#1e293b'; grid[5][2] = '#475569'; grid[5][3] = '#64748b'; grid[5][4] = '#d97706';
  grid[4][2] = '#334155'; grid[4][3] = '#64748b'; grid[4][4] = '#94a3b8'; grid[4][5] = '#475569';
  grid[3][3] = '#1e293b'; grid[3][4] = '#475569'; grid[3][5] = '#64748b'; grid[3][6] = '#94a3b8';
  grid[2][4] = '#334155'; grid[2][5] = '#64748b'; grid[2][6] = '#94a3b8'; grid[2][7] = '#cbd5e1'; grid[2][8] = '#94a3b8';

  // 3. Massive Glowing Copper-Wound Tesla Coil (x: 8..17, y: 0..5)
  // Rear Ceramic Dielectric Insulator Collar
  grid[1][8] = '#1e293b'; grid[2][8] = '#475569'; grid[3][8] = '#475569'; grid[4][8] = '#334155';
  grid[1][9] = '#334155'; grid[2][9] = '#64748b'; grid[3][9] = '#64748b'; grid[4][9] = '#1e293b';

  // Twin Angled Copper Electrodes / Antennae (x: 7..11, y: 0..1)
  grid[0][7] = '#d97706'; grid[0][8] = '#f59e0b'; grid[0][9] = '#ffffff'; grid[0][10] = '#f59e0b'; grid[0][11] = '#d97706';
  grid[1][10] = '#d97706'; grid[1][11] = '#f59e0b';

  // Dense Copper Wire Windings (x: 10..16, y: 1..5)
  for (let x = 10; x <= 16; x++) {
    grid[1][x] = (x % 2 === 0) ? '#f59e0b' : '#fbbf24'; // Bright copper wire gleam
    grid[2][x] = (x % 2 === 0) ? '#d97706' : '#f59e0b'; // Core wire winding
    grid[3][x] = (x % 2 === 0) ? '#b45309' : '#d97706'; // Shaded copper underbelly
    grid[4][x] = (x % 2 === 0) ? '#78350f' : '#b45309'; // Lower copper coil mass
  }

  // Front Ceramic Insulator Collar (x: 17, y: 1..4)
  grid[1][17] = '#475569'; grid[2][17] = '#64748b'; grid[3][17] = '#64748b'; grid[4][17] = '#334155';

  // 4. Emitter Cone & Forward Needle Stinger (x: 18..23, y: 1..4)
  grid[1][18] = '#0284c7'; grid[2][18] = '#38bdf8'; grid[3][18] = '#0284c7';
  grid[1][19] = '#38bdf8'; grid[2][19] = '#00f0ff'; grid[3][19] = '#38bdf8';
  grid[2][20] = '#00f0ff'; grid[2][21] = '#ffffff'; grid[3][21] = '#38bdf8';
  grid[2][22] = '#00f0ff'; grid[2][23] = '#ffffff'; // Needle point stinger

  return { gridSize: g, grid };
}

function getHD_HyperTeslaWalker_Chassis() {
  const g = 24, grid = makeGrid();
  // 🛡️ Heavy Armored Scorpion Walker Hull & Cockpit (Facing +X)

  // 1. Armored Carapace Body Plates (x: 4..17, y: 9..13 - sleeker, low-profile hull)
  for (let y = 9; y <= 13; y++) {
    for (let x = 4; x <= 17; x++) {
      grid[y][x] = (y === 9 || x === 17) ? '#64748b' : ((x === 4 || y === 13) ? '#0f172a' : '#334155');
    }
  }
  grid[8][6] = '#1e293b'; grid[8][7] = '#475569'; grid[8][8] = '#64748b'; grid[8][9] = '#64748b';
  grid[8][10] = '#475569'; grid[8][11] = '#64748b'; grid[8][12] = '#64748b'; grid[8][13] = '#475569'; grid[8][14] = '#1e293b';

  // 2. High Copper Piping / Hydraulic Conduits (y: 7..9)
  grid[7][7] = '#b45309'; grid[7][8] = '#d97706'; grid[7][9] = '#f59e0b'; grid[7][10] = '#d97706';
  grid[7][11] = '#f59e0b'; grid[7][12] = '#d97706'; grid[7][13] = '#b45309';
  grid[8][15] = '#d97706'; grid[9][15] = '#f59e0b'; grid[9][16] = '#d97706';

  // Exposed side copper gear cluster & mechanical valves (x: 5..6, y: 10..12)
  grid[10][5] = '#d97706'; grid[10][6] = '#f59e0b'; grid[11][5] = '#b45309'; grid[11][6] = '#d97706';
  grid[12][5] = '#d97706'; grid[12][6] = '#f59e0b';

  // 3. Central Forward Optical Lens / High-Tech Sensor Eye (x: 16..19, y: 9..11)
  grid[9][16] = '#1e293b'; grid[9][17] = '#0284c7'; grid[9][18] = '#38bdf8';
  grid[10][16] = '#0284c7'; grid[10][17] = '#00f0ff'; grid[10][18] = '#ffffff'; grid[10][19] = '#00f0ff';
  grid[11][16] = '#0f172a'; grid[11][17] = '#0284c7'; grid[11][18] = '#38bdf8'; grid[11][19] = '#0284c7';

  // 4. Pilot Operator Cockpit Pod (x: 14..19, y: 11..15)
  grid[11][15] = '#1e293b'; grid[11][16] = '#334155'; grid[11][17] = '#475569'; grid[11][18] = '#1e293b';
  grid[12][14] = '#1e293b'; grid[12][15] = '#38bdf8'; grid[12][16] = '#00f0ff'; grid[12][17] = '#0284c7'; grid[12][18] = '#334155';
  grid[13][14] = '#1e293b'; grid[13][15] = '#0284c7'; grid[13][16] = '#caa152'; grid[13][17] = '#caa152'; grid[13][18] = '#0284c7'; grid[13][19] = '#1e293b';
  grid[14][14] = '#0f172a'; grid[14][15] = '#0284c7'; grid[14][16] = '#0284c7'; grid[14][17] = '#0284c7'; grid[14][18] = '#334155'; grid[14][19] = '#0f172a';
  grid[15][15] = '#1e293b'; grid[15][16] = '#334155'; grid[15][17] = '#475569'; grid[15][18] = '#0f172a';

  // 5. Team Insignia Decals (x: 10..13, y: 10..12)
  for (let y = 10; y <= 12; y++) {
    for (let x = 10; x <= 13; x++) {
      grid[y][x] = 'TEAM';
    }
  }

  return { gridSize: g, grid };
}

function getHD_HyperTeslaWalker_Claw() {
  const g = 24, grid = makeGrid();
  // ✂️ Left Hydraulic Cleaver Pincer Arm - Neutral Stance (raised y: 12..17)
  // Shoulder Pivot & Dual Hydraulic Cylinders (x: 13..16, y: 12..16)
  grid[13][13] = '#0f172a'; grid[13][14] = '#1e293b'; grid[13][15] = '#334155';
  grid[14][13] = '#334155'; grid[14][14] = '#d97706'; grid[14][15] = '#f59e0b'; grid[14][16] = '#d97706';
  grid[15][13] = '#1e293b'; grid[15][14] = '#475569'; grid[15][15] = '#64748b'; grid[15][16] = '#475569';

  // Pincer Wrist & Upper Blade (x: 16..22, y: 12..15)
  grid[13][17] = '#475569'; grid[13][18] = '#64748b'; grid[12][19] = '#94a3b8'; grid[12][20] = '#cbd5e1'; grid[12][21] = '#ffffff';
  grid[14][17] = '#d97706'; grid[14][18] = '#f59e0b';

  // Lower Blade (x: 16..22, y: 15..19)
  grid[16][17] = '#475569'; grid[16][18] = '#64748b'; grid[17][19] = '#94a3b8'; grid[17][20] = '#cbd5e1'; grid[17][21] = '#ffffff';
  grid[15][17] = '#64748b'; grid[15][18] = '#94a3b8';

  return { gridSize: g, grid };
}

function getHD_HyperTeslaWalker_Claw_Grab() {
  const g = 24, grid = makeGrid();
  // Snapping Jaws Wide Open (raised)
  grid[13][13] = '#0f172a'; grid[13][14] = '#1e293b'; grid[13][15] = '#334155';
  grid[14][13] = '#334155'; grid[14][14] = '#d97706'; grid[14][15] = '#f59e0b'; grid[14][16] = '#d97706';
  grid[15][13] = '#1e293b'; grid[15][14] = '#475569'; grid[15][15] = '#64748b';

  // Wide Upper Blade Jaws
  grid[11][17] = '#64748b'; grid[11][18] = '#94a3b8'; grid[10][19] = '#cbd5e1'; grid[10][20] = '#ffffff'; grid[9][21] = '#ffffff';
  grid[12][16] = '#475569'; grid[12][17] = '#64748b';

  // Wide Lower Blade Jaws
  grid[16][16] = '#475569'; grid[16][17] = '#64748b';
  grid[17][17] = '#64748b'; grid[17][18] = '#94a3b8'; grid[18][19] = '#cbd5e1'; grid[18][20] = '#ffffff'; grid[19][21] = '#ffffff';

  // Center Copper Hinge Joint
  grid[13][16] = '#d97706'; grid[14][17] = '#f59e0b'; grid[15][16] = '#d97706';

  return { gridSize: g, grid };
}

function getHD_HyperTeslaWalker_Claw_Lift() {
  const g = 24, grid = makeGrid();
  // Lifted Upward Pose (Holding victim in air)
  grid[13][13] = '#0f172a'; grid[13][14] = '#1e293b'; grid[13][15] = '#334155';
  grid[14][13] = '#334155'; grid[14][14] = '#d97706'; grid[14][15] = '#f59e0b';

  grid[12][14] = '#475569'; grid[12][15] = '#64748b'; grid[12][16] = '#94a3b8';
  grid[11][15] = '#d97706'; grid[11][16] = '#f59e0b';
  grid[10][16] = '#475569'; grid[10][17] = '#64748b'; grid[10][18] = '#94a3b8';
  grid[9][17] = '#64748b'; grid[9][18] = '#94a3b8'; grid[9][19] = '#cbd5e1';
  grid[8][18] = '#cbd5e1'; grid[8][19] = '#ffffff'; grid[7][19] = '#ffffff';

  return { gridSize: g, grid };
}

function getHD_HyperTeslaWalker_Legs() {
  const g = 24, grid = makeGrid();
  // 🦂 8-Legged Mechanical Scorpion Walker Undercarriage (Stand / Neutral - High Ground Clearance)
  // Chassis mounting girder & 4 Heavy Copper Swivel Hip Bearings (y: 11..12, x: 4..17)
  for (let x = 4; x <= 17; x++) { grid[11][x] = '#1e293b'; grid[12][x] = '#0f172a'; }
  grid[11][4] = '#d97706'; grid[12][4] = '#b45309';
  grid[11][8] = '#f59e0b'; grid[12][8] = '#d97706';
  grid[11][12] = '#f59e0b'; grid[12][12] = '#d97706';
  grid[11][16] = '#d97706'; grid[12][16] = '#b45309';

  // Leg 1 (Front Left, x: 16..22, y: 11..23)
  grid[11][17] = '#475569'; grid[11][18] = '#64748b'; grid[12][19] = '#94a3b8';
  grid[13][20] = '#64748b'; grid[14][20] = '#475569'; grid[15][20] = '#334155';
  grid[16][20] = '#1e293b'; grid[17][21] = '#475569'; grid[18][21] = '#94a3b8'; grid[19][21] = '#64748b';
  grid[20][21] = '#475569'; grid[21][22] = '#cbd5e1'; grid[22][22] = '#64748b'; grid[23][22] = '#0f172a';

  // Leg 2 (Mid-Front Left, x: 12..18, y: 12..23)
  grid[12][13] = '#475569'; grid[12][14] = '#64748b'; grid[13][15] = '#94a3b8';
  grid[14][16] = '#64748b'; grid[15][16] = '#475569'; grid[16][17] = '#334155';
  grid[17][17] = '#1e293b'; grid[18][17] = '#475569'; grid[19][18] = '#94a3b8'; grid[20][18] = '#475569';
  grid[21][18] = '#94a3b8'; grid[22][18] = '#cbd5e1';

  // Leg 3 (Mid-Rear Left, x: 7..12, y: 12..23)
  grid[12][9] = '#475569'; grid[12][8] = '#64748b'; grid[13][8] = '#94a3b8';
  grid[14][7] = '#64748b'; grid[15][7] = '#475569'; grid[16][7] = '#334155';
  grid[17][7] = '#1e293b'; grid[18][8] = '#475569'; grid[19][8] = '#94a3b8'; grid[20][8] = '#475569';
  grid[21][9] = '#94a3b8'; grid[22][9] = '#cbd5e1';

  // Leg 4 (Rear Left, x: 0..6, y: 11..23)
  grid[11][4] = '#475569'; grid[11][3] = '#64748b'; grid[12][2] = '#94a3b8';
  grid[13][2] = '#64748b'; grid[14][2] = '#475569'; grid[15][2] = '#334155';
  grid[16][2] = '#1e293b'; grid[17][2] = '#475569'; grid[18][2] = '#1e293b'; grid[19][2] = '#475569';
  grid[20][1] = '#94a3b8'; grid[21][1] = '#cbd5e1'; grid[22][0] = '#64748b'; grid[23][0] = '#0f172a';

  // Far Side Shadow Legs (R1..R4)
  grid[13][17] = '#1e293b'; grid[14][18] = '#0f172a'; grid[15][18] = '#1e293b'; grid[16][19] = '#0f172a'; grid[17][19] = '#1e293b';
  grid[13][13] = '#1e293b'; grid[14][13] = '#0f172a'; grid[15][14] = '#1e293b'; grid[16][14] = '#0f172a'; grid[17][15] = '#1e293b';
  grid[13][10] = '#1e293b'; grid[14][11] = '#0f172a'; grid[15][11] = '#1e293b'; grid[16][12] = '#0f172a'; grid[17][12] = '#1e293b';
  grid[13][5] = '#1e293b'; grid[14][4] = '#0f172a'; grid[15][4] = '#1e293b'; grid[16][4] = '#0f172a'; grid[17][3] = '#1e293b';

  return { gridSize: g, grid };
}

function getHD_HyperTeslaWalker_Legs_Walk1() {
  const g = 24, grid = makeGrid();
  // Chassis mounting girder & bearings (y: 11..12)
  for (let x = 4; x <= 17; x++) { grid[11][x] = '#1e293b'; grid[12][x] = '#0f172a'; }
  grid[11][4] = '#d97706'; grid[12][4] = '#b45309';
  grid[11][8] = '#f59e0b'; grid[12][8] = '#d97706';
  grid[11][12] = '#f59e0b'; grid[12][12] = '#d97706';
  grid[11][16] = '#d97706'; grid[12][16] = '#b45309';

  // Phase 1: Group A (L1, R2, L3, R4) Reaches Forward (+X)
  grid[11][18] = '#64748b'; grid[11][19] = '#94a3b8'; grid[12][20] = '#cbd5e1'; grid[13][21] = '#94a3b8';
  grid[14][21] = '#64748b'; grid[15][21] = '#475569'; grid[16][22] = '#334155'; grid[17][22] = '#475569';
  grid[18][22] = '#94a3b8'; grid[19][23] = '#cbd5e1'; grid[20][23] = '#ffffff';

  grid[12][13] = '#475569'; grid[13][14] = '#334155'; grid[14][15] = '#1e293b'; grid[15][15] = '#334155';
  grid[16][16] = '#475569'; grid[17][16] = '#94a3b8'; grid[18][16] = '#64748b'; grid[19][16] = '#94a3b8';
  grid[20][16] = '#cbd5e1'; grid[21][16] = '#cbd5e1'; grid[22][16] = '#94a3b8';

  grid[11][10] = '#64748b'; grid[12][11] = '#94a3b8'; grid[13][11] = '#64748b'; grid[14][11] = '#475569';
  grid[15][12] = '#334155'; grid[16][12] = '#475569'; grid[17][12] = '#94a3b8'; grid[18][12] = '#64748b';
  grid[19][13] = '#94a3b8'; grid[20][13] = '#cbd5e1'; grid[21][13] = '#ffffff';

  grid[12][4] = '#334155'; grid[13][3] = '#1e293b'; grid[14][2] = '#334155'; grid[15][2] = '#1e293b';
  grid[16][2] = '#475569'; grid[17][1] = '#475569'; grid[18][1] = '#94a3b8'; grid[19][1] = '#cbd5e1';
  grid[20][1] = '#94a3b8'; grid[21][1] = '#64748b'; grid[22][0] = '#cbd5e1';

  // Far legs
  grid[13][16] = '#1e293b'; grid[14][17] = '#0f172a'; grid[15][17] = '#1e293b'; grid[16][18] = '#0f172a'; grid[17][18] = '#1e293b';
  grid[12][14] = '#0f172a'; grid[13][15] = '#1e293b'; grid[14][15] = '#0f172a'; grid[15][16] = '#1e293b';
  grid[13][8] = '#0f172a'; grid[14][8] = '#1e293b'; grid[15][8] = '#0f172a'; grid[16][8] = '#1e293b';
  grid[12][6] = '#0f172a'; grid[13][5] = '#1e293b'; grid[14][5] = '#0f172a'; grid[15][4] = '#1e293b';

  return { gridSize: g, grid };
}

function getHD_HyperTeslaWalker_Legs_Walk2() {
  const g = 24, grid = makeGrid();
  // Chassis mounting girder & bearings (y: 11..12)
  for (let x = 4; x <= 17; x++) { grid[11][x] = '#1e293b'; grid[12][x] = '#0f172a'; }
  grid[11][4] = '#d97706'; grid[12][4] = '#b45309';
  grid[11][8] = '#f59e0b'; grid[12][8] = '#d97706';
  grid[11][12] = '#f59e0b'; grid[12][12] = '#d97706';
  grid[11][16] = '#d97706'; grid[12][16] = '#b45309';

  // Phase 2: Weight Transfer & Hydraulic Absorption
  grid[11][18] = '#64748b'; grid[12][19] = '#94a3b8'; grid[13][20] = '#64748b'; grid[14][20] = '#475569';
  grid[15][21] = '#334155'; grid[16][21] = '#475569'; grid[17][21] = '#94a3b8'; grid[18][21] = '#64748b';
  grid[19][22] = '#94a3b8'; grid[20][22] = '#cbd5e1'; grid[21][22] = '#cbd5e1'; grid[22][22] = '#64748b';

  grid[12][14] = '#64748b'; grid[13][15] = '#94a3b8'; grid[14][15] = '#64748b'; grid[15][16] = '#475569';
  grid[16][16] = '#334155'; grid[17][17] = '#475569'; grid[18][17] = '#94a3b8'; grid[19][17] = '#cbd5e1';
  grid[20][17] = '#94a3b8'; grid[21][17] = '#cbd5e1'; grid[22][17] = '#475569';

  grid[12][10] = '#64748b'; grid[13][10] = '#94a3b8'; grid[14][10] = '#475569'; grid[15][11] = '#334155';
  grid[16][11] = '#475569'; grid[17][11] = '#94a3b8'; grid[18][11] = '#64748b'; grid[19][12] = '#94a3b8';
  grid[20][12] = '#cbd5e1'; grid[21][12] = '#94a3b8'; grid[22][12] = '#cbd5e1';

  grid[11][4] = '#64748b'; grid[12][3] = '#94a3b8'; grid[13][2] = '#64748b'; grid[14][2] = '#475569';
  grid[15][2] = '#334155'; grid[16][2] = '#475569'; grid[17][2] = '#1e293b'; grid[18][1] = '#94a3b8';
  grid[19][1] = '#cbd5e1'; grid[20][1] = '#94a3b8'; grid[21][1] = '#cbd5e1'; grid[22][0] = '#64748b';

  // Far legs
  grid[13][17] = '#0f172a'; grid[14][18] = '#1e293b'; grid[15][18] = '#0f172a'; grid[16][18] = '#1e293b';
  grid[13][13] = '#0f172a'; grid[14][13] = '#1e293b'; grid[15][14] = '#0f172a'; grid[16][14] = '#1e293b';
  grid[13][10] = '#0f172a'; grid[14][11] = '#1e293b'; grid[15][11] = '#0f172a'; grid[16][12] = '#1e293b';
  grid[13][5] = '#0f172a'; grid[14][4] = '#1e293b'; grid[15][4] = '#0f172a'; grid[16][4] = '#1e293b';

  return { gridSize: g, grid };
}

function getHD_HyperTeslaWalker_Legs_Walk3() {
  const g = 24, grid = makeGrid();
  // Chassis mounting girder & bearings (y: 11..12)
  for (let x = 4; x <= 17; x++) { grid[11][x] = '#1e293b'; grid[12][x] = '#0f172a'; }
  grid[11][4] = '#d97706'; grid[12][4] = '#b45309';
  grid[11][8] = '#f59e0b'; grid[12][8] = '#d97706';
  grid[11][12] = '#f59e0b'; grid[12][12] = '#d97706';
  grid[11][16] = '#d97706'; grid[12][16] = '#b45309';

  // Phase 3: Group B (R1, L2, R3, L4) Reaches Forward
  grid[12][16] = '#475569'; grid[13][17] = '#334155'; grid[14][17] = '#1e293b'; grid[15][18] = '#334155';
  grid[16][18] = '#475569'; grid[17][19] = '#94a3b8'; grid[18][19] = '#64748b'; grid[19][19] = '#cbd5e1';
  grid[20][19] = '#94a3b8'; grid[21][19] = '#cbd5e1'; grid[22][19] = '#64748b';

  grid[11][14] = '#64748b'; grid[11][15] = '#94a3b8'; grid[12][16] = '#cbd5e1'; grid[13][17] = '#94a3b8';
  grid[14][17] = '#64748b'; grid[15][18] = '#475569'; grid[16][18] = '#334155'; grid[17][19] = '#94a3b8';
  grid[18][19] = '#cbd5e1'; grid[19][20] = '#cbd5e1'; grid[20][20] = '#ffffff';

  grid[12][9] = '#334155'; grid[13][8] = '#1e293b'; grid[14][8] = '#334155'; grid[15][8] = '#1e293b';
  grid[16][8] = '#475569'; grid[17][9] = '#94a3b8'; grid[18][9] = '#64748b'; grid[19][9] = '#cbd5e1';
  grid[20][9] = '#94a3b8'; grid[21][9] = '#cbd5e1'; grid[22][9] = '#64748b';

  grid[11][5] = '#64748b'; grid[12][4] = '#94a3b8'; grid[13][3] = '#64748b'; grid[14][3] = '#475569';
  grid[15][2] = '#334155'; grid[16][2] = '#475569'; grid[17][1] = '#94a3b8'; grid[18][1] = '#cbd5e1';
  grid[19][1] = '#94a3b8'; grid[20][1] = '#cbd5e1'; grid[21][1] = '#ffffff';

  // Far legs
  grid[12][18] = '#0f172a'; grid[13][19] = '#1e293b'; grid[14][19] = '#0f172a'; grid[15][20] = '#1e293b';
  grid[13][14] = '#0f172a'; grid[14][14] = '#1e293b'; grid[15][15] = '#0f172a'; grid[16][15] = '#1e293b';
  grid[12][11] = '#0f172a'; grid[13][12] = '#1e293b'; grid[14][12] = '#0f172a'; grid[15][13] = '#1e293b';
  grid[13][4] = '#0f172a'; grid[14][3] = '#1e293b'; grid[15][3] = '#0f172a'; grid[16][2] = '#1e293b';

  return { gridSize: g, grid };
}

function getHD_HyperTeslaWalker_Legs_Walk4() {
  const g = 24, grid = makeGrid();
  // Chassis mounting girder & bearings (y: 11..12)
  for (let x = 4; x <= 17; x++) { grid[11][x] = '#1e293b'; grid[12][x] = '#0f172a'; }
  grid[11][4] = '#d97706'; grid[12][4] = '#b45309';
  grid[11][8] = '#f59e0b'; grid[12][8] = '#d97706';
  grid[11][12] = '#f59e0b'; grid[12][12] = '#d97706';
  grid[11][16] = '#d97706'; grid[12][16] = '#b45309';

  // Phase 4: Passing & Return to Balance
  grid[11][16] = '#475569'; grid[12][17] = '#64748b'; grid[13][18] = '#94a3b8'; grid[14][18] = '#64748b';
  grid[15][19] = '#475569'; grid[16][19] = '#334155'; grid[17][20] = '#94a3b8'; grid[18][20] = '#cbd5e1';
  grid[19][20] = '#94a3b8'; grid[20][20] = '#cbd5e1'; grid[21][20] = '#64748b'; grid[22][20] = '#0f172a';

  grid[12][13] = '#475569'; grid[13][14] = '#64748b'; grid[14][15] = '#94a3b8'; grid[15][15] = '#64748b';
  grid[16][16] = '#475569'; grid[17][16] = '#334155'; grid[18][17] = '#94a3b8'; grid[19][17] = '#cbd5e1';
  grid[20][17] = '#94a3b8'; grid[21][17] = '#cbd5e1'; grid[22][17] = '#64748b';

  grid[12][9] = '#475569'; grid[13][9] = '#64748b'; grid[14][9] = '#94a3b8'; grid[15][10] = '#475569';
  grid[16][10] = '#334155'; grid[17][10] = '#475569'; grid[18][11] = '#94a3b8'; grid[19][11] = '#cbd5e1';
  grid[20][11] = '#94a3b8'; grid[21][11] = '#cbd5e1'; grid[22][11] = '#64748b';

  grid[11][4] = '#475569'; grid[12][3] = '#64748b'; grid[13][2] = '#94a3b8'; grid[14][2] = '#475569';
  grid[15][2] = '#334155'; grid[16][2] = '#1e293b'; grid[17][2] = '#475569'; grid[18][1] = '#94a3b8';
  grid[19][1] = '#cbd5e1'; grid[20][1] = '#94a3b8'; grid[21][0] = '#cbd5e1'; grid[22][0] = '#64748b';

  // Far legs
  grid[13][17] = '#1e293b'; grid[14][17] = '#0f172a'; grid[15][18] = '#1e293b'; grid[16][18] = '#0f172a';
  grid[13][13] = '#1e293b'; grid[14][13] = '#0f172a'; grid[15][14] = '#1e293b'; grid[16][14] = '#0f172a';
  grid[13][10] = '#1e293b'; grid[14][10] = '#0f172a'; grid[15][11] = '#1e293b'; grid[16][11] = '#0f172a';
  grid[13][4] = '#1e293b'; grid[14][3] = '#0f172a'; grid[15][3] = '#1e293b'; grid[16][3] = '#0f172a';

  return { gridSize: g, grid };
}

function getHD_HyperTeslaWalker() {
  const g = 24, grid = makeGrid();
  const l = getHD_HyperTeslaWalker_Legs().grid;
  const c = getHD_HyperTeslaWalker_Chassis().grid;
  const t = getHD_HyperTeslaWalker_Tail().grid;
  const w = getHD_HyperTeslaWalker_Claw().grid;

  // Composite order: Legs under Chassis under Tail under Claw
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (l[y][x]) grid[y][x] = l[y][x];
      if (c[y][x]) grid[y][x] = c[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
      if (w[y][x]) grid[y][x] = w[y][x];
    }
  }
  return { gridSize: g, grid };
}


// ── WHEELIE BOMBER (24x24 HD REFERENCE) ─────────────────────────

function paintHD_WheelieBomber_Wheel(grid, x0, cy, roll = 0) {
  const TIRE = '#0c0a09', RIM = '#e2e8f0', HUB = '#334155', SPOKE = '#94a3b8';
  const r = ((roll % 3) + 3) % 3;

  // Outer 7x6 knobby tire ring
  grid[cy - 3][x0 + 2] = TIRE; grid[cy - 3][x0 + 3] = TIRE; grid[cy - 3][x0 + 4] = TIRE;
  grid[cy - 2][x0 + 1] = TIRE; grid[cy - 2][x0 + 5] = TIRE;
  grid[cy - 1][x0] = TIRE;     grid[cy - 1][x0 + 5] = TIRE;
  grid[cy][x0] = TIRE;         grid[cy][x0 + 5] = TIRE;
  grid[cy + 1][x0] = TIRE;     grid[cy + 1][x0 + 5] = TIRE;
  grid[cy + 2][x0 + 1] = TIRE; grid[cy + 2][x0 + 5] = TIRE;
  grid[cy + 3][x0 + 2] = TIRE; grid[cy + 3][x0 + 3] = TIRE; grid[cy + 3][x0 + 4] = TIRE;

  // 12-pixel chrome rim perimeter in clockwise order (4 spoke ticks at period 3)
  const rimRing = [
    [cy - 2, x0 + 2], [cy - 2, x0 + 3], [cy - 2, x0 + 4],
    [cy - 1, x0 + 4], [cy,     x0 + 4], [cy + 1, x0 + 4],
    [cy + 2, x0 + 4], [cy + 2, x0 + 3], [cy + 2, x0 + 2],
    [cy + 1, x0 + 1], [cy,     x0 + 1], [cy - 1, x0 + 1]
  ];
  for (let i = 0; i < 12; i++) {
    const [ry, rx] = rimRing[i];
    grid[ry][rx] = ((i - r + 12) % 3 === 1) ? SPOKE : RIM;
  }

  // 6-pixel inner hub in clockwise order (2 opposite spoke bars at period 3)
  const hubRing = [
    [cy - 1, x0 + 2], [cy - 1, x0 + 3],
    [cy,     x0 + 3], [cy + 1, x0 + 3],
    [cy + 1, x0 + 2], [cy,     x0 + 2]
  ];
  for (let i = 0; i < 6; i++) {
    const [hy, hx] = hubRing[i];
    grid[hy][hx] = ((i - r + 6) % 3 === 0) ? SPOKE : HUB;
  }
}

function getHD_WheelieBomber_Bike(roll = 0) {
  const g = 24, grid = makeGrid();

  // 1. Rear Wheel (7x7 knobby tire, center x=4, y=19)
  paintHD_WheelieBomber_Wheel(grid, 1, 19, roll);

  // 2. Front Wheel (7x7 knobby tire, center x=19, y=19)
  paintHD_WheelieBomber_Wheel(grid, 16, 19, roll);

  // 3. Rear Fender & Tail Light (x: 0..5, y: 14..15)
  grid[15][1] = '#0f172a'; grid[15][2] = '#1e293b'; grid[15][3] = '#334155'; grid[15][4] = '#475569'; grid[15][5] = '#334155';
  grid[14][1] = '#dc2626'; grid[14][0] = '#991b1b'; // Taillight red

  // 4. Strapped Dynamite Payload (x: 2..5, y: 10..13)
  grid[11][2] = '#dc2626'; grid[11][3] = '#ef4444'; grid[11][4] = '#dc2626'; grid[11][5] = '#ca8a04';
  grid[12][2] = '#991b1b'; grid[12][3] = '#dc2626'; grid[12][4] = '#ef4444'; grid[12][5] = '#ca8a04';
  grid[10][4] = '#f59e0b'; grid[10][5] = '#fbbf24'; // Fuse spark

  // 5. Classic Horizontal Bench Seat (x: 6..11, y: 12..13)
  grid[12][6] = '#18181b'; grid[12][7] = '#27272a'; grid[12][8] = '#3f3f46'; grid[12][9] = '#27272a'; grid[12][10] = '#27272a'; grid[12][11] = '#18181b';
  grid[13][6] = '#09090b'; grid[13][7] = '#18181b'; grid[13][8] = '#27272a'; grid[13][9] = '#18181b'; grid[13][10] = '#18181b';

  // 6. Muscular Teardrop Fuel Tank with TEAM Insignia (x: 10..17, y: 10..13)
  // Top chrome cap & metallic highlight
  grid[10][13] = '#cbd5e1'; grid[10][14] = '#f8fafc'; grid[10][15] = '#94a3b8';
  // Upper tank shell
  grid[11][11] = '#475569'; grid[11][12] = '#64748b'; grid[11][13] = 'TEAM'; grid[11][14] = 'TEAM'; grid[11][15] = 'TEAM'; grid[11][16] = '#64748b'; grid[11][17] = '#334155';
  // Main tank flank with TEAM badge
  grid[12][11] = '#334155'; grid[12][12] = 'TEAM'; grid[12][13] = 'TEAM'; grid[12][14] = 'TEAM'; grid[12][15] = 'TEAM'; grid[12][16] = 'TEAM'; grid[12][17] = '#475569';
  // Tank lower contour & knee indent
  grid[13][11] = '#1e293b'; grid[13][12] = '#334155'; grid[13][13] = '#475569'; grid[13][14] = '#475569'; grid[13][15] = '#334155'; grid[13][16] = '#1e293b';

  // 7. Twin-Cylinder Engine Block & Transmission (x: 7..15, y: 14..18)
  // Airbox & frame triangle
  grid[14][7] = '#1e293b'; grid[14][8] = '#334155'; grid[14][9] = '#475569'; grid[14][10] = '#64748b';
  grid[15][7] = '#1e293b'; grid[15][8] = '#334155'; grid[15][9] = '#475569'; grid[15][10] = '#334155';

  // Cylinder Head with Silver Cooling Fins
  grid[14][11] = '#64748b'; grid[14][12] = '#94a3b8'; grid[14][13] = '#cbd5e1'; grid[14][14] = '#94a3b8'; grid[14][15] = '#475569';
  grid[15][11] = '#334155'; grid[15][12] = '#475569'; grid[15][13] = '#64748b'; grid[15][14] = '#475569'; grid[15][15] = '#1e293b';
  grid[16][10] = '#475569'; grid[16][11] = '#64748b'; grid[16][12] = '#94a3b8'; grid[16][13] = '#cbd5e1'; grid[16][14] = '#64748b';

  // Crankcase, Sump & Footpeg
  grid[16][7] = '#1e293b'; grid[16][8] = '#334155'; grid[16][9] = '#475569';
  grid[17][8] = '#334155'; grid[17][9] = '#475569'; grid[17][10] = '#64748b'; grid[17][11] = '#475569'; grid[17][12] = '#334155';
  grid[18][8] = '#1e293b'; grid[18][9] = '#334155'; grid[18][10] = '#475569'; grid[18][11] = '#334155';
  grid[19][9] = '#0f172a'; grid[19][10] = '#1e293b'; grid[19][11] = '#1e293b';
  grid[17][7] = '#64748b'; // Footpeg

  // 8. Swept-Back Chrome Exhaust Header, Pipe & Megaphone Muffler (x: 0..15, y: 15..18)
  grid[15][15] = '#94a3b8'; grid[16][15] = '#cbd5e1';
  grid[17][15] = '#cbd5e1'; grid[17][14] = '#94a3b8'; grid[17][13] = '#cbd5e1';
  grid[18][13] = '#cbd5e1'; grid[18][12] = '#94a3b8'; grid[18][11] = '#cbd5e1'; grid[18][10] = '#94a3b8';
  grid[18][9] = '#cbd5e1'; grid[18][8] = '#94a3b8'; grid[18][7] = '#cbd5e1'; grid[18][6] = '#94a3b8'; grid[18][5] = '#cbd5e1';
  grid[17][4] = '#cbd5e1'; grid[17][3] = '#e2e8f0'; grid[17][2] = '#cbd5e1'; // Megaphone
  grid[17][1] = '#ea580c'; grid[17][0] = '#f97316'; grid[16][0] = '#fbbf24'; // Hot tip

  // 9. Front Suspension (Raked Fork), Triple Clamp, Round Headlight & Low Handlebars
  grid[10][16] = '#475569'; grid[10][17] = '#64748b'; // Triple clamp
  grid[11][17] = '#334155'; grid[11][18] = '#475569';

  // Low Cafe/Tracker Handlebars
  grid[9][15] = '#18181b'; grid[9][16] = '#64748b'; grid[9][17] = '#18181b';

  // Raked Fork Tubes (~60° angle from clamp down to front axle x=19, y=19)
  grid[12][18] = '#cbd5e1'; grid[12][19] = '#94a3b8';
  grid[13][18] = '#cbd5e1'; grid[13][19] = '#94a3b8';
  grid[14][18] = '#cbd5e1'; grid[14][19] = '#94a3b8';
  grid[15][19] = '#cbd5e1'; grid[15][20] = '#94a3b8';
  grid[16][19] = '#cbd5e1'; grid[17][19] = '#64748b'; // Slider & Axle clamp
  grid[15][17] = '#334155'; grid[15][18] = '#475569'; // Fender

  // Classic Round Headlamp
  grid[10][18] = '#1e293b'; grid[10][19] = '#fde047'; grid[10][20] = '#fef08a'; grid[10][21] = '#ffffff';
  grid[11][19] = '#ca8a04'; grid[11][20] = '#fde047'; grid[11][21] = '#fef08a';
  grid[12][20] = '#ca8a04';

  return { gridSize: g, grid };
}
function getHD_WheelieBomber_Bike_Roll1() { return getHD_WheelieBomber_Bike(0); }
function getHD_WheelieBomber_Bike_Roll2() { return getHD_WheelieBomber_Bike(1); }
function getHD_WheelieBomber_Bike_Roll3() { return getHD_WheelieBomber_Bike(2); }

function getHD_WheelieBomber_Bike_Wheelie1(roll = 0) {
  const g = 24, grid = makeGrid();

  // Rear Wheel (x=4, y=19) planted pivot
  paintHD_WheelieBomber_Wheel(grid, 1, 19, roll);

  // Front Wheel: lifted to center x=19, y=12
  paintHD_WheelieBomber_Wheel(grid, 16, 12, roll);

  // Rear Fender & Tail
  grid[16][1] = '#0f172a'; grid[16][2] = '#1e293b'; grid[15][2] = '#334155'; grid[15][3] = '#475569';
  grid[15][1] = '#dc2626';

  // Tilted Dynamite Bundle (x: 2..5, y: 11..13)
  grid[11][3] = '#dc2626'; grid[11][4] = '#ef4444'; grid[11][5] = '#ca8a04';
  grid[12][3] = '#991b1b'; grid[12][4] = '#dc2626'; grid[12][5] = '#ef4444'; grid[12][6] = '#ca8a04';
  grid[10][4] = '#f59e0b'; grid[10][5] = '#fbbf24';

  // Tilted Bench Seat (x: 5..10, y: 12..14)
  grid[12][7] = '#18181b'; grid[12][8] = '#27272a'; grid[12][9] = '#3f3f46'; grid[12][10] = '#27272a';
  grid[13][6] = '#18181b'; grid[13][7] = '#27272a'; grid[13][8] = '#18181b';

  // Tilted Muscular Fuel Tank (x: 9..16, y: 9..13)
  grid[9][12] = '#cbd5e1'; grid[9][13] = '#f8fafc'; grid[9][14] = '#94a3b8';
  grid[10][10] = '#475569'; grid[10][11] = '#64748b'; grid[10][12] = 'TEAM'; grid[10][13] = 'TEAM'; grid[10][14] = 'TEAM'; grid[10][15] = '#334155';
  grid[11][9] = '#334155'; grid[11][10] = 'TEAM'; grid[11][11] = 'TEAM'; grid[11][12] = 'TEAM'; grid[11][13] = 'TEAM'; grid[11][14] = 'TEAM'; grid[11][15] = '#475569';
  grid[12][10] = '#1e293b'; grid[12][11] = '#334155'; grid[12][12] = '#475569'; grid[12][13] = '#475569'; grid[12][14] = '#334155';

  // Tilted Engine with Cooling Fins (x: 8..15, y: 13..18)
  grid[13][11] = '#64748b'; grid[13][12] = '#94a3b8'; grid[13][13] = '#cbd5e1'; grid[13][14] = '#64748b';
  grid[14][10] = '#475569'; grid[14][11] = '#64748b'; grid[14][12] = '#94a3b8'; grid[14][13] = '#cbd5e1'; grid[14][14] = '#475569';
  grid[15][9] = '#334155'; grid[15][10] = '#475569'; grid[15][11] = '#64748b'; grid[15][12] = '#94a3b8';
  grid[15][7] = '#1e293b'; grid[15][8] = '#334155'; grid[16][8] = '#475569'; grid[16][9] = '#334155';
  grid[16][7] = '#1e293b'; grid[17][8] = '#334155'; grid[17][9] = '#1e293b'; grid[16][10] = '#475569'; grid[16][11] = '#334155';

  // Exhaust Pipe & Muffler (angled down-back)
  grid[14][15] = '#94a3b8'; grid[15][14] = '#cbd5e1'; grid[16][13] = '#cbd5e1'; grid[16][12] = '#94a3b8';
  grid[17][11] = '#cbd5e1'; grid[17][10] = '#94a3b8'; grid[17][9] = '#cbd5e1'; grid[17][8] = '#94a3b8';
  grid[18][7] = '#cbd5e1'; grid[18][6] = '#e2e8f0'; grid[18][5] = '#cbd5e1';
  grid[18][4] = '#ea580c'; grid[18][3] = '#f97316'; grid[18][2] = '#fbbf24';

  // Front Fork, Clamp & Low Handlebars
  grid[8][15] = '#475569'; grid[8][16] = '#64748b';
  grid[7][14] = '#18181b'; grid[7][15] = '#64748b'; grid[7][16] = '#18181b';
  grid[9][16] = '#cbd5e1'; grid[9][17] = '#94a3b8';
  grid[10][16] = '#cbd5e1'; grid[10][17] = '#94a3b8';
  grid[11][17] = '#cbd5e1'; grid[11][18] = '#94a3b8';
  grid[12][17] = '#cbd5e1'; grid[12][18] = '#94a3b8';
  grid[13][18] = '#cbd5e1'; grid[13][19] = '#64748b';

  // Headlight
  grid[6][16] = '#1e293b'; grid[6][17] = '#fde047'; grid[6][18] = '#fef08a'; grid[6][19] = '#ffffff';
  grid[7][17] = '#ca8a04'; grid[7][18] = '#fde047'; grid[7][19] = '#fef08a';

  // Ground Roost & Exhaust Jet
  grid[22][0] = '#78350f'; grid[22][1] = '#92400e'; grid[23][1] = '#78350f';
  grid[19][0] = '#f97316'; grid[19][1] = '#ea580c'; grid[20][0] = '#ea580c';

  return { gridSize: g, grid };
}
function getHD_WheelieBomber_Bike_Wheelie1_Roll1() { return getHD_WheelieBomber_Bike_Wheelie1(0); }
function getHD_WheelieBomber_Bike_Wheelie1_Roll2() { return getHD_WheelieBomber_Bike_Wheelie1(1); }
function getHD_WheelieBomber_Bike_Wheelie1_Roll3() { return getHD_WheelieBomber_Bike_Wheelie1(2); }

function getHD_WheelieBomber_Bike_Wheelie2(roll = 0) {
  const g = 24, grid = makeGrid();

  // Rear Wheel (pivot at x=4, y=19)
  paintHD_WheelieBomber_Wheel(grid, 1, 19, roll);

  // Front Wheel high overhead centered at x=15, y=5
  paintHD_WheelieBomber_Wheel(grid, 12, 5, roll);

  // Steep Frame & Engine (diagonal ~60°)
  grid[15][7] = '#334155'; grid[15][8] = '#475569';
  grid[14][7] = '#475569'; grid[14][8] = '#64748b'; grid[14][9] = '#94a3b8'; grid[14][10] = '#cbd5e1';
  grid[13][8] = '#334155'; grid[13][9] = '#475569'; grid[13][10] = '#64748b'; grid[13][11] = '#94a3b8';
  grid[12][8] = '#475569'; grid[12][9] = '#64748b'; grid[12][10] = '#94a3b8';
  grid[11][9] = '#1e293b'; grid[11][10] = '#475569'; grid[11][11] = '#64748b';

  // Steep Tank & Seat
  grid[13][5] = '#18181b'; grid[13][6] = '#27272a'; grid[14][6] = '#18181b';
  grid[10][10] = '#475569'; grid[10][11] = 'TEAM'; grid[10][12] = '#334155';
  grid[9][11] = '#334155'; grid[9][12] = 'TEAM'; grid[9][13] = 'TEAM'; grid[9][14] = '#475569';
  grid[8][12] = 'TEAM'; grid[8][13] = 'TEAM'; grid[7][13] = '#cbd5e1'; // Chrome cap

  // Steep Bomb
  grid[14][4] = '#dc2626'; grid[14][5] = '#ef4444'; grid[13][4] = '#ca8a04';
  grid[15][4] = '#991b1b'; grid[15][5] = '#dc2626';

  // High Fork & Headlamp
  grid[6][12] = '#18181b'; grid[5][12] = '#64748b'; grid[5][13] = '#18181b';
  grid[6][13] = '#475569'; grid[5][14] = '#cbd5e1';
  grid[4][13] = '#cbd5e1'; grid[4][14] = '#94a3b8';
  grid[3][14] = '#cbd5e1'; grid[3][15] = '#64748b';

  // Headlamp
  grid[3][12] = '#1e293b'; grid[2][12] = '#fde047'; grid[1][12] = '#fef08a'; grid[1][13] = '#ffffff';
  grid[2][13] = '#ca8a04';

  // Scraped Tail Sparks & Exhaust Jet
  grid[16][0] = '#f97316'; grid[17][0] = '#fdba74'; grid[17][1] = '#fbbf24';
  grid[18][0] = '#fbbf24'; grid[19][0] = '#f97316'; grid[19][1] = '#ea580c';
  grid[20][0] = '#f59e0b'; grid[21][0] = '#ea580c'; grid[22][0] = '#fbbf24';

  return { gridSize: g, grid };
}
function getHD_WheelieBomber_Bike_Wheelie2_Roll1() { return getHD_WheelieBomber_Bike_Wheelie2(0); }
function getHD_WheelieBomber_Bike_Wheelie2_Roll2() { return getHD_WheelieBomber_Bike_Wheelie2(1); }
function getHD_WheelieBomber_Bike_Wheelie2_Roll3() { return getHD_WheelieBomber_Bike_Wheelie2(2); }

function getHD_WheelieBomber_Rider() {
  const g = 24, grid = makeGrid();
  // Mad-Max Wasteland Biker: athletic forward racer tuck

  // 1. Windblown Orange Mohawk (y: 4..6, x: 8..12)
  grid[4][9] = '#ea580c'; grid[4][10] = '#f97316'; grid[4][11] = '#fb923c';
  grid[5][8] = '#c2410c'; grid[5][9] = '#ea580c'; grid[5][10] = '#f97316'; grid[5][11] = '#fb923c';

  // 2. Helmet & Visor (aero tuck, y: 5..8, x: 9..15)
  grid[5][12] = '#1e293b'; grid[5][13] = '#334155'; grid[5][14] = '#1e293b';
  grid[6][10] = '#0f172a'; grid[6][11] = '#1e293b'; grid[6][12] = '#334155'; grid[6][13] = '#475569';
  grid[6][14] = '#00f0ff'; grid[6][15] = '#38bdf8'; grid[6][16] = '#ffffff';
  grid[7][10] = '#0f172a'; grid[7][11] = '#1e293b'; grid[7][12] = '#0284c7'; grid[7][13] = '#00f0ff'; grid[7][14] = '#38bdf8';
  grid[8][11] = '#0f172a'; grid[8][12] = '#1e293b'; grid[8][13] = '#334155';

  // 3. Torso / Armored Vest in Forward Lean (y: 7..11, x: 6..12)
  grid[7][8] = '#1e293b'; grid[7][9] = '#334155'; grid[7][10] = 'TEAM';
  grid[8][7] = '#0f172a'; grid[8][8] = '#1e293b'; grid[8][9] = 'TEAM'; grid[8][10] = 'TEAM'; grid[8][11] = '#334155';
  grid[9][7] = '#0f172a'; grid[9][8] = '#1e293b'; grid[9][9] = 'TEAM'; grid[9][10] = 'TEAM'; grid[9][11] = '#334155';
  grid[10][6] = '#18181b'; grid[10][7] = '#1e293b'; grid[10][8] = 'TEAM'; grid[10][9] = 'TEAM'; grid[10][10] = '#1e293b';
  grid[11][6] = '#18181b'; grid[11][7] = '#27272a'; grid[11][8] = '#334155';

  // 4. Arms reaching forward to low handlebars at x=16..17, y=9 (y: 7..10, x: 12..17)
  grid[8][12] = '#334155'; grid[8][13] = '#475569';
  grid[9][13] = '#1e293b'; grid[9][14] = '#334155'; grid[9][15] = '#475569';
  grid[9][16] = '#18181b'; grid[9][17] = '#27272a';

  // 5. Legs & Boots (tucked tight along tank flank, boot on rearset peg, y: 11..16, x: 7..12)
  grid[12][7] = '#1e293b'; grid[12][8] = '#334155'; grid[12][9] = '#475569'; grid[12][10] = '#334155';
  grid[13][8] = '#1e293b'; grid[13][9] = '#334155'; grid[13][10] = '#475569'; grid[13][11] = '#64748b';
  grid[14][8] = '#0f172a'; grid[14][9] = '#1e293b'; grid[14][10] = '#334155';
  grid[15][7] = '#18181b'; grid[15][8] = '#27272a'; grid[15][9] = '#334155';
  grid[16][7] = '#09090b'; grid[16][8] = '#18181b';

  return { gridSize: g, grid };
}

function getHD_WheelieBomber() {
  const g = 24, grid = makeGrid();
  const b = getHD_WheelieBomber_Bike().grid;
  const r = getHD_WheelieBomber_Rider().grid;

  // Composite: Bike underneath, Rider mounted on top
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (b[y][x]) grid[y][x] = b[y][x];
      if (r[y][x]) grid[y][x] = r[y][x];
    }
  }
  return { gridSize: g, grid };
}


// ── PANZER (36x36 HD TIER M REFERENCE) ─────────────────────────

function getHD_Panzer_Chassis(roll = 0) {
  const g = 36, grid = makeGrid36();

  // Palette: Industrial Sci-Fi Vanguard Armor & Heavy Steel
  const OUT        = '#05080f'; // Darkest contour, recessed seams & panel gaps
  const T_VOID     = '#020617'; // Deep shadow cavity under hull & inside wheel wells
  const T_BLACK    = '#090d16'; // Deepest track tread rim & shadow rim
  const T_DARK     = '#1e293b'; // Track link dark steel & dark chassis armor
  const T_CLEAT    = '#475569'; // Cleat grouser steel
  const T_CLEAT_HI = '#64748b'; // Cleat grouser bright glint

  // Composite armor plates (Industrial Sci-Fi Vanguard Slate & Titanium)
  const ARM_DEEP   = '#0f172a'; // Deepest recessed bevels & shadow borders
  const ARM_DARK   = '#1e293b'; // Shaded lower plates & panel bevels
  const ARM_MID    = '#334155'; // Main body composite plate
  const ARM_LGT    = '#475569'; // Midtone armor & forward plates
  const ARM_HI     = '#64748b'; // Beveled edge highlight & upper plates
  const ARM_TOP    = '#94a3b8'; // Sunlit top plate highlight & weld seams
  const STEEL_HI   = '#cbd5e1'; // Specular glint on hard steel edges & rivets
  const STEEL_MAX  = '#f8fafc'; // Pure bright steel glint

  // Wheel assembly
  const RIM_DARK   = '#0f172a'; // Heavy rubber outer tire rim
  const WHEEL_SH   = '#1e293b'; // Wheel dish shaded quadrant
  const WHEEL_STEEL= '#475569'; // Stamped steel road wheel dish
  const WHEEL_HI   = '#64748b'; // Wheel rim highlight
  const WHEEL_HUB  = '#94a3b8'; // Central wheel hubcap
  const WHEEL_BOLT = '#cbd5e1'; // Central grease cap / bolt glint

  // Driver Vision Slit (Cyber Cyan)
  const DRV_CYAN_D = '#0284c7';
  const DRV_CYAN   = '#00f0ff';
  const DRV_CYAN_L = '#38bdf8';
  const DRV_CYAN_W = '#ffffff';

  // Headlights (Combat Halogen / LED array)
  const LAMP_DARK  = '#1e293b';
  const LAMP_AMBER = '#f59e0b';
  const LAMP_YELLOW= '#facc15';
  const LAMP_CORE  = '#fef08a';
  const LAMP_WHITE = '#ffffff';

  // Exhausts (Combustion Heat Glow)
  const EXH_DARK   = '#451a03';
  const EXH_MID    = '#78350f';
  const EXH_FIRE   = '#ea580c';
  const EXH_HOT    = '#f97316';
  const EXH_VENT   = '#0f172a';

  // 1. Under-hull Shadow Cavity & Wheel Bay (y: 25..34, x: 2..33)
  for (let y = 25; y <= 34; y++) {
    for (let x = 2; x <= 33; x++) {
      grid[y][x] = T_VOID;
    }
  }

  // 2. Caterpillar Track Perimeter Loop (y: 25..35, x: 1..34)
  // Bottom ground contact track (y: 34..35, x: 4..30)
  for (let x = 4; x <= 30; x++) {
    grid[34][x] = T_DARK;
    grid[35][x] = T_BLACK;
  }

  // Rear Drive Sprocket Incline (x: 1..4, y: 25..34)
  grid[25][4] = T_BLACK;
  grid[26][3] = T_BLACK; grid[26][4] = T_DARK;
  grid[27][2] = T_BLACK; grid[27][3] = T_DARK;
  grid[28][1] = T_BLACK; grid[28][2] = T_DARK;
  grid[29][1] = T_BLACK; grid[29][2] = T_DARK;
  grid[30][1] = T_BLACK; grid[30][2] = T_DARK;
  grid[31][1] = T_BLACK; grid[31][2] = T_DARK;
  grid[32][2] = T_BLACK; grid[32][3] = T_DARK;
  grid[33][2] = T_BLACK; grid[33][3] = T_DARK;
  grid[34][3] = T_BLACK; grid[34][4] = T_DARK;

  // Front Idler Wheel Incline (x: 30..34, y: 25..34)
  grid[25][30] = T_DARK;  grid[25][31] = T_BLACK;
  grid[26][31] = T_DARK;  grid[26][32] = T_BLACK;
  grid[27][32] = T_DARK;  grid[27][33] = T_BLACK;
  grid[28][32] = T_DARK;  grid[28][33] = T_BLACK; grid[28][34] = T_BLACK;
  grid[29][33] = T_DARK;  grid[29][34] = T_BLACK;
  grid[30][32] = T_DARK;  grid[30][33] = T_BLACK;
  grid[31][31] = T_DARK;  grid[31][32] = T_BLACK;
  grid[32][30] = T_DARK;  grid[32][31] = T_BLACK;
  grid[33][30] = T_DARK;  grid[33][31] = T_BLACK;

  // Animated Track Grousers / Cleats (cycling along bottom contact and inclines)
  for (let x = 4; x <= 30; x++) {
    if ((x + roll) % 3 === 0) {
      grid[35][x] = T_CLEAT_HI;
      grid[34][x] = T_CLEAT;
    }
  }
  // Sprocket / Idler animated track cleats
  if (roll === 0) {
    grid[28][1] = T_CLEAT_HI; grid[30][33] = T_CLEAT_HI;
    grid[26][3] = T_CLEAT;    grid[32][31] = T_CLEAT;
  } else if (roll === 1) {
    grid[29][1] = T_CLEAT_HI; grid[29][34] = T_CLEAT_HI;
    grid[27][2] = T_CLEAT;    grid[31][32] = T_CLEAT;
  } else {
    grid[30][1] = T_CLEAT_HI; grid[28][34] = T_CLEAT_HI;
    grid[28][2] = T_CLEAT;    grid[27][33] = T_CLEAT;
  }

  // 3. 5 Circular Double-Road Wheels (5x6 round dish wheels with rim bolts & rotating hub)
  const wheels = [
    { x1: 4,  x2: 8  },
    { x1: 10, x2: 14 },
    { x1: 16, x2: 20 },
    { x1: 22, x2: 26 },
    { x1: 27, x2: 31 }
  ];

  wheels.forEach((w) => {
    // Row 0 (y=27, top rounded edge width 3)
    grid[27][w.x1 + 1] = RIM_DARK;
    grid[27][w.x1 + 2] = WHEEL_HI;
    grid[27][w.x1 + 3] = RIM_DARK;

    // Row 1 (y=28, upper wheel dish width 5 with top rim bolt)
    grid[28][w.x1]     = RIM_DARK;
    grid[28][w.x1 + 1] = WHEEL_HI;
    grid[28][w.x1 + 2] = STEEL_HI; // Top rim bolt
    grid[28][w.x1 + 3] = WHEEL_STEEL;
    grid[28][w.x2]     = RIM_DARK;

    // Row 2 (y=29, upper center hub level width 5)
    grid[29][w.x1]     = RIM_DARK;
    grid[29][w.x1 + 1] = WHEEL_STEEL;
    grid[29][w.x1 + 2] = WHEEL_HUB;
    grid[29][w.x1 + 3] = WHEEL_STEEL;
    grid[29][w.x2]     = RIM_DARK;

    // Row 3 (y=30, lower center hub level width 5)
    grid[30][w.x1]     = RIM_DARK;
    grid[30][w.x1 + 1] = WHEEL_SH;
    grid[30][w.x1 + 2] = WHEEL_HUB;
    grid[30][w.x1 + 3] = WHEEL_SH;
    grid[30][w.x2]     = RIM_DARK;

    // Row 4 (y=31, lower wheel dish width 5)
    grid[31][w.x1]     = RIM_DARK;
    grid[31][w.x1 + 1] = WHEEL_SH;
    grid[31][w.x1 + 2] = WHEEL_SH;
    grid[31][w.x1 + 3] = WHEEL_SH;
    grid[31][w.x2]     = RIM_DARK;

    // Row 5 (y=32, bottom rounded edge width 3)
    grid[32][w.x1 + 1] = RIM_DARK;
    grid[32][w.x1 + 2] = RIM_DARK;
    grid[32][w.x1 + 3] = RIM_DARK;

    // Animated rotating axle bolt highlight
    if (roll === 0) {
      grid[29][w.x1 + 2] = STEEL_MAX; // Glint top hub
      grid[30][w.x1 + 2] = ARM_DARK;
    } else if (roll === 1) {
      grid[30][w.x1 + 2] = STEEL_MAX; // Glint bottom hub
      grid[29][w.x1 + 2] = ARM_DARK;
    } else {
      grid[29][w.x1 + 1] = STEEL_MAX; // Glint side
      grid[30][w.x1 + 3] = ARM_DARK;
    }
  });

  // Suspension swing-arms & hydraulic dampers visible in gaps
  for (const gapX of [9, 15, 21]) {
    grid[26][gapX] = ARM_DARK;
    grid[27][gapX] = ARM_MID;
    grid[28][gapX] = ARM_DARK;
  }

  // 4. Side Skirts (Kettenschürzen) & Segmented Modular ERA Panels (y: 19..25, x: 2..31)
  for (let y = 19; y <= 24; y++) {
    for (let x = 3; x <= 29; x++) {
      grid[y][x] = ARM_MID;
    }
  }

  // Top deck transition & skirt top bevel highlight
  for (let x = 3; x <= 29; x++) {
    grid[19][x] = ARM_HI;
  }
  // Bottom skirt beveled chamfer & deep shadow edge
  for (let x = 3; x <= 29; x++) {
    grid[24][x] = ARM_HI;
    grid[25][x] = OUT;
  }
  grid[25][2] = ARM_DARK; grid[25][3] = ARM_HI;
  grid[25][29] = ARM_HI; grid[25][30] = ARM_DARK;

  // Vertical panel seams dividing skirt into modular ERA composite blocks
  for (const seamX of [9, 15, 21, 27]) {
    for (let y = 19; y <= 24; y++) {
      grid[y][seamX] = OUT;
    }
  }

  // Center Skirt Plate: Sleek TEAM Tactical Insignia Stripe (x: 17..19, y: 21..22)
  grid[21][17] = 'TEAM'; grid[21][18] = 'TEAM'; grid[21][19] = 'TEAM';
  grid[22][17] = 'TEAM'; grid[22][18] = 'TEAM'; grid[22][19] = 'TEAM';
  // Beveled insignia frame
  grid[20][16] = ARM_TOP; grid[20][17] = ARM_TOP; grid[20][18] = ARM_TOP; grid[20][19] = ARM_TOP; grid[20][20] = ARM_TOP;
  grid[21][16] = OUT;     grid[21][20] = OUT;
  grid[22][16] = OUT;     grid[22][20] = OUT;
  grid[23][16] = ARM_DARK;grid[23][17] = ARM_DARK;grid[23][18] = ARM_DARK;grid[23][19] = ARM_DARK;grid[23][20] = ARM_DARK;

  // 5. Sloped Front Glacis Plate (Bug-Keilpanzerung, x: 26..34, y: 17..24)
  grid[17][26] = ARM_HI;  grid[17][27] = ARM_HI;
  grid[18][27] = ARM_HI;  grid[18][28] = ARM_TOP;
  grid[19][28] = ARM_HI;  grid[19][29] = ARM_TOP;
  grid[20][29] = ARM_HI;  grid[20][30] = ARM_TOP;
  grid[21][30] = ARM_MID; grid[21][31] = ARM_HI;  grid[21][32] = ARM_TOP;
  grid[22][31] = ARM_MID; grid[22][32] = ARM_HI;  grid[22][33] = ARM_TOP;
  grid[23][32] = ARM_LGT; grid[23][33] = ARM_MID; grid[23][34] = ARM_HI;
  grid[24][32] = ARM_DARK;grid[24][33] = ARM_DARK;grid[24][34] = ARM_MID;

  // Driver Tactical Optic / Vision Slit (Cyan cyber slit, x: 24..27, y: 18)
  grid[18][24] = DRV_CYAN_D; grid[18][25] = DRV_CYAN; grid[18][26] = DRV_CYAN_L; grid[18][27] = DRV_CYAN_W;

  // Armored High-Intensity Combat Headlight (x: 30..32, y: 20..21)
  grid[20][30] = LAMP_DARK; grid[20][31] = LAMP_CORE;   grid[20][32] = LAMP_WHITE;
  grid[21][30] = LAMP_DARK; grid[21][31] = LAMP_YELLOW; grid[21][32] = LAMP_AMBER;

  // Heavy Front Towing Hooks / Recovery Shackles (x: 34..35, y: 23..25)
  grid[23][34] = STEEL_HI; grid[23][35] = ARM_TOP;
  grid[24][34] = ARM_HI;   grid[24][35] = STEEL_HI;
  grid[25][34] = ARM_DARK; grid[25][35] = OUT;

  // 6. Rear Engine Deck & Twin Armored Exhausts with Combustion Glow (x: 1..8, y: 17..24)
  // Engine ventilation louvers
  for (let x = 4; x <= 9; x++) {
    grid[17][x] = (x % 2 === 0) ? EXH_VENT : ARM_LGT;
    grid[18][x] = (x % 2 === 0) ? OUT : ARM_MID;
  }
  // Armored Twin Exhaust Cowling with glowing combustion core
  grid[20][1] = ARM_DARK; grid[20][2] = EXH_MID;  grid[20][3] = EXH_FIRE; grid[20][4] = EXH_HOT;
  grid[21][1] = OUT;      grid[21][2] = EXH_DARK; grid[21][3] = EXH_MID;  grid[21][4] = EXH_FIRE;
  grid[22][1] = OUT;      grid[22][2] = ARM_DARK; grid[22][3] = ARM_DARK; grid[22][4] = ARM_MID;

  // Rear recovery hooks / towing bracket
  grid[23][1] = STEEL_HI; grid[23][2] = ARM_TOP;
  grid[24][1] = ARM_HI;   grid[24][2] = ARM_DARK;

  // 7. Turret Mounting Barbette Ring (Drehkranz-Schutz, x: 10..24, y: 15..17)
  for (let x = 12; x <= 22; x++) {
    grid[17][x] = ARM_MID;
  }
  grid[17][11] = ARM_DARK; grid[17][23] = ARM_DARK;

  grid[16][12] = ARM_DARK;
  for (let x = 13; x <= 21; x++) {
    grid[16][x] = ARM_LGT;
  }
  grid[16][22] = ARM_DARK;

  grid[15][13] = ARM_DARK;
  grid[15][14] = ARM_LGT; grid[15][15] = STEEL_HI; grid[15][16] = STEEL_MAX;
  grid[15][17] = STEEL_HI; grid[15][18] = ARM_LGT; grid[15][19] = ARM_LGT;
  grid[15][20] = ARM_DARK;

  return { gridSize: g, grid };
}

function getHD_Panzer_Chassis_Roll1() { return getHD_Panzer_Chassis(1); }
function getHD_Panzer_Chassis_Roll2() { return getHD_Panzer_Chassis(2); }
function getHD_Panzer_Chassis_Roll3() { return getHD_Panzer_Chassis(0); }

function getHD_Panzer_Turret() {
  const g = 36, grid = makeGrid36();

  const OUT        = '#05080f'; // Dark contour & shadow cavity
  const T_DARK     = '#1e293b'; // Shaded turret bevel
  const T_MID      = '#334155'; // Main turret body slate armor
  const T_LIGHT    = '#475569'; // Midtone armor & forward plates
  const T_HI       = '#64748b'; // Beveled edge highlight & chamfer
  const T_TOP      = '#94a3b8'; // Specular top plate
  const STEEL_MID  = '#94a3b8';
  const STEEL_HI   = '#cbd5e1';
  const STEEL_MAX  = '#f8fafc';

  // Commander Optic / Sensor Box (Golden / Amber Eye)
  const OPTIC_BEZEL= '#1e293b'; // Armored sensor housing bezel
  const OPTIC_HOUS = '#334155'; // Armored housing frame
  const OPTIC_GOLD = '#facc15'; // Amber-gold lens rim
  const OPTIC_AMBER= '#f59e0b'; // Sensor lens body
  const OPTIC_CORE = '#fef08a'; // Bright sensor core
  const OPTIC_GLINT= '#ffffff'; // Specular reflection dot
  const OPTIC_DARK = '#78350f'; // Deep shaded lens socket

  // 1. Turret Roof Armor & Central Citadel Housing (y: 7..15, x: 3..22)
  // Flat armored roof plate across bustle and hull
  for (let x = 4; x <= 19; x++) {
    grid[7][x] = T_TOP;
  }
  grid[7][11] = STEEL_HI; grid[7][12] = STEEL_MAX; grid[7][13] = STEEL_HI; // Central roof armor weld seam

  // Main Turret Body Core Volume
  for (let y = 8; y <= 14; y++) {
    for (let x = 4; x <= 20; x++) {
      grid[y][x] = T_MID;
    }
  }

  // Upper chamfer highlight row
  for (let x = 4; x <= 19; x++) {
    grid[8][x] = T_HI;
  }

  // Angular Faceted Front Cheek Armor (Keilform - sharp angled wedge forward toward mantlet)
  grid[8][20] = T_HI;  grid[8][21] = T_TOP;
  grid[9][20] = T_HI;  grid[9][21] = T_TOP;   grid[9][22] = STEEL_HI;
  grid[10][20] = T_MID; grid[10][21] = T_HI;  grid[10][22] = T_TOP;
  grid[11][20] = T_MID; grid[11][21] = T_HI;  grid[11][22] = T_TOP;
  grid[12][20] = T_MID; grid[12][21] = T_MID; grid[12][22] = T_HI;
  grid[13][20] = T_DARK; grid[13][21] = T_LIGHT; grid[13][22] = T_MID;
  grid[14][20] = T_DARK; grid[14][21] = T_DARK;  grid[14][22] = T_LIGHT;

  // Extended Rear Bustle Overhang (Munitionsbunker & Blow-out panels reaching back to x=3)
  grid[8][3] = T_DARK; grid[8][4] = T_LIGHT;
  grid[9][3] = T_DARK; grid[9][4] = T_LIGHT;
  grid[10][3] = T_DARK; grid[10][4] = T_MID;
  grid[11][3] = T_DARK; grid[11][4] = T_MID;
  grid[12][3] = T_DARK; grid[12][4] = T_DARK;
  grid[13][4] = T_DARK; grid[13][5] = T_DARK;
  grid[14][5] = T_DARK; grid[14][6] = T_DARK;

  // Turret Lower Ring Sealing (y: 15..16, x: 6..21)
  for (let x = 6; x <= 20; x++) {
    grid[15][x] = T_DARK;
    grid[16][x] = OUT;
  }

  // 2. Commander Optic / Sensor Box (Golden / Amber Eye from Artwork, x: 11..16, y: 3..7)
  grid[3][12] = OPTIC_HOUS; grid[3][13] = OPTIC_HOUS; grid[3][14] = OPTIC_HOUS; grid[3][15] = OPTIC_HOUS;
  grid[4][11] = OPTIC_BEZEL; grid[4][12] = OPTIC_GOLD; grid[4][13] = OPTIC_CORE; grid[4][14] = OPTIC_CORE; grid[4][15] = OPTIC_GOLD; grid[4][16] = OPTIC_BEZEL;
  grid[5][11] = OPTIC_BEZEL; grid[5][12] = OPTIC_GOLD; grid[5][13] = OPTIC_GLINT; grid[5][14] = OPTIC_AMBER; grid[5][15] = OPTIC_GOLD; grid[5][16] = OPTIC_BEZEL;
  grid[6][11] = OPTIC_BEZEL; grid[6][12] = OPTIC_AMBER; grid[6][13] = OPTIC_DARK; grid[6][14] = OPTIC_DARK; grid[6][15] = OPTIC_AMBER; grid[6][16] = OPTIC_BEZEL;
  grid[7][11] = OPTIC_BEZEL; grid[7][12] = OPTIC_BEZEL; grid[7][13] = OPTIC_BEZEL; grid[7][14] = OPTIC_BEZEL; grid[7][15] = OPTIC_BEZEL; grid[7][16] = OPTIC_BEZEL;

  // Communications Antenna Mast (rear bustle, x: 4..5, y: 2..7)
  grid[2][4] = STEEL_HI;
  grid[3][4] = STEEL_MID;
  grid[4][4] = T_HI;
  grid[5][4] = T_LIGHT;
  grid[6][4] = T_DARK;
  grid[7][4] = T_DARK;

  // Secondary Weapon / Dual Smoke Grenade Dischargers (x: 17..20, y: 5..7)
  grid[5][17] = T_DARK;  grid[5][18] = OUT;     grid[5][19] = T_DARK;  grid[5][20] = OUT;
  grid[6][17] = T_MID;   grid[6][18] = T_DARK;  grid[6][19] = T_MID;   grid[6][20] = T_DARK;
  grid[7][17] = T_LIGHT; grid[7][18] = T_MID;   grid[7][19] = T_LIGHT; grid[7][20] = T_MID;

  // Turret Flank Tactical TEAM Stripe (chevron-style marking, x: 8..11, y: 11..12)
  grid[11][8] = 'TEAM'; grid[11][9] = 'TEAM'; grid[11][10] = 'TEAM'; grid[11][11] = 'TEAM';
  grid[12][8] = 'TEAM'; grid[12][9] = 'TEAM'; grid[12][10] = 'TEAM'; grid[12][11] = 'TEAM';
  // Subtle crest frame
  grid[10][8] = T_LIGHT; grid[10][9] = T_LIGHT; grid[10][10] = T_LIGHT; grid[10][11] = T_LIGHT;
  grid[13][8] = T_DARK;  grid[13][9] = T_DARK;  grid[13][10] = T_DARK;  grid[13][11] = T_DARK;
  grid[11][7] = T_LIGHT; grid[12][7] = T_LIGHT;
  grid[11][12] = T_DARK; grid[12][12] = T_DARK;

  // 3. Heavy Gun Mantlet (Walzenblende / Geschützblende, x: 21..25, y: 8..15)
  grid[8][22]  = T_LIGHT;  grid[8][23]  = T_HI;     grid[8][24]  = T_HI;
  grid[9][21]  = T_LIGHT;  grid[9][22]  = T_HI;     grid[9][23]  = STEEL_HI; grid[9][24]  = STEEL_HI; grid[9][25]  = T_HI;
  grid[10][21] = T_MID;    grid[10][22] = T_HI;     grid[10][23] = STEEL_HI; grid[10][24] = STEEL_HI; grid[10][25] = STEEL_MAX;
  grid[11][21] = T_MID;    grid[11][22] = T_HI;     grid[11][23] = STEEL_HI; grid[11][24] = '#0f172a';grid[11][25] = STEEL_MAX; // Coaxial port
  grid[12][21] = T_MID;    grid[12][22] = T_MID;    grid[12][23] = T_HI;     grid[12][24] = T_HI;     grid[12][25] = STEEL_HI;
  grid[13][21] = T_DARK;   grid[13][22] = T_MID;    grid[13][23] = T_MID;    grid[13][24] = T_LIGHT;  grid[13][25] = T_HI;
  grid[14][22] = T_DARK;   grid[14][23] = T_DARK;   grid[14][24] = T_MID;    grid[14][25] = T_LIGHT;
  grid[15][23] = T_DARK;   grid[15][24] = T_DARK;

  // 4. Heavy 120mm Shock Cannon Barrel & Perforated Thermal Sleeve (x: 25..35, y: 9..15)
  // Bore center is at rows 11..12 (11.5/36 = 0.319 ~ 0.32 normalized)

  // Perforated Thermal Sleeve (Wärmeschutzhülle, x: 25..29, y: 10..14)
  for (let x = 25; x <= 29; x++) {
    grid[10][x] = (x % 2 === 0) ? STEEL_HI : T_TOP;
    grid[11][x] = (x % 2 === 0) ? '#090d16' : T_HI; // Dark perforated ventilation slots!
    grid[12][x] = (x % 2 === 0) ? '#090d16' : T_MID;
    grid[13][x] = (x % 2 === 0) ? T_DARK : T_MID;
    grid[14][x] = T_DARK;
  }
  // Sleeve retention collar bands
  grid[9][25] = T_LIGHT; grid[9][26] = T_HI;
  grid[9][28] = T_LIGHT; grid[9][29] = T_HI;
  grid[15][25] = T_DARK; grid[15][26] = T_DARK;
  grid[15][28] = T_DARK; grid[15][29] = T_DARK;

  // Stepped Bore Evacuator Collar (Rauchabsauger, x: 29..31, y: 9..14)
  grid[9][29] = T_LIGHT; grid[9][30] = T_HI; grid[9][31] = T_TOP;
  grid[10][30] = STEEL_MAX; grid[10][31] = STEEL_HI;
  grid[11][30] = '#64748b'; grid[11][31] = '#94a3b8';
  grid[12][30] = '#475569'; grid[12][31] = '#64748b';
  grid[13][30] = '#334155'; grid[13][31] = '#475569';
  grid[14][29] = T_DARK; grid[14][30] = T_DARK; grid[14][31] = T_DARK;

  // Forward Rifled Barrel (x: 31..33, y: 10..13)
  for (let x = 31; x <= 33; x++) {
    grid[10][x] = (x % 2 === 0) ? STEEL_MAX : STEEL_HI;
    grid[11][x] = '#64748b';
    grid[12][x] = '#334155';
    grid[13][x] = T_DARK;
  }

  // 5. Massive Double-Baffle Muzzle Brake (Mündungsbremse, x: 33..35, y: 8..15)
  grid[8][33] = T_LIGHT; grid[8][34] = T_HI; grid[8][35] = STEEL_HI;
  grid[9][33] = STEEL_HI; grid[9][34] = STEEL_MAX; grid[9][35] = STEEL_MAX;
  grid[10][33] = STEEL_HI; grid[10][34] = STEEL_MAX; grid[10][35] = STEEL_MAX;

  // Deep hollow gun bore cavity (rows 11..12, col 34..35)
  grid[11][33] = STEEL_HI; grid[11][34] = '#0f172a'; grid[11][35] = '#020617';
  grid[12][33] = STEEL_MID; grid[12][34] = '#0f172a'; grid[12][35] = '#020617';

  grid[13][33] = STEEL_MID; grid[13][34] = STEEL_HI; grid[13][35] = STEEL_HI;
  grid[14][33] = T_DARK; grid[14][34] = T_MID; grid[14][35] = T_DARK;
  grid[15][33] = OUT; grid[15][34] = T_DARK; grid[15][35] = OUT;

  return { gridSize: g, grid };
}

function getHD_Panzer() {
  const g = 36, grid = makeGrid36();
  const c = getHD_Panzer_Chassis(0).grid;
  const t = getHD_Panzer_Turret().grid;

  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (c[y][x]) grid[y][x] = c[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
    }
  }
  return { gridSize: g, grid };
}

function _composePanzerRoll(roll = 0) {
  const g = 36, grid = makeGrid36();
  const c = getHD_Panzer_Chassis(roll).grid;
  const t = getHD_Panzer_Turret().grid;
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (c[y][x]) grid[y][x] = c[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
    }
  }
  return { gridSize: g, grid };
}
function getHD_Panzer_Roll1() { return _composePanzerRoll(1); }
function getHD_Panzer_Roll2() { return _composePanzerRoll(2); }
function getHD_Panzer_Roll3() { return _composePanzerRoll(0); }

// ── HYPER PANZER (36x36 HD NATIVE SCALE) ─────────────────────────
// Melt tier 2 version of the Panzer: Heavy dreadnought chassis with 5 round road wheels,
// high-plasticity 3D modular side skirts, deep cold titanium/slate steel dreadnought coloring,
// solid horizontal turret ring, and natural linear gun elevation (cf. 1_hyperpanzer.png).

function getHD_HyperPanzer_Chassis(roll = 0) {
  const g = 36, grid = makeGrid36();

  // Tracks & Undercarriage Palette
  const T_VOID      = '#020617'; // Under-hull void
  const T_BLACK     = '#060a12'; // Deepest crevice & shadow
  const T_DARK      = '#0d1522'; // Dark track tread & plate seams
  const T_MID       = '#172033'; // Track links & deep recesses
  const T_STEEL     = '#243247'; // Dark armor undercuts
  const T_CLEAT     = '#475569'; // Hardened track grouser cleat
  const T_CLEAT_HI  = '#64748b'; // Cleat specular edge

  // Chassis Armor (Dark cold titanium/slate steel matching artwork)
  const ARM_CREVICE = '#090d16'; // Deepest panel seam & armor joint
  const ARM_SHADOW  = '#161f30'; // Shadowed plate bevel & undercuts
  const ARM_DARK    = '#263349'; // Dark slate armor base
  const ARM_MID     = '#3b4b63'; // Primary armor midtone (dominant body)
  const ARM_STEEL   = '#4d5f7a'; // Muted cold steel surface
  const ARM_LGT     = '#647794'; // Sunlit armor plate
  const ARM_BEVEL   = '#8295b3'; // Crisp beveled edge highlight
  const ARM_HI      = '#a8b9d1'; // Light metal reflection
  const ARM_SPEC    = '#dce5f2'; // Razor-thin specular glint

  // Road Wheels & Heavy Suspension
  const RIM_RUBBER  = '#090d16'; // Heavy synthetic rubber tire
  const WHEEL_STEEL = '#263349'; // Road wheel dish
  const WHEEL_MID   = '#3b4b63'; // Wheel face
  const WHEEL_HUB   = '#566885'; // Central hubcap
  const WHEEL_HI    = '#8295b3'; // Hub specular rim

  // Optics & Energy Weapons
  const VISOR_CORE  = '#e0f2fe'; // Blazing cyan-white core
  const VISOR_CYAN  = '#00f0ff'; // Vibrant neon cyan sensor glow
  const VISOR_MID   = '#0ea5e9'; // Mid cyan optical lens
  const VISOR_DARK  = '#0369a1'; // Deep cyan optical housing

  // Headlights
  const LIGHT_CORE  = '#fef08a'; // High-intensity LED beam
  const LIGHT_AMBER = '#facc15'; // Amber tactical spotlight rim
  const LIGHT_DARK  = '#a16207'; // Light casing shadow

  // Exhaust & Thermals
  const HEAT_GLOW   = '#f97316'; // Glowing manifold vent
  const HEAT_HOT    = '#ea580c'; // Radiant orange exhaust
  const HEAT_CORE   = '#7c2d12'; // Scorched copper exhaust pipe

  // 1. Under-hull Void (y: 25..33, x: 1..34)
  for (let y = 25; y <= 33; y++) {
    for (let x = 1; x <= 34; x++) {
      grid[y][x] = T_VOID;
    }
  }

  // 2. Heavy Caterpillar Track Perimeter Loop (y: 24..35, x: 0..35)
  for (let x = 3; x <= 32; x++) {
    grid[24][x] = T_BLACK;
    grid[25][x] = T_DARK;
    grid[34][x] = T_MID;
    grid[35][x] = T_BLACK;
  }

  // Front Idler Curve (x: 32..35, y: 24..34)
  grid[24][32] = T_BLACK; grid[24][33] = T_BLACK;
  grid[25][33] = T_BLACK; grid[25][34] = T_DARK;
  for (let y = 26; y <= 32; y++) {
    grid[y][34] = T_MID;
    grid[y][35] = T_BLACK;
  }
  grid[33][33] = T_BLACK; grid[33][34] = T_DARK;
  grid[34][32] = T_BLACK; grid[34][33] = T_BLACK;
  grid[35][32] = T_BLACK;

  // Rear Drive Sprocket Curve (x: 0..3, y: 24..34)
  grid[24][2] = T_BLACK; grid[24][3] = T_BLACK;
  grid[25][1] = T_BLACK; grid[25][2] = T_DARK;
  for (let y = 26; y <= 32; y++) {
    grid[y][0] = T_BLACK;
    grid[y][1] = T_MID;
  }
  grid[33][1] = T_BLACK; grid[33][2] = T_DARK;
  grid[34][2] = T_BLACK; grid[34][3] = T_BLACK;
  grid[35][3] = T_BLACK;

  // Track Grousers / Cleats Animation
  for (let x = 3; x <= 32; x++) {
    if ((x + roll) % 3 === 0) {
      grid[35][x] = T_CLEAT_HI;
      grid[34][x] = T_CLEAT;
    }
  }

  // Curved End Cleat Shifting (Roll 0, 1, 2)
  if (roll === 0) {
    grid[27][0]  = T_CLEAT_HI; grid[31][0]  = T_CLEAT;
    grid[26][35] = T_CLEAT_HI; grid[30][35] = T_CLEAT;
  } else if (roll === 1) {
    grid[28][0]  = T_CLEAT_HI; grid[32][0]  = T_CLEAT;
    grid[27][35] = T_CLEAT_HI; grid[31][35] = T_CLEAT;
  } else {
    grid[26][0]  = T_CLEAT_HI; grid[29][0]  = T_CLEAT;
    grid[28][35] = T_CLEAT_HI; grid[32][35] = T_CLEAT;
  }

  // 3. 5 DISTINCT ROUND ROAD WHEELS (5x7 circular road wheels)
  const wheels = [
    { x1: 4,  x2: 8 },
    { x1: 10, x2: 14 },
    { x1: 16, x2: 20 },
    { x1: 22, x2: 26 },
    { x1: 28, x2: 32 }
  ];

  wheels.forEach((w) => {
    grid[27][w.x1 + 1] = RIM_RUBBER; grid[27][w.x1 + 2] = RIM_RUBBER; grid[27][w.x1 + 3] = RIM_RUBBER;

    grid[28][w.x1]     = RIM_RUBBER; grid[28][w.x1 + 1] = WHEEL_STEEL;
    grid[28][w.x1 + 2] = WHEEL_MID;  grid[28][w.x1 + 3] = WHEEL_STEEL; grid[28][w.x2] = RIM_RUBBER;

    for (let wy = 29; wy <= 31; wy++) {
      grid[wy][w.x1]     = RIM_RUBBER; grid[wy][w.x1 + 1] = WHEEL_STEEL;
      grid[wy][w.x1 + 2] = WHEEL_HUB;   grid[wy][w.x1 + 3] = WHEEL_STEEL; grid[wy][w.x2] = RIM_RUBBER;
    }
    grid[30][w.x1 + 2] = ARM_SPEC;

    if (roll === 0) {
      grid[29][w.x1 + 1] = WHEEL_HI; grid[29][w.x1 + 2] = ARM_SPEC; grid[31][w.x1 + 3] = T_BLACK;
    } else if (roll === 1) {
      grid[29][w.x1 + 3] = WHEEL_HI; grid[30][w.x1 + 3] = ARM_SPEC; grid[31][w.x1 + 1] = T_BLACK;
    } else {
      grid[31][w.x1 + 2] = WHEEL_HI; grid[31][w.x1 + 3] = ARM_SPEC; grid[29][w.x1 + 1] = T_BLACK;
    }

    grid[32][w.x1]     = RIM_RUBBER; grid[32][w.x1 + 1] = WHEEL_STEEL;
    grid[32][w.x1 + 2] = WHEEL_STEEL;grid[32][w.x1 + 3] = WHEEL_STEEL; grid[32][w.x2] = RIM_RUBBER;

    grid[33][w.x1 + 1] = RIM_RUBBER; grid[33][w.x1 + 2] = RIM_RUBBER; grid[33][w.x1 + 3] = RIM_RUBBER;
  });

  for (const gapX of [9, 15, 21, 27]) {
    grid[25][gapX] = T_BLACK; grid[26][gapX] = ARM_CREVICE; grid[27][gapX] = ARM_SHADOW;
  }

  // 4. MODULAR SIDE SKIRTS WITH HIGH 3D PLASTICITY (y: 20..25)
  const slabs = [
    { x1: 2,  x2: 7 },
    { x1: 9,  x2: 14 },
    { x1: 16, x2: 21, isTeam: true },
    { x1: 23, x2: 28 },
    { x1: 30, x2: 34, isFrontWedge: true }
  ];

  slabs.forEach(slab => {
    // Row 20: Top Bevel / Chamfer
    for (let x = slab.x1; x <= slab.x2; x++) grid[20][x] = ARM_BEVEL;
    grid[20][slab.x1] = ARM_SPEC;

    // Row 21: Upper plate face (Sunlit)
    for (let x = slab.x1; x <= slab.x2; x++) grid[21][x] = ARM_LGT;
    grid[21][slab.x1] = ARM_HI;

    // Row 22: Mid plate face
    for (let x = slab.x1; x <= slab.x2; x++) grid[22][x] = ARM_STEEL;
    grid[22][slab.x1] = ARM_LGT;
    grid[22][slab.x2] = ARM_DARK;

    // Row 23: Lower plate face (Shaded)
    for (let x = slab.x1; x <= slab.x2; x++) grid[23][x] = ARM_MID;
    grid[23][slab.x1] = ARM_STEEL;
    grid[23][slab.x2] = ARM_DARK;

    // Row 24: Bottom lip / Under-bevel
    for (let x = slab.x1; x <= slab.x2; x++) grid[24][x] = ARM_DARK;
    grid[24][slab.x2] = ARM_SHADOW;

    // Row 25: Cast Drop Shadow onto wheels/tracks
    for (let x = slab.x1; x <= slab.x2; x++) grid[25][x] = T_BLACK;

    // Mounting bolts on non-team plates
    if (!slab.isTeam) {
      grid[21][slab.x1 + 1] = ARM_SPEC;
      grid[23][slab.x1 + 1] = ARM_BEVEL;
      grid[21][slab.x2 - 1] = ARM_BEVEL;
      grid[23][slab.x2 - 1] = ARM_MID;
    }

    if (slab.isFrontWedge) {
      grid[20][34] = ARM_HI;
      grid[21][34] = ARM_STEEL;
      grid[22][34] = ARM_MID;
      grid[23][34] = ARM_DARK;
      grid[24][34] = ARM_SHADOW;
      grid[24][33] = ARM_DARK;
    }

    if (slab.isTeam) {
      for (let y = 21; y <= 23; y++) {
        for (let x = 17; x <= 20; x++) grid[y][x] = 'TEAM';
      }
      grid[21][16] = ARM_BEVEL; grid[22][16] = ARM_BEVEL; grid[23][16] = ARM_STEEL;
      grid[21][21] = ARM_DARK;  grid[22][21] = ARM_DARK;  grid[23][21] = ARM_SHADOW;
    }
  });

  for (const sx of [8, 15, 22, 29]) {
    for (let y = 20; y <= 24; y++) grid[y][sx] = ARM_CREVICE;
  }

  grid[20][1] = ARM_DARK; grid[21][1] = ARM_CREVICE;
  grid[20][35] = ARM_LGT; grid[21][35] = ARM_STEEL; grid[22][35] = ARM_DARK;

  // 5. SLOPED FRONT GLACIS PLATE (x: 24..35, y: 15..20)
  for (let x = 24; x <= 30; x++) {
    grid[15][x] = ARM_BEVEL;
    grid[16][x] = ARM_LGT;
    grid[17][x] = ARM_STEEL;
  }
  grid[15][27] = ARM_SPEC; grid[15][28] = ARM_SPEC;

  grid[16][31] = ARM_BEVEL; grid[16][32] = ARM_LGT;
  grid[17][31] = ARM_LGT;   grid[17][32] = ARM_STEEL; grid[17][33] = ARM_MID;
  grid[18][32] = ARM_BEVEL; grid[18][33] = ARM_LGT;   grid[18][34] = ARM_STEEL; grid[18][35] = ARM_MID;
  grid[19][33] = ARM_STEEL; grid[19][34] = ARM_MID;   grid[19][35] = ARM_DARK;

  grid[18][33] = LIGHT_AMBER; grid[18][34] = LIGHT_CORE;
  grid[19][33] = LIGHT_DARK;  grid[19][34] = LIGHT_AMBER;

  grid[16][25] = VISOR_DARK; grid[16][26] = VISOR_MID; grid[16][27] = VISOR_CYAN; grid[16][28] = VISOR_CORE;

  // 6. Hull Upper Deck & Rear Engine Deck (x: 1..24, y: 16..20)
  for (let y = 16; y <= 19; y++) {
    for (let x = 2; x <= 24; x++) {
      if (!grid[y][x]) grid[y][x] = (y === 16) ? ARM_MID : ARM_DARK;
    }
  }

  for (let x = 3; x <= 8; x++) {
    grid[16][x] = (x % 2 === 0) ? ARM_CREVICE : ARM_STEEL;
    grid[17][x] = (x % 2 === 0) ? ARM_CREVICE : ARM_DARK;
    grid[18][x] = (x % 2 === 0) ? ARM_CREVICE : ARM_SHADOW;
  }
  grid[16][2] = ARM_BEVEL; grid[16][9] = ARM_BEVEL;

  grid[19][0] = ARM_SHADOW; grid[19][1] = HEAT_CORE; grid[19][2] = HEAT_HOT;  grid[19][3] = HEAT_GLOW;
  grid[20][0] = ARM_CREVICE;grid[20][1] = HEAT_CORE; grid[20][2] = HEAT_HOT;  grid[20][3] = HEAT_CORE;
  grid[21][0] = T_BLACK;    grid[21][1] = ARM_CREVICE;

  // 7. Drehkranz Barbette Collar (x: 9..24, y: 14..15)
  grid[14][9]  = ARM_SHADOW; grid[14][10] = ARM_DARK;
  for (let x = 11; x <= 23; x++) {
    grid[14][x] = ARM_MID;
    grid[15][x] = ARM_DARK;
  }
  grid[14][24] = ARM_SHADOW;
  grid[14][14] = ARM_BEVEL; grid[14][15] = ARM_SPEC; grid[14][16] = ARM_SPEC; grid[14][17] = ARM_BEVEL;

  return { gridSize: g, grid };
}

function getHD_HyperPanzer_Chassis_Roll1() { return getHD_HyperPanzer_Chassis(1); }
function getHD_HyperPanzer_Chassis_Roll2() { return getHD_HyperPanzer_Chassis(2); }
function getHD_HyperPanzer_Chassis_Roll3() { return getHD_HyperPanzer_Chassis(0); }

// ── FLUTE-TURRET BUILDER WITH 5 AIMING STATES ("straight", "left", "right", "up", "down") ──
function buildHD_HyperPanzer_Turret(aim = 'straight') {
  const g = 36, grid = makeGrid36();

  // Dark Armor Palette
  const ARM_CREVICE = '#090d16';
  const ARM_SHADOW  = '#161f30';
  const ARM_DARK    = '#263349';
  const ARM_MID     = '#3b4b63';
  const ARM_STEEL   = '#4d5f7a';
  const ARM_LGT     = '#647794';
  const ARM_BEVEL   = '#8295b3';
  const ARM_SPEC    = '#dce5f2';

  // Missile Pod Palette (from artwork)
  const POD_FRAME   = '#15182e';
  const POD_STEEL   = '#26284d';
  const POD_BRACKET = '#3b3a78';
  const ROCKET_HOT  = '#ffffff';
  const ROCKET_MAG  = '#ec4899';
  const ROCKET_VIO  = '#d946ef';
  const ROCKET_CYA  = '#00f0ff';

  // Optics
  const VISOR_CORE  = '#e0f2fe';
  const VISOR_CYAN  = '#00f0ff';

  if (aim === 'up') {
    // ═════════════════════════════════════════════════════════════════
    // STATE: UP (Turret viewed from top/rear, gun pointing straight North)
    // ═════════════════════════════════════════════════════════════════
    for (let x = 10; x <= 26; x++) {
      grid[15][x] = ARM_SHADOW;
      grid[16][x] = ARM_CREVICE;
    }
    for (let y = 11; y <= 15; y++) {
      for (let x = 11; x <= 25; x++) {
        grid[y][x] = (y === 11) ? ARM_STEEL : ARM_MID;
      }
    }
    for (let x = 12; x <= 24; x++) grid[15][x] = ARM_DARK;

    grid[12][17] = ARM_BEVEL; grid[12][18] = ARM_SPEC; grid[12][19] = ARM_BEVEL;
    grid[13][16] = '#94a3b8'; grid[13][17] = '#facc15'; grid[13][18] = '#ef4444'; grid[13][19] = '#38bdf8'; grid[13][20] = '#94a3b8';

    for (let y = 11; y <= 16; y++) grid[y][25] = ARM_BEVEL;
    grid[17][25] = '#ef4444';

    for (let y = 9; y <= 14; y++) {
      for (let x = 6; x <= 10; x++) grid[y][x] = POD_FRAME;
    }
    grid[10][7] = ROCKET_HOT; grid[10][8] = ROCKET_MAG; grid[10][9] = ROCKET_CYA;
    grid[12][7] = ROCKET_MAG; grid[12][8] = ROCKET_VIO; grid[12][9] = ROCKET_HOT;

    for (let y = 7; y <= 10; y++) {
      for (let x = 15; x <= 22; x++) grid[y][x] = (y <= 8) ? ARM_LGT : ARM_STEEL;
    }

    for (let y = 0; y <= 6; y++) {
      grid[y][17] = ARM_BEVEL;
      grid[y][18] = ARM_LGT;
      grid[y][19] = ARM_STEEL;
      grid[y][20] = ARM_DARK;
    }
    for (let y = 3; y <= 5; y++) {
      grid[y][16] = ARM_SPEC;
      grid[y][17] = ARM_BEVEL;
      grid[y][18] = ARM_LGT;
      grid[y][19] = ARM_STEEL;
      grid[y][20] = ARM_DARK;
      grid[y][21] = ARM_CREVICE;
    }
    for (let y = 1; y <= 2; y++) {
      grid[y][16] = ARM_BEVEL;
      grid[y][17] = ARM_SPEC;
      grid[y][18] = ARM_LGT;
      grid[y][19] = ARM_STEEL;
      grid[y][20] = ARM_DARK;
      grid[y][21] = ARM_CREVICE;
    }
    grid[0][16] = ARM_DARK;
    grid[0][17] = '#0f172a'; // Bore hole anchor!
    grid[0][18] = '#050811';
    grid[0][19] = '#0f172a';
    grid[0][20] = ARM_DARK;

    return { gridSize: g, grid };
  }

  if (aim === 'down') {
    // ═════════════════════════════════════════════════════════════════
    // STATE: DOWN (Turret viewed from front/top, gun pointing South)
    // ═════════════════════════════════════════════════════════════════
    for (let x = 10; x <= 26; x++) {
      grid[14][x] = ARM_SHADOW;
      grid[15][x] = ARM_CREVICE;
    }
    for (let y = 9; y <= 14; y++) {
      for (let x = 11; x <= 25; x++) {
        grid[y][x] = (y === 9) ? ARM_STEEL : ARM_MID;
      }
    }
    grid[9][17] = ARM_BEVEL; grid[9][18] = ARM_SPEC; grid[9][19] = ARM_BEVEL;

    grid[10][17] = ARM_BEVEL; grid[10][18] = ARM_SPEC; grid[10][19] = ARM_BEVEL;
    grid[11][16] = '#94a3b8'; grid[11][17] = '#facc15'; grid[11][18] = '#ef4444'; grid[11][19] = '#38bdf8'; grid[11][20] = '#94a3b8';

    for (let y = 4; y <= 9; y++) grid[y][11] = ARM_BEVEL;
    grid[3][11] = '#ef4444';

    for (let y = 9; y <= 14; y++) {
      for (let x = 26; x <= 30; x++) grid[y][x] = POD_FRAME;
    }
    grid[10][27] = ROCKET_HOT; grid[10][28] = ROCKET_MAG; grid[10][29] = ROCKET_CYA;
    grid[12][27] = ROCKET_MAG; grid[12][28] = ROCKET_VIO; grid[12][29] = ROCKET_HOT;

    for (let y = 14; y <= 17; y++) {
      for (let x = 15; x <= 22; x++) grid[y][x] = (y <= 15) ? ARM_LGT : ARM_STEEL;
    }

    for (let y = 18; y <= 34; y++) {
      grid[y][17] = ARM_BEVEL;
      grid[y][18] = ARM_LGT;
      grid[y][19] = ARM_STEEL;
      grid[y][20] = ARM_DARK;
    }
    for (let y = 24; y <= 27; y++) {
      grid[y][16] = ARM_SPEC;
      grid[y][17] = ARM_BEVEL;
      grid[y][18] = ARM_LGT;
      grid[y][19] = ARM_STEEL;
      grid[y][20] = ARM_DARK;
      grid[y][21] = ARM_CREVICE;
    }
    for (let y = 33; y <= 34; y++) {
      grid[y][16] = ARM_BEVEL;
      grid[y][17] = ARM_SPEC;
      grid[y][18] = ARM_LGT;
      grid[y][19] = ARM_STEEL;
      grid[y][20] = ARM_DARK;
      grid[y][21] = ARM_CREVICE;
    }
    grid[35][16] = ARM_DARK;
    grid[35][17] = '#0f172a'; // Bore hole anchor!
    grid[35][18] = '#050811';
    grid[35][19] = '#0f172a';
    grid[35][20] = ARM_DARK;

    return { gridSize: g, grid };
  }

  // ── SOLID LEVEL HORIZONTAL TURRET BODY (for straight, left, and right) ──
  for (let x = 8; x <= 24; x++) {
    grid[15][x] = ARM_SHADOW;
    grid[16][x] = ARM_CREVICE;
  }

  for (let x = 7; x <= 23; x++) {
    grid[9][x]  = ARM_LGT;
    grid[10][x] = ARM_STEEL;
  }
  grid[9][13] = ARM_BEVEL; grid[9][14] = ARM_SPEC; grid[9][15] = ARM_SPEC; grid[9][16] = ARM_BEVEL;

  for (let y = 11; y <= 14; y++) {
    for (let x = 4; x <= 24; x++) {
      grid[y][x] = (y === 11) ? ARM_MID : ARM_DARK;
    }
  }

  // Angular Faceted Front Cheek Armor
  grid[10][23] = ARM_BEVEL; grid[10][24] = ARM_LGT;
  grid[11][23] = ARM_LGT;   grid[11][24] = ARM_STEEL; grid[11][25] = ARM_MID;
  grid[12][24] = ARM_STEEL; grid[12][25] = ARM_MID;
  grid[13][24] = ARM_MID;   grid[13][25] = ARM_DARK;
  grid[14][24] = ARM_DARK;  grid[14][25] = ARM_SHADOW;
  grid[15][24] = ARM_CREVICE;

  // Extended Rear Bustle
  for (let y = 10; y <= 14; y++) {
    grid[y][2] = ARM_CREVICE;
    grid[y][3] = ARM_SHADOW;
  }
  grid[10][4] = ARM_STEEL; grid[10][5] = ARM_MID;

  for (let y = 3; y <= 9; y++) grid[y][2] = (y <= 5) ? ARM_SPEC : ARM_BEVEL;
  grid[2][2] = '#ef4444';

  for (let y = 12; y <= 14; y++) {
    for (let x = 8; x <= 13; x++) {
      grid[y][x] = 'TEAM';
    }
  }

  grid[6][11]  = ARM_BEVEL; grid[6][12]  = ARM_SPEC; grid[6][13]  = ARM_BEVEL;
  grid[7][10]  = ARM_STEEL; grid[7][11]  = ARM_BEVEL;grid[7][12]  = ARM_SPEC; grid[7][13]  = ARM_BEVEL; grid[7][14]  = ARM_STEEL;
  grid[8][9]   = ARM_DARK;  grid[8][10]  = '#facc15';grid[8][11]  = '#ef4444';grid[8][12]  = '#38bdf8'; grid[8][13]  = '#00f0ff'; grid[8][14]  = ARM_DARK;

  // Multi-Tube Flank Missile Pod (Artwork Detail)
  for (let y = 2; y <= 8; y++) {
    const minX = Math.max(7, 10 - y);
    const maxX = Math.min(18, 15 + Math.floor((8 - y) * 0.5));
    for (let x = minX; x <= maxX; x++) {
      if (!grid[y][x]) grid[y][x] = POD_FRAME;
    }
  }
  grid[2][8]  = POD_STEEL; grid[2][9]  = POD_BRACKET; grid[2][16] = POD_STEEL;
  grid[8][7]  = POD_STEEL; grid[8][16] = POD_BRACKET;

  grid[3][10] = ROCKET_MAG; grid[3][11] = ROCKET_HOT;
  grid[3][12] = ROCKET_MAG; grid[3][13] = ROCKET_HOT;
  grid[3][14] = ROCKET_VIO; grid[3][15] = ROCKET_HOT;
  grid[3][16] = ROCKET_MAG; grid[3][17] = ROCKET_CYA;

  grid[5][9]  = ROCKET_HOT; grid[5][10] = ROCKET_MAG;
  grid[5][11] = ROCKET_HOT; grid[5][12] = ROCKET_MAG;
  grid[5][13] = ROCKET_HOT; grid[5][14] = ROCKET_VIO;
  grid[5][15] = ROCKET_CYA; grid[5][16] = ROCKET_MAG;

  // ── WEAPON MANTLET & 150mm CANNON BARREL ────────────────────────
  if (aim === 'right') {
    // ═════════════════════════════════════════════════════════════════
    // STATE: RIGHT (Aiming down-forward at a realistic ~12° angle)
    // Mantlet pivots down slightly. Barrel steps from y=12 down to y=14.
    // Perfectly straight linear cylinder! Clears glacis cleanly!
    // ═════════════════════════════════════════════════════════════════
    for (let y = 11; y <= 16; y++) {
      for (let x = 22; x <= 25; x++) {
        grid[y][x] = (x >= 24) ? ARM_LGT : ARM_STEEL;
      }
    }
    grid[10][23] = ARM_MID; grid[10][24] = ARM_MID;
    grid[16][24] = ARM_DARK;

    const rightSegs = [
      { x1: 25, x2: 27, top: 11, bot: 14 },
      { x1: 28, x2: 31, top: 12, bot: 15 },
      { x1: 32, x2: 35, top: 13, bot: 16 }
    ];

    rightSegs.forEach(s => {
      for (let x = s.x1; x <= s.x2; x++) {
        grid[s.top][x]     = ARM_BEVEL;
        grid[s.top + 1][x] = ARM_LGT;
        grid[s.top + 2][x] = ARM_STEEL;
        grid[s.bot][x]     = ARM_DARK;
      }
    });

    for (let x = 28; x <= 31; x++) {
      grid[11][x] = (x % 2 === 0) ? ARM_SPEC : ARM_BEVEL;
      grid[16][x] = ARM_CREVICE;
    }

    for (let x = 32; x <= 35; x++) {
      grid[12][x] = (x === 33) ? ARM_CREVICE : ARM_SPEC;
      grid[17][x] = (x === 33) ? ARM_CREVICE : ARM_CREVICE;
    }
    grid[14][34] = VISOR_CORE;
    grid[15][34] = VISOR_CYAN;
    grid[14][35] = '#0f172a'; // Bore opening anchor!
    grid[15][35] = '#050811';

  } else if (aim === 'left') {
    // ═════════════════════════════════════════════════════════════════
    // STATE: LEFT (Aiming up-forward at a realistic ~12° angle)
    // Mantlet pivots up slightly. Barrel steps from y=12 up to y=10.
    // Perfectly straight linear cylinder! Clean and solid!
    // ═════════════════════════════════════════════════════════════════
    for (let y = 9; y <= 14; y++) {
      for (let x = 22; x <= 25; x++) {
        grid[y][x] = (x >= 24) ? ARM_LGT : ARM_STEEL;
      }
    }
    grid[8][23]  = ARM_MID; grid[8][24]  = ARM_MID;
    grid[15][24] = ARM_DARK;

    const leftSegs = [
      { x1: 25, x2: 27, top: 11, bot: 14 },
      { x1: 28, x2: 31, top: 10, bot: 13 },
      { x1: 32, x2: 35, top: 9,  bot: 12 }
    ];

    leftSegs.forEach(s => {
      for (let x = s.x1; x <= s.x2; x++) {
        grid[s.top][x]     = ARM_BEVEL;
        grid[s.top + 1][x] = ARM_LGT;
        grid[s.top + 2][x] = ARM_STEEL;
        grid[s.bot][x]     = ARM_DARK;
      }
    });

    for (let x = 28; x <= 31; x++) {
      grid[9][x]  = (x % 2 === 0) ? ARM_SPEC : ARM_BEVEL;
      grid[14][x] = ARM_CREVICE;
    }

    for (let x = 32; x <= 35; x++) {
      grid[8][x]  = (x === 33) ? ARM_CREVICE : ARM_SPEC;
      grid[13][x] = (x === 33) ? ARM_CREVICE : ARM_CREVICE;
    }
    grid[10][34] = VISOR_CORE;
    grid[11][34] = VISOR_CYAN;
    grid[10][35] = '#0f172a'; // Bore opening anchor!
    grid[11][35] = '#050811';

  } else {
    // ═════════════════════════════════════════════════════════════════
    // STATE: STRAIGHT (Horizontal Forward)
    // ═════════════════════════════════════════════════════════════════
    for (let y = 10; y <= 15; y++) {
      for (let x = 22; x <= 25; x++) {
        grid[y][x] = (x === 24 || x === 25) ? ARM_LGT : ARM_STEEL;
      }
    }
    grid[9][23]  = ARM_DARK; grid[9][24]  = ARM_DARK;
    grid[16][23] = ARM_CREVICE; grid[16][24] = ARM_CREVICE;

    for (let x = 26; x <= 35; x++) {
      grid[11][x] = (x % 2 === 0) ? ARM_SPEC : ARM_BEVEL;
      grid[12][x] = ARM_LGT;
      grid[13][x] = ARM_STEEL;
      grid[14][x] = ARM_DARK;
    }

    for (let x = 28; x <= 31; x++) {
      grid[10][x] = (x % 2 === 0) ? ARM_SPEC : ARM_BEVEL;
      grid[11][x] = ARM_BEVEL;
      grid[12][x] = ARM_LGT;
      grid[13][x] = ARM_STEEL;
      grid[14][x] = ARM_DARK;
      grid[15][x] = ARM_CREVICE;
    }

    for (let x = 32; x <= 35; x++) {
      grid[10][x] = (x === 33) ? ARM_CREVICE : ARM_SPEC;
      grid[11][x] = (x === 33) ? ARM_SHADOW : ARM_BEVEL;
      grid[12][x] = ARM_LGT;
      grid[13][x] = ARM_STEEL;
      grid[14][x] = (x === 33) ? ARM_SHADOW : ARM_DARK;
      grid[15][x] = (x === 33) ? ARM_CREVICE : ARM_CREVICE;
    }

    grid[12][34] = VISOR_CORE;
    grid[13][34] = VISOR_CYAN;
    grid[12][35] = '#0f172a'; // Bore opening anchor!
    grid[13][35] = '#050811';
  }

  return { gridSize: g, grid };
}

function getHD_HyperPanzer_Turret() { return buildHD_HyperPanzer_Turret('straight'); }
function getHD_HyperPanzer_Turret_Straight() { return buildHD_HyperPanzer_Turret('straight'); }
function getHD_HyperPanzer_Turret_Left() { return buildHD_HyperPanzer_Turret('left'); }
function getHD_HyperPanzer_Turret_Right() { return buildHD_HyperPanzer_Turret('right'); }
function getHD_HyperPanzer_Turret_Up() { return buildHD_HyperPanzer_Turret('up'); }
function getHD_HyperPanzer_Turret_Down() { return buildHD_HyperPanzer_Turret('down'); }

function getHD_HyperPanzer() {
  const g = 36, grid = makeGrid36();
  const c = getHD_HyperPanzer_Chassis(0).grid;
  const t = getHD_HyperPanzer_Turret().grid;

  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (c[y][x]) grid[y][x] = c[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
    }
  }
  return { gridSize: g, grid };
}

function _composeHyperPanzerRoll(roll = 0) {
  const g = 36, grid = makeGrid36();
  const c = getHD_HyperPanzer_Chassis(roll).grid;
  const t = getHD_HyperPanzer_Turret().grid;
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (c[y][x]) grid[y][x] = c[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
    }
  }
  return { gridSize: g, grid };
}
function getHD_HyperPanzer_Roll1() { return _composeHyperPanzerRoll(1); }
function getHD_HyperPanzer_Roll2() { return _composeHyperPanzerRoll(2); }
function getHD_HyperPanzer_Roll3() { return _composeHyperPanzerRoll(0); }



// ── ORCHESTRA (48x48 UHD NATIVE RELAUNCH) ────────────────────────
// Heavy 8x8 Tactical Missile Artillery Transporter (BM-30 Smerch / Uragan Class)
// Artwork reference: assets/cards/1_orchestra.png
// Camouflage: Military Olive Drab / Khaki with dark steel chassis, ruby & emerald roof optics, and loaded 300mm warheads

function _paintHD_Orchestra_Chassis(grid, roll = 0) {
  // ── PALETTE ────────────────────────────────────────────────────────────
  const OLIVE_TOP  = '#97aa77'; // Sunlit horizontal top planes (roof, hood, bed rail)
  const OLIVE_HI   = '#829762'; // Upper highlight on camo panels
  const OLIVE_MID  = '#53623f'; // Primary military olive drab
  const OLIVE_LGT  = '#64754d'; // Soft sunlit olive / chamfer
  const OLIVE_SHD  = '#3e4b2d'; // Shadowed olive
  const OLIVE_DEEP = '#242c19'; // Crevices / panel seams / deep shadow
  const KHAKI_ACC  = '#8c8266'; // Camo khaki patch
  const KHAKI_MID  = '#776e55';

  const STEEL_DD   = '#090d16'; // Deepest shadow / frame underbelly
  const STEEL_D    = '#1e293b'; // Heavy structural frame
  const STEEL_M    = '#334155'; // Armor plate edge / bracket
  const STEEL_L    = '#475569'; // Mid steel / collar
  const STEEL_HI   = '#64748b'; // Highlighted steel
  const STEEL_CAP  = '#94a3b8'; // Bolts / polished metal
  const STEEL_W    = '#cbd5e1'; // Chrome / specular glint

  const TIRE_BLACK = '#05080f'; // Rubber outer perimeter
  const TIRE_TREAD = '#111827'; // Heavy rubber block
  const TIRE_WALL  = '#1e293b'; // Sidewall rim bevel
  const TIRE_FAR   = '#0a0f18'; // Far-side tire in deep shadow
  const TIRE_FAR_T = '#162030'; // Far-side tire tread pattern
  const TIRE_FAR_H = '#27364e'; // Far-side rim hub highlight

  const GLASS_CORE = '#00f0ff';
  const GLASS_MID  = '#0284c7';
  const GLASS_HI   = '#38bdf8';
  const GLASS_W    = '#e0f2fe';

  const RUBY_CORE  = '#ef4444';
  const RUBY_HI    = '#fca5a5';
  const RUBY_DEEP  = '#991b1b';

  const EMERALD_CORE = '#10b981';
  const EMERALD_HI   = '#6ee7b7';
  const EMERALD_DEEP = '#065f46';

  const HEADLIGHT_HI = '#fef08a';
  const HEADLIGHT_M  = '#facc15';
  const SIGNAL_AMBER = '#f97316';

  const TEAM = 'TEAM';

  // Wheel Centers
  const wheelCentersNear = [6, 16, 30, 40];
  const cyNear = 41;

  // Far-side wheels in 2.5D perspective:
  // Shifted UP by 3px (cyFar = 38 vs 41) and REARWARD by 2px (dx = -2)
  const wheelCentersFar = [4, 14, 28, 38];
  const cyFar = 38;

  const rPhase = ((roll % 6) + 6) % 6; // 0..5
  const baseAngle = -Math.PI / 2 + rPhase * (Math.PI / 3); // 12 -> 2 -> 4 -> 6 -> 8 -> 10 o'clock

  // =========================================================================
  // 1. SOLID UNDERCARRIAGE BACKGROUND, 3D AXLES & FAR-SIDE WHEELS
  // =========================================================================

  // 1A. Heavy Undercarriage Skid Plate & Frame Belly (x: 2..44, y: 34..42)
  for (let y = 34; y <= 42; y++) {
    for (let x = 2; x <= 44; x++) {
      grid[y][x] = STEEL_DD;
    }
  }

  // 1B. Longitudinal Heavy Chassis Rail Beams (y: 35..37)
  for (let x = 3; x <= 43; x++) {
    grid[35][x] = STEEL_DD;
    grid[36][x] = STEEL_D;
    grid[37][x] = STEEL_M;
  }

  // 1C. Far-side 4 Heavy Off-Road Wheels with synchronized rotating tread (cyFar = 38, radius ~4.0px, ground contact at y: 42)
  wheelCentersFar.forEach((cx) => {
    for (let dy = -4; dy <= 4; dy++) {
      for (let dx = -4; dx <= 4; dx++) {
        const distSq = dx * dx + dy * dy;
        const py = cyFar + dy;
        const px = cx + dx;
        if (distSq > 16.5) continue;
        if (px >= 0 && px < 48 && py >= 0 && py < 48) {
          const theta = Math.atan2(dy, dx);
          const relAngle = ((theta - baseAngle) % (2 * Math.PI) + (2 * Math.PI)) % (2 * Math.PI);
          const sectorAngle = relAngle % (Math.PI / 3);

          if (distSq >= 11.5) {
            grid[py][px] = (sectorAngle < Math.PI / 6) ? TIRE_FAR_T : TIRE_BLACK;
          } else if (distSq >= 5.5) {
            grid[py][px] = (sectorAngle < Math.PI / 6) ? TIRE_FAR_T : TIRE_FAR;
          } else {
            grid[py][px] = STEEL_D;
          }
        }
      }
    }
    // Far-side rotating hub
    const hubDist = 1.6;
    const hx = Math.round(cx + Math.cos(baseAngle) * hubDist);
    const hy = Math.round(cyFar + Math.sin(baseAngle) * hubDist);
    if (hx >= 0 && hx < 48 && hy >= 0 && hy < 48) grid[hy][hx] = TIRE_FAR_H;
  });

  // 1D. Diagonal 2.5D Axle Beams connecting Far Wheel Hubs to Near Wheel Hubs
  // Angled from (cxFar, 38) down-right to (cxNear, 41)
  wheelCentersNear.forEach((cxNear, idx) => {
    const cxFar = wheelCentersFar[idx];
    // Diagonal axle tube
    grid[38][cxFar + 1] = STEEL_D;
    grid[39][cxFar + 1] = STEEL_M;
    grid[39][cxNear - 1] = STEEL_M;
    grid[40][cxNear - 1] = STEEL_L;
    // Massive central differential pumpkin casing
    grid[38][cxFar + 2] = STEEL_M;
    grid[39][cxFar + 2] = STEEL_HI;
    grid[40][cxFar + 2] = STEEL_D;
  });

  // Rear Heavy Mudflap behind rearmost wheel (x: 0..2, y: 34..43)
  for (let y = 34; y <= 43; y++) {
    grid[y][0] = TIRE_BLACK;
    grid[y][1] = (y % 2 === 0) ? TIRE_TREAD : TIRE_BLACK;
    grid[y][2] = (y % 3 === 0) ? STEEL_M : STEEL_D;
  }

  // Front splash guard & cab access stirrup (x: 44..45, y: 35..41)
  for (let y = 35; y <= 41; y++) {
    grid[y][45] = TIRE_BLACK;
    grid[y][44] = (y % 2 === 0) ? STEEL_M : STEEL_D;
  }

  // =========================================================================
  // 2. MID-SECTION STOWAGE BAY & 3D HYDRAULIC OUTRIGGER JACK (x: 21..25)
  // =========================================================================
  // Volumetric stowage compartment: visible top bevel, recessed door, and heavy jack
  for (let y = 32; y <= 41; y++) {
    for (let x = 21; x <= 25; x++) {
      grid[y][x] = OLIVE_SHD;
    }
  }
  // 2.5D sunlit top lid
  grid[31][21] = OLIVE_MID; grid[31][22] = OLIVE_HI; grid[31][23] = OLIVE_TOP; grid[31][24] = OLIVE_HI; grid[31][25] = OLIVE_MID;
  grid[32][21] = OLIVE_HI;  grid[32][22] = OLIVE_TOP;grid[32][23] = OLIVE_TOP; grid[32][24] = OLIVE_HI; grid[32][25] = OLIVE_LGT;
  // Khaki camo patch
  grid[33][21] = KHAKI_MID; grid[33][22] = KHAKI_ACC; grid[33][23] = KHAKI_ACC;
  grid[34][21] = KHAKI_MID; grid[34][22] = KHAKI_ACC;
  // Recessed door seam & latches
  grid[35][21] = OLIVE_DEEP; grid[36][21] = OLIVE_DEEP;
  grid[35][25] = OLIVE_DEEP; grid[36][25] = OLIVE_DEEP;
  grid[35][22] = STEEL_CAP;  grid[35][24] = STEEL_CAP;
  // Lower skid rail
  grid[41][21] = STEEL_D; grid[41][22] = STEEL_M; grid[41][23] = STEEL_M; grid[41][24] = STEEL_M; grid[41][25] = STEEL_D;

  // Integrated Chrome Hydraulic Outrigger Stabilizer Jack
  for (let y = 35; y <= 40; y++) {
    grid[y][23] = (y % 2 === 0) ? STEEL_W : STEEL_CAP;
  }
  grid[36][22] = STEEL_D; grid[36][24] = STEEL_D;
  grid[38][22] = STEEL_D; grid[38][24] = STEEL_D;
  // Outrigger Jack Base Footpad (Ground anchor at y: 42..45)
  grid[42][22] = STEEL_M; grid[42][23] = STEEL_HI; grid[42][24] = STEEL_M;
  grid[43][21] = STEEL_D; grid[43][22] = STEEL_HI; grid[43][23] = STEEL_CAP; grid[43][24] = STEEL_HI; grid[43][25] = STEEL_D;
  grid[44][21] = STEEL_DD;grid[44][22] = STEEL_D;  grid[44][23] = STEEL_M;   grid[44][24] = STEEL_D;  grid[44][25] = STEEL_DD;
  grid[45][21] = TIRE_BLACK; grid[45][22] = STEEL_DD; grid[45][23] = STEEL_D; grid[45][24] = STEEL_DD; grid[45][25] = TIRE_BLACK;

  // =========================================================================
  // 3. 2.5D FLATBED DECK: FAR COAMING, BED FLOOR & NEAR ARMOR SKIRT (x: 2..24)
  // True spatial depth: Far Wall -> Recessed Deck Floor -> Near Armor Wall
  // =========================================================================

  // 3A. Hintere Bordwand / Far Coaming (y: 25..27, x: 2..22) - seen in background!
  for (let x = 3; x <= 22; x++) {
    grid[25][x] = (x % 2 === 0) ? OLIVE_LGT : OLIVE_MID; // Far top edge
    grid[26][x] = OLIVE_SHD;                              // Far inner face in shadow
    grid[27][x] = OLIVE_DEEP;                             // Far floor junction crevice
  }
  // Camo accents on far wall
  grid[25][5] = KHAKI_ACC; grid[25][6] = KHAKI_ACC;
  grid[25][15] = KHAKI_ACC; grid[25][16] = KHAKI_ACC;

  // 3B. Ladeflächen-Boden & Riffelblech (y: 28..29, x: 2..24)
  for (let x = 2; x <= 24; x++) {
    grid[28][x] = (x % 3 === 0) ? STEEL_DD : STEEL_D;    // Floor shadow & tie-down channels
    grid[29][x] = (x % 2 === 0) ? STEEL_HI : STEEL_L;    // Checkerplate anti-skid floor
  }

  // 3C. Turntable Pivot Base (Centered at exact x: 8.5, y: 27.5 -> MUST PRESERVE!)
  // Circular 2.5D mounting ring sitting in the flatbed floor
  grid[26][7] = STEEL_DD; grid[26][8] = STEEL_HI;  grid[26][9] = STEEL_W;   grid[26][10] = STEEL_DD;
  grid[27][6] = STEEL_DD; grid[27][7] = STEEL_M;   grid[27][8] = STEEL_W;   grid[27][9] = STEEL_W;   grid[27][10] = STEEL_M;   grid[27][11] = STEEL_DD;
  grid[28][6] = STEEL_D;  grid[28][7] = STEEL_HI;  grid[28][8] = STEEL_CAP; grid[28][9] = STEEL_CAP; grid[28][10] = STEEL_HI; grid[28][11] = STEEL_D;
  grid[29][7] = STEEL_DD; grid[29][8] = STEEL_D;   grid[29][9] = STEEL_D;   grid[29][10] = STEEL_DD;

  // Forward launcher travel cradle rest (x: 18..22, y: 27..29)
  grid[27][18] = STEEL_DD; grid[27][19] = STEEL_HI; grid[27][20] = STEEL_W;  grid[27][21] = STEEL_DD;
  grid[28][18] = STEEL_D;  grid[28][19] = TIRE_WALL; grid[28][20] = TIRE_WALL; grid[28][21] = STEEL_D;

  // 3D. Vordere Bordwand & Ausgestellte Seitenschürze (y: 30..34, x: 1..24)
  // Near coaming top edge with bright sunlit shelf
  for (let x = 2; x <= 23; x++) {
    grid[30][x] = (x % 2 === 0) ? OLIVE_TOP : OLIVE_HI;
    grid[31][x] = OLIVE_MID;
    grid[32][x] = OLIVE_SHD;
    grid[33][x] = OLIVE_DEEP;
    grid[34][x] = STEEL_DD;
  }
  // Khaki camo spots on near side plate
  grid[30][12] = KHAKI_ACC; grid[31][12] = KHAKI_ACC; grid[31][13] = KHAKI_MID;
  grid[30][18] = KHAKI_ACC; grid[31][18] = KHAKI_MID;
  // Tool locker hinges & latches on near flank
  grid[31][4] = STEEL_CAP;  grid[31][10] = STEEL_CAP; grid[31][16] = STEEL_CAP;

  // =========================================================================
  // 4. LOWER CHASSIS FRAME & FLARED 2.5D WHEEL ARCHES (KOTFLÜGEL)
  // =========================================================================
  // Flares over near wheels: prominent 3D overhang that casts shadow over tire
  wheelCentersNear.forEach((cx) => {
    // Arch apex with 2.5D highlight shelf
    grid[31][cx] = (cx <= 20) ? OLIVE_TOP : STEEL_W;
    grid[32][cx] = (cx <= 20) ? OLIVE_HI  : STEEL_HI;
    grid[33][cx] = (cx <= 20) ? OLIVE_MID : STEEL_M;
    // Arch shoulders
    if (cx - 3 >= 0) {
      grid[32][cx - 3] = (cx <= 20) ? OLIVE_TOP : STEEL_HI;
      grid[33][cx - 3] = (cx <= 20) ? OLIVE_HI  : STEEL_M;
      grid[34][cx - 3] = STEEL_D;
      grid[35][cx - 3] = STEEL_DD;
    }
    if (cx - 4 >= 0) {
      grid[33][cx - 4] = STEEL_M;
      grid[34][cx - 4] = STEEL_D;
      grid[35][cx - 4] = STEEL_DD;
    }
    if (cx + 3 < 48) {
      grid[32][cx + 3] = (cx <= 20) ? OLIVE_TOP : STEEL_HI;
      grid[33][cx + 3] = (cx <= 20) ? OLIVE_HI  : STEEL_M;
      grid[34][cx + 3] = STEEL_D;
      grid[35][cx + 3] = STEEL_DD;
    }
    if (cx + 4 < 48) {
      grid[33][cx + 4] = STEEL_M;
      grid[34][cx + 4] = STEEL_D;
      grid[35][cx + 4] = STEEL_DD;
    }
    // Deep inner wheel arch shadow
    for (let dx = -3; dx <= 3; dx++) {
      grid[36][cx + dx] = TIRE_BLACK;
    }
  });

  // Rear towing shackles & rear bumper (-X: x: 0..2)
  grid[32][0] = STEEL_M;  grid[33][0] = STEEL_HI; grid[34][0] = STEEL_DD; grid[35][0] = STEEL_DD;
  grid[32][1] = STEEL_HI; grid[33][1] = STEEL_W;  grid[34][1] = STEEL_M;  grid[35][1] = STEEL_D;
  grid[33][2] = STEEL_CAP;

  // Front heavy 3D bumper & winch (+X: x: 44..47, y: 32..36)
  for (let y = 32; y <= 35; y++) {
    grid[y][45] = STEEL_HI;
    grid[y][46] = STEEL_M;
    grid[y][47] = STEEL_D; // Front wrap-around edge!
  }
  grid[36][45] = STEEL_D;  grid[36][46] = STEEL_DD; grid[36][47] = STEEL_DD;
  grid[32][44] = STEEL_W;  grid[32][45] = STEEL_W;  grid[32][46] = STEEL_HI;
  grid[33][44] = STEEL_W;  grid[33][45] = STEEL_CAP;grid[34][44] = STEEL_W;

  // =========================================================================
  // 5. 4 MASSIVE FOREGROUND HEAVY OFF-ROAD WHEELS WITH DEEP-DISH RIM & 2.5D CAMBER
  // cyNear = 41, radius ~4.2px, ground contact at y: 45
  // =========================================================================
  wheelCentersNear.forEach((cx) => {
    for (let dy = -4; dy <= 4; dy++) {
      for (let dx = -4; dx <= 4; dx++) {
        const distSq = dx * dx + dy * dy;
        const py = cyNear + dy;
        const px = cx + dx;
        if (distSq > 17.5) continue;

        const theta = Math.atan2(dy, dx);
        const relAngle = ((theta - baseAngle) % (2 * Math.PI) + (2 * Math.PI)) % (2 * Math.PI);
        const sectorAngle = relAngle % (Math.PI / 3);

        // A. Outer Tread Perimeter (distSq >= 12.0) - ROTATING LUGS & GROOVES!
        if (distSq >= 12.0) {
          const isLug = (sectorAngle < Math.PI / 6);
          const isMarkerCleat = (relAngle < Math.PI / 3); // Traveling mud/chalk marker!
          const isOpposingCleat = (relAngle >= Math.PI && relAngle < 4 * Math.PI / 3);

          if (isMarkerCleat) {
            // High-contrast dried mud/chalk mark traveling on rubber perimeter!
            grid[py][px] = (distSq >= 14.0) ? '#cbd5e1' : '#94a3b8';
          } else if (isOpposingCleat) {
            grid[py][px] = (distSq >= 14.0) ? '#8c8266' : '#53623f';
          } else if (isLug) {
            // Heavy rubber tread block
            grid[py][px] = (dy <= -1) ? '#2e3d54' : ((dy >= 2) ? TIRE_TREAD : TIRE_WALL);
          } else {
            // Deep tread groove between lugs
            grid[py][px] = TIRE_BLACK;
          }
        }
        // B. Inner Tire Sidewall & Deep-Dish Rim Flange (5.5 <= distSq < 12.0)
        else if (distSq >= 5.5) {
          const isSpoke = (sectorAngle < Math.PI / 6);
          if (distSq >= 9.0) {
            // Sidewall bevel ring
            grid[py][px] = (dy <= -2) ? TIRE_WALL : TIRE_TREAD;
          } else {
            // Rotating deep-dish rim windows & spokes!
            if (isSpoke) {
              grid[py][px] = (dy < 0) ? STEEL_HI : STEEL_M;
            } else {
              grid[py][px] = STEEL_DD; // Dark recessed ventilation window!
            }
          }
        }
        // C. Central Planetary Gear Hub (distSq < 5.5)
        else {
          grid[py][px] = (distSq <= 1.5) ? STEEL_W : STEEL_M;
        }
      }
    }

    // Rotating Studs around center hub
    for (let k = 0; k < 6; k++) {
      const boltAng = baseAngle + k * (Math.PI / 3);
      const bx = Math.round(cx + Math.cos(boltAng) * 2.0);
      const by = Math.round(cyNear + Math.sin(boltAng) * 2.0);
      if (bx >= 0 && bx < 48 && by >= 0 && by < 48) {
        grid[by][bx] = (k === 0) ? STEEL_W : (k === 3 ? STEEL_CAP : STEEL_HI);
      }
    }
  });

  // =========================================================================
  // 6. MIDDLE SUPPORT / EQUIPMENT COMPARTMENT (x: 23..33, y: 24..32)
  // =========================================================================
  for (let x = 23; x <= 33; x++) {
    grid[24][x] = OLIVE_TOP;
    grid[25][x] = OLIVE_HI;
  }
  for (let y = 26; y <= 32; y++) {
    for (let x = 23; x <= 33; x++) {
      grid[y][x] = OLIVE_MID;
    }
  }
  grid[26][25] = KHAKI_ACC; grid[26][26] = KHAKI_ACC;
  grid[27][25] = KHAKI_MID;
  grid[26][28] = OLIVE_DEEP; grid[27][28] = OLIVE_DEEP; grid[28][28] = OLIVE_DEEP;
  grid[26][32] = OLIVE_DEEP; grid[27][32] = OLIVE_DEEP; grid[28][32] = OLIVE_DEEP;
  grid[27][31] = STEEL_W;

  // =========================================================================
  // 7. FORWARD ARMORED DRIVER & CREW CAB WITH DEEP 2.5D VOLUMETRY (x: 34..47, y: 17..35)
  // Slanted Roof, Dual-Pane Windshield, 3D Engine Hood, and Wrap-around Nose
  // =========================================================================

  // 7A. 2.5D Slanted Cab Roof (x: 34..44, y: 17..21)
  // Far roof edge (Row 17..18) receding in perspective
  for (let x = 35; x <= 42; x++) {
    grid[17][x] = (x % 2 === 0) ? OLIVE_SHD : OLIVE_MID;
    grid[18][x] = OLIVE_LGT;
  }
  // Sunlit top roof deck plate (Row 19)
  for (let x = 34; x <= 43; x++) {
    grid[19][x] = OLIVE_TOP;
  }
  // Circular escape hatch on roof ($x: 35..37, y: 18..19$)
  grid[18][36] = STEEL_L;
  grid[19][35] = STEEL_L; grid[19][36] = STEEL_CAP; grid[19][37] = STEEL_L;
  // Khaki camo patch on roof
  grid[19][39] = KHAKI_ACC; grid[19][40] = KHAKI_ACC;

  // Sunlit roof brow overhang / visor (Row 20)
  for (let x = 34; x <= 43; x++) {
    grid[20][x] = OLIVE_HI;
  }
  grid[20][43] = STEEL_W; // Specular corner glint
  grid[20][44] = STEEL_HI;

  // Visor under-shadow casting over windshield (Row 21)
  for (let x = 37; x <= 44; x++) {
    grid[21][x] = OLIVE_DEEP;
  }

  // 7B. 2.5D Dual-Pane Ballistic Windshield (x: 37..44, y: 22..25)
  // Far pane (left: x: 37..40) - deeper perspective blue
  for (let y = 22; y <= 25; y++) {
    for (let x = 37; x <= 40; x++) {
      grid[y][x] = GLASS_MID;
    }
  }
  grid[22][38] = GLASS_HI;   grid[22][39] = GLASS_HI;
  grid[23][38] = GLASS_CORE; grid[23][39] = GLASS_HI;
  grid[24][38] = GLASS_MID;  grid[24][39] = GLASS_CORE;

  // Angled center mullion / A-pillar (x: 41)
  grid[22][41] = STEEL_D; grid[23][41] = STEEL_M; grid[24][41] = STEEL_D; grid[25][41] = STEEL_DD;

  // Near pane (right: x: 42..44) - bright forward reflection & corner wrap
  for (let y = 22; y <= 25; y++) {
    for (let x = 42; x <= 44; x++) {
      grid[y][x] = GLASS_CORE;
    }
  }
  grid[22][42] = GLASS_W;    grid[22][43] = GLASS_HI;   grid[22][44] = GLASS_MID;
  grid[23][42] = GLASS_W;    grid[23][43] = GLASS_CORE; grid[23][44] = GLASS_CORE;
  grid[24][42] = GLASS_HI;   grid[24][43] = GLASS_CORE; grid[24][44] = GLASS_MID;
  grid[25][42] = GLASS_CORE; grid[25][43] = GLASS_HI;   grid[25][44] = STEEL_D;

  // Window sill & dash cowl (Row 26)
  for (let x = 37; x <= 44; x++) grid[26][x] = STEEL_D;

  // 7C. Cab side door & Side Window (x: 34..38, y: 22..30)
  for (let y = 22; y <= 30; y++) {
    grid[y][34] = OLIVE_DEEP; // Door jamb
  }
  // Side driver door window slit
  grid[23][35] = GLASS_MID; grid[23][36] = GLASS_CORE; grid[23][37] = STEEL_D;
  grid[24][35] = GLASS_CORE;grid[24][36] = GLASS_MID;  grid[24][37] = STEEL_D;

  for (let y = 25; y <= 30; y++) {
    for (let x = 35; x <= 38; x++) {
      grid[y][x] = OLIVE_MID;
    }
  }
  // TEAM insignia
  grid[27][35] = TEAM; grid[27][36] = TEAM; grid[27][37] = TEAM;
  grid[28][35] = TEAM; grid[28][36] = TEAM; grid[28][37] = TEAM;
  // Chrome door latch handle
  grid[28][38] = STEEL_W;
  // Side entry foot-stirrups
  grid[31][35] = STEEL_M;  grid[31][36] = STEEL_M;
  grid[32][35] = STEEL_HI; grid[32][36] = STEEL_HI;

  // 7D. 3D Sloped Engine Hood & Nose (x: 41..47, y: 25..31)
  // Top horizontal hood surface (Row 25..26)
  grid[25][42] = OLIVE_TOP; grid[25][43] = OLIVE_TOP; grid[25][44] = OLIVE_HI; grid[25][45] = OLIVE_LGT;
  grid[26][41] = OLIVE_TOP; grid[26][42] = OLIVE_TOP; grid[26][43] = OLIVE_HI; grid[26][44] = OLIVE_HI; grid[26][45] = OLIVE_LGT;
  // Sloped hood chamfer line (Row 27)
  grid[27][41] = OLIVE_HI; grid[27][42] = KHAKI_ACC; grid[27][43] = KHAKI_MID; grid[27][44] = OLIVE_LGT; grid[27][45] = OLIVE_MID;
  // Side hood flank (Rows 28..31)
  for (let y = 28; y <= 31; y++) {
    for (let x = 41; x <= 44; x++) {
      grid[y][x] = OLIVE_MID;
    }
  }

  // Front Radiator Grille with 3D Corner Wrap (x: 45..47, y: 28..31)
  // Column 45: near side wrap
  // Column 46: corner highlight
  // Column 47: front face
  grid[28][45] = STEEL_DD; grid[28][46] = STEEL_D;  grid[28][47] = STEEL_DD;
  grid[29][45] = STEEL_M;  grid[29][46] = STEEL_W;  grid[29][47] = STEEL_M;
  grid[30][45] = STEEL_DD; grid[30][46] = STEEL_D;  grid[30][47] = STEEL_DD;
  grid[31][45] = STEEL_M;  grid[31][46] = STEEL_HI; grid[31][47] = STEEL_M;

  // Dual Headlights & Amber Turn Signal (x: 44..46, y: 31..33)
  grid[31][44] = HEADLIGHT_HI; grid[31][45] = HEADLIGHT_M;  grid[31][46] = HEADLIGHT_HI;
  grid[32][44] = HEADLIGHT_M;  grid[32][45] = SIGNAL_AMBER;grid[32][46] = SIGNAL_AMBER;

  // Side-view mirror on tall tubular bracket at (44, 19..22)
  grid[19][44] = STEEL_HI;
  grid[20][44] = GLASS_HI;
  grid[21][44] = STEEL_M;
  grid[22][44] = STEEL_D;

  // 7E. Roof Optronic Sensor Turret (FLIR) Directly Above Driver Side (x: 38..43, y: 13..18)
  // Volumetric turret casing with sunlit top plate
  grid[13][40] = OLIVE_TOP; grid[13][41] = OLIVE_TOP; grid[13][42] = OLIVE_HI;
  for (let y = 14; y <= 18; y++) {
    for (let x = 39; x <= 43; x++) {
      grid[y][x] = (y === 14) ? OLIVE_HI : OLIVE_MID;
    }
  }
  grid[18][40] = STEEL_D; grid[18][41] = STEEL_M; grid[18][42] = STEEL_D;

  // Primary Ruby / Crimson Infrared Optic (x: 39..41, y: 15..17)
  grid[15][39] = STEEL_DD; grid[15][40] = RUBY_HI;   grid[15][41] = STEEL_DD;
  grid[16][39] = RUBY_HI;   grid[16][40] = RUBY_CORE; grid[16][41] = RUBY_DEEP;
  grid[17][39] = STEEL_DD; grid[17][40] = RUBY_DEEP; grid[17][41] = STEEL_DD;

  // Secondary Emerald / Green Optical Sensor (x: 42..43, y: 15..16)
  grid[15][42] = EMERALD_HI;   grid[15][43] = EMERALD_CORE;
  grid[16][42] = EMERALD_CORE; grid[16][43] = EMERALD_DEEP;
  grid[17][42] = STEEL_DD;

  // Spotter dial gauge at (38, 17..18)
  grid[17][38] = STEEL_W;
  grid[18][38] = STEEL_CAP;

  // Whip Antenna rooted at (37, 13) and arching backward
  grid[13][37] = STEEL_D;
  grid[12][37] = STEEL_HI;
  grid[11][36] = STEEL_CAP;
  grid[10][35] = STEEL_CAP;
  grid[9][34]  = STEEL_W;
  grid[9][33]  = STEEL_CAP;

  return grid;
}

function _paintHD_Orchestra_Launcher(grid) {
  const OLIVE_TOP  = '#9ba885'; // Sunlit cylindrical crest highlight
  const OLIVE_HI   = '#829762';
  const OLIVE_MID  = '#53623f';
  const OLIVE_LGT  = '#64754d';
  const OLIVE_SHD  = '#3e4b2d';
  const OLIVE_DEEP = '#242c19';
  const KHAKI_ACC  = '#8c8266';

  const STEEL_DD   = '#090d16';
  const STEEL_D    = '#1e293b';
  const STEEL_M    = '#334155';
  const STEEL_L    = '#475569';
  const STEEL_HI   = '#64748b';
  const STEEL_CAP  = '#94a3b8';
  const STEEL_W    = '#cbd5e1';

  const WARHEAD_RED  = '#dc2626';
  const WARHEAD_HI   = '#ef4444';
  const WARHEAD_SHD  = '#991b1b';
  const WARHEAD_TIP  = '#ffffff';

  const TEAM = 'TEAM';

  // 1. Turntable Pivot Hinge & Hydraulic Ram (Center preserved at exact x: 8.5, y: 27.5!)
  grid[26][7] = STEEL_DD; grid[26][8] = STEEL_HI;  grid[26][9] = STEEL_W;   grid[26][10] = STEEL_DD;
  grid[27][6] = STEEL_DD; grid[27][7] = STEEL_M;   grid[27][8] = STEEL_W;   grid[27][9] = STEEL_W;   grid[27][10] = STEEL_M;   grid[27][11] = STEEL_DD;
  grid[28][7] = STEEL_D;  grid[28][8] = STEEL_HI;  grid[28][9] = STEEL_HI;  grid[28][10] = STEEL_D;

  // Telescopic Hydraulic Actuator Cylinder (x: 17..21, y: 25..29)
  grid[25][18] = STEEL_W;   grid[25][19] = STEEL_CAP; grid[25][20] = STEEL_HI;
  grid[26][18] = STEEL_CAP; grid[26][19] = STEEL_W;   grid[26][20] = STEEL_L;
  grid[27][19] = STEEL_L;   grid[27][20] = STEEL_M;
  grid[28][19] = STEEL_M;   grid[28][20] = STEEL_D;

  // =========================================================================
  // 2. HEAVY MULTI-TUBE ROCKET ORGAN (2.5D Volumetric Cylindrical Banks: x: 4..27, y: 12..24)
  // =========================================================================

  // ── A. UPPER TUBE BANK (y: 12..17) with cylindrical crown shading ────────
  // Dorsal curve of far tubes peeking out (Row 12)
  for (let x = 6; x <= 27; x++) {
    grid[12][x] = (x % 3 === 0) ? OLIVE_LGT : OLIVE_SHD;
  }
  // Sunlit crest line (Row 13)
  for (let x = 5; x <= 27; x++) {
    grid[13][x] = (x % 2 === 0) ? OLIVE_TOP : '#7e8f66';
  }
  // Upper belly curvature (Rows 14..16)
  for (let x = 5; x <= 27; x++) {
    grid[14][x] = OLIVE_HI;
    grid[15][x] = OLIVE_MID;
    grid[16][x] = OLIVE_MID;
    grid[17][x] = OLIVE_SHD;
  }
  // Camo accents on upper bank
  grid[14][10] = KHAKI_ACC; grid[15][10] = KHAKI_ACC; grid[15][11] = KHAKI_ACC;
  grid[14][21] = KHAKI_ACC; grid[15][21] = KHAKI_ACC;

  // ── B. CENTRAL LONGITUDINAL RECESS SEAM & GUIDE RAIL (Row 18) ─────────────
  for (let x = 4; x <= 27; x++) {
    grid[18][x] = OLIVE_DEEP;
  }
  for (let x = 8; x <= 24; x += 3) {
    grid[18][x] = STEEL_M;
  }

  // ── C. LOWER TUBE BANK (y: 19..24) with cylindrical curvature ───────────
  for (let x = 5; x <= 27; x++) {
    grid[19][x] = OLIVE_HI;
    grid[20][x] = (x >= 9 && x <= 24) ? TEAM : OLIVE_MID;
    grid[21][x] = (x >= 9 && x <= 24) ? TEAM : OLIVE_SHD;
    grid[22][x] = OLIVE_SHD;
    grid[23][x] = OLIVE_DEEP;
    grid[24][x] = STEEL_DD;
  }

  // ── D. CURVED STRUCTURAL CLAMP COLLARS (x: 6..8, x: 16..18, x: 25..27) ──
  // Curved over the cylindrical tubes with bright 2.5D specular highlights
  const collarX = [6, 16, 25];
  collarX.forEach((cx) => {
    // Top arch curving over upper tube (Row 12)
    grid[12][cx]     = STEEL_M;
    grid[12][cx + 1] = STEEL_W;
    grid[12][cx + 2] = STEEL_HI;

    for (let y = 13; y <= 24; y++) {
      grid[y][cx]     = STEEL_L;
      grid[y][cx + 1] = STEEL_HI;
      grid[y][cx + 2] = STEEL_M;
    }
    // Specular crown glints
    grid[13][cx + 1] = STEEL_W;
    grid[14][cx + 1] = STEEL_W;
    // Upper tension clamp bolt
    grid[16][cx + 1] = STEEL_CAP;
    // Central hinge knuckle
    grid[18][cx]     = STEEL_CAP;
    grid[18][cx + 1] = STEEL_W;
    grid[18][cx + 2] = STEEL_CAP;
    // Lower tension clamp bolt
    grid[21][cx + 1] = STEEL_CAP;
    // Bottom cradle mount
    grid[24][cx + 1] = STEEL_CAP;
  });

  // =========================================================================
  // 3. FRONT TUBE MUZZLES & LOADED 300mm WARHEADS (x: 28..34)
  // Staggered in 2.5D depth: Near and Far tube muzzles & conical warheads
  // =========================================================================

  // ── UPPER TIER: Staggered Far & Near Muzzle Rings (y: 12..17, x: 28..30) ──
  // Far upper tube muzzle (y: 12..14, x: 28..29)
  grid[12][28] = STEEL_L;  grid[12][29] = STEEL_W;
  grid[13][28] = STEEL_DD; grid[13][29] = STEEL_DD;
  // Near upper tube muzzle (y: 14..17, x: 28..30)
  for (let y = 14; y <= 17; y++) {
    grid[y][28] = STEEL_D;
    grid[y][29] = STEEL_L;
  }
  grid[14][29] = STEEL_W;
  grid[15][29] = STEEL_DD; grid[16][29] = STEEL_DD; grid[17][29] = STEEL_DD;

  // Staggered Far Upper Warhead tip (x: 30..32, y: 12..14)
  grid[12][30] = WARHEAD_HI; grid[12][31] = WARHEAD_RED;
  grid[13][30] = WARHEAD_RED; grid[13][31] = WARHEAD_SHD; grid[13][32] = WARHEAD_TIP;

  // Near Upper 300mm Warhead (x: 30..34, y: 14..17)
  grid[14][30] = STEEL_W;   grid[15][30] = STEEL_W;   grid[16][30] = STEEL_CAP;
  grid[14][31] = WARHEAD_HI; grid[15][31] = WARHEAD_HI;  grid[16][31] = WARHEAD_RED;
  grid[14][32] = WARHEAD_HI; grid[15][32] = WARHEAD_RED; grid[16][32] = WARHEAD_SHD;
  grid[15][33] = WARHEAD_RED; grid[16][33] = WARHEAD_SHD;
  grid[15][34] = WARHEAD_TIP; // Aerodynamic nose fuze point

  // ── LOWER TIER: Staggered Far & Near Muzzle Rings (y: 18..23, x: 28..30) ──
  // Far lower tube muzzle (y: 18..20, x: 28..29)
  grid[18][28] = STEEL_L;  grid[18][29] = STEEL_W;
  grid[19][28] = STEEL_DD; grid[19][29] = STEEL_DD;
  // Near lower tube muzzle (y: 20..23, x: 28..30)
  for (let y = 20; y <= 23; y++) {
    grid[y][28] = STEEL_D;
    grid[y][29] = STEEL_L;
  }
  grid[20][29] = STEEL_W;
  grid[21][29] = STEEL_DD; grid[22][29] = STEEL_DD; grid[23][29] = STEEL_DD;

  // Staggered Far Lower Warhead tip (x: 30..32, y: 18..20)
  grid[18][30] = WARHEAD_HI; grid[18][31] = WARHEAD_RED;
  grid[19][30] = WARHEAD_RED; grid[19][31] = WARHEAD_SHD; grid[19][32] = WARHEAD_TIP;

  // Near Lower 300mm Warhead (x: 30..34, y: 20..23)
  grid[20][30] = STEEL_W;   grid[21][30] = STEEL_W;   grid[22][30] = STEEL_CAP;
  grid[20][31] = WARHEAD_HI; grid[21][31] = WARHEAD_HI;  grid[22][31] = WARHEAD_RED;
  grid[20][32] = WARHEAD_HI; grid[21][32] = WARHEAD_RED; grid[22][32] = WARHEAD_SHD;
  grid[21][33] = WARHEAD_RED; grid[22][33] = WARHEAD_SHD;
  grid[21][34] = WARHEAD_TIP;

  // =========================================================================
  // 4. REAR ROCKET EXHAUST VENTURI NOZZLES (-X: x: 2..5, y: 12..24)
  // Volumetric titanium nozzle bells with rocket propellent burn patina
  // =========================================================================
  grid[12][4] = STEEL_M;  grid[12][3] = STEEL_D;
  grid[13][4] = STEEL_L;  grid[13][3] = STEEL_M;  grid[13][2] = STEEL_D;
  grid[14][5] = STEEL_M;  grid[14][4] = STEEL_DD; grid[14][3] = STEEL_DD; grid[14][2] = '#b45309';
  grid[15][5] = STEEL_M;  grid[15][4] = STEEL_DD; grid[15][3] = STEEL_DD; grid[15][2] = '#b45309';
  grid[16][5] = STEEL_D;  grid[16][4] = STEEL_DD; grid[16][3] = STEEL_DD; grid[16][2] = '#78350f';
  grid[17][4] = STEEL_D;  grid[17][3] = STEEL_DD; grid[17][2] = STEEL_DD;

  grid[18][4] = STEEL_M;  grid[18][3] = STEEL_D;
  grid[19][4] = STEEL_L;  grid[19][3] = STEEL_M;  grid[19][2] = STEEL_D;
  grid[20][5] = STEEL_M;  grid[20][4] = STEEL_DD; grid[20][3] = STEEL_DD; grid[20][2] = '#b45309';
  grid[21][5] = STEEL_M;  grid[21][4] = STEEL_DD; grid[21][3] = STEEL_DD; grid[21][2] = '#b45309';
  grid[22][5] = STEEL_D;  grid[22][4] = STEEL_DD; grid[22][3] = STEEL_DD; grid[22][2] = '#78350f';
  grid[23][4] = STEEL_D;  grid[23][3] = STEEL_DD; grid[23][2] = STEEL_DD;

  for (let y = 13; y <= 23; y++) {
    if (!grid[y][5]) grid[y][5] = STEEL_D;
  }

  return grid;
}


function getHD_Orchestra_Chassis(roll = 0) {
  const g = 48, grid = makeGrid48();
  _paintHD_Orchestra_Chassis(grid, roll);
  return { gridSize: g, grid };
}

function getHD_Orchestra_Chassis_Roll1() { return getHD_Orchestra_Chassis(0); }
function getHD_Orchestra_Chassis_Roll2() { return getHD_Orchestra_Chassis(1); }
function getHD_Orchestra_Chassis_Roll3() { return getHD_Orchestra_Chassis(2); }
function getHD_Orchestra_Chassis_Roll4() { return getHD_Orchestra_Chassis(3); }
function getHD_Orchestra_Chassis_Roll5() { return getHD_Orchestra_Chassis(4); }
function getHD_Orchestra_Chassis_Roll6() { return getHD_Orchestra_Chassis(5); }

function getHD_Orchestra_Launcher() {
  const g = 48, grid = makeGrid48();
  _paintHD_Orchestra_Launcher(grid);
  return { gridSize: g, grid };
}

function getHD_Orchestra() {
  const g = 48, grid = makeGrid48();
  const c = getHD_Orchestra_Chassis(0).grid;
  const l = getHD_Orchestra_Launcher().grid;

  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (c[y][x]) grid[y][x] = c[y][x];
      if (l[y][x]) grid[y][x] = l[y][x];
    }
  }
  return { gridSize: g, grid };
}

function _composeOrchestraRoll(roll = 0) {
  const g = 48, grid = makeGrid48();
  const c = getHD_Orchestra_Chassis(roll).grid;
  const l = getHD_Orchestra_Launcher().grid;
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (c[y][x]) grid[y][x] = c[y][x];
      if (l[y][x]) grid[y][x] = l[y][x];
    }
  }
  return { gridSize: g, grid };
}
function getHD_Orchestra_Roll1() { return _composeOrchestraRoll(0); }
function getHD_Orchestra_Roll2() { return _composeOrchestraRoll(1); }
function getHD_Orchestra_Roll3() { return _composeOrchestraRoll(2); }
function getHD_Orchestra_Roll4() { return _composeOrchestraRoll(3); }
function getHD_Orchestra_Roll5() { return _composeOrchestraRoll(4); }
function getHD_Orchestra_Roll6() { return _composeOrchestraRoll(5); }
function getHD_Orchestra_Aim() {
  const g = 48, grid = makeGrid48();
  const c = getHD_Orchestra_Chassis(0).grid;
  const l = getHD_Orchestra_Launcher().grid;

  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (c[y][x]) grid[y][x] = c[y][x];
    }
  }

  // Pre-bake elevated rocket launcher (~38 degrees / -0.66 rad around pivot x0: 8.5, y0: 27.5)
  const x0 = 8.5, y0 = 27.5;
  const theta = -0.66;
  const cos = Math.cos(theta);
  const sin = Math.sin(theta);

  for (let ty = 0; ty < g; ty++) {
    for (let tx = 0; tx < g; tx++) {
      const srcX = Math.round(x0 + (tx - x0) * cos + (ty - y0) * sin);
      const srcY = Math.round(y0 - (tx - x0) * sin + (ty - y0) * cos);
      if (srcX >= 0 && srcX < g && srcY >= 0 && srcY < g && l[srcY][srcX]) {
        grid[ty][tx] = l[srcY][srcX];
      }
    }
  }

  return { gridSize: g, grid };
}


// ── THE SALVAGE COMPANY (48×48 UHD ULTRA-GLOBIG & HEAVY-RUST RELAUNCH) ───
// Super-Heavy Industrial Scrap Recovery Crawler with Articulated Hydraulic Crane Arm
// Artwork-accurate (assets/cards/1_thesalvagecompany.png):
// Grungy Dark Rust Patina, Massive 9-10px Excavator Boom, Giant 4-Tine Scrap Grapple,
// Ponderous Slow 6-Phase Wheel Rotation, Zero Sine Hopping (Grounded Heavy Crawl)

// ── COLOR PALETTE: Dark, Grimy, Rust-Encrusted Industrial Diesel-Punk ──
const SALVAGE_R_KRUSTE = '#0a0604'; // Tiefster Rostlochfraß & Spaltenschatten
const SALVAGE_R_TIEFSCH= '#140b05'; // Verkrusteter alter Rost & Ruß
const SALVAGE_R_DUNKEL = '#221008'; // Dunkler Brandrost
const SALVAGE_R_UMBER  = '#33170a'; // Dunkle Rostschattierung
const SALVAGE_R_OXID   = '#47200d'; // Tiefe Rostoxidation
const SALVAGE_R_ROT    = '#602c12'; // Warmer Eisenrost
const SALVAGE_R_STREAK = '#783715'; // Rostablauf-Fahne (Drip streak)
const SALVAGE_R_FLUG   = '#91431a'; // Frischer Flugrost
const SALVAGE_R_KANTE  = '#ab5722'; // Helle Rostabplatzung

// Weathered Dark Grungy Industrial Armor (Dunkel verwittertes, schmutziges Ocker-Blech)
const SALVAGE_P_SCHATT = '#100d0a'; // Blech-Schattenfuge
const SALVAGE_P_FETT   = '#1f1b14'; // Ölige Schmiere / Rußablagerung
const SALVAGE_P_DUNKEL = '#30291f'; // Stark verschmutzte Blechpartie
const SALVAGE_P_BRAUN  = '#42382c'; // Dunkles Ockerbraun (Schattenseite)
const SALVAGE_P_MITTEL = '#564939'; // Hauptton: Schmutziges, verwittertes Ocker
const SALVAGE_P_HELL   = '#6d5d48'; // Beleuchtete Ockerplatte
const SALVAGE_P_KANTE  = '#827057'; // Farbkante / abgewetzte Ecke
const SALVAGE_P_CHIP   = '#998467'; // Stark abgewetzte Lackkante
const SALVAGE_P_WEISS  = '#b39c7b'; // Blanker Abplatzer-Punkt

// Cast Iron, Chassis & Heavy Steel (Gusseisen, Achsen & Pflugstahl)
const SALVAGE_G_SCHWARZ = '#060504'; // Tiefste Kontur
const SALVAGE_G_DUNKEL  = '#100e0c'; // Dunkles Gusseisen
const SALVAGE_G_GRAU    = '#1b1816'; // Maschinenguss
const SALVAGE_G_STAHL   = '#292522'; // Industriestahl
const SALVAGE_G_HELL    = '#3c3733'; // Geschliffene Stahlkante

// Tires (Schwere Gummistollen & Dreck)
const SALVAGE_T_SCHWARZ = '#080706'; // Profilrillen tief
const SALVAGE_T_GUMMI   = '#11100e'; // Schweres Reifengummi
const SALVAGE_T_STAUB   = '#1e1c18'; // Staubige Reifenflanke
const SALVAGE_T_SCHMUTZ = '#2e2920'; // Eingetrockneter Dreck / Schlamm in den Stollen

// Hydraulics & Chrome (Fette Hydraulikstempel)
const SALVAGE_H_SCHWARZ = '#151922'; // Zylindergehäuse Schatten
const SALVAGE_H_DUNKEL  = '#253040'; // Zylinderwand
const SALVAGE_H_STAHL   = '#364457'; // Zylinderkante
const SALVAGE_H_GRAU    = '#4d5d73'; // Kolbenstangenschatten
const SALVAGE_H_CHROME  = '#6e7f99'; // Polierter Chromkolben
const SALVAGE_H_BLANK   = '#96a5bc'; // Glänzender Chromkolben
const SALVAGE_H_WEISS   = '#c4d1e2'; // Chrom-Glanzreflex

// Lights & Cab (Scheinwerfer & Panzersichtschlitz)
const SALVAGE_S_RING   = '#713f12'; // Scheinwerfer-Gussfassung
const SALVAGE_S_AMBER  = '#eab308'; // Bernstein-Reflektor
const SALVAGE_S_GELB   = '#facc15'; // Leuchtkern gelb
const SALVAGE_S_WEISS  = '#fef08a'; // Wolfram-Glühfaden
const SALVAGE_S_FLARE  = '#fbbf24'; // Lichtkegel

const SALVAGE_L_DUNKEL = '#024266'; // Panzersichtschlitz tief
const SALVAGE_L_CYAN   = '#0369a1'; // Sichtschlitz mittel
const SALVAGE_L_HELL   = '#38bdf8'; // Scheiben-Reflexion

const SALVAGE_TALLY_ROT = '#dc2626'; // Karminrote Abschusskerben
const SALVAGE_TALLY_DRK = '#991b1b'; // Tally-Schatten
const SALVAGE_TEAM_TAG  = 'TEAM';    // Team-Emblem

// Pure Mechanical Scrap (Massives Altmetall in Mulde & Klaue - KEIN GLOW)
const SALVAGE_S_I_D    = '#121822'; // Doppel-T-Träger Steg tief
const SALVAGE_S_I_M    = '#1e2837'; // Doppel-T-Träger Steg
const SALVAGE_S_I_H    = '#2f3d52'; // Doppel-T-Träger Flansch
const SALVAGE_S_I_TOP  = '#45556e'; // Träger Lichtkante
const SALVAGE_S_BRZ_D  = '#34220e'; // Bronzezahnrad Zahnunterkante
const SALVAGE_S_BRZ_M  = '#523919'; // Bronzezahnrad Flanke
const SALVAGE_S_BRZ_H  = '#7a5726'; // Bronzezahnrad Zahnkante
const SALVAGE_S_BRZ_P  = '#a37937'; // Bronzezahnrad polierter Zahn

function _paintHD_TheSalvageCompany_Chassis(grid, roll = 0) {
  const rPhase = ((roll % 6) + 6) % 6; // 0..5
  const baseAngle = -Math.PI / 2 + rPhase * (Math.PI / 3); // 12 -> 2 -> 4 -> 6 -> 8 -> 10 o'clock

  // 4 Kolossale Schwerlasträder (Breite 9-10px, Höhe 12px, y: 33..44)
  const wheels = [
    { x1: 2,  x2: 10, cx: 6  },
    { x1: 12, x2: 20, cx: 16 },
    { x1: 22, x2: 30, cx: 26 },
    { x1: 32, x2: 40, cx: 36 }
  ];

  // Massiver dunkelrostiger Fahrgestell-Träger & Achsbrücken (y: 33..36, x: 2..41)
  for (let y = 33; y <= 36; y++) {
    for (let x = 2; x <= 41; x++) {
      grid[y][x] = SALVAGE_G_SCHWARZ;
    }
  }

  // Jedes einzelne wuchtige Rad mit rotierendem Stollenprofil und Felgenspeichen
  wheels.forEach((w) => {
    const cx = w.cx;
    const cy = 39; // Radmitte

    for (let dy = -6; dy <= 5; dy++) {
      for (let dx = -4; dx <= 4; dx++) {
        const py = cy + dy;
        const px = cx + dx;
        if (px < w.x1 || px > w.x2 || py < 33 || py > 44) continue;

        // Elliptische Kontur für 9x12 Rad
        const nx = dx / 4.2;
        const ny = (dy + 0.5) / 5.8;
        const distSq = nx * nx + ny * ny;
        if (distSq > 1.05) continue;

        const theta = Math.atan2(ny, nx);
        const relAngle = ((theta - baseAngle) % (2 * Math.PI) + (2 * Math.PI)) % (2 * Math.PI);
        const sectorAngle = relAngle % (Math.PI / 3); // 60 deg sector
        const isLug = (sectorAngle < Math.PI / 6);    // 30 deg lug vs 30 deg groove

        // A. Äußere Reifenkontur & massive Stollen (Tread Lugs): distSq >= 0.55
        if (distSq >= 0.55) {
          const isMarkerCleat = (relAngle < Math.PI / 3); // Traveling prominent mud/chalk marker!
          const isOpposingCleat = (relAngle >= Math.PI && relAngle < 4 * Math.PI / 3);

          if (isMarkerCleat) {
            // Auffälliger getrockneter Lehm- / Kreidemarker auf dem Reifen
            grid[py][px] = (distSq >= 0.8) ? SALVAGE_P_CHIP : SALVAGE_P_HELL;
          } else if (isOpposingCleat) {
            // Rost-Dreck-Ablagerung gegenüber
            grid[py][px] = (distSq >= 0.8) ? SALVAGE_R_ROT : SALVAGE_R_OXID;
          } else if (isLug) {
            // Massiver Gummistollen: Oben staubig/belichtet, unten schlammig, an Flanken Gummi
            if (dy <= -3) {
              grid[py][px] = (distSq >= 0.85) ? SALVAGE_T_STAUB : SALVAGE_P_BRAUN;
            } else if (dy >= 3) {
              grid[py][px] = (distSq >= 0.85) ? SALVAGE_T_SCHWARZ : SALVAGE_T_GUMMI;
            } else {
              grid[py][px] = (distSq >= 0.85) ? SALVAGE_T_STAUB : SALVAGE_T_GUMMI;
            }
          } else {
            // Tiefe Profilrille zwischen den Stollen
            grid[py][px] = SALVAGE_T_SCHWARZ;
          }
        }
        // B. Tiefbett-Stahlfelge (0.20 <= distSq < 0.55)
        else if (distSq >= 0.20) {
          const isSpoke = (sectorAngle < Math.PI / 6);
          if (distSq >= 0.40) {
            // Felgenrand / Tiefbett-Kante
            grid[py][px] = (dy < 0) ? SALVAGE_G_STAHL : SALVAGE_R_DUNKEL;
          } else {
            // Rotierende Felgenspeichen & Lüftungsöffnungen
            if (isSpoke) {
              grid[py][px] = (dy < 0) ? SALVAGE_G_HELL : SALVAGE_G_STAHL;
            } else {
              grid[py][px] = SALVAGE_G_SCHWARZ; // Dunkles Lüftungsfenster
            }
          }
        }
        // C. Massive Planetengetriebe-Nabe (distSq < 0.20)
        else {
          grid[py][px] = SALVAGE_G_GRAU;
        }
      }
    }

    // Zentrale Bronzeschraube
    grid[cy][cx] = SALVAGE_S_BRZ_P;

    // Rotierende Radbolzen um die Nabe
    for (let k = 0; k < 6; k++) {
      const boltAng = baseAngle + k * (Math.PI / 3);
      const bx = Math.round(cx + Math.cos(boltAng) * 2.2);
      const by = Math.round(cy + Math.sin(boltAng) * 2.6);
      if (bx >= w.x1 && bx <= w.x2 && by >= 33 && by <= 44) {
        grid[by][bx] = (k === 0) ? SALVAGE_P_WEISS : (k === 3 ? SALVAGE_P_CHIP : SALVAGE_R_FLUG);
      }
    }
  });

  // Dicke dunkelrostige Radkästen & Kotflügel (y: 30..32)
  for (let x = 2; x <= 41; x++) {
    grid[31][x] = SALVAGE_R_DUNKEL;
    grid[32][x] = SALVAGE_R_KRUSTE;
  }
  wheels.forEach(w => {
    for (let x = w.x1; x <= w.x2; x++) {
      grid[30][x] = SALVAGE_P_BRAUN;
      grid[31][x] = (x === w.x1 || x === w.x2) ? SALVAGE_R_KRUSTE : SALVAGE_P_DUNKEL;
    }
  });

  // Massive Panzerschürzen mit rechteckigen Wartungsluken zwischen den Rädern
  [11, 21, 31].forEach(sx => {
    for (let y = 32; y <= 37; y++) {
      grid[y][sx] = (y === 34 || y === 35) ? SALVAGE_G_SCHWARZ : SALVAGE_R_DUNKEL;
    }
  });

  // Fetter Heck-Schmutzfänger (x: 1..2, y: 31..42)
  for (let y = 32; y <= 42; y++) {
    grid[y][1] = SALVAGE_T_SCHWARZ;
    grid[y][2] = SALVAGE_T_GUMMI;
  }
  grid[31][1] = SALVAGE_G_STAHL; grid[31][2] = SALVAGE_G_STAHL;

  // 2. ULTRA-MASSIVER BULLDOZER-PFLUG (x: 36..47, y: 24..44)
  for (let x = 37; x <= 47; x++) {
    grid[42][x] = SALVAGE_R_KRUSTE;
    grid[43][x] = (x % 2 === 0) ? SALVAGE_R_TIEFSCH : SALVAGE_G_SCHWARZ;
    grid[44][x] = (x % 2 === 0) ? SALVAGE_G_SCHWARZ : SALVAGE_R_DUNKEL;
  }

  // Wuchtig gebogene Schildklinge mit extrem dunkler Rostpatina & Rostfahnen
  for (let y = 25; y <= 41; y++) {
    const minX = Math.max(36, Math.round(36 + (y - 25) * 0.12));
    const maxX = Math.min(47, Math.round(39 + (y - 25) * 0.48));
    for (let x = minX; x <= maxX; x++) {
      if (x === maxX) {
        grid[y][x] = (y < 31) ? SALVAGE_P_KANTE : SALVAGE_P_HELL;
      } else if (x === maxX - 1) {
        grid[y][x] = (y < 34) ? SALVAGE_P_HELL : SALVAGE_P_MITTEL;
      } else if (x === minX) {
        grid[y][x] = SALVAGE_R_KRUSTE;
      } else {
        const isRustStreak = (x === 40 || x === 43 || (x + y * 2) % 5 === 0);
        grid[y][x] = isRustStreak ? SALVAGE_R_ROT : SALVAGE_P_DUNKEL;
      }
    }
  }

  // Vertikale Verstärkungs-Stege über den Pflug (Gusset-Ribs)
  for (let y = 27; y <= 41; y++) {
    if (grid[y][40]) grid[y][40] = SALVAGE_R_DUNKEL;
    if (grid[y][44]) grid[y][44] = SALVAGE_R_DUNKEL;
  }

  // Scheinwerfer-Kasten im Pflug (x: 39..43, y: 29..33)
  for (let y = 29; y <= 33; y++) {
    grid[y][39] = SALVAGE_S_RING;
    grid[y][43] = SALVAGE_S_RING;
  }
  // Oberer Scheinwerfer (y: 29..30, x: 40..42)
  grid[29][40] = SALVAGE_S_RING;  grid[29][41] = SALVAGE_S_AMBER; grid[29][42] = SALVAGE_S_WEISS;
  grid[30][40] = SALVAGE_S_AMBER; grid[30][41] = SALVAGE_S_WEISS; grid[30][42] = SALVAGE_S_GELB;
  // Unterer Scheinwerfer (y: 31..32, x: 40..42)
  grid[31][40] = SALVAGE_S_RING;  grid[31][41] = SALVAGE_S_AMBER; grid[31][42] = SALVAGE_S_WEISS;
  grid[32][40] = SALVAGE_S_AMBER; grid[32][41] = SALVAGE_S_WEISS; grid[32][42] = SALVAGE_S_GELB;
  // Scheinwerfer-Frontflare
  grid[30][43] = SALVAGE_S_FLARE; grid[31][43] = SALVAGE_S_FLARE;

  // Wuchtige Hydraulik-Schiebearme hinter Pflug (x: 34..37, y: 33..36)
  for (let y = 33; y <= 36; y++) {
    grid[y][34] = SALVAGE_H_SCHWARZ;
    grid[y][35] = SALVAGE_H_GRAU;
    grid[y][36] = SALVAGE_H_BLANK;
    grid[y][37] = SALVAGE_H_WEISS;
  }

  // 3. FAHRERKABINE MIT VISIERDACH & SCHMUTZIGER PATINA (x: 26..38, y: 14..31)
  // Gelbe Warnleuchte / Rundumlicht
  grid[14][35] = SALVAGE_S_WEISS; grid[14][36] = SALVAGE_S_AMBER;
  grid[15][35] = SALVAGE_G_SCHWARZ; grid[15][36] = SALVAGE_G_SCHWARZ;

  // Massives Visierdach (y: 15..18, x: 26..38)
  for (let x = 27; x <= 37; x++) {
    grid[15][x] = (x === 27 || x === 37) ? SALVAGE_P_HELL : SALVAGE_P_CHIP;
    grid[16][x] = SALVAGE_P_KANTE;
  }
  for (let x = 26; x <= 38; x++) {
    grid[17][x] = (x >= 35) ? SALVAGE_P_KANTE : SALVAGE_P_MITTEL;
    grid[18][x] = (x >= 36) ? SALVAGE_P_HELL  : SALVAGE_P_DUNKEL;
  }
  // Visier-Überhang-Schatten
  for (let x = 27; x <= 38; x++) grid[19][x] = SALVAGE_R_KRUSTE;

  // Panzersichtschlitz (y: 20..21, x: 28..36)
  grid[20][28] = SALVAGE_R_TIEFSCH; grid[21][28] = SALVAGE_R_TIEFSCH;
  for (let x = 29; x <= 35; x++) {
    grid[20][x] = (x >= 33) ? SALVAGE_L_HELL : SALVAGE_L_CYAN;
    grid[21][x] = SALVAGE_L_DUNKEL;
  }
  grid[20][36] = SALVAGE_R_TIEFSCH; grid[21][36] = SALVAGE_R_TIEFSCH;

  // Gepanzerte Motorhaube unter Scheibe (y: 22..25, x: 34..38)
  for (let y = 22; y <= 25; y++) {
    for (let x = 34; x <= 38; x++) {
      grid[y][x] = (x === 38) ? SALVAGE_R_UMBER : ((y === 22) ? SALVAGE_P_MITTEL : SALVAGE_P_DUNKEL);
    }
  }

  // Kabinen-Seitenwand & Tür (y: 22..31, x: 26..34)
  for (let y = 22; y <= 31; y++) {
    for (let x = 26; x <= 34; x++) {
      const isRustRun = (x === 27 || x === 33 || (x + y * 2) % 4 === 0);
      grid[y][x] = isRustRun ? SALVAGE_R_ROT : SALVAGE_P_DUNKEL;
    }
    grid[y][26] = SALVAGE_R_KRUSTE; // Türnaht
    grid[y][34] = SALVAGE_R_KRUSTE;
  }
  for (let x = 26; x <= 34; x++) {
    grid[22][x] = SALVAGE_R_KRUSTE;
    grid[31][x] = SALVAGE_R_KRUSTE;
  }

  // Einstiegsleiter-Sprossen links (x: 25..26, y: 22..30)
  for (let y = 23; y <= 29; y += 2) {
    grid[y][25] = SALVAGE_G_STAHL;
    grid[y][26] = SALVAGE_G_GRAU;
  }

  // TEAM-Insignia-Badge (5x3 px, x: 28..32, y: 23..25)
  for (let y = 23; y <= 25; y++) {
    for (let x = 28; x <= 32; x++) {
      grid[y][x] = SALVAGE_TEAM_TAG;
    }
  }

  // Lufteinlass mit massivem X-Gitter & Ruß (x: 22..25, y: 22..29)
  for (let y = 22; y <= 29; y++) {
    for (let x = 22; x <= 25; x++) {
      grid[y][x] = (y === 22 || y === 29 || x === 22 || x === 25) ? SALVAGE_R_KRUSTE : SALVAGE_G_DUNKEL;
    }
  }
  grid[24][23] = SALVAGE_R_OXID;  grid[24][24] = SALVAGE_R_OXID;
  grid[25][23] = SALVAGE_P_HELL;  grid[25][24] = SALVAGE_P_HELL;
  grid[26][23] = SALVAGE_P_HELL;  grid[26][24] = SALVAGE_P_HELL;
  grid[27][23] = SALVAGE_R_OXID;  grid[27][24] = SALVAGE_R_OXID;

  // 4. AUSPUFFANLAGE (x: 23..25, y: 7..21)
  grid[7][23] = SALVAGE_T_SCHWARZ; grid[7][24] = SALVAGE_T_SCHWARZ; grid[7][25] = SALVAGE_T_SCHWARZ;
  grid[8][23] = SALVAGE_T_SCHWARZ; grid[8][24] = SALVAGE_G_DUNKEL;   grid[8][25] = SALVAGE_T_SCHWARZ;
  for (let y = 9; y <= 18; y++) {
    grid[y][23] = (y % 2 === 0) ? SALVAGE_G_STAHL : SALVAGE_T_SCHWARZ;
    grid[y][24] = (y % 2 === 0) ? SALVAGE_R_OXID  : SALVAGE_G_STAHL;
    grid[y][25] = (y % 2 === 0) ? SALVAGE_G_STAHL : SALVAGE_T_SCHWARZ;
  }
  for (let y = 19; y <= 21; y++) {
    grid[y][23] = SALVAGE_R_ROT;
    grid[y][24] = SALVAGE_R_TIEFSCH;
    grid[y][25] = SALVAGE_R_KRUSTE;
  }

  // 5. MULDE / 2.5D HOPPER BED MIT TIEFE & BEIDEN FLANKEN (x: 2..22, y: 17..32)
  // A. HINTERE FLANKE (Linke Fahrzeugseite im Hintergrund, y: 17..23)
  // Oberkante der hinteren Flanke
  for (let x = 2; x <= 22; x++) {
    grid[18][x] = (x === 2 || x === 22) ? SALVAGE_P_CHIP : ((x % 2 === 0) ? SALVAGE_P_HELL : SALVAGE_P_KANTE);
  }
  // Stanchion-Kappen der hinteren Wand (in 3/4-Perspektive leicht versetzt)
  const farStanchions = [ [5,6], [9,10], [14,15], [19,20] ];
  farStanchions.forEach(([s1, s2]) => {
    grid[17][s1] = SALVAGE_P_CHIP;
    grid[17][s2] = SALVAGE_P_KANTE;
  });

  // Innenfläche der hinteren Flanke (y: 19..23)
  for (let y = 19; y <= 23; y++) {
    for (let x = 2; x <= 22; x++) {
      const isSt = farStanchions.some(([s1, s2]) => x === s1 || x === s2);
      if (isSt) {
        grid[y][x] = (x % 2 === 0) ? SALVAGE_P_BRAUN : SALVAGE_P_DUNKEL;
      } else {
        const isRust = ((x + y * 2) % 3 === 0);
        grid[y][x] = isRust ? SALVAGE_R_OXID : SALVAGE_R_DUNKEL;
      }
    }
  }

  // B. MASSIVE 2.5D HECKWAND (Tailgate, x: 2..4, y: 18..24)
  grid[18][2] = SALVAGE_P_CHIP;  grid[18][3] = SALVAGE_P_HELL;
  grid[19][2] = SALVAGE_P_KANTE; grid[19][3] = SALVAGE_P_MITTEL; grid[19][4] = SALVAGE_R_OXID;
  grid[20][2] = SALVAGE_P_HELL;  grid[20][3] = SALVAGE_P_BRAUN;  grid[20][4] = SALVAGE_R_OXID;
  grid[21][2] = SALVAGE_P_KANTE; grid[21][3] = SALVAGE_P_DUNKEL; grid[21][4] = SALVAGE_P_BRAUN;
  grid[22][2] = SALVAGE_P_HELL;  grid[22][3] = SALVAGE_P_BRAUN;  grid[22][4] = SALVAGE_P_MITTEL;
  grid[23][2] = SALVAGE_P_KANTE; grid[23][3] = SALVAGE_P_HELL;   grid[23][4] = SALVAGE_P_KANTE;

  // C. LADEFLÄCHEN-BODEN & SCHROTT (y: 23..24, x: 4..21)
  for (let x = 4; x <= 21; x++) {
    grid[23][x] = (x % 2 === 0) ? SALVAGE_G_SCHWARZ : SALVAGE_R_TIEFSCH;
    grid[24][x] = SALVAGE_P_FETT;
  }

  // Schrott I-Träger (x: 6..9, y: 16..23)
  grid[16][7] = SALVAGE_S_I_H; grid[16][8] = SALVAGE_S_I_M; grid[16][9] = SALVAGE_S_I_D;
  grid[17][6] = SALVAGE_S_I_H; grid[17][7] = SALVAGE_S_I_D; grid[17][8] = SALVAGE_S_I_M; grid[17][9] = SALVAGE_S_I_H;
  grid[18][6] = SALVAGE_S_I_M; grid[18][7] = SALVAGE_S_I_D; grid[18][8] = SALVAGE_S_I_D;
  grid[19][6] = SALVAGE_S_I_D; grid[19][7] = SALVAGE_S_I_M; grid[19][8] = SALVAGE_S_I_TOP;
  grid[20][7] = SALVAGE_S_I_D; grid[20][8] = SALVAGE_S_I_M;
  grid[21][7] = SALVAGE_S_I_D; grid[21][8] = SALVAGE_S_I_H;

  // Bronzezahnrad (x: 12..15, y: 15..23)
  for (let y = 15; y <= 21; y++) {
    for (let x = 12; x <= 15; x++) {
      grid[y][x] = ((x + y) % 2 === 0) ? SALVAGE_S_BRZ_H : SALVAGE_S_BRZ_M;
    }
  }
  grid[15][13] = SALVAGE_S_BRZ_P;
  grid[17][14] = SALVAGE_S_BRZ_D;
  grid[19][13] = SALVAGE_S_BRZ_P; grid[19][14] = SALVAGE_S_BRZ_H;

  // Rosttrümmer & Schrottbleche
  for (let x = 9; x <= 11; x++) {
    grid[19][x] = SALVAGE_R_FLUG;
    grid[20][x] = SALVAGE_R_ROT;
    grid[21][x] = SALVAGE_R_OXID;
    grid[22][x] = SALVAGE_R_DUNKEL;
  }
  for (let x = 16; x <= 19; x++) {
    grid[20][x] = SALVAGE_R_ROT;
    grid[21][x] = SALVAGE_R_DUNKEL;
    grid[22][x] = SALVAGE_R_OXID;
  }

  // D. VORDERE FLANKE (Rechte Fahrzeugseite im Vordergrund, y: 24..31 - reduzierte Höhe)
  const nearStanchions = [ [3,4], [7,8], [12,13], [17,18], [21,22] ];

  // Oberkante der vorderen Flanke (y = 24, x = 2..22)
  for (let x = 2; x <= 22; x++) {
    grid[24][x] = (x === 2 || x === 22) ? SALVAGE_P_CHIP : ((x % 2 === 0) ? SALVAGE_P_HELL : SALVAGE_P_KANTE);
  }
  nearStanchions.forEach(([s1, s2]) => {
    grid[24][s1] = SALVAGE_P_WEISS;
    grid[24][s2] = SALVAGE_P_CHIP;
  });

  // Lichtkante / Bevel unter der Deckleiste (y = 25)
  for (let x = 2; x <= 22; x++) {
    grid[25][x] = SALVAGE_P_MITTEL;
  }

  // Seitenwand-Fläche mit Vertikalrippen & Rostfahnen (y: 26..31)
  for (let y = 26; y <= 31; y++) {
    for (let x = 2; x <= 22; x++) {
      const isSt = nearStanchions.some(([s1, s2]) => x === s1 || x === s2);
      if (isSt) {
        grid[y][x] = (x % 2 === 0) ? SALVAGE_P_HELL : SALVAGE_P_KANTE;
      } else {
        const isRustStreak = ((x + y * 2) % 4 === 0 || y >= 29);
        grid[y][x] = isRustStreak ? SALVAGE_R_ROT : SALVAGE_P_DUNKEL;
      }
    }
  }

  // Unterkante der Flanke & Übergang zum Fahrgestell (y: 31..32)
  for (let x = 2; x <= 22; x++) {
    grid[31][x] = SALVAGE_R_DUNKEL;
    grid[32][x] = SALVAGE_G_SCHWARZ;
  }

  // 6. DREHKRANZ-SOCKEL FÜR DEN GREIFARM (x: 17..25, y: 16..21)
  for (let y = 19; y <= 21; y++) {
    for (let x = 17; x <= 25; x++) {
      grid[y][x] = (y === 21) ? SALVAGE_G_SCHWARZ : SALVAGE_G_DUNKEL;
    }
  }
  for (let x = 17; x <= 24; x++) {
    grid[18][x] = (x % 2 === 0) ? SALVAGE_G_STAHL : SALVAGE_G_GRAU;
  }
  for (let y = 16; y <= 17; y++) {
    for (let x = 18; x <= 24; x++) {
      grid[y][x] = SALVAGE_R_ROT;
    }
  }
  grid[17][21] = SALVAGE_S_BRZ_P;
}

function getHD_TheSalvageCompany_Chassis(roll = 0) {
  const g = 48, grid = makeGrid48();
  _paintHD_TheSalvageCompany_Chassis(grid, roll);
  return { gridSize: g, grid };
}

function getHD_TheSalvageCompany_Chassis_Roll1() { return getHD_TheSalvageCompany_Chassis(0); }
function getHD_TheSalvageCompany_Chassis_Roll2() { return getHD_TheSalvageCompany_Chassis(1); }
function getHD_TheSalvageCompany_Chassis_Roll3() { return getHD_TheSalvageCompany_Chassis(2); }
function getHD_TheSalvageCompany_Chassis_Roll4() { return getHD_TheSalvageCompany_Chassis(3); }
function getHD_TheSalvageCompany_Chassis_Roll5() { return getHD_TheSalvageCompany_Chassis(4); }
function getHD_TheSalvageCompany_Chassis_Roll6() { return getHD_TheSalvageCompany_Chassis(5); }

// ============================================================================
// THE SALVAGE COMPANY — 11-STAGE SMOOTH KINEMATIC CRANE ARM
// Rigid-body kinematics with constant segment lengths (Boom 13.0px, Stick 13.4px)
// Eliminates telescoping/stretching: boom articulates down to reach the ground.
// ============================================================================

function _drawSalvageBeam(grid, x0, y0, x1, y1, width, type) {
  const dx = x1 - x0;
  const dy = y1 - y0;
  const len = Math.hypot(dx, dy);
  if (len === 0) return;
  const nx = -dy / len;
  const ny = dx / len;

  const steps = Math.ceil(len * 2.5);
  const halfW = (width - 1) / 2;

  for (let s = 0; s <= steps; s++) {
    const t = s / steps;
    const cx = x0 + dx * t;
    const cy = y0 + dy * t;

    for (let w = -Math.floor(halfW); w <= Math.ceil(halfW); w++) {
      const px = Math.round(cx + nx * w);
      const py = Math.round(cy + ny * w);
      if (px >= 0 && px < 48 && py >= 0 && py < 48) {
        const relW = w / (halfW || 1);
        let col = SALVAGE_R_ROT;
        if (type === 'boom') {
          if (relW > 0.6) col = SALVAGE_P_KANTE;
          else if (relW > 0.3) col = SALVAGE_P_HELL;
          else if (relW < -0.6) col = SALVAGE_R_KRUSTE;
          else if (relW < -0.3) col = SALVAGE_R_ROT;
          else col = (s % 4 === 0) ? SALVAGE_G_SCHWARZ : SALVAGE_P_DUNKEL;
        } else if (type === 'stick') {
          if (relW > 0.5) col = SALVAGE_P_KANTE;
          else if (relW > 0.2) col = SALVAGE_P_HELL;
          else if (relW < -0.5) col = SALVAGE_R_KRUSTE;
          else col = SALVAGE_R_ROT;
        } else if (type === 'cylinder') {
          if (relW > 0.3) col = SALVAGE_H_BLANK;
          else if (relW > -0.3) col = (s % 3 === 0) ? SALVAGE_H_WEISS : SALVAGE_H_BLANK;
          else col = SALVAGE_H_DUNKEL;
        }
        grid[py][px] = col;
      }
    }
  }
}

function _drawSalvageKnuckle(grid, cx, cy) {
  for (let dy = -3; dy <= 3; dy++) {
    for (let dx = -3; dx <= 3; dx++) {
      const dist = Math.hypot(dx, dy);
      if (dist <= 3.2) {
        const px = cx + dx, py = cy + dy;
        if (px >= 0 && px < 48 && py >= 0 && py < 48) {
          const col = (dist <= 1.2) ? SALVAGE_S_BRZ_P : ((dx + dy < 0) ? SALVAGE_P_KANTE : SALVAGE_G_GRAU);
          grid[py][px] = col;
        }
      }
    }
  }
  if (cx >= 0 && cx < 48 && cy >= 0 && cy < 48) {
    grid[cy][cx] = SALVAGE_S_BRZ_H;
  }
}

function _drawSalvageWrist(grid, cx, cy) {
  for (let dy = -2; dy <= 2; dy++) {
    for (let dx = -2; dx <= 2; dx++) {
      const px = cx + dx, py = cy + dy;
      if (px >= 0 && px < 48 && py >= 0 && py < 48) {
        grid[py][px] = (dx === 0 && dy === 0) ? SALVAGE_S_BRZ_P : SALVAGE_G_STAHL;
      }
    }
  }
}

function _drawSalvageClaw(grid, wx, wy, state) {
  function p(x, y, col) {
    if (x >= 0 && x < 48 && y >= 0 && y < 48 && col) grid[y][x] = col;
  }

  if (state === 'closed_empty') {
    for (let dy = 1; dy <= 5; dy++) {
      p(wx - 2, wy + dy, SALVAGE_P_KANTE);
      p(wx - 1, wy + dy, SALVAGE_R_ROT);
      p(wx,     wy + dy, SALVAGE_G_STAHL);
      p(wx + 1, wy + dy, SALVAGE_R_ROT);
      p(wx + 2, wy + dy, SALVAGE_P_KANTE);
    }
    p(wx - 1, wy + 6, SALVAGE_P_CHIP);
    p(wx,     wy + 6, SALVAGE_G_SCHWARZ);
    p(wx + 1, wy + 6, SALVAGE_P_CHIP);
  } else if (state === 'opening') {
    for (let dy = 1; dy <= 5; dy++) {
      p(wx - 1 - dy, wy + dy, SALVAGE_P_KANTE);
      p(wx - dy,     wy + dy, SALVAGE_R_ROT);
      p(wx + dy,     wy + dy, SALVAGE_R_ROT);
      p(wx + 1 + dy, wy + dy, SALVAGE_P_KANTE);
    }
    p(wx - 1, wy + 1, SALVAGE_G_STAHL);
    p(wx,     wy + 1, SALVAGE_G_STAHL);
    p(wx + 1, wy + 1, SALVAGE_G_STAHL);
  } else if (state === 'open') {
    // 4-tine demolition grabber wide open (14px span)
    p(wx - 2, wy + 1, SALVAGE_P_KANTE);
    p(wx - 3, wy + 2, SALVAGE_P_KANTE);
    p(wx - 4, wy + 3, SALVAGE_P_HELL);
    p(wx - 5, wy + 4, SALVAGE_P_CHIP);
    p(wx - 6, wy + 5, SALVAGE_P_KANTE);
    p(wx - 6, wy + 6, SALVAGE_P_HELL);
    p(wx - 6, wy + 7, SALVAGE_R_ROT);
    p(wx - 5, wy + 8, SALVAGE_P_CHIP);
    p(wx - 4, wy + 9, SALVAGE_G_SCHWARZ);

    for (let y = 1; y <= 7; y++) {
      p(wx - 2, wy + y, (y < 4) ? SALVAGE_P_HELL : SALVAGE_R_ROT);
      p(wx + 2, wy + y, (y < 4) ? SALVAGE_P_HELL : SALVAGE_R_ROT);
    }
    p(wx - 1, wy + 8, SALVAGE_P_KANTE);
    p(wx + 1, wy + 8, SALVAGE_P_KANTE);

    p(wx + 2, wy + 1, SALVAGE_P_KANTE);
    p(wx + 3, wy + 2, SALVAGE_P_KANTE);
    p(wx + 4, wy + 3, SALVAGE_P_HELL);
    p(wx + 5, wy + 4, SALVAGE_P_CHIP);
    p(wx + 6, wy + 5, SALVAGE_P_KANTE);
    p(wx + 6, wy + 6, SALVAGE_P_HELL);
    p(wx + 6, wy + 7, SALVAGE_R_ROT);
    p(wx + 5, wy + 8, SALVAGE_P_CHIP);
    p(wx + 4, wy + 9, SALVAGE_G_SCHWARZ);
  } else if (state === 'clamping_scrap' || state === 'holding_scrap') {
    for (let dy = 1; dy <= 6; dy++) {
      p(wx - 3, wy + dy, SALVAGE_P_KANTE);
      p(wx - 2, wy + dy, SALVAGE_R_ROT);
      p(wx + 2, wy + dy, SALVAGE_R_ROT);
      p(wx + 3, wy + dy, SALVAGE_P_KANTE);
    }
    p(wx - 1, wy + 7, SALVAGE_P_CHIP);
    p(wx,     wy + 7, SALVAGE_G_SCHWARZ);
    p(wx + 1, wy + 7, SALVAGE_P_CHIP);

    // Clamped Steel I-Beam
    p(wx - 1, wy + 2, SALVAGE_S_I_TOP);
    p(wx,     wy + 2, SALVAGE_S_I_H);
    p(wx + 1, wy + 2, SALVAGE_S_I_TOP);
    p(wx - 1, wy + 3, SALVAGE_S_I_H);
    p(wx,     wy + 3, SALVAGE_S_I_D);
    p(wx + 1, wy + 3, SALVAGE_S_I_H);
    p(wx - 1, wy + 4, SALVAGE_S_I_TOP);
    p(wx,     wy + 4, SALVAGE_S_I_H);
    p(wx + 1, wy + 4, SALVAGE_S_I_TOP);

    // Clamped Bronze Gear
    p(wx - 1, wy + 5, SALVAGE_S_BRZ_P);
    p(wx,     wy + 5, SALVAGE_S_BRZ_H);
    p(wx + 1, wy + 5, SALVAGE_S_BRZ_P);
    p(wx - 1, wy + 6, SALVAGE_S_BRZ_H);
    p(wx,     wy + 6, SALVAGE_S_BRZ_M);
    p(wx + 1, wy + 6, SALVAGE_S_BRZ_H);
  } else if (state === 'dumping') {
    for (let dy = 1; dy <= 4; dy++) {
      p(wx - 2 - dy, wy + dy, SALVAGE_P_KANTE);
      p(wx - 1 - dy, wy + dy, SALVAGE_R_ROT);
      p(wx + 1 + dy, wy + dy, SALVAGE_R_ROT);
      p(wx + 2 + dy, wy + dy, SALVAGE_P_KANTE);
    }
    // Tumbling scrap
    p(wx - 1, wy + 5, SALVAGE_S_I_TOP);
    p(wx,     wy + 5, SALVAGE_S_I_H);
    p(wx + 1, wy + 6, SALVAGE_S_I_D);
    p(wx,     wy + 7, SALVAGE_S_BRZ_P);
    p(wx + 1, wy + 7, SALVAGE_S_BRZ_H);
    p(wx,     wy + 8, SALVAGE_S_BRZ_M);
    p(wx - 2, wy + 8, '#facc15');
    p(wx + 2, wy + 7, '#fef08a');
  }
}

function _paintHD_TheSalvageCompany_Arm_Pose(grid, P1, P2, clawState) {
  const P0 = [21, 16];
  // Turret Base
  for (let y = 15; y <= 18; y++) {
    for (let x = 18; x <= 24; x++) grid[y][x] = SALVAGE_R_ROT;
  }
  grid[17][21] = SALVAGE_S_BRZ_P;

  // Main Boom: 9px thick
  _drawSalvageBeam(grid, P0[0], P0[1], P1[0], P1[1], 9, 'boom');

  // Hydraulic Ram
  const midX = (P0[0] + P1[0]) / 2;
  const midY = (P0[1] + P1[1]) / 2;
  const cylX = midX + ((P1[0] > P0[0]) ? -1 : 1);
  const cylY = midY + 1;
  _drawSalvageBeam(grid, P0[0], P0[1], Math.round(cylX), Math.round(cylY), 4, 'cylinder');

  // Elbow Knuckle
  _drawSalvageKnuckle(grid, P1[0], P1[1]);

  // Stick (Knickarm): 8px thick
  _drawSalvageBeam(grid, P1[0], P1[1], P2[0], P2[1], 8, 'stick');

  // Stick Cylinder
  const stickMidX = (P1[0] + P2[0]) / 2;
  const stickMidY = (P1[1] + P2[1]) / 2;
  _drawSalvageBeam(grid, P1[0], P1[1], Math.round(stickMidX), Math.round(stickMidY), 3, 'cylinder');

  // Wrist & Claw
  _drawSalvageWrist(grid, P2[0], P2[1]);
  _drawSalvageClaw(grid, P2[0], P2[1], clawState);
}

// 11 Concrete Painters
function _paintHD_TheSalvageCompany_Arm_Rest(grid)      { _paintHD_TheSalvageCompany_Arm_Pose(grid, [11, 7],  [9, 20],  'closed_empty'); }
function _paintHD_TheSalvageCompany_Arm_Raise(grid)     { _paintHD_TheSalvageCompany_Arm_Pose(grid, [17, 4],  [12, 15], 'closed_empty'); }
function _paintHD_TheSalvageCompany_Arm_SwingFwd(grid)  { _paintHD_TheSalvageCompany_Arm_Pose(grid, [27, 4],  [34, 14], 'opening'); }
function _paintHD_TheSalvageCompany_Arm_Lower(grid)     { _paintHD_TheSalvageCompany_Arm_Pose(grid, [32, 11], [39, 22], 'open'); }
function _paintHD_TheSalvageCompany_Arm_Reach(grid)     { _paintHD_TheSalvageCompany_Arm_Pose(grid, [34, 17], [40, 29], 'open'); }
function _paintHD_TheSalvageCompany_Arm_Grab(grid)      { _paintHD_TheSalvageCompany_Arm_Pose(grid, [34, 17], [40, 29], 'clamping_scrap'); }
function _paintHD_TheSalvageCompany_Arm_Lift(grid)      { _paintHD_TheSalvageCompany_Arm_Pose(grid, [31, 8],  [39, 18], 'holding_scrap'); }
function _paintHD_TheSalvageCompany_Arm_SwingBack(grid) { _paintHD_TheSalvageCompany_Arm_Pose(grid, [25, 4],  [30, 15], 'holding_scrap'); }
function _paintHD_TheSalvageCompany_Arm_Hover(grid)     { _paintHD_TheSalvageCompany_Arm_Pose(grid, [20, 3],  [9, 10],  'holding_scrap'); }
function _paintHD_TheSalvageCompany_Arm_Dump(grid)      { _paintHD_TheSalvageCompany_Arm_Pose(grid, [20, 3],  [9, 10],  'dumping'); }
function _paintHD_TheSalvageCompany_Arm_Fold(grid)      { _paintHD_TheSalvageCompany_Arm_Pose(grid, [12, 6],  [10, 19], 'closed_empty'); }

// 11 Getters
function getHD_TheSalvageCompany_Arm_Rest()      { const g = 48, grid = makeGrid48(); _paintHD_TheSalvageCompany_Arm_Rest(grid); return { gridSize: g, grid }; }
function getHD_TheSalvageCompany_Arm_Raise()     { const g = 48, grid = makeGrid48(); _paintHD_TheSalvageCompany_Arm_Raise(grid); return { gridSize: g, grid }; }
function getHD_TheSalvageCompany_Arm_SwingFwd()  { const g = 48, grid = makeGrid48(); _paintHD_TheSalvageCompany_Arm_SwingFwd(grid); return { gridSize: g, grid }; }
function getHD_TheSalvageCompany_Arm_Lower()     { const g = 48, grid = makeGrid48(); _paintHD_TheSalvageCompany_Arm_Lower(grid); return { gridSize: g, grid }; }
function getHD_TheSalvageCompany_Arm_Reach()     { const g = 48, grid = makeGrid48(); _paintHD_TheSalvageCompany_Arm_Reach(grid); return { gridSize: g, grid }; }
function getHD_TheSalvageCompany_Arm_Grab()      { const g = 48, grid = makeGrid48(); _paintHD_TheSalvageCompany_Arm_Grab(grid); return { gridSize: g, grid }; }
function getHD_TheSalvageCompany_Arm_Lift()      { const g = 48, grid = makeGrid48(); _paintHD_TheSalvageCompany_Arm_Lift(grid); return { gridSize: g, grid }; }
function getHD_TheSalvageCompany_Arm_SwingBack() { const g = 48, grid = makeGrid48(); _paintHD_TheSalvageCompany_Arm_SwingBack(grid); return { gridSize: g, grid }; }
function getHD_TheSalvageCompany_Arm_Hover()     { const g = 48, grid = makeGrid48(); _paintHD_TheSalvageCompany_Arm_Hover(grid); return { gridSize: g, grid }; }
function getHD_TheSalvageCompany_Arm_Dump()      { const g = 48, grid = makeGrid48(); _paintHD_TheSalvageCompany_Arm_Dump(grid); return { gridSize: g, grid }; }
function getHD_TheSalvageCompany_Arm_Fold()      { const g = 48, grid = makeGrid48(); _paintHD_TheSalvageCompany_Arm_Fold(grid); return { gridSize: g, grid }; }

function getHD_TheSalvageCompany() {
  const g = 48, grid = makeGrid48();
  _paintHD_TheSalvageCompany_Chassis(grid, 0);
  const armGrid = makeGrid48();
  _paintHD_TheSalvageCompany_Arm_Rest(armGrid);

  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (armGrid[y][x]) grid[y][x] = armGrid[y][x];
    }
  }
  return { gridSize: g, grid };
}

function _composeTheSalvageCompanyRoll(roll = 0) {
  const g = 48, grid = makeGrid48();
  _paintHD_TheSalvageCompany_Chassis(grid, roll);
  const armGrid = makeGrid48();
  _paintHD_TheSalvageCompany_Arm_Rest(armGrid);
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (armGrid[y][x]) grid[y][x] = armGrid[y][x];
    }
  }
  return { gridSize: g, grid };
}
function getHD_TheSalvageCompany_Roll1() { return _composeTheSalvageCompanyRoll(0); }
function getHD_TheSalvageCompany_Roll2() { return _composeTheSalvageCompanyRoll(1); }
function getHD_TheSalvageCompany_Roll3() { return _composeTheSalvageCompanyRoll(2); }
function getHD_TheSalvageCompany_Roll4() { return _composeTheSalvageCompanyRoll(3); }
function getHD_TheSalvageCompany_Roll5() { return _composeTheSalvageCompanyRoll(4); }
function getHD_TheSalvageCompany_Roll6() { return _composeTheSalvageCompanyRoll(5); }

function getHD_Rocketship() {
  const g = 24, grid = makeGrid();

  // PALETTE
  const T_OUTLINE = '#090d16'; // Deep contour
  const T_DARK    = '#0f172a'; // Deep shadow / pylon
  const T_BASE_D  = '#1e293b'; // Lower fuselage dark armor
  const T_BASE    = '#334155'; // Main military titanium armor
  const T_MID     = '#475569'; // Mid plating
  const T_HI      = '#64748b'; // Specular highlight
  const T_GLINT   = '#94a3b8'; // Metallic edge bevel
  const T_SHINE   = '#cbd5e1'; // Chrome/titanium trim & nose
  const T_WHITE   = '#f1f5f9'; // High-specular glint & missile skin

  // 1. SWEPT DORSAL TAIL FIN (-X rear: y: 4..8, x: 2..8)
  grid[4][3] = T_OUTLINE; grid[4][4] = '#4ade80'; grid[4][5] = '#22c55e'; // Green nav strobe
  grid[5][3] = T_OUTLINE; grid[5][4] = 'TEAM';   grid[5][5] = 'TEAM';   grid[5][6] = T_SHINE;
  grid[6][3] = T_OUTLINE; grid[6][4] = T_BASE;   grid[6][5] = 'TEAM';   grid[6][6] = T_HI;     grid[6][7] = T_GLINT;
  grid[7][3] = T_OUTLINE; grid[7][4] = T_BASE_D; grid[7][5] = T_BASE;   grid[7][6] = T_MID;    grid[7][7] = T_HI;    grid[7][8] = T_SHINE;
  grid[8][3] = T_OUTLINE; grid[8][4] = T_BASE_D; grid[8][5] = T_BASE;   grid[8][6] = T_MID;    grid[8][7] = T_HI;    grid[8][8] = T_GLINT;

  // 2. DORSAL SPINE & UPPER FUSELAGE RIDGE (y: 8, x: 9..12)
  for (let x = 9; x <= 11; x++) grid[8][x] = T_HI;
  grid[8][12] = T_GLINT;

  // 3. FLUSH INTEGRATED COCKPIT CANOPY (y: 7..9, x: 12..17)
  // Top canopy contour (y=7, x: 13..16)
  grid[7][13] = T_OUTLINE; grid[7][14] = '#38bdf8'; grid[7][15] = '#00f0ff'; grid[7][16] = '#e0f2fe'; grid[7][17] = T_OUTLINE;
  // Mid canopy glass (y=8, x: 12..17)
  grid[8][13] = '#0284c7'; grid[8][14] = '#38bdf8'; grid[8][15] = '#00f0ff'; grid[8][16] = '#ffffff'; grid[8][17] = T_SHINE;
  // Lower canopy glass & sill frame (y=9, x: 12..18)
  grid[9][13] = '#0c4a6e'; grid[9][14] = '#0369a1'; grid[9][15] = '#0284c7'; grid[9][16] = '#0284c7'; grid[9][17] = T_BASE_D; grid[9][18] = T_SHINE;

  // 4. LONG SUPERSONIC NEEDLE NOSE (x: 18..23, y: 10..12)
  grid[10][18] = T_SHINE; grid[10][19] = T_GLINT; grid[10][20] = T_HI;
  // Centerline supersonic needle radome:
  grid[11][18] = T_WHITE; grid[11][19] = T_SHINE; grid[11][20] = T_GLINT; grid[11][21] = T_SHINE; grid[11][22] = T_WHITE; grid[11][23] = '#ffffff';
  // Lower nose contour:
  grid[12][18] = T_GLINT; grid[12][19] = T_MID;   grid[12][20] = T_BASE_D;

  // 5. MAIN FUSELAGE & FLANK LIVERY BADGE (x: 2..18, y: 9..12)
  // Row 9 (Upper Fuselage)
  grid[9][3]  = T_OUTLINE; grid[9][4]  = T_BASE_D; grid[9][5]  = T_BASE;   grid[9][6]  = T_MID;
  grid[9][7]  = 'TEAM';   grid[9][8]  = 'TEAM';   grid[9][9]  = 'TEAM';   grid[9][10] = 'TEAM';
  grid[9][11] = T_MID;    grid[9][12] = T_BASE;

  // Row 10 (Fuselage Centerline)
  grid[10][2] = T_OUTLINE; grid[10][3] = T_BASE_D; grid[10][4] = T_BASE;   grid[10][5] = T_BASE; grid[10][6] = T_MID;
  grid[10][7] = 'TEAM';   grid[10][8] = 'TEAM';   grid[10][9] = 'TEAM';   grid[10][10] = 'TEAM';
  grid[10][11] = T_MID;   grid[10][12] = T_BASE;
  for (let x = 13; x <= 17; x++) grid[10][x] = T_MID;

  // Row 11 (Mid-Lower Fuselage)
  grid[11][2] = T_OUTLINE; grid[11][3] = T_DARK;
  for (let x = 4; x <= 12; x++) grid[11][x] = T_BASE_D;
  for (let x = 13; x <= 17; x++) grid[11][x] = T_BASE;

  // Row 12 (Fuselage Chine & Wing Mount Shelf)
  grid[12][2] = T_OUTLINE; grid[12][3] = T_DARK;
  for (let x = 4; x <= 17; x++) grid[12][x] = T_BASE_D;

  // 6. DELTA WING IN SIDE PROFILE (y: 13, x: 5..16)
  grid[13][4] = T_OUTLINE; grid[13][5] = T_DARK;
  grid[13][6] = T_BASE_D;  grid[13][7] = T_BASE;  grid[13][8] = T_BASE;
  grid[13][9] = T_MID;     grid[13][10] = T_MID;  grid[13][11] = T_HI; grid[13][12] = T_GLINT; grid[13][13] = T_SHINE; grid[13][14] = T_GLINT; grid[13][15] = T_BASE;

  // 7. WEAPON PYLONS & DUAL ROCKET MISSILES (y: 14..16, x: 7..17)
  // Pylon hardpoint mounting
  grid[14][8] = T_DARK; grid[14][9] = T_DARK; grid[14][10] = T_DARK;

  // Missile 1 (Upper primary missile: y: 14, x: 10..17)
  grid[14][10] = T_BASE_D; grid[14][11] = T_SHINE;  grid[14][12] = T_WHITE; grid[14][13] = T_WHITE; // Rocket body
  grid[14][14] = '#dc2626'; grid[14][15] = '#ef4444'; grid[14][16] = '#ef4444'; // Red warhead cone
  grid[14][17] = '#facc15'; // Amber seeker optic tip!

  // Missile 2 (Lower tandem missile: y: 15..16, x: 7..15)
  grid[15][7]  = T_DARK;   grid[15][8]  = T_BASE_D;
  grid[15][9]  = T_SHINE;  grid[15][10] = T_WHITE;  grid[15][11] = T_WHITE;
  grid[15][12] = '#dc2626'; grid[15][13] = '#ef4444'; grid[15][14] = '#ef4444'; grid[15][15] = '#facc15';
  // Missile lower 3D shadow:
  grid[16][9]  = T_BASE_D; grid[16][10] = T_GLINT;  grid[16][11] = T_SHINE;
  grid[16][12] = '#991b1b'; grid[16][13] = '#b91c1c'; grid[16][14] = '#dc2626';

  // 8. VENTRAL ENGINE COWL & LOWER STRAKE (-X rear: y: 13..16, x: 2..6)
  grid[14][2] = T_OUTLINE; grid[14][3] = T_DARK;
  grid[15][2] = T_OUTLINE; grid[15][3] = T_DARK; grid[15][4] = T_BASE_D;
  grid[16][2] = T_OUTLINE; grid[16][3] = T_DARK; grid[16][4] = T_BASE_D;
  grid[17][2] = T_OUTLINE; grid[17][3] = T_DARK;

  // 9. TWIN ROCKET SCRAMJET ENGINES & AFTERBURNERS (-X rear: x: 0..3)
  // Upper Thruster Nozzle (y: 9..10, x: 1..3)
  grid[9][1]  = T_OUTLINE; grid[9][2]  = T_BASE_D; grid[9][3]  = T_BASE;
  grid[10][1] = T_OUTLINE; grid[10][2] = T_DARK;   grid[10][3] = T_BASE_D;
  // Upper Afterburner Exhaust Flame (x: 0..1, y: 9..10)
  grid[9][0]  = '#fef08a'; grid[9][1]  = '#ffffff'; // White-hot plasma core
  grid[10][0] = '#f97316'; grid[10][1] = '#fb923c';

  // Lower Thruster Nozzle (y: 12..13, x: 1..3)
  grid[12][1] = T_OUTLINE; grid[12][2] = T_DARK;   grid[12][3] = T_BASE_D;
  grid[13][1] = T_OUTLINE; grid[13][2] = T_DARK;
  // Lower Afterburner Exhaust Flame (x: 0..1, y: 12..13)
  grid[12][0] = '#f97316'; grid[12][1] = '#fb923c';
  grid[13][0] = '#fef08a'; grid[13][1] = '#ffffff'; // White-hot plasma core

  return { gridSize: g, grid };
}

// ============================================================================
// A9 PIRANHA — 36x36 HD ATTACK GUNSHIP SPRITE
// Authentisches Militär-Kampfflugzeug / Kampfhubschrauber-Design:
// - Gestaffeltes Tandem-Stealthcockpit (Stepped Stadium: erhöhter Bordschütze hinten, tieferer Pilot vorn)
// - Durchgehende diagonale 45° Windschutzscheiben-Reflexion mit Facettenkanten
// - Horizontale Turbinentriebwerk-Gondel mit nach hinten gerichtetem Abgaskonus (Aft Exhaust Nozzle)
// - Seitliche Pylonen-Stummelflügel mit horizontal gestaffelten Doppel-Hellfire-Raketenwerferrohren
// - Messerscharfe Stealth-Knickkanten (Chine Lines) und spitzer Pitot-Sonden-Keilbug
// - Klassische, tiefprofilige Militär-Rohrkufen mit Stoßdämpfern und freistehender Unterflur-Maschinenkanone
// - Weißer Arktis-Tigerstreifen-Tarnanstrich (Off-white Titanium & Shadow Charcoal)
// ============================================================================
function getHD_A9Piranha_Hull() {
  const g = 36, grid = makeGrid36();

  const OUT        = '#090d16'; // Tiefe Außenkonturen & Strukturkanten
  const SHADOW     = '#0f172a'; // Schattenfugen & Unterboden
  const DARK_CAMO  = '#14231a'; // Dunkler Kern der Tigerstreifen
  const STRIPE     = '#1e293b'; // Titan-Anthrazit Tigerstreifenband
  const STEEL_D    = '#1e293b'; // Dunkle Mechanik / Gestänge
  const STEEL_M    = '#334155'; // Geschwärzter Waffenstahl
  const STEEL_MID  = '#475569'; // Mittlerer Rumpfstahl
  const STEEL_HI   = '#64748b'; // Lichtkanten & Fasen

  // Tigerstreifen-Grundpanzerung (Off-White / Titan-Silber)
  const CAMO_D     = '#64748b'; // Beschattete Unterseiten
  const CAMO_M     = '#94a3b8'; // Mittlere Tarnpaneele
  const CAMO_HI    = '#cbd5e1'; // Helle Basis-Panzerung
  const CAMO_L     = '#e2e8f0'; // Sonnenbeschienene Oberflächen
  const CAMO_W     = '#f8fafc'; // Glanzkanten & Raketenspitzen

  // Stealth-Cockpitverglasung (Himmels- & Cyan-Reflexionen)
  const GLASS_DD   = '#082f49'; // Tiefer Cockpitboden
  const GLASS_D    = '#0369a1'; // Tiefblaues Panzerglas
  const GLASS_M    = '#0284c7'; // Cyanfarbener Glaskörper
  const GLASS_HI   = '#38bdf8'; // Helle Himmelsspiegelung
  const GLASS_L    = '#7dd3fc'; // Leuchtendes Glas
  const GLASS_W    = '#ffffff'; // Glanzreflexion

  // Signal- & Sensor-Akzente
  const OPTIC_GOLD = '#facc15'; // FLIR-Wärmebildoptik & Rotorwarnspitzen
  const OPTIC_CORE = '#f59e0b'; // Sensorlinse / Blende
  const STROBE     = '#4ade80'; // Grünes Navigations-Stroboskop

  // Row 7
  grid[7][4] = STROBE; grid[7][5] = OUT;
  // Row 8
  grid[8][3] = OUT; grid[8][4] = CAMO_W; grid[8][5] = CAMO_L; grid[8][6] = OUT;
  grid[8][20] = CAMO_W; grid[8][21] = STEEL_HI;
  // Row 9
  grid[9][1] = OPTIC_GOLD; grid[9][3] = OUT; grid[9][4] = CAMO_HI; grid[9][5] = CAMO_L;
  grid[9][6] = OUT; grid[9][19] = OUT; grid[9][20] = CAMO_HI; grid[9][21] = STRIPE;
  // Row 10
  grid[10][1] = CAMO_W; grid[10][2] = OUT; grid[10][3] = STRIPE; grid[10][4] = DARK_CAMO;
  grid[10][5] = CAMO_HI; grid[10][6] = OUT; grid[10][19] = OUT; grid[10][20] = STEEL_HI;
  grid[10][21] = STRIPE;
  // Row 11
  grid[11][1] = CAMO_HI; grid[11][2] = OUT; grid[11][3] = STRIPE; grid[11][4] = DARK_CAMO;
  grid[11][5] = CAMO_HI; grid[11][6] = OUT; grid[11][19] = STEEL_MID; grid[11][20] = CAMO_M;
  grid[11][21] = STRIPE;
  // Row 12
  grid[12][1] = CAMO_M; grid[12][2] = OUT; grid[12][3] = CAMO_HI; grid[12][4] = CAMO_L;
  grid[12][5] = STRIPE; grid[12][6] = OUT; grid[12][10] = SHADOW; grid[12][11] = STRIPE;
  grid[12][12] = STEEL_M; grid[12][13] = OUT; grid[12][14] = CAMO_L; grid[12][15] = STRIPE;
  grid[12][16] = DARK_CAMO; grid[12][17] = CAMO_HI; grid[12][18] = CAMO_L;
  grid[12][19] = STEEL_M; grid[12][20] = STEEL_HI; grid[12][21] = CAMO_L; grid[12][22] = OUT;
  // Row 13
  grid[13][1] = STEEL_HI; grid[13][2] = OUT; grid[13][3] = CAMO_HI; grid[13][4] = CAMO_M;
  grid[13][5] = STRIPE; grid[13][6] = OUT; grid[13][7] = DARK_CAMO; grid[13][8] = CAMO_W;
  grid[13][9] = CAMO_HI; grid[13][10] = OUT; grid[13][11] = SHADOW; grid[13][12] = STRIPE;
  grid[13][13] = SHADOW; grid[13][14] = STRIPE; grid[13][15] = DARK_CAMO;
  grid[13][16] = CAMO_HI; grid[13][17] = CAMO_L; grid[13][18] = CAMO_W; grid[13][19] = STRIPE;
  grid[13][20] = STEEL_MID; grid[13][21] = STRIPE; grid[13][23] = OUT; grid[13][24] = STEEL_HI;
  grid[13][25] = STEEL_HI; grid[13][26] = OUT;
  // Row 14
  grid[14][1] = OUT; grid[14][2] = SHADOW; grid[14][3] = OPTIC_GOLD; grid[14][4] = CAMO_HI;
  grid[14][5] = STRIPE; grid[14][6] = DARK_CAMO; grid[14][7] = CAMO_L; grid[14][8] = CAMO_HI;
  grid[14][9] = STRIPE; grid[14][10] = OUT; grid[14][11] = STRIPE; grid[14][12] = STEEL_M;
  grid[14][13] = STEEL_M; grid[14][14] = STRIPE; grid[14][15] = DARK_CAMO;
  grid[14][16] = CAMO_HI; grid[14][17] = CAMO_L; grid[14][18] = CAMO_HI;
  grid[14][19] = CAMO_HI; grid[14][20] = CAMO_L; grid[14][21] = STRIPE; grid[14][23] = OUT;
  grid[14][24] = GLASS_HI; grid[14][25] = GLASS_W; grid[14][26] = GLASS_HI; grid[14][27] = OUT;
  // Row 15
  grid[15][1] = OUT; grid[15][2] = STRIPE; grid[15][3] = SHADOW; grid[15][4] = STRIPE;
  grid[15][5] = DARK_CAMO; grid[15][6] = CAMO_M; grid[15][7] = STEEL_HI; grid[15][8] = STRIPE;
  grid[15][9] = DARK_CAMO; grid[15][10] = CAMO_M; grid[15][11] = STEEL_HI;
  grid[15][12] = CAMO_M; grid[15][13] = OUT; grid[15][14] = CAMO_M; grid[15][15] = STRIPE;
  grid[15][16] = DARK_CAMO; grid[15][17] = CAMO_HI; grid[15][18] = CAMO_HI;
  grid[15][19] = CAMO_M; grid[15][20] = CAMO_HI; grid[15][21] = STRIPE; grid[15][23] = OUT;
  grid[15][24] = GLASS_D; grid[15][25] = GLASS_M; grid[15][26] = GLASS_HI;
  grid[15][27] = STEEL_MID; grid[15][28] = STEEL_HI; grid[15][29] = GLASS_W;
  grid[15][30] = OUT;
  // Row 16
  grid[16][1] = STEEL_HI; grid[16][4] = OUT; grid[16][5] = OUT; grid[16][6] = OUT;
  grid[16][7] = OUT; grid[16][8] = OUT; grid[16][9] = OUT; grid[16][10] = OUT;
  grid[16][11] = OUT; grid[16][12] = CAMO_M; grid[16][13] = STRIPE; grid[16][14] = DARK_CAMO;
  grid[16][15] = CAMO_HI; grid[16][16] = CAMO_L; grid[16][17] = CAMO_HI; grid[16][18] = CAMO_W;
  grid[16][19] = STRIPE; grid[16][20] = DARK_CAMO; grid[16][21] = STRIPE; grid[16][23] = OUT;
  grid[16][24] = GLASS_DD; grid[16][25] = GLASS_D; grid[16][26] = GLASS_M;
  grid[16][27] = STRIPE; grid[16][28] = GLASS_HI; grid[16][29] = GLASS_M;
  grid[16][30] = GLASS_W; grid[16][31] = OUT;
  // Row 17
  grid[17][1] = CAMO_M; grid[17][3] = STEEL_HI; grid[17][4] = STRIPE; grid[17][12] = OUT;
  grid[17][13] = CAMO_W; grid[17][14] = STRIPE; grid[17][15] = DARK_CAMO;
  grid[17][16] = CAMO_HI; grid[17][17] = CAMO_L; grid[17][18] = CAMO_HI; grid[17][19] = STRIPE;
  grid[17][20] = DARK_CAMO; grid[17][21] = CAMO_HI; grid[17][26] = OUT; grid[17][27] = STRIPE;
  grid[17][28] = GLASS_D; grid[17][29] = GLASS_M; grid[17][30] = GLASS_HI;
  grid[17][31] = GLASS_W; grid[17][32] = OUT;
  // Row 18
  grid[18][1] = CAMO_HI; grid[18][2] = OUT; grid[18][3] = STEEL_M; grid[18][4] = OUT;
  grid[18][13] = OUT; grid[18][14] = CAMO_L; grid[18][15] = CAMO_HI; grid[18][16] = CAMO_L;
  grid[18][17] = OUT; grid[18][18] = 'TEAM'; grid[18][19] = 'TEAM'; grid[18][20] = 'TEAM';
  grid[18][21] = OUT; grid[18][22] = CAMO_W; grid[18][23] = STRIPE; grid[18][24] = DARK_CAMO;
  grid[18][25] = STRIPE; grid[18][26] = CAMO_W; grid[18][27] = CAMO_L; grid[18][28] = CAMO_HI;
  grid[18][29] = CAMO_HI; grid[18][30] = CAMO_HI; grid[18][31] = CAMO_W; grid[18][32] = OUT;
  grid[18][33] = CAMO_HI; grid[18][34] = OUT;
  // Row 19
  grid[19][1] = CAMO_W; grid[19][2] = OUT; grid[19][3] = OUT; grid[19][14] = OUT;
  grid[19][15] = CAMO_L; grid[19][16] = CAMO_HI; grid[19][17] = OUT; grid[19][18] = 'TEAM';
  grid[19][19] = 'TEAM'; grid[19][20] = STEEL_MID; grid[19][21] = STEEL_HI;
  grid[19][22] = CAMO_M; grid[19][23] = STRIPE; grid[19][24] = DARK_CAMO;
  grid[19][25] = CAMO_HI; grid[19][26] = STRIPE; grid[19][27] = DARK_CAMO;
  grid[19][28] = CAMO_HI; grid[19][29] = OUT; grid[19][30] = CAMO_HI; grid[19][31] = STRIPE;
  grid[19][32] = DARK_CAMO; grid[19][33] = CAMO_HI; grid[19][34] = CAMO_W;
  grid[19][35] = CAMO_W;
  // Row 20
  grid[20][1] = OPTIC_GOLD; grid[20][15] = OUT; grid[20][16] = CAMO_L; grid[20][17] = CAMO_HI;
  grid[20][18] = STRIPE; grid[20][19] = STEEL_M; grid[20][20] = STRIPE; grid[20][21] = STRIPE;
  grid[20][22] = STRIPE; grid[20][23] = SHADOW; grid[20][24] = STEEL_MID;
  grid[20][25] = STEEL_HI; grid[20][26] = STEEL_M; grid[20][27] = STEEL_MID;
  grid[20][28] = STEEL_HI; grid[20][29] = CAMO_W; grid[20][30] = STRIPE; grid[20][31] = STRIPE;
  grid[20][32] = CAMO_HI; grid[20][33] = OUT;
  // Row 21
  grid[21][16] = OUT; grid[21][17] = CAMO_M; grid[21][18] = STRIPE; grid[21][19] = STEEL_M;
  grid[21][20] = STRIPE; grid[21][21] = SHADOW; grid[21][22] = STRIPE; grid[21][23] = SHADOW;
  grid[21][24] = STEEL_MID; grid[21][25] = STEEL_HI; grid[21][26] = STEEL_M;
  grid[21][27] = STEEL_MID; grid[21][28] = STEEL_HI; grid[21][29] = CAMO_W;
  grid[21][30] = CAMO_HI; grid[21][31] = OUT; grid[21][32] = OPTIC_GOLD;
  grid[21][33] = OPTIC_CORE; grid[21][34] = OUT;
  // Row 22
  grid[22][16] = SHADOW; grid[22][17] = STRIPE; grid[22][18] = OUT; grid[22][22] = OUT;
  grid[22][23] = SHADOW; grid[22][24] = STRIPE; grid[22][25] = STRIPE; grid[22][26] = OUT;
  grid[22][27] = OUT; grid[22][28] = STRIPE; grid[22][29] = SHADOW; grid[22][30] = OUT;
  grid[22][31] = OPTIC_GOLD; grid[22][32] = SHADOW; grid[22][33] = OUT;
  // Row 23
  grid[23][15] = STRIPE; grid[23][16] = STEEL_MID; grid[23][23] = STRIPE;
  grid[23][24] = STEEL_MID; grid[23][28] = SHADOW; grid[23][29] = STRIPE;
  grid[23][30] = STEEL_M; grid[23][31] = STEEL_MID; grid[23][32] = STEEL_HI;
  grid[23][33] = STEEL_HI; grid[23][34] = CAMO_HI; grid[23][35] = CAMO_W;
  // Row 24
  grid[24][15] = SHADOW; grid[24][16] = CAMO_HI; grid[24][23] = SHADOW; grid[24][24] = CAMO_HI;
  grid[24][29] = CAMO_HI; grid[24][30] = CAMO_W; grid[24][31] = OUT;
  // Row 25
  grid[25][13] = STRIPE; grid[25][14] = STEEL_HI; grid[25][15] = CAMO_HI;
  grid[25][16] = STEEL_MID; grid[25][17] = STEEL_MID; grid[25][18] = CAMO_HI;
  grid[25][19] = STEEL_MID; grid[25][20] = STEEL_MID; grid[25][21] = CAMO_HI;
  grid[25][22] = STEEL_MID; grid[25][23] = STEEL_MID; grid[25][24] = CAMO_HI;
  grid[25][25] = STEEL_MID; grid[25][26] = STEEL_MID; grid[25][27] = CAMO_HI;
  grid[25][28] = CAMO_HI;
  // Row 26
  grid[26][15] = SHADOW; grid[26][16] = OUT; grid[26][23] = SHADOW; grid[26][24] = OUT;

  return { grid, gridSize: g };
}

function getHD_A9Piranha_Rotor() {
  const g = 36, grid = makeGrid36();

  const OUT        = '#090d16';
  const SHADOW     = '#0f172a';
  const STEEL_D    = '#1e293b';
  const STEEL_M    = '#334155';
  const STEEL_HI   = '#64748b';
  const CAMO_HI    = '#cbd5e1';
  const CAMO_W     = '#f8fafc';
  const OPTIC_GOLD = '#facc15';

  // Mast collar & hub (x: 19..21, y: 7..9)
  grid[7][20] = CAMO_W;
  grid[8][19] = OUT;       grid[8][20] = CAMO_HI;   grid[8][21] = SHADOW;
  grid[9][19] = STEEL_D;   grid[9][20] = STEEL_HI;  grid[9][21] = SHADOW;

  // Overhead 5-blade main rotor disc (spanning y: 6..7, x: 2..34)
  for (let x = 2; x <= 34; x++) {
    if (x <= 4 || x >= 32) {
      grid[6][x] = OPTIC_GOLD; // High-visibility yellow safety tips
    } else if (x === 20) {
      grid[5][x] = CAMO_W;     // Rotor cap
      grid[6][x] = STEEL_HI;
    } else {
      grid[6][x] = (x % 2 === 0) ? STEEL_D : STEEL_M;
    }
  }

  return { grid, gridSize: g };
}

function getHD_A9Piranha() {
  const g = 36, grid = makeGrid36();
  const h = getHD_A9Piranha_Hull().grid;
  const r = getHD_A9Piranha_Rotor().grid;

  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (h[y][x]) grid[y][x] = h[y][x];
      if (r[y][x]) grid[y][x] = r[y][x];
    }
  }
  return { gridSize: g, grid };
}

function _composeA9PiranhaSpin(phase = 0) {
  const g = 36, grid = makeGrid36();
  const h = getHD_A9Piranha_Hull().grid;
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (h[y][x]) grid[y][x] = h[y][x];
    }
  }
  const OUT        = '#090d16';
  const SHADOW     = '#0f172a';
  const STEEL_D    = '#1e293b';
  const STEEL_M    = '#334155';
  const STEEL_HI   = '#64748b';
  const CAMO_HI    = '#cbd5e1';
  const CAMO_W     = '#f8fafc';
  const OPTIC_GOLD = '#facc15';

  // Mast collar & hub (x: 19..21, y: 7..9)
  grid[7][20] = CAMO_W;
  grid[8][19] = OUT;       grid[8][20] = CAMO_HI;   grid[8][21] = SHADOW;
  grid[9][19] = STEEL_D;   grid[9][20] = STEEL_HI;  grid[9][21] = SHADOW;

  // Overhead 5-blade spinning rotor disc (2.5D ellipse)
  const theta = (phase / 4) * ((Math.PI * 2) / 5);
  for (let b = 0; b < 5; b++) {
    const ang = theta + b * ((Math.PI * 2) / 5);
    const tipX = 20 + 15 * Math.cos(ang);
    const tipY = 6 + 2.4 * Math.sin(ang);
    const steps = Math.max(Math.abs(tipX - 20), Math.abs(tipY - 6), 1);
    for (let s = 1; s <= steps; s++) {
      const t = s / steps;
      const x = Math.round(20 + (tipX - 20) * t);
      const y = Math.round(6 + (tipY - 6) * t);
      if (x >= 0 && x < g && y >= 0 && y < g) {
        grid[y][x] = t > 0.82 ? OPTIC_GOLD : (t > 0.4 ? STEEL_HI : (s % 2 === 0 ? STEEL_D : STEEL_M));
      }
    }
  }
  grid[5][20] = CAMO_W;     // Rotor cap
  grid[6][20] = STEEL_HI;

  return { grid, gridSize: g };
}
function getHD_A9Piranha_Spin1() { return _composeA9PiranhaSpin(0); }
function getHD_A9Piranha_Spin2() { return _composeA9PiranhaSpin(1); }
function getHD_A9Piranha_Spin3() { return _composeA9PiranhaSpin(2); }
function getHD_A9Piranha_Spin4() { return _composeA9PiranhaSpin(3); }

// ============================================================================
// A9 PIGEON — 36x36 HD HEAVY VTOL FIGHTER-BOMBER & WINGMAN PIGEON RIG
// 75° 2.5D Side-Profile Perspective (matching Rocketship & A9Piranha):
// - Prominent Iridescent Pigeon-Neck Nose (Emerald-Teal -> Amethyst-Violet plumage sheen)
// - Flush Glossy Cyan Cockpit Canopy (Rocketship visor palette)
// - Separate Pivoting Vector-Thrust Jet Engine Sprites (Horiz 0°, Diag 45°, Vert 90°)
// - Separate Chin-Mounted Rotary Gatling Gun (Spin1 / Spin2)
// - Separate Detachable Heavy Ground Bomb under fuselage
// - Separate 3-Frame 8-Bit Pigeon Sprite (Flap1..3) for Wingman & Death Flock
// ============================================================================
function getHD_A9Pigeon_Hull() {
  const g = 36, grid = makeGrid36();

  const OUT       = '#090d16'; // Deep contour
  const SHADOW    = '#0f172a'; // Deep shadow / vents
  const STEEL_D   = '#1e293b'; // Dark structural titanium
  const STEEL_M   = '#334155'; // Mid military hull armor
  const STEEL_L   = '#475569'; // Lit armor plate
  const STEEL_HI  = '#64748b'; // Specular edge
  const GLINT     = '#94a3b8'; // Metallic bevel
  const SHINE     = '#cbd5e1'; // High-light trim
  const CHROME    = '#cbd5e1'; // Polished chrome trim
  const WHITE     = '#f1f5f9'; // Specular peak

  // Weathered warm bronze/oxide aircraft skin accents (from 1_a9pigeon.png)
  const WARM_D    = '#44403c';
  const WARM_M    = '#78716c';
  const WARM_L    = '#a8a29e';
  const WARM_HI   = '#d6d3d1';

  // Iridescent Pigeon-Neck Nose Palette (Emerald-Teal -> Amethyst-Magenta with micro-scale glints)
  const TEAL_D    = '#064e3b';
  const TEAL_M    = '#0d9488';
  const TEAL_L    = '#14b8a6';
  const TEAL_HI   = '#2dd4bf';
  const TEAL_GLOW = '#99f6e4';

  const PURP_D    = '#581c87';
  const PURP_M    = '#7e22ce';
  const PURP_L    = '#a855f7';
  const PURP_HI   = '#c084fc';
  const MAG_GLOW  = '#e879f9';

  // 1. FAR 90° WING (Extending straight UP in aft third: y: 5..12, razor-straight chord x: 9..12 with Sleek Streamlined Tip Missile Rail)
  // Row 5 (Tapered Top Silhouette Seal of Far Wingtip Rail)
  for (let x = 9; x <= 14; x++) grid[5][x] = OUT;
  // Row 6 (Sleek Far Wingtip Missile Rail Body & Aerodynamic Bullet Nose - flush aft, no blocky heel)
  grid[6][8]   = OUT;     grid[6][9]   = STEEL_D; grid[6][10]  = STEEL_M; grid[6][11]  = CHROME;   grid[6][12]  = SHINE;    grid[6][13]  = WHITE;    grid[6][14] = WHITE; grid[6][15] = GLINT; grid[6][16] = OUT;
  // Row 7 (Far Wingtip Mounting Pylon & Rail Under-bracket)
  grid[7][8]   = OUT;     grid[7][9]   = STEEL_D; grid[7][10]  = STEEL_M; grid[7][11]  = WARM_L;   grid[7][12]  = SHINE;    grid[7][13]  = STEEL_L;  grid[7][14]  = OUT;
  // Row 8 (Mid Outer Wing Span & Leading Edge Slat)
  grid[8][8]   = OUT;     grid[8][9]   = STEEL_D; grid[8][10]  = WARM_L;  grid[8][11]  = WHITE;    grid[8][12]  = SHINE;    grid[8][13]  = OUT;
  // Row 9 (Mid Wing Span & Panel Seam)
  grid[9][8]   = OUT;     grid[9][9]   = STEEL_M; grid[9][10]  = WARM_M;  grid[9][11]  = WARM_L;   grid[9][12]  = GLINT;    grid[9][13]  = OUT;
  // Row 10 (Far Wing Inboard Panel)
  grid[10][8]  = OUT;     grid[10][9]  = STEEL_D; grid[10][10] = WARM_M;  grid[10][11] = SHINE;    grid[10][12] = GLINT;    grid[10][13] = OUT;
  // Row 11 (Far Wing Root Fillet into Dorsal Spine)
  grid[11][8]  = OUT;     grid[11][9]  = STEEL_M; grid[11][10] = WARM_HI; grid[11][11] = SHINE;    grid[11][12] = STEEL_L;  grid[11][13] = OUT;
  // Row 12 (Far Wing Fairing merging with fuselage top)
  grid[12][8]  = OUT;     grid[12][9]  = STEEL_D; grid[12][10] = WARM_M;  grid[12][11] = SHINE;    grid[12][12] = STEEL_L;  grid[12][13] = OUT;

  // 2. FLUSH LOW-PROFILE COCKPIT CANOPY (Polarized Visor + Internal Pilot Silhouette + HUD glow: y: 11..13, x: 17..24)
  grid[11][18] = OUT;     grid[11][19] = '#0369a1'; grid[11][20] = '#38bdf8'; grid[11][21] = '#67e8f9'; grid[11][22] = WHITE;     grid[11][23] = OUT;
  grid[12][17] = OUT;     grid[12][18] = '#082f49'; grid[12][19] = '#1e293b'; grid[12][20] = '#0284c7'; grid[12][21] = '#34d399'; grid[12][22] = '#38bdf8'; grid[12][23] = '#0284c7'; grid[12][24] = OUT;
  grid[13][17] = STEEL_L; grid[13][18] = '#f59e0b'; grid[13][19] = SHADOW;  grid[13][20] = STEEL_D; grid[13][21] = STEEL_M; grid[13][22] = STEEL_L; grid[13][23] = STEEL_HI;

  // 3. RAZOR-SLEEK SUPERSONIC DART NOSE & VIBRANT PIGEON-NECK FEATHER SCALES (y: 13..16, x: 21..35)
  // Row 13 (Upper Iridescent Cowl Slope)
  grid[13][24] = OUT;     grid[13][25] = PURP_D;  grid[13][26] = PURP_M;  grid[13][27] = PURP_L;  grid[13][28] = TEAL_M;  grid[13][29] = TEAL_HI; grid[13][30] = OUT;
  // Row 14 (Upper Nose Ridge & Shimmering Micro-Feather Plumage)
  grid[14][22] = PURP_D;  grid[14][23] = PURP_M;  grid[14][24] = PURP_HI; grid[14][25] = MAG_GLOW;
  grid[14][26] = PURP_HI; grid[14][27] = '#818cf8'; grid[14][28] = TEAL_HI; grid[14][29] = TEAL_GLOW;
  grid[14][30] = WHITE;   grid[14][31] = TEAL_GLOW; grid[14][32] = TEAL_HI; grid[14][33] = OUT;
  // Row 15 (Needle Nose Centerline, Titanium Panel Rivets & Needle Pitot Tip)
  grid[15][21] = STEEL_M; grid[15][22] = PURP_D;  grid[15][23] = PURP_M;  grid[15][24] = PURP_HI;
  grid[15][25] = PURP_L;  grid[15][26] = TEAL_M;  grid[15][27] = TEAL_L;  grid[15][28] = TEAL_HI;
  grid[15][29] = TEAL_L;  grid[15][30] = TEAL_M;  grid[15][31] = TEAL_L;  grid[15][32] = TEAL_HI;
  grid[15][33] = STEEL_L; grid[15][34] = GLINT;   grid[15][35] = WHITE;
  // Row 16 (Slender Lower Radome & Chin Recess)
  grid[16][22] = OUT;     grid[16][23] = STEEL_D; grid[16][24] = STEEL_M; grid[16][25] = TEAL_D;
  grid[16][26] = TEAL_M;  grid[16][27] = TEAL_D;  grid[16][28] = STEEL_D; grid[16][29] = TEAL_D;
  grid[16][30] = TEAL_M;  grid[16][31] = STEEL_M; grid[16][32] = STEEL_D; grid[16][33] = OUT;
  // Row 17 (Gatling Recessed Rail under Chin)
  for (let x = 24; x <= 33; x++) grid[17][x] = OUT;

  // 4. SLENDER STREAMLINED FUSELAGE & REAR GIMBAL COLLAR (y: 13..17, x: 6..21)
  // Row 13 (Sunlit Titanium Dorsal Spine with NACA Cooling Duct)
  grid[13][7]  = OUT;     grid[13][8]  = GLINT;   grid[13][9]  = SHINE;   grid[13][10] = SHADOW;
  grid[13][11] = SHADOW;  grid[13][12] = WARM_M;  grid[13][13] = STEEL_L; grid[13][14] = STEEL_M;
  grid[13][15] = STEEL_HI; grid[13][16] = GLINT;
  // Row 14 (Aft Body, Service Hatches & Hydraulic Actuator Mounts)
  grid[14][6]  = OUT;     grid[14][7]  = STEEL_HI; grid[14][8]  = GLINT;   grid[14][9]  = SHINE;
  grid[14][10] = WARM_HI; grid[14][11] = WARM_L;  grid[14][12] = WARM_M;  grid[14][13] = STEEL_HI;
  grid[14][14] = STEEL_L; grid[14][15] = STEEL_M; grid[14][16] = STEEL_D; grid[14][17] = STEEL_M;
  grid[14][18] = STEEL_L; grid[14][19] = STEEL_HI; grid[14][20] = STEEL_M; grid[14][21] = PURP_D;
  // Row 15 (Fuselage Centerline, Gimbal Pivot Ear & Panel Rivet Seams)
  grid[15][6]  = OUT;     grid[15][7]  = GLINT;   grid[15][8]  = WHITE;   grid[15][9]  = STEEL_M;
  grid[15][10] = STEEL_L; grid[15][11] = WARM_M;  grid[15][12] = WARM_D;  grid[15][13] = STEEL_M;
  grid[15][14] = STEEL_L; grid[15][15] = STEEL_HI; grid[15][16] = WARM_L;  grid[15][17] = STEEL_M;
  grid[15][18] = STEEL_L; grid[15][19] = STEEL_M; grid[15][20] = PURP_D;
  // Row 16 (Lower Fuselage Keel & Belly Ordnance Channel)
  grid[16][6]  = OUT;     grid[16][7]  = STEEL_D; grid[16][8]  = STEEL_M; grid[16][9]  = SHADOW;
  grid[16][10] = STEEL_D; grid[16][11] = STEEL_M; grid[16][12] = STEEL_L; grid[16][13] = WARM_L;
  grid[16][14] = WARM_M;  grid[16][15] = STEEL_M; grid[16][16] = STEEL_D; grid[16][17] = SHADOW;
  grid[16][18] = STEEL_D; grid[16][19] = STEEL_M; grid[16][20] = STEEL_D; grid[16][21] = OUT;
  // Row 17 (Belly Flush Hardpoint Line & Fuselage Underbelly)
  grid[17][6]  = OUT;     grid[17][7]  = OUT;     grid[17][8]  = STEEL_D; grid[17][9]  = SHADOW;
  grid[17][10] = STEEL_D; grid[17][11] = SHADOW;  grid[17][12] = STEEL_D;
  grid[17][13] = OUT;     grid[17][14] = STEEL_D; grid[17][15] = STEEL_M; grid[17][16] = OUT;
  for (let x = 17; x <= 23; x++) grid[17][x] = OUT;

  // 5. 2.5D NEAR 90° MAIN WING (Razor-straight military titanium plank, mounted far back in aft third: y: 17..26, clean straight chord x: 9..13 with Aerodynamic Tip Missile Rail Pod)
  // Shortened span by 2 px total (Rows 27 & 28 cleared -> ends at Row 26), shifted 1 px forward (trailing outline x=8), 1 px narrower chord (x=9..13)
  // Row 17 (Wing Root Fillet connecting directly ahead of engine collar)
  grid[17][8]  = OUT;     grid[17][9]  = STEEL_D; grid[17][10] = WARM_M;  grid[17][11] = WARM_L;  grid[17][12] = SHINE;   grid[17][13] = STEEL_L; grid[17][14] = OUT;
  // Row 18 (Inboard Root Slat & Panel)
  grid[18][8]  = OUT;     grid[18][9]  = STEEL_D; grid[18][10] = WARM_L;  grid[18][11] = WARM_HI; grid[18][12] = WHITE;   grid[18][13] = SHINE;   grid[18][14] = OUT;
  // Row 19 (Inboard Wing Box & Spar Rivet Line)
  grid[19][8]  = OUT;     grid[19][9]  = STEEL_M; grid[19][10] = WARM_M;  grid[19][11] = WARM_L;  grid[19][12] = SHINE;   grid[19][13] = GLINT;   grid[19][14] = OUT;
  // Row 20 (Mid-Wing Panel with crisp TEAM Insignia Band)
  grid[20][8]  = OUT;     grid[20][9]  = STEEL_D; grid[20][10] = 'TEAM';  grid[20][11] = 'TEAM';  grid[20][12] = SHINE;   grid[20][13] = GLINT;   grid[20][14] = OUT;
  // Row 21 (Mid-Wing Panel with crisp TEAM Insignia Band 2 - straight continuous edges!)
  grid[21][8]  = OUT;     grid[21][9]  = STEEL_M; grid[21][10] = 'TEAM';  grid[21][11] = 'TEAM';  grid[21][12] = WHITE;   grid[21][13] = SHINE;   grid[21][14] = OUT;
  // Row 22 (Outboard Wing Box & Titanium Spar)
  grid[22][8]  = OUT;     grid[22][9]  = STEEL_D; grid[22][10] = WARM_M;  grid[22][11] = WARM_L;  grid[22][12] = SHINE;   grid[22][13] = GLINT;   grid[22][14] = OUT;
  // Row 23 (Outboard Wing Surface with Aileron Split Line)
  grid[23][8]  = OUT;     grid[23][9]  = STEEL_M; grid[23][10] = WARM_L;  grid[23][11] = WARM_HI; grid[23][12] = WHITE;   grid[23][13] = SHINE;   grid[23][14] = OUT;
  // Row 24 (Upper Mounting Pylon of Wingtip Missile Rail - smooth aerodynamic taper)
  grid[24][8]  = OUT;     grid[24][9]  = STEEL_D; grid[24][10] = STEEL_M; grid[24][11] = WARM_L;  grid[24][12] = SHINE;   grid[24][13] = GLINT;   grid[24][14] = OUT;
  // Row 25 (Sleek Cylindrical Missile Launch Rail Body & Aerodynamic Bullet Nose - flush aft, no blocky heel)
  grid[25][8]  = OUT;     grid[25][9]  = STEEL_D; grid[25][10] = STEEL_M; grid[25][11] = CHROME;  grid[25][12] = SHINE;   grid[25][13] = WHITE;   grid[25][14] = WHITE; grid[25][15] = GLINT; grid[25][16] = OUT;
  // Row 26 (Tapered Underside Silhouette Seal & Under-Rail Bevel)
  for (let x = 9; x <= 14; x++) grid[26][x] = OUT;

  return { grid, gridSize: g };
}

function getHD_A9Pigeon_Engine_Horiz() {
  const g = 36, grid = makeGrid36();

  const OUT       = '#090d16';
  const SHADOW    = '#0f172a';
  const NOZ_D     = '#1e293b';
  const NOZ_M     = '#334155';
  const NOZ_L     = '#475569';
  const NOZ_HI    = '#64748b';
  const STRUT     = '#94a3b8';
  const CHROME    = '#cbd5e1';
  const WHITE     = '#ffffff';

  // Metallurgical Titanium Heat-Temper Gradient (Straw Gold -> Purple -> Cobalt Blue -> Charred Lip)
  const TEMPER_G  = '#d97706'; // Anodized straw gold
  const TEMPER_AM = '#b45309'; // Deep amber bronze
  const TEMPER_P  = '#8b5cf6'; // Iridescent violet/purple
  const TEMPER_M  = '#6d28d9'; // Deep magenta heat ring
  const TEMPER_B  = '#3b82f6'; // Electric cobalt blue
  const TEMPER_CB = '#1d4ed8'; // Dark temper blue

  // Supersonic Afterburner Plasma & Turbine Guide Vanes
  const TURB_D    = '#0a0f1d';
  const PLASMA_D  = '#0284c7';
  const PLASMA_M  = '#38bdf8';
  const PLASMA_L  = '#00f0ff';
  const CORE_Y    = '#fef08a';
  const CORE_W    = '#ffffff';

  // High-Tech Pivoting Vector-Thrust Jet Engine (Directed Aft 0°: x: 1..10, y: 12..18)
  // Row 12: Upper Hydraulic Pushrod Clevis & Trunnion Pin
  grid[12][5] = OUT;     grid[12][6] = CHROME;  grid[12][7] = STRUT;   grid[12][8] = OUT;

  // Row 13: Upper Nacelle Casing with Anodized Heat Shield & Pivot Collar
  grid[13][3] = OUT;     grid[13][4] = TEMPER_B; grid[13][5] = TEMPER_P; grid[13][6] = TEMPER_G;
  grid[13][7] = NOZ_HI;  grid[13][8] = STRUT;   grid[13][9] = CHROME;  grid[13][10] = OUT;

  // Row 14: Upper Divergent Vectoring Petals (12-Segment Petal Ring with Seams) & Heat Bloom
  grid[14][2] = OUT;     grid[14][3] = STRUT;   grid[14][4] = OUT;     grid[14][5] = CHROME;
  grid[14][6] = TEMPER_B; grid[14][7] = TEMPER_P; grid[14][8] = TEMPER_AM; grid[14][9] = NOZ_M; grid[14][10] = OUT;

  // Row 15: Engine Centerline — Supersonic Combustion Chamber, Stator Vanes & Bullet Spinner Cone
  grid[15][1] = CORE_Y;  grid[15][2] = CORE_W;  grid[15][3] = PLASMA_L; grid[15][4] = STRUT;
  grid[15][5] = TURB_D;  grid[15][6] = NOZ_M;   grid[15][7] = NOZ_L;   grid[15][8] = STRUT;   grid[15][9] = CHROME;

  // Row 16: Lower Divergent Vectoring Petals & Thermal Temper Gradient
  grid[16][1] = PLASMA_M; grid[16][2] = CORE_W; grid[16][3] = PLASMA_L; grid[16][4] = STRUT;
  grid[16][5] = OUT;     grid[16][6] = TEMPER_B; grid[16][7] = TEMPER_P; grid[16][8] = NOZ_L;   grid[16][9] = NOZ_M; grid[16][10] = OUT;

  // Row 17: Lower Nacelle Shroud, Oil Scavenge Line & Actuator Clevis Boss
  grid[17][2] = OUT;     grid[17][3] = TEMPER_B; grid[17][4] = TEMPER_M; grid[17][5] = NOZ_D;
  grid[17][6] = SHADOW;  grid[17][7] = STRUT;   grid[17][8] = NOZ_D;   grid[17][9] = OUT;

  // Row 18: Lower Actuator Anchor Boss
  grid[18][5] = OUT;     grid[18][6] = NOZ_D;   grid[18][7] = STRUT;   grid[18][8] = OUT;

  return { grid, gridSize: g };
}

function getHD_A9Pigeon_Engine_Diag() {
  const g = 36, grid = makeGrid36();

  const OUT       = '#090d16';
  const SHADOW    = '#0f172a';
  const NOZ_D     = '#1e293b';
  const NOZ_M     = '#334155';
  const NOZ_L     = '#475569';
  const NOZ_HI    = '#64748b';
  const STRUT     = '#94a3b8';
  const CHROME    = '#cbd5e1';

  const TEMPER_G  = '#d97706';
  const TEMPER_P  = '#8b5cf6';
  const TEMPER_B  = '#3b82f6';

  const TURB_D    = '#0a0f1d';
  const PLASMA_D  = '#0284c7';
  const PLASMA_M  = '#38bdf8';
  const PLASMA_L  = '#00f0ff';
  const CORE_Y    = '#fef08a';
  const CORE_W    = '#ffffff';

  // Vector-Thrust Jet Engine in 45° Transition with Articulating Linkages (x: 2..10, y: 13..23)
  grid[13][7] = OUT;     grid[13][8] = CHROME;  grid[13][9] = STRUT;
  grid[14][6] = OUT;     grid[14][7] = CHROME;  grid[14][8] = STRUT;   grid[14][9] = OUT;
  grid[15][5] = OUT;     grid[15][6] = STRUT;   grid[15][7] = NOZ_HI;  grid[15][8] = NOZ_M;   grid[15][9] = OUT;
  grid[16][4] = OUT;     grid[16][5] = TEMPER_B; grid[16][6] = TEMPER_P; grid[16][7] = NOZ_HI; grid[16][8] = SHADOW; grid[16][9] = OUT;
  grid[17][3] = OUT;     grid[17][4] = TEMPER_P; grid[17][5] = TEMPER_G; grid[17][6] = NOZ_L;  grid[17][7] = NOZ_D;  grid[17][8] = OUT;
  grid[18][2] = OUT;     grid[18][3] = STRUT;   grid[18][4] = NOZ_M;   grid[18][5] = TURB_D;  grid[18][6] = SHADOW; grid[18][7] = OUT;
  grid[19][2] = PLASMA_M; grid[19][3] = PLASMA_L; grid[19][4] = STRUT;  grid[19][5] = SHADOW; grid[19][6] = OUT;
  grid[20][1] = CORE_Y;  grid[20][2] = CORE_W;  grid[20][3] = PLASMA_M; grid[20][4] = OUT;
  grid[21][1] = PLASMA_L; grid[21][2] = CORE_W; grid[21][3] = CORE_Y;
  grid[22][1] = PLASMA_D; grid[22][2] = PLASMA_M;

  return { grid, gridSize: g };
}

function getHD_A9Pigeon_Engine_Vert() {
  const g = 36, grid = makeGrid36();

  const OUT       = '#090d16';
  const SHADOW    = '#0f172a';
  const NOZ_D     = '#1e293b';
  const NOZ_M     = '#334155';
  const NOZ_L     = '#475569';
  const NOZ_HI    = '#64748b';
  const STRUT     = '#94a3b8';
  const CHROME    = '#cbd5e1';

  const TEMPER_G  = '#d97706';
  const TEMPER_P  = '#8b5cf6';
  const TEMPER_B  = '#3b82f6';

  const PLASMA_D  = '#0284c7';
  const PLASMA_M  = '#38bdf8';
  const PLASMA_L  = '#00f0ff';
  const CORE_Y    = '#fef08a';
  const CORE_W    = '#ffffff';

  // Vector-Thrust Jet Engine Directed 90° DOWNWARD with Extended Telescoping Actuators (x: 4..10, y: 13..25)
  // Gimbal Swivel Ring & Upper Clevis Trunnions
  grid[13][6] = OUT;     grid[13][7] = CHROME;  grid[13][8] = STRUT;   grid[13][9] = OUT;
  grid[14][5] = OUT;     grid[14][6] = STRUT;   grid[14][7] = CHROME;  grid[14][8] = STRUT;   grid[14][9] = OUT;
  grid[15][4] = OUT;     grid[15][5] = STRUT;   grid[15][6] = NOZ_HI;  grid[15][7] = NOZ_M;   grid[15][8] = NOZ_D;  grid[15][9] = OUT;

  // Circumferential Titanium Heat-Temper Bands (Gold -> Purple -> Blue)
  grid[16][4] = OUT;     grid[16][5] = TEMPER_G; grid[16][6] = TEMPER_P; grid[16][7] = TEMPER_B; grid[16][8] = NOZ_M; grid[16][9] = OUT;
  grid[17][4] = OUT;     grid[17][5] = TEMPER_P; grid[17][6] = TEMPER_B; grid[17][7] = NOZ_L;  grid[17][8] = NOZ_D;  grid[17][9] = OUT;

  // Articulated 12-Segment Downward Petal Shroud & Expansion Slits
  grid[18][4] = OUT;     grid[18][5] = NOZ_HI;  grid[18][6] = OUT;     grid[18][7] = NOZ_L;   grid[18][8] = SHADOW; grid[18][9] = OUT;
  grid[19][4] = OUT;     grid[19][5] = STRUT;   grid[19][6] = NOZ_M;   grid[19][7] = STRUT;   grid[19][8] = SHADOW; grid[19][9] = OUT;
  grid[20][4] = OUT;     grid[20][5] = NOZ_M;   grid[20][6] = NOZ_D;   grid[20][7] = NOZ_D;   grid[20][8] = SHADOW; grid[20][9] = OUT;

  // Exhaust Nozzle Convergent-Divergent Lip
  grid[21][4] = OUT;     grid[21][5] = PLASMA_D; grid[21][6] = PLASMA_L; grid[21][7] = PLASMA_L; grid[21][8] = PLASMA_D; grid[21][9] = OUT;

  // Supersonic Downward Thrust Plume & Mach Core
  grid[22][5] = PLASMA_M; grid[22][6] = CORE_W;   grid[22][7] = CORE_W;   grid[22][8] = PLASMA_M;
  grid[23][5] = CORE_Y;   grid[23][6] = CORE_W;   grid[23][7] = CORE_W;   grid[23][8] = PLASMA_M;
  grid[24][5] = PLASMA_L; grid[24][6] = CORE_Y;   grid[24][7] = CORE_Y;   grid[24][8] = PLASMA_L;
  grid[25][6] = PLASMA_M; grid[25][7] = PLASMA_M;

  return { grid, gridSize: g };
}

function getHD_A9Pigeon_Gatling(spinPhase = 0) {
  const g = 36, grid = makeGrid36();

  const OUT     = '#090d16';
  const SHADOW  = '#0f172a';
  const GUN_D   = '#1e293b';
  const GUN_M   = '#334155';
  const GUN_L   = '#475569';
  const GUN_HI  = '#64748b';
  const STEEL   = '#94a3b8';
  const CHROME  = '#e2e8f0';
  const WHITE   = '#ffffff';
  const BRASS_D = '#b45309';
  const BRASS_M = '#d97706';
  const BRASS_L = '#facc15';

  // 6-Barrel Rotary Minigun (Chin-mounted: x: 22..35, y: 16..19)
  // Receiver Housing & Ammunition Chute (x: 22..25, y: 16..19)
  // Articulated Brass Link Feed Chute entering from top
  grid[16][23] = BRASS_D; grid[16][24] = BRASS_M; grid[16][25] = BRASS_L;
  // Receiver Box & Recoil Buffer
  grid[17][22] = OUT;     grid[17][23] = GUN_D;   grid[17][24] = GUN_M;   grid[17][25] = STEEL;
  grid[18][22] = OUT;     grid[18][23] = GUN_M;   grid[18][24] = GUN_HI;  grid[18][25] = CHROME;
  // Ventral Spent Casing Ejection Port Chute
  grid[19][22] = OUT;     grid[19][23] = SHADOW;  grid[19][24] = BRASS_M; grid[19][25] = OUT;

  // Perforated Cooling Jacket Shroud (x: 25..27, y: 17..18)
  grid[17][26] = GUN_M;   grid[17][27] = SHADOW;
  grid[18][26] = STEEL;   grid[18][27] = GUN_M;
  grid[19][26] = OUT;     grid[19][27] = OUT;

  // Rotating 6-Barrel Cluster (x: 28..34, y: 17..18)
  const isP0 = (spinPhase % 2 === 0);
  const barrelTop1 = isP0 ? WHITE   : STEEL;
  const barrelTop2 = isP0 ? CHROME  : GUN_HI;
  const barrelBot1 = isP0 ? GUN_D   : CHROME;
  const barrelBot2 = isP0 ? SHADOW  : GUN_M;

  for (let x = 28; x <= 33; x++) {
    const isCollar = (x === 29 || x === 32);
    if (isCollar) {
      grid[17][x] = CHROME;
      grid[18][x] = GUN_HI;
    } else {
      grid[17][x] = (x % 2 === 0) ? barrelTop1 : barrelTop2;
      grid[18][x] = (x % 2 === 0) ? barrelBot1 : barrelBot2;
    }
    grid[19][x] = OUT;
  }

  // Radial Fluted Muzzle Brake Crown at x=34..35
  grid[17][34] = CHROME; grid[17][35] = WHITE;
  grid[18][34] = STEEL;  grid[18][35] = GUN_HI;
  grid[19][34] = OUT;

  return { grid, gridSize: g };
}

function getHD_A9Pigeon_Gatling_Spin1() { return getHD_A9Pigeon_Gatling(0); }
function getHD_A9Pigeon_Gatling_Spin2() { return getHD_A9Pigeon_Gatling(1); }

function getHD_A9Pigeon_Bomb() {
  const g = 36, grid = makeGrid36();

  const OUT     = '#090d16';
  const SHADOW  = '#0f172a';
  const BOMB_D  = '#1e293b';
  const BOMB_M  = '#334155';
  const BOMB_L  = '#475569';
  const BOMB_HI = '#64748b';
  const STEEL   = '#94a3b8';
  const CHROME  = '#cbd5e1';
  const WARN_Y  = '#facc15'; // High-visibility hazard yellow
  const DOVE_W  = '#f8fafc'; // White peace dove stencil
  const BEACON  = '#ef4444'; // Red arming status beacon

  // Heavy Ground Bomb slung flush under center-mid fuselage (x: 13..24, y: 18..22)
  // Row 18: Dual NATO Suspension Lug Shackles & Hardpoint Pylons (x: 16 & x: 20)
  grid[18][16] = SHADOW; grid[18][17] = CHROME; grid[18][18] = BOMB_D;
  grid[18][19] = SHADOW; grid[18][20] = CHROME; grid[18][21] = BOMB_D;

  // Row 19: Upper Bomb Casing, Cruciform Tail Fin Tops & Yellow Hazard Band
  grid[19][13] = OUT;    grid[19][14] = WARN_Y; grid[19][15] = BOMB_L; grid[19][16] = BEACON;
  grid[19][17] = BOMB_M; grid[19][18] = BOMB_L; grid[19][19] = WARN_Y; grid[19][20] = BOMB_HI;
  grid[19][21] = WARN_Y; grid[19][22] = BOMB_M; grid[19][23] = STEEL;  grid[19][24] = OUT;

  // Row 20: Bomb Centerline — Tail Fin Stabilizer Ring, White Dove Stencil, Hazard Chevrons & Penetrator Probe
  grid[20][13] = BOMB_HI; grid[20][14] = BOMB_M; grid[20][15] = BOMB_D; grid[20][16] = DOVE_W;
  grid[20][17] = DOVE_W; grid[20][18] = DOVE_W; grid[20][19] = WARN_Y; grid[20][20] = BOMB_L;
  grid[20][21] = WARN_Y; grid[20][22] = STEEL;  grid[20][23] = CHROME; grid[20][24] = '#ffffff';

  // Row 21: Lower Bomb Casing, Fin Bottoms & Shading
  grid[21][13] = OUT;    grid[21][14] = WARN_Y; grid[21][15] = SHADOW; grid[21][16] = BOMB_D;
  grid[21][17] = BOMB_D; grid[21][18] = BOMB_M; grid[21][19] = WARN_Y; grid[21][20] = BOMB_D;
  grid[21][21] = WARN_Y; grid[21][22] = SHADOW; grid[21][23] = STEEL;  grid[21][24] = OUT;

  // Row 22: Ventral Tail Fin Tip & Underside Contour
  grid[22][14] = OUT;    grid[22][15] = WARN_Y;
  for (let x = 16; x <= 23; x++) grid[22][x] = OUT;

  return { grid, gridSize: g };
}

function getHD_A9Pigeon_Bird(flapPhase = 0) {
  const g = 24, grid = makeGrid();

  const OUT     = '#090d16'; // Deep silhouette contour
  const WING_D  = '#0f172a'; // Bold black wing bars (Doppel-Flügelbinden)
  const HEAD_D  = '#1e293b'; // Slate head shading
  const HEAD_M  = '#334155'; // Dark slate-grey head
  const MANTLE  = '#475569'; // Ash-grey mantle
  const BODY_M  = '#64748b'; // Slate blue-grey back
  const BODY_L  = '#94a3b8'; // Light slate plumage
  const BREAST  = '#cbd5e1'; // Pale pigeon breast
  const WHITE   = '#f8fafc'; // White cere & white rump patch (Bürzel)
  const BEAK    = '#1e293b'; // Pigeon beak tip

  // Iridescent Pigeon-Neck Collar (Alternating emerald-green & amethyst-purple sheen)
  const TEAL_D  = '#0d9488';
  const TEAL_L  = '#14b8a6';
  const TEAL_HI = '#2dd4bf';
  const PURP_D  = '#7e22ce';
  const PURP_L  = '#a855f7';
  const PURP_HI = '#c084fc';

  // Eye & Feet
  const EYE_O   = '#ea580c'; // Vibrant orange iris
  const EYE_P   = '#090d16'; // Black pupil
  const EYE_SP  = '#ffffff'; // Specular eye gleam
  const FOOT    = '#f43f5e'; // Coral red pigeon feet

  // 1. Tail Feathers & White Rump Patch (x: 4..8, y: 11..13)
  grid[11][5] = OUT;    grid[11][6] = WHITE;   grid[11][7] = WHITE;   grid[11][8] = BODY_L;
  grid[12][4] = OUT;    grid[12][5] = WING_D;  grid[12][6] = WING_D;  grid[12][7] = BODY_M; grid[12][8] = BODY_M;
  grid[13][5] = OUT;    grid[13][6] = WHITE;   grid[13][7] = WING_D;  grid[13][8] = OUT;

  // 2. Pigeon Body, Iridescent Throat Collar, Beak with White Cere & Orange Eye (x: 8..17, y: 10..14)
  // Row 10 (Crown of Head & Nape)
  grid[10][13] = OUT;   grid[10][14] = HEAD_M; grid[10][15] = HEAD_D; grid[10][16] = OUT;

  // Row 11 (Eye with Pupil & Glint, Beak with Soft White Cere, Iridescent Throat)
  grid[11][9]  = BODY_L; grid[11][10] = BODY_L; grid[11][11] = BODY_M;
  grid[11][12] = TEAL_L; grid[11][13] = PURP_HI; grid[11][14] = HEAD_M;
  grid[11][15] = EYE_O;  grid[11][16] = WHITE;  grid[11][17] = BEAK;   grid[11][18] = OUT;
  // Detail pupil in row 11 at x=15
  grid[11][15] = EYE_P;

  // Row 12 (Iridescent Green/Purple Neck Breast & Pale Plumage)
  grid[12][9]  = BODY_L; grid[12][10] = BREAST; grid[12][11] = BREAST;
  grid[12][12] = PURP_L; grid[12][13] = TEAL_HI; grid[12][14] = BREAST; grid[12][15] = BEAK;   grid[12][16] = OUT;

  // Row 13 (Ventral Keel & Tucked Coral Feet)
  grid[13][9]  = BODY_M; grid[13][10] = BREAST; grid[13][11] = BREAST; grid[13][12] = BODY_L; grid[13][13] = OUT;
  grid[14][10] = OUT;    grid[14][11] = FOOT;   grid[14][12] = FOOT;   grid[14][13] = OUT;

  // 3. 3-Phase Wing Flap Animation with Double Black Wing Bars
  if (flapPhase === 0) {
    // Flap1: Wings Raised High (Upstroke V-pose: y: 4..10, x: 8..14)
    grid[4][10] = OUT;    grid[4][11] = WHITE;   grid[4][12] = OUT;
    grid[5][9]  = OUT;    grid[5][10] = BODY_L;  grid[5][11] = WHITE;   grid[5][12] = BODY_L;  grid[5][13] = OUT;
    grid[6][8]  = OUT;    grid[6][9]  = WING_D;  grid[6][10] = BODY_L;  grid[6][11] = WING_D;  grid[6][12] = BODY_L;  grid[6][13] = OUT;
    grid[7][8]  = OUT;    grid[7][9]  = BODY_M;  grid[7][10] = WING_D;  grid[7][11] = BODY_L;  grid[7][12] = WING_D;  grid[7][13] = OUT;
    grid[8][8]  = OUT;    grid[8][9]  = BODY_M;  grid[8][10] = BODY_L;  grid[8][11] = BREAST;  grid[8][12] = BODY_M;  grid[8][13] = OUT;
    grid[9][9]  = BODY_M; grid[9][10] = BODY_L;  grid[9][11] = BREAST;  grid[9][12] = BODY_M;
  } else if (flapPhase === 1) {
    // Flap2: Wings Extended Mid-Level Glide (Showing iconic double dark wing bars: y: 9..12, x: 6..14)
    grid[8][7]  = OUT;    grid[8][8]  = WHITE;   grid[8][9]  = BODY_L;  grid[8][10] = WING_D;  grid[8][11] = BODY_L;  grid[8][12] = WING_D;  grid[8][13] = OUT;
    grid[9][6]  = OUT;    grid[9][7]  = WHITE;   grid[9][8]  = BODY_L;  grid[9][9]  = WING_D;  grid[9][10] = BODY_L;  grid[9][11] = WING_D;  grid[9][12] = BODY_L;  grid[9][13] = OUT;
    grid[10][6] = OUT;    grid[10][7] = BODY_L;  grid[10][8] = WING_D;  grid[10][9] = BODY_L;  grid[10][10] = WING_D; grid[10][11] = BODY_M; grid[10][12] = OUT;
  } else {
    // Flap3: Wings Swept Downward (Power downstroke: y: 12..17, x: 8..15)
    grid[12][8]  = OUT;    grid[12][9]  = WING_D;  grid[12][10] = BODY_L;
    grid[13][8]  = OUT;    grid[13][9]  = BODY_L;  grid[13][10] = WING_D; grid[13][11] = BODY_L; grid[13][12] = WHITE;
    grid[14][9]  = OUT;    grid[14][10] = WING_D;  grid[14][11] = BODY_L; grid[14][12] = WING_D; grid[14][13] = WHITE;  grid[14][14] = OUT;
    grid[15][9]  = OUT;    grid[15][10] = BODY_L;  grid[15][11] = WING_D; grid[15][12] = WHITE;  grid[15][13] = OUT;
    grid[16][10] = OUT;    grid[16][11] = WHITE;   grid[16][12] = OUT;
  }

  return { grid, gridSize: g };
}

function getHD_A9Pigeon_Bird_Flap1() { return getHD_A9Pigeon_Bird(0); }
function getHD_A9Pigeon_Bird_Flap2() { return getHD_A9Pigeon_Bird(1); }
function getHD_A9Pigeon_Bird_Flap3() { return getHD_A9Pigeon_Bird(2); }

function getHD_A9Pigeon_PilotBird(flapPhase = 0) {
  const base = getHD_A9Pigeon_Bird(flapPhase);
  const grid = base.grid;
  const g = base.gridSize;

  // Golden Aviator Goggles on crown (Dark leather headband + polished gold bezels & specular glint)
  grid[9][13]  = '#0f172a'; grid[9][14]  = '#facc15'; grid[9][15]  = '#ffffff'; grid[9][16]  = '#0f172a';
  grid[10][13] = '#0f172a'; grid[10][14] = '#ca8a04'; grid[10][15] = '#facc15'; grid[10][16] = '#0f172a';

  // Fluttering Crimson Silk Aviator Scarf knot around throat with trailing slipstream streamer
  grid[12][11] = '#ef4444'; grid[12][12] = '#b91c1c'; grid[12][13] = '#ef4444';
  grid[13][9]  = '#ef4444'; grid[13][10] = '#dc2626'; grid[13][11] = '#f87171';

  return { grid, gridSize: g };
}

function getHD_A9Pigeon_Pilot_Flap1() { return getHD_A9Pigeon_PilotBird(0); }
function getHD_A9Pigeon_Pilot_Flap2() { return getHD_A9Pigeon_PilotBird(1); }
function getHD_A9Pigeon_Pilot_Flap3() { return getHD_A9Pigeon_PilotBird(2); }

function getHD_A9Pigeon_Bird_BackFlap(flapPhase = 0) {
  const g = 24, grid = makeGrid();

  const OUT     = '#090d16'; // Deep silhouette contour
  const WING_D  = '#0f172a'; // Bold black wing bars
  const HEAD_D  = '#1e293b'; // Slate head shading
  const HEAD_M  = '#334155'; // Dark slate-grey head
  const MANTLE  = '#475569'; // Ash-grey mantle
  const BODY_M  = '#64748b'; // Slate blue-grey back
  const BODY_L  = '#94a3b8'; // Light slate plumage
  const BREAST  = '#cbd5e1'; // Pale pigeon breast
  const WHITE   = '#f8fafc'; // White cere & white rump patch
  const BEAK    = '#1e293b'; // Pigeon beak tip

  // Iridescent Pigeon-Neck Collar
  const TEAL_L  = '#14b8a6';
  const TEAL_HI = '#2dd4bf';
  const PURP_L  = '#a855f7';
  const PURP_HI = '#c084fc';

  // Eye & Dropped Braking Feet
  const EYE_P   = '#090d16';
  const FOOT    = '#f43f5e';
  const FOOT_D  = '#be123c';

  // 1. Fanned Braking Tail & Flared White Rump (Air-brake wedge pitched downward: x: 3..8, y: 12..16)
  grid[12][4] = OUT;    grid[12][5] = WHITE;   grid[12][6] = WHITE;   grid[12][7] = BODY_L;
  grid[13][3] = OUT;    grid[13][4] = WING_D;  grid[13][5] = WING_D;  grid[13][6] = BODY_M;  grid[13][7] = BODY_M;
  grid[14][3] = OUT;    grid[14][4] = WING_D;  grid[14][5] = WHITE;   grid[14][6] = WING_D;  grid[14][7] = OUT;
  grid[15][4] = OUT;    grid[15][5] = WING_D;  grid[15][6] = OUT;

  // 2. Backward-Tilted Torso & Alert Forward Head (x: 8..17, y: 8..14)
  // Row 8 (Alert Crown)
  grid[8][13] = OUT;    grid[8][14] = HEAD_M;  grid[8][15] = HEAD_D;  grid[8][16] = OUT;

  // Row 9 (Eye, Cere & Beak pointed straight forward at enemy)
  grid[9][11] = BODY_L; grid[9][12] = HEAD_M;  grid[9][13] = HEAD_M;  grid[9][14] = EYE_P;
  grid[9][15] = WHITE;  grid[9][16] = BEAK;    grid[9][17] = OUT;

  // Row 10 (Iridescent Neck Collar rippling from reverse airflow)
  grid[10][9] = BODY_M; grid[10][10] = MANTLE; grid[10][11] = TEAL_HI; grid[10][12] = PURP_HI;
  grid[10][13] = HEAD_M; grid[10][14] = BREAST; grid[10][15] = BREAST; grid[10][16] = OUT;

  // Row 11 (Puffed High Breast thrusting into wind)
  grid[11][8] = BODY_M; grid[11][9] = BODY_L;  grid[11][10] = PURP_L; grid[11][11] = TEAL_L;
  grid[11][12] = BREAST; grid[11][13] = BREAST; grid[11][14] = BREAST; grid[11][15] = OUT;

  // Row 12 (Ventral Keel & Lower Breast)
  grid[12][8] = BODY_M; grid[12][9] = BODY_L;  grid[12][10] = BREAST; grid[12][11] = BREAST; grid[12][12] = OUT;

  // Row 13-14 (Dropped Coral Braking Feet acting as aerodynamic drag rudders)
  grid[13][9] = OUT;    grid[13][10] = FOOT;   grid[13][11] = FOOT;   grid[13][12] = OUT;
  grid[14][9] = FOOT_D; grid[14][10] = FOOT;   grid[14][11] = FOOT;   grid[14][12] = OUT;

  // 3. 3-Phase High-Frequency Reverse Wing Flutter (Thrusting air forward!)
  if (flapPhase === 0) {
    // BackFlap1: Wings Raised High Forward (Cupped air scoop: y: 3..9, x: 9..16)
    grid[3][12] = OUT;    grid[3][13] = WHITE;   grid[3][14] = OUT;
    grid[4][11] = OUT;    grid[4][12] = BODY_L;  grid[4][13] = WHITE;   grid[4][14] = BODY_L;  grid[4][15] = OUT;
    grid[5][10] = OUT;    grid[5][11] = WING_D;  grid[5][12] = BODY_L;  grid[5][13] = WING_D;  grid[5][14] = BODY_L;  grid[5][15] = OUT;
    grid[6][10] = OUT;    grid[6][11] = BODY_M;  grid[6][12] = WING_D;  grid[6][13] = BODY_L;  grid[6][14] = WING_D;  grid[6][15] = OUT;
    grid[7][10] = OUT;    grid[7][11] = BODY_M;  grid[7][12] = BODY_L;  grid[7][13] = WING_D;  grid[7][14] = BODY_M;  grid[7][15] = OUT;
    grid[8][10] = BODY_M; grid[8][11] = BODY_L;  grid[8][12] = BREAST;
  } else if (flapPhase === 1) {
    // BackFlap2: Forward-thrusting Mid-Stroke (Wings angled forward pushing air frontward: y: 7..12, x: 10..17)
    grid[7][11] = OUT;    grid[7][12] = WHITE;   grid[7][13] = BODY_L;  grid[7][14] = WING_D;  grid[7][15] = BODY_L;  grid[7][16] = OUT;
    grid[8][10] = OUT;    grid[8][11] = WHITE;   grid[8][12] = BODY_L;  grid[8][13] = WING_D;  grid[8][14] = BODY_L;  grid[8][15] = WING_D;  grid[8][16] = OUT;
    grid[9][9]  = OUT;    grid[9][10] = BODY_L;  grid[9][11] = WING_D;  grid[9][12] = BODY_L;  grid[9][13] = WING_D;  grid[9][14] = BODY_M;  grid[9][15] = OUT;
    grid[10][9] = OUT;    grid[10][10] = BODY_M; grid[10][11] = WING_D; grid[10][12] = BODY_M; grid[10][13] = OUT;
  } else {
    // BackFlap3: Deep Cupped Downstroke Scoop (Forward-angled downstroke: y: 11..17, x: 9..17)
    grid[11][12] = OUT;   grid[11][13] = WING_D; grid[11][14] = BODY_L; grid[11][15] = OUT;
    grid[12][11] = OUT;   grid[12][12] = BODY_L; grid[12][13] = WING_D; grid[12][14] = BODY_L; grid[12][15] = WHITE; grid[12][16] = OUT;
    grid[13][11] = OUT;   grid[13][12] = WING_D; grid[13][13] = BODY_L; grid[13][14] = WING_D; grid[13][15] = WHITE; grid[13][16] = OUT;
    grid[14][12] = OUT;   grid[14][13] = BODY_L; grid[14][14] = WING_D; grid[14][15] = WHITE;  grid[14][16] = OUT;
    grid[15][13] = OUT;   grid[15][14] = WHITE;  grid[15][15] = OUT;
  }

  return { grid, gridSize: g };
}

function getHD_A9Pigeon_Bird_BackFlap1() { return getHD_A9Pigeon_Bird_BackFlap(0); }
function getHD_A9Pigeon_Bird_BackFlap2() { return getHD_A9Pigeon_Bird_BackFlap(1); }
function getHD_A9Pigeon_Bird_BackFlap3() { return getHD_A9Pigeon_Bird_BackFlap(2); }

function getHD_A9Pigeon_Pilot_BackFlap(phase = 0) {
  const base = getHD_A9Pigeon_Bird_BackFlap(phase);
  const grid = base.grid;
  // Golden Aviator Goggles
  grid[7][13] = '#0f172a'; grid[7][14] = '#facc15'; grid[7][15] = '#ffffff'; grid[7][16] = '#0f172a';
  grid[8][13] = '#0f172a'; grid[8][14] = '#ca8a04'; grid[8][15] = '#facc15'; grid[8][16] = '#0f172a';
  // Crimson Scarf whipping forward into the reverse slipstream
  grid[10][12] = '#ef4444'; grid[10][13] = '#b91c1c'; grid[10][14] = '#ef4444';
  grid[10][15] = '#dc2626'; grid[10][16] = '#f87171'; grid[10][17] = '#ffffff';
  return { grid, gridSize: base.gridSize };
}

function getHD_A9Pigeon_Pilot_BackFlap1() { return getHD_A9Pigeon_Pilot_BackFlap(0); }
function getHD_A9Pigeon_Pilot_BackFlap2() { return getHD_A9Pigeon_Pilot_BackFlap(1); }
function getHD_A9Pigeon_Pilot_BackFlap3() { return getHD_A9Pigeon_Pilot_BackFlap(2); }

function getHD_A9Pigeon_Bird_Perched() {
  const g = 24, grid = makeGrid();

  const OUT     = '#090d16'; // Deep silhouette contour
  const WING_D  = '#0f172a'; // Bold black wing bars (Doppel-Flügelbinden)
  const HEAD_D  = '#1e293b'; // Slate head shading
  const HEAD_M  = '#334155'; // Dark slate-grey head
  const MANTLE  = '#475569'; // Ash-grey mantle
  const BODY_M  = '#64748b'; // Slate blue-grey back
  const BODY_L  = '#94a3b8'; // Light slate plumage
  const BREAST  = '#cbd5e1'; // Pale pigeon breast
  const WHITE   = '#f8fafc'; // White cere & white rump patch (Bürzel)
  const BEAK    = '#1e293b'; // Pigeon beak tip

  // Iridescent Pigeon-Neck Collar
  const TEAL_L  = '#14b8a6';
  const TEAL_HI = '#2dd4bf';
  const PURP_L  = '#a855f7';
  const PURP_HI = '#c084fc';

  // Eye & Gripping Claws
  const EYE_P   = '#090d16'; // Black pupil
  const FOOT    = '#f43f5e'; // Coral red pigeon feet
  const FOOT_D  = '#be123c'; // Shadowed coral red
  const CLAW    = '#0f172a'; // Curled grip talons

  // 1. Upright Alert Head & Nape (y: 8..9, x: 13..18)
  grid[8][13] = OUT;    grid[8][14] = HEAD_M;  grid[8][15] = HEAD_D;  grid[8][16] = OUT;
  grid[9][12] = OUT;    grid[9][13] = HEAD_M;  grid[9][14] = HEAD_M;  grid[9][15] = EYE_P;
  grid[9][16] = WHITE;  grid[9][17] = BEAK;    grid[9][18] = OUT;

  // 2. Iridescent Emerald/Amethyst Throat & Ash Mantle (y: 10..11, x: 10..17)
  grid[10][10] = OUT;   grid[10][11] = MANTLE; grid[10][12] = TEAL_L; grid[10][13] = PURP_HI;
  grid[10][14] = HEAD_M; grid[10][15] = BREAST; grid[10][16] = BEAK;  grid[10][17] = OUT;

  grid[11][7]  = OUT;   grid[11][8]  = WHITE;   grid[11][9]  = BODY_L; grid[11][10] = MANTLE;
  grid[11][11] = PURP_L; grid[11][12] = TEAL_HI; grid[11][13] = BREAST; grid[11][14] = BREAST; grid[11][15] = OUT;

  // 3. Folded Wing with Crisp Double Black Bars & Rounded Breast (y: 12..14, x: 4..14)
  grid[12][5] = OUT;    grid[12][6] = WHITE;   grid[12][7] = BODY_L;  grid[12][8] = WING_D;
  grid[12][9] = BODY_L; grid[12][10] = WING_D; grid[12][11] = BODY_M; grid[12][12] = BREAST; grid[12][13] = BREAST; grid[12][14] = OUT;

  grid[13][4] = OUT;    grid[13][5] = WING_D;  grid[13][6] = BODY_M;  grid[13][7] = WING_D;
  grid[13][8] = BODY_L; grid[13][9] = WING_D;  grid[13][10] = BODY_M; grid[13][11] = BREAST; grid[13][12] = OUT;

  grid[14][4] = OUT;    grid[14][5] = WING_D;  grid[14][6] = OUT;     grid[14][8] = BODY_M;
  grid[14][9] = BODY_L; grid[14][10] = BODY_M; grid[14][11] = OUT;

  // 4. Extended Coral Legs & Talons Gripping Probe Bar (y: 15..16, x: 9..12)
  grid[15][9] = OUT;    grid[15][10] = FOOT;   grid[15][11] = FOOT;   grid[15][12] = OUT;
  grid[16][9] = CLAW;   grid[16][10] = FOOT_D; grid[16][11] = FOOT;   grid[16][12] = CLAW;

  return { grid, gridSize: g };
}

function getHD_A9Pigeon_Bird_Peck() {
  const g = 24, grid = makeGrid();

  const OUT     = '#090d16';
  const WING_D  = '#0f172a';
  const HEAD_D  = '#1e293b';
  const HEAD_M  = '#334155';
  const MANTLE  = '#475569';
  const BODY_M  = '#64748b';
  const BODY_L  = '#94a3b8';
  const BREAST  = '#cbd5e1';
  const WHITE   = '#f8fafc';
  const BEAK    = '#1e293b';

  const TEAL_L  = '#14b8a6';
  const TEAL_HI = '#2dd4bf';
  const PURP_L  = '#a855f7';
  const PURP_HI = '#c084fc';

  const EYE_P   = '#090d16';
  const FOOT    = '#f43f5e';
  const FOOT_D  = '#be123c';
  const CLAW    = '#0f172a';

  // 1. Folded Wings & Body (Same anchor as Perched for rock-solid stability)
  grid[12][5] = OUT;    grid[12][6] = WHITE;   grid[12][7] = BODY_L;  grid[12][8] = WING_D;
  grid[12][9] = BODY_L; grid[12][10] = WING_D; grid[12][11] = BODY_M; grid[12][12] = BREAST; grid[12][13] = OUT;

  grid[13][4] = OUT;    grid[13][5] = WING_D;  grid[13][6] = BODY_M;  grid[13][7] = WING_D;
  grid[13][8] = BODY_L; grid[13][9] = WING_D;  grid[13][10] = BODY_M; grid[13][11] = OUT;

  grid[14][4] = OUT;    grid[14][5] = WING_D;  grid[14][6] = OUT;     grid[14][8] = BODY_M;
  grid[14][9] = BODY_L; grid[14][10] = BODY_M; grid[14][11] = OUT;

  // 2. Lowered Inspection Peck Head & Dipped Beak (y: 10..13, x: 10..17)
  grid[10][10] = OUT;   grid[10][11] = MANTLE; grid[10][12] = HEAD_M; grid[10][13] = HEAD_D; grid[10][14] = OUT;

  grid[11][10] = OUT;   grid[11][11] = BODY_L; grid[11][12] = TEAL_HI; grid[11][13] = PURP_HI;
  grid[11][14] = HEAD_M; grid[11][15] = EYE_P; grid[11][16] = WHITE;  grid[11][17] = OUT;

  grid[12][13] = PURP_L; grid[12][14] = TEAL_L; grid[12][15] = BREAST; grid[12][16] = BEAK;  grid[12][17] = OUT;

  grid[13][15] = OUT;   grid[13][16] = BEAK;   grid[13][17] = OUT;

  // 3. Extended Coral Legs & Talons Gripping Probe Bar (Identical anchor coordinates)
  grid[15][9] = OUT;    grid[15][10] = FOOT;   grid[15][11] = FOOT;   grid[15][12] = OUT;
  grid[16][9] = CLAW;   grid[16][10] = FOOT_D; grid[16][11] = FOOT;   grid[16][12] = CLAW;

  return { grid, gridSize: g };
}

function getHD_A9Pigeon_Pilot_Perched() {
  const base = getHD_A9Pigeon_Bird_Perched();
  const grid = base.grid;
  // Golden Aviator Goggles on crown
  grid[7][13] = '#0f172a'; grid[7][14] = '#facc15'; grid[7][15] = '#ffffff'; grid[7][16] = '#0f172a';
  grid[8][13] = '#0f172a'; grid[8][14] = '#ca8a04'; grid[8][15] = '#facc15'; grid[8][16] = '#0f172a';
  // Crimson Silk Aviator Scarf knot
  grid[10][11] = '#ef4444'; grid[10][12] = '#b91c1c'; grid[10][13] = '#ef4444';
  grid[11][9]  = '#ef4444'; grid[11][10] = '#dc2626'; grid[11][11] = '#f87171';
  return { grid, gridSize: base.gridSize };
}

function getHD_A9Pigeon_Pilot_Peck() {
  const base = getHD_A9Pigeon_Bird_Peck();
  const grid = base.grid;
  // Golden Aviator Goggles tilted forward on lowered head
  grid[9][12]  = '#0f172a'; grid[9][13]  = '#facc15'; grid[9][14]  = '#ffffff'; grid[9][15]  = '#0f172a';
  grid[10][12] = '#0f172a'; grid[10][13] = '#ca8a04'; grid[10][14] = '#facc15'; grid[10][15] = '#0f172a';
  // Crimson Silk Aviator Scarf hanging forward
  grid[11][11] = '#ef4444'; grid[11][12] = '#b91c1c';
  grid[12][11] = '#dc2626'; grid[12][12] = '#ef4444';
  return { grid, gridSize: base.gridSize };
}

// ⚔️ A9 PIGEON WINGMAN — DOGFIGHT AGGRO-THREAT DISPLAY
// 1. "Hals aufblasen": Puffed-up, inflated iridescent throat & broad proud chest
function getHD_A9Pigeon_Bird_Threat_Puff() {
  const g = 24, grid = makeGrid();

  const OUT     = '#090d16'; // Deep silhouette contour
  const WING_D  = '#0f172a'; // Bold black wing bars (Doppel-Flügelbinden)
  const HEAD_D  = '#1e293b'; // Slate head shading
  const HEAD_M  = '#334155'; // Dark slate-grey head
  const MANTLE  = '#475569'; // Ash-grey mantle
  const BODY_M  = '#64748b'; // Slate blue-grey back
  const BODY_L  = '#94a3b8'; // Light slate plumage
  const BREAST  = '#cbd5e1'; // Pale pigeon breast
  const WHITE   = '#f8fafc'; // White cere & white rump patch (Bürzel)
  const BEAK    = '#1e293b'; // Pigeon beak tip

  // Iridescent Pigeon-Neck Collar (Puffed up & flared)
  const TEAL_L  = '#14b8a6';
  const TEAL_HI = '#2dd4bf';
  const PURP_L  = '#a855f7';
  const PURP_HI = '#c084fc';

  // Eye & Gripping Claws
  const EYE_P   = '#090d16'; // Black pupil
  const FOOT    = '#f43f5e'; // Coral red pigeon feet
  const FOOT_D  = '#be123c'; // Shadowed coral red
  const CLAW    = '#0f172a'; // Curled grip talons

  // 1. Alert Raised Head & Nape (y: 8..9, x: 13..18)
  grid[8][13] = OUT;    grid[8][14] = HEAD_M;  grid[8][15] = HEAD_D;  grid[8][16] = HEAD_M;  grid[8][17] = OUT;
  grid[9][12] = OUT;    grid[9][13] = HEAD_M;  grid[9][14] = HEAD_M;  grid[9][15] = EYE_P;
  grid[9][16] = WHITE;  grid[9][17] = BEAK;    grid[9][18] = OUT;

  // 2. Broad Inflated Iridescent Throat & Flared Breast (y: 10..11, x: 9..17)
  grid[10][9]  = OUT;   grid[10][10] = MANTLE; grid[10][11] = TEAL_L; grid[10][12] = PURP_HI;
  grid[10][13] = TEAL_HI; grid[10][14] = HEAD_M; grid[10][15] = BREAST; grid[10][16] = BREAST; grid[10][17] = OUT;

  grid[11][6]  = OUT;   grid[11][7]  = WHITE;   grid[11][8]  = BODY_L;  grid[11][9]  = MANTLE;
  grid[11][10] = PURP_L; grid[11][11] = TEAL_HI; grid[11][12] = TEAL_HI; grid[11][13] = PURP_HI;
  grid[11][14] = BREAST; grid[11][15] = BREAST; grid[11][16] = OUT;

  // 3. Hunched Shoulders & Arched Wing with Dominant Black Bars (y: 12..14, x: 4..15)
  grid[12][5] = OUT;    grid[12][6] = WHITE;   grid[12][7] = BODY_L;  grid[12][8] = WING_D;
  grid[12][9] = BODY_L; grid[12][10] = WING_D; grid[12][11] = BODY_M; grid[12][12] = BREAST; grid[12][13] = BREAST; grid[12][14] = BREAST; grid[12][15] = OUT;

  grid[13][4] = OUT;    grid[13][5] = WING_D;  grid[13][6] = BODY_M;  grid[13][7] = WING_D;
  grid[13][8] = BODY_L; grid[13][9] = WING_D;  grid[13][10] = BODY_M; grid[13][11] = BREAST; grid[13][12] = BREAST; grid[13][13] = OUT;

  grid[14][4] = OUT;    grid[14][5] = WING_D;  grid[14][6] = OUT;     grid[14][8] = BODY_M;
  grid[14][9] = BODY_L; grid[14][10] = BODY_M; grid[14][11] = OUT;

  // 4. Extended Coral Legs & Gripping Claws (Identical anchor coordinates)
  grid[15][9] = OUT;    grid[15][10] = FOOT;   grid[15][11] = FOOT;   grid[15][12] = OUT;
  grid[16][9] = CLAW;   grid[16][10] = FOOT_D; grid[16][11] = FOOT;   grid[16][12] = CLAW;

  return { grid, gridSize: g };
}

// 2. "Mit Kopf nicken": Aggressive forward thrust / nod with parted beak & pressed tail
function getHD_A9Pigeon_Bird_Threat_Bob() {
  const g = 24, grid = makeGrid();

  const OUT     = '#090d16';
  const WING_D  = '#0f172a';
  const HEAD_D  = '#1e293b';
  const HEAD_M  = '#334155';
  const MANTLE  = '#475569';
  const BODY_M  = '#64748b';
  const BODY_L  = '#94a3b8';
  const BREAST  = '#cbd5e1';
  const WHITE   = '#f8fafc';
  const BEAK    = '#1e293b';

  const TEAL_L  = '#14b8a6';
  const TEAL_HI = '#2dd4bf';
  const PURP_L  = '#a855f7';
  const PURP_HI = '#c084fc';

  const EYE_P   = '#090d16';
  const FOOT    = '#f43f5e';
  const FOOT_D  = '#be123c';
  const CLAW    = '#0f172a';

  // 1. Forward-Thrust Head with Parted Beak (y: 8..10, x: 13..20)
  grid[8][14] = OUT;    grid[8][15] = HEAD_M;  grid[8][16] = HEAD_D;  grid[8][17] = OUT;
  grid[9][13] = OUT;    grid[9][14] = HEAD_M;  grid[9][15] = HEAD_M;  grid[9][16] = EYE_P;
  grid[9][17] = WHITE;  grid[9][18] = BEAK;    grid[9][19] = BEAK;    grid[9][20] = OUT;

  // 2. Iridescent Neck & Open Beak Gap (y: 10..11, x: 10..19)
  grid[10][10] = OUT;   grid[10][11] = MANTLE; grid[10][12] = TEAL_L; grid[10][13] = PURP_HI;
  grid[10][14] = HEAD_M; grid[10][15] = BREAST; grid[10][16] = OUT;   grid[10][17] = BEAK; grid[10][18] = OUT;

  grid[11][7]  = OUT;   grid[11][8]  = WHITE;   grid[11][9]  = BODY_L;  grid[11][10] = MANTLE;
  grid[11][11] = PURP_L; grid[11][12] = TEAL_HI; grid[11][13] = BREAST; grid[11][14] = BREAST; grid[11][15] = BREAST; grid[11][16] = OUT;

  // 3. Tail Pressed Downward & Broad Wing (y: 12..15, x: 3..14)
  grid[12][5] = OUT;    grid[12][6] = WHITE;   grid[12][7] = BODY_L;  grid[12][8] = WING_D;
  grid[12][9] = BODY_L; grid[12][10] = WING_D; grid[12][11] = BODY_M; grid[12][12] = BREAST; grid[12][13] = BREAST; grid[12][14] = OUT;

  grid[13][4] = OUT;    grid[13][5] = WING_D;  grid[13][6] = BODY_M;  grid[13][7] = WING_D;
  grid[13][8] = BODY_L; grid[13][9] = WING_D;  grid[13][10] = BODY_M; grid[13][11] = BREAST; grid[13][12] = OUT;

  grid[14][3] = OUT;    grid[14][4] = WING_D;  grid[14][5] = OUT;     grid[14][7] = BODY_M;
  grid[14][8] = BODY_L; grid[14][9] = BODY_M;  grid[14][10] = OUT;

  grid[15][3] = OUT;    grid[15][4] = WING_D;  grid[15][5] = OUT;

  // 4. Extended Coral Legs & Talons (Identical anchor coordinates)
  grid[15][9] = OUT;    grid[15][10] = FOOT;   grid[15][11] = FOOT;   grid[15][12] = OUT;
  grid[16][9] = CLAW;   grid[16][10] = FOOT_D; grid[16][11] = FOOT;   grid[16][12] = CLAW;

  return { grid, gridSize: g };
}

// 3. "Flügel strecken": High wings-extended dihedral stretch display
function getHD_A9Pigeon_Bird_Threat_WingStretch() {
  const g = 24, grid = makeGrid();

  const OUT     = '#090d16';
  const WING_D  = '#0f172a';
  const HEAD_D  = '#1e293b';
  const HEAD_M  = '#334155';
  const MANTLE  = '#475569';
  const BODY_M  = '#64748b';
  const BODY_L  = '#94a3b8';
  const BREAST  = '#cbd5e1';
  const WHITE   = '#f8fafc';
  const BEAK    = '#1e293b';

  const TEAL_L  = '#14b8a6';
  const TEAL_HI = '#2dd4bf';
  const PURP_L  = '#a855f7';
  const PURP_HI = '#c084fc';

  const EYE_P   = '#090d16';
  const FOOT    = '#f43f5e';
  const FOOT_D  = '#be123c';
  const CLAW    = '#0f172a';

  // 1. High Raised & Stretched Wings (Rows 4..9, Columns 5..11)
  grid[4][7] = OUT;     grid[4][8] = WHITE;    grid[4][9] = WING_D;   grid[4][10] = OUT;
  grid[5][6] = OUT;     grid[5][7] = WHITE;    grid[5][8] = BODY_L;   grid[5][9] = WING_D;   grid[5][10] = OUT;
  grid[6][5] = OUT;     grid[6][6] = BODY_L;   grid[6][7] = WING_D;   grid[6][8] = BODY_L;   grid[6][9] = WING_D;   grid[6][10] = OUT;
  grid[7][5] = OUT;     grid[7][6] = BODY_M;   grid[7][7] = WING_D;   grid[7][8] = BODY_L;   grid[7][9] = WING_D;   grid[7][10] = OUT;
  grid[8][6] = OUT;     grid[8][7] = BODY_M;   grid[8][8] = WING_D;   grid[8][9] = BODY_M;   grid[8][10] = OUT;
  grid[9][6] = OUT;     grid[9][7] = BODY_L;   grid[9][8] = WING_D;   grid[9][9] = BODY_M;   grid[9][10] = OUT;

  // 2. Alert Raised Head & Nape (y: 8..9, x: 13..18)
  grid[8][13] = OUT;    grid[8][14] = HEAD_M;  grid[8][15] = HEAD_D;  grid[8][16] = HEAD_M;  grid[8][17] = OUT;
  grid[9][12] = OUT;    grid[9][13] = HEAD_M;  grid[9][14] = HEAD_M;  grid[9][15] = EYE_P;
  grid[9][16] = WHITE;  grid[9][17] = BEAK;    grid[9][18] = OUT;

  // 3. Throat & Puffed Forward Breast (y: 10..14, x: 10..16)
  grid[10][10] = OUT;   grid[10][11] = MANTLE; grid[10][12] = TEAL_L; grid[10][13] = PURP_HI;
  grid[10][14] = HEAD_M; grid[10][15] = BREAST; grid[10][16] = OUT;

  grid[11][7]  = OUT;   grid[11][8]  = WHITE;   grid[11][9]  = BODY_L;  grid[11][10] = MANTLE;
  grid[11][11] = PURP_L; grid[11][12] = TEAL_HI; grid[11][13] = BREAST; grid[11][14] = BREAST; grid[11][15] = OUT;

  grid[12][6]  = OUT;   grid[12][7]  = BODY_L;  grid[12][8]  = WING_D;  grid[12][9]  = BODY_M;
  grid[12][10] = BODY_M; grid[12][11] = BREAST; grid[12][12] = BREAST; grid[12][13] = BREAST; grid[12][14] = OUT;

  grid[13][6]  = OUT;   grid[13][7]  = BODY_M;  grid[13][8]  = WING_D;  grid[13][9]  = BODY_M;
  grid[13][10] = BREAST; grid[13][11] = BREAST; grid[13][12] = OUT;

  grid[14][7]  = OUT;   grid[14][8]  = BODY_M;  grid[14][9]  = BODY_L;  grid[14][10] = BODY_M; grid[14][11] = OUT;

  // 4. Extended Coral Legs & Talons (Identical anchor coordinates)
  grid[15][9] = OUT;    grid[15][10] = FOOT;   grid[15][11] = FOOT;   grid[15][12] = OUT;
  grid[16][9] = CLAW;   grid[16][10] = FOOT_D; grid[16][11] = FOOT;   grid[16][12] = CLAW;

  return { grid, gridSize: g };
}

// 4. "Wachsamer Blick": Alert focal stance watching enemy aircraft
function getHD_A9Pigeon_Bird_Threat_Alert() {
  const base = getHD_A9Pigeon_Bird_Perched();
  return base;
}

// Aliases for 100% backward compatibility with Threat1/Threat2
function getHD_A9Pigeon_Bird_Threat1() { return getHD_A9Pigeon_Bird_Threat_Puff(); }
function getHD_A9Pigeon_Bird_Threat2() { return getHD_A9Pigeon_Bird_Threat_Bob(); }

// Pilot variants with golden goggles & crimson scarf
function getHD_A9Pigeon_Pilot_Threat_Puff() {
  const base = getHD_A9Pigeon_Bird_Threat_Puff();
  const grid = base.grid;
  grid[7][14] = '#0f172a'; grid[7][15] = '#facc15'; grid[7][16] = '#ffffff'; grid[7][17] = '#0f172a';
  grid[8][14] = '#0f172a'; grid[8][15] = '#ca8a04'; grid[8][16] = '#facc15'; grid[8][17] = '#0f172a';
  grid[10][10] = '#ef4444'; grid[10][11] = '#b91c1c'; grid[10][12] = '#ef4444';
  grid[11][8]  = '#ef4444'; grid[11][9]  = '#dc2626'; grid[11][10] = '#f87171';
  return { grid, gridSize: base.gridSize };
}

function getHD_A9Pigeon_Pilot_Threat_Bob() {
  const base = getHD_A9Pigeon_Bird_Threat_Bob();
  const grid = base.grid;
  grid[8][15]  = '#0f172a'; grid[8][16]  = '#facc15'; grid[8][17]  = '#ffffff'; grid[8][18]  = '#0f172a';
  grid[9][15]  = '#0f172a'; grid[9][16]  = '#ca8a04'; grid[9][17]  = '#facc15'; grid[9][18]  = '#0f172a';
  grid[10][11] = '#ef4444'; grid[10][12] = '#b91c1c';
  grid[11][9]  = '#dc2626'; grid[11][10] = '#ef4444';
  return { grid, gridSize: base.gridSize };
}

function getHD_A9Pigeon_Pilot_Threat_WingStretch() {
  const base = getHD_A9Pigeon_Bird_Threat_WingStretch();
  const grid = base.grid;
  grid[7][14] = '#0f172a'; grid[7][15] = '#facc15'; grid[7][16] = '#ffffff'; grid[7][17] = '#0f172a';
  grid[8][14] = '#0f172a'; grid[8][15] = '#ca8a04'; grid[8][16] = '#facc15'; grid[8][17] = '#0f172a';
  grid[10][11] = '#ef4444'; grid[10][12] = '#b91c1c'; grid[10][13] = '#ef4444';
  grid[11][9]  = '#ef4444'; grid[11][10] = '#dc2626'; grid[11][11] = '#f87171';
  return { grid, gridSize: base.gridSize };
}

function getHD_A9Pigeon_Pilot_Threat_Alert() {
  return getHD_A9Pigeon_Pilot_Perched();
}

function getHD_A9Pigeon_Pilot_Threat1() { return getHD_A9Pigeon_Pilot_Threat_Puff(); }
function getHD_A9Pigeon_Pilot_Threat2() { return getHD_A9Pigeon_Pilot_Threat_Bob(); }

function getHD_A9Pigeon() {
  const g = 36, grid = makeGrid36();
  const bomb = getHD_A9Pigeon_Bomb().grid;
  const eng  = getHD_A9Pigeon_Engine_Horiz().grid;
  const hull = getHD_A9Pigeon_Hull().grid;
  const gun  = getHD_A9Pigeon_Gatling_Spin1().grid;

  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (bomb[y][x]) grid[y][x] = bomb[y][x];
      if (eng[y][x])  grid[y][x] = eng[y][x];
      if (hull[y][x]) grid[y][x] = hull[y][x];
      if (gun[y][x])  grid[y][x] = gun[y][x];
    }
  }
  return { gridSize: g, grid };
}

// ── A9 GRIZZLY (36x36 HD TIER M) ──────────────────────────────
// Armored gunmetal/titanium exploration vehicle with 3 DISTINCT SUPERSTRUCTURE MODULES
// (matching artwork: 1. Rear Boxy Sensor Shelter with ladder & window, 2. Middle Cylindrical
// Turbine/Generator Drum with cooling louvers & catwalk railing, 3. Front Sloped Armored Cab
// with bullbar & triple halogen searchlights), two circular 12x12 off-road bronze roller wheels,
// 360-degree rotating roof radar array, and cupola .50 cal MG gunner.

export const A9_GRIZZLY_CHASSIS_ROLL_FRAMES = Object.freeze([
  'A9Grizzly_Chassis_Roll1',
  'A9Grizzly_Chassis_Roll2',
  'A9Grizzly_Chassis_Roll3',
  'A9Grizzly_Chassis_Roll4',
  'A9Grizzly_Chassis_Roll5',
  'A9Grizzly_Chassis_Roll6',
  'A9Grizzly_Chassis_Roll7',
  'A9Grizzly_Chassis_Roll8'
]);

export const A9_GRIZZLY_RADAR_ROT_FRAMES = Object.freeze([
  'A9Grizzly_Radar_Rot1',
  'A9Grizzly_Radar_Rot2',
  'A9Grizzly_Radar_Rot3',
  'A9Grizzly_Radar_Rot4',
  'A9Grizzly_Radar_Rot5',
  'A9Grizzly_Radar_Rot6'
]);

function getHD_A9Grizzly_Chassis(roll = 0) {
  const g = 36, grid = makeGrid36();

  const OUT        = '#090d16'; // Deep contour, recessed bulkhead seams & shadow
  const TIRE_D     = '#0f172a'; // Vulcanized rubber shadow / dark rim well
  const TIRE_M     = '#1e293b'; // Dark rim well & tire seam
  const STEEL_DD   = '#1e293b'; // Recessed bulkhead seam & dark steel
  const STEEL_D    = '#334155'; // Dark gunmetal structural steel, struts & catwalk
  const STEEL_M    = '#475569'; // Structural gunmetal frame & suspension
  const HULL_SH    = '#475569'; // Shaded armor plate
  const HULL_M     = '#64748b'; // Main brushed military titanium-steel body
  const HULL_L     = '#94a3b8'; // Upper lit brushed metallic bevel
  const HULL_HI    = '#cbd5e1'; // Sharp specular metallic edge glint, rivets & ladder
  const HULL_WHITE = '#f1f5f9'; // Brightest specular highlight on roof crest & rivets

  // Weathered earth-brown / muddy bronze circular wheel armor palette (sampled from card artwork)
  const BRZ_GOLD   = '#946b56'; // Dusty weathered bronze-clay apex highlight
  const BRZ_CREST  = '#7c5947'; // Weathered earth-brown chevron ridge
  const BRZ_HI     = '#6a4f44'; // Sunlit muddy bronze armor segment
  const BRZ_SH     = '#4a332a'; // Deep shaded umber armor segment
  const BRZ_DK     = '#2e1c14'; // Dark soil/carbon notch between grousers

  // Lights, optics & indicators
  const LAMP_CORE  = '#ffffff'; // Blinding halogen center
  const LAMP_GLOW  = '#fef08a'; // Bright yellow halogen beam
  const LAMP_RIM   = '#facc15'; // Amber lamp housing ring
  const TAIL_RED   = '#ef4444'; // Red beacon lights on rear shelter
  const VISOR_C    = '#38bdf8'; // Cyan tinted armored observation glass
  const LADDER     = '#cbd5e1'; // Metallic ladder rungs
  const HUB_CHROME = '#e2e8f0'; // Chrome hydraulic piston rod

  // =========================================================================
  // MODULE 1: HECK-SHELTER (Rear Sensor & Comms Container Module, x: 1..12)
  // =========================================================================

  // Rear vertical comms mast with dual red warning beacons (x: 1..3, y: 6..12)
  grid[6][2]  = STEEL_M;
  grid[7][2]  = STEEL_M;
  grid[8][1]  = STEEL_M; grid[8][2]  = TAIL_RED; grid[8][3]  = STEEL_D;
  grid[9][2]  = STEEL_M;
  grid[10][2] = STEEL_D;
  grid[11][1] = STEEL_M; grid[11][2] = TAIL_RED; grid[11][3] = STEEL_D;
  grid[12][2] = STEEL_M;

  // Elevated flat container roof line (y: 11..12, x: 3..12)
  grid[11][3] = OUT;     grid[11][4] = HULL_L;  grid[11][5] = HULL_HI; grid[11][6] = HULL_WHITE;
  grid[11][7] = HULL_WHITE; grid[11][8] = HULL_WHITE; grid[11][9] = HULL_HI; grid[11][10] = HULL_L;
  grid[11][11] = HULL_L; grid[11][12] = OUT;

  grid[12][3] = OUT;     grid[12][4] = HULL_L;  grid[12][5] = HULL_HI; grid[12][6] = HULL_L;
  grid[12][7] = HULL_M;  grid[12][8] = HULL_M;  grid[12][9] = HULL_M;  grid[12][10] = HULL_L;
  grid[12][11] = STEEL_DD; grid[12][12] = OUT; // Deep vertical bulkhead corner

  // Shelter side wall, observation window, ladder rungs & door (y: 13..21)
  // Row 13: Upper shelter wall, top of observation window & top ladder rung
  grid[13][3] = STEEL_D; grid[13][4] = HULL_M;  grid[13][5] = HULL_SH; grid[13][6] = OUT;
  grid[13][7] = OUT;     grid[13][8] = OUT;     grid[13][9] = STEEL_D; grid[13][10] = LADDER;
  grid[13][11] = LADDER; grid[13][12] = OUT; // Bulkhead seam 1

  // Row 14: Mid shelter wall, observation window with ballistic cyan glass & ladder rung 1
  grid[14][3] = HULL_M;  grid[14][4] = HULL_M;  grid[14][5] = HULL_SH; grid[14][6] = VISOR_C;
  grid[14][7] = VISOR_C; grid[14][8] = VISOR_C; grid[14][9] = STEEL_D; grid[14][10] = LADDER;
  grid[14][11] = LADDER; grid[14][12] = STEEL_DD;

  // Row 15: Lower observation window, wall panel & ladder spacing
  grid[15][3] = HULL_SH; grid[15][4] = HULL_M;  grid[15][5] = STEEL_DD; grid[15][6] = VISOR_C;
  grid[15][7] = STEEL_DD; grid[15][8] = STEEL_DD; grid[15][9] = STEEL_D; grid[15][10] = STEEL_M;
  grid[15][11] = STEEL_M; grid[15][12] = OUT;

  // Row 16: Container side door panel, top hinge & ladder rung 2
  grid[16][2] = STEEL_DD; grid[16][3] = HULL_HI; grid[16][4] = HULL_M;  grid[16][5] = HULL_M;
  grid[16][6] = HULL_SH; grid[16][7] = HULL_SH; grid[16][8] = HULL_M;  grid[16][9] = STEEL_D;
  grid[16][10] = LADDER; grid[16][11] = LADDER; grid[16][12] = STEEL_DD;

  // Row 17: Container door panel & mid wall
  grid[17][2] = STEEL_DD; grid[17][3] = HULL_M;  grid[17][4] = HULL_M;  grid[17][5] = HULL_SH;
  grid[17][6] = HULL_SH; grid[17][7] = HULL_M;  grid[17][8] = HULL_M;  grid[17][9] = STEEL_D;
  grid[17][10] = STEEL_M; grid[17][11] = STEEL_M; grid[17][12] = OUT;

  // Row 18: Door latch handle & ladder rung 3
  grid[18][2] = STEEL_DD; grid[18][3] = HULL_M;  grid[18][4] = HULL_M;  grid[18][5] = HULL_HI; // Latch handle
  grid[18][6] = HULL_SH; grid[18][7] = HULL_SH; grid[18][8] = HULL_M;  grid[18][9] = STEEL_D;
  grid[18][10] = LADDER; grid[18][11] = LADDER; grid[18][12] = STEEL_DD;

  // Row 19: Lower door hinge & lower wall
  grid[19][2] = STEEL_DD; grid[19][3] = HULL_HI; grid[19][4] = HULL_SH; grid[19][5] = HULL_SH;
  grid[19][6] = STEEL_DD; grid[19][7] = STEEL_DD; grid[19][8] = HULL_SH; grid[19][9] = STEEL_D;
  grid[19][10] = STEEL_M; grid[19][11] = STEEL_M; grid[19][12] = OUT;

  // Row 20: Door sill & bottom ladder rung 4
  grid[20][2] = STEEL_D; grid[20][3] = STEEL_DD; grid[20][4] = STEEL_DD; grid[20][5] = STEEL_DD;
  grid[20][6] = STEEL_DD; grid[20][7] = STEEL_DD; grid[20][8] = STEEL_D; grid[20][9] = STEEL_D;
  grid[20][10] = LADDER; grid[20][11] = LADDER; grid[20][12] = STEEL_DD;

  // Row 21..22: Lower shelter skirt over rear wheel arch
  grid[21][2] = STEEL_D; grid[21][3] = OUT;     grid[21][4] = OUT;     grid[21][11] = STEEL_D;
  grid[21][12] = OUT;
  grid[22][2] = STEEL_DD; grid[22][3] = OUT;    grid[22][12] = STEEL_DD;

  // =========================================================================
  // MODULE 2: MITTEL-SEKTION (Cylindrical Turbine / Generator Drum, x: 13..22)
  // =========================================================================

  // Left Bolted Bulkhead Flange Ring (x=13, y: 13..21)
  grid[13][13] = HULL_HI;  // Bolted rivet head 1
  grid[14][13] = STEEL_DD; // Recessed ring seam
  grid[15][13] = HULL_HI;  // Bolted rivet head 2
  grid[16][13] = STEEL_DD;
  grid[17][13] = HULL_HI;  // Bolted rivet head 3
  grid[18][13] = STEEL_DD;
  grid[19][13] = HULL_HI;  // Bolted rivet head 4
  grid[20][13] = STEEL_DD;
  grid[21][13] = HULL_HI;  // Bolted rivet head 5

  // Cylindrical Turbine Drum Body & Cooling Louvers (x: 14..21, y: 13..19)
  // Row 13: Arched curved cylindrical crest (curves lower than shelter roof y=11..12)
  grid[13][14] = HULL_L;  grid[13][15] = HULL_HI; grid[13][16] = HULL_HI; grid[13][17] = HULL_WHITE;
  grid[13][18] = HULL_WHITE; grid[13][19] = HULL_HI; grid[13][20] = HULL_L;  grid[13][21] = HULL_M;

  // Row 14: Upper cylindrical curve with brushed highlight
  grid[14][14] = HULL_M;  grid[14][15] = HULL_L;  grid[14][16] = HULL_L;  grid[14][17] = HULL_HI;
  grid[14][18] = HULL_HI; grid[14][19] = HULL_L;  grid[14][20] = HULL_M;  grid[14][21] = HULL_SH;

  // Row 15: Upper horizontal cooling louver vent slots
  grid[15][14] = HULL_SH; grid[15][15] = OUT;     grid[15][16] = STEEL_DD; grid[15][17] = OUT;
  grid[15][18] = STEEL_DD; grid[15][19] = OUT;    grid[15][20] = STEEL_DD; grid[15][21] = HULL_SH;

  // Row 16..17: Mid cylindrical flank with Faction Insignia Badge
  grid[16][14] = HULL_SH; grid[16][15] = HULL_M;  grid[16][16] = 'TEAM';  grid[16][17] = 'TEAM';
  grid[16][18] = 'TEAM';  grid[16][19] = 'TEAM';  grid[16][20] = HULL_M;  grid[16][21] = HULL_SH;

  grid[17][14] = HULL_SH; grid[17][15] = HULL_M;  grid[17][16] = 'TEAM';  grid[17][17] = 'TEAM';
  grid[17][18] = 'TEAM';  grid[17][19] = 'TEAM';  grid[17][20] = HULL_M;  grid[17][21] = HULL_SH;

  // Row 18: Lower horizontal cooling louver vent slots
  grid[18][14] = STEEL_D; grid[18][15] = STEEL_DD; grid[18][16] = OUT;     grid[18][17] = STEEL_DD;
  grid[18][18] = OUT;     grid[18][19] = STEEL_DD; grid[18][20] = OUT;     grid[18][21] = STEEL_D;

  // Row 19: Lower cylindrical curve
  grid[19][14] = STEEL_D; grid[19][15] = STEEL_D; grid[19][16] = HULL_SH; grid[19][17] = HULL_SH;
  grid[19][18] = HULL_SH; grid[19][19] = STEEL_D; grid[19][20] = STEEL_D; grid[19][21] = STEEL_DD;

  // Row 20..22: Industrial Catwalk & Maintenance Railing (Laufsteg mit Geländer)
  // Row 20: Horizontal safety handrail & vertical stanchion posts
  grid[20][14] = HULL_HI; grid[20][15] = STEEL_D; grid[20][16] = STEEL_D; grid[20][17] = HULL_HI;
  grid[20][18] = STEEL_D; grid[20][19] = STEEL_D; grid[20][20] = HULL_HI; grid[20][21] = STEEL_D;

  // Row 21: Diamond mesh grating floor
  grid[21][14] = STEEL_M; grid[21][15] = HULL_L;  grid[21][16] = STEEL_DD; grid[21][17] = STEEL_M;
  grid[21][18] = HULL_L;  grid[21][19] = STEEL_DD; grid[21][20] = STEEL_M; grid[21][21] = HULL_L;

  // Row 22: Support gusset brackets
  grid[22][14] = OUT;     grid[22][17] = OUT;     grid[22][20] = OUT;

  // Right Bolted Bulkhead Flange Ring (x=22, y: 13..21)
  grid[13][22] = HULL_HI;  // Bolted rivet head 1
  grid[14][22] = STEEL_DD; // Recessed ring seam
  grid[15][22] = HULL_HI;  // Bolted rivet head 2
  grid[16][22] = STEEL_DD;
  grid[17][22] = HULL_HI;  // Bolted rivet head 3
  grid[18][22] = STEEL_DD;
  grid[19][22] = HULL_HI;  // Bolted rivet head 4
  grid[20][22] = STEEL_DD;
  grid[21][22] = HULL_HI;  // Bolted rivet head 5
  grid[22][22] = OUT;

  // =========================================================================
  // MODULE 3: BUG-KABINE (Front Cockpit, Bullbar & Searchlights, x: 23..35)
  // =========================================================================

  // Row 12..13: Cab roof deck & overhead halogen floodlights
  grid[12][24] = STEEL_DD; grid[12][25] = HULL_M;  grid[12][26] = HULL_L;  grid[12][27] = HULL_HI;
  grid[12][28] = OUT;

  grid[13][23] = STEEL_D;  grid[13][24] = HULL_L;  grid[13][25] = LAMP_CORE; grid[13][26] = LAMP_GLOW;
  grid[13][27] = LAMP_RIM; grid[13][28] = HULL_L;  grid[13][29] = OUT;

  // Row 14: Visor brow overhang
  grid[14][23] = STEEL_D;  grid[14][24] = HULL_L;  grid[14][25] = HULL_HI; grid[14][26] = HULL_L;
  grid[14][27] = HULL_M;   grid[14][28] = HULL_SH; grid[14][29] = OUT;

  // Row 15..17: Sloped armored windshield visor & ballistic cyan glass
  // Row 15: Upper windshield slit
  grid[15][23] = HULL_M;   grid[15][24] = HULL_M;  grid[15][25] = OUT;     grid[15][26] = VISOR_C;
  grid[15][27] = VISOR_C;  grid[15][28] = VISOR_C; grid[15][29] = OUT;

  // Row 16: Mid windshield glass & corner light
  grid[16][23] = HULL_SH;  grid[16][24] = HULL_M;  grid[16][25] = VISOR_C; grid[16][26] = VISOR_C;
  grid[16][27] = VISOR_C;  grid[16][28] = LAMP_GLOW; grid[16][29] = LAMP_CORE; grid[16][30] = OUT;

  // Row 17: Lower windshield frame & cowl seam
  grid[17][23] = STEEL_D;  grid[17][24] = HULL_SH; grid[17][25] = HULL_M;  grid[17][26] = HULL_L;
  grid[17][27] = HULL_L;   grid[17][28] = HULL_M;  grid[17][29] = STEEL_DD; grid[17][30] = OUT;

  // Row 18..24: Sloped nose plate, Radiator Grille & TRIPLE Bullbar Halogen Searchlights
  // Row 18: Nose plate, grille top & Lamp 1 top rim
  grid[18][24] = STEEL_D;  grid[18][25] = HULL_SH; grid[18][26] = HULL_M;  grid[18][27] = HULL_L;
  grid[18][28] = HULL_M;   grid[18][29] = STEEL_DD; grid[18][30] = STEEL_D;
  // Lamp 1 (Upper Searchlight, center x=32..33, y=19):
  grid[18][31] = STEEL_D;  grid[18][32] = LAMP_RIM; grid[18][33] = LAMP_RIM; grid[18][34] = STEEL_D; grid[18][35] = OUT;

  // Row 19: Grille slats & Lamp 1 glowing lens
  grid[19][24] = STEEL_M;  grid[19][25] = HULL_M;  grid[19][26] = HULL_L;  grid[19][27] = HULL_M;
  grid[19][28] = OUT;      grid[19][29] = STEEL_DD; grid[19][30] = STEEL_M;
  grid[19][31] = LAMP_RIM; grid[19][32] = LAMP_CORE; grid[19][33] = LAMP_GLOW; grid[19][34] = LAMP_RIM; grid[19][35] = OUT;

  // Row 20: Hydraulic strut, radiator grille & Lamp 2 (Middle Searchlight, center x=33..34, y=20..21)
  grid[20][23] = HULL_HI;  grid[20][24] = HUB_CHROME; grid[20][25] = HUB_CHROME; grid[20][26] = STEEL_M;
  grid[20][27] = HULL_SH;  grid[20][28] = OUT;     grid[20][29] = STEEL_DD; grid[20][30] = STEEL_D;
  grid[20][31] = STEEL_M;  grid[20][32] = LAMP_RIM; grid[20][33] = LAMP_CORE; grid[20][34] = LAMP_GLOW; grid[20][35] = OUT;

  // Row 21: Hydraulic strut shaft, radiator grille & Lamp 2 lower lens
  grid[21][23] = STEEL_M;  grid[21][24] = HUB_CHROME; grid[21][25] = HUB_CHROME; grid[21][26] = STEEL_D;
  grid[21][27] = STEEL_D;  grid[21][28] = OUT;     grid[21][29] = STEEL_DD; grid[21][30] = STEEL_M;
  grid[21][31] = STEEL_D;  grid[21][32] = LAMP_RIM; grid[21][33] = LAMP_GLOW; grid[21][34] = LAMP_RIM; grid[21][35] = OUT;

  // Row 22: Lower strut foot, bumper rail & Lamp 3 (Bottom Searchlight, center x=32..33, y=22)
  grid[22][23] = STEEL_D;  grid[22][24] = STEEL_D; grid[22][25] = HULL_HI; grid[22][26] = STEEL_M;
  grid[22][27] = STEEL_DD; grid[22][28] = STEEL_D; grid[22][29] = STEEL_M; grid[22][30] = STEEL_D;
  grid[22][31] = LAMP_RIM; grid[22][32] = LAMP_CORE; grid[22][33] = LAMP_GLOW; grid[22][34] = LAMP_RIM; grid[22][35] = OUT;

  // Row 23: Lower tubular bullbar loop & Lamp 3 bottom rim
  grid[23][24] = STEEL_DD; grid[23][25] = STEEL_M; grid[23][26] = HULL_HI; grid[23][27] = STEEL_D;
  grid[23][28] = OUT;     grid[23][29] = STEEL_D; grid[23][30] = STEEL_M;
  grid[23][31] = STEEL_D;  grid[23][32] = LAMP_RIM; grid[23][33] = LAMP_RIM; grid[23][34] = STEEL_D; grid[23][35] = OUT;

  // Row 24: Front heavy push bumper / bullbar frame & tow pintle
  grid[24][28] = STEEL_DD; grid[24][29] = STEEL_M; grid[24][30] = STEEL_D; grid[24][31] = STEEL_M;
  grid[24][32] = STEEL_DD; grid[24][33] = OUT;

  // Central undercarriage frame & transmission linkage between wheels (x: 13..20, y: 22..24)
  grid[22][14] = STEEL_M;  grid[22][15] = STEEL_DD; grid[22][16] = HULL_L;  grid[22][17] = HULL_M;
  grid[22][18] = STEEL_D;  grid[22][19] = STEEL_M;
  grid[23][14] = TIRE_M;   grid[23][15] = STEEL_M;  grid[23][16] = STEEL_DD; grid[23][17] = HULL_L;
  grid[23][18] = STEEL_M;  grid[23][19] = TIRE_D;
  grid[24][15] = STEEL_DD; grid[24][16] = STEEL_M;  grid[24][17] = STEEL_DD; grid[24][18] = STEEL_DD;

  // =========================================================================
  // 4. TWO MASSIVE CIRCULAR 12x12 PIXEL ROLLER WHEELS (wx: 2..13 and wx: 20..31)
  // =========================================================================
  const CIRCLE_SPANS_12 = [
    [4, 7],   // dy=0  (y=22): 4px top flat chord
    [2, 9],   // dy=1  (y=23): 8px upper shoulder
    [1, 10],  // dy=2  (y=24): 10px upper curve
    [0, 11],  // dy=3  (y=25): 12px full width
    [0, 11],  // dy=4  (y=26): 12px full width
    [0, 11],  // dy=5  (y=27): 12px full width
    [0, 11],  // dy=6  (y=28): 12px full width
    [0, 11],  // dy=7  (y=29): 12px full width
    [0, 11],  // dy=8  (y=30): 12px full width
    [1, 10],  // dy=9  (y=31): 10px lower curve
    [2, 9],   // dy=10 (y=32): 8px lower shoulder
    [4, 7]    // dy=11 (y=33): 4px bottom ground contact chord
  ];

  const drawGrizzlyWheel36 = (wx, phase) => {
    const numSectors = 6;
    const sectorAngle = (Math.PI * 2) / numSectors; // 60°
    // 8-phase chunky roll cycle advancing 22.5° (π/8) per frame clockwise (3x larger angle step than previous 7.5°!)
    // Rotates physical fragment chevrons and rim bolts for unmistakable, punchy mechanical rotation
    const rotOffset = phase * (Math.PI / 8);

    for (let dy = 0; dy < 12; dy++) {
      const wy = 22 + dy;
      const [xMin, xMax] = CIRCLE_SPANS_12[dy];

      for (let dx = 0; dx < 12; dx++) {
        // Carve out clean transparent corners outside the 12x12 circle
        if (dx < xMin || dx > xMax) {
          grid[wy][wx + dx] = null;
          continue;
        }

        const rx = dx - 5.5;
        const ry = dy - 5.5;
        const distSq = rx * rx + ry * ry;
        const dist = Math.sqrt(distSq);
        const polar = Math.atan2(ry, rx); // -π..+π
        // Clockwise rotation (polar - rotOffset)
        const rotAngle = ((polar - rotOffset) % (Math.PI * 2) + Math.PI * 2) % (Math.PI * 2);

        // LAYER 1: Central Planetary Axle Cap (dist <= 1.4)
        if (dist <= 1.4) {
          const glint = Math.floor((rotAngle / (Math.PI / 2))) % 4;
          grid[wy][wx + dx] = (glint === 0) ? HULL_WHITE : STEEL_M;
          continue;
        }

        // LAYER 2: Planetary Flange & Rim Well (1.4 < dist <= 3.3)
        if (dist <= 3.3) {
          const spokeFrac = (rotAngle % sectorAngle) / sectorAngle;
          if (spokeFrac >= 0.38 && spokeFrac <= 0.62 && dist >= 1.7 && dist <= 2.9) {
            // Steel bolt on planetary flange orbiting with wheel
            grid[wy][wx + dx] = HULL_HI;
          } else {
            // Cast-iron dark rim well
            grid[wy][wx + dx] = TIRE_D;
          }
          continue;
        }

        // 6 interlocking bronze crawler tread sectors (fragments)
        const sectorFrac = (rotAngle % sectorAngle) / sectorAngle;

        // LAYER 3: Segmented Bronze Armor Plate Band (3.3 < dist <= 4.7)
        if (dist <= 4.7) {
          // PITCH-BLACK RAZOR GAP between adjacent fragments!
          if (sectorFrac < 0.16) {
            grid[wy][wx + dx] = OUT; // Distinct black separation line!
          } else if (
            // DUAL RIVET BOLT HOLES punched into each segment (matching artwork!)
            (sectorFrac >= 0.25 && sectorFrac <= 0.36 && dist >= 3.6 && dist <= 4.4) ||
            (sectorFrac >= 0.64 && sectorFrac <= 0.75 && dist >= 3.6 && dist <= 4.4)
          ) {
            grid[wy][wx + dx] = OUT; // Dark punched bolt holes
          } else if (sectorFrac >= 0.42 && sectorFrac <= 0.58) {
            // Raised center chevron ridge: glint rotates with fragment!
            grid[wy][wx + dx] = BRZ_GOLD;
          } else if (sectorFrac < 0.42) {
            // Leading sunlit flank of fragment
            grid[wy][wx + dx] = BRZ_HI;
          } else {
            // Trailing shaded flank of fragment
            grid[wy][wx + dx] = BRZ_SH;
          }
          continue;
        }

        // LAYER 4: Outer Bronze Grousers / Perimeter Tread Shoes (dist > 4.7)
        if (sectorFrac < 0.18) {
          // Recessed notch between pads
          grid[wy][wx + dx] = BRZ_DK;
        } else if (sectorFrac >= 0.36 && sectorFrac <= 0.64) {
          // Protruding heavy chevron shoe peak
          grid[wy][wx + dx] = BRZ_GOLD;
        } else if (sectorFrac < 0.36) {
          grid[wy][wx + dx] = BRZ_CREST;
        } else {
          grid[wy][wx + dx] = BRZ_SH;
        }
      }
    }
  };

  // Stamp Rear Wheel (wx = 2..13) & Front Wheel (wx = 20..31) with 8-phase rotation
  const p = ((roll % 8) + 8) % 8;
  drawGrizzlyWheel36(2, p);
  drawGrizzlyWheel36(20, p);

  return { grid, gridSize: g };
}

function getHD_A9Grizzly_Chassis_Roll1() { return getHD_A9Grizzly_Chassis(0); }
function getHD_A9Grizzly_Chassis_Roll2() { return getHD_A9Grizzly_Chassis(1); }
function getHD_A9Grizzly_Chassis_Roll3() { return getHD_A9Grizzly_Chassis(2); }
function getHD_A9Grizzly_Chassis_Roll4() { return getHD_A9Grizzly_Chassis(3); }
function getHD_A9Grizzly_Chassis_Roll5() { return getHD_A9Grizzly_Chassis(4); }
function getHD_A9Grizzly_Chassis_Roll6() { return getHD_A9Grizzly_Chassis(5); }
function getHD_A9Grizzly_Chassis_Roll7() { return getHD_A9Grizzly_Chassis(6); }
function getHD_A9Grizzly_Chassis_Roll8() { return getHD_A9Grizzly_Chassis(7); }

// ── ROOF RADAR ARRAY: 360-DEGREE CONTINUOUS ROTATION (6 PHASES) ─────────────
// Features BOTH antennas from artwork:
// 1. Massive parabolic satellite dish on rear shelter (pedestal at x: 7..10, y: 10..11)
// 2. Rectangular rotating lattice grid scanner on middle turbine (pedestal at x: 16..18, y: 11..12)
function getHD_A9Grizzly_Radar(rot = 0) {
  const g = 36, grid = makeGrid36();

  const OUT      = '#090d16';
  const STEEL_DD = '#0f172a';
  const STEEL_D  = '#1e293b';
  const STEEL_M  = '#334155';
  const DISH_SH = '#475569';
  const DISH_M  = '#64748b';
  const DISH_L  = '#94a3b8';
  const DISH_HI = '#cbd5e1';
  const DISH_WT = '#f1f5f9';
  const FEED_C  = '#38bdf8';
  const BEACON  = '#ef4444';

  const rotIdx = ((rot % 6) + 6) % 6;

  // 1. GIMBAL PEDESTALS ON ROOF DECKS
  // Rear Shelter gimbal pedestal (x: 7..10, y: 10..11)
  grid[10][7]  = STEEL_D; grid[10][8]  = DISH_M;  grid[10][9]  = DISH_M;  grid[10][10] = STEEL_D;
  grid[11][7]  = STEEL_D; grid[11][8]  = STEEL_M; grid[11][9]  = STEEL_M; grid[11][10] = STEEL_D;

  // Middle Turbine radar pylon (x: 16..18, y: 11..12)
  grid[11][16] = STEEL_M; grid[11][17] = STEEL_M; grid[11][18] = STEEL_M;
  grid[12][16] = STEEL_D; grid[12][17] = STEEL_M; grid[12][18] = STEEL_D;

  if (rotIdx === 0) {
    // ── ROTATION PHASE 0 (0°: Broadside facing forward-right / target) ──
    // Rear Parabolic Dish (Wide concave reflector bowl facing right, feed horn pointing right)
    grid[2][8]  = BEACON;  grid[2][9]  = DISH_HI;
    grid[3][7]  = OUT;     grid[3][8]  = DISH_WT; grid[3][9]  = DISH_L;  grid[3][10] = STEEL_M;
    grid[4][6]  = OUT;     grid[4][7]  = DISH_WT; grid[4][8]  = DISH_L;  grid[4][9]  = DISH_M;  grid[4][10] = STEEL_D;
    grid[5][5]  = OUT;     grid[5][6]  = DISH_L;  grid[5][7]  = DISH_M;  grid[5][8]  = DISH_SH; grid[5][9]  = STEEL_D; grid[5][10] = STEEL_M; grid[5][11] = STEEL_M; grid[5][12] = FEED_C;
    grid[6][5]  = OUT;     grid[6][6]  = DISH_L;  grid[6][7]  = DISH_M;  grid[6][8]  = DISH_SH; grid[6][9]  = STEEL_D; grid[6][10] = FEED_C;  grid[6][11] = FEED_C;  grid[6][12] = FEED_C;
    grid[7][6]  = OUT;     grid[7][7]  = DISH_M;  grid[7][8]  = DISH_SH; grid[7][9]  = OUT;
    grid[8][7]  = OUT;     grid[8][8]  = STEEL_M; grid[8][9]  = STEEL_M; grid[8][10] = STEEL_D;
    grid[9][8]  = STEEL_M; grid[9][9]  = STEEL_D;

    // Middle Lattice Grid Scanner (Wide rectangular mesh facing forward-right)
    grid[7][15]  = OUT;     grid[7][16]  = DISH_L;  grid[7][17]  = DISH_HI; grid[7][18]  = DISH_WT; grid[7][19]  = OUT;
    grid[8][15]  = DISH_L;  grid[8][16]  = STEEL_D; grid[8][17]  = DISH_M;  grid[8][18]  = STEEL_D; grid[8][19]  = DISH_L;
    grid[9][15]  = DISH_M;  grid[9][16]  = DISH_SH; grid[9][17]  = STEEL_M; grid[9][18]  = DISH_SH; grid[9][19]  = DISH_M;
    grid[10][16] = STEEL_D; grid[10][17] = STEEL_M; grid[10][18] = STEEL_D;
  } else if (rotIdx === 1) {
    // ── ROTATION PHASE 1 (60°: Angled forward, narrowing toward viewer) ──
    // Rear Parabolic Dish (Angled 3/4 front)
    grid[2][9]  = BEACON;  grid[2][10] = DISH_HI;
    grid[3][8]  = OUT;     grid[3][9]  = DISH_WT; grid[3][10] = DISH_L;
    grid[4][7]  = OUT;     grid[4][8]  = DISH_HI; grid[4][9]  = DISH_L;  grid[4][10] = FEED_C;
    grid[5][7]  = OUT;     grid[5][8]  = DISH_L;  grid[5][9]  = DISH_M;  grid[5][10] = FEED_C; grid[5][11] = FEED_C;
    grid[6][7]  = OUT;     grid[6][8]  = DISH_M;  grid[6][9]  = DISH_SH; grid[6][10] = STEEL_D;
    grid[7][7]  = OUT;     grid[7][8]  = DISH_M;  grid[7][9]  = DISH_SH;
    grid[8][8]  = STEEL_M; grid[8][9]  = STEEL_D;
    grid[9][8]  = STEEL_M; grid[9][9]  = STEEL_D;

    // Middle Lattice Grid Scanner (Angled mesh)
    grid[7][16]  = DISH_HI; grid[7][17]  = DISH_WT; grid[7][18]  = DISH_L;
    grid[8][16]  = DISH_L;  grid[8][17]  = STEEL_D; grid[8][18]  = DISH_M;
    grid[9][16]  = STEEL_D; grid[9][17]  = STEEL_M; grid[9][18]  = STEEL_D;
    grid[10][17] = STEEL_M;
  } else if (rotIdx === 2) {
    // ── ROTATION PHASE 2 (120°: Edge-on profile, turning toward back) ──
    // Rear Parabolic Dish (Sleek edge-on vertical blade, feed horn pointing at camera)
    grid[2][9]  = BEACON;
    grid[3][9]  = DISH_WT;
    grid[4][9]  = DISH_HI;
    grid[5][9]  = DISH_L;  grid[5][10] = FEED_C;  grid[5][11] = FEED_C;
    grid[6][9]  = DISH_M;  grid[6][10] = FEED_C;
    grid[7][9]  = DISH_SH;
    grid[8][9]  = STEEL_M;
    grid[9][8]  = STEEL_M; grid[9][9]  = STEEL_D;

    // Middle Lattice Grid Scanner (Edge-on vertical mast)
    grid[7][17]  = DISH_HI;
    grid[8][17]  = DISH_L;
    grid[9][17]  = STEEL_M;
    grid[10][17] = STEEL_D;
  } else if (rotIdx === 3) {
    // ── ROTATION PHASE 3 (180°: Turned COMPLETELY REAR / facing left) ──
    // Rear Parabolic Dish (Showing dark convex titanium rear shell & cross trusses)
    grid[2][7]  = DISH_HI; grid[2][8]  = BEACON;
    grid[3][7]  = STEEL_M; grid[3][8]  = DISH_SH; grid[3][9]  = STEEL_D; grid[3][10] = OUT;
    grid[4][6]  = STEEL_M; grid[4][7]  = DISH_SH; grid[4][8]  = STEEL_D; grid[4][9]  = STEEL_D; grid[4][10] = OUT;
    grid[5][5]  = STEEL_M; grid[5][6]  = DISH_SH; grid[5][7]  = STEEL_D; grid[5][8]  = STEEL_D; grid[5][9]  = STEEL_D; grid[5][10] = OUT;
    grid[6][6]  = STEEL_D; grid[6][7]  = STEEL_M; grid[6][8]  = STEEL_D; grid[6][9]  = STEEL_D; grid[6][10] = OUT;
    grid[7][7]  = STEEL_D; grid[7][8]  = STEEL_M; grid[7][9]  = STEEL_D; grid[7][10] = OUT;
    grid[8][7]  = STEEL_D; grid[8][8]  = STEEL_M; grid[8][9]  = OUT;
    grid[9][8]  = STEEL_M; grid[9][9]  = STEEL_D;

    // Middle Lattice Grid Scanner (Rear structural backing)
    grid[7][15]  = OUT;     grid[7][16]  = STEEL_M; grid[7][17]  = DISH_SH; grid[7][18]  = STEEL_D; grid[7][19]  = OUT;
    grid[8][15]  = STEEL_D; grid[8][16]  = STEEL_M; grid[8][17]  = STEEL_D; grid[8][18]  = STEEL_M; grid[8][19]  = STEEL_D;
    grid[9][15]  = STEEL_DD; grid[9][16] = STEEL_D; grid[9][17] = STEEL_M; grid[9][18] = STEEL_D; grid[9][19] = STEEL_DD;
    grid[10][16] = STEEL_D; grid[10][17] = STEEL_M; grid[10][18] = STEEL_D;
  } else if (rotIdx === 4) {
    // ── ROTATION PHASE 4 (240°: Angled backward-left) ──
    // Rear Parabolic Dish (Angled 3/4 rear)
    grid[2][8]  = BEACON;  grid[2][9]  = STEEL_M;
    grid[3][7]  = STEEL_M; grid[3][8]  = DISH_SH; grid[3][9]  = OUT;
    grid[4][7]  = STEEL_M; grid[4][8]  = STEEL_D; grid[4][9]  = OUT;
    grid[5][7]  = STEEL_M; grid[5][8]  = STEEL_D; grid[5][9]  = OUT;
    grid[6][7]  = STEEL_D; grid[6][8]  = STEEL_M; grid[6][9]  = OUT;
    grid[7][8]  = STEEL_D; grid[7][9]  = STEEL_M; grid[7][10] = OUT;
    grid[8][8]  = STEEL_M; grid[8][9]  = STEEL_D;
    grid[9][8]  = STEEL_M; grid[9][9]  = STEEL_D;

    // Middle Lattice Grid Scanner (Angled rear mesh)
    grid[7][16]  = STEEL_M; grid[7][17]  = DISH_SH; grid[7][18]  = STEEL_D;
    grid[8][16]  = STEEL_D; grid[8][17]  = STEEL_M; grid[8][18]  = STEEL_D;
    grid[9][16]  = STEEL_DD; grid[9][17] = STEEL_M; grid[9][18] = STEEL_D;
    grid[10][17] = STEEL_M;
  } else {
    // ── ROTATION PHASE 5 (300°: Edge-on returning toward front) ──
    // Rear Parabolic Dish (Returning edge-on vertical blade)
    grid[2][8]  = BEACON;
    grid[3][8]  = DISH_WT;
    grid[4][8]  = DISH_HI;
    grid[5][8]  = DISH_L;  grid[5][9]  = FEED_C;  grid[5][10] = FEED_C;
    grid[6][8]  = DISH_M;  grid[6][9]  = FEED_C;
    grid[7][8]  = DISH_SH;
    grid[8][8]  = STEEL_M;
    grid[9][8]  = STEEL_M; grid[9][9]  = STEEL_D;

    // Middle Lattice Grid Scanner (Edge-on returning)
    grid[7][17]  = DISH_HI;
    grid[8][17]  = DISH_L;
    grid[9][17]  = STEEL_M;
    grid[10][17] = STEEL_D;
  }

  return { grid, gridSize: g };
}

function getHD_A9Grizzly_Radar_Rot1() { return getHD_A9Grizzly_Radar(0); }
function getHD_A9Grizzly_Radar_Rot2() { return getHD_A9Grizzly_Radar(1); }
function getHD_A9Grizzly_Radar_Rot3() { return getHD_A9Grizzly_Radar(2); }
function getHD_A9Grizzly_Radar_Rot4() { return getHD_A9Grizzly_Radar(3); }
function getHD_A9Grizzly_Radar_Rot5() { return getHD_A9Grizzly_Radar(4); }
function getHD_A9Grizzly_Radar_Rot6() { return getHD_A9Grizzly_Radar(5); }

function getHD_A9Grizzly_Turret() {
  const g = 36, grid = makeGrid36();

  const OUT     = '#090d16';
  const GUN_D   = '#0f172a';
  const GUN_M   = '#1e293b';
  const STEEL_D = '#334155';
  const SHLD_SH = '#475569';
  const SHLD_M  = '#64748b';
  const SHLD_L  = '#94a3b8';
  const SHLD_HI = '#cbd5e1';
  const SHLD_WT = '#f1f5f9';
  const VISOR   = '#38bdf8';
  const BRASS   = '#d97706';
  const AMMO_G  = '#f59e0b';

  // 1. HUMAN GUNNER IN ROOF CUPOLA (x: 18..23, y: 7..12)
  // Helmet dome & glowing cyan visor
  grid[7][19]  = OUT;     grid[7][20]  = SHLD_M;  grid[7][21]  = SHLD_L;  grid[7][22]  = OUT;
  grid[8][19]  = SHLD_SH; grid[8][20]  = STEEL_D; grid[8][21]  = STEEL_D; grid[8][22]  = VISOR;   grid[8][23]  = VISOR;
  // Armored shoulders & torso in hatch with TEAM insignia
  grid[9][18]  = OUT;     grid[9][19]  = 'TEAM';  grid[9][20]  = 'TEAM';  grid[9][21]  = SHLD_SH; grid[9][22]  = GUN_M;
  grid[10][18] = STEEL_D; grid[10][19] = 'TEAM';  grid[10][20] = 'TEAM';  grid[10][21] = SHLD_M;  grid[10][22] = GUN_M;   grid[10][23] = SHLD_L; // Spade grip hand
  grid[11][18] = STEEL_D; grid[11][19] = SHLD_SH; grid[11][20] = SHLD_M;  grid[11][21] = STEEL_D; grid[11][22] = STEEL_D;
  // Cupola hatch coaming ring
  grid[12][18] = STEEL_D; grid[12][19] = STEEL_D; grid[12][20] = SHLD_SH; grid[12][21] = STEEL_D; grid[12][22] = STEEL_D; grid[12][23] = STEEL_D;

  // 2. ANGLED BRUSHED-TITANIUM V-SHIELD MANTLET (x: 24..27, y: 7..12)
  grid[7][24]  = SHLD_WT; grid[7][25]  = SHLD_HI; grid[7][26]  = SHLD_L;
  grid[8][24]  = SHLD_HI; grid[8][25]  = OUT;     grid[8][26]  = SHLD_HI; grid[8][27]  = SHLD_M; // Sighting aperture
  grid[9][24]  = SHLD_L;  grid[9][25]  = SHLD_HI; grid[9][26]  = SHLD_L;  grid[9][27]  = SHLD_L;
  grid[10][24] = SHLD_M;  grid[10][25] = SHLD_L;  grid[10][26] = SHLD_L;  grid[10][27] = SHLD_SH;
  grid[11][24] = STEEL_D; grid[11][25] = SHLD_M;  grid[11][26] = SHLD_SH; grid[11][27] = STEEL_D;
  grid[12][24] = OUT;     grid[12][25] = SHLD_SH; grid[12][26] = STEEL_D;

  // 3. LONG-BARRELED .50 CAL HEAVY MACHINE GUN (x: 27..35, y: 8..12)
  // Receiver box & charging handle
  grid[8][28]  = GUN_D;   grid[8][29]  = GUN_D;
  grid[9][28]  = GUN_D;   grid[9][29]  = SHLD_SH; grid[9][30]  = GUN_D;   grid[9][31]  = SHLD_SH;
  grid[9][32]  = GUN_D;   grid[9][33]  = SHLD_M;  grid[9][34]  = SHLD_L;  grid[9][35]  = SHLD_HI; // Barrel upper sleeve & muzzle brake
  grid[10][28] = SHLD_M;  grid[10][29] = GUN_M;   grid[10][30] = SHLD_M;  grid[10][31] = GUN_D;
  grid[10][32] = SHLD_M;  grid[10][33] = GUN_D;   grid[10][34] = SHLD_SH; grid[10][35] = SHLD_L; // Barrel lower sleeve & brake
  // Brass linked ammunition belt & feed box
  grid[11][27] = BRASS;   grid[11][28] = AMMO_G;  grid[11][29] = GUN_D;
  grid[12][27] = BRASS;   grid[12][28] = GUN_D;

  return { grid, gridSize: g };
}

function getHD_A9Grizzly() {
  const g = 36, grid = makeGrid36();
  const c = getHD_A9Grizzly_Chassis(0).grid;
  const r = getHD_A9Grizzly_Radar().grid;
  const t = getHD_A9Grizzly_Turret().grid;

  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (c[y][x]) grid[y][x] = c[y][x];
      if (r[y][x]) grid[y][x] = r[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
    }
  }
  return { gridSize: g, grid };
}

function _composeA9GrizzlyRoll(roll = 0) {
  const g = 36, grid = makeGrid36();
  const c = getHD_A9Grizzly_Chassis(roll).grid;
  const r = getHD_A9Grizzly_Radar().grid;
  const t = getHD_A9Grizzly_Turret().grid;
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (c[y][x]) grid[y][x] = c[y][x];
      if (r[y][x]) grid[y][x] = r[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
    }
  }
  return { gridSize: g, grid };
}
function getHD_A9Grizzly_Roll1() { return _composeA9GrizzlyRoll(0); }
function getHD_A9Grizzly_Roll2() { return _composeA9GrizzlyRoll(1); }
function getHD_A9Grizzly_Roll3() { return _composeA9GrizzlyRoll(2); }
function getHD_A9Grizzly_Roll4() { return _composeA9GrizzlyRoll(3); }
function getHD_A9Grizzly_Roll5() { return _composeA9GrizzlyRoll(4); }
function getHD_A9Grizzly_Roll6() { return _composeA9GrizzlyRoll(5); }
function getHD_A9Grizzly_Roll7() { return _composeA9GrizzlyRoll(6); }
function getHD_A9Grizzly_Roll8() { return _composeA9GrizzlyRoll(7); }

// ── DEPLOYABLE CANNON (24x24 HD) ───────────────────────────────
function getHD_DeployableCannon_Base() {
  const g = 24, grid = makeGrid(g);

  const T_OUTLINE = '#090d16'; // Deep structural contour & shadow
  const T_DARK    = '#0f172a'; // Recessed shadow & deep armor
  const T_BASE_D  = '#1e293b'; // Lower armor & shaded mechanical parts
  const T_BASE    = '#334155'; // Main military titanium body
  const T_MID     = '#475569'; // Mid plate / panel surfaces
  const T_HI      = '#64748b'; // Specular highlight & ridge reflection
  const T_GLINT   = '#94a3b8'; // Metallic edge bevel
  const T_SHINE   = '#cbd5e1'; // Polished titanium / chrome fittings
  const T_WHITE   = '#f1f5f9'; // Flash suppressor / optics glint

  // 1. ROTARY TURRET BEARING COLLAR (y: 11..13, x: 7..14)
  grid[11][8]  = T_OUTLINE; grid[11][9]  = T_HI;     grid[11][10] = T_SHINE;  grid[11][11] = T_HI;     grid[11][12] = T_MID;    grid[11][13] = T_OUTLINE;
  grid[12][7]  = T_OUTLINE; grid[12][8]  = T_MID;    grid[12][9]  = T_DARK;   grid[12][10] = T_DARK;   grid[12][11] = T_DARK;   grid[12][12] = T_MID;    grid[12][13] = T_BASE; grid[12][14] = T_OUTLINE;
  grid[13][7]  = T_DARK;    grid[13][8]  = T_BASE_D; grid[13][9]  = T_MID;    grid[13][10] = T_HI;     grid[13][11] = T_MID;    grid[13][12] = T_BASE_D; grid[13][13] = T_DARK;

  // 2. FRONT ARMORED BLAST SHIELDS / BREASTPLATES (y: 14..18, x: 6..15)
  // Upper blast shield contour
  grid[14][6]  = T_OUTLINE; grid[14][7]  = T_MID;    grid[14][8]  = T_HI;     grid[14][9]  = T_GLINT;  grid[14][10] = T_HI;     grid[14][11] = T_MID;    grid[14][12] = T_BASE; grid[14][13] = T_MID;  grid[14][14] = T_HI; grid[14][15] = T_OUTLINE;
  
  // Mid shield with TEAM insignia (Framed: x: 7..10, y: 15..17)
  grid[15][6]  = T_OUTLINE; grid[15][7]  = 'TEAM';   grid[15][8]  = 'TEAM';   grid[15][9]  = 'TEAM';   grid[15][10] = 'TEAM';   grid[15][11] = T_BASE;   grid[15][12] = T_MID;  grid[15][13] = T_HI;   grid[15][14] = T_MID; grid[15][15] = T_OUTLINE;
  grid[16][6]  = T_OUTLINE; grid[16][7]  = 'TEAM';   grid[16][8]  = 'TEAM';   grid[16][9]  = 'TEAM';   grid[16][10] = 'TEAM';   grid[16][11] = T_BASE_D; grid[16][12] = T_BASE; grid[16][13] = T_MID;  grid[16][14] = T_BASE; grid[16][15] = T_OUTLINE;
  grid[17][6]  = T_OUTLINE; grid[17][7]  = 'TEAM';   grid[17][8]  = 'TEAM';   grid[17][9]  = 'TEAM';   grid[17][10] = 'TEAM';   grid[17][11] = T_DARK;   grid[17][12] = T_BASE_D; grid[17][13] = T_BASE; grid[17][14] = T_BASE_D; grid[17][15] = T_OUTLINE;

  // Lower shield edge & Telemetry LED Sensor light
  grid[18][6]  = T_OUTLINE; grid[18][7]  = T_DARK;   grid[18][8]  = T_BASE_D; grid[18][9]  = T_BASE_D; grid[18][10] = T_DARK;   grid[18][11] = T_OUTLINE;
  grid[18][12] = T_DARK;    grid[18][13] = '#4ade80'; grid[18][14] = '#22c55e'; grid[18][15] = T_OUTLINE; // Glowing green telemetry status sensor!

  // 3. ARTICULATED SPIDER MECH LEGS (Anchored to ground)
  // A. REAR FOREGROUND LEG (-X, y: 13..23, x: 0..6)
  // Hip pivot
  grid[14][5]  = T_BASE;    grid[14][6]  = T_MID;
  // Upper femur segment angling up-back
  grid[13][4]  = T_MID;     grid[13][5]  = T_HI;     grid[13][6]  = T_GLINT;
  grid[14][3]  = T_BASE;    grid[14][4]  = T_MID;
  // Heavy armored knee joint
  grid[15][2]  = T_OUTLINE; grid[15][3]  = T_HI;     grid[15][4]  = T_GLINT;
  grid[16][2]  = T_MID;     grid[16][3]  = T_SHINE;  grid[16][4]  = T_HI;
  // Tibia segment angling down-back
  grid[17][2]  = T_BASE;    grid[17][3]  = T_MID;
  grid[18][1]  = T_MID;     grid[18][2]  = T_BASE;
  grid[19][1]  = T_HI;      grid[19][2]  = T_BASE_D;
  grid[20][0]  = T_OUTLINE; grid[20][1]  = T_MID;    grid[20][2]  = T_DARK;
  // Hydraulic recoil piston
  grid[17][1]  = T_SHINE;   grid[18][1]  = T_GLINT;
  // Heavy ground spade / claw foot
  grid[21][0]  = T_MID;     grid[21][1]  = T_HI;     grid[21][2]  = T_BASE;
  grid[22][0]  = T_DARK;    grid[22][1]  = T_GLINT;  grid[22][2]  = T_SHINE; grid[22][3] = T_OUTLINE;
  grid[23][0]  = T_OUTLINE; grid[23][1]  = T_DARK;   grid[23][2]  = T_DARK;

  // B. REAR BACKGROUND LEG (Deeper perspective shadow: y: 16..22, x: 3..6)
  grid[16][5]  = T_DARK;
  grid[17][5]  = T_BASE_D;
  grid[18][4]  = T_DARK;    grid[18][5]  = T_BASE_D;
  grid[19][4]  = T_DARK;
  grid[20][3]  = T_BASE_D;  grid[20][4]  = T_DARK;
  grid[21][3]  = T_DARK;    grid[21][4]  = T_BASE_D;
  grid[22][3]  = T_OUTLINE; grid[22][4]  = T_DARK;

  // C. FRONT FOREGROUND LEG (+X, y: 13..23, x: 14..23)
  // Hip pivot
  grid[14][14] = T_MID;     grid[14][15] = T_HI;
  // Upper femur segment angling forward-up
  grid[13][15] = T_MID;     grid[13][16] = T_HI;     grid[13][17] = T_GLINT;
  grid[14][16] = T_BASE;    grid[14][17] = T_MID;
  // Heavy armored knee joint
  grid[15][18] = T_OUTLINE; grid[15][19] = T_HI;     grid[15][20] = T_GLINT;
  grid[16][18] = T_MID;     grid[16][19] = T_SHINE;  grid[16][20] = T_HI;
  // Tibia segment angling down-forward
  grid[17][19] = T_BASE;    grid[17][20] = T_MID;
  grid[18][20] = T_MID;     grid[18][21] = T_BASE;
  grid[19][20] = T_HI;      grid[19][21] = T_BASE_D;
  grid[20][21] = T_MID;     grid[20][22] = T_DARK;
  // Hydraulic forward piston
  grid[17][21] = T_SHINE;   grid[18][22] = T_GLINT;
  // Heavy forward claw foot / ground anchor pad
  grid[21][21] = T_MID;     grid[21][22] = T_HI;     grid[21][23] = T_BASE;
  grid[22][20] = T_OUTLINE; grid[22][21] = T_SHINE;  grid[22][22] = T_GLINT; grid[22][23] = T_DARK;
  grid[23][21] = T_OUTLINE; grid[23][22] = T_DARK;   grid[23][23] = T_OUTLINE;

  // D. FRONT BACKGROUND LEG (Deeper perspective shadow: y: 16..22, x: 17..20)
  grid[16][17] = T_DARK;
  grid[17][17] = T_BASE_D;
  grid[18][18] = T_DARK;    grid[18][19] = T_BASE_D;
  grid[19][19] = T_DARK;
  grid[20][19] = T_BASE_D;  grid[20][20] = T_DARK;
  grid[21][19] = T_DARK;    grid[21][20] = T_BASE_D;
  grid[22][19] = T_OUTLINE; grid[22][20] = T_DARK;

  return { grid, gridSize: g };
}

function getHD_DeployableCannon_Turret() {
  const g = 24, grid = makeGrid(g);

  const T_OUTLINE = '#090d16';
  const T_DARK    = '#0f172a';
  const T_BASE_D  = '#1e293b';
  const T_BASE    = '#334155';
  const T_MID     = '#475569';
  const T_HI      = '#64748b';
  const T_GLINT   = '#94a3b8';
  const T_SHINE   = '#cbd5e1';
  const T_WHITE   = '#f1f5f9';

  // 1. REAR WHIP ANTENNA (y: 1..7, x: 4..5)
  grid[1][4]  = T_SHINE;
  grid[2][4]  = T_GLINT;
  grid[3][4]  = T_MID;
  grid[4][4]  = T_BASE;
  grid[5][4]  = T_OUTLINE; grid[5][5] = T_DARK;

  // 2. REAR SENSOR RADOME DOME (y: 3..6, x: 5..9)
  grid[3][6]  = T_OUTLINE; grid[3][7]  = T_HI;     grid[3][8]  = T_GLINT; grid[3][9]  = T_OUTLINE;
  grid[4][6]  = T_MID;     grid[4][7]  = T_SHINE;  grid[4][8]  = T_HI;    grid[4][9]  = T_BASE;
  grid[5][6]  = T_BASE_D;  grid[5][7]  = T_MID;    grid[5][8]  = T_BASE;  grid[5][9]  = T_DARK;

  // 3. TOP OPTICAL TARGETING SCOPE (Over gun trunnion: y: 4..6, x: 10..14)
  grid[4][10] = T_OUTLINE; grid[4][11] = T_HI;     grid[4][12] = T_SHINE; grid[4][13] = '#38bdf8'; grid[4][14] = '#ffffff';
  grid[5][10] = T_BASE_D;  grid[5][11] = T_BASE;   grid[5][12] = T_MID;   grid[5][13] = '#0284c7'; grid[5][14] = T_OUTLINE;

  // 4. MULTI-SPECTRAL SENSOR POD & OPTICS (Rear/mid flank: y: 6..9, x: 2..8)
  // Amber telemetry digital readout
  grid[6][2]  = '#facc15'; grid[6][3]  = '#fef08a'; grid[6][4] = T_DARK;
  // Dual-aperture tactical laser / optical lenses
  grid[7][2]  = T_BASE;    grid[7][3]  = T_DARK;   grid[7][4] = '#4ade80'; grid[7][5] = '#22c55e'; // Green Laser!
  grid[8][2]  = T_DARK;    grid[8][3]  = T_OUTLINE; grid[8][4] = '#00f0ff'; grid[8][5] = '#38bdf8'; // Blue Optic!
  grid[9][3]  = T_DARK;    grid[9][4]  = T_BASE_D; grid[9][5] = T_BASE;   grid[9][6] = T_MID;

  // 5. ARMORED GUN BREECH & TRUNNION (y: 6..10, x: 7..14)
  grid[6][6]  = T_OUTLINE; grid[6][7]  = T_BASE_D; grid[6][8]  = T_MID;   grid[6][9]  = T_HI;     grid[6][10] = T_GLINT; grid[6][11] = T_BASE;
  
  // TEAM emblem on turret flank
  grid[7][6]  = T_OUTLINE; grid[7][7]  = 'TEAM';   grid[7][8]  = 'TEAM';  grid[7][9]  = 'TEAM';   grid[7][10] = T_HI;    grid[7][11] = T_MID;
  grid[8][6]  = T_OUTLINE; grid[8][7]  = 'TEAM';   grid[8][8]  = 'TEAM';  grid[8][9]  = 'TEAM';   grid[8][10] = T_BASE;  grid[8][11] = T_MID;
  
  // Lower breech & elevation trunnion pivot bolt
  grid[9][7]  = T_DARK;    grid[9][8]  = T_BASE_D; grid[9][9]  = T_BASE;  grid[9][10] = T_SHINE;  grid[9][11] = T_GLINT; grid[9][12] = T_BASE_D;

  // 6. EXPOSED MECHANICAL COG / GEAR DRIVE (y: 10..11, x: 6..12)
  grid[10][5] = T_OUTLINE; grid[10][6] = T_DARK;   grid[10][7] = T_MID;   grid[10][8] = T_DARK;   grid[10][9] = T_MID;   grid[10][10] = T_DARK;  grid[10][11] = T_MID; grid[10][12] = T_OUTLINE;
  grid[11][6] = T_OUTLINE; grid[11][7] = T_DARK;   grid[11][8] = T_BASE_D; grid[11][9] = T_DARK; grid[11][10] = T_BASE_D; grid[11][11] = T_OUTLINE;

  // 7. HEAVY AUTOCANNON BARREL (+X Forward: y: 6..9, x: 12..23)
  // Reinforced barrel sleeve & recoil collar (x: 12..14, y: 7..9)
  grid[7][12] = T_MID;     grid[7][13] = T_HI;     grid[7][14] = T_GLINT;
  grid[8][12] = T_BASE;    grid[8][13] = T_MID;    grid[8][14] = T_HI;
  grid[9][13] = T_DARK;    grid[9][14] = T_BASE_D;

  // Fluted Heavy Barrel Tube with Thermal Vents (x: 15..20, y: 7..8)
  grid[7][15] = T_SHINE;   grid[7][16] = T_GLINT;  grid[7][17] = T_SHINE; grid[7][18] = T_GLINT; grid[7][19] = T_SHINE; grid[7][20] = T_GLINT;
  grid[8][15] = T_BASE;    grid[8][16] = T_BASE_D; grid[8][17] = T_BASE;  grid[8][18] = T_BASE_D; grid[8][19] = T_BASE;  grid[8][20] = T_BASE_D;

  // Massive Ported Tactical Muzzle Brake / Blast Compensator (x: 21..23, y: 6..9)
  grid[6][21] = T_OUTLINE; grid[6][22] = T_HI;     grid[6][23] = T_SHINE;
  grid[7][21] = T_OUTLINE; grid[7][22] = T_DARK;   grid[7][23] = T_WHITE; // Muzzle front glint!
  grid[8][21] = T_OUTLINE; grid[8][22] = T_DARK;   grid[8][23] = T_SHINE;
  grid[9][21] = T_OUTLINE; grid[9][22] = T_BASE_D; grid[9][23] = T_MID;

  return { grid, gridSize: g };
}

function getHD_DeployableCannon() {
  const g = 24, grid = makeGrid(g);
  const b = getHD_DeployableCannon_Base().grid;
  const t = getHD_DeployableCannon_Turret().grid;

  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      if (b[y][x]) grid[y][x] = b[y][x];
      if (t[y][x]) grid[y][x] = t[y][x];
    }
  }
  return { gridSize: g, grid };
}

function getHD_Marine_Parachute() {
  const g = 24, grid = makeGrid(g);

  // 🪂 HD Emergency Parachute & Suspended Marine Pilot (24x24)
  // 1. BILLOWING AERODYNAMIC CANOPY DOME (y: 0..6, x: 1..22)
  // Apex Vent & Crown (y: 0, x: 7..16)
  for (let x = 7; x <= 16; x++) {
    grid[0][x] = (x >= 9 && x <= 14) ? '#ffffff' : '#f1f5f9';
  }
  grid[0][6] = '#e2e8f0'; grid[0][17] = '#e2e8f0';

  // Upper Dome (y: 1, x: 4..19)
  for (let x = 4; x <= 19; x++) {
    grid[1][x] = '#f8fafc';
  }
  grid[1][3] = '#cbd5e1'; grid[1][20] = '#cbd5e1';

  // Mid Upper Dome (y: 2, x: 2..21)
  for (let x = 2; x <= 21; x++) {
    grid[2][x] = '#e2e8f0';
  }
  grid[2][1] = '#94a3b8'; grid[2][22] = '#94a3b8';

  // Mid Dome (y: 3, x: 1..22)
  for (let x = 1; x <= 22; x++) {
    grid[3][x] = '#cbd5e1';
  }

  // Lower Mid Dome (y: 4, x: 1..22)
  for (let x = 1; x <= 22; x++) {
    grid[4][x] = '#94a3b8';
  }

  // Underside Shadow Curve (y: 5, x: 1..22)
  for (let x = 1; x <= 22; x++) {
    grid[5][x] = '#64748b';
  }

  // Scalloped Hem Rim with cellular intake chambers (y: 6, x: 2..21)
  for (let x = 2; x <= 21; x++) {
    grid[6][x] = '#475569';
  }
  // Dark underside cell openings
  grid[6][4] = '#1e293b'; grid[6][5] = '#1e293b';
  grid[6][8] = '#1e293b'; grid[6][9] = '#1e293b';
  grid[6][14] = '#1e293b'; grid[6][15] = '#1e293b';
  grid[6][18] = '#1e293b'; grid[6][19] = '#1e293b';

  // Structural Seams / Gores separating 5 curved cells (at x=4, x=8, x=15, x=19)
  const seams = [4, 8, 15, 19];
  for (const sx of seams) {
    grid[1][sx] = '#cbd5e1';
    grid[2][sx] = '#94a3b8';
    grid[3][sx] = '#64748b';
    grid[4][sx] = '#475569';
    grid[5][sx] = '#334155';
    grid[6][sx] = '#0f172a';
  }

  // Central Broad TEAM Insignia Stripe (x: 10..13, y: 0..5)
  for (let y = 0; y <= 5; y++) {
    for (let x = 10; x <= 13; x++) {
      grid[y][x] = 'TEAM';
    }
  }
  // Team stripe highlights on crown & shadow at rim
  grid[0][10] = '#ffffff'; grid[0][13] = '#ffffff';
  grid[5][10] = '#1e293b'; grid[5][13] = '#1e293b';

  // Aerodynamic Warning Markers (Yellow Wingtip Patches)
  grid[2][2] = '#facc15'; grid[2][21] = '#facc15';
  grid[3][2] = '#facc15'; grid[3][21] = '#facc15';

  // 2. KEVLAR SUSPENSION RIGGING LINES (y: 7..12)
  // Cleanly converging toward left and right steering riser straps (x: 7..8 and x: 15..16)
  // leaving the pilot's head/helmet completely clear in the center (x: 9..14)!

  // Left Cluster: lines from x: 2, x: 6, x: 10 converging to Left Riser at x: 7..8, y: 12..13
  grid[7][2] = '#cbd5e1';
  grid[8][3] = '#94a3b8';
  grid[9][4] = '#94a3b8';
  grid[10][5] = '#cbd5e1';
  grid[11][6] = '#94a3b8';
  grid[12][7] = '#64748b';

  grid[7][6] = '#cbd5e1';
  grid[8][6] = '#94a3b8';
  grid[9][7] = '#cbd5e1';
  grid[10][7] = '#94a3b8';
  grid[11][7] = '#cbd5e1';

  grid[7][10] = '#cbd5e1';
  grid[8][9] = '#94a3b8';
  grid[9][9] = '#64748b';
  grid[10][8] = '#94a3b8';
  grid[11][8] = '#cbd5e1';

  // Right Cluster: lines from x: 13, x: 17, x: 21 converging to Right Riser at x: 15..16, y: 12..13
  grid[7][13] = '#cbd5e1';
  grid[8][14] = '#94a3b8';
  grid[9][14] = '#64748b';
  grid[10][15] = '#94a3b8';
  grid[11][15] = '#cbd5e1';

  grid[7][17] = '#cbd5e1';
  grid[8][17] = '#94a3b8';
  grid[9][16] = '#cbd5e1';
  grid[10][16] = '#94a3b8';
  grid[11][16] = '#cbd5e1';

  grid[7][21] = '#cbd5e1';
  grid[8][20] = '#94a3b8';
  grid[9][19] = '#94a3b8';
  grid[10][18] = '#cbd5e1';
  grid[11][17] = '#94a3b8';
  grid[12][16] = '#64748b';

  // 3. COMBAT MARINE PILOT IN DESCENT (y: 11..23, x: 6..17)
  // Riser Webbing Straps & Steering Toggles (y: 12..14, x: 7..8 & 15..16)
  grid[12][7] = '#94a3b8'; grid[12][8] = '#cbd5e1';
  grid[12][15] = '#cbd5e1'; grid[12][16] = '#94a3b8';
  grid[13][7] = '#64748b'; grid[13][8] = '#94a3b8';
  grid[13][15] = '#94a3b8'; grid[13][16] = '#64748b';

  // Pilot's Hands / Armored Gauntlets gripping the steering risers (y: 13..14, x: 6..7 & 16..17)
  grid[13][6] = '#1e293b'; grid[13][7] = '#475569';
  grid[14][6] = '#334155'; grid[14][7] = '#64748b';
  grid[13][16] = '#475569'; grid[13][17] = '#1e293b';
  grid[14][16] = '#64748b'; grid[14][17] = '#334155';

  // Armored Forearms angling in to chest (y: 15, x: 7..8 & 15..16)
  grid[15][7] = '#1e293b'; grid[15][8] = '#334155';
  grid[15][15] = '#334155'; grid[15][16] = '#1e293b';

  // A. Combat Helmet & Tactical HUD Visor (y: 11..15, x: 9..14)
  // Cranial Dome Ridge (y: 11, x: 10..13)
  grid[11][10] = '#334155'; grid[11][11] = '#64748b'; grid[11][12] = '#64748b'; grid[11][13] = '#334155';
  // Helmet Upper Brow & Visor Seal (y: 12, x: 9..14)
  grid[12][9] = '#1e293b'; grid[12][10] = '#475569'; grid[12][11] = '#334155';
  grid[12][12] = '#334155'; grid[12][13] = '#475569'; grid[12][14] = '#1e293b';
  // Wide Wraparound Glowing Cyan Visor with specular flash (y: 13, x: 9..14)
  grid[13][9] = '#0284c7'; grid[13][10] = '#00f0ff'; grid[13][11] = '#38bdf8';
  grid[13][12] = '#00f0ff'; grid[13][13] = '#ffffff'; grid[13][14] = '#38bdf8';
  // Lower Visor & Cheeks (y: 14, x: 9..14)
  grid[14][9] = '#0f172a'; grid[14][10] = '#0284c7'; grid[14][11] = '#00f0ff';
  grid[14][12] = '#0284c7'; grid[14][13] = '#38bdf8'; grid[14][14] = '#0f172a';
  // Armored Chin Guard & Respirator Filter (y: 15, x: 10..13)
  grid[15][10] = '#1e293b'; grid[15][11] = '#334155'; grid[15][12] = '#334155'; grid[15][13] = '#1e293b';

  // B. Ballistic Chest Armor with TEAM Insignia (y: 16..18, x: 8..15)
  // Pauldrons & Shoulder plates (y: 16, x: 8..9, 14..15)
  grid[16][8] = '#1e293b'; grid[16][9] = '#475569';
  grid[16][14] = '#475569'; grid[16][15] = '#1e293b';
  // Chest Armor Plate with TEAM Insignia (y: 16..17, x: 10..13)
  grid[16][10] = 'TEAM'; grid[16][11] = 'TEAM'; grid[16][12] = 'TEAM'; grid[16][13] = 'TEAM';
  grid[17][10] = 'TEAM'; grid[17][11] = 'TEAM'; grid[17][12] = 'TEAM'; grid[17][13] = 'TEAM';
  grid[17][8] = '#0f172a'; grid[17][9] = '#334155';
  grid[17][14] = '#334155'; grid[17][15] = '#0f172a';
  // Abdominal Armor & Rib Plates (y: 18, x: 9..14)
  grid[18][9] = '#1e293b'; grid[18][10] = '#334155'; grid[18][11] = '#475569';
  grid[18][12] = '#475569'; grid[18][13] = '#334155'; grid[18][14] = '#1e293b';

  // C. Tactical Belt & Ejection Quick-Release Box (y: 19, x: 8..15)
  grid[19][8] = '#0f172a'; grid[19][9] = '#1e293b'; grid[19][10] = '#334155';
  grid[19][11] = '#facc15'; grid[19][12] = '#fef08a'; // Golden emergency release box
  grid[19][13] = '#334155'; grid[19][14] = '#1e293b'; grid[19][15] = '#0f172a';

  // D. Dangling Combat Legs & Reinforced Boots (y: 20..23, x: 7..16)
  // Thigh plates (y: 20, x: 9..14)
  grid[20][9] = '#1e293b'; grid[20][10] = '#334155';
  grid[20][13] = '#334155'; grid[20][14] = '#1e293b';

  // Heavy Armored Kneepads (y: 21, x: 8..15)
  grid[21][8] = '#1e293b'; grid[21][9] = '#475569'; grid[21][10] = '#64748b';
  grid[21][13] = '#64748b'; grid[21][14] = '#475569'; grid[21][15] = '#1e293b';

  // Lower Shins (y: 22, x: 8..15)
  grid[22][8] = '#0f172a'; grid[22][9] = '#1e293b'; grid[22][10] = '#334155';
  grid[22][13] = '#334155'; grid[22][14] = '#1e293b'; grid[22][15] = '#0f172a';

  // Combat Boots (treads angled down for landing) (y: 23, x: 7..16)
  grid[23][7] = '#0f172a'; grid[23][8] = '#1e293b'; grid[23][9] = '#334155'; grid[23][10] = '#1e293b';
  grid[23][13] = '#1e293b'; grid[23][14] = '#334155'; grid[23][15] = '#1e293b'; grid[23][16] = '#0f172a';

  return { grid, gridSize: g };
}

// ── ADDITIONAL ROSTER VARIANTS ────────────────────────────────
function getHD_MarineBlack_Torso() {
  const base = getHD_Marine_Torso();
  const g = 24, grid = makeGrid(g);
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      const c = base.grid[y][x];
      if (!c) continue;
      // Recolor blue armor plates to dark titanium stealth black
      if (c === '#2563eb') grid[y][x] = '#0f172a';
      else if (c === '#3b82f6') grid[y][x] = '#1e293b';
      else if (c === '#60a5fa') grid[y][x] = '#334155';
      else if (c === '#93c5fd') grid[y][x] = '#475569';
      else if (c === '#1d4ed8') grid[y][x] = '#090d16';
      else grid[y][x] = c;
    }
  }
  return { grid, gridSize: g };
}

function makeHD_MarineGold(base) {
  const g = 24, grid = makeGrid(g);
  const mg = base.grid;
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      const c = mg[y][x];
      if (!c) continue;
      // Recolor blue armor plates to warm golden-yellow hues
      if (c === '#2563eb') grid[y][x] = '#d97706';
      else if (c === '#3b82f6') grid[y][x] = '#eab308';
      else if (c === '#60a5fa') grid[y][x] = '#facc15';
      else if (c === '#93c5fd') grid[y][x] = '#fef08a';
      else if (c === '#1d4ed8') grid[y][x] = '#b45309';
      else grid[y][x] = c;
    }
  }
  return { grid, gridSize: g };
}

function getHD_MarineGold_Torso() { return makeHD_MarineGold(getHD_Marine_Torso()); }
function getHD_MarineGold_Legs() { return makeHD_MarineGold(getHD_Marine_Legs()); }
function getHD_MarineGold_Legs_Walk1() { return makeHD_MarineGold(getHD_Marine_Legs_Walk1()); }
function getHD_MarineGold_Legs_Walk2() { return makeHD_MarineGold(getHD_Marine_Legs_Walk2()); }
function getHD_MarineGold_Legs_Walk3() { return makeHD_MarineGold(getHD_Marine_Legs_Walk3()); }
function getHD_MarineGold_Legs_Walk4() { return makeHD_MarineGold(getHD_Marine_Legs_Walk4()); }
function getHD_MarineGold_Legs_Walk5() { return makeHD_MarineGold(getHD_Marine_Legs_Walk5()); }
function getHD_MarineGold_Legs_Walk6() { return makeHD_MarineGold(getHD_Marine_Legs_Walk6()); }

function getHD_MarineGold_Parachute() {
  const base = getHD_Marine_Parachute();
  const g = 24, grid = makeGrid(g);
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      grid[y][x] = base.grid[y][x];
    }
  }
  // Canopy: Warm gold center stripe (y: 0..5, x: 10..13)
  for (let y = 0; y <= 5; y++) {
    for (let x = 10; x <= 13; x++) {
      grid[y][x] = '#facc15';
    }
  }
  grid[0][10] = '#fef08a'; grid[0][13] = '#fef08a';
  grid[5][10] = '#b45309'; grid[5][13] = '#b45309';

  // Pilot armor & visor (y: 11..23)
  // Gold Tactical Visor (y: 13..14, x: 9..14)
  grid[13][9] = '#b45309'; grid[13][10] = '#facc15'; grid[13][11] = '#fef08a';
  grid[13][12] = '#facc15'; grid[13][13] = '#ffffff'; grid[13][14] = '#fef08a';
  grid[14][9] = '#0f172a'; grid[14][10] = '#b45309'; grid[14][11] = '#facc15';
  grid[14][12] = '#b45309'; grid[14][13] = '#fef08a'; grid[14][14] = '#0f172a';

  // Pauldrons (y: 16)
  grid[16][8] = '#b45309'; grid[16][9] = '#eab308';
  grid[16][14] = '#eab308'; grid[16][15] = '#b45309';
  // Chest plate (y: 16..17, x: 10..13)
  grid[16][10] = '#d97706'; grid[16][11] = '#eab308'; grid[16][12] = '#facc15'; grid[16][13] = '#d97706';
  grid[17][10] = '#b45309'; grid[17][11] = '#d97706'; grid[17][12] = '#eab308'; grid[17][13] = '#b45309';
  // Kneepads (y: 21, x: 8..15)
  grid[21][9] = '#d97706'; grid[21][10] = '#facc15';
  grid[21][13] = '#facc15'; grid[21][14] = '#d97706';
  return { grid, gridSize: g };
}

function getHD_Shade_Parachute() {
  const base = getHD_Marine_Parachute();
  const g = 24, grid = makeGrid(g);
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      const c = base.grid[y][x];
      if (!c) continue;
      // Pilot is at y >= 11
      if (y >= 11) {
        // Red visor
        if (c === '#00f0ff' || c === '#38bdf8' || c === '#0284c7') {
          grid[y][x] = (c === '#00f0ff') ? '#ef4444' : (c === '#38bdf8' ? '#f87171' : '#dc2626');
        } else if (c === '#475569') {
          grid[y][x] = '#1e293b';
        } else if (c === '#334155') {
          grid[y][x] = '#0f172a';
        } else {
          grid[y][x] = c;
        }
      } else {
        grid[y][x] = c;
      }
    }
  }
  return { grid, gridSize: g };
}

// ── SUL ENFORCER VULTURE (48×48 UHD NATIVE RELAUNCH) ───────────
// Master-crafted reproduction of 1_enforcervulture.png & gold_enforcervulture.png (Facing RIGHT +X):
// - Ivory bone cranial dome, rostral antenna spikes & triangular triple crimson ocular cluster (x: 28..45, y: 4..22)
// - Colossal segmented recurved sickle tusks with horizontal chitin joint rings (x: 26..47, y: 22..45)
// - Drooping mouth visceral tendrils & bronze neural cables (x: 26..35, y: 23..38)
// - Dorsal raked Gothic flying buttresses & cantilever trusses (x: 6..34, y: 2..15)
// - 4 symmetrical dual-pod columns (8 recessed socket ports & nestled glowing bio-spheres) (x: 10..32, y: 8..20)
// - Biomechanical ribbed Giger vertebrae chassis & sinuous vascular conduit bundles (x: 6..34, y: 17..26)
// - Ventral amniotic dome with embossed hexagonal geodesic wireframe & suspended fetal elder Sul pilot (x: 8..27, y: 25..43)
// - Aft levitation exhaust nozzle & tapering spinal vertebrae (x: 0..9, y: 16..24)

const _EV_C = {
  // Ivory Bone & Skull & Tusks
  WHITE:      '#ffffff',
  BONE_W:     '#fffbeb',
  BONE_L:     '#fef3c7',
  BONE_M:     '#fde68a',
  BONE_Y:     '#fef9c3',
  BONE_AMB:   '#d97706',
  BONE_D:     '#b45309',
  BONE_DD:    '#92400e',
  BONE_SH:    '#78350f',
  BONE_OUT:   '#451a03',
  BONE_DEEP:  '#381602',

  // Antique Weathered Bronze & Structural Armor
  BRONZE_HI:  '#f59e0b',
  BRONZE_L:   '#d97706',
  BRONZE_M:   '#b45309',
  BRONZE_D:   '#92400e',
  BRONZE_DD:  '#78350f',
  BRONZE_RIB: '#5c3d1e',
  BRONZE_OUT: '#451a03',
  CAV_SHADOW: '#2e1805',
  CAV_DEEP:   '#1f1103',
  CAV_VOID:   '#140a02',
  BLACK:      '#05070b',

  // Biomechanical Slate Steel & Giger Chassis
  STEEL_HI:   '#94a3b8',
  STEEL_L:    '#64748b',
  STEEL_M:    '#475569',
  STEEL_D:    '#334155',
  STEEL_DD:   '#1e293b',
  STEEL_DARK: '#0f172a',
  STEEL_VOID: '#080d16',

  // Crimson Bio-Luminescence & Optics & Viscera
  GLOW_W:     '#ffffff',
  GLOW_PINK:  '#ff8099',
  GLOW_RAD:   '#ff4d6d',
  RED_PURE:   '#ff0033',
  RED_BRIGHT: '#ef4444',
  RED_MID:    '#dc2626',
  RED_RUBY:   '#be123c',
  RED_DARK:   '#991b1b',
  RED_DEEP:   '#7f1d1d',
  RED_SHADOW: '#450a0a',
  RED_BLACK:  '#260505',

  // Exhaust Thrust Fire
  THRUST_OR:  '#f97316',
  THRUST_YEL: '#fef08a',

  // Elder Sul Pilot Silhouette (Ventral Dome)
  PILOT_CORE: '#090204',
  PILOT_BODY: '#140307',
  PILOT_LIMB: '#1a050b',
  PILOT_CORD: '#2d0610'
};

function _paintHD_EnforcerVulture_Body(grid, loadedPodsCount = 8) {
  const C = _EV_C;

  // 1. DORSAL SKELETAL HOUSING & RAKED GOTHIC BUTTRESSES (Rows 2..15, Cols 6..34)
  // Highest Cantilever Apex (swept up and backward to Col 12..16, Row 2..4)
  grid[2][14] = C.WHITE; grid[2][15] = C.BONE_W; grid[2][16] = C.BONE_M;
  grid[3][13] = C.BONE_W; grid[3][14] = C.BONE_L; grid[3][15] = C.BRONZE_L; grid[3][16] = C.BRONZE_M; grid[3][17] = C.BRONZE_D;
  grid[4][11] = C.BONE_L; grid[4][12] = C.BONE_M; grid[4][13] = C.BRONZE_L; grid[4][14] = C.BONE_M; grid[4][15] = C.BRONZE_M; grid[4][16] = C.BRONZE_D; grid[4][17] = C.BRONZE_DD;

  // Buttress Arch 0 (Rearmost raked rib):
  grid[5][9] = C.BONE_L; grid[5][10] = C.BRONZE_L; grid[5][11] = C.BRONZE_M;
  grid[6][8] = C.BRONZE_L; grid[6][9] = C.BRONZE_M; grid[6][10] = C.BRONZE_D;
  grid[7][7] = C.BRONZE_M; grid[7][8] = C.BRONZE_D; grid[7][9] = C.BRONZE_DD;
  grid[8][6] = C.BRONZE_D; grid[8][7] = C.BRONZE_DD; grid[8][8] = C.BRONZE_OUT;
  grid[9][5] = C.BRONZE_DD; grid[9][6] = C.BRONZE_OUT;

  // Buttress Arch 1 (Mid-Rear):
  grid[5][15] = C.BONE_W; grid[5][16] = C.BONE_L; grid[5][17] = C.BRONZE_L;
  grid[6][14] = C.BRONZE_L; grid[6][15] = C.BRONZE_M; grid[6][16] = C.BRONZE_D;
  grid[7][14] = C.BRONZE_M; grid[7][15] = C.BRONZE_D; grid[7][16] = C.BRONZE_DD;
  grid[8][13] = C.BRONZE_D; grid[8][14] = C.BRONZE_DD;

  // Buttress Arch 2 (Mid-Front):
  grid[5][21] = C.BONE_W; grid[5][22] = C.BONE_L; grid[5][23] = C.BRONZE_L;
  grid[6][20] = C.BRONZE_L; grid[6][21] = C.BRONZE_M; grid[6][22] = C.BRONZE_D;
  grid[7][20] = C.BRONZE_M; grid[7][21] = C.BRONZE_D; grid[7][22] = C.BRONZE_DD;
  grid[8][19] = C.BRONZE_D; grid[8][20] = C.BRONZE_DD;

  // Buttress Arch 3 (Front / Neck Base):
  grid[6][27] = C.BONE_W; grid[6][28] = C.BONE_L; grid[6][29] = C.BRONZE_L;
  grid[7][26] = C.BRONZE_L; grid[7][27] = C.BRONZE_M; grid[7][28] = C.BRONZE_D;
  grid[8][25] = C.BRONZE_M; grid[8][26] = C.BRONZE_D; grid[8][27] = C.BRONZE_DD;
  grid[9][25] = C.BRONZE_D; grid[9][26] = C.BRONZE_DD;

  // Neck base crestplate & vertebrae collar (Cols 28..33, Rows 7..10)
  grid[7][29] = C.BONE_W; grid[7][30] = C.BONE_L; grid[7][31] = C.BONE_M;
  grid[8][29] = C.BONE_L; grid[8][30] = C.BRONZE_L; grid[8][31] = C.BRONZE_M; grid[8][32] = C.BRONZE_D;
  grid[9][30] = C.BRONZE_L; grid[9][31] = C.BRONZE_M; grid[9][32] = C.BRONZE_D; grid[9][33] = C.BRONZE_DD;
  grid[10][31] = C.BRONZE_M; grid[10][32] = C.BRONZE_D; grid[10][33] = C.BRONZE_DD;

  // Open shadow wells between the buttress trusses (giving deep 3D architecture):
  grid[4][8] = C.CAV_VOID; grid[4][9] = C.CAV_DEEP; grid[4][10] = C.CAV_DEEP;
  grid[5][12] = C.CAV_VOID; grid[5][13] = C.CAV_DEEP; grid[5][14] = C.CAV_DEEP;
  grid[6][11] = C.CAV_VOID; grid[6][12] = C.CAV_DEEP; grid[6][13] = C.CAV_DEEP;
  grid[6][17] = C.CAV_VOID; grid[6][18] = C.CAV_DEEP; grid[6][19] = C.CAV_DEEP;
  grid[7][17] = C.CAV_VOID; grid[7][18] = C.CAV_DEEP; grid[7][19] = C.CAV_DEEP;
  grid[7][23] = C.CAV_VOID; grid[7][24] = C.CAV_DEEP; grid[7][25] = C.CAV_DEEP;

  // Solid dorsal armored mantle above pod wells (Rows 8..10)
  for (let x = 8; x <= 31; x++) {
    const y = Math.round(7.5 + (x - 8) * 0.12);
    if (!grid[y][x]) grid[y][x] = (x % 3 === 0) ? C.BONE_L : ((x % 3 === 1) ? C.BONE_M : C.BRONZE_L);
    if (!grid[y + 1][x]) grid[y + 1][x] = (x % 2 === 0) ? C.BRONZE_M : C.BRONZE_D;
  }

  // 2. 8 BIO-ROCKET POD WELLS (Solid Biomechanical Hull Plate Integration)
  const POD_DEFS = [
    { idx: 0, cx: 12, cy: 10, isFar: true },  // Pod 0 (far rear)
    { idx: 1, cx: 12, cy: 15, isFar: false }, // Pod 1 (near rear)
    { idx: 2, cx: 18, cy: 11, isFar: true },  // Pod 2 (far mid-rear)
    { idx: 3, cx: 18, cy: 16, isFar: false }, // Pod 3 (near mid-rear)
    { idx: 4, cx: 24, cy: 12, isFar: true },  // Pod 4 (far mid-front)
    { idx: 5, cx: 24, cy: 17, isFar: false }, // Pod 5 (near mid-front)
    { idx: 6, cx: 30, cy: 13, isFar: true },  // Pod 6 (far front)
    { idx: 7, cx: 30, cy: 18, isFar: false }  // Pod 7 (near front)
  ];

  // Solid biomechanical hull plates (Rows 9..19, Cols 8..33)
  for (let y = 9; y <= 19; y++) {
    for (let x = 8; x <= 33; x++) {
      if (!grid[y][x]) {
        if (y <= 12) {
          grid[y][x] = ((x + y) % 2 === 0) ? C.BRONZE_D : C.BRONZE_DD;
        } else if (y <= 16) {
          grid[y][x] = ((x + y) % 3 === 0) ? C.BRONZE_M : C.BRONZE_D;
        } else {
          grid[y][x] = ((x + y) % 2 === 0) ? C.BRONZE_D : C.BRONZE_DD;
        }
      }
    }
  }

  // Recessed cylindrical socket wells carved into the armor
  for (const pod of POD_DEFS) {
    const { cx, cy, isFar } = pod;
    for (let dy = -2; dy <= 2; dy++) {
      for (let dx = -2; dx <= 2; dx++) {
        const d2 = dx * dx + dy * dy;
        const px = cx + dx, py = cy + dy;
        if (d2 <= 4) {
          grid[py][px] = isFar ? C.CAV_VOID : C.CAV_DEEP;
        } else if (d2 <= 7) {
          grid[py][px] = (dy <= 0 && dx <= 0) 
            ? (isFar ? C.BRONZE_M : C.BONE_M) 
            : (isFar ? C.BRONZE_OUT : C.BRONZE_D);
        }
      }
    }
  }

  // Bio-spheres (or empty reload bays)
  for (let i = 0; i < 8; i++) {
    const pod = POD_DEFS[i];
    const { cx, cy, isFar } = pod;
    const isLoaded = i < loadedPodsCount;

    if (isLoaded) {
      if (isFar) {
        grid[cy - 1][cx]     = C.RED_RUBY;
        grid[cy - 1][cx + 1] = C.RED_DARK;
        grid[cy][cx - 1]     = C.RED_DARK;
        grid[cy][cx]         = C.RED_MID;
        grid[cy][cx + 1]     = C.RED_RUBY;
        grid[cy + 1][cx]     = C.RED_SHADOW;
        grid[cy + 1][cx + 1] = C.RED_DARK;
        grid[cy - 1][cx]     = C.GLOW_PINK;
      } else {
        grid[cy - 1][cx - 1] = C.RED_MID;
        grid[cy - 1][cx]     = C.GLOW_W;      // Specular highlight!
        grid[cy - 1][cx + 1] = C.GLOW_RAD;
        grid[cy][cx - 1]     = C.RED_PURE;
        grid[cy][cx]         = C.RED_PURE;
        grid[cy][cx + 1]     = C.RED_BRIGHT;
        grid[cy + 1][cx - 1] = C.RED_DARK;
        grid[cy + 1][cx]     = C.RED_MID;
        grid[cy + 1][cx + 1] = C.RED_DARK;
      }
    } else {
      grid[cy][cx]         = C.CAV_VOID;
      grid[cy][cx + 1]     = C.CAV_VOID;
      grid[cy + 1][cx]     = C.RED_SHADOW;
      grid[cy + 1][cx + 1] = C.CAV_DEEP;
    }
  }

  // 3. BIOMECHANICAL RIBBED MIDSECTION & CURVING CONDUIT BUNDLES
  for (let r = 0; r < 5; r++) {
    const rx = 10 + r * 5;
    grid[19][rx + 1] = C.STEEL_L; grid[19][rx + 2] = C.BRONZE_D;
    grid[20][rx]     = C.STEEL_HI; grid[20][rx + 1] = C.STEEL_M; grid[20][rx + 2] = C.BRONZE_DD;
    grid[21][rx - 1] = C.STEEL_M; grid[21][rx]     = C.STEEL_D; grid[21][rx + 1] = C.CAV_DEEP;
    grid[22][rx - 2] = C.STEEL_D; grid[22][rx - 1] = C.STEEL_DD;
  }

  // Sinuous Arterial & Hydraulic Conduit Bundle (Rows 22..26, Cols 13..34)
  for (let x = 14; x <= 34; x++) {
    const y = (x >= 28) ? 23 : ((x >= 20) ? 24 : 23);
    grid[y][x] = (x % 4 === 0) ? C.RED_BRIGHT : C.RED_MID;
    grid[y + 1][x] = (x % 4 === 0) ? C.RED_MID : C.RED_DARK;
  }

  for (let x = 11; x <= 33; x++) {
    const y = (x >= 26) ? 25 : ((x >= 18) ? 26 : 25);
    if (!grid[y][x] || grid[y][x] === C.CAV_DEEP) {
      grid[y][x] = (x % 3 === 0) ? C.STEEL_HI : C.STEEL_L;
    }
    if (!grid[y + 1][x]) {
      grid[y + 1][x] = (x % 3 === 0) ? C.BRONZE_D : C.STEEL_D;
    }
  }

  grid[23][18] = C.BRONZE_HI; grid[24][18] = C.BRONZE_L;
  grid[23][25] = C.BRONZE_HI; grid[24][25] = C.BRONZE_L;
  grid[24][31] = C.BRONZE_HI; grid[25][31] = C.BRONZE_L;

  // 4. VENTRAL AMNIOTIC INCUBATION DOME (The Hans Rudolf Bio-Capsule, Rows 25..43, Cols 8..27)
  const sacCx = 17.5, sacCy = 34.0, sacR = 8.6;

  for (let y = 25; y <= 42; y++) {
    for (let x = 8; x <= 27; x++) {
      const dx = x - sacCx, dy = y - sacCy;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist <= sacR) {
        const norm = dist / sacR;
        if (norm > 0.88) {
          grid[y][x] = C.RED_SHADOW;
        } else if (norm > 0.70) {
          grid[y][x] = C.RED_DEEP;
        } else if (norm > 0.45) {
          grid[y][x] = C.RED_DARK;
        } else if (norm > 0.22) {
          grid[y][x] = C.RED_MID;
        } else {
          grid[y][x] = C.RED_BRIGHT;
        }
      }
    }
  }

  // Hexagonal Chitinous Geodesic Wireframe Framework
  const hexStruts = [
    { y: 27, xs: [13, 14, 15, 19, 20, 21] },
    { y: 30, xs: [10, 11, 15, 16, 20, 21, 24, 25] },
    { y: 34, xs: [9, 10, 14, 15, 19, 20, 24, 25] },
    { y: 38, xs: [10, 11, 15, 16, 20, 21, 24, 25] },
    { y: 41, xs: [13, 14, 15, 19, 20, 21] },
    { y: 28, xs: [12, 17, 22] },
    { y: 29, xs: [11, 16, 23] },
    { y: 31, xs: [10, 15, 21] },
    { y: 32, xs: [9, 14, 20, 25] },
    { y: 33, xs: [9, 14, 20, 25] },
    { y: 35, xs: [10, 15, 21] },
    { y: 36, xs: [11, 16, 22] },
    { y: 37, xs: [11, 17, 23] },
    { y: 39, xs: [12, 18, 22] },
    { y: 40, xs: [13, 17, 21] }
  ];
  for (const h of hexStruts) {
    for (const x of h.xs) {
      if (grid[h.y] && grid[h.y][x] && grid[h.y][x].startsWith('#')) {
        grid[h.y][x] = C.BRONZE_D;
      }
    }
  }

  // Glass Specular Glint
  grid[27][13] = C.BONE_W; grid[27][14] = C.BONE_L;
  grid[28][12] = C.BONE_L; grid[28][13] = C.WHITE; grid[28][14] = C.BONE_W;
  grid[29][12] = C.BONE_M;

  // SUSPENDED ELDER SUL PILOT (Dark organic curled fetal silhouette)
  grid[30][19] = C.PILOT_CORE; grid[30][20] = C.PILOT_CORE;
  grid[31][18] = C.PILOT_CORE; grid[31][19] = C.PILOT_BODY; grid[31][20] = C.PILOT_CORE; grid[31][21] = C.PILOT_LIMB;
  grid[32][18] = C.PILOT_CORE; grid[32][19] = C.PILOT_CORE; grid[32][20] = C.PILOT_BODY;

  // Bioluminescent Third-Eye Ganglia Synapse
  grid[30][20] = C.GLOW_RAD;
  grid[31][20] = C.GLOW_W;

  // Curled spinal column
  grid[33][16] = C.PILOT_CORE; grid[33][17] = C.PILOT_BODY; grid[33][18] = C.PILOT_BODY;
  grid[34][15] = C.PILOT_CORE; grid[34][16] = C.PILOT_BODY; grid[34][17] = C.PILOT_CORE;
  grid[35][15] = C.PILOT_CORE; grid[35][16] = C.PILOT_BODY; grid[35][17] = C.PILOT_BODY;
  grid[36][16] = C.PILOT_CORE; grid[36][17] = C.PILOT_BODY; grid[36][18] = C.PILOT_LIMB;

  // Curled limbs
  grid[33][19] = C.PILOT_LIMB; grid[33][20] = C.PILOT_BODY;
  grid[34][19] = C.PILOT_BODY; grid[34][20] = C.PILOT_CORE; grid[34][21] = C.PILOT_LIMB;
  grid[35][18] = C.PILOT_BODY; grid[35][19] = C.PILOT_CORE; grid[35][20] = C.PILOT_LIMB;
  grid[36][19] = C.PILOT_LIMB; grid[36][20] = C.PILOT_BODY;
  grid[37][17] = C.PILOT_LIMB; grid[37][18] = C.PILOT_BODY;

  // Umbilical neural conduits
  grid[29][16] = C.PILOT_CORD; grid[29][17] = C.PILOT_BODY;
  grid[28][16] = C.PILOT_CORD;
  grid[27][17] = C.PILOT_CORD;
  grid[26][17] = C.RED_SHADOW;

  // Underside Stabilizer Claws
  grid[40][11] = C.BRONZE_OUT; grid[41][10] = C.BRONZE_DD; grid[42][9] = C.BRONZE_D; grid[43][9] = C.BRONZE_M; grid[44][10] = C.BONE_W;
  grid[42][16] = C.BRONZE_OUT; grid[43][16] = C.BRONZE_DD; grid[44][17] = C.BRONZE_L; grid[45][17] = C.WHITE;
  grid[41][23] = C.BRONZE_OUT; grid[42][24] = C.BRONZE_DD; grid[43][25] = C.BRONZE_L; grid[44][26] = C.BONE_W;

  // 5. AFT LEVITATION EXHAUST & SPINAL TAIL (Rows 16..24, Cols 1..9)
  grid[16][5] = C.BRONZE_OUT; grid[16][6] = C.BRONZE_DD;
  grid[17][4] = C.BRONZE_OUT; grid[17][5] = C.BRONZE_DD; grid[17][6] = C.BRONZE_D; grid[17][7] = C.BRONZE_M;
  grid[18][3] = C.STEEL_VOID; grid[18][4] = C.STEEL_DD; grid[18][5] = C.STEEL_D; grid[18][6] = C.BRONZE_D; grid[18][7] = C.BRONZE_L;
  grid[19][2] = C.STEEL_VOID; grid[19][3] = C.STEEL_DD; grid[19][4] = C.STEEL_D; grid[19][5] = C.STEEL_M; grid[19][6] = C.BRONZE_D;
  grid[20][2] = C.STEEL_VOID; grid[20][3] = C.STEEL_D; grid[20][4] = C.STEEL_L; grid[20][5] = C.STEEL_HI; grid[20][6] = C.BRONZE_L;
  grid[21][2] = C.STEEL_VOID; grid[21][3] = C.STEEL_DD; grid[21][4] = C.STEEL_D; grid[21][5] = C.STEEL_M; grid[21][6] = C.BRONZE_D;
  grid[22][3] = C.STEEL_VOID; grid[22][4] = C.STEEL_DD; grid[22][5] = C.STEEL_D; grid[22][6] = C.BRONZE_D;
  grid[23][4] = C.BRONZE_OUT; grid[23][5] = C.BRONZE_DD; grid[23][6] = C.BRONZE_D;
  grid[24][5] = C.BRONZE_OUT; grid[24][6] = C.BRONZE_DD;

  grid[19][0] = C.RED_SHADOW; grid[19][1] = C.RED_DARK;
  grid[20][0] = C.THRUST_OR;  grid[20][1] = C.THRUST_YEL; grid[20][2] = C.WHITE;
  grid[21][0] = C.RED_SHADOW; grid[21][1] = C.RED_DARK;
}

function _paintHD_EnforcerVulture_Head(grid) {
  const C = _EV_C;

  // 1. CRANIAL DOME & ROSTRAL ANTENNA HORNS (Rows 4..22, Cols 30..45)
  // Primary Forehead Horn (sweeps up from snout to Col 43, Row 4):
  grid[4][43] = C.WHITE;
  grid[5][42] = C.WHITE;    grid[5][43] = C.BONE_W;
  grid[6][41] = C.BONE_W;   grid[6][42] = C.BONE_L;
  grid[7][40] = C.BONE_L;   grid[7][41] = C.BONE_M;
  grid[8][39] = C.BONE_M;   grid[8][40] = C.BRONZE_L;
  grid[9][39] = C.BRONZE_L; grid[9][40] = C.BRONZE_M;

  // Secondary Horn (nested behind primary, Rows 7..11, Cols 36..38):
  grid[7][37]  = C.WHITE;
  grid[8][36]  = C.BONE_W;   grid[8][37] = C.BONE_L;
  grid[9][36]  = C.BONE_L;   grid[9][37] = C.BONE_M;
  grid[10][35] = C.BRONZE_L; grid[10][36] = C.BRONZE_M;
  grid[11][35] = C.BRONZE_M; grid[11][36] = C.BRONZE_D;

  // Anatomically Rounded Ivory Cranial Vault (Rows 9..14, Cols 31..42)
  grid[9][34] = C.BRONZE_OUT; grid[9][35] = C.BONE_L; grid[9][36] = C.BONE_W; grid[9][37] = C.BONE_M; grid[9][38] = C.BRONZE_D;
  
  grid[10][32] = C.BRONZE_OUT; grid[10][33] = C.BONE_D; grid[10][34] = C.BONE_L; grid[10][35] = C.BONE_W;
  grid[10][36] = C.WHITE;      grid[10][37] = C.BONE_W; grid[10][38] = C.BONE_L; grid[10][39] = C.BRONZE_M;

  grid[11][31] = C.BRONZE_OUT; grid[11][32] = C.BONE_D; grid[11][33] = C.BONE_M; grid[11][34] = C.BONE_L;
  grid[11][35] = C.BONE_W;     grid[11][36] = C.WHITE;  grid[11][37] = C.BONE_W; grid[11][38] = C.BONE_L;
  grid[11][39] = C.BONE_M;     grid[11][40] = C.BRONZE_L; grid[11][41] = C.BRONZE_M;

  // Brow ridge & temple vault (Rows 12..14, Cols 30..43)
  grid[12][30] = C.BRONZE_OUT; grid[12][31] = C.BONE_D; grid[12][32] = C.BONE_M; grid[12][33] = C.BONE_L;
  for (let x = 34; x <= 40; x++) grid[12][x] = (x === 36 || x === 37) ? C.WHITE : C.BONE_W;
  grid[12][41] = C.BONE_L; grid[12][42] = C.BONE_M; grid[12][43] = C.BRONZE_D;

  grid[13][29] = C.BRONZE_OUT; grid[13][30] = C.BONE_D; grid[13][31] = C.BONE_M;
  for (let x = 32; x <= 41; x++) grid[13][x] = (x >= 39) ? C.BONE_L : C.BONE_W;
  grid[13][42] = C.BONE_M; grid[13][43] = C.BONE_D;

  grid[14][29] = C.BRONZE_OUT; grid[14][30] = C.BONE_D;
  for (let x = 31; x <= 42; x++) grid[14][x] = (x >= 41) ? C.BONE_M : ((x >= 38) ? C.BONE_L : C.BONE_W);
  grid[14][43] = C.BONE_D;

  // 2. TRIANGULAR TRIPLE OCULAR CLUSTER (Rows 15..22, Cols 33..43)
  grid[15][29] = C.BRONZE_OUT; grid[15][30] = C.BRONZE_D; grid[15][31] = C.BONE_M; grid[15][32] = C.BONE_L;
  grid[15][41] = C.BONE_M; grid[15][42] = C.BONE_L; grid[15][43] = C.BONE_D;

  for (let y = 16; y <= 21; y++) {
    for (let x = 33; x <= 42; x++) {
      grid[y][x] = C.CAV_VOID;
    }
  }

  grid[16][37] = C.BRONZE_D; grid[16][38] = C.BRONZE_DD;
  grid[17][37] = C.BRONZE_D; grid[17][38] = C.BRONZE_DD;

  // Upper Eye 1 (Rear optic, Rows 16..17, Cols 34..36):
  grid[16][34] = C.RED_DARK;   grid[16][35] = C.GLOW_W;     grid[16][36] = C.RED_BRIGHT;
  grid[17][34] = C.RED_SHADOW; grid[17][35] = C.RED_PURE;   grid[17][36] = C.RED_MID;

  // Upper Eye 2 (Front optic, Rows 16..17, Cols 39..41):
  grid[16][39] = C.RED_DARK;   grid[16][40] = C.GLOW_W;     grid[16][41] = C.RED_BRIGHT;
  grid[17][39] = C.RED_SHADOW; grid[17][40] = C.RED_PURE;   grid[17][41] = C.RED_MID;

  // Lower Primary Radiant Projector Lens (Rows 19..21, Cols 36..40):
  grid[18][37] = C.RED_DARK;   grid[18][38] = C.RED_MID;    grid[18][39] = C.RED_DARK;
  grid[19][36] = C.RED_DARK;   grid[19][37] = C.RED_PURE;   grid[19][38] = C.GLOW_W;     grid[19][39] = C.GLOW_W;     grid[19][40] = C.RED_BRIGHT;
  grid[20][36] = C.RED_DARK;   grid[20][37] = C.RED_PURE;   grid[20][38] = C.GLOW_W;     grid[20][39] = C.GLOW_RAD;   grid[20][40] = C.RED_PURE;
  grid[21][37] = C.RED_SHADOW; grid[21][38] = C.RED_DARK;   grid[21][39] = C.RED_DARK;

  grid[16][33] = C.BONE_D; grid[16][42] = C.BONE_M; grid[16][43] = C.BONE_L;
  grid[17][33] = C.BONE_D; grid[17][42] = C.BONE_L; grid[17][43] = C.BONE_W;
  grid[18][33] = C.BONE_D; grid[18][34] = C.BONE_M; grid[18][41] = C.BONE_L; grid[18][42] = C.BONE_W; grid[18][43] = C.WHITE;
  grid[19][33] = C.BONE_D; grid[19][34] = C.BONE_M; grid[19][42] = C.BONE_W; grid[19][43] = C.WHITE;
  grid[20][33] = C.BRONZE_D; grid[20][34] = C.BONE_M; grid[20][42] = C.BONE_W; grid[20][43] = C.BONE_L;
  grid[21][33] = C.BRONZE_D; grid[21][34] = C.BONE_M; grid[21][41] = C.BONE_L; grid[21][42] = C.BONE_M;
  grid[22][32] = C.BRONZE_DD; grid[22][33] = C.BRONZE_D; grid[22][34] = C.BONE_M; grid[22][40] = C.BONE_L; grid[22][41] = C.BONE_M;

  // 3. COLOSSAL SEGMENTED RECURVED SICKLE TUSKS / MANDIBLES (Rows 22..45, Cols 26..47)
  grid[22][36] = C.BRONZE_M; grid[22][37] = C.BONE_L; grid[22][38] = C.BONE_W; grid[22][39] = C.WHITE;
  grid[23][36] = C.BRONZE_D; grid[23][37] = C.BRONZE_L; grid[23][38] = C.BONE_L; grid[23][39] = C.BONE_W; grid[23][40] = C.WHITE;

  // Segment 1 (Rows 24..27)
  grid[24][37] = C.BRONZE_D; grid[24][38] = C.BRONZE_L; grid[24][39] = C.BONE_L; grid[24][40] = C.BONE_W; grid[24][41] = C.WHITE;
  grid[25][38] = C.BRONZE_D; grid[25][39] = C.BRONZE_L; grid[25][40] = C.BONE_L; grid[25][41] = C.BONE_W; grid[25][42] = C.WHITE;
  grid[26][39] = C.BRONZE_D; grid[26][40] = C.BRONZE_L; grid[26][41] = C.BONE_L; grid[26][42] = C.BONE_W; grid[26][43] = C.WHITE;
  grid[27][39] = C.BONE_OUT; grid[27][40] = C.BONE_DEEP; grid[27][41] = C.BONE_D; grid[27][42] = C.BONE_M; grid[27][43] = C.BONE_W;

  // Segment 2 (Rows 28..31)
  grid[28][40] = C.BRONZE_D; grid[28][41] = C.BRONZE_L; grid[28][42] = C.BONE_L; grid[28][43] = C.BONE_W; grid[28][44] = C.WHITE;
  grid[29][41] = C.BRONZE_D; grid[29][42] = C.BRONZE_L; grid[29][43] = C.BONE_L; grid[29][44] = C.BONE_W; grid[29][45] = C.WHITE;
  grid[30][42] = C.BRONZE_D; grid[30][43] = C.BRONZE_L; grid[30][44] = C.BONE_L; grid[30][45] = C.BONE_W; grid[30][46] = C.WHITE;
  grid[31][42] = C.BRONZE_D; grid[31][43] = C.BRONZE_L; grid[31][44] = C.BONE_L; grid[31][45] = C.BONE_W; grid[31][46] = C.WHITE;
  grid[32][41] = C.BONE_OUT; grid[32][42] = C.BONE_DEEP; grid[32][43] = C.BONE_D; grid[32][44] = C.BONE_M; grid[32][45] = C.BONE_W;

  // Segment 3 (Rows 33..36)
  grid[33][41] = C.BRONZE_D; grid[33][42] = C.BRONZE_L; grid[33][43] = C.BONE_L; grid[33][44] = C.BONE_W; grid[33][45] = C.WHITE;
  grid[34][40] = C.BRONZE_D; grid[34][41] = C.BRONZE_L; grid[34][42] = C.BONE_L; grid[34][43] = C.BONE_W; grid[34][44] = C.WHITE;
  grid[35][39] = C.BRONZE_D; grid[35][40] = C.BRONZE_L; grid[35][41] = C.BONE_L; grid[35][42] = C.BONE_W; grid[35][43] = C.WHITE;
  grid[36][38] = C.BRONZE_D; grid[36][39] = C.BRONZE_L; grid[36][40] = C.BONE_L; grid[36][41] = C.BONE_W; grid[36][42] = C.WHITE;
  grid[37][36] = C.BONE_OUT; grid[37][37] = C.BONE_DEEP; grid[37][38] = C.BONE_D; grid[37][39] = C.BONE_M; grid[37][40] = C.BONE_W;

  // Segment 4 (Rows 38..41)
  grid[38][35] = C.BRONZE_D; grid[38][36] = C.BRONZE_L; grid[38][37] = C.BONE_L; grid[38][38] = C.BONE_W; grid[38][39] = C.WHITE;
  grid[39][33] = C.BRONZE_D; grid[39][34] = C.BRONZE_L; grid[39][35] = C.BONE_L; grid[39][36] = C.BONE_W; grid[39][37] = C.WHITE;
  grid[40][31] = C.BRONZE_D; grid[40][32] = C.BRONZE_L; grid[40][33] = C.BONE_L; grid[40][34] = C.BONE_W; grid[40][35] = C.WHITE;
  grid[41][29] = C.BRONZE_D; grid[41][30] = C.BRONZE_L; grid[41][31] = C.BONE_L; grid[41][32] = C.BONE_W; grid[41][33] = C.WHITE;
  grid[42][28] = C.BONE_OUT; grid[42][29] = C.BONE_DEEP; grid[42][30] = C.BONE_D; grid[42][31] = C.BONE_M;

  // Segment 5 (Recurved Needle Tip, Rows 42..44)
  grid[42][29] = C.BONE_L; grid[42][30] = C.BONE_W; grid[42][31] = C.WHITE;
  grid[43][27] = C.BRONZE_D; grid[43][28] = C.BONE_L; grid[43][29] = C.BONE_W; grid[43][30] = C.WHITE;
  grid[44][26] = C.WHITE;    grid[44][27] = C.BONE_W; grid[44][28] = C.BONE_L;

  // Secondary Inner Recurved Tusk
  grid[24][35] = C.BRONZE_D; grid[24][36] = C.BONE_L;
  grid[25][36] = C.BRONZE_D; grid[25][37] = C.BONE_L; grid[25][38] = C.BONE_W;
  grid[26][37] = C.BRONZE_D; grid[26][38] = C.BONE_L; grid[26][39] = C.WHITE;
  grid[27][37] = C.BRONZE_D; grid[27][38] = C.BONE_L; grid[27][39] = C.WHITE;
  grid[28][38] = C.BRONZE_D; grid[28][39] = C.BONE_L; grid[28][40] = C.WHITE;
  grid[29][39] = C.BRONZE_D; grid[29][40] = C.BONE_L; grid[29][41] = C.WHITE;
  grid[30][39] = C.BRONZE_D; grid[30][40] = C.BONE_L; grid[30][41] = C.WHITE;
  grid[31][39] = C.BRONZE_D; grid[31][40] = C.BONE_L; grid[31][41] = C.WHITE;
  grid[32][38] = C.BRONZE_D; grid[32][39] = C.BONE_L; grid[32][40] = C.WHITE;
  grid[33][37] = C.BRONZE_D; grid[33][38] = C.BONE_L; grid[33][39] = C.WHITE;
  grid[34][36] = C.BRONZE_D; grid[34][37] = C.BONE_L; grid[34][38] = C.WHITE;
  grid[35][35] = C.BRONZE_D; grid[35][36] = C.BONE_L; grid[35][37] = C.WHITE;
  grid[36][33] = C.BRONZE_D; grid[36][34] = C.BONE_L; grid[36][35] = C.WHITE;
  grid[37][32] = C.WHITE;    grid[37][33] = C.BONE_W; grid[37][34] = C.BONE_L;

  // Tertiary Throat Barb
  grid[27][33] = C.BONE_D; grid[27][34] = C.BONE_M;
  grid[28][33] = C.BONE_M; grid[28][34] = C.BONE_L;
  grid[29][32] = C.BONE_L; grid[29][33] = C.WHITE;
  grid[30][31] = C.WHITE;

  // 4. DROOPING MOUTH TENDRILS & THROAT CABLES (Rows 23..38, Cols 26..35)
  grid[23][32] = C.RED_SHADOW; grid[23][33] = C.RED_DARK; grid[23][34] = C.RED_MID; grid[23][35] = C.RED_SHADOW;
  grid[24][31] = C.RED_SHADOW; grid[24][32] = C.RED_DARK; grid[24][33] = C.RED_BRIGHT; grid[24][34] = C.RED_MID;
  grid[25][30] = C.RED_SHADOW; grid[25][31] = C.RED_DARK; grid[25][32] = C.RED_BRIGHT; grid[25][33] = C.RED_DARK;

  // Tendril 1 (Front primary visceral strand, curling forward):
  grid[26][31] = C.RED_DARK;
  grid[27][31] = C.RED_BRIGHT;
  grid[28][31] = C.RED_PURE;
  grid[29][30] = C.RED_BRIGHT;
  grid[30][30] = C.RED_PURE;
  grid[31][30] = C.RED_MID;
  grid[32][30] = C.RED_DARK;
  grid[33][29] = C.RED_BRIGHT;
  grid[34][29] = C.GLOW_RAD;

  // Tendril 2 (Mid visceral strand):
  grid[26][29] = C.RED_DARK; grid[26][30] = C.RED_MID;
  grid[27][29] = C.RED_MID;
  grid[28][29] = C.RED_DARK;
  grid[29][28] = C.RED_MID;
  grid[30][28] = C.RED_BRIGHT;
  grid[31][28] = C.RED_DARK;
  grid[32][27] = C.RED_DARK;
  grid[33][27] = C.RED_BRIGHT;

  // Tendril 3 (Rear neural conduit cable):
  grid[25][28] = C.BRONZE_DD; grid[25][29] = C.BRONZE_D;
  grid[26][28] = C.BRONZE_D;
  grid[27][27] = C.BRONZE_D;
  grid[28][27] = C.BRONZE_M;
  grid[29][26] = C.BRONZE_D;
  grid[30][26] = C.BRONZE_DD;
  grid[31][26] = C.CAV_VOID;
}

function getHD_EnforcerVulture(loadedPodsCount = 8) {
  const g = 48, grid = makeGrid48();
  _paintHD_EnforcerVulture_Body(grid, loadedPodsCount);
  _paintHD_EnforcerVulture_Head(grid);
  return { grid, gridSize: g };
}

function getHD_EnforcerVulture_Body(loadedPodsCount = 8) {
  const g = 48, grid = makeGrid48();
  _paintHD_EnforcerVulture_Body(grid, loadedPodsCount);
  return { grid, gridSize: g };
}

function getHD_EnforcerVulture_Head() {
  const g = 48, grid = makeGrid48();
  _paintHD_EnforcerVulture_Head(grid);
  return { grid, gridSize: g };
}

// ── SUL LOOTING VULTURE 24x24 HD ─────────────────────────────
// Authentic reproduction of 1_lootingvulture.png (Facing RIGHT +X):
// - Celestial Serpentine Dragon inspired by Zelda: Tears of the Kingdom sky dragons
// - Monumental 3D Sandstone / Terracotta Pyramid mounted on cervical dorsal hump
//   with two-tone chiaroscuro lighting (sunlit golden face vs shadow terracotta face along central hip ridge)
//   and solid 24k gold pyramidion capstone with radiant solar apex star
// - Autonomous Draconic Skull with upturned ivory rostral horn, parted predatory jaw, sharp teeth,
//   and 6 glowing amber/gold compound optics
// ── SUL LOOTING VULTURE 24x24 HD ─────────────────────────────
// Authentic horizontal serpentine celestial dragon inspired by classic Eastern luck dragons:
// - Body lies horizontally in the air (stretching across Cols 0..23)
// - Horizontally stretched dragon skull facing forward (+X) with upturned ivory horn and 6 amber optics
// - Towering 3D Sandstone / Terracotta Pyramid mounted directly behind head as a monumental cockscomb
//   with two-tone chiaroscuro lighting (golden sunlit facet vs dark terracotta shadow facet)
//   and solid 24k gold pyramidion capstone with radiant solar apex star
// - Sinuous horizontal body with thoracic belly dip and pelvic arch
// - Trailing caudal tail spine ending in a radiant tri-point golden dragon tail fin

function _paintHD_LootingVulture_Pyramid(grid) {
  // Peak Pinnacle Capstone Point (Cols 13..14, pure white & brilliant gold)
  grid[0][13] = '#ffffff'; grid[0][14] = '#fef08a';

  // Polished 24k Gold Pyramidion Capstone (Cols 12..15, bevelled 4px peak)
  grid[1][12] = '#fef08a'; grid[1][13] = '#ffffff'; grid[1][14] = '#fde047'; grid[1][15] = '#d97706';

  // Tier 1 Upper Terrace (Cols 11..16, 6px wide)
  // Sunlit facet (cols 11..13) | Shadow facet (cols 14..16)
  grid[2][11] = '#fde047'; grid[2][12] = '#f59e0b'; grid[2][13] = '#fde047';
  grid[2][14] = '#b45309'; grid[2][15] = '#9a3412'; grid[2][16] = '#7c2d12';

  // Tier 2 Terrace & Golden Runic Fissure (Cols 10..17, 8px wide)
  grid[3][10] = '#f59e0b'; grid[3][11] = '#d97706'; grid[3][12] = '#fde047'; grid[3][13] = '#ffffff';
  grid[3][14] = '#9a3412'; grid[3][15] = '#7c2d12'; grid[3][16] = '#451a03'; grid[3][17] = '#292524';

  // Tier 3 Mid Terrace & First Ascending Bio-Roots (Cols 9..18, 10px wide)
  grid[4][9]  = '#d97706'; grid[4][10] = '#f59e0b'; grid[4][11] = '#fde047'; grid[4][12] = '#d97706'; grid[4][13] = '#f59e0b';
  grid[4][14] = '#7c2d12'; grid[4][15] = '#9a3412'; grid[4][16] = '#451a03'; grid[4][17] = '#292524'; grid[4][18] = '#1c1917';

  // Tier 4 Terracotta Steps with Bio-Roots Climbing Up (Cols 8..19, 12px wide)
  grid[5][8]  = '#292524'; grid[5][9]  = '#b45309'; grid[5][10] = '#d97706'; grid[5][11] = '#facc15'; grid[5][12] = '#fde047'; grid[5][13] = '#d97706';
  grid[5][14] = '#9a3412'; grid[5][15] = '#7c2d12'; grid[5][16] = '#ca8a04'; grid[5][17] = '#451a03'; grid[5][18] = '#292524'; grid[5][19] = '#1c1917';

  // Tier 5 Megalithic Foundation Clamped by Dragon Scales (Cols 8..19)
  grid[6][8]  = '#1c1917'; grid[6][9]  = '#9a3412'; grid[6][10] = '#b45309'; grid[6][11] = '#d97706'; grid[6][12] = '#facc15'; grid[6][13] = '#d97706';
  grid[6][14] = '#7c2d12'; grid[6][15] = '#451a03'; grid[6][16] = '#7c2d12'; grid[6][17] = '#ca8a04'; grid[6][18] = '#292524'; grid[6][19] = '#1c1917';

  // Bio-Root & Stone Fusion Zone (Rows 7..10: Embedded deeply into thoracic vertebrae!)
  grid[7][8]  = '#1c1917'; grid[7][9]  = '#292524'; grid[7][10] = '#ca8a04'; grid[7][11] = '#b45309'; grid[7][12] = '#facc15'; grid[7][13] = '#d97706';
  grid[7][14] = '#7c2d12'; grid[7][15] = '#451a03'; grid[7][16] = '#ca8a04'; grid[7][17] = '#292524'; grid[7][18] = '#1c1917';

  // Row 8: Stone roots branching into spine
  grid[8][9]  = '#1c1917'; grid[8][10] = '#ca8a04'; grid[8][11] = '#b45309'; grid[8][12] = '#fde047'; grid[8][13] = '#d97706';
  grid[8][14] = '#9a3412'; grid[8][15] = '#7c2d12'; grid[8][16] = '#ca8a04'; grid[8][17] = '#1c1917';

  // Row 9: Deep spinal tendon anchors
  grid[9][10] = '#1c1917'; grid[9][11] = '#7c2d12'; grid[9][12] = '#ca8a04'; grid[9][13] = '#b45309';
  grid[9][14] = '#7c2d12'; grid[9][15] = '#451a03'; grid[9][16] = '#1c1917';

  // Row 10: Vertebrae core fusion
  grid[10][11] = '#1c1917'; grid[10][12] = '#9a3412'; grid[10][13] = '#ca8a04'; grid[10][14] = '#7c2d12'; grid[10][15] = '#1c1917';
}

function _paintHD_LootingVulture_Head(grid) {
  // 🐉 Looting Vulture Dragon Head (Modeled with photographic fidelity from 1_lootingvulture.png):
  // 1. Pale fleshy terracotta/bone snout with dark wrinkled creases
  // 2. Sharp upturned ivory rostral horn at far-right apex (col 23, row 9)
  // 3. Dark elongated slit nostril on rostral bridge (col 20, row 9)
  // 4. Cluster of 6 bulging 3D golden dome compound eyes with white specular glints & deep amber shadows
  // 5. Gaping serrated jaw with sharp white needle fangs and spilling golden sand cascade

  // Row 5: Radiant Golden Crown Mane / Fleece Crest (top of occiput)
  grid[5][15] = '#fef08a'; grid[5][16] = '#fde047'; grid[5][17] = '#ca8a04';

  // Row 6: Dorsal Golden Fleece Tufts & Topmost Cranial Golden Eye Orb Peak
  grid[6][14] = '#ca8a04'; grid[6][15] = '#fde047'; grid[6][16] = '#ffffff'; grid[6][17] = '#facc15'; grid[6][18] = '#ffffff'; grid[6][19] = '#fde047'; grid[6][20] = '#ca8a04';

  // Row 7: Cranial Eye Clustered Orbs (Upper Hemisphere) & Root Tendons
  grid[7][13] = '#78350f'; grid[7][14] = '#451a03'; grid[7][15] = '#3b1619';
  grid[7][16] = '#ffffff'; grid[7][17] = '#fde047'; grid[7][18] = '#ca8a04'; // Orb A (upper-rear golden eye)
  grid[7][19] = '#ffffff'; grid[7][20] = '#facc15'; grid[7][21] = '#92400e'; // Orb B (upper-mid golden eye)

  // Row 8: Central Golden Eye Cluster & Pale Fleshy Snout Bridge Root
  grid[8][12] = '#292524'; grid[8][13] = '#78350f'; grid[8][14] = '#3b1619';
  grid[8][15] = '#3b1619'; grid[8][16] = '#ffffff'; grid[8][17] = '#fde047'; grid[8][18] = '#ca8a04'; // Orb C (central giant golden dome)
  grid[8][19] = '#ffffff'; grid[8][20] = '#facc15'; grid[8][21] = '#8f4f4a'; grid[8][22] = '#c9938c'; // Orb D + fleshy snout root

  // Row 9: The Distinctive Rostral Snout, Dark Slit Nostril & Upturned Ivory Horn
  grid[9][12] = '#1c1917'; grid[9][13] = '#3b1619';
  grid[9][14] = '#ffffff'; grid[9][15] = '#fde047'; grid[9][16] = '#ca8a04'; // Orb E (lower-rear golden eye)
  grid[9][17] = '#ffffff'; grid[9][18] = '#facc15'; grid[9][19] = '#ba7e77'; // Orb F + fleshy bridge
  grid[9][20] = '#1a0a0c'; // 👃 DARK ELONGATED SLIT NOSTRIL
  grid[9][21] = '#dfb6b0'; // pale dusty-rose rostral bridge
  grid[9][22] = '#ebd0cb'; // upturned horn base
  grid[9][23] = '#ffffff'; // 🦏 SHARP UPTURNED IVORY ROSTRAL HORN APEX!

  // Row 10: Fleshy Upper Snout, Lower Eye Sockets & Horn Underside
  grid[10][13] = '#2d1316'; grid[10][14] = '#4a1f22'; grid[10][15] = '#6d3532';
  grid[10][16] = '#facc15'; grid[10][17] = '#ca8a04'; grid[10][18] = '#8f4f4a'; // Orb G (ventral eye) & socket shadow
  grid[10][19] = '#b2746d'; grid[10][20] = '#c9938c'; grid[10][21] = '#dfb6b0'; grid[10][22] = '#c9938c'; // wrinkled snout flesh

  // Row 11: Parted Mouth Cavity & Jagged Needle Fangs
  grid[11][13] = '#1a0a0c'; grid[11][14] = '#2d1316'; grid[11][15] = '#4a1f22';
  grid[11][16] = '#1a0a0c'; // dark mouth interior
  grid[11][17] = '#ffffff'; // sharp upper fang 1
  grid[11][18] = '#1a0a0c'; // cavity gap
  grid[11][19] = '#ffffff'; // sharp upper fang 2
  grid[11][20] = '#1a0a0c'; // cavity gap
  grid[11][21] = '#ffffff'; // sharp upper fang 3
  grid[11][22] = '#ba7e77'; // lower snout margin

  // Row 12: Serrated Lower Mandible & Upturned Chin Tip & Lower Teeth
  grid[12][13] = '#1a0a0c'; grid[12][14] = '#4a1f22'; grid[12][15] = '#6d3532';
  grid[12][16] = '#8f4f4a';
  grid[12][17] = '#ffffff'; // lower needle tooth 1
  grid[12][18] = '#b2746d';
  grid[12][19] = '#ffffff'; // lower needle tooth 2
  grid[12][20] = '#c9938c'; grid[12][21] = '#dfb6b0';
  grid[12][22] = '#ebd0cb'; // sharp upturned chin tip!

  // Row 13: Spilling Golden Sand & Mandible Throat Base (Gold pouring from the maw!)
  grid[13][14] = '#3b1619'; grid[13][15] = '#6d3532'; grid[13][16] = '#8f4f4a';
  grid[13][17] = '#fde047'; grid[13][18] = '#ffffff'; grid[13][19] = '#facc15'; grid[13][20] = '#fef08a'; grid[13][21] = '#ca8a04';

  // Row 14: Cascading Golden Sand Stream & Throat Beard
  grid[14][14] = '#1c1917'; grid[14][15] = '#78350f'; grid[14][16] = '#ca8a04';
  grid[14][17] = '#facc15'; grid[14][18] = '#fef08a'; grid[14][19] = '#fde047'; grid[14][20] = '#d97706';

  // Row 15: Trailing Golden Sand Flecks & Root Tendons
  grid[15][14] = '#1c1917'; grid[15][15] = '#ca8a04'; grid[15][16] = '#facc15'; grid[15][17] = '#fef08a'; grid[15][18] = '#d97706';
}

function _paintHD_LootingVulture_Body(grid) {
  // Horizontal Serpentine Torso with Coarse Fibrous Mane & Shaggy Fur Coat:
  // Row 6: Dorsal Coarse Mane Spikes & Neck Mane Tufts (bristling hairy crest)
  grid[6][5]  = '#1c1917'; grid[6][6]  = '#ca8a04'; grid[6][7]  = '#292524'; grid[6][8]  = '#eab308'; grid[6][9]  = '#1c1917';
  grid[6][17] = '#ca8a04'; grid[6][18] = '#292524'; grid[6][19] = '#1c1917';

  // Row 7: Chitin collar, coarse mane fur roots and cervical tufts
  grid[7][4]  = '#1c1917'; grid[7][5]  = '#292524'; grid[7][6]  = '#ca8a04'; grid[7][7]  = '#1c1917'; grid[7][8]  = '#292524'; grid[7][9]  = '#ca8a04'; grid[7][10] = '#44403c';
  grid[7][16] = '#44403c'; grid[7][17] = '#ca8a04'; grid[7][18] = '#292524'; grid[7][19] = '#eab308'; grid[7][20] = '#1c1917';

  // Row 8: Thoracic vertebrae saddle, coarse dorsal mane, and forward neck emergence
  grid[8][5]  = '#1c1917'; grid[8][6]  = '#292524'; grid[8][7]  = '#ca8a04'; grid[8][8]  = '#44403c'; grid[8][9]  = '#ca8a04';
  grid[8][16] = '#ca8a04'; grid[8][17] = '#fde047'; grid[8][18] = '#44403c'; grid[8][19] = '#292524'; grid[8][20] = '#eab308'; grid[8][21] = '#1c1917';

  // Row 9: Cervical neck & fibrous spine arch
  grid[9][4]  = '#1c1917'; grid[9][5]  = '#292524'; grid[9][6]  = '#44403c'; grid[9][7]  = '#ca8a04'; grid[9][8]  = '#eab308';
  grid[9][16] = '#fde047'; grid[9][17] = '#eab308'; grid[9][18] = '#fde047'; grid[9][19] = '#44403c'; grid[9][20] = '#292524';

  // Row 10: Pelvic arch (rear) & Muscular neck (front) with fur fringes
  grid[10][4] = '#1c1917'; grid[10][5] = '#292524'; grid[10][6] = '#eab308'; grid[10][7] = '#fde047'; grid[10][8] = '#44403c';
  grid[10][16] = '#44403c'; grid[10][17] = '#fde047'; grid[10][18] = '#eab308'; grid[10][19] = '#fde047'; grid[10][20] = '#292524';

  // Row 11: Pelvic flank (rear), mid-torso shaggy fur, and chest (front)
  grid[11][4] = '#1c1917'; grid[11][5] = '#44403c'; grid[11][6] = '#fde047'; grid[11][7] = '#eab308'; grid[11][8] = '#292524';
  grid[11][11] = '#1c1917'; grid[11][12] = '#292524'; grid[11][13] = '#ca8a04'; grid[11][14] = '#44403c'; grid[11][15] = '#fde047'; grid[11][16] = '#eab308'; grid[11][17] = '#fde047'; grid[11][18] = '#292524';

  // Row 12: Belly Dip descent & Chest bulk with wire-hair texture
  grid[12][4] = '#1c1917'; grid[12][5] = '#292524'; grid[12][6] = '#ca8a04'; grid[12][7] = '#eab308'; grid[12][8] = '#fde047'; grid[12][9] = '#ca8a04';
  grid[12][10] = '#1c1917'; grid[12][11] = '#292524'; grid[12][12] = '#eab308'; grid[12][13] = '#fde047'; grid[12][14] = '#eab308'; grid[12][15] = '#44403c'; grid[12][16] = '#1c1917';

  // Row 13: Horizontal Belly Dip transition (coarse hairy underbelly)
  grid[13][4] = '#1c1917'; grid[13][5] = '#292524'; grid[13][6] = '#ca8a04'; grid[13][7] = '#44403c'; grid[13][8] = '#eab308'; grid[13][9] = '#fde047';
  grid[13][10] = '#eab308'; grid[13][11] = '#44403c'; grid[13][12] = '#fde047'; grid[13][13] = '#eab308'; grid[13][14] = '#44403c'; grid[13][15] = '#1c1917';

  // Row 14: Belly Dip lower curve with shaggy fur bristles
  grid[14][5] = '#1c1917'; grid[14][6] = '#292524'; grid[14][7] = '#ca8a04'; grid[14][8] = '#eab308'; grid[14][9] = '#fde047'; grid[14][10] = '#eab308';
  grid[14][11] = '#fde047'; grid[14][12] = '#eab308'; grid[14][13] = '#ca8a04'; grid[14][14] = '#292524'; grid[14][15] = '#1c1917';

  // Row 15: Belly Dip lowest trough & coarse fur fringe
  grid[15][6] = '#1c1917'; grid[15][7] = '#292524'; grid[15][8] = '#ca8a04'; grid[15][9] = '#44403c'; grid[15][10] = '#fde047'; grid[15][11] = '#eab308';
  grid[15][12] = '#fde047'; grid[15][13] = '#ca8a04'; grid[15][14] = '#1c1917';

  // Row 16: Ventral shaggy hair fringe hanging into slipstream
  grid[16][7] = '#1c1917'; grid[16][8] = '#292524'; grid[16][9] = '#ca8a04'; grid[16][10] = '#eab308'; grid[16][11] = '#fde047'; grid[16][12] = '#ca8a04'; grid[16][13] = '#1c1917';

  // Row 17: Coarse hair tuft tips trailing beneath belly
  grid[17][8] = '#1c1917'; grid[17][9] = '#ca8a04'; grid[17][10] = '#eab308'; grid[17][11] = '#292524'; grid[17][12] = '#1c1917';

  // Row 18: Shaggy beard-hair wisps
  grid[18][9] = '#1c1917'; grid[18][10] = '#ca8a04'; grid[18][11] = '#1c1917';
}

function _paintHD_LootingVulture_Tail(grid) {
  // Horizontal Trailing Caudal Tail Spine & Radiant Golden Tail Fin with Coarse Hair Fringes:
  // Row 6: Upper Caudal Coarse Fur Spikes
  grid[6][3] = '#1c1917'; grid[6][4] = '#ca8a04'; grid[6][5] = '#292524'; grid[6][6] = '#ca8a04';

  // Row 7: Upper golden tail fin tuft & dorsal bristles
  grid[7][1] = '#ca8a04'; grid[7][2] = '#fde047'; grid[7][3] = '#ffffff'; grid[7][4] = '#facc15'; grid[7][5] = '#292524'; grid[7][6] = '#1c1917';
  grid[7][7] = '#ca8a04'; grid[7][8] = '#eab308'; grid[7][9] = '#1c1917';

  // Row 8: Main radiant golden dragon fin fan & dorsal hair crest
  grid[8][0] = '#ca8a04'; grid[8][1] = '#fde047'; grid[8][2] = '#ffffff'; grid[8][3] = '#facc15'; grid[8][4] = '#eab308'; grid[8][5] = '#44403c';
  grid[8][6] = '#292524'; grid[8][7] = '#ca8a04'; grid[8][8] = '#fde047'; grid[8][9] = '#292524';

  // Row 9: Lower tail fin feather & horizontal caudal spine vertebrae with fur tufts
  grid[9][1] = '#1c1917'; grid[9][2] = '#ca8a04'; grid[9][3] = '#fde047'; grid[9][4] = '#eab308'; grid[9][5] = '#44403c'; grid[9][6] = '#292524';
  grid[9][7] = '#1c1917'; grid[9][8] = '#44403c'; grid[9][9] = '#eab308'; grid[9][10] = '#fde047'; grid[9][11] = '#44403c'; grid[9][12] = '#292524';

  // Row 10: Horizontal caudal vertebrae connecting to pelvis
  grid[10][2] = '#1c1917'; grid[10][3] = '#292524'; grid[10][4] = '#ca8a04'; grid[10][5] = '#fde047'; grid[10][6] = '#eab308'; grid[10][7] = '#44403c';
  grid[10][8] = '#292524'; grid[10][9] = '#fde047'; grid[10][10] = '#eab308'; grid[10][11] = '#fde047'; grid[10][12] = '#44403c'; grid[10][13] = '#292524';

  // Row 11: Ventral tail tuft trailing in the slipstream & coarse shaggy fringe
  grid[11][2] = '#ca8a04'; grid[11][3] = '#facc15'; grid[11][4] = '#ca8a04'; grid[11][5] = '#1c1917'; grid[11][6] = '#292524';
  grid[11][9] = '#1c1917'; grid[11][10] = '#292524'; grid[11][11] = '#eab308'; grid[11][12] = '#fde047'; grid[11][13] = '#eab308'; grid[11][14] = '#292524';

  // Row 12: Trailing lower fur tufts
  grid[12][3] = '#1c1917'; grid[12][4] = '#ca8a04'; grid[12][5] = '#292524';
}

function getHD_LootingVulture() {
  const g = 24, grid = makeGrid();
  const tailGrid = makeGrid();
  const bodyGrid = makeGrid();
  const pyramidGrid = makeGrid();
  const headGrid = makeGrid();
  _paintHD_LootingVulture_Tail(tailGrid);
  _paintHD_LootingVulture_Body(bodyGrid);
  _paintHD_LootingVulture_Pyramid(pyramidGrid);
  _paintHD_LootingVulture_Head(headGrid);

  // Composite the 4 articulated segments at their horizontal offsets
  // (Tail: -7, Body: 0, Pyramid: +4, Head: +5 -> 36-column span vx in [-7..28])
  // and project onto the 24-column grid so the full horizontal dragon body length is preserved.
  const vMin = -7, vMax = 28, vSpan = vMax - vMin; // 35
  const vGrid = Array.from({ length: g }, () => Array(vSpan + 1).fill(null));
  const blit = (src, shiftX, shiftY = 0) => {
    for (let y = 0; y < g; y++) {
      const ty = y + shiftY;
      if (ty < 0 || ty >= g) continue;
      for (let x = 0; x < g; x++) {
        const c = src[y][x];
        if (!c) continue;
        const vx = x + shiftX - vMin;
        if (vx >= 0 && vx <= vSpan) vGrid[ty][vx] = c;
      }
    }
  };
  blit(tailGrid, -7, 0);
  // Pelvis & tail spine bridge connecting tail (cols 4..6) to rear pelvis (cols 4..6)
  for (let vx = 4 - vMin; vx <= 6 - vMin; vx++) {
    vGrid[8][vx] = '#1c1917';
    vGrid[9][vx] = '#ca8a04';
    vGrid[10][vx] = '#fde047';
    vGrid[11][vx] = '#292524';
  }
  blit(bodyGrid, 0, 0);
  blit(pyramidGrid, 4, 1);
  blit(headGrid, 5, 0);

  for (let y = 0; y < g; y++) {
    for (let gx = 0; gx < g; gx++) {
      const vx = Math.round((gx / (g - 1)) * vSpan);
      grid[y][gx] = vGrid[y][vx];
    }
  }
  return { grid, gridSize: g };
}

function getHD_LootingVulture_Tail() {
  const g = 24, grid = makeGrid();
  _paintHD_LootingVulture_Tail(grid);
  return { grid, gridSize: g };
}

function getHD_LootingVulture_Body() {
  const g = 24, grid = makeGrid();
  _paintHD_LootingVulture_Body(grid);
  return { grid, gridSize: g };
}

function getHD_LootingVulture_Pyramid() {
  const g = 24, grid = makeGrid();
  _paintHD_LootingVulture_Pyramid(grid);
  return { grid, gridSize: g };
}

function getHD_LootingVulture_Head() {
  const g = 24, grid = makeGrid();
  _paintHD_LootingVulture_Head(grid);
  return { grid, gridSize: g };
}

// ── SUL PARASITE VULTURE 24x24 HD ────────────────────────────
// Authentic reproduction of 1_parasitevulture.png (Facing RIGHT +X):
// - Colossal bio-manipulated raptor with spread feathered wings and crimson arterial cords
// - Parasite ("The Red Meatball"): Pulsing visceral bio-organism on the dorsal spinal cradle
// - Agape predatory beak screeching with crazed crimson ocular optics
// - Visceral crater socket remaining on back after parasite leap

function _paintHD_ParasiteVulture_Parasite(grid, isStandalone = false) {
  if (isStandalone) {
    // Standalone / Projectile / Attached Parasite Sprite (Centered in 24x24 grid, Rows 8..15, Cols 8..15)
    // Pulsing organic meatball core with trailing bio-tendrils
    grid[8][11] = '#7f1d1d'; grid[8][12] = '#dc2626'; grid[8][13] = '#7f1d1d';
    grid[9][10] = '#991b1b'; grid[9][11] = '#ef4444'; grid[9][12] = '#f87171'; grid[9][13] = '#dc2626'; grid[9][14] = '#7f1d1d';
    grid[10][9] = '#7f1d1d'; grid[10][10] = '#dc2626'; grid[10][11] = '#ffffff'; grid[10][12] = '#ef4444'; grid[10][13] = '#dc2626'; grid[10][14] = '#991b1b'; grid[10][15] = '#450a0a';
    grid[11][9] = '#991b1b'; grid[11][10] = '#ef4444'; grid[11][11] = '#f87171'; grid[11][12] = '#ef4444'; grid[11][13] = '#dc2626'; grid[11][14] = '#991b1b';
    grid[12][9] = '#450a0a'; grid[12][10] = '#dc2626'; grid[12][11] = '#ef4444'; grid[12][12] = '#dc2626'; grid[12][13] = '#991b1b'; grid[12][14] = '#450a0a';
    grid[13][10] = '#7f1d1d'; grid[13][11] = '#991b1b'; grid[13][12] = '#991b1b'; grid[13][13] = '#7f1d1d';
    // Trailing filament tendrils peitschen nach hinten/unten
    grid[14][9] = '#dc2626'; grid[14][11] = '#450a0a'; grid[14][13] = '#dc2626';
    grid[15][8] = '#ef4444'; grid[15][14] = '#ef4444';
  } else {
    // Parasite mounted in Vulture's Dorsal Spinal Cradle (Rows 3..7, Cols 8..13)
    grid[3][9] = '#7f1d1d'; grid[3][10] = '#dc2626'; grid[3][11] = '#ef4444'; grid[3][12] = '#991b1b';
    grid[4][8] = '#991b1b'; grid[4][9] = '#ef4444'; grid[4][10] = '#f87171'; grid[4][11] = '#ffffff'; grid[4][12] = '#dc2626'; grid[4][13] = '#7f1d1d';
    grid[5][8] = '#7f1d1d'; grid[5][9] = '#dc2626'; grid[5][10] = '#ef4444'; grid[5][11] = '#dc2626'; grid[5][12] = '#991b1b'; grid[5][13] = '#450a0a';
    grid[6][9] = '#450a0a'; grid[6][10] = '#991b1b'; grid[6][11] = '#dc2626'; grid[6][12] = '#7f1d1d';
    // Deep bio-root tendrils burrowing into host spine
    grid[7][8] = '#7f1d1d'; grid[7][9] = '#450a0a'; grid[7][11] = '#450a0a'; grid[7][12] = '#7f1d1d';
  }
}

function _paintHD_ParasiteVulture_Wing(grid) {
  // 🦅 PREDATORY SOARING RAPTOR WING (High Aspect Ratio, Slotted Primary Digits P1..P5)
  // Shoulder joint at Row 18, Col 12.
  // Straight aerodynamic leading arm spar slanting back-up along Cols 12..15 to wrist at Row 2, Col 13.
  // 5 slotted primary digits (remiges) extending tall and separated into the slipstream.
  // Sleek obsidian plumage with dark crimson muscle sinews (NO rounded turkey fan).

  // 1. Slotted Primary Flight Digits (P1..P5, Rows 0..6)
  // P5 (Leading Primary Finger - highest tip)
  grid[0][13] = '#cbd5e1'; grid[0][14] = '#f8fafc';
  grid[1][13] = '#64748b'; grid[1][14] = '#94a3b8';
  grid[2][13] = '#334155'; grid[2][14] = '#475569';

  // P4 (Second Primary Finger)
  grid[0][11] = '#94a3b8'; grid[0][12] = '#cbd5e1';
  grid[1][11] = '#475569'; grid[1][12] = '#64748b';
  grid[2][11] = '#1e293b'; grid[2][12] = '#334155';
  grid[3][11] = '#0f172a'; grid[3][12] = '#1e293b';

  // P3 (Third Primary Finger)
  grid[1][9] = '#94a3b8'; grid[1][10] = '#cbd5e1';
  grid[2][9] = '#475569'; grid[2][10] = '#64748b';
  grid[3][9] = '#1e293b'; grid[3][10] = '#334155';
  grid[4][9] = '#0f172a'; grid[4][10] = '#1e293b';

  // P2 (Fourth Primary Finger)
  grid[2][7] = '#64748b'; grid[2][8] = '#94a3b8';
  grid[3][7] = '#334155'; grid[3][8] = '#475569';
  grid[4][7] = '#1e293b'; grid[4][8] = '#334155';
  grid[5][7] = '#0f172a'; grid[5][8] = '#1e293b';

  // P1 (Inner Primary Finger)
  grid[4][5] = '#64748b'; grid[4][6] = '#94a3b8';
  grid[5][5] = '#334155'; grid[5][6] = '#475569';
  grid[6][5] = '#1e293b'; grid[6][6] = '#334155';
  grid[7][5] = '#0f172a'; grid[7][6] = '#1e293b';

  // 2. Muscular Leading Arm Spar (Humerus, Radius/Ulna, Rows 2..18, Cols 12..15)
  grid[2][12] = '#b45309'; grid[2][13] = '#fde68a';
  grid[3][13] = '#b45309'; grid[3][14] = '#d97706';
  grid[4][13] = '#b45309'; grid[4][14] = '#d97706';
  grid[5][13] = '#b45309'; grid[5][14] = '#d97706';
  grid[6][13] = '#78350f'; grid[6][14] = '#b45309'; grid[6][15] = '#d97706';
  grid[7][13] = '#78350f'; grid[7][14] = '#b45309'; grid[7][15] = '#d97706';
  grid[8][13] = '#78350f'; grid[8][14] = '#b45309'; grid[8][15] = '#d97706';
  grid[9][13] = '#78350f'; grid[9][14] = '#b45309'; grid[9][15] = '#d97706';
  grid[10][13] = '#78350f'; grid[10][14] = '#b45309'; grid[10][15] = '#d97706';
  grid[11][13] = '#78350f'; grid[11][14] = '#b45309'; grid[11][15] = '#d97706';
  grid[12][13] = '#78350f'; grid[12][14] = '#b45309'; grid[12][15] = '#d97706';
  grid[13][12] = '#78350f'; grid[13][13] = '#b45309'; grid[13][14] = '#d97706';
  grid[14][12] = '#78350f'; grid[14][13] = '#b45309'; grid[14][14] = '#d97706';
  grid[15][11] = '#451a03'; grid[15][12] = '#78350f'; grid[15][13] = '#b45309';
  grid[16][11] = '#292524'; grid[16][12] = '#451a03'; grid[16][13] = '#78350f';
  grid[17][11] = '#1c1917'; grid[17][12] = '#292524'; grid[17][13] = '#451a03';
  grid[18][11] = '#1c1917'; grid[18][12] = '#292524'; grid[18][13] = '#451a03';

  // 3. Arterial Crimson Vascular Cords (Sul Bio-cybernetic power sinews)
  grid[4][11] = '#0f172a'; grid[4][12] = '#7f1d1d'; grid[4][13] = '#dc2626';
  grid[5][11] = '#450a0a'; grid[5][12] = '#dc2626';
  grid[6][11] = '#450a0a'; grid[6][12] = '#ef4444';
  grid[7][11] = '#7f1d1d'; grid[7][12] = '#dc2626';
  grid[8][10] = '#450a0a'; grid[8][11] = '#dc2626'; grid[8][12] = '#991b1b';
  grid[9][10] = '#450a0a'; grid[9][11] = '#dc2626'; grid[9][12] = '#7f1d1d';
  grid[10][11] = '#450a0a'; grid[10][12] = '#991b1b';
  grid[11][11] = '#450a0a'; grid[11][12] = '#7f1d1d';

  // 4. Secondary Flight Vanes & Wing Panel (Rows 5..18, Cols 6..12)
  grid[5][8] = '#334155'; grid[5][9] = '#1e293b'; grid[5][10] = '#0f172a';
  grid[6][7] = '#334155'; grid[6][8] = '#1e293b'; grid[6][9] = '#0f172a'; grid[6][10] = '#1c1917';
  grid[7][7] = '#334155'; grid[7][8] = '#1e293b'; grid[7][9] = '#0f172a'; grid[7][10] = '#1c1917';
  grid[8][6] = '#334155'; grid[8][7] = '#1e293b'; grid[8][8] = '#0f172a'; grid[8][9] = '#1c1917';
  grid[9][6] = '#334155'; grid[9][7] = '#1e293b'; grid[9][8] = '#0f172a'; grid[9][9] = '#1c1917';
  grid[10][6] = '#334155'; grid[10][7] = '#1e293b'; grid[10][8] = '#0f172a'; grid[10][9] = '#1c1917'; grid[10][10] = '#292524';
  grid[11][6] = '#334155'; grid[11][7] = '#1e293b'; grid[11][8] = '#0f172a'; grid[11][9] = '#1c1917'; grid[11][10] = '#292524';
  grid[12][7] = '#334155'; grid[12][8] = '#1e293b'; grid[12][9] = '#0f172a'; grid[12][10] = '#1c1917'; grid[12][11] = '#292524'; grid[12][12] = '#451a03';
  grid[13][7] = '#334155'; grid[13][8] = '#1e293b'; grid[13][9] = '#0f172a'; grid[13][10] = '#1c1917'; grid[13][11] = '#292524';
  grid[14][8] = '#334155'; grid[14][9] = '#1e293b'; grid[14][10] = '#0f172a'; grid[14][11] = '#1c1917';
  grid[15][8] = '#1e293b'; grid[15][9] = '#0f172a'; grid[15][10] = '#1c1917';
  grid[16][8] = '#1e293b'; grid[16][9] = '#0f172a'; grid[16][10] = '#1c1917';
  grid[17][8] = '#1e293b'; grid[17][9] = '#0f172a'; grid[17][10] = '#1c1917';
  grid[18][8] = '#0f172a'; grid[18][9] = '#0f172a'; grid[18][10] = '#1c1917';
}

function _paintHD_ParasiteVulture_Wing_Injured(grid) {
  // 🦅 INJURED RAPTOR WING: Broken primary quills, chipped tips, desaturated slate/bone & dried gore
  // 1. Tattered Slotted Primary Digits (P1..P5, Rows 1..7)
  // P5 (Chipped apex, missing row 0)
  grid[1][13] = '#94a3b8'; grid[1][14] = '#cbd5e1';
  grid[2][13] = '#475569'; grid[2][14] = '#64748b';

  // P4 (Shattered quill, missing rows 0..1)
  grid[2][11] = '#64748b'; grid[2][12] = '#94a3b8';
  grid[3][11] = '#334155'; grid[3][12] = '#475569';

  // P3 (Frayed digit)
  grid[2][9] = '#64748b'; grid[2][10] = '#94a3b8';
  grid[3][9] = '#334155'; grid[3][10] = '#475569';
  grid[4][9] = '#1e293b'; grid[4][10] = '#334155';

  // P2 (Broken quill at row 3)
  grid[3][7] = '#64748b'; grid[3][8] = '#94a3b8';
  grid[4][7] = '#334155'; grid[4][8] = '#475569';
  grid[5][7] = '#1e293b'; grid[5][8] = '#334155';

  // P1 (Inner trailing digit)
  grid[5][5] = '#475569'; grid[5][6] = '#64748b';
  grid[6][5] = '#334155'; grid[6][6] = '#475569';
  grid[7][5] = '#1e293b'; grid[7][6] = '#334155';

  // 2. Weathered Humeral Arm Spar (Desaturated Bone / Bruised Slate)
  grid[2][12] = '#64748b'; grid[2][13] = '#94a3b8';
  grid[3][13] = '#475569'; grid[3][14] = '#64748b';
  grid[4][13] = '#475569'; grid[4][14] = '#64748b';
  grid[5][13] = '#334155'; grid[5][14] = '#475569';
  grid[6][13] = '#334155'; grid[6][14] = '#475569'; grid[6][15] = '#64748b';
  grid[7][13] = '#1e293b'; grid[7][14] = '#334155'; grid[7][15] = '#475569';
  grid[8][13] = '#1e293b'; grid[8][14] = '#334155'; grid[8][15] = '#475569';
  grid[9][13] = '#1e293b'; grid[9][14] = '#334155'; grid[9][15] = '#475569';
  grid[10][13] = '#1e293b'; grid[10][14] = '#334155'; grid[10][15] = '#475569';
  grid[11][13] = '#1e293b'; grid[11][14] = '#334155'; grid[11][15] = '#475569';
  grid[12][13] = '#1e293b'; grid[12][14] = '#334155'; grid[12][15] = '#475569';
  grid[13][12] = '#0f172a'; grid[13][13] = '#1e293b'; grid[13][14] = '#334155';
  grid[14][12] = '#0f172a'; grid[14][13] = '#1e293b'; grid[14][14] = '#334155';
  grid[15][11] = '#0f172a'; grid[15][12] = '#1e293b'; grid[15][13] = '#334155';
  grid[16][11] = '#0f172a'; grid[16][12] = '#1e293b'; grid[16][13] = '#1e293b';
  grid[17][11] = '#0f172a'; grid[17][12] = '#1e293b';
  grid[18][11] = '#0f172a'; grid[18][12] = '#1e293b';

  // 3. Dried Clotted Blood & Gore Along Leading Edge
  grid[4][11] = '#450a0a'; grid[4][12] = '#7f1d1d';
  grid[5][11] = '#450a0a'; grid[5][12] = '#7f1d1d';
  grid[6][11] = '#450a0a'; grid[6][12] = '#7f1d1d';
  grid[7][11] = '#450a0a'; grid[7][12] = '#7f1d1d';
  grid[8][11] = '#450a0a'; grid[8][12] = '#7f1d1d';
  grid[9][11] = '#450a0a'; grid[9][12] = '#7f1d1d';
  grid[10][11] = '#450a0a'; grid[10][12] = '#7f1d1d';
  grid[11][11] = '#450a0a'; grid[11][12] = '#7f1d1d';

  // 4. Solid Opaque Secondary & Covert Feather Pane (Rows 5..18, NO GAPS - Fully Occludes Legs on Downstroke)
  grid[5][8] = '#475569'; grid[5][9] = '#334155'; grid[5][10] = '#1e293b';
  grid[6][7] = '#475569'; grid[6][8] = '#334155'; grid[6][9] = '#1e293b'; grid[6][10] = '#0f172a';
  grid[7][7] = '#475569'; grid[7][8] = '#334155'; grid[7][9] = '#1e293b'; grid[7][10] = '#0f172a';
  grid[8][6] = '#475569'; grid[8][7] = '#334155'; grid[8][8] = '#1e293b'; grid[8][9] = '#0f172a'; grid[8][10] = '#1c1917';
  grid[9][6] = '#475569'; grid[9][7] = '#334155'; grid[9][8] = '#1e293b'; grid[9][9] = '#0f172a'; grid[9][10] = '#1c1917';
  grid[10][6] = '#334155'; grid[10][7] = '#1e293b'; grid[10][8] = '#0f172a'; grid[10][9] = '#0f172a'; grid[10][10] = '#1c1917';
  grid[11][6] = '#334155'; grid[11][7] = '#1e293b'; grid[11][8] = '#0f172a'; grid[11][9] = '#1c1917'; grid[11][10] = '#292524';
  grid[12][7] = '#334155'; grid[12][8] = '#1e293b'; grid[12][9] = '#0f172a'; grid[12][10] = '#1c1917'; grid[12][11] = '#292524'; grid[12][12] = '#1e293b';
  grid[13][7] = '#334155'; grid[13][8] = '#1e293b'; grid[13][9] = '#0f172a'; grid[13][10] = '#1c1917'; grid[13][11] = '#292524';
  grid[14][8] = '#334155'; grid[14][9] = '#1e293b'; grid[14][10] = '#0f172a'; grid[14][11] = '#1c1917';
  grid[15][8] = '#1e293b'; grid[15][9] = '#0f172a'; grid[15][10] = '#1c1917';
  grid[16][8] = '#1e293b'; grid[16][9] = '#0f172a'; grid[16][10] = '#1c1917';
  grid[17][8] = '#1e293b'; grid[17][9] = '#0f172a'; grid[17][10] = '#1c1917';
  grid[18][8] = '#0f172a'; grid[18][9] = '#0f172a'; grid[18][10] = '#1c1917';
}

function _paintHD_ParasiteVulture_Body(grid, hasParasite = true) {
  if (hasParasite) {
    // ══════════════════════════════════════════════════════════════
    // INFESTED VULTURE BODY: Sleek obsidian plumage, glowing crimson arterial mesh, spinal cradle
    // (Note: Wings are rendered dynamically via layered wing components)
    // ══════════════════════════════════════════════════════════════
    // Dorsal Spinal Cradle: Parasite mounted firmly
    _paintHD_ParasiteVulture_Parasite(grid, false);

    // Torso, thoracic ribs & pulsing crimson mesh
    grid[6][4] = '#1c1917'; grid[6][5] = '#292524'; grid[6][6] = '#450a0a'; grid[6][7] = '#7f1d1d'; grid[6][13] = '#450a0a'; grid[6][14] = '#7f1d1d'; grid[6][15] = '#292524';
    grid[7][3] = '#1c1917'; grid[7][4] = '#292524'; grid[7][5] = '#7f1d1d'; grid[7][6] = '#dc2626'; grid[7][7] = '#ef4444';
    grid[7][13] = '#dc2626'; grid[7][14] = '#991b1b'; grid[7][15] = '#450a0a';

    grid[8][3] = '#1c1917'; grid[8][4] = '#450a0a'; grid[8][5] = '#991b1b'; grid[8][6] = '#ef4444'; grid[8][7] = '#dc2626';
    grid[8][8] = '#7f1d1d'; grid[8][9] = '#450a0a'; grid[8][10] = '#7f1d1d'; grid[8][11] = '#dc2626'; grid[8][12] = '#ef4444';
    grid[8][13] = '#dc2626'; grid[8][14] = '#7f1d1d'; grid[8][15] = '#450a0a';

    grid[9][4] = '#292524'; grid[9][5] = '#7f1d1d'; grid[9][6] = '#dc2626'; grid[9][7] = '#ef4444'; grid[9][8] = '#dc2626';
    grid[9][9] = '#991b1b'; grid[9][10] = '#dc2626'; grid[9][11] = '#ef4444'; grid[9][12] = '#dc2626'; grid[9][13] = '#7f1d1d';
    grid[9][14] = '#450a0a'; grid[9][15] = '#292524';

    grid[10][4] = '#1c1917'; grid[10][5] = '#450a0a'; grid[10][6] = '#991b1b'; grid[10][7] = '#dc2626'; grid[10][8] = '#ef4444';
    grid[10][9] = '#ff4d6d'; grid[10][10] = '#ef4444'; grid[10][11] = '#dc2626'; grid[10][12] = '#991b1b'; grid[10][13] = '#450a0a';
    grid[10][14] = '#1c1917';

    // Lower thoracic ribcage
    grid[11][5] = '#292524'; grid[11][6] = '#450a0a'; grid[11][7] = '#7f1d1d'; grid[11][8] = '#dc2626'; grid[11][9] = '#ef4444';
    grid[11][10] = '#dc2626'; grid[11][11] = '#7f1d1d'; grid[11][12] = '#450a0a'; grid[11][13] = '#292524';

    grid[12][5] = '#1c1917'; grid[12][6] = '#292524'; grid[12][7] = '#450a0a'; grid[12][8] = '#7f1d1d'; grid[12][9] = '#991b1b';
    grid[12][10] = '#7f1d1d'; grid[12][11] = '#450a0a'; grid[12][12] = '#292524';

    // Trailing tail plumage
    grid[13][2] = '#fffbeb'; grid[13][3] = '#d4d4d8'; grid[13][4] = '#78716c'; grid[13][5] = '#292524';
    grid[14][1] = '#fffbeb'; grid[14][2] = '#e5e5e5'; grid[14][3] = '#78716c'; grid[14][4] = '#57534e'; grid[14][5] = '#292524';
    grid[15][0] = '#fffbeb'; grid[15][1] = '#d4d4d8'; grid[15][2] = '#78716c'; grid[15][3] = '#57534e';
    grid[16][1] = '#d4d4d8'; grid[16][2] = '#78716c'; grid[16][3] = '#292524';
    grid[17][2] = '#57534e'; grid[17][3] = '#1c1917';

    // Sharp predatory raptor talons
    grid[14][7] = '#451a03'; grid[14][8] = '#78350f'; grid[14][10] = '#78350f'; grid[14][11] = '#451a03';
    grid[15][7] = '#78350f'; grid[15][8] = '#b45309'; grid[15][9] = '#d97706'; grid[15][10] = '#b45309'; grid[15][11] = '#78350f';
    grid[16][7] = '#451a03'; grid[16][8] = '#d97706'; grid[16][9] = '#fde68a'; grid[16][10] = '#d97706'; grid[16][11] = '#451a03';
    grid[17][8] = '#451a03'; grid[17][9] = '#b45309'; grid[17][10] = '#d97706'; grid[17][11] = '#fde68a'; grid[17][12] = '#fffbeb';
    grid[18][8] = '#78350f'; grid[18][9] = '#fde68a'; grid[18][10] = '#fffbeb'; grid[18][11] = '#ffffff';
    grid[19][9] = '#ffffff';
  } else {
    // ══════════════════════════════════════════════════════════════
    // INJURED VULTURE BODY: Desaturated ash-grey/slate,
    // gaping bleeding wound crater with white exposed bone splinters and ripped tissue
    // ══════════════════════════════════════════════════════════════
    // 🔴 GAPING RAW WOUND CRATER (Where parasite ripped out of host spine)
    // Dark torn necrotic borders
    grid[3][7] = '#450a0a'; grid[3][8] = '#7f1d1d'; grid[3][9] = '#991b1b'; grid[3][10] = '#7f1d1d'; grid[3][11] = '#450a0a';
    grid[3][13] = '#475569'; grid[3][14] = '#334155';

    // Deep bloody flesh with JAGGED WHITE EXPOSED VERTEBRAE & BONE SPLINTERS
    grid[4][6] = '#450a0a'; grid[4][7] = '#7f1d1d'; grid[4][8] = '#ffffff'; grid[4][9] = '#dc2626'; grid[4][10] = '#ffffff'; grid[4][11] = '#dc2626'; grid[4][12] = '#ffffff'; grid[4][13] = '#450a0a';
    grid[5][7] = '#450a0a'; grid[5][8] = '#dc2626'; grid[5][9] = '#f8fafc'; grid[5][10] = '#ef4444'; grid[5][11] = '#e2e8f0'; grid[5][12] = '#dc2626'; grid[5][13] = '#450a0a';
    grid[6][8] = '#450a0a'; grid[6][9] = '#991b1b'; grid[6][10] = '#ffffff'; grid[6][11] = '#991b1b'; grid[6][12] = '#450a0a';
    grid[7][9] = '#450a0a'; grid[7][10] = '#7f1d1d'; grid[7][11] = '#450a0a';

    // Torso: Desaturated, sickly ash-grey & slate plumage with blood streaks
    grid[6][4] = '#334155'; grid[6][5] = '#475569'; grid[6][6] = '#64748b'; grid[6][7] = '#450a0a'; grid[6][14] = '#450a0a'; grid[6][15] = '#334155';
    grid[7][3] = '#1e293b'; grid[7][4] = '#334155'; grid[7][5] = '#475569'; grid[7][6] = '#64748b'; grid[7][7] = '#450a0a';
    grid[7][13] = '#7f1d1d'; grid[7][14] = '#475569'; grid[7][15] = '#334155';

    grid[8][3] = '#1e293b'; grid[8][4] = '#334155'; grid[8][5] = '#475569'; grid[8][6] = '#64748b'; grid[8][7] = '#450a0a';
    grid[8][8] = '#7f1d1d'; grid[8][9] = '#dc2626'; grid[8][10] = '#7f1d1d'; grid[8][11] = '#450a0a'; grid[8][12] = '#64748b';
    grid[8][13] = '#475569'; grid[8][14] = '#334155'; grid[8][15] = '#1e293b';

    grid[9][4] = '#1e293b'; grid[9][5] = '#334155'; grid[9][6] = '#475569'; grid[9][7] = '#64748b'; grid[9][8] = '#450a0a';
    grid[9][9] = '#7f1d1d'; grid[9][10] = '#991b1b'; grid[9][11] = '#450a0a'; grid[9][12] = '#475569'; grid[9][13] = '#334155';
    grid[9][14] = '#1e293b';

    grid[10][4] = '#0f172a'; grid[10][5] = '#1e293b'; grid[10][6] = '#334155'; grid[10][7] = '#475569'; grid[10][8] = '#64748b';
    grid[10][9] = '#475569'; grid[10][10] = '#334155'; grid[10][11] = '#1e293b'; grid[10][12] = '#0f172a';

    // Lower bruised thoracic ribs
    grid[11][5] = '#1e293b'; grid[11][6] = '#334155'; grid[11][7] = '#475569'; grid[11][8] = '#334155'; grid[11][9] = '#1e293b';
    grid[11][10] = '#334155'; grid[11][11] = '#1e293b';

    grid[12][5] = '#0f172a'; grid[12][6] = '#1e293b'; grid[12][7] = '#334155'; grid[12][8] = '#1e293b'; grid[12][9] = '#0f172a';

    // Tattered tail plumage with missing quills
    grid[13][3] = '#94a3b8'; grid[13][4] = '#64748b'; grid[13][5] = '#334155';
    grid[14][2] = '#94a3b8'; grid[14][3] = '#64748b'; grid[14][4] = '#475569'; grid[14][5] = '#1e293b';
    grid[15][1] = '#94a3b8'; grid[15][2] = '#64748b'; grid[15][3] = '#334155';
    grid[16][2] = '#475569'; grid[16][3] = '#1e293b';

    // Gore-stained talons
    grid[14][7] = '#450a0a'; grid[14][8] = '#7f1d1d'; grid[14][10] = '#450a0a';
    grid[15][7] = '#78350f'; grid[15][8] = '#450a0a'; grid[15][9] = '#7f1d1d'; grid[15][10] = '#78350f';
    grid[16][7] = '#451a03'; grid[16][8] = '#78350f'; grid[16][9] = '#b45309'; grid[16][10] = '#451a03';
    grid[17][8] = '#451a03'; grid[17][9] = '#78350f'; grid[17][10] = '#b45309'; grid[17][11] = '#d4d4d8';
    grid[18][8] = '#451a03'; grid[18][9] = '#d4d4d8'; grid[18][10] = '#e5e5e5';
    grid[19][9] = '#cbd5e1';
  }
}


function _paintHD_ParasiteVulture_Head(grid) {
  // 1. RAGGED FEATHER RUFF & COLLAR (Rows 6..12, Cols 13..16)
  grid[6][14] = '#fffbeb'; grid[6][15] = '#fef3c7'; grid[6][16] = '#d4d4d8';
  grid[7][13] = '#fffbeb'; grid[7][14] = '#fef3c7'; grid[7][15] = '#d4d4d8'; grid[7][16] = '#78716c';
  grid[8][13] = '#fef3c7'; grid[8][14] = '#e5e5e5'; grid[8][15] = '#78716c';
  grid[9][13] = '#fffbeb'; grid[9][14] = '#d4d4d8'; grid[9][15] = '#57534e';
  grid[10][14] = '#fffbeb'; grid[10][15] = '#78716c';
  grid[11][14] = '#d4d4d8'; grid[11][15] = '#57534e';

  // 2. CRANIAL DOME & BLOOD-RED EYE (Rows 5..8, Cols 16..20)
  grid[5][17] = '#fffbeb'; grid[5][18] = '#fef3c7'; grid[5][19] = '#fde68a';
  grid[6][17] = '#fde68a'; grid[6][18] = '#b45309'; grid[6][19] = '#92400e'; grid[6][20] = '#78350f';

  // Bloodshot crazed ocular sensor / eye (Row 7, Cols 17..18)
  grid[7][16] = '#450a0a'; grid[7][17] = '#ffffff'; grid[7][18] = '#ff0033'; grid[7][19] = '#b45309'; grid[7][20] = '#fde68a';
  grid[8][16] = '#7f1d1d'; grid[8][17] = '#ff0033'; grid[8][18] = '#450a0a'; grid[8][19] = '#d97706'; grid[8][20] = '#fde68a';

  // 3. UPPER HOOKED BEAK (Rows 7..10, Cols 20..23)
  grid[7][21] = '#fde68a'; grid[7][22] = '#fffbeb';
  grid[8][21] = '#fde68a'; grid[8][22] = '#fffbeb'; grid[8][23] = '#ffffff';
  grid[9][20] = '#d97706'; grid[9][21] = '#fde68a'; grid[9][22] = '#fffbeb'; grid[9][23] = '#ffffff';
  // Sharp downward hooked tip
  grid[10][22] = '#b45309'; grid[10][23] = '#ffffff';
  grid[11][23] = '#d97706';

  // 4. AGAPE LOWER JAW & SCREECHING Schlund (Rows 10..13, Cols 16..21)
  grid[9][17] = '#450a0a'; grid[9][18] = '#7f1d1d'; grid[9][19] = '#dc2626';
  grid[10][17] = '#7f1d1d'; grid[10][18] = '#dc2626'; grid[10][19] = '#ef4444'; grid[10][20] = '#991b1b';
  grid[11][18] = '#450a0a'; grid[11][19] = '#7f1d1d'; grid[11][20] = '#dc2626'; grid[11][21] = '#ef4444'; // Dripping saliva

  // Lower jaw bone
  grid[12][16] = '#78350f'; grid[12][17] = '#b45309'; grid[12][18] = '#fde68a'; grid[12][19] = '#fffbeb'; grid[12][20] = '#ffffff';
  grid[13][16] = '#451a03'; grid[13][17] = '#78350f'; grid[13][18] = '#b45309'; grid[13][19] = '#fde68a';
}

function _paintHD_ParasiteVulture_Head_Injured(grid) {
  // Injured / Deparasitized Head: Scruffy ash-grey ruff, blind dead milky grey eye, chipped bloodied beak
  // 1. Tattered feather collar (ash-grey with dried blood)
  grid[6][14] = '#cbd5e1'; grid[6][15] = '#94a3b8'; grid[6][16] = '#64748b';
  grid[7][13] = '#94a3b8'; grid[7][14] = '#64748b'; grid[7][15] = '#475569'; grid[7][16] = '#334155';
  grid[8][13] = '#64748b'; grid[8][14] = '#475569'; grid[8][15] = '#450a0a';
  grid[9][13] = '#94a3b8'; grid[9][14] = '#64748b'; grid[9][15] = '#334155';
  grid[10][14] = '#64748b'; grid[10][15] = '#334155';
  grid[11][14] = '#475569'; grid[11][15] = '#1e293b';

  // 2. Bruised cranial dome & DEAD/BLIND MILKY EYE (optic extinguished)
  grid[5][17] = '#94a3b8'; grid[5][18] = '#64748b'; grid[5][19] = '#475569';
  grid[6][17] = '#64748b'; grid[6][18] = '#475569'; grid[6][19] = '#334155'; grid[6][20] = '#1e293b';

  // Blind cloudy eye with bruised dark socket
  grid[7][16] = '#1e293b'; grid[7][17] = '#64748b'; grid[7][18] = '#94a3b8'; grid[7][19] = '#475569'; grid[7][20] = '#334155';
  grid[8][16] = '#450a0a'; grid[8][17] = '#94a3b8'; grid[8][18] = '#64748b'; grid[8][19] = '#334155'; grid[8][20] = '#1e293b';

  // 3. Chipped beak with dried blood smear
  grid[7][21] = '#b45309'; grid[7][22] = '#78350f';
  grid[8][21] = '#b45309'; grid[8][22] = '#78350f'; grid[8][23] = '#450a0a';
  grid[9][20] = '#78350f'; grid[9][21] = '#b45309'; grid[9][22] = '#dc2626'; grid[9][23] = '#991b1b';
  grid[10][22] = '#78350f'; grid[10][23] = '#450a0a';
  grid[11][23] = '#451a03';

  // 4. Screeching Schlund in agony
  grid[9][17] = '#1e1b4b'; grid[9][18] = '#450a0a'; grid[9][19] = '#7f1d1d';
  grid[10][17] = '#450a0a'; grid[10][18] = '#7f1d1d'; grid[10][19] = '#991b1b'; grid[10][20] = '#450a0a';
  grid[11][18] = '#450a0a'; grid[11][19] = '#7f1d1d'; grid[11][20] = '#dc2626'; grid[11][21] = '#7f1d1d';

  grid[12][16] = '#451a03'; grid[12][17] = '#78350f'; grid[12][18] = '#b45309'; grid[12][19] = '#78350f'; grid[12][20] = '#450a0a';
  grid[13][16] = '#1c1917'; grid[13][17] = '#451a03'; grid[13][18] = '#78350f'; grid[13][19] = '#451a03';
}

function getHD_ParasiteVulture(hasParasite = true) {
  const g = 24, grid = makeGrid();
  if (hasParasite) {
    _paintHD_ParasiteVulture_Wing(grid);
    _paintHD_ParasiteVulture_Body(grid, true);
    _paintHD_ParasiteVulture_Head(grid);
  } else {
    _paintHD_ParasiteVulture_Wing_Injured(grid);
    _paintHD_ParasiteVulture_Body(grid, false);
    _paintHD_ParasiteVulture_Head_Injured(grid);
  }
  return { grid, gridSize: g };
}

function _composeParasiteVultureFlap(flapFrame, hasParasite = true) {
  const g = 24, grid = makeGrid();
  const wingGrid = makeGrid();
  if (hasParasite) {
    _paintHD_ParasiteVulture_Wing(wingGrid);
  } else {
    _paintHD_ParasiteVulture_Wing_Injured(wingGrid);
  }
  // flapFrame: 1: upstroke (shift wing up -2), 2: neutral (shift 0), 3: downstroke (shift wing down +2)
  const dy = flapFrame === 1 ? -2 : (flapFrame === 3 ? 2 : 0);
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      const ny = y + dy;
      if (ny >= 0 && ny < g && wingGrid[y][x]) {
        grid[ny][x] = wingGrid[y][x];
      }
    }
  }
  _paintHD_ParasiteVulture_Body(grid, hasParasite);
  if (hasParasite) {
    _paintHD_ParasiteVulture_Head(grid);
  } else {
    _paintHD_ParasiteVulture_Head_Injured(grid);
  }
  return { grid, gridSize: g };
}
function getHD_ParasiteVulture_Flap1() { return _composeParasiteVultureFlap(1, true); }
function getHD_ParasiteVulture_Flap2() { return _composeParasiteVultureFlap(2, true); }
function getHD_ParasiteVulture_Flap3() { return _composeParasiteVultureFlap(3, true); }
function getHD_ParasiteVulture_Empty_Flap1() { return _composeParasiteVultureFlap(1, false); }
function getHD_ParasiteVulture_Empty_Flap2() { return _composeParasiteVultureFlap(2, false); }
function getHD_ParasiteVulture_Empty_Flap3() { return _composeParasiteVultureFlap(3, false); }

function getHD_ParasiteVulture_Wing() {
  const g = 24, grid = makeGrid();
  _paintHD_ParasiteVulture_Wing(grid);
  return { grid, gridSize: g };
}

function getHD_ParasiteVulture_Wing_Injured() {
  const g = 24, grid = makeGrid();
  _paintHD_ParasiteVulture_Wing_Injured(grid);
  return { grid, gridSize: g };
}

function getHD_ParasiteVulture_Body(hasParasite = true) {
  const g = 24, grid = makeGrid();
  _paintHD_ParasiteVulture_Body(grid, hasParasite);
  return { grid, gridSize: g };
}

function getHD_ParasiteVulture_Body_Empty() {
  const g = 24, grid = makeGrid();
  _paintHD_ParasiteVulture_Body(grid, false);
  return { grid, gridSize: g };
}

function getHD_ParasiteVulture_Head() {
  const g = 24, grid = makeGrid();
  _paintHD_ParasiteVulture_Head(grid);
  return { grid, gridSize: g };
}

function getHD_ParasiteVulture_Head_Injured() {
  const g = 24, grid = makeGrid();
  _paintHD_ParasiteVulture_Head_Injured(grid);
  return { grid, gridSize: g };
}

function getHD_ParasiteVulture_Parasite() {
  const g = 24, grid = makeGrid();
  _paintHD_ParasiteVulture_Parasite(grid, true);
  return { grid, gridSize: g };
}

// ── SUL ANTI SHADE (24x24 HD-FIRST) ─────────────────────────
function _paintHD_AntiShade_Torso(grid) {
  // 1. Crown tendrils & wispy smoke flowing backward (y: 1..6, x: 2..15)
  // Far wisps
  grid[1][3] = '#020617'; grid[1][4] = '#090d16'; grid[1][5] = '#2d0a12'; grid[1][6] = '#450a0a';
  grid[2][2] = '#020617'; grid[2][3] = '#090d16'; grid[2][4] = '#1e1015'; grid[2][5] = '#991b1b'; grid[2][6] = '#dc2626';
  grid[2][7] = '#090d16'; grid[2][8] = '#020617';

  // Upper head dome & crest tendrils
  grid[1][8] = '#020617'; grid[1][9] = '#090d16'; grid[1][10] = '#0f172a'; grid[1][11] = '#090d16'; grid[1][12] = '#020617';
  grid[2][9] = '#090d16'; grid[2][10] = '#1e1b2e'; grid[2][11] = '#1e1015'; grid[2][12] = '#991b1b'; grid[2][13] = '#020617';

  // 2. Skull mask & glowing scarlet slit eyes (y: 3..6, x: 8..14)
  grid[3][8] = '#020617'; grid[3][9] = '#090d16'; grid[3][10] = '#020617'; grid[3][11] = '#090d16'; grid[3][12] = '#1e1015'; grid[3][13] = '#020617';
  grid[4][8] = '#020617'; grid[4][9] = '#090d16'; 
  // Piercing red eyes
  grid[4][10] = '#991b1b'; grid[4][11] = '#ff0033'; grid[4][12] = '#fca5a5'; grid[4][13] = '#ff0033'; grid[4][14] = '#020617';
  grid[5][8] = '#020617'; grid[5][9] = '#090d16'; grid[5][10] = '#090d16'; grid[5][11] = '#2d0a12'; grid[5][12] = '#090d16'; grid[5][13] = '#020617';

  // 3. Collar, Cowl & Chitin Horns (y: 6..7, x: 6..14)
  grid[6][6] = '#020617'; grid[6][7] = '#090d16'; grid[6][8] = '#0f172a'; grid[6][9] = '#1e293b'; grid[6][10] = '#0f172a';
  grid[6][11] = '#090d16'; grid[6][12] = '#090d16'; grid[6][13] = '#020617';
  grid[7][5] = '#020617'; grid[7][6] = '#090d16'; grid[7][7] = '#0f172a'; grid[7][8] = '#1e293b'; grid[7][9] = '#090d16';
  grid[7][10] = '#0f172a'; grid[7][11] = '#1e293b'; grid[7][12] = '#0f172a'; grid[7][13] = '#020617';

  // 4. Armored Chitin Torso with Team Accent & Blood Veins (y: 8..13, x: 6..15)
  grid[8][6] = '#020617'; grid[8][7] = '#090d16'; grid[8][8] = 'TEAM'; grid[8][9] = 'TEAM'; grid[8][10] = '#0f172a'; grid[8][11] = 'TEAM'; grid[8][12] = '#090d16'; grid[8][13] = '#020617';
  grid[9][6] = '#020617'; grid[9][7] = '#090d16'; grid[9][8] = 'TEAM'; grid[9][9] = '#dc2626'; grid[9][10] = '#ef4444'; grid[9][11] = 'TEAM'; grid[9][12] = '#090d16'; grid[9][13] = '#020617';
  grid[10][6] = '#020617'; grid[10][7] = '#0f172a'; grid[10][8] = 'TEAM'; grid[10][9] = 'TEAM'; grid[10][10] = 'TEAM'; grid[10][11] = 'TEAM'; grid[10][12] = '#090d16'; grid[10][13] = '#020617';
  grid[11][7] = '#020617'; grid[11][8] = '#090d16'; grid[11][9] = '#dc2626'; grid[11][10] = '#0f172a'; grid[11][11] = '#090d16'; grid[11][12] = '#020617';
  grid[12][7] = '#020617'; grid[12][8] = '#090d16'; grid[12][9] = '#0f172a'; grid[12][10] = '#090d16'; grid[12][11] = '#020617';
  grid[13][8] = '#020617'; grid[13][9] = '#090d16'; grid[13][10] = '#090d16'; grid[13][11] = '#020617';

  // 5. Back-cape smoke wisps
  grid[8][4] = '#020617'; grid[8][5] = '#2d0a12';
  grid[9][3] = '#020617'; grid[9][4] = '#1e1015'; grid[9][5] = '#450a0a';
  grid[10][3] = '#020617'; grid[10][4] = '#090d16';
  grid[11][4] = '#020617'; grid[11][5] = '#090d16';
  grid[12][5] = '#020617'; grid[12][6] = '#1e1015';
}

function _paintHD_AntiShade_Base(grid, frame = 0) {
  // Kontinuierlich rotierender, fetzenartiger Schatten- & Rauch-Strudel (Artwork-Parität, y: 13..23, x: 0..23)
  const f = frame % 6;
  const phase = (f / 6) * Math.PI * 2;
  const xc = 11.5;

  // 1. Transition waist & ribbed mantle root (y: 13..15)
  for (let x = 7; x <= 16; x++) {
    if (grid[13]) grid[13][x] = '#020617';
    grid[14][x] = (x === 7 || x === 16) ? '#020617' : ((x % 2 === 0) ? '#0f172a' : '#000000');
    grid[15][x] = (x === 7 || x === 16) ? '#050811' : '#020617';
  }
  const waistSwirlX = Math.round(xc + Math.sin(phase) * 2.2);
  grid[14][waistSwirlX] = '#1e293b';
  grid[15][waistSwirlX] = '#0f172a';

  // 2. 4 getrennte, zackige Stofffetzen-Bahnen (y: 16..19, ausladender Schwebemantel)
  const streamers = [
    { baseAng: 0.20,  spd: 1.05, amp: 4.2, maxRow: 19, width: 3, color: '#020617', smoke: '#1e293b' },
    { baseAng: 1.70,  spd: 0.90, amp: 4.8, maxRow: 19, width: 3, color: '#050811', smoke: '#0f172a' },
    { baseAng: 3.20,  spd: 1.15, amp: 5.2, maxRow: 19, width: 4, color: '#020617', smoke: '#334155' },
    { baseAng: 4.75,  spd: 0.85, amp: 4.5, maxRow: 19, width: 3, color: '#000000', smoke: '#1e293b' }
  ];

  for (let sIdx = 0; sIdx < 4; sIdx++) {
    const s = streamers[sIdx];
    const ang = phase * s.spd + s.baseAng;
    const inFront = Math.cos(ang) >= 0;

    for (let y = 16; y <= Math.min(19, s.maxRow); y++) {
      const depth = y - 15;
      const wave = Math.sin(ang + depth * 0.75) * (s.amp * 0.7 + depth * 0.5);
      const cx = Math.max(2, Math.min(21, Math.round(xc + wave)));

      // Gezackte Kante (Serrations): Stufenversatz auf ungeraden Zeilen
      const serration = (y % 2 === 1) ? 1 : 0;
      const leftX = Math.max(1, cx - Math.floor(s.width / 2) - serration);
      const rightX = Math.min(22, cx + Math.floor(s.width / 2));

      // Hinterer Tusch-Rauchschleier (Smoke Wash) auf der strömungsabgewandten Seite
      const smokeX = inFront ? (leftX - 1) : (rightX + 1);
      if (smokeX >= 0 && smokeX < 24 && !grid[y][smokeX]) {
        grid[y][smokeX] = s.smoke;
      }

      // Vorderer schwarzer Stofffetzen
      for (let x = leftX; x <= rightX; x++) {
        grid[y][x] = inFront ? s.color : '#050811';
      }

      // Vertikale Falten-Rippe (Highlight auf Frontal-Fetzen)
      if (inFront && cx >= leftX && cx <= rightX) {
        grid[y][cx] = '#0f172a';
      }
    }
  }
}

function _paintHD_AntiShade_Blade(grid) {
  // Massive Curved Void Executioner Blade (y: 6..22, x: 14..21)
  // Hilt / Pommel
  grid[7][13] = '#020617'; grid[7][14] = '#1e293b'; grid[7][15] = '#020617';
  grid[8][14] = '#334155'; grid[8][15] = '#475569';
  grid[9][14] = '#1e293b'; grid[9][15] = '#334155';

  // Crossguard / Chitin emitter
  grid[9][13] = '#020617'; grid[9][16] = '#020617'; grid[9][17] = '#991b1b';
  grid[10][13] = '#090d16'; grid[10][14] = '#020617'; grid[10][15] = '#020617'; grid[10][16] = '#dc2626';

  // Curved Heavy Blade Body (y: 11..22)
  const bladeCoords = [
    { y: 11, xBack: 14, xSpine: 15, xCore: 16, xEdge: 17 },
    { y: 12, xBack: 14, xSpine: 15, xCore: 16, xEdge: 17 },
    { y: 13, xBack: 15, xSpine: 16, xCore: 17, xEdge: 18 },
    { y: 14, xBack: 15, xSpine: 16, xCore: 17, xEdge: 18 },
    { y: 15, xBack: 15, xSpine: 16, xCore: 17, xEdge: 19 },
    { y: 16, xBack: 16, xSpine: 17, xCore: 18, xEdge: 19 },
    { y: 17, xBack: 16, xSpine: 17, xCore: 18, xEdge: 20 },
    { y: 18, xBack: 16, xSpine: 17, xCore: 18, xEdge: 20 },
    { y: 19, xBack: 15, xSpine: 16, xCore: 17, xEdge: 19 },
    { y: 20, xBack: 14, xSpine: 15, xCore: 16, xEdge: 18 },
    { y: 21, xBack: 13, xSpine: 14, xCore: 15, xEdge: 16 },
    { y: 22, xBack: 12, xSpine: 13, xCore: 14, xEdge: 15 }
  ];

  for (const b of bladeCoords) {
    grid[b.y][b.xBack] = '#020617';
    grid[b.y][b.xSpine] = '#090d16';
    grid[b.y][b.xCore] = '#991b1b';
    grid[b.y][b.xEdge] = '#ff0033';
    if (b.xEdge + 1 < 24 && b.y >= 14 && b.y <= 18) {
      grid[b.y][b.xEdge + 1] = '#ffffff'; // Blinding white-hot razor edge
    }
  }
}

function getHD_AntiShade_Torso() {
  const g = 24, grid = makeGrid();
  _paintHD_AntiShade_Torso(grid);
  return { grid, gridSize: g };
}

function getHD_AntiShade_Base() {
  const g = 24, grid = makeGrid();
  _paintHD_AntiShade_Base(grid, 0);
  return { grid, gridSize: g };
}

function getHD_AntiShade_Base_Walk1() {
  const g = 24, grid = makeGrid();
  _paintHD_AntiShade_Base(grid, 1);
  return { grid, gridSize: g };
}

function getHD_AntiShade_Base_Walk2() {
  const g = 24, grid = makeGrid();
  _paintHD_AntiShade_Base(grid, 2);
  return { grid, gridSize: g };
}

function getHD_AntiShade_Base_Walk3() {
  const g = 24, grid = makeGrid();
  _paintHD_AntiShade_Base(grid, 3);
  return { grid, gridSize: g };
}

function getHD_AntiShade_Base_Walk4() {
  const g = 24, grid = makeGrid();
  _paintHD_AntiShade_Base(grid, 4);
  return { grid, gridSize: g };
}

function getHD_AntiShade_Base_Walk5() {
  const g = 24, grid = makeGrid();
  _paintHD_AntiShade_Base(grid, 5);
  return { grid, gridSize: g };
}

function getHD_AntiShade_Base_Walk6() {
  const g = 24, grid = makeGrid();
  _paintHD_AntiShade_Base(grid, 0);
  return { grid, gridSize: g };
}

function getHD_AntiShade_Blade() {
  const g = 24, grid = makeGrid();
  _paintHD_AntiShade_Blade(grid);
  return { grid, gridSize: g };
}

function _composeAntiShade(frame = 0) {
  const g = 24, grid = makeGrid();
  _paintHD_AntiShade_Base(grid, frame);
  _paintHD_AntiShade_Torso(grid);
  _paintHD_AntiShade_Blade(grid);
  return { grid, gridSize: g };
}

function getHD_AntiShade_Walk1() { return _composeAntiShade(1); }
function getHD_AntiShade_Walk2() { return _composeAntiShade(2); }
function getHD_AntiShade_Walk3() { return _composeAntiShade(3); }
function getHD_AntiShade_Walk4() { return _composeAntiShade(4); }
function getHD_AntiShade_Walk5() { return _composeAntiShade(5); }
function getHD_AntiShade_Walk6() { return _composeAntiShade(0); }
function getHD_AntiShade() { return _composeAntiShade(0); }

function _paintHD_Pulp_Head(grid) {
  // 🎭 CLOWN HEAD IN SIDE PROFILE (Facing RIGHT +X, Rows 0..8, Cols 2..19)

  // 1. JESTER CAP HORNS & BELLS (Sweeping back and up)
  // Rear Horn (Sweeping backward-up to x: 2..7, y: 0..3)
  grid[2][2] = '#fbbf24'; grid[2][3] = '#f59e0b'; // Rear gold bell
  grid[2][4] = '#7c3aed'; grid[2][5] = '#6b21a8';
  grid[1][5] = '#a855f7'; grid[1][6] = '#7c3aed';
  grid[0][6] = '#fbbf24'; grid[0][7] = '#f59e0b'; // Top crest bell
  grid[1][7] = '#eab308'; grid[1][8] = '#7c3aed'; grid[1][9] = '#65a30d';

  // Cap Crown (x: 6..13, y: 2..3)
  grid[2][6] = '#7c3aed'; grid[2][7] = '#6b21a8'; grid[2][8] = '#65a30d'; grid[2][9] = '#4d7c0f'; grid[2][10] = '#7c3aed'; grid[2][11] = '#eab308';
  grid[3][7] = '#6b21a8'; grid[3][8] = '#7c3aed'; grid[3][9] = '#65a30d'; grid[3][10] = '#7c3aed';

  // Front Horn (Curving forward above brow, x: 12..15, y: 0..2)
  grid[0][14] = '#fbbf24'; grid[0][15] = '#f59e0b'; // Front horn gold bell
  grid[1][13] = '#10b981'; grid[1][14] = '#059669';
  grid[2][12] = '#65a30d'; grid[2][13] = '#84cc16';

  // 2. SUL BIO-HORROR MUTATION ON NAPE / REAR (x: 4..9, y: 4..7)
  grid[4][5] = '#831843'; grid[4][6] = '#9d174d'; grid[4][7] = '#be185d';
  grid[5][4] = '#831843'; grid[5][5] = '#be185d'; grid[5][6] = '#10b981'; grid[5][7] = '#db2777'; // Glowing green bio-eye at (6, 5)
  grid[6][5] = '#9d174d'; grid[6][6] = '#db2777'; grid[6][7] = '#ec4899'; grid[6][8] = '#be185d';
  grid[7][6] = '#831843'; grid[7][7] = '#9d174d'; grid[7][8] = '#be185d';

  // 3. WHITE CLOWN PORCELAIN MASK (SIDE PROFILE, Facing RIGHT +X, x: 10..18, y: 3..8)
  // Forehead & Brow (x: 11..15, y: 3)
  grid[3][11] = '#cbd5e1'; grid[3][12] = '#f8fafc'; grid[3][13] = '#ffffff'; grid[3][14] = '#ffffff'; grid[3][15] = '#1e293b';

  // Piercing Clown Eye & Pierrot Diamond/Teardrop Makeup (x: 12..15, y: 2..5)
  grid[2][13] = '#2563eb'; // Blue diamond tattoo above eye
  grid[4][10] = '#e2e8f0'; grid[4][11] = '#f8fafc'; grid[4][12] = '#ffffff';
  grid[4][13] = '#0f172a'; // Piercing black pupil looking forward +X
  grid[4][14] = '#ffffff'; grid[4][15] = '#1e293b'; // Temple rim
  grid[5][13] = '#3b82f6'; // Blue teardrop running down cheek

  // Cheek & Rosy Clown Blush Circle (x: 11..14, y: 5)
  grid[5][10] = '#cbd5e1'; grid[5][11] = '#f8fafc'; grid[5][12] = '#f87171'; // Rosy pink clown blush
  grid[5][14] = '#f8fafc';

  // 4. THE PROTRUDING RED CLOWN NOSE BULB (Facing +X, x: 15..18, y: 4..5)
  grid[4][15] = '#b91c1c'; grid[4][16] = '#ff0033'; grid[4][17] = '#ff4d6d'; // Nose top glint
  grid[5][15] = '#b91c1c'; grid[5][16] = '#ef4444'; grid[5][17] = '#ff0033'; grid[5][18] = '#b91c1c'; // Protruding round red nose tip!

  // 5. THE MANIC CLOWN GRIN WITH TEETH (In Side Profile, x: 11..17, y: 6..7)
  // Wide red lipstick smile extending along jaw
  grid[6][11] = '#dc2626'; // Upturned smile corner at rear cheek
  grid[6][12] = '#ef4444';
  grid[6][13] = '#ffffff'; grid[6][14] = '#ffffff'; grid[6][15] = '#ffffff'; // Gleaming white teeth!
  grid[6][16] = '#dc2626'; grid[6][17] = '#991b1b'; // Front lip curve
  grid[7][12] = '#991b1b'; grid[7][13] = '#dc2626'; grid[7][14] = '#ef4444'; grid[7][15] = '#dc2626'; // Lower red lip
  grid[7][16] = '#f8fafc'; // Chin porcelain

  // Chin & Jaw (x: 13..15, y: 8)
  grid[8][13] = '#cbd5e1'; grid[8][14] = '#f8fafc'; grid[8][15] = '#cbd5e1';

  // 6. FRILLED JESTER COLLAR / RUFF WITH BELLS (Neck level, x: 7..16, y: 8..9)
  grid[8][7] = '#fbbf24'; // Rear collar bell
  grid[8][8] = '#7c3aed'; grid[8][9] = '#f8fafc'; grid[8][10] = '#65a30d'; grid[8][11] = '#7c3aed'; grid[8][12] = '#f8fafc';
  grid[9][14] = '#fbbf24'; // Front collar bell
}

function _paintHD_Pulp_Body(grid) {
  // 🛡️ TORSO IN SIDE PROFILE (Facing RIGHT +X, Rows 9..15, Cols 4..16)

  // 1. REAR DORSAL SUL BIOMASS & PUSTULES (Back / Left side, x: 4..10, y: 9..15)
  grid[9][5] = '#831843'; grid[9][6] = '#9d174d'; grid[9][7] = '#be185d';
  grid[10][4] = '#831843'; grid[10][5] = '#be185d'; grid[10][6] = '#10b981'; grid[10][7] = '#db2777'; // Green pustule
  grid[11][4] = '#9d174d'; grid[11][5] = '#db2777'; grid[11][6] = '#ec4899'; grid[11][7] = '#be185d';
  grid[12][4] = '#831843'; grid[12][5] = '#9d174d'; grid[12][6] = '#be185d'; grid[12][7] = '#9d174d';
  grid[13][5] = '#9d174d'; grid[13][6] = '#db2777'; grid[13][7] = '#be185d';
  grid[14][5] = '#831843'; grid[14][6] = '#9d174d'; grid[14][7] = '#831843';
  grid[15][6] = '#0f172a'; grid[15][7] = '#1e293b'; // Spine pelvic connection

  // 2. CENTER HARLEQUIN COAT & TEAM INSIGNIA (Mid-Torso, x: 8..12, y: 9..14)
  grid[9][8] = '#7c3aed'; grid[9][9] = '#6b21a8'; grid[9][10] = '#65a30d';
  grid[10][8] = 'TEAM'; grid[10][9] = 'TEAM'; grid[10][10] = 'TEAM'; grid[10][11] = '#7c3aed';
  grid[11][8] = 'TEAM'; grid[11][9] = 'TEAM'; grid[11][10] = 'TEAM'; grid[11][11] = '#65a30d';
  grid[12][8] = 'TEAM'; grid[12][9] = 'TEAM'; grid[12][10] = 'TEAM'; grid[12][11] = '#ca8a04';
  grid[13][8] = '#7c3aed'; grid[13][9] = '#6b21a8'; grid[13][10] = '#65a30d'; grid[13][11] = '#eab308';
  grid[14][8] = '#65a30d'; grid[14][9] = '#4d7c0f'; grid[14][10] = '#7c3aed';

  // 3. FRONT CHEST & HARLEQUIN VEST (Leading Front / Right side, x: 12..16, y: 9..14)
  grid[9][11] = '#7c3aed'; grid[9][12] = '#f8fafc'; grid[9][13] = '#eab308';
  grid[10][12] = '#65a30d'; grid[10][13] = '#84cc16'; grid[10][14] = '#4d7c0f';
  grid[11][12] = '#7c3aed'; grid[11][13] = '#a855f7'; grid[11][14] = '#6b21a8';
  grid[12][12] = '#65a30d'; grid[12][13] = '#84cc16'; grid[12][14] = '#eab308';
  grid[13][12] = '#7c3aed'; grid[13][13] = '#6b21a8';
  grid[14][11] = '#eab308'; grid[14][12] = '#ca8a04';

  // 4. WAIST & SASH (Row 15)
  grid[15][8] = '#ca8a04'; grid[15][9] = '#eab308'; grid[15][10] = '#ca8a04'; grid[15][11] = '#eab308'; grid[15][12] = '#ca8a04';

  // 5. FOREGROUND ARM & JESTER SKULL SCEPTER (Held in near front hand, x: 13..18, y: 7..17)
  // Arm reaching forward from chest
  grid[11][13] = '#65a30d'; grid[11][14] = '#7c3aed';
  // Hand gripping scepter
  grid[12][14] = '#f8fafc'; grid[12][15] = '#cbd5e1';
  // Scepter staff (polished hardwood & gold rings)
  grid[10][15] = '#b45309'; grid[11][15] = '#78350f'; grid[13][15] = '#b45309'; grid[14][15] = '#78350f';
  grid[15][15] = '#b45309'; grid[16][15] = '#78350f'; grid[17][15] = '#f59e0b';
  // Mini Skull atop scepter
  grid[8][15] = '#e2e8f0'; grid[8][16] = '#f8fafc';
  grid[9][14] = '#e2e8f0'; grid[9][15] = '#0f172a'; grid[9][16] = '#0f172a'; grid[9][17] = '#f8fafc'; // Mini eye sockets
  grid[7][15] = '#fbbf24'; // Tiny golden bell atop scepter!

  // 6. SHORT SUL TENTACLE TIPS HANGING FROM BENEATH WAIST / HEM (Rows 13..17, Cols 1..5)
  // Characteristic Sul biology: deep plum/magenta flesh with glowing emerald/cyan bulbous tips
  // Tentacle Tip 1 (Upper dorsal short tendril):
  grid[13][3] = '#701a75'; grid[14][2] = '#be185d'; grid[15][2] = '#10b981';
  // Tentacle Tip 2 (Mid-waist drooping tip):
  grid[14][4] = '#831843'; grid[15][3] = '#9d174d'; grid[16][2] = '#db2777'; grid[16][1] = '#10b981'; grid[16][0] = '#6ee7b7';
  // Tentacle Tip 3 (Lower ventral curl):
  grid[16][5] = '#701a75'; grid[17][4] = '#be185d'; grid[17][3] = '#06b6d4';
}

function _paintHD_Pulp_Weapon(grid) {
  // 💣 FAR/REAR SHOULDER MORTAR (Mounted on far dorsal shoulder behind head, aiming forward-up into +X sky)
  // Organic socket mount on far dorsal shoulder (x: 4..7, y: 7..10)
  grid[8][4] = '#831843'; grid[8][5] = '#be185d'; grid[8][6] = '#db2777';
  grid[9][5] = '#9d174d'; grid[9][6] = '#451a03';
  grid[7][5] = '#78350f'; grid[7][6] = '#b45309'; grid[7][7] = '#d97706';

  // Mortar Tube Barrel (Angling forward-up into +X sky behind the head, x: 5..11, y: 1..7)
  grid[6][5] = '#451a03'; grid[6][6] = '#78350f'; grid[6][7] = '#b45309'; grid[6][8] = '#d97706';
  grid[5][6] = '#451a03'; grid[5][7] = '#78350f'; grid[5][8] = '#b45309'; grid[5][9] = '#d97706';
  grid[4][7] = '#451a03'; grid[4][8] = '#78350f'; grid[4][9] = '#b45309'; grid[4][10] = '#d97706';
  grid[3][8] = '#78350f'; grid[3][9] = '#b45309'; grid[3][10] = '#d97706';
  grid[2][9] = '#92400e'; grid[2][10] = '#b45309'; grid[2][11] = '#d97706';

  // Heavy Reinforced Muzzle Ring & Bore Opening (x: 9..12, y: 0..2)
  grid[1][9] = '#1c1917'; grid[1][10] = '#292524'; grid[1][11] = '#d97706'; grid[1][12] = '#f59e0b';
  grid[0][10] = '#1c1917'; grid[0][11] = '#292524'; // Hollow bore aiming into sky!
}

function _paintHD_Pulp_Legs(grid, frame = 0) {
  const f = frame % 6;
  if (f === 0) {
    // ── FRAME 0: HOPSA PUSH-OFF (Absprung: Harlekin-Bein vorn drückt ab, Kette hinten greift) ──
    // Front Jester Leg: Thigh angled down, calf driving into floor, curled shoe planted
    grid[16][10] = '#7c3aed'; grid[16][11] = '#6b21a8'; grid[16][12] = '#4d7c0f';
    grid[17][11] = '#7c3aed'; grid[17][12] = '#65a30d'; grid[17][13] = '#84cc16';
    grid[18][12] = '#65a30d'; grid[18][13] = '#4d7c0f'; grid[18][14] = '#7c3aed';
    grid[19][13] = '#ca8a04'; grid[19][14] = '#eab308'; grid[19][15] = '#f59e0b';
    grid[20][13] = '#fbbf24'; grid[20][14] = '#ca8a04'; grid[20][15] = '#eab308'; // Sole planted
    grid[19][16] = '#fbbf24'; grid[18][16] = '#f59e0b'; // Gold bell curling up at toe

    // Rear Sul Tread: Track belt pressing hard into asphalt
    grid[16][6] = '#be185d'; grid[16][7] = '#9d174d';
    grid[17][5] = '#db2777'; grid[17][6] = '#334155'; grid[17][7] = '#475569';
    grid[18][4] = '#1e293b'; grid[18][5] = '#334155'; grid[18][6] = '#475569'; grid[18][7] = '#1e293b';
    grid[19][4] = '#0f172a'; grid[19][5] = '#1e293b'; grid[19][6] = '#334155'; grid[19][7] = '#475569';
    grid[20][4] = '#0f172a'; grid[20][5] = '#1e293b'; grid[20][6] = '#334155'; grid[20][7] = '#0f172a';
  } else if (f === 1) {
    // ── FRAME 1: HOPSA DRIVE & STRETCH (Vorwärts-Durchstreckung) ──
    // Front Jester Leg: Driving backward-down, catapulting Pulp forward into +X
    grid[16][9] = '#7c3aed'; grid[16][10] = '#6b21a8';
    grid[17][9] = '#65a30d'; grid[17][10] = '#84cc16'; grid[17][11] = '#4d7c0f';
    grid[18][8] = '#7c3aed'; grid[18][9] = '#6b21a8';
    grid[19][8] = '#65a30d'; grid[19][9] = '#84cc16';
    grid[20][7] = '#ca8a04'; grid[20][8] = '#eab308'; grid[20][9] = '#f59e0b';
    grid[19][6] = '#fbbf24'; grid[18][6] = '#f59e0b'; // Bell curled up behind

    // Rear Sul Tread: Lifted off ground, trailing behind
    grid[16][5] = '#db2777'; grid[16][6] = '#be185d';
    grid[17][4] = '#9d174d'; grid[17][5] = '#db2777';
    grid[18][3] = '#334155'; grid[18][4] = '#1e293b'; grid[18][5] = '#334155';
    grid[19][3] = '#475569'; grid[19][4] = '#334155'; grid[19][5] = '#1e293b';
    grid[20][4] = '#0f172a'; grid[20][5] = '#1e293b';
  } else if (f === 2) {
    // ── FRAME 2: HIGH FRONT SKIPPING KNEE! (Hopsa-Kniehochstand nach vorn +X) ──
    // Front Jester Leg: Thigh raised HIGH horizontal forward, shin angled with bell high!
    grid[16][9] = '#7c3aed'; grid[16][10] = '#6b21a8';
    grid[15][11] = '#65a30d'; grid[15][12] = '#84cc16'; grid[15][13] = '#7c3aed'; // High horizontal thigh!
    grid[15][14] = '#7c3aed'; grid[15][15] = '#6b21a8'; grid[15][16] = '#84cc16'; // Knee bent forward!
    grid[16][16] = '#ca8a04'; grid[16][17] = '#eab308'; grid[16][18] = '#f59e0b'; // Shin & foot pointing forward
    grid[16][19] = '#fbbf24'; grid[15][19] = '#fef08a'; grid[15][18] = '#fbbf24'; // 🔔 Curled shoe tip & gleaming bell at (19, 16)!

    // Rear Sul Tread: Dangling vertically beneath the chassis in low gravity
    grid[16][6] = '#be185d'; grid[16][7] = '#9d174d';
    grid[17][5] = '#db2777'; grid[17][6] = '#10b981'; grid[17][7] = '#be185d';
    grid[18][6] = '#334155'; grid[18][7] = '#475569';
    grid[19][6] = '#1e293b'; grid[19][7] = '#334155';
    grid[20][6] = '#0f172a'; grid[20][7] = '#1e293b'; grid[20][8] = '#475569';
    grid[21][7] = '#0f172a'; // Lowest dangling track pin
  } else if (f === 3) {
    // ── FRAME 3: FULL FORWARD MOON-LEAP (Weiter schwereloser Sprungschritt nach vorn) ──
    // Front Jester Leg: Straight forward moon kick into +X!
    grid[16][10] = '#7c3aed'; grid[16][11] = '#6b21a8';
    grid[16][12] = '#7c3aed'; grid[16][13] = '#65a30d'; grid[16][14] = '#84cc16';
    grid[16][15] = '#65a30d'; grid[16][16] = '#7c3aed'; grid[16][17] = '#a855f7';
    grid[16][18] = '#ca8a04'; grid[16][19] = '#eab308'; grid[16][20] = '#f59e0b';
    grid[15][20] = '#fbbf24'; grid[15][21] = '#fef08a'; // Bell leading the charge forward!

    // Rear Sul Tread: Swung forward on hydraulic strut
    grid[16][5] = '#be185d'; grid[16][6] = '#db2777';
    grid[17][5] = '#9d174d'; grid[17][6] = '#334155'; grid[17][7] = '#475569';
    grid[18][6] = '#1e293b'; grid[18][7] = '#334155'; grid[18][8] = '#475569';
    grid[19][6] = '#0f172a'; grid[19][7] = '#1e293b'; grid[19][8] = '#334155';
    grid[20][7] = '#0f172a'; grid[20][8] = '#1e293b';
  } else if (f === 4) {
    // ── FRAME 4: HOPSA DESCENT REACH (Vorbereitung auf den Boden) ──
    // Front Jester Leg: Dropping down with toes reaching forward-down for landing
    grid[16][10] = '#7c3aed'; grid[16][11] = '#6b21a8';
    grid[17][11] = '#65a30d'; grid[17][12] = '#84cc16'; grid[17][13] = '#4d7c0f';
    grid[18][12] = '#7c3aed'; grid[18][13] = '#6b21a8'; grid[18][14] = '#7c3aed';
    grid[19][13] = '#ca8a04'; grid[19][14] = '#eab308'; grid[19][15] = '#f59e0b';
    grid[20][14] = '#fbbf24'; grid[20][15] = '#ca8a04'; grid[20][16] = '#eab308';
    grid[19][17] = '#fbbf24'; // Toe tip reaching for floor

    // Rear Sul Tread: Leveling out horizontally parallel to ground
    grid[16][6] = '#be185d'; grid[16][7] = '#9d174d';
    grid[17][5] = '#db2777'; grid[17][6] = '#be185d';
    grid[18][5] = '#334155'; grid[18][6] = '#475569'; grid[18][7] = '#334155';
    grid[19][5] = '#1e293b'; grid[19][6] = '#334155'; grid[19][7] = '#475569'; grid[19][8] = '#1e293b';
    grid[20][5] = '#0f172a'; grid[20][6] = '#1e293b'; grid[20][7] = '#334155'; grid[20][8] = '#475569';
  } else {
    // ── FRAME 5: HOPSA SQUASH & REBOUND SKID (Tiefe elastische Kniebeuge & Bodenkontakt) ──
    // Front Jester Leg: Deep comedic knee bend forward, foot squashed flat on ground
    grid[16][10] = '#7c3aed'; grid[16][11] = '#6b21a8'; grid[16][12] = '#eab308';
    grid[17][12] = '#7c3aed'; grid[17][13] = '#84cc16'; grid[17][14] = '#65a30d'; // Knee splaying forward
    grid[18][13] = '#65a30d'; grid[18][14] = '#4d7c0f'; grid[18][15] = '#7c3aed';
    grid[19][13] = '#ca8a04'; grid[19][14] = '#eab308'; grid[19][15] = '#f59e0b'; grid[19][16] = '#ca8a04';
    grid[20][13] = '#fbbf24'; grid[20][14] = '#f59e0b'; grid[20][15] = '#eab308'; // Shoe squashed flat
    grid[19][17] = '#fbbf24'; grid[18][17] = '#fef08a'; // Bell pointing up on ground

    // Rear Sul Tread: Heavy compressed impact, track links grinding on ground with sparks
    grid[16][5] = '#9d174d'; grid[16][6] = '#db2777';
    grid[17][4] = '#be185d'; grid[17][5] = '#9d174d';
    grid[18][4] = '#334155'; grid[18][5] = '#475569'; grid[18][6] = '#334155';
    grid[19][3] = '#0f172a'; grid[19][4] = '#1e293b'; grid[19][5] = '#334155'; grid[19][6] = '#475569'; grid[19][7] = '#f59e0b';
    grid[20][2] = '#fbbf24'; grid[20][3] = '#0f172a'; grid[20][4] = '#1e293b'; grid[20][5] = '#334155'; grid[20][6] = '#475569'; // Ground friction sparks shooting backwards!
  }
}

function getHD_Pulp_Head() {
  const g = 24, grid = makeGrid();
  _paintHD_Pulp_Head(grid);
  return { grid, gridSize: g };
}

function getHD_Pulp_Body() {
  const g = 24, grid = makeGrid();
  _paintHD_Pulp_Body(grid);
  return { grid, gridSize: g };
}

function getHD_Pulp_Weapon() {
  const g = 24, grid = makeGrid();
  _paintHD_Pulp_Weapon(grid);
  return { grid, gridSize: g };
}

function getHD_Pulp_Legs_Walk1() {
  const g = 24, grid = makeGrid();
  _paintHD_Pulp_Legs(grid, 0);
  return { grid, gridSize: g };
}

function getHD_Pulp_Legs_Walk2() {
  const g = 24, grid = makeGrid();
  _paintHD_Pulp_Legs(grid, 1);
  return { grid, gridSize: g };
}

function getHD_Pulp_Legs_Walk3() {
  const g = 24, grid = makeGrid();
  _paintHD_Pulp_Legs(grid, 2);
  return { grid, gridSize: g };
}

function getHD_Pulp_Legs_Walk4() {
  const g = 24, grid = makeGrid();
  _paintHD_Pulp_Legs(grid, 3);
  return { grid, gridSize: g };
}

function getHD_Pulp_Legs_Walk5() {
  const g = 24, grid = makeGrid();
  _paintHD_Pulp_Legs(grid, 4);
  return { grid, gridSize: g };
}

function getHD_Pulp_Legs_Walk6() {
  const g = 24, grid = makeGrid();
  _paintHD_Pulp_Legs(grid, 5);
  return { grid, gridSize: g };
}

function getHD_Pulp() {
  const g = 24, grid = makeGrid();
  _paintHD_Pulp_Weapon(grid); // 1. Far/rear shoulder mortar in background
  _paintHD_Pulp_Legs(grid, 0); // 2. Legs
  _paintHD_Pulp_Body(grid);    // 3. Torso & front arm scepter
  _paintHD_Pulp_Head(grid);    // 4. Articulated clown head in foreground
  return { grid, gridSize: g };
}

function _composePulpHop(legIdx) {
  const g = 24, grid = makeGrid();
  _paintHD_Pulp_Weapon(grid);
  _paintHD_Pulp_Legs(grid, legIdx);
  _paintHD_Pulp_Body(grid);
  _paintHD_Pulp_Head(grid);
  return { grid, gridSize: g };
}
function getHD_Pulp_Hop1() { return _composePulpHop(0); }
function getHD_Pulp_Hop2() { return _composePulpHop(1); }
function getHD_Pulp_Hop3() { return _composePulpHop(2); }
function getHD_Pulp_Hop4() { return _composePulpHop(3); }
function getHD_Pulp_Hop5() { return _composePulpHop(4); }
function getHD_Pulp_Hop6() { return _composePulpHop(5); }


// ── PRESERVER LOCK (48×48 UHD TIER L HEXAPOD TITAN) ──────────
// Tier 2 Sul Heavy Mech-Panzer: Six-legged biomechanical colossus with a high neck mast,
// suspended glowing plasma orb at summit, elongated Xenomorph cranial horn crest,
// concentric mechanical hip joint (Power Disc) and 6 articulated tripod-gait legs.

const _PL_C = {
  OUTLINE:       '#020617',
  CORE_W:        '#ffffff',
  CYAN_SPEC:     '#f0f9ff',
  CYAN_HI:       '#e0f2fe',
  CYAN_MED:      '#7dd3fc',
  CYAN_GLW:      '#38bdf8',
  CYAN_DRK:      '#0284c7',
  CYAN_DEEP:     '#0369a1',

  // Anthracite & Cold Slate
  ANTH_DEEP:     '#090d16',
  ANTH_DARK:     '#0f172a',
  ANTH_BASE:     '#151d2d',
  ANTH_MID:      '#1e293b',
  ANTH_SLATE:    '#334155',
  ANTH_LGT:      '#475569',
  ANTH_RIM:      '#64748b',
  ANTH_SPEC:     '#94a3b8',

  // Biomechanical Chitin & Bone Ivory Accents
  CHITIN_PALE:   '#f1f5f9',
  CHITIN_H:      '#cbd5e1',
  CHITIN_M:      '#94a3b8',
  CHITIN_D:      '#64748b',
  SHADOW_TRENCH: '#050811',
  TEAM:          'TEAM',

  // Hazard Amber & Gold Knee Joints
  KNEE_DRK:      '#713f12',
  KNEE_MID:      '#854d0e',
  KNEE_AMB:      '#a16207',
  KNEE_GLD:      '#ca8a04',
  KNEE_HI:       '#eab308',
  KNEE_BRT:      '#facc15',
  KNEE_SPEC:     '#fef08a'
};

function _paintHD_PreserverLock_Tower(grid, cablePhase = 0) {
  const {
    OUTLINE, CORE_W, CYAN_SPEC, CYAN_HI, CYAN_MED, CYAN_GLW, CYAN_DRK,
    ANTH_DEEP, ANTH_BASE, ANTH_MID, ANTH_SLATE, ANTH_LGT, ANTH_RIM,
    CHITIN_H
  } = _PL_C;

  // ───────────────────────────────────────────────────────────────────────────
  // A. GLOWING SPHERICAL EMITTER ORB (Rows 0-6, Centered at x: 24, y: 3)
  // Perfectly circular perimeter with luminous gradient and corona
  // ───────────────────────────────────────────────────────────────────────────

  // Row 0: Top central vertical needle spike & crown dome curve (Cols 23-25)
  grid[0][24] = CORE_W;
  grid[0][23] = CYAN_HI; grid[0][25] = CYAN_HI;

  // Row 1: Upper sphere dome curve (Cols 21-27) & Angled Spikes (Cols 19, 29)
  grid[1][19] = CYAN_GLW; // Angled needle spike (~10 o clock)
  grid[1][21] = OUTLINE;  grid[1][22] = CYAN_MED;  grid[1][23] = CYAN_HI;
  grid[1][24] = CORE_W;
  grid[1][25] = CYAN_HI;  grid[1][26] = CYAN_MED;  grid[1][27] = OUTLINE;
  grid[1][29] = CYAN_GLW; // Angled needle spike (~2 o clock)

  // Row 2: Upper hemisphere (Cols 20-28)
  grid[2][20] = OUTLINE;
  grid[2][21] = CYAN_GLW; grid[2][22] = CORE_W;    grid[2][23] = CYAN_SPEC;
  grid[2][24] = CORE_W;
  grid[2][25] = CYAN_SPEC; grid[2][26] = CORE_W;   grid[2][27] = CYAN_GLW;
  grid[2][28] = OUTLINE;

  // Row 3: Equator & Twin Spotlight Cores (TEST ANCHORS: grid[3][22] === '#ffffff', grid[3][26] === '#ffffff')
  // Horizontal flare rays:
  grid[3][16] = CYAN_GLW; grid[3][17] = CYAN_HI; grid[3][18] = CYAN_SPEC;
  grid[3][19] = OUTLINE;
  grid[3][20] = CYAN_GLW; grid[3][21] = CYAN_HI;   grid[3][22] = CORE_W; grid[3][23] = CYAN_HI;
  grid[3][24] = CORE_W;   // Blazing white center bridge
  grid[3][25] = CYAN_HI;  grid[3][26] = CORE_W;    grid[3][27] = CYAN_HI; grid[3][28] = CYAN_GLW;
  grid[3][29] = OUTLINE;
  grid[3][30] = CYAN_SPEC; grid[3][31] = CYAN_HI;  grid[3][32] = CYAN_GLW;

  // Row 4: Lower hemisphere (Cols 20-28)
  grid[4][20] = OUTLINE;
  grid[4][21] = CYAN_DRK; grid[4][22] = CYAN_MED;  grid[4][23] = CYAN_GLW;
  grid[4][24] = CYAN_MED;
  grid[4][25] = CYAN_GLW; grid[4][26] = CYAN_MED;  grid[4][27] = CYAN_DRK;
  grid[4][28] = OUTLINE;

  // Row 5: Lower sphere curve (Cols 21-27) & Downward diagonal spikes
  grid[5][19] = CYAN_GLW; // Down-left spike (~8 o clock)
  grid[5][21] = OUTLINE;  grid[5][22] = CYAN_DRK;  grid[5][23] = ANTH_SLATE;
  grid[5][24] = ANTH_RIM;
  grid[5][25] = ANTH_SLATE; grid[5][26] = CYAN_DRK; grid[5][27] = OUTLINE;
  grid[5][29] = CYAN_GLW; // Down-right spike (~4 o clock)

  // Row 6: Spherical bottom rim & cable attachment hub (Cols 23-25)
  grid[6][23] = OUTLINE;  grid[6][24] = ANTH_BASE; grid[6][25] = OUTLINE;

  // ───────────────────────────────────────────────────────────────────────────
  // B. FILIGREE VERTEBRAL SPINE MAST (Rows 7 to 22, Cols 24-26)
  // Slender, organic vertebra column - ONLY 2-3 PIXELS WIDE!
  // ───────────────────────────────────────────────────────────────────────────
  for (let y = 7; y <= 22; y++) {
    // Slender spine at cols 24-26:
    // Twists gently: y: 7-11 at col 24-25, y: 12-16 at col 25-26, y: 17-22 at col 24-25
    let sx = (y >= 12 && y <= 16) ? 25 : 24;
    const isVertebraRidge = (y % 3 === 0);

    grid[y][sx]     = isVertebraRidge ? ANTH_RIM : ANTH_SLATE;
    grid[y][sx + 1] = isVertebraRidge ? CHITIN_H : ANTH_LGT;
    grid[y][sx + 2] = OUTLINE;
  }

  // Row 23: Spine root entering the carapace collar
  grid[23][24] = ANTH_BASE; grid[23][25] = ANTH_SLATE; grid[23][26] = OUTLINE;

  // ───────────────────────────────────────────────────────────────────────────
  // C. DISTINCT HANGING CABLES (Rows 6 to 22)
  // Attached to underside of sphere (Cols 21-22), hanging down with visible air
  // between the cables and the spine!
  // cablePhase allows dynamic sway when walking!
  // ───────────────────────────────────────────────────────────────────────────
  for (let y = 6; y <= 22; y++) {
    // Normalized height: 0 at sphere, 1 at collar
    const prog = (y - 6) / 16;
    // Parabolic catenary hang curve with dynamic sway offset
    const sway = Math.sin(prog * Math.PI) * cablePhase;
    const cx1 = Math.round(20.5 + sway);
    const cx2 = Math.round(21.5 + sway);

    // Cable 1: Outer tension cable
    if (cx1 >= 0 && cx1 < 48) {
      grid[y][cx1] = (y % 4 === 1) ? CYAN_GLW : ((y % 2 === 0) ? ANTH_SLATE : ANTH_DEEP);
    }
    // Cable 2: Inner conduit cable with bright cyan fiber pulses
    if (cx2 >= 0 && cx2 < 48 && cx2 !== cx1) {
      grid[y][cx2] = (y % 3 === 0) ? CYAN_HI : ((y % 2 === 0) ? ANTH_RIM : ANTH_BASE);
    }
  }
}

/**
 * 2. PRESERVER LOCK CARAPACE ("Kopfartige Panzerung")
 * - Completely removed the floating back element per user request!
 * - Sweeping diagonal Xenomorph skull / crest pointing to top-left (rows 9-22, cols 6-25)
 * - Concentric spherical hip joint / Power Disc (cols 2-10, rows 25-31)
 * - Front collar / cradle cup (cols 27-32, rows 19-24) where the tower rises out
 * - Central chestplate with glowing TEAM power crystal (grid[25][24] === 'TEAM')
 * - Full-span underbelly girder anchoring to all 8 legs seamlessly
 */

function _paintHD_PreserverLock_Carapace(grid) {
  const {
    OUTLINE, CORE_W, ANTH_DEEP, ANTH_BASE, ANTH_MID, ANTH_SLATE, ANTH_LGT, ANTH_RIM, ANTH_SPEC,
    CHITIN_PALE, CHITIN_H, CHITIN_M, SHADOW_TRENCH, TEAM
  } = _PL_C;

  // NOTE: The floating back element (rows 16-22, cols 3-8) has been COMPLETELY REMOVED
  // per user instruction: "entferne das im rücken schwebende element gänzlich".

  // ───────────────────────────────────────────────────────────────────────────
  // A. ELONGATED XENOMORPH-LIKE CRANIAL CREST (Rows 9 to 23)
  // Slopes diagonally at ~35° from horn apex (x: 6-9, y: 9) down-forward to collar (x: 23, y: 20)
  // ───────────────────────────────────────────────────────────────────────────

  // Row 9: Snout / Apex Tip of Cranial Horn
  grid[9][6]  = OUTLINE; grid[9][7]  = CHITIN_PALE; grid[9][8]  = CHITIN_H; grid[9][9]  = OUTLINE;

  // Row 10: Horn tip expansion
  grid[10][6] = OUTLINE; grid[10][7] = CHITIN_H; grid[10][8] = ANTH_RIM; grid[10][9] = ANTH_SLATE; grid[10][10] = OUTLINE;

  // Row 11: Top dorsal ridge & upper flute
  grid[11][7] = OUTLINE; grid[11][8] = CHITIN_H; grid[11][9] = ANTH_RIM; grid[11][10] = ANTH_LGT; grid[11][11] = ANTH_SLATE; grid[11][12] = OUTLINE;

  // Row 12: Sleek dorsal bone crest & horizontal flute groove
  grid[12][7] = OUTLINE; grid[12][8] = CHITIN_H; grid[12][9] = ANTH_RIM; grid[12][10] = ANTH_SLATE;
  grid[12][11] = SHADOW_TRENCH; grid[12][12] = ANTH_SLATE; grid[12][13] = ANTH_LGT; grid[12][14] = OUTLINE;

  // Row 13: Dorsal bone ridge + Lacuna Pore #1 (Cols 11-13)
  grid[13][8] = OUTLINE; grid[13][9] = CHITIN_H; grid[13][10] = ANTH_RIM; grid[13][11] = ANTH_MID;
  grid[13][12] = SHADOW_TRENCH; grid[13][13] = SHADOW_TRENCH; grid[13][14] = ANTH_SLATE; grid[13][15] = CHITIN_M; grid[13][16] = OUTLINE;

  // Row 14: Mid-skull bone bridge & lower edge of lacuna #1
  grid[14][8] = OUTLINE; grid[14][9] = CHITIN_H; grid[14][10] = ANTH_RIM; grid[14][11] = ANTH_SLATE;
  grid[14][12] = ANTH_BASE; grid[14][13] = ANTH_SLATE; grid[14][14] = CHITIN_M; grid[14][15] = ANTH_RIM; grid[14][16] = ANTH_SLATE; grid[14][17] = OUTLINE;

  // Row 15: Ribbed horizontal flute & Lacuna Pore #2 (Cols 14-16)
  grid[15][9]  = OUTLINE; grid[15][10] = CHITIN_H; grid[15][11] = ANTH_RIM; grid[15][12] = ANTH_SLATE;
  grid[15][13] = ANTH_MID; grid[15][14] = SHADOW_TRENCH; grid[15][15] = SHADOW_TRENCH; grid[15][16] = ANTH_MID;
  grid[15][17] = ANTH_SLATE; grid[15][18] = CHITIN_M; grid[15][19] = OUTLINE;

  // Row 16:
  grid[16][10] = OUTLINE; grid[16][11] = CHITIN_H; grid[16][12] = ANTH_RIM; grid[16][13] = ANTH_SLATE;
  grid[16][14] = ANTH_BASE; grid[16][15] = ANTH_SLATE; grid[16][16] = CHITIN_M; grid[16][17] = ANTH_RIM;
  grid[16][18] = ANTH_SLATE; grid[16][19] = ANTH_MID; grid[16][20] = OUTLINE;

  // Row 17: Widening lower skull & striated cheek arches
  grid[17][10] = OUTLINE; grid[17][11] = ANTH_RIM; grid[17][12] = ANTH_SLATE; grid[17][13] = ANTH_MID;
  grid[17][14] = SHADOW_TRENCH; grid[17][15] = ANTH_SLATE; grid[17][16] = CHITIN_M; grid[17][17] = ANTH_RIM;
  grid[17][18] = ANTH_SLATE; grid[17][19] = ANTH_MID; grid[17][20] = ANTH_DEEP; grid[17][21] = OUTLINE;

  // Row 18:
  grid[18][11] = OUTLINE; grid[18][12] = ANTH_SLATE; grid[18][13] = ANTH_MID; grid[18][14] = ANTH_BASE;
  grid[18][15] = ANTH_SLATE; grid[18][16] = CHITIN_M; grid[18][17] = ANTH_SLATE; grid[18][18] = ANTH_MID;
  grid[18][19] = SHADOW_TRENCH; grid[18][20] = ANTH_SLATE; grid[18][21] = CHITIN_M; grid[18][22] = OUTLINE;

  // Row 19: Lower cranial flank & Front Cradle Lip Tip (Cols 29-31)
  grid[19][11] = OUTLINE; grid[19][12] = ANTH_SLATE; grid[19][13] = ANTH_MID; grid[19][14] = ANTH_BASE;
  grid[19][15] = ANTH_SLATE; grid[19][16] = ANTH_LGT; grid[19][17] = ANTH_SLATE; grid[19][18] = ANTH_MID;
  grid[19][19] = ANTH_BASE; grid[19][20] = ANTH_SLATE; grid[19][21] = ANTH_LGT; grid[19][22] = ANTH_MID; grid[19][23] = OUTLINE;
  // Front Cradle Lip Tip (Cols 29-31): curling upward like a chalice around tower base
  grid[19][29] = OUTLINE; grid[19][30] = CHITIN_H; grid[19][31] = OUTLINE;

  // Row 20: Collar Rim & Socket Opening (Cols 20-28)
  grid[20][10] = OUTLINE; grid[20][11] = ANTH_SLATE; grid[20][12] = ANTH_MID; grid[20][13] = ANTH_BASE;
  grid[20][14] = ANTH_SLATE; grid[20][15] = ANTH_LGT; grid[20][16] = ANTH_SLATE; grid[20][17] = ANTH_MID;
  grid[20][18] = ANTH_BASE; grid[20][19] = ANTH_SLATE; grid[20][20] = ANTH_DEEP; grid[20][21] = OUTLINE;
  // Front Cradle Lip
  grid[20][29] = OUTLINE; grid[20][30] = ANTH_RIM; grid[20][31] = ANTH_SLATE; grid[20][32] = OUTLINE;

  // Row 21:
  grid[21][9]  = OUTLINE; grid[21][10] = ANTH_SLATE; grid[21][11] = ANTH_MID; grid[21][12] = ANTH_BASE;
  grid[21][13] = ANTH_SLATE; grid[21][14] = ANTH_LGT; grid[21][15] = ANTH_SLATE; grid[21][16] = ANTH_MID;
  grid[21][17] = ANTH_BASE; grid[21][18] = ANTH_SLATE; grid[21][19] = ANTH_BASE; grid[21][20] = OUTLINE;
  // Front Cradle Prow
  grid[21][28] = OUTLINE; grid[21][29] = ANTH_SLATE; grid[21][30] = ANTH_LGT; grid[21][31] = ANTH_SLATE; grid[21][32] = OUTLINE;

  // Row 22:
  grid[22][8]  = OUTLINE; grid[22][9]  = ANTH_SLATE; grid[22][10] = ANTH_MID; grid[22][11] = ANTH_BASE;
  grid[22][12] = ANTH_SLATE; grid[22][13] = ANTH_LGT; grid[22][14] = ANTH_SLATE; grid[22][15] = ANTH_MID;
  grid[22][16] = ANTH_BASE; grid[22][17] = ANTH_SLATE; grid[22][18] = ANTH_LGT; grid[22][19] = ANTH_BASE; grid[22][20] = OUTLINE;
  // Front Cradle Prow
  grid[22][28] = OUTLINE; grid[22][29] = ANTH_BASE; grid[22][30] = ANTH_SLATE; grid[22][31] = ANTH_MID; grid[22][32] = OUTLINE;

  // Row 23: Thorax expansion & Cradle base
  grid[23][7]  = OUTLINE; grid[23][8]  = ANTH_BASE; grid[23][9]  = ANTH_MID; grid[23][10] = ANTH_SLATE;
  grid[23][11] = ANTH_LGT; grid[23][12] = ANTH_RIM; grid[23][13] = ANTH_LGT; grid[23][14] = ANTH_SLATE;
  grid[23][15] = ANTH_MID; grid[23][16] = ANTH_BASE; grid[23][17] = ANTH_SLATE; grid[23][18] = ANTH_LGT;
  grid[23][19] = ANTH_SLATE; grid[23][20] = ANTH_BASE; grid[23][21] = ANTH_DEEP;
  grid[23][27] = OUTLINE; grid[23][28] = ANTH_BASE; grid[23][29] = ANTH_SLATE; grid[23][30] = ANTH_MID;
  grid[23][31] = ANTH_BASE; grid[23][32] = OUTLINE;

  // ───────────────────────────────────────────────────────────────────────────
  // B. VENTRAL CHESTPLATE & GLOWING TEAM POWER CRYSTAL (Rows 24-27)
  // Test requirement: grid[25][24] === 'TEAM'
  // ───────────────────────────────────────────────────────────────────────────

  // Row 24: Upper Chestplate & crystal aperture
  grid[24][7]  = OUTLINE; grid[24][8]  = ANTH_BASE; grid[24][9]  = ANTH_MID; grid[24][10] = ANTH_SLATE;
  grid[24][11] = ANTH_LGT; grid[24][12] = ANTH_RIM; grid[24][13] = ANTH_LGT; grid[24][14] = ANTH_SLATE;
  grid[24][15] = ANTH_MID; grid[24][16] = ANTH_BASE; grid[24][17] = ANTH_SLATE; grid[24][18] = ANTH_LGT;
  grid[24][19] = ANTH_BASE; grid[24][20] = ANTH_DEEP;
  grid[24][21] = TEAM; grid[24][22] = TEAM; grid[24][23] = TEAM; grid[24][24] = TEAM;
  grid[24][25] = ANTH_DEEP; grid[24][26] = ANTH_BASE; grid[24][27] = ANTH_SLATE; grid[24][28] = ANTH_LGT;
  grid[24][29] = ANTH_MID; grid[24][30] = ANTH_SLATE; grid[24][31] = ANTH_BASE; grid[24][32] = OUTLINE;

  // Row 25: Central Chestplate with Glowing TEAM Crystal Matrix (TEST ANCHOR: grid[25][24] === 'TEAM')
  grid[25][7]  = OUTLINE; grid[25][8]  = ANTH_BASE; grid[25][9]  = ANTH_MID; grid[25][10] = ANTH_SLATE;
  grid[25][11] = ANTH_LGT; grid[25][12] = ANTH_RIM; grid[25][13] = ANTH_LGT; grid[25][14] = ANTH_SLATE;
  grid[25][15] = ANTH_MID; grid[25][16] = ANTH_BASE; grid[25][17] = ANTH_SLATE; grid[25][18] = ANTH_LGT;
  grid[25][19] = ANTH_MID; grid[25][20] = ANTH_DEEP;
  grid[25][21] = TEAM; grid[25][22] = TEAM; grid[25][23] = TEAM; grid[25][24] = TEAM; grid[25][25] = TEAM;
  grid[25][26] = ANTH_DEEP; grid[25][27] = ANTH_BASE; grid[25][28] = ANTH_SLATE; grid[25][29] = ANTH_LGT;
  grid[25][30] = ANTH_SLATE; grid[25][31] = ANTH_BASE; grid[25][32] = OUTLINE;

  // Row 26: Lower Chestplate & Abdominal belly
  grid[26][10] = OUTLINE; grid[26][11] = ANTH_BASE; grid[26][12] = ANTH_MID; grid[26][13] = ANTH_SLATE;
  grid[26][14] = ANTH_LGT; grid[26][15] = ANTH_MID; grid[26][16] = ANTH_BASE; grid[26][17] = ANTH_SLATE;
  grid[26][18] = ANTH_LGT; grid[26][19] = ANTH_BASE; grid[26][20] = ANTH_DEEP;
  grid[26][21] = TEAM; grid[26][22] = TEAM; grid[26][23] = TEAM; grid[26][24] = ANTH_DEEP;
  grid[26][25] = ANTH_BASE; grid[26][26] = ANTH_SLATE; grid[26][27] = ANTH_LGT; grid[26][28] = ANTH_MID;
  grid[26][29] = ANTH_BASE; grid[26][30] = OUTLINE;

  // Row 27: Lower Torso Chassis & Leg Attachment Anchors (seamless bridge to col 35)
  grid[27][10] = OUTLINE; grid[27][11] = ANTH_BASE; grid[27][12] = ANTH_SLATE; grid[27][13] = ANTH_LGT;
  grid[27][14] = ANTH_RIM; grid[27][15] = ANTH_LGT; grid[27][16] = ANTH_SLATE; grid[27][17] = ANTH_BASE;
  grid[27][18] = ANTH_DEEP; grid[27][19] = ANTH_BASE; grid[27][20] = ANTH_SLATE; grid[27][21] = ANTH_LGT;
  grid[27][22] = ANTH_SLATE; grid[27][23] = ANTH_BASE; grid[27][24] = ANTH_DEEP; grid[27][25] = ANTH_BASE;
  grid[27][26] = ANTH_SLATE; grid[27][27] = ANTH_LGT; grid[27][28] = ANTH_SLATE; grid[27][29] = ANTH_BASE;
  grid[27][30] = ANTH_DEEP; grid[27][31] = ANTH_BASE; grid[27][32] = ANTH_SLATE; grid[27][33] = ANTH_BASE;
  grid[27][34] = ANTH_DEEP; grid[27][35] = OUTLINE;

  // Row 28: Underbelly Girder
  grid[28][10] = OUTLINE; grid[28][11] = ANTH_DEEP; grid[28][12] = ANTH_BASE; grid[28][13] = ANTH_SLATE;
  grid[28][14] = ANTH_SLATE; grid[28][15] = ANTH_BASE; grid[28][16] = ANTH_DEEP; grid[28][17] = ANTH_DEEP;
  grid[28][18] = ANTH_BASE; grid[28][19] = ANTH_SLATE; grid[28][20] = ANTH_DEEP; grid[28][21] = ANTH_DEEP;
  grid[28][22] = ANTH_BASE; grid[28][23] = ANTH_SLATE; grid[28][24] = ANTH_DEEP; grid[28][25] = ANTH_DEEP;
  grid[28][26] = ANTH_BASE; grid[28][27] = ANTH_SLATE; grid[28][28] = ANTH_DEEP; grid[28][29] = OUTLINE;
  grid[28][31] = OUTLINE; grid[28][32] = ANTH_BASE; grid[28][33] = ANTH_DEEP; grid[28][34] = OUTLINE;

  // Row 29: Underbelly Hydraulics
  grid[29][11] = OUTLINE; grid[29][12] = ANTH_DEEP; grid[29][13] = ANTH_BASE; grid[29][14] = ANTH_DEEP;
  grid[29][15] = OUTLINE; grid[29][17] = OUTLINE; grid[29][18] = ANTH_DEEP; grid[29][19] = ANTH_BASE;
  grid[29][20] = OUTLINE; grid[29][22] = OUTLINE; grid[29][23] = ANTH_DEEP; grid[29][24] = OUTLINE;

  // ───────────────────────────────────────────────────────────────────────────
  // C. CIRCULAR HIP JOINT / POWER DISC (Rows 25-31, Cols 2-10)
  // ───────────────────────────────────────────────────────────────────────────
  grid[25][4] = OUTLINE; grid[25][5] = ANTH_DEEP; grid[25][6] = ANTH_SLATE; grid[25][7] = ANTH_DEEP; grid[25][8] = OUTLINE;

  grid[26][3] = OUTLINE; grid[26][4] = ANTH_DEEP; grid[26][5] = ANTH_LGT;   grid[26][6] = CHITIN_H;
  grid[26][7] = ANTH_LGT; grid[26][8] = ANTH_DEEP; grid[26][9] = OUTLINE;

  grid[27][2] = OUTLINE; grid[27][3] = ANTH_DEEP; grid[27][4] = ANTH_SLATE; grid[27][5] = CHITIN_H;
  grid[27][6] = CORE_W;  grid[27][7] = CHITIN_H;  grid[27][8] = ANTH_SLATE; grid[27][9] = ANTH_DEEP; grid[27][10] = OUTLINE;

  grid[28][2] = OUTLINE; grid[28][3] = ANTH_DEEP; grid[28][4] = ANTH_SLATE; grid[28][5] = CHITIN_H;
  grid[28][6] = CHITIN_M; grid[28][7] = ANTH_LGT;  grid[28][8] = ANTH_SLATE; grid[28][9] = ANTH_DEEP; grid[28][10] = OUTLINE;

  grid[29][3] = OUTLINE; grid[29][4] = ANTH_DEEP; grid[29][5] = ANTH_BASE;  grid[29][6] = ANTH_SLATE;
  grid[29][7] = ANTH_BASE; grid[29][8] = ANTH_DEEP; grid[29][9] = OUTLINE;

  grid[30][4] = OUTLINE; grid[30][5] = ANTH_DEEP; grid[30][6] = ANTH_DEEP; grid[30][7] = OUTLINE;
}

function _paintHD_PreserverLock_Legs(grid, walkPhase = 0) {
  if (walkPhase === 1) {
    // Phase 1: Tripod A (front-left, mid-right, rear-left) swinging forward & lifted
    grid[28][35] = _PL_C.KNEE_GLD; grid[28][36] = _PL_C.KNEE_BRT;
    grid[29][16] = _PL_C.ANTH_LGT; grid[29][25] = _PL_C.ANTH_MID; grid[29][26] = _PL_C.KNEE_AMB; grid[29][27] = _PL_C.KNEE_GLD; grid[29][28] = _PL_C.KNEE_BRT; grid[29][33] = _PL_C.OUTLINE; grid[29][34] = _PL_C.OUTLINE; grid[29][35] = _PL_C.OUTLINE; grid[29][36] = _PL_C.KNEE_BRT; grid[29][37] = _PL_C.KNEE_HI; grid[29][38] = _PL_C.KNEE_GLD;
    grid[30][0] = _PL_C.KNEE_AMB; grid[30][1] = _PL_C.KNEE_GLD; grid[30][2] = _PL_C.KNEE_HI; grid[30][3] = _PL_C.KNEE_DRK; grid[30][8] = _PL_C.ANTH_LGT; grid[30][9] = _PL_C.ANTH_MID; grid[30][11] = _PL_C.KNEE_AMB; grid[30][12] = _PL_C.KNEE_GLD; grid[30][13] = _PL_C.OUTLINE; grid[30][14] = _PL_C.KNEE_SPEC; grid[30][15] = _PL_C.KNEE_HI; grid[30][16] = _PL_C.KNEE_GLD; grid[30][17] = _PL_C.KNEE_GLD; grid[30][24] = _PL_C.OUTLINE; grid[30][25] = _PL_C.KNEE_SPEC; grid[30][26] = _PL_C.KNEE_HI; grid[30][27] = _PL_C.KNEE_GLD; grid[30][28] = _PL_C.KNEE_AMB; grid[30][29] = _PL_C.KNEE_GLD; grid[30][30] = _PL_C.KNEE_HI; grid[30][36] = _PL_C.OUTLINE; grid[30][37] = _PL_C.OUTLINE; grid[30][38] = _PL_C.OUTLINE; grid[30][39] = _PL_C.OUTLINE; grid[30][40] = _PL_C.KNEE_BRT; grid[30][41] = _PL_C.KNEE_HI; grid[30][42] = _PL_C.KNEE_GLD;
    grid[31][0] = _PL_C.ANTH_DARK; grid[31][1] = _PL_C.KNEE_HI; grid[31][6] = _PL_C.OUTLINE; grid[31][7] = _PL_C.KNEE_SPEC; grid[31][8] = _PL_C.KNEE_HI; grid[31][9] = _PL_C.KNEE_GLD; grid[31][11] = _PL_C.OUTLINE; grid[31][12] = _PL_C.KNEE_BRT; grid[31][13] = _PL_C.KNEE_HI; grid[31][14] = _PL_C.KNEE_GLD; grid[31][24] = _PL_C.OUTLINE; grid[31][25] = _PL_C.KNEE_SPEC; grid[31][26] = _PL_C.KNEE_HI; grid[31][27] = _PL_C.KNEE_GLD; grid[31][29] = _PL_C.KNEE_AMB; grid[31][30] = _PL_C.ANTH_DARK; grid[31][31] = _PL_C.OUTLINE; grid[31][32] = _PL_C.KNEE_HI; grid[31][39] = _PL_C.OUTLINE; grid[31][40] = _PL_C.OUTLINE; grid[31][41] = _PL_C.OUTLINE; grid[31][42] = _PL_C.KNEE_BRT; grid[31][43] = _PL_C.OUTLINE; grid[31][44] = _PL_C.ANTH_MID;
    grid[32][0] = _PL_C.OUTLINE; grid[32][5] = _PL_C.OUTLINE; grid[32][6] = _PL_C.KNEE_BRT; grid[32][7] = _PL_C.KNEE_HI; grid[32][8] = _PL_C.KNEE_GLD; grid[32][9] = _PL_C.OUTLINE; grid[32][10] = _PL_C.KNEE_BRT; grid[32][11] = _PL_C.OUTLINE; grid[32][12] = _PL_C.ANTH_MID; grid[32][13] = _PL_C.KNEE_GLD; grid[32][25] = _PL_C.OUTLINE; grid[32][26] = _PL_C.KNEE_MID; grid[32][27] = _PL_C.OUTLINE; grid[32][30] = _PL_C.OUTLINE; grid[32][31] = _PL_C.ANTH_MID; grid[32][32] = _PL_C.ANTH_LGT; grid[32][39] = _PL_C.KNEE_AMB; grid[32][40] = _PL_C.KNEE_AMB; grid[32][41] = _PL_C.OUTLINE; grid[32][42] = _PL_C.ANTH_RIM; grid[32][43] = _PL_C.ANTH_SLATE; grid[32][44] = _PL_C.OUTLINE;
    grid[33][0] = _PL_C.OUTLINE; grid[33][5] = _PL_C.OUTLINE; grid[33][6] = _PL_C.KNEE_MID; grid[33][7] = _PL_C.OUTLINE; grid[33][9] = _PL_C.OUTLINE; grid[33][10] = _PL_C.ANTH_LGT; grid[33][11] = _PL_C.ANTH_MID; grid[33][12] = _PL_C.OUTLINE; grid[33][26] = _PL_C.OUTLINE; grid[33][27] = _PL_C.KNEE_BRT; grid[33][28] = _PL_C.KNEE_HI; grid[33][29] = _PL_C.KNEE_GLD; grid[33][30] = _PL_C.OUTLINE; grid[33][31] = _PL_C.ANTH_DARK; grid[33][32] = _PL_C.ANTH_SLATE; grid[33][41] = _PL_C.ANTH_DARK; grid[33][42] = _PL_C.OUTLINE; grid[33][43] = _PL_C.ANTH_LGT; grid[33][44] = _PL_C.ANTH_MID; grid[33][45] = _PL_C.OUTLINE;
    grid[34][0] = _PL_C.OUTLINE; grid[34][4] = _PL_C.OUTLINE; grid[34][5] = _PL_C.KNEE_BRT; grid[34][6] = _PL_C.KNEE_HI; grid[34][7] = _PL_C.KNEE_GLD; grid[34][8] = _PL_C.ANTH_DARK; grid[34][9] = _PL_C.OUTLINE; grid[34][10] = _PL_C.ANTH_RIM; grid[34][11] = _PL_C.ANTH_SLATE; grid[34][12] = _PL_C.OUTLINE; grid[34][26] = _PL_C.OUTLINE; grid[34][27] = _PL_C.KNEE_BRT; grid[34][28] = _PL_C.KNEE_HI; grid[34][29] = _PL_C.KNEE_GLD; grid[34][31] = _PL_C.OUTLINE; grid[34][32] = _PL_C.ANTH_MID; grid[34][33] = _PL_C.ANTH_LGT; grid[34][41] = _PL_C.OUTLINE; grid[34][42] = _PL_C.OUTLINE; grid[34][43] = _PL_C.ANTH_RIM; grid[34][44] = _PL_C.ANTH_SLATE; grid[34][45] = _PL_C.OUTLINE;
    grid[35][0] = _PL_C.OUTLINE; grid[35][3] = _PL_C.OUTLINE; grid[35][4] = _PL_C.KNEE_BRT; grid[35][5] = _PL_C.OUTLINE; grid[35][6] = _PL_C.ANTH_MID; grid[35][8] = _PL_C.OUTLINE; grid[35][9] = _PL_C.OUTLINE; grid[35][10] = _PL_C.ANTH_LGT; grid[35][11] = _PL_C.ANTH_MID; grid[35][12] = _PL_C.OUTLINE; grid[35][27] = _PL_C.OUTLINE; grid[35][28] = _PL_C.KNEE_BRT; grid[35][29] = _PL_C.OUTLINE; grid[35][30] = _PL_C.ANTH_MID; grid[35][31] = _PL_C.OUTLINE; grid[35][32] = _PL_C.ANTH_DARK; grid[35][33] = _PL_C.ANTH_SLATE; grid[35][41] = _PL_C.OUTLINE; grid[35][42] = _PL_C.OUTLINE; grid[35][43] = _PL_C.ANTH_LGT; grid[35][44] = _PL_C.ANTH_MID; grid[35][45] = _PL_C.OUTLINE;
    grid[36][0] = _PL_C.OUTLINE; grid[36][3] = _PL_C.OUTLINE; grid[36][4] = _PL_C.ANTH_RIM; grid[36][5] = _PL_C.ANTH_SLATE; grid[36][6] = _PL_C.OUTLINE; grid[36][8] = _PL_C.OUTLINE; grid[36][9] = _PL_C.OUTLINE; grid[36][10] = _PL_C.ANTH_RIM; grid[36][11] = _PL_C.ANTH_SLATE; grid[36][12] = _PL_C.OUTLINE; grid[36][27] = _PL_C.OUTLINE; grid[36][28] = _PL_C.ANTH_RIM; grid[36][29] = _PL_C.ANTH_SLATE; grid[36][30] = _PL_C.OUTLINE; grid[36][31] = _PL_C.OUTLINE; grid[36][32] = _PL_C.ANTH_MID; grid[36][33] = _PL_C.ANTH_LGT; grid[36][42] = _PL_C.OUTLINE; grid[36][43] = _PL_C.ANTH_RIM; grid[36][44] = _PL_C.ANTH_SLATE; grid[36][45] = _PL_C.OUTLINE;
    grid[37][0] = _PL_C.OUTLINE; grid[37][3] = _PL_C.OUTLINE; grid[37][4] = _PL_C.ANTH_LGT; grid[37][5] = _PL_C.ANTH_MID; grid[37][6] = _PL_C.OUTLINE; grid[37][8] = _PL_C.OUTLINE; grid[37][9] = _PL_C.OUTLINE; grid[37][10] = _PL_C.ANTH_LGT; grid[37][11] = _PL_C.ANTH_MID; grid[37][12] = _PL_C.OUTLINE; grid[37][28] = _PL_C.OUTLINE; grid[37][29] = _PL_C.ANTH_LGT; grid[37][30] = _PL_C.ANTH_MID; grid[37][31] = _PL_C.OUTLINE; grid[37][32] = _PL_C.ANTH_DARK; grid[37][33] = _PL_C.ANTH_SLATE; grid[37][42] = _PL_C.OUTLINE; grid[37][43] = _PL_C.OUTLINE; grid[37][44] = _PL_C.ANTH_LGT; grid[37][45] = _PL_C.ANTH_MID; grid[37][46] = _PL_C.OUTLINE;
    grid[38][0] = _PL_C.OUTLINE; grid[38][3] = _PL_C.OUTLINE; grid[38][4] = _PL_C.ANTH_RIM; grid[38][5] = _PL_C.ANTH_SLATE; grid[38][6] = _PL_C.OUTLINE; grid[38][8] = _PL_C.OUTLINE; grid[38][9] = _PL_C.OUTLINE; grid[38][10] = _PL_C.ANTH_RIM; grid[38][11] = _PL_C.ANTH_SLATE; grid[38][12] = _PL_C.OUTLINE; grid[38][28] = _PL_C.OUTLINE; grid[38][29] = _PL_C.ANTH_RIM; grid[38][30] = _PL_C.ANTH_SLATE; grid[38][31] = _PL_C.OUTLINE; grid[38][32] = _PL_C.ANTH_MID; grid[38][33] = _PL_C.ANTH_LGT; grid[38][42] = _PL_C.OUTLINE; grid[38][43] = _PL_C.OUTLINE; grid[38][44] = _PL_C.ANTH_RIM; grid[38][45] = _PL_C.ANTH_SLATE; grid[38][46] = _PL_C.OUTLINE;
    grid[39][0] = _PL_C.OUTLINE; grid[39][3] = _PL_C.OUTLINE; grid[39][4] = _PL_C.ANTH_LGT; grid[39][5] = _PL_C.ANTH_MID; grid[39][6] = _PL_C.OUTLINE; grid[39][8] = _PL_C.OUTLINE; grid[39][9] = _PL_C.OUTLINE; grid[39][10] = _PL_C.ANTH_LGT; grid[39][11] = _PL_C.ANTH_MID; grid[39][12] = _PL_C.OUTLINE; grid[39][28] = _PL_C.OUTLINE; grid[39][29] = _PL_C.ANTH_LGT; grid[39][30] = _PL_C.ANTH_MID; grid[39][31] = _PL_C.OUTLINE; grid[39][32] = _PL_C.OUTLINE; grid[39][33] = _PL_C.ANTH_DARK; grid[39][34] = _PL_C.ANTH_SLATE; grid[39][42] = _PL_C.OUTLINE; grid[39][43] = _PL_C.OUTLINE; grid[39][44] = _PL_C.ANTH_LGT; grid[39][45] = _PL_C.ANTH_MID; grid[39][46] = _PL_C.OUTLINE;
    grid[40][0] = _PL_C.OUTLINE; grid[40][3] = _PL_C.OUTLINE; grid[40][4] = _PL_C.ANTH_RIM; grid[40][5] = _PL_C.ANTH_SLATE; grid[40][6] = _PL_C.OUTLINE; grid[40][8] = _PL_C.OUTLINE; grid[40][9] = _PL_C.OUTLINE; grid[40][10] = _PL_C.ANTH_RIM; grid[40][11] = _PL_C.ANTH_SLATE; grid[40][12] = _PL_C.OUTLINE; grid[40][28] = _PL_C.OUTLINE; grid[40][29] = _PL_C.ANTH_RIM; grid[40][30] = _PL_C.ANTH_SLATE; grid[40][31] = _PL_C.OUTLINE; grid[40][32] = _PL_C.OUTLINE; grid[40][33] = _PL_C.ANTH_MID; grid[40][34] = _PL_C.ANTH_LGT; grid[40][42] = _PL_C.OUTLINE; grid[40][43] = _PL_C.OUTLINE; grid[40][44] = _PL_C.ANTH_RIM; grid[40][45] = _PL_C.ANTH_SLATE; grid[40][46] = _PL_C.OUTLINE;
    grid[41][0] = _PL_C.OUTLINE; grid[41][1] = _PL_C.ANTH_MID; grid[41][4] = _PL_C.OUTLINE; grid[41][5] = _PL_C.ANTH_LGT; grid[41][6] = _PL_C.ANTH_MID; grid[41][7] = _PL_C.OUTLINE; grid[41][8] = _PL_C.OUTLINE; grid[41][9] = _PL_C.OUTLINE; grid[41][10] = _PL_C.ANTH_LGT; grid[41][11] = _PL_C.ANTH_MID; grid[41][12] = _PL_C.OUTLINE; grid[41][29] = _PL_C.OUTLINE; grid[41][30] = _PL_C.ANTH_LGT; grid[41][31] = _PL_C.ANTH_MID; grid[41][32] = _PL_C.OUTLINE; grid[41][33] = _PL_C.OUTLINE; grid[41][34] = _PL_C.OUTLINE; grid[41][35] = _PL_C.ANTH_MID; grid[41][42] = _PL_C.OUTLINE; grid[41][43] = _PL_C.ANTH_DARK; grid[41][44] = _PL_C.OUTLINE; grid[41][45] = _PL_C.ANTH_LGT; grid[41][46] = _PL_C.ANTH_MID; grid[41][47] = _PL_C.OUTLINE;
    grid[42][4] = _PL_C.OUTLINE; grid[42][5] = _PL_C.ANTH_RIM; grid[42][6] = _PL_C.ANTH_SLATE; grid[42][7] = _PL_C.OUTLINE; grid[42][8] = _PL_C.OUTLINE; grid[42][9] = _PL_C.OUTLINE; grid[42][10] = _PL_C.OUTLINE; grid[42][11] = _PL_C.ANTH_SLATE; grid[42][29] = _PL_C.OUTLINE; grid[42][30] = _PL_C.ANTH_RIM; grid[42][31] = _PL_C.ANTH_SLATE; grid[42][32] = _PL_C.OUTLINE; grid[42][43] = _PL_C.OUTLINE; grid[42][44] = _PL_C.OUTLINE; grid[42][45] = _PL_C.OUTLINE; grid[42][46] = _PL_C.ANTH_SLATE;
    grid[43][4] = _PL_C.OUTLINE; grid[43][5] = _PL_C.ANTH_LGT; grid[43][6] = _PL_C.ANTH_MID; grid[43][7] = _PL_C.OUTLINE; grid[43][8] = _PL_C.OUTLINE; grid[43][9] = _PL_C.ANTH_DARK; grid[43][10] = _PL_C.ANTH_SLATE; grid[43][29] = _PL_C.OUTLINE; grid[43][30] = _PL_C.ANTH_LGT; grid[43][31] = _PL_C.ANTH_MID; grid[43][32] = _PL_C.OUTLINE; grid[43][43] = _PL_C.OUTLINE; grid[43][44] = _PL_C.ANTH_DARK; grid[43][45] = _PL_C.ANTH_SLATE;
    grid[44][4] = _PL_C.OUTLINE; grid[44][5] = _PL_C.ANTH_RIM; grid[44][6] = _PL_C.ANTH_SLATE; grid[44][7] = _PL_C.OUTLINE; grid[44][8] = _PL_C.OUTLINE; grid[44][9] = _PL_C.ANTH_MID; grid[44][10] = _PL_C.ANTH_LGT; grid[44][29] = _PL_C.OUTLINE; grid[44][30] = _PL_C.ANTH_RIM; grid[44][31] = _PL_C.ANTH_SLATE; grid[44][32] = _PL_C.OUTLINE; grid[44][43] = _PL_C.OUTLINE; grid[44][44] = _PL_C.ANTH_MID; grid[44][45] = _PL_C.ANTH_LGT;
    grid[45][4] = _PL_C.OUTLINE; grid[45][5] = _PL_C.ANTH_LGT; grid[45][6] = _PL_C.ANTH_MID; grid[45][7] = _PL_C.OUTLINE; grid[45][9] = _PL_C.OUTLINE; grid[45][10] = _PL_C.OUTLINE; grid[45][11] = _PL_C.ANTH_MID; grid[45][30] = _PL_C.OUTLINE; grid[45][31] = _PL_C.ANTH_LGT; grid[45][32] = _PL_C.ANTH_MID; grid[45][33] = _PL_C.OUTLINE; grid[45][44] = _PL_C.OUTLINE; grid[45][45] = _PL_C.OUTLINE; grid[45][46] = _PL_C.ANTH_MID;
    grid[46][4] = _PL_C.OUTLINE; grid[46][5] = _PL_C.OUTLINE; grid[46][6] = _PL_C.ANTH_SLATE; grid[46][30] = _PL_C.OUTLINE; grid[46][31] = _PL_C.OUTLINE; grid[46][32] = _PL_C.ANTH_SLATE;
  } else if (walkPhase === 2 || walkPhase === 3) {
    // Phase 2/3: Tripod B (front-right, mid-left, rear-right) swinging forward & lifted
    grid[28][35] = _PL_C.KNEE_GLD; grid[28][36] = _PL_C.KNEE_AMB; grid[28][37] = _PL_C.KNEE_AMB; grid[28][38] = _PL_C.KNEE_GLD; grid[28][39] = _PL_C.KNEE_HI;
    grid[29][10] = _PL_C.OUTLINE; grid[29][16] = _PL_C.ANTH_LGT; grid[29][25] = _PL_C.KNEE_SPEC; grid[29][26] = _PL_C.KNEE_HI; grid[29][27] = _PL_C.KNEE_GLD; grid[29][32] = _PL_C.OUTLINE; grid[29][33] = _PL_C.KNEE_SPEC; grid[29][34] = _PL_C.KNEE_HI; grid[29][35] = _PL_C.KNEE_GLD; grid[29][39] = _PL_C.KNEE_AMB; grid[29][40] = _PL_C.KNEE_AMB; grid[29][41] = _PL_C.KNEE_GLD; grid[29][42] = _PL_C.OUTLINE; grid[29][43] = _PL_C.KNEE_DRK;
    grid[30][3] = _PL_C.KNEE_AMB; grid[30][8] = _PL_C.KNEE_HI; grid[30][9] = _PL_C.KNEE_GLD; grid[30][10] = _PL_C.KNEE_HI; grid[30][15] = _PL_C.OUTLINE; grid[30][16] = _PL_C.KNEE_SPEC; grid[30][17] = _PL_C.KNEE_HI; grid[30][18] = _PL_C.KNEE_GLD; grid[30][25] = _PL_C.OUTLINE; grid[30][26] = _PL_C.OUTLINE; grid[30][27] = _PL_C.KNEE_MID; grid[30][28] = _PL_C.OUTLINE; grid[30][33] = _PL_C.OUTLINE; grid[30][34] = _PL_C.KNEE_SPEC; grid[30][35] = _PL_C.KNEE_HI; grid[30][36] = _PL_C.KNEE_GLD; grid[30][42] = _PL_C.KNEE_AMB; grid[30][43] = _PL_C.KNEE_AMB; grid[30][44] = _PL_C.ANTH_DARK; grid[30][45] = _PL_C.OUTLINE; grid[30][46] = _PL_C.KNEE_HI;
    grid[31][2] = _PL_C.OUTLINE; grid[31][3] = _PL_C.KNEE_BRT; grid[31][4] = _PL_C.KNEE_HI; grid[31][5] = _PL_C.KNEE_GLD; grid[31][6] = _PL_C.KNEE_GLD; grid[31][7] = _PL_C.KNEE_HI; grid[31][8] = _PL_C.KNEE_GLD; grid[31][14] = _PL_C.OUTLINE; grid[31][15] = _PL_C.KNEE_SPEC; grid[31][16] = _PL_C.KNEE_HI; grid[31][17] = _PL_C.KNEE_GLD; grid[31][27] = _PL_C.OUTLINE; grid[31][28] = _PL_C.OUTLINE; grid[31][29] = _PL_C.KNEE_BRT; grid[31][30] = _PL_C.KNEE_HI; grid[31][31] = _PL_C.KNEE_GLD; grid[31][34] = _PL_C.OUTLINE; grid[31][35] = _PL_C.OUTLINE; grid[31][36] = _PL_C.KNEE_BRT; grid[31][37] = _PL_C.KNEE_HI; grid[31][38] = _PL_C.KNEE_GLD; grid[31][44] = _PL_C.OUTLINE; grid[31][45] = _PL_C.ANTH_DARK; grid[31][46] = _PL_C.ANTH_SLATE;
    grid[32][0] = _PL_C.OUTLINE; grid[32][1] = _PL_C.KNEE_BRT; grid[32][2] = _PL_C.OUTLINE; grid[32][3] = _PL_C.ANTH_MID; grid[32][4] = _PL_C.KNEE_DRK; grid[32][5] = _PL_C.OUTLINE; grid[32][6] = _PL_C.ANTH_MID; grid[32][7] = _PL_C.ANTH_LGT; grid[32][14] = _PL_C.OUTLINE; grid[32][15] = _PL_C.KNEE_MID; grid[32][16] = _PL_C.OUTLINE; grid[32][26] = _PL_C.KNEE_AMB; grid[32][27] = _PL_C.KNEE_GLD; grid[32][28] = _PL_C.KNEE_HI; grid[32][29] = _PL_C.OUTLINE; grid[32][30] = _PL_C.OUTLINE; grid[32][31] = _PL_C.KNEE_BRT; grid[32][32] = _PL_C.OUTLINE; grid[32][33] = _PL_C.ANTH_MID; grid[32][36] = _PL_C.OUTLINE; grid[32][37] = _PL_C.KNEE_BRT; grid[32][38] = _PL_C.KNEE_HI; grid[32][39] = _PL_C.KNEE_GLD; grid[32][44] = _PL_C.OUTLINE; grid[32][45] = _PL_C.ANTH_MID; grid[32][46] = _PL_C.ANTH_LGT;
    grid[33][0] = _PL_C.OUTLINE; grid[33][1] = _PL_C.ANTH_LGT; grid[33][2] = _PL_C.ANTH_MID; grid[33][3] = _PL_C.OUTLINE; grid[33][5] = _PL_C.OUTLINE; grid[33][6] = _PL_C.ANTH_DARK; grid[33][7] = _PL_C.ANTH_SLATE; grid[33][13] = _PL_C.OUTLINE; grid[33][14] = _PL_C.KNEE_BRT; grid[33][15] = _PL_C.KNEE_HI; grid[33][16] = _PL_C.KNEE_GLD; grid[33][27] = _PL_C.KNEE_AMB; grid[33][28] = _PL_C.KNEE_GLD; grid[33][29] = _PL_C.KNEE_HI; grid[33][31] = _PL_C.OUTLINE; grid[33][32] = _PL_C.ANTH_LGT; grid[33][33] = _PL_C.ANTH_MID; grid[33][34] = _PL_C.OUTLINE; grid[33][37] = _PL_C.OUTLINE; grid[33][38] = _PL_C.KNEE_MID; grid[33][39] = _PL_C.OUTLINE; grid[33][44] = _PL_C.OUTLINE; grid[33][45] = _PL_C.ANTH_DARK; grid[33][46] = _PL_C.ANTH_SLATE;
    grid[34][0] = _PL_C.OUTLINE; grid[34][1] = _PL_C.ANTH_RIM; grid[34][2] = _PL_C.ANTH_SLATE; grid[34][3] = _PL_C.OUTLINE; grid[34][4] = _PL_C.OUTLINE; grid[34][5] = _PL_C.ANTH_MID; grid[34][6] = _PL_C.ANTH_LGT; grid[34][13] = _PL_C.OUTLINE; grid[34][14] = _PL_C.KNEE_BRT; grid[34][15] = _PL_C.KNEE_HI; grid[34][16] = _PL_C.KNEE_GLD; grid[34][27] = _PL_C.ANTH_DARK; grid[34][28] = _PL_C.OUTLINE; grid[34][29] = _PL_C.KNEE_HI; grid[34][31] = _PL_C.OUTLINE; grid[34][32] = _PL_C.ANTH_RIM; grid[34][33] = _PL_C.ANTH_SLATE; grid[34][34] = _PL_C.OUTLINE; grid[34][38] = _PL_C.OUTLINE; grid[34][39] = _PL_C.KNEE_BRT; grid[34][40] = _PL_C.OUTLINE; grid[34][41] = _PL_C.ANTH_MID; grid[34][44] = _PL_C.OUTLINE; grid[34][45] = _PL_C.ANTH_MID; grid[34][46] = _PL_C.ANTH_LGT;
    grid[35][0] = _PL_C.OUTLINE; grid[35][1] = _PL_C.ANTH_LGT; grid[35][2] = _PL_C.ANTH_MID; grid[35][3] = _PL_C.OUTLINE; grid[35][4] = _PL_C.OUTLINE; grid[35][5] = _PL_C.ANTH_DARK; grid[35][6] = _PL_C.ANTH_SLATE; grid[35][12] = _PL_C.OUTLINE; grid[35][13] = _PL_C.KNEE_BRT; grid[35][14] = _PL_C.OUTLINE; grid[35][15] = _PL_C.ANTH_MID; grid[35][27] = _PL_C.OUTLINE; grid[35][28] = _PL_C.ANTH_DARK; grid[35][29] = _PL_C.ANTH_SLATE; grid[35][32] = _PL_C.OUTLINE; grid[35][33] = _PL_C.ANTH_LGT; grid[35][34] = _PL_C.ANTH_MID; grid[35][35] = _PL_C.OUTLINE; grid[35][38] = _PL_C.OUTLINE; grid[35][39] = _PL_C.ANTH_LGT; grid[35][40] = _PL_C.ANTH_MID; grid[35][41] = _PL_C.OUTLINE; grid[35][44] = _PL_C.OUTLINE; grid[35][45] = _PL_C.ANTH_DARK; grid[35][46] = _PL_C.ANTH_SLATE;
    grid[36][0] = _PL_C.OUTLINE; grid[36][1] = _PL_C.ANTH_RIM; grid[36][2] = _PL_C.ANTH_SLATE; grid[36][3] = _PL_C.OUTLINE; grid[36][4] = _PL_C.OUTLINE; grid[36][5] = _PL_C.ANTH_MID; grid[36][6] = _PL_C.ANTH_LGT; grid[36][12] = _PL_C.OUTLINE; grid[36][13] = _PL_C.ANTH_RIM; grid[36][14] = _PL_C.ANTH_SLATE; grid[36][15] = _PL_C.OUTLINE; grid[36][27] = _PL_C.OUTLINE; grid[36][28] = _PL_C.ANTH_MID; grid[36][29] = _PL_C.ANTH_LGT; grid[36][32] = _PL_C.OUTLINE; grid[36][33] = _PL_C.ANTH_RIM; grid[36][34] = _PL_C.ANTH_SLATE; grid[36][35] = _PL_C.OUTLINE; grid[36][38] = _PL_C.OUTLINE; grid[36][39] = _PL_C.ANTH_RIM; grid[36][40] = _PL_C.ANTH_SLATE; grid[36][41] = _PL_C.OUTLINE; grid[36][45] = _PL_C.OUTLINE; grid[36][46] = _PL_C.ANTH_MID; grid[36][47] = _PL_C.ANTH_LGT;
    grid[37][0] = _PL_C.OUTLINE; grid[37][1] = _PL_C.ANTH_LGT; grid[37][2] = _PL_C.ANTH_MID; grid[37][3] = _PL_C.OUTLINE; grid[37][4] = _PL_C.OUTLINE; grid[37][5] = _PL_C.ANTH_DARK; grid[37][6] = _PL_C.ANTH_SLATE; grid[37][12] = _PL_C.OUTLINE; grid[37][13] = _PL_C.ANTH_LGT; grid[37][14] = _PL_C.ANTH_MID; grid[37][15] = _PL_C.OUTLINE; grid[37][27] = _PL_C.OUTLINE; grid[37][28] = _PL_C.ANTH_DARK; grid[37][29] = _PL_C.ANTH_SLATE; grid[37][33] = _PL_C.OUTLINE; grid[37][34] = _PL_C.ANTH_LGT; grid[37][35] = _PL_C.ANTH_MID; grid[37][36] = _PL_C.OUTLINE; grid[37][38] = _PL_C.OUTLINE; grid[37][39] = _PL_C.ANTH_LGT; grid[37][40] = _PL_C.ANTH_MID; grid[37][41] = _PL_C.OUTLINE; grid[37][45] = _PL_C.OUTLINE; grid[37][46] = _PL_C.ANTH_DARK; grid[37][47] = _PL_C.ANTH_SLATE;
    grid[38][0] = _PL_C.ANTH_RIM; grid[38][1] = _PL_C.ANTH_SLATE; grid[38][2] = _PL_C.OUTLINE; grid[38][4] = _PL_C.OUTLINE; grid[38][5] = _PL_C.ANTH_MID; grid[38][6] = _PL_C.ANTH_LGT; grid[38][13] = _PL_C.OUTLINE; grid[38][14] = _PL_C.ANTH_RIM; grid[38][15] = _PL_C.ANTH_SLATE; grid[38][16] = _PL_C.OUTLINE; grid[38][27] = _PL_C.OUTLINE; grid[38][28] = _PL_C.ANTH_MID; grid[38][29] = _PL_C.ANTH_LGT; grid[38][33] = _PL_C.OUTLINE; grid[38][34] = _PL_C.ANTH_RIM; grid[38][35] = _PL_C.ANTH_SLATE; grid[38][36] = _PL_C.OUTLINE; grid[38][38] = _PL_C.OUTLINE; grid[38][39] = _PL_C.ANTH_RIM; grid[38][40] = _PL_C.ANTH_SLATE; grid[38][41] = _PL_C.OUTLINE; grid[38][45] = _PL_C.OUTLINE; grid[38][46] = _PL_C.ANTH_MID; grid[38][47] = _PL_C.ANTH_LGT;
    grid[39][0] = _PL_C.ANTH_LGT; grid[39][1] = _PL_C.ANTH_MID; grid[39][2] = _PL_C.OUTLINE; grid[39][3] = _PL_C.OUTLINE; grid[39][4] = _PL_C.ANTH_DARK; grid[39][5] = _PL_C.ANTH_SLATE; grid[39][13] = _PL_C.OUTLINE; grid[39][14] = _PL_C.ANTH_LGT; grid[39][15] = _PL_C.ANTH_MID; grid[39][16] = _PL_C.OUTLINE; grid[39][27] = _PL_C.OUTLINE; grid[39][28] = _PL_C.ANTH_DARK; grid[39][29] = _PL_C.ANTH_SLATE; grid[39][34] = _PL_C.OUTLINE; grid[39][35] = _PL_C.ANTH_LGT; grid[39][36] = _PL_C.ANTH_MID; grid[39][37] = _PL_C.OUTLINE; grid[39][38] = _PL_C.OUTLINE; grid[39][39] = _PL_C.ANTH_LGT; grid[39][40] = _PL_C.ANTH_MID; grid[39][41] = _PL_C.OUTLINE; grid[39][45] = _PL_C.OUTLINE; grid[39][46] = _PL_C.ANTH_DARK; grid[39][47] = _PL_C.ANTH_SLATE;
    grid[40][0] = _PL_C.ANTH_RIM; grid[40][1] = _PL_C.ANTH_SLATE; grid[40][2] = _PL_C.OUTLINE; grid[40][3] = _PL_C.OUTLINE; grid[40][4] = _PL_C.ANTH_MID; grid[40][5] = _PL_C.ANTH_LGT; grid[40][13] = _PL_C.OUTLINE; grid[40][14] = _PL_C.ANTH_RIM; grid[40][15] = _PL_C.ANTH_SLATE; grid[40][16] = _PL_C.OUTLINE; grid[40][27] = _PL_C.OUTLINE; grid[40][28] = _PL_C.ANTH_MID; grid[40][29] = _PL_C.ANTH_LGT; grid[40][34] = _PL_C.OUTLINE; grid[40][35] = _PL_C.ANTH_RIM; grid[40][36] = _PL_C.ANTH_SLATE; grid[40][37] = _PL_C.OUTLINE; grid[40][39] = _PL_C.OUTLINE; grid[40][40] = _PL_C.ANTH_RIM; grid[40][41] = _PL_C.ANTH_SLATE; grid[40][42] = _PL_C.OUTLINE; grid[40][45] = _PL_C.OUTLINE; grid[40][46] = _PL_C.ANTH_MID; grid[40][47] = _PL_C.ANTH_LGT;
    grid[41][0] = _PL_C.ANTH_LGT; grid[41][1] = _PL_C.ANTH_MID; grid[41][2] = _PL_C.OUTLINE; grid[41][4] = _PL_C.OUTLINE; grid[41][5] = _PL_C.OUTLINE; grid[41][6] = _PL_C.ANTH_MID; grid[41][13] = _PL_C.OUTLINE; grid[41][14] = _PL_C.ANTH_LGT; grid[41][15] = _PL_C.ANTH_MID; grid[41][16] = _PL_C.OUTLINE; grid[41][27] = _PL_C.OUTLINE; grid[41][28] = _PL_C.ANTH_DARK; grid[41][29] = _PL_C.ANTH_SLATE; grid[41][35] = _PL_C.OUTLINE; grid[41][36] = _PL_C.ANTH_LGT; grid[41][37] = _PL_C.ANTH_MID; grid[41][38] = _PL_C.OUTLINE; grid[41][39] = _PL_C.OUTLINE; grid[41][40] = _PL_C.ANTH_LGT; grid[41][41] = _PL_C.ANTH_MID; grid[41][42] = _PL_C.OUTLINE; grid[41][46] = _PL_C.OUTLINE; grid[41][47] = _PL_C.ANTH_MID;
    grid[42][0] = _PL_C.OUTLINE; grid[42][1] = _PL_C.ANTH_SLATE; grid[42][2] = _PL_C.ANTH_LGT; grid[42][13] = _PL_C.OUTLINE; grid[42][14] = _PL_C.ANTH_RIM; grid[42][15] = _PL_C.ANTH_SLATE; grid[42][16] = _PL_C.OUTLINE; grid[42][27] = _PL_C.OUTLINE; grid[42][28] = _PL_C.ANTH_MID; grid[42][29] = _PL_C.ANTH_LGT; grid[42][35] = _PL_C.OUTLINE; grid[42][36] = _PL_C.OUTLINE; grid[42][37] = _PL_C.ANTH_SLATE; grid[42][39] = _PL_C.OUTLINE; grid[42][40] = _PL_C.ANTH_RIM; grid[42][41] = _PL_C.ANTH_SLATE; grid[42][42] = _PL_C.OUTLINE;
    grid[43][0] = _PL_C.OUTLINE; grid[43][1] = _PL_C.ANTH_DARK; grid[43][2] = _PL_C.ANTH_SLATE; grid[43][13] = _PL_C.OUTLINE; grid[43][14] = _PL_C.ANTH_LGT; grid[43][15] = _PL_C.ANTH_MID; grid[43][16] = _PL_C.OUTLINE; grid[43][27] = _PL_C.OUTLINE; grid[43][28] = _PL_C.ANTH_DARK; grid[43][29] = _PL_C.ANTH_SLATE; grid[43][39] = _PL_C.OUTLINE; grid[43][40] = _PL_C.ANTH_LGT; grid[43][41] = _PL_C.ANTH_MID; grid[43][42] = _PL_C.OUTLINE;
    grid[44][0] = _PL_C.OUTLINE; grid[44][1] = _PL_C.ANTH_MID; grid[44][2] = _PL_C.ANTH_LGT; grid[44][14] = _PL_C.OUTLINE; grid[44][15] = _PL_C.ANTH_RIM; grid[44][16] = _PL_C.ANTH_SLATE; grid[44][17] = _PL_C.OUTLINE; grid[44][27] = _PL_C.OUTLINE; grid[44][28] = _PL_C.ANTH_MID; grid[44][29] = _PL_C.ANTH_LGT; grid[44][39] = _PL_C.OUTLINE; grid[44][40] = _PL_C.ANTH_RIM; grid[44][41] = _PL_C.ANTH_SLATE; grid[44][42] = _PL_C.OUTLINE;
    grid[45][1] = _PL_C.OUTLINE; grid[45][2] = _PL_C.OUTLINE; grid[45][3] = _PL_C.ANTH_MID; grid[45][14] = _PL_C.OUTLINE; grid[45][15] = _PL_C.ANTH_LGT; grid[45][16] = _PL_C.ANTH_MID; grid[45][17] = _PL_C.OUTLINE; grid[45][28] = _PL_C.OUTLINE; grid[45][29] = _PL_C.OUTLINE; grid[45][30] = _PL_C.ANTH_MID; grid[45][39] = _PL_C.OUTLINE; grid[45][40] = _PL_C.ANTH_LGT; grid[45][41] = _PL_C.ANTH_MID; grid[45][42] = _PL_C.OUTLINE;
    grid[46][14] = _PL_C.OUTLINE; grid[46][15] = _PL_C.OUTLINE; grid[46][16] = _PL_C.ANTH_SLATE; grid[46][39] = _PL_C.OUTLINE; grid[46][40] = _PL_C.OUTLINE; grid[46][41] = _PL_C.ANTH_SLATE;
  } else {
    // Phase 0 / Neutral: All 6 legs planted firmly in balanced tripod stance
    grid[28][35] = _PL_C.KNEE_GLD; grid[28][36] = _PL_C.KNEE_BRT;
    grid[29][16] = _PL_C.ANTH_LGT; grid[29][25] = _PL_C.ANTH_MID; grid[29][26] = _PL_C.KNEE_GLD; grid[29][27] = _PL_C.KNEE_BRT; grid[29][32] = _PL_C.OUTLINE; grid[29][33] = _PL_C.KNEE_SPEC; grid[29][34] = _PL_C.KNEE_HI; grid[29][35] = _PL_C.KNEE_GLD; grid[29][36] = _PL_C.KNEE_AMB; grid[29][37] = _PL_C.KNEE_GLD; grid[29][38] = _PL_C.KNEE_HI;
    grid[30][3] = _PL_C.KNEE_AMB; grid[30][8] = _PL_C.ANTH_LGT; grid[30][9] = _PL_C.ANTH_MID; grid[30][10] = _PL_C.KNEE_AMB; grid[30][11] = _PL_C.KNEE_GLD; grid[30][12] = _PL_C.KNEE_BRT; grid[30][14] = _PL_C.OUTLINE; grid[30][15] = _PL_C.KNEE_SPEC; grid[30][16] = _PL_C.KNEE_HI; grid[30][17] = _PL_C.KNEE_GLD; grid[30][24] = _PL_C.OUTLINE; grid[30][25] = _PL_C.KNEE_SPEC; grid[30][26] = _PL_C.KNEE_HI; grid[30][27] = _PL_C.KNEE_GLD; grid[30][33] = _PL_C.OUTLINE; grid[30][34] = _PL_C.OUTLINE; grid[30][35] = _PL_C.KNEE_MID; grid[30][36] = _PL_C.OUTLINE; grid[30][37] = _PL_C.KNEE_AMB; grid[30][38] = _PL_C.KNEE_GLD; grid[30][39] = _PL_C.KNEE_HI;
    grid[31][2] = _PL_C.KNEE_AMB; grid[31][3] = _PL_C.KNEE_GLD; grid[31][4] = _PL_C.KNEE_HI; grid[31][6] = _PL_C.OUTLINE; grid[31][7] = _PL_C.KNEE_SPEC; grid[31][8] = _PL_C.KNEE_HI; grid[31][9] = _PL_C.KNEE_GLD; grid[31][11] = _PL_C.OUTLINE; grid[31][12] = _PL_C.KNEE_DRK; grid[31][14] = _PL_C.OUTLINE; grid[31][15] = _PL_C.KNEE_SPEC; grid[31][16] = _PL_C.KNEE_HI; grid[31][17] = _PL_C.KNEE_GLD; grid[31][25] = _PL_C.OUTLINE; grid[31][26] = _PL_C.KNEE_SPEC; grid[31][27] = _PL_C.KNEE_HI; grid[31][28] = _PL_C.KNEE_GLD; grid[31][35] = _PL_C.OUTLINE; grid[31][36] = _PL_C.KNEE_BRT; grid[31][37] = _PL_C.KNEE_HI; grid[31][38] = _PL_C.KNEE_GLD; grid[31][39] = _PL_C.KNEE_AMB; grid[31][40] = _PL_C.KNEE_GLD; grid[31][41] = _PL_C.KNEE_HI;
    grid[32][2] = _PL_C.OUTLINE; grid[32][3] = _PL_C.KNEE_DRK; grid[32][5] = _PL_C.OUTLINE; grid[32][6] = _PL_C.KNEE_BRT; grid[32][7] = _PL_C.KNEE_HI; grid[32][8] = _PL_C.KNEE_GLD; grid[32][9] = _PL_C.KNEE_AMB; grid[32][10] = _PL_C.KNEE_GLD; grid[32][11] = _PL_C.KNEE_HI; grid[32][13] = _PL_C.OUTLINE; grid[32][14] = _PL_C.KNEE_MID; grid[32][15] = _PL_C.OUTLINE; grid[32][26] = _PL_C.OUTLINE; grid[32][27] = _PL_C.KNEE_MID; grid[32][28] = _PL_C.OUTLINE; grid[32][29] = _PL_C.KNEE_HI; grid[32][36] = _PL_C.OUTLINE; grid[32][37] = _PL_C.KNEE_BRT; grid[32][38] = _PL_C.KNEE_HI; grid[32][39] = _PL_C.KNEE_GLD; grid[32][40] = _PL_C.KNEE_AMB; grid[32][41] = _PL_C.KNEE_GLD; grid[32][42] = _PL_C.OUTLINE; grid[32][43] = _PL_C.KNEE_DRK;
    grid[33][0] = _PL_C.KNEE_AMB; grid[33][1] = _PL_C.KNEE_GLD; grid[33][2] = _PL_C.KNEE_HI; grid[33][4] = _PL_C.OUTLINE; grid[33][5] = _PL_C.KNEE_MID; grid[33][6] = _PL_C.OUTLINE; grid[33][8] = _PL_C.KNEE_AMB; grid[33][9] = _PL_C.KNEE_GLD; grid[33][10] = _PL_C.KNEE_HI; grid[33][12] = _PL_C.OUTLINE; grid[33][13] = _PL_C.KNEE_BRT; grid[33][14] = _PL_C.KNEE_HI; grid[33][15] = _PL_C.KNEE_GLD; grid[33][26] = _PL_C.OUTLINE; grid[33][27] = _PL_C.KNEE_BRT; grid[33][28] = _PL_C.KNEE_HI; grid[33][29] = _PL_C.KNEE_GLD; grid[33][37] = _PL_C.OUTLINE; grid[33][38] = _PL_C.OUTLINE; grid[33][39] = _PL_C.KNEE_BRT; grid[33][40] = _PL_C.KNEE_HI; grid[33][41] = _PL_C.KNEE_GLD; grid[33][42] = _PL_C.ANTH_DARK; grid[33][43] = _PL_C.OUTLINE; grid[33][44] = _PL_C.KNEE_HI;
    grid[34][0] = _PL_C.ANTH_DARK; grid[34][1] = _PL_C.KNEE_HI; grid[34][3] = _PL_C.OUTLINE; grid[34][4] = _PL_C.KNEE_BRT; grid[34][5] = _PL_C.KNEE_HI; grid[34][6] = _PL_C.KNEE_GLD; grid[34][7] = _PL_C.ANTH_DARK; grid[34][8] = _PL_C.OUTLINE; grid[34][9] = _PL_C.KNEE_HI; grid[34][12] = _PL_C.OUTLINE; grid[34][13] = _PL_C.KNEE_BRT; grid[34][14] = _PL_C.KNEE_HI; grid[34][15] = _PL_C.KNEE_GLD; grid[34][27] = _PL_C.OUTLINE; grid[34][28] = _PL_C.KNEE_BRT; grid[34][29] = _PL_C.KNEE_HI; grid[34][30] = _PL_C.KNEE_GLD; grid[34][39] = _PL_C.OUTLINE; grid[34][40] = _PL_C.KNEE_BRT; grid[34][41] = _PL_C.OUTLINE; grid[34][42] = _PL_C.ANTH_MID; grid[34][43] = _PL_C.ANTH_MID; grid[34][44] = _PL_C.ANTH_LGT;
    grid[35][0] = _PL_C.OUTLINE; grid[35][1] = _PL_C.ANTH_SLATE; grid[35][2] = _PL_C.OUTLINE; grid[35][3] = _PL_C.KNEE_BRT; grid[35][4] = _PL_C.OUTLINE; grid[35][5] = _PL_C.ANTH_MID; grid[35][7] = _PL_C.OUTLINE; grid[35][8] = _PL_C.ANTH_DARK; grid[35][9] = _PL_C.ANTH_SLATE; grid[35][11] = _PL_C.OUTLINE; grid[35][12] = _PL_C.KNEE_BRT; grid[35][13] = _PL_C.OUTLINE; grid[35][14] = _PL_C.ANTH_MID; grid[35][28] = _PL_C.OUTLINE; grid[35][29] = _PL_C.KNEE_BRT; grid[35][30] = _PL_C.OUTLINE; grid[35][31] = _PL_C.ANTH_MID; grid[35][39] = _PL_C.OUTLINE; grid[35][40] = _PL_C.ANTH_LGT; grid[35][41] = _PL_C.ANTH_MID; grid[35][42] = _PL_C.OUTLINE; grid[35][43] = _PL_C.OUTLINE; grid[35][44] = _PL_C.ANTH_DARK; grid[35][45] = _PL_C.ANTH_SLATE;
    grid[36][0] = _PL_C.OUTLINE; grid[36][1] = _PL_C.ANTH_LGT; grid[36][2] = _PL_C.OUTLINE; grid[36][3] = _PL_C.ANTH_RIM; grid[36][4] = _PL_C.ANTH_SLATE; grid[36][5] = _PL_C.OUTLINE; grid[36][7] = _PL_C.OUTLINE; grid[36][8] = _PL_C.ANTH_MID; grid[36][9] = _PL_C.ANTH_LGT; grid[36][11] = _PL_C.OUTLINE; grid[36][12] = _PL_C.ANTH_RIM; grid[36][13] = _PL_C.ANTH_SLATE; grid[36][14] = _PL_C.OUTLINE; grid[36][28] = _PL_C.OUTLINE; grid[36][29] = _PL_C.ANTH_RIM; grid[36][30] = _PL_C.ANTH_SLATE; grid[36][31] = _PL_C.OUTLINE; grid[36][39] = _PL_C.OUTLINE; grid[36][40] = _PL_C.ANTH_RIM; grid[36][41] = _PL_C.ANTH_SLATE; grid[36][42] = _PL_C.OUTLINE; grid[36][43] = _PL_C.OUTLINE; grid[36][44] = _PL_C.ANTH_MID; grid[36][45] = _PL_C.ANTH_LGT;
    grid[37][0] = _PL_C.OUTLINE; grid[37][1] = _PL_C.ANTH_SLATE; grid[37][2] = _PL_C.OUTLINE; grid[37][3] = _PL_C.ANTH_LGT; grid[37][4] = _PL_C.ANTH_MID; grid[37][5] = _PL_C.OUTLINE; grid[37][7] = _PL_C.OUTLINE; grid[37][8] = _PL_C.ANTH_DARK; grid[37][9] = _PL_C.ANTH_SLATE; grid[37][11] = _PL_C.OUTLINE; grid[37][12] = _PL_C.ANTH_LGT; grid[37][13] = _PL_C.ANTH_MID; grid[37][14] = _PL_C.OUTLINE; grid[37][28] = _PL_C.OUTLINE; grid[37][29] = _PL_C.OUTLINE; grid[37][30] = _PL_C.ANTH_LGT; grid[37][31] = _PL_C.ANTH_MID; grid[37][32] = _PL_C.OUTLINE; grid[37][40] = _PL_C.OUTLINE; grid[37][41] = _PL_C.ANTH_LGT; grid[37][42] = _PL_C.ANTH_MID; grid[37][43] = _PL_C.OUTLINE; grid[37][44] = _PL_C.ANTH_DARK; grid[37][45] = _PL_C.ANTH_SLATE;
    grid[38][0] = _PL_C.OUTLINE; grid[38][1] = _PL_C.ANTH_LGT; grid[38][2] = _PL_C.OUTLINE; grid[38][3] = _PL_C.ANTH_RIM; grid[38][4] = _PL_C.ANTH_SLATE; grid[38][5] = _PL_C.OUTLINE; grid[38][7] = _PL_C.OUTLINE; grid[38][8] = _PL_C.ANTH_MID; grid[38][9] = _PL_C.ANTH_LGT; grid[38][11] = _PL_C.OUTLINE; grid[38][12] = _PL_C.ANTH_RIM; grid[38][13] = _PL_C.ANTH_SLATE; grid[38][14] = _PL_C.OUTLINE; grid[38][28] = _PL_C.OUTLINE; grid[38][29] = _PL_C.OUTLINE; grid[38][30] = _PL_C.ANTH_RIM; grid[38][31] = _PL_C.ANTH_SLATE; grid[38][32] = _PL_C.OUTLINE; grid[38][40] = _PL_C.OUTLINE; grid[38][41] = _PL_C.ANTH_RIM; grid[38][42] = _PL_C.ANTH_SLATE; grid[38][43] = _PL_C.OUTLINE; grid[38][44] = _PL_C.ANTH_MID; grid[38][45] = _PL_C.ANTH_LGT;
    grid[39][0] = _PL_C.OUTLINE; grid[39][1] = _PL_C.ANTH_SLATE; grid[39][2] = _PL_C.OUTLINE; grid[39][3] = _PL_C.ANTH_LGT; grid[39][4] = _PL_C.ANTH_MID; grid[39][5] = _PL_C.OUTLINE; grid[39][7] = _PL_C.OUTLINE; grid[39][8] = _PL_C.ANTH_DARK; grid[39][9] = _PL_C.ANTH_SLATE; grid[39][11] = _PL_C.OUTLINE; grid[39][12] = _PL_C.ANTH_LGT; grid[39][13] = _PL_C.ANTH_MID; grid[39][14] = _PL_C.OUTLINE; grid[39][28] = _PL_C.OUTLINE; grid[39][29] = _PL_C.OUTLINE; grid[39][30] = _PL_C.ANTH_LGT; grid[39][31] = _PL_C.ANTH_MID; grid[39][32] = _PL_C.OUTLINE; grid[39][40] = _PL_C.OUTLINE; grid[39][41] = _PL_C.ANTH_LGT; grid[39][42] = _PL_C.ANTH_MID; grid[39][43] = _PL_C.OUTLINE; grid[39][44] = _PL_C.OUTLINE; grid[39][45] = _PL_C.ANTH_DARK; grid[39][46] = _PL_C.ANTH_SLATE;
    grid[40][0] = _PL_C.OUTLINE; grid[40][2] = _PL_C.OUTLINE; grid[40][3] = _PL_C.ANTH_RIM; grid[40][4] = _PL_C.ANTH_SLATE; grid[40][5] = _PL_C.OUTLINE; grid[40][6] = _PL_C.OUTLINE; grid[40][7] = _PL_C.ANTH_MID; grid[40][8] = _PL_C.ANTH_LGT; grid[40][11] = _PL_C.OUTLINE; grid[40][12] = _PL_C.ANTH_RIM; grid[40][13] = _PL_C.ANTH_SLATE; grid[40][14] = _PL_C.OUTLINE; grid[40][29] = _PL_C.OUTLINE; grid[40][30] = _PL_C.OUTLINE; grid[40][31] = _PL_C.ANTH_RIM; grid[40][32] = _PL_C.ANTH_SLATE; grid[40][33] = _PL_C.OUTLINE; grid[40][40] = _PL_C.OUTLINE; grid[40][41] = _PL_C.ANTH_RIM; grid[40][42] = _PL_C.ANTH_SLATE; grid[40][43] = _PL_C.OUTLINE; grid[40][44] = _PL_C.OUTLINE; grid[40][45] = _PL_C.ANTH_MID; grid[40][46] = _PL_C.ANTH_LGT;
    grid[41][0] = _PL_C.OUTLINE; grid[41][2] = _PL_C.OUTLINE; grid[41][3] = _PL_C.ANTH_LGT; grid[41][4] = _PL_C.ANTH_MID; grid[41][5] = _PL_C.OUTLINE; grid[41][6] = _PL_C.OUTLINE; grid[41][7] = _PL_C.ANTH_DARK; grid[41][8] = _PL_C.ANTH_SLATE; grid[41][12] = _PL_C.OUTLINE; grid[41][13] = _PL_C.ANTH_LGT; grid[41][14] = _PL_C.ANTH_MID; grid[41][15] = _PL_C.OUTLINE; grid[41][29] = _PL_C.OUTLINE; grid[41][30] = _PL_C.OUTLINE; grid[41][31] = _PL_C.ANTH_LGT; grid[41][32] = _PL_C.ANTH_MID; grid[41][33] = _PL_C.OUTLINE; grid[41][40] = _PL_C.OUTLINE; grid[41][41] = _PL_C.ANTH_LGT; grid[41][42] = _PL_C.ANTH_MID; grid[41][43] = _PL_C.OUTLINE; grid[41][44] = _PL_C.OUTLINE; grid[41][45] = _PL_C.ANTH_DARK; grid[41][46] = _PL_C.ANTH_SLATE;
    grid[42][0] = _PL_C.OUTLINE; grid[42][2] = _PL_C.OUTLINE; grid[42][3] = _PL_C.ANTH_RIM; grid[42][4] = _PL_C.ANTH_SLATE; grid[42][5] = _PL_C.OUTLINE; grid[42][6] = _PL_C.OUTLINE; grid[42][7] = _PL_C.ANTH_MID; grid[42][8] = _PL_C.ANTH_LGT; grid[42][12] = _PL_C.OUTLINE; grid[42][13] = _PL_C.ANTH_RIM; grid[42][14] = _PL_C.ANTH_SLATE; grid[42][15] = _PL_C.OUTLINE; grid[42][29] = _PL_C.OUTLINE; grid[42][30] = _PL_C.ANTH_MID; grid[42][31] = _PL_C.OUTLINE; grid[42][32] = _PL_C.ANTH_RIM; grid[42][33] = _PL_C.ANTH_SLATE; grid[42][34] = _PL_C.OUTLINE; grid[42][40] = _PL_C.OUTLINE; grid[42][41] = _PL_C.ANTH_RIM; grid[42][42] = _PL_C.ANTH_SLATE; grid[42][43] = _PL_C.OUTLINE; grid[42][44] = _PL_C.OUTLINE; grid[42][45] = _PL_C.ANTH_MID; grid[42][46] = _PL_C.ANTH_LGT;
    grid[43][0] = _PL_C.OUTLINE; grid[43][2] = _PL_C.OUTLINE; grid[43][3] = _PL_C.ANTH_LGT; grid[43][4] = _PL_C.ANTH_MID; grid[43][5] = _PL_C.OUTLINE; grid[43][6] = _PL_C.OUTLINE; grid[43][7] = _PL_C.ANTH_DARK; grid[43][8] = _PL_C.ANTH_SLATE; grid[43][12] = _PL_C.OUTLINE; grid[43][13] = _PL_C.ANTH_LGT; grid[43][14] = _PL_C.ANTH_MID; grid[43][15] = _PL_C.OUTLINE; grid[43][29] = _PL_C.OUTLINE; grid[43][30] = _PL_C.ANTH_DARK; grid[43][31] = _PL_C.OUTLINE; grid[43][32] = _PL_C.ANTH_LGT; grid[43][33] = _PL_C.ANTH_MID; grid[43][34] = _PL_C.OUTLINE; grid[43][41] = _PL_C.OUTLINE; grid[43][42] = _PL_C.ANTH_LGT; grid[43][43] = _PL_C.ANTH_MID; grid[43][44] = _PL_C.OUTLINE; grid[43][45] = _PL_C.OUTLINE; grid[43][46] = _PL_C.ANTH_DARK; grid[43][47] = _PL_C.ANTH_SLATE;
    grid[44][0] = _PL_C.OUTLINE; grid[44][2] = _PL_C.OUTLINE; grid[44][3] = _PL_C.ANTH_RIM; grid[44][4] = _PL_C.ANTH_SLATE; grid[44][5] = _PL_C.OUTLINE; grid[44][6] = _PL_C.OUTLINE; grid[44][7] = _PL_C.ANTH_MID; grid[44][8] = _PL_C.ANTH_LGT; grid[44][12] = _PL_C.OUTLINE; grid[44][13] = _PL_C.ANTH_RIM; grid[44][14] = _PL_C.ANTH_SLATE; grid[44][15] = _PL_C.OUTLINE; grid[44][29] = _PL_C.OUTLINE; grid[44][30] = _PL_C.ANTH_MID; grid[44][31] = _PL_C.OUTLINE; grid[44][32] = _PL_C.ANTH_RIM; grid[44][33] = _PL_C.ANTH_SLATE; grid[44][34] = _PL_C.OUTLINE; grid[44][41] = _PL_C.OUTLINE; grid[44][42] = _PL_C.ANTH_RIM; grid[44][43] = _PL_C.ANTH_SLATE; grid[44][44] = _PL_C.OUTLINE; grid[44][45] = _PL_C.OUTLINE; grid[44][46] = _PL_C.ANTH_MID; grid[44][47] = _PL_C.ANTH_LGT;
    grid[45][0] = _PL_C.OUTLINE; grid[45][1] = _PL_C.ANTH_MID; grid[45][2] = _PL_C.OUTLINE; grid[45][3] = _PL_C.ANTH_LGT; grid[45][4] = _PL_C.ANTH_MID; grid[45][5] = _PL_C.OUTLINE; grid[45][7] = _PL_C.OUTLINE; grid[45][8] = _PL_C.OUTLINE; grid[45][9] = _PL_C.ANTH_MID; grid[45][12] = _PL_C.OUTLINE; grid[45][13] = _PL_C.ANTH_LGT; grid[45][14] = _PL_C.ANTH_MID; grid[45][15] = _PL_C.OUTLINE; grid[45][30] = _PL_C.OUTLINE; grid[45][31] = _PL_C.OUTLINE; grid[45][32] = _PL_C.OUTLINE; grid[45][33] = _PL_C.ANTH_LGT; grid[45][34] = _PL_C.ANTH_MID; grid[45][35] = _PL_C.OUTLINE; grid[45][41] = _PL_C.OUTLINE; grid[45][42] = _PL_C.ANTH_LGT; grid[45][43] = _PL_C.ANTH_MID; grid[45][44] = _PL_C.OUTLINE; grid[45][46] = _PL_C.OUTLINE; grid[45][47] = _PL_C.ANTH_MID;
    grid[46][2] = _PL_C.OUTLINE; grid[46][3] = _PL_C.OUTLINE; grid[46][4] = _PL_C.ANTH_SLATE; grid[46][12] = _PL_C.OUTLINE; grid[46][13] = _PL_C.OUTLINE; grid[46][14] = _PL_C.ANTH_SLATE; grid[46][32] = _PL_C.OUTLINE; grid[46][33] = _PL_C.OUTLINE; grid[46][34] = _PL_C.ANTH_SLATE; grid[46][41] = _PL_C.OUTLINE; grid[46][42] = _PL_C.OUTLINE; grid[46][43] = _PL_C.ANTH_SLATE;
  }
}

function getHD_PreserverLock_Carapace() {
  const g = 48, grid = makeGrid48();
  _paintHD_PreserverLock_Carapace(grid);
  return { gridSize: g, grid };
}

function getHD_PreserverLock_Tower(cablePhase = 0) {
  const g = 48, grid = makeGrid48();
  _paintHD_PreserverLock_Tower(grid, cablePhase);
  return { gridSize: g, grid };
}

function getHD_PreserverLock_Tower_Stand() { return getHD_PreserverLock_Tower(0); }
function getHD_PreserverLock_Tower_Walk1() { return getHD_PreserverLock_Tower(-1.6); }
function getHD_PreserverLock_Tower_Walk2() { return getHD_PreserverLock_Tower(0); }
function getHD_PreserverLock_Tower_Walk3() { return getHD_PreserverLock_Tower(1.6); }
function getHD_PreserverLock_Tower_Walk4() { return getHD_PreserverLock_Tower(0); }

function getHD_PreserverLock_Legs(walkPhase = 0) {
  const g = 48, grid = makeGrid48();
  _paintHD_PreserverLock_Legs(grid, walkPhase);
  return { gridSize: g, grid };
}

function getHD_PreserverLock_Legs_Stand() { return getHD_PreserverLock_Legs(0); }
function getHD_PreserverLock_Legs_Walk1() { return getHD_PreserverLock_Legs(1); }
function getHD_PreserverLock_Legs_Walk2() { return getHD_PreserverLock_Legs(0); }
function getHD_PreserverLock_Legs_Walk3() { return getHD_PreserverLock_Legs(2); }
function getHD_PreserverLock_Legs_Walk4() { return getHD_PreserverLock_Legs(0); }

function getHD_PreserverLock_Body(cablePhase = 0) {
  const g = 48, grid = makeGrid48();
  _paintHD_PreserverLock_Carapace(grid);
  _paintHD_PreserverLock_Tower(grid, cablePhase);
  return { gridSize: g, grid };
}

function getHD_PreserverLock_Body_Walk1() { return getHD_PreserverLock_Body(-1.6); }
function getHD_PreserverLock_Body_Walk2() { return getHD_PreserverLock_Body(0); }
function getHD_PreserverLock_Body_Walk3() { return getHD_PreserverLock_Body(1.6); }
function getHD_PreserverLock_Body_Walk4() { return getHD_PreserverLock_Body(0); }

function getHD_PreserverLock(walkPhase = 0) {
  const g = 48, grid = makeGrid48();
  const sway = (walkPhase === 1) ? -1.6 : (walkPhase === 2 || walkPhase === 3 ? 1.6 : 0);
  _paintHD_PreserverLock_Legs(grid, walkPhase);
  _paintHD_PreserverLock_Carapace(grid);
  _paintHD_PreserverLock_Tower(grid, sway);
  return { gridSize: g, grid };
}
function getHD_PreserverLock_Walk1() { return getHD_PreserverLock(1); }
function getHD_PreserverLock_Walk2() { return getHD_PreserverLock(0); }
function getHD_PreserverLock_Walk3() { return getHD_PreserverLock(2); }
function getHD_PreserverLock_Walk4() { return getHD_PreserverLock(0); }

// ── SUL BASTION LOCK (36×36 HD TIER M REFERENCE) ─────────────────────────
// Heavy frontline bio-tank with massive chitin fore-shields.
// In mobile stance: walks on two giant articulated shield-limbs, pod suspended with small trailing hind legs.
// In deployed stance: shields move close together in front forming an interlocking barrier with narrow blue beam embrasure.

// Desaturated, weathered carapace palette for body pod and dorsal head:
// Distinguishes the unit from organic foliage/wood (no warm bark brown or leaf green).
// Ash-olive / slate-chitin tones (#59634e, #768369, #97a488) paired with desaturated dark composite cords.
// Vibrant cyan visor and blue sinew remain fully saturated.
const _BL_C_CARAPACE = {
  OUTLINE:     '#080a06',
  CREVICE:     '#130d09',
  CHITIN_SHD:  '#231c17',
  CHITIN_BASE: '#362c25',
  CHITIN_MIDD: '#484437',
  CHITIN_MID:  '#59634e',
  CHITIN_RDG:  '#768369',
  CHITIN_HI:   '#97a488',

  // Biomechanical ribbed cables/hoses (desaturated bronze-slate cords)
  CABLE_OUT:   '#080604',
  CABLE_DRK:   '#231c17',
  CABLE_BASE:  '#362c25',
  CABLE_MID:   '#4f4036',
  CABLE_HL:    '#6d5c50',
  CABLE_HI:    '#8e7b6d',

  MUSCLE_VOID: '#0f172a',
  MUSCLE_BLUE: '#1e293b',
  MUSCLE_LGT:  '#3b82f6',

  CYAN_GLOW:   '#0a91b3',
  CYAN_CORE:   '#38bdf9',
  CYAN_SPEC:   '#e0f2fe'
};

const _BL_PALETTE_CARAPACE = Object.freeze({
  '#': _BL_C_CARAPACE.OUTLINE,
  '%': _BL_C_CARAPACE.CREVICE,
  '=': _BL_C_CARAPACE.CHITIN_SHD,
  '+': _BL_C_CARAPACE.CHITIN_BASE,
  'o': _BL_C_CARAPACE.CHITIN_MIDD,
  'O': _BL_C_CARAPACE.CHITIN_MID,
  '*': _BL_C_CARAPACE.CHITIN_RDG,
  '@': _BL_C_CARAPACE.CHITIN_HI,
  'k': _BL_C_CARAPACE.CABLE_OUT,
  'x': _BL_C_CARAPACE.CABLE_BASE,
  'X': _BL_C_CARAPACE.CABLE_MID,
  's': _BL_C_CARAPACE.CABLE_HL,
  'S': _BL_C_CARAPACE.CABLE_HI,
  'b': _BL_C_CARAPACE.MUSCLE_VOID,
  'B': _BL_C_CARAPACE.MUSCLE_BLUE,
  'c': _BL_C_CARAPACE.CYAN_GLOW,
  'C': _BL_C_CARAPACE.CYAN_CORE,
  'W': _BL_C_CARAPACE.CYAN_SPEC
});

// Hardened alloy shield carapace palette with metallic specular sheen:
// Muted slate base plate (#5c6753), brushed steel-olive plate (#81917a),
// and crisp specular metallic glint / alloy reflection (#d1ded0) on the leading bevels.
const _BL_C_SHIELD = {
  OUTLINE:     '#080a06',
  CREVICE:     '#130d09',
  CHITIN_SHD:  '#231c17',
  CHITIN_BASE: '#362c25',
  CHITIN_MIDD: '#484437',
  CHITIN_MID:  '#5c6753',
  CHITIN_RDG:  '#81917a',
  CHITIN_HI:   '#d1ded0',

  CABLE_OUT:   '#080604',
  CABLE_DRK:   '#231c17',
  CABLE_BASE:  '#362c25',
  CABLE_MID:   '#4f4036',
  CABLE_HL:    '#6d5c50',
  CABLE_HI:    '#8e7b6d',

  MUSCLE_VOID: '#0f172a',
  MUSCLE_BLUE: '#1e293b',
  MUSCLE_LGT:  '#3b82f6',

  CYAN_GLOW:   '#0a91b3',
  CYAN_CORE:   '#38bdf9',
  CYAN_SPEC:   '#e0f2fe'
};

const _BL_PALETTE_SHIELD = Object.freeze({
  '#': _BL_C_SHIELD.OUTLINE,
  '%': _BL_C_SHIELD.CREVICE,
  '=': _BL_C_SHIELD.CHITIN_SHD,
  '+': _BL_C_SHIELD.CHITIN_BASE,
  'o': _BL_C_SHIELD.CHITIN_MIDD,
  'O': _BL_C_SHIELD.CHITIN_MID,
  '*': _BL_C_SHIELD.CHITIN_RDG,
  '@': _BL_C_SHIELD.CHITIN_HI,
  'k': _BL_C_SHIELD.CABLE_OUT,
  'x': _BL_C_SHIELD.CABLE_BASE,
  'X': _BL_C_SHIELD.CABLE_MID,
  's': _BL_C_SHIELD.CABLE_HL,
  'S': _BL_C_SHIELD.CABLE_HI,
  'b': _BL_C_SHIELD.MUSCLE_VOID,
  'B': _BL_C_SHIELD.MUSCLE_BLUE,
  'c': _BL_C_SHIELD.CYAN_GLOW,
  'C': _BL_C_SHIELD.CYAN_CORE,
  'W': _BL_C_SHIELD.CYAN_SPEC
});

// Organic chitin brown & blue muscle sinew palette for articulating arms and crooked hind spider limbs
const _BL_C_LIMBS = {
  OUTLINE:     '#080604',
  CREVICE:     '#130d09',
  CHITIN_SHD:  '#231c17',
  CHITIN_BASE: '#362c25',
  CHITIN_MIDD: '#4f4036',
  CHITIN_MID:  '#6d5c50',
  CHITIN_RDG:  '#8e7b6d',
  CHITIN_HI:   '#ae9c8e',

  MUSCLE_VOID: '#0f172a',
  MUSCLE_BLUE: '#1e293b',
  MUSCLE_LGT:  '#3b82f6',

  CYAN_GLOW:   '#0a91b3',
  CYAN_CORE:   '#38bdf9',
  CYAN_SPEC:   '#e0f2fe'
};

const _BL_PALETTE_LIMBS = Object.freeze({
  '#': _BL_C_LIMBS.OUTLINE,
  '%': _BL_C_LIMBS.CREVICE,
  '=': _BL_C_LIMBS.CHITIN_SHD,
  '+': _BL_C_LIMBS.CHITIN_BASE,
  'o': _BL_C_LIMBS.CHITIN_MIDD,
  'O': _BL_C_LIMBS.CHITIN_MID,
  '*': _BL_C_LIMBS.CHITIN_RDG,
  '@': _BL_C_LIMBS.CHITIN_HI,
  'b': _BL_C_LIMBS.MUSCLE_VOID,
  'B': _BL_C_LIMBS.MUSCLE_BLUE,
  'c': _BL_C_LIMBS.CYAN_GLOW,
  'C': _BL_C_LIMBS.CYAN_CORE,
  'W': _BL_C_LIMBS.CYAN_SPEC
});

const _BL_SHIELD_BACK_LINES = Object.freeze([
  '                                    ',
  '   #                                ',
  '  #o#                               ',
  '  #*#                               ',
  ' #=O@#                              ',
  ' #+*@@#        ##                   ',
  '#=+O@@*#      #+o##                 ',
  '#==+*@@*#    #+oO*+#                ',
  '#%==+o@@o#  #=oO***o#               ',
  '#%%==+o*@*# #=oO***o#               ',
  ' #%==+oO@@# #=oO**Oo#               ',
  ' #%===+o*@*##=oO**Oo#               ',
  '  #%==+oO@@*#=oO**o##               ',
  '  #%===+o*@*#+oO*oo#                ',
  '   #%==+oO*@#=oO*o##                ',
  '   #%===+oO*##==+oo#                ',
  '    #%==+oO*# #%==+#                ',
  '    #%===+oO#  #%==#                ',
  '     #%==+oO*#  ##                  ',
  '   ##bB%==+oO#                      ',
  '  #+bB%%==+oO*#                     ',
  ' #=+o%==+oO*@@#                     ',
  ' #+oX%==+oO*@@#                     ',
  '  #=+oXs+oO*@*#                     ',
  '  #%==+oO*@@*+#                     ',
  '   #%==+o*@@*+#                     ',
  '   #%==+oO*@*#                      ',
  '    #%==+oO*#                       ',
  '    #%===+oO#                       ',
  '     #%==+oO#                       ',
  '     #%===+o#                       ',
  '      #%==+o#                       ',
  '      #%===+#                       ',
  '       #%==+#                       ',
  '       ##%###                       ',
  '         ##                         '
]);

const _BL_BODY_LINES = Object.freeze([
  '                                    ',
  '          kss#                      ',
  '        kxS##kX#      kss#          ',
  '       kxS#  #xS#    kxS#kX#        ',
  '      kxS#    #xS#  ##%kxS#%##      ',
  '    kss#   ####+oo+##xS###+o*#      ',
  '   kxS#   #%oO*@*Oo+#%#*O*@*#       ',
  '  kxS#   #=+O#kssX##O@+#%O*@@#      ',
  '  kxS#  #=kXSkssS#@*@@@%@*@#        ',
  '  kxS#  #kxS##*@%@*O%bBbBb##        ',
  '   kxS# #xS##*@*%*@%bBcCbb#         ',
  '    kxS##kXS#*@*%*@%bCcCWb#         ',
  '     kX##=+kXSS#%@cCCb#             ',
  '        #==#kssX#%bBcCCkss#         ',
  '        #==+oO%*Oo+bBccWWkxS#       ',
  '        #===+o%o**Oo+##%#kxS#       ',
  '         #%==+o%oo**O@o+kxS#        ',
  '          #%===%++ooo+=+kxS#        ',
  '           ##%==========kk#         ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    '
]);

const _BL_SHIELD_FRONT_LINES = Object.freeze([
  '                                    ',
  '                         #          ',
  '                        #o#         ',
  '                        #*#         ',
  '                       #=O@#        ',
  '                      #+*@@#        ',
  '                     #=+O@@*#       ',
  '                    #==+*@@*#       ',
  '                   #%==+o@@o#       ',
  '                  #%%==+o*@*#       ',
  '                 #%==+oO@@*#        ',
  '                  #%===+o*@*#       ',
  '                   #%==+oO@@*#      ',
  '                    #%===+o*@*##    ',
  '                   ##bB==+oO*@@*#   ',
  '                 ##bB==+oO*@@@@*#   ',
  '                #+bB%==+oO*@@@*#    ',
  '               #=+o%===+oO*@@*#     ',
  '              #=+oX%===+oO*@@*#     ',
  '             #bB===+o*@@*#          ',
  '            #+bB==+oO*@@*#          ',
  '            #=+o==+oO*@@*#          ',
  '            #=+oXs+oO*@@##          ',
  '            #%==+oO*@@*#            ',
  '            #%==+oO*@@*#            ',
  '            #%==+oO*@@*#            ',
  '            #%==+oO**Oo#            ',
  '             #%==+oO*O*#            ',
  '             #%==+oo*o#             ',
  '             #%==++o+#              ',
  '              #%==++o+#             ',
  '              #%==++#               ',
  '               #%==+#               ',
  '               ###%##               ',
  '                 ##                 ',
  '                                    '
]);

function _paintBastionLockFromLines(grid, lines, offX = 0, offY = 0, palette = _BL_PALETTE_CARAPACE) {
  for (let y = 0; y < 36; y++) {
    const row = lines[y];
    if (!row) continue;
    const ty = y + offY;
    if (ty < 0 || ty >= 36) continue;
    for (let x = 0; x < 36; x++) {
      const ch = row[x];
      if (!ch || ch === ' ') continue;
      const tx = x + offX;
      if (tx < 0 || tx >= 36) continue;
      grid[ty][tx] = palette[ch] || palette['+'];
    }
  }
}

function _paintHD_BastionLock_Shield_Back(grid, deployed = false, walkPhase = 0) {
  if (deployed) {
    _paintBastionLockFromLines(grid, _BL_SHIELD_BACK_LINES, 8, 1, _BL_PALETTE_SHIELD);
  } else {
    let ox = -2, oy = -2;
    if (walkPhase === 1) { ox = 0; oy = -4; }
    else if (walkPhase === 3) { ox = -3; oy = 0; }
    _paintBastionLockFromLines(grid, _BL_SHIELD_BACK_LINES, ox, oy, _BL_PALETTE_SHIELD);
  }
}

function _paintHD_BastionLock_Body(grid, deployed = false, walkPhase = 0) {
  const oy = deployed ? 1 : ((walkPhase === 2 || walkPhase === 0) ? 0 : -1);
  _paintBastionLockFromLines(grid, _BL_BODY_LINES, 0, oy, _BL_PALETTE_CARAPACE);
}

function _paintHD_BastionLock_Shield_Front(grid, deployed = false, walkPhase = 0) {
  if (deployed) {
    _paintBastionLockFromLines(grid, _BL_SHIELD_FRONT_LINES, 1, 1, _BL_PALETTE_SHIELD);
  } else {
    let ox = 4, oy = 1;
    if (walkPhase === 3) { ox = 6; oy = -1; }
    else if (walkPhase === 1) { ox = 2; oy = 2; }
    _paintBastionLockFromLines(grid, _BL_SHIELD_FRONT_LINES, ox, oy, _BL_PALETTE_SHIELD);
  }
}

const _BL_LEGS_STAND = Object.freeze([
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '          ###        ###            ',
  '         #+o+#      #+O*#           ',
  '        #+o=o#     #+o=O*#          ',
  '       #=+o##     #=+o##O#          ',
  '      ##+=#      ##+O#*#            ',
  '       #=+#       #=O#              ',
  '       #=+#       #=O#              ',
  '        #+#        #+#              ',
  '        #+#        #+#              ',
  '        #%#        #%#              ',
  '        ###        ###              ',
  '         ##         ##              ',
  '                                    '
]);

const _BL_LEGS_WALK1 = Object.freeze([
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '          ###        ###            ',
  '         #+o+#        #+O*#         ',
  '        #+o=+#         #+o=O*#      ',
  '       ##+o#          #=+o##O#      ',
  '        #=+#         ##+O#*#        ',
  '        #=+#          #=O#          ',
  '        #+#           #=O#          ',
  '        #+#            #+#          ',
  '        ###            #+#          ',
  '                       #%#          ',
  '                       ###          ',
  '                        ##          ',
  '                                    '
]);

const _BL_LEGS_WALK2 = Object.freeze([
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '          ###        ###            ',
  '        #+o+#       #+O*#           ',
  '       #+o=o#      #+o=O*#          ',
  '      #=+o##      #=+o##O#          ',
  '     ##+=#       ##+O#*#            ',
  '      #=+#        #=O#              ',
  '      #=+#        #=O#              ',
  '       #+#         #+#              ',
  '       #+#         #+#              ',
  '       #%#         #%#              ',
  '       ###         ###              ',
  '        ##          ##              ',
  '                                    '
]);

const _BL_LEGS_WALK3 = Object.freeze([
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '          ###        ###            ',
  '        #+o+#       #+O*#           ',
  '       #+o=O*#     #+o=+#           ',
  '      #=+o##O#    ##+o#             ',
  '     ##+O#*#       #=+#             ',
  '      #=O#         #=+#             ',
  '      #=O#         #+#              ',
  '       #+#         #+#              ',
  '       #+#         ###              ',
  '       #%#                          ',
  '       ###                          ',
  '        ##                          ',
  '                                    '
]);

const _BL_LEGS_WALK4 = Object.freeze([
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '                                    ',
  '          ###        ###            ',
  '         #+o+#      #+O*#           ',
  '        #+o=o#     #+o=O*#          ',
  '       #=+o##     #=+o##O#          ',
  '      ##+=#      ##+O#*#            ',
  '       #=+#       #=O#              ',
  '       #=+#       #=O#              ',
  '        #+#        #+#              ',
  '        #+#        #+#              ',
  '        #%#        #%#              ',
  '        ###        ###              ',
  '         ##         ##              ',
  '                                    '
]);

function _paintHD_BastionLock_Legs(grid, walkPhase = 0, deployed = false) {
  let lines = _BL_LEGS_STAND;
  if (!deployed) {
    if (walkPhase === 1) lines = _BL_LEGS_WALK1;
    else if (walkPhase === 2) lines = _BL_LEGS_WALK2;
    else if (walkPhase === 3) lines = _BL_LEGS_WALK3;
    else if (walkPhase === 4) lines = _BL_LEGS_WALK4;
  }
  _paintBastionLockFromLines(grid, lines, 0, 0, _BL_PALETTE_LIMBS);
}

function getHD_BastionLock(walkPhase = 0) {
  const g = 36, grid = makeGrid36();
  _paintHD_BastionLock_Shield_Back(grid, false, walkPhase);
  _paintHD_BastionLock_Legs(grid, walkPhase, false);
  _paintHD_BastionLock_Body(grid, false, walkPhase);
  _paintHD_BastionLock_Shield_Front(grid, false, walkPhase);
  return { gridSize: g, grid };
}
function getHD_BastionLock_Walk1() { return getHD_BastionLock(1); }
function getHD_BastionLock_Walk2() { return getHD_BastionLock(2); }
function getHD_BastionLock_Walk3() { return getHD_BastionLock(3); }
function getHD_BastionLock_Walk4() { return getHD_BastionLock(4); }

function getHD_BastionLock_Deployed() {
  const g = 36, grid = makeGrid36();
  _paintHD_BastionLock_Shield_Back(grid, true, 0);
  _paintHD_BastionLock_Legs(grid, 0, true);
  _paintHD_BastionLock_Body(grid, true, 0);
  _paintHD_BastionLock_Shield_Front(grid, true, 0);
  return { gridSize: g, grid };
}

function getHD_BastionLock_Body(deployed = false) {
  const g = 36, grid = makeGrid36();
  _paintHD_BastionLock_Body(grid, deployed, 0);
  return { gridSize: g, grid };
}

function getHD_BastionLock_Shield_Back(deployed = false, walkPhase = 0) {
  const g = 36, grid = makeGrid36();
  _paintHD_BastionLock_Shield_Back(grid, deployed, walkPhase);
  return { gridSize: g, grid };
}

function getHD_BastionLock_Shield_Front(deployed = false, walkPhase = 0) {
  const g = 36, grid = makeGrid36();
  _paintHD_BastionLock_Shield_Front(grid, deployed, walkPhase);
  return { gridSize: g, grid };
}

function getHD_BastionLock_Legs(walkPhase = 0, deployed = false) {
  const g = 36, grid = makeGrid36();
  _paintHD_BastionLock_Legs(grid, walkPhase, deployed);
  return { gridSize: g, grid };
}

function getHD_BastionLock_Legs_Stand() { return getHD_BastionLock_Legs(0, false); }
function getHD_BastionLock_Legs_Walk1() { return getHD_BastionLock_Legs(1, false); }
function getHD_BastionLock_Legs_Walk2() { return getHD_BastionLock_Legs(2, false); }
function getHD_BastionLock_Legs_Walk3() { return getHD_BastionLock_Legs(3, false); }
function getHD_BastionLock_Legs_Walk4() { return getHD_BastionLock_Legs(4, false); }

// ── STICKMAN (48×48 UHD NATIVE RELAUNCH) ──────────────────────
// Slender colossal B1-inspired bipedal walker in strict 90° side profile
// Heavy underslung kinetic siege railgun, articulated rotary knee actuators & 6-phase walkcycle

function _paintHD_Stickman_Torso(grid) {
  const OUT = '#0a0f1d';
  const SHADOW = '#020617';
  const STEEL_DD = '#1e293b';
  const STEEL_D = '#334155';
  const STEEL_M = '#475569';
  const STEEL_L = '#64748b';
  const STEEL_HI = '#94a3b8';
  const STEEL_BRIGHT = '#cbd5e1';
  const STEEL_WHITE = '#f1f5f9';
  const CYAN_CORE = '#e0f2fe';
  const CYAN_BRIGHT = '#00e5ff';
  const CYAN_MID = '#0284c7';
  const CYAN_DARK = '#0369a1';
  const TEAM = 'TEAM'; // Exclusively on the shoulder dome pauldron!

  // 1. Dual Vertical Sensor Antennas (anchored firmly into cranial cap & nape/neck socket)
  // Rear antenna mast (taller beacon with cyan tip, x: 21, y: 1..8 anchored into nape & neck conduit at y: 8..11)
  grid[1][21] = CYAN_CORE;
  grid[2][21] = CYAN_BRIGHT;
  grid[3][21] = STEEL_BRIGHT;
  grid[4][21] = STEEL_HI;
  grid[5][21] = STEEL_L;
  grid[6][21] = STEEL_M;
  grid[7][21] = STEEL_D;
  grid[8][21] = STEEL_DD;
  // Solid nape mounting socket linking antenna seamlessly into skull & neck conduit
  grid[8][20] = OUT;
  grid[9][20] = OUT;
  grid[9][21] = STEEL_D;
  grid[10][20] = OUT;
  grid[10][21] = STEEL_DD;

  // Forward antenna mast (1px ultra-thin wire, x: 24, y: 1..4 rooted directly into cranial top plate at y: 4..5)
  grid[1][24] = STEEL_WHITE;
  grid[2][24] = STEEL_BRIGHT;
  grid[3][24] = STEEL_HI;
  grid[4][24] = STEEL_L;

  // 2. Slender Forward-Angled B1 Mechanical Neck (y: 9..14, x: 19..25) - only 2px metal + 1px outline!
  for (let y = 9; y <= 14; y++) {
    const t = (y - 9) / 5;
    const nx = Math.round(23 - t * 3); // slopes from 23 down to 20
    grid[y][nx - 1] = OUT;
    grid[y][nx] = STEEL_D;
    grid[y][nx + 1] = STEEL_HI;
    grid[y][nx + 2] = OUT;
  }
  // Hydraulic neck conduit
  grid[11][21] = STEEL_DD;
  grid[12][20] = STEEL_DD;

  // 3. Compact Humanoid Robotic Skull & 3-Lens Ocular Cluster (y: 4..11, x: 22..30)
  // Replaces the elongated snout with the authentic humanoid skull from the artwork!
  
  // Cranial cap top plate (y: 4..5, x: 23..28)
  for (let x = 24; x <= 27; x++) grid[4][x] = OUT;
  grid[4][24] = STEEL_D; // Antenna base socket on cranial rim
  grid[5][23] = OUT;
  grid[5][24] = STEEL_HI;
  grid[5][25] = STEEL_BRIGHT;
  grid[5][26] = STEEL_WHITE;
  grid[5][27] = STEEL_BRIGHT;
  grid[5][28] = OUT;

  // Upper skull & Brow rim (y: 6, x: 22..29)
  grid[6][22] = OUT;
  grid[6][23] = STEEL_M;
  grid[6][24] = STEEL_HI;
  grid[6][25] = STEEL_BRIGHT;
  grid[6][26] = STEEL_WHITE;
  grid[6][27] = STEEL_HI;
  grid[6][28] = STEEL_BRIGHT; // Brow ridge
  grid[6][29] = OUT;

  // Mid skull, temple & Eye 1 (Upper optic lens) (y: 7, x: 22..29)
  grid[7][22] = OUT;
  grid[7][23] = STEEL_D;
  grid[7][24] = STEEL_M;
  grid[7][25] = STEEL_HI;
  grid[7][26] = CYAN_DARK; grid[7][27] = CYAN_BRIGHT; // Eye 1 (Upper optic)
  grid[7][28] = STEEL_L;
  grid[7][29] = OUT;

  // Cheek plate & Eyes 2 & 3 (Front & Lower-Mid optics) (y: 8, x: 22..30)
  grid[8][22] = OUT;
  grid[8][23] = STEEL_DD;
  grid[8][24] = STEEL_D;
  grid[8][25] = CYAN_DARK; grid[8][26] = CYAN_CORE;   // Eye 3 (Lower-mid optic)
  grid[8][27] = STEEL_M;
  grid[8][28] = CYAN_DARK; grid[8][29] = CYAN_BRIGHT; // Eye 2 (Front optic)
  grid[8][30] = OUT;

  // Lower cheek & sub-optic sensor / mouthplate (y: 9, x: 23..30)
  grid[9][23] = OUT;
  grid[9][24] = STEEL_DD;
  grid[9][25] = STEEL_D;
  grid[9][26] = CYAN_MID; grid[9][27] = CYAN_CORE;    // Optic flare reflection
  grid[9][28] = STEEL_M;
  grid[9][29] = STEEL_D;
  grid[9][30] = OUT;

  // Angular humanoid jawline & compact chin (y: 10, x: 23..28)
  grid[10][23] = OUT;
  grid[10][24] = STEEL_DD;
  grid[10][25] = STEEL_D;
  grid[10][26] = STEEL_M;
  grid[10][27] = STEEL_HI; // Compact chin point (NO snout!)
  grid[10][28] = OUT;

  // Under-chin & neck joint socket (y: 11, x: 24..27)
  grid[11][24] = OUT;
  grid[11][25] = STEEL_DD;
  grid[11][26] = STEEL_D;
  grid[11][27] = OUT;

  // 4. Compact Spherical Shoulder Pauldron (y: 11..17, x: 15..22 - only 7px wide!)
  // Upper dome rim
  for (let x = 17; x <= 21; x++) grid[11][x] = OUT;
  grid[12][16] = OUT; grid[12][22] = OUT;
  for (let x = 17; x <= 21; x++) grid[12][x] = STEEL_L;

  // Main dome body & EXCLUSIVE TEAM COLOR BADGE ("3 nur schulter")
  for (let y = 13; y <= 15; y++) {
    grid[y][15] = OUT;
    grid[y][16] = STEEL_M;
    // TEAM insignia patch on the curved face of the shoulder dome
    grid[y][17] = TEAM;
    grid[y][18] = TEAM;
    grid[y][19] = TEAM;
    grid[y][20] = STEEL_HI;
    grid[y][21] = STEEL_L;
    grid[y][22] = OUT;
  }
  // Specular sheen on top edge of shoulder
  grid[13][16] = STEEL_BRIGHT; grid[13][20] = STEEL_BRIGHT;

  // Lower pauldron rim (compact spherical dome, rests cleanly behind foreground cannon)
  grid[16][15] = OUT;
  for (let x = 16; x <= 21; x++) grid[16][x] = OUT;
  grid[16][22] = OUT;

  // 5. Rear Backpack / Power Core (x: 12..15, y: 12..17)
  for (let y = 13; y <= 16; y++) {
    grid[y][12] = OUT;
    grid[y][13] = STEEL_DD;
    grid[y][14] = STEEL_D;
    grid[y][15] = STEEL_M;
  }
  grid[12][13] = OUT; grid[12][14] = STEEL_D; grid[12][15] = OUT;
  grid[17][13] = OUT; grid[17][14] = OUT;
  // Heat sink vents on backpack
  grid[14][13] = SHADOW; grid[16][13] = SHADOW;

  // 6. Upper Spine Column (y: 17..19, x: 18..21) - shortened by 3px so legs are longer!
  for (let y = 17; y <= 19; y++) {
    grid[y][18] = OUT;
    grid[y][19] = STEEL_D;
    grid[y][20] = STEEL_HI;
    grid[y][21] = OUT;
  }
}

function _paintHD_Stickman_Chassis(grid) {
  const OUT = '#0a0f1d';
  const SHADOW = '#020617';
  const STEEL_DD = '#1e293b';
  const STEEL_D = '#334155';
  const STEEL_M = '#475569';
  const STEEL_L = '#64748b';
  const STEEL_HI = '#94a3b8';
  const STEEL_BRIGHT = '#cbd5e1';

  // 1. Slender Skeletal Spine (y: 18..21, x: 17..22) - shortened by 3px!
  // Central 2px vertebrae column with alternating mechanical discs
  for (let y = 18; y <= 21; y++) {
    grid[y][18] = OUT;
    grid[y][19] = (y % 2 === 0) ? STEEL_D : STEEL_DD;
    grid[y][20] = (y % 2 === 0) ? STEEL_HI : STEEL_L;
    grid[y][21] = OUT;
  }
  // Delicate 1px hydraulic struts flanking the spine
  for (let y = 19; y <= 21; y++) {
    grid[y][17] = (y % 2 === 0) ? STEEL_HI : STEEL_M;
    grid[y][22] = (y % 2 === 0) ? STEEL_L : STEEL_D;
  }
  grid[18][17] = OUT; grid[18][22] = OUT;

  // 2. Narrow Pelvic Gimbal Hub & Rotary Hip Actuator (y: 22..25, x: 18..22 - narrowed to 5px!)
  // Upper pelvic rim
  grid[22][18] = OUT;
  grid[22][19] = STEEL_M;
  grid[22][20] = STEEL_HI;
  grid[22][21] = STEEL_M;
  grid[22][22] = OUT;

  // Narrow pelvic housing (only 3px metal core: x: 19..21!)
  for (let y = 23; y <= 24; y++) {
    grid[y][18] = OUT;
    grid[y][19] = STEEL_D;
    grid[y][20] = STEEL_BRIGHT;
    grid[y][21] = STEEL_HI;
    grid[y][22] = OUT;
  }

  // Rotary hip socket bearing (compact, narrow hip pivot at y: 24..25)
  grid[25][18] = OUT;
  grid[25][19] = STEEL_BRIGHT;
  grid[25][20] = STEEL_HI;
  grid[25][21] = STEEL_BRIGHT;
  grid[25][22] = OUT;
  grid[26][19] = OUT; grid[26][21] = OUT;
}

function _paintHD_Stickman_Cannon(grid) {
  const OUT = '#0a0f1d';
  const SHADOW = '#020617';
  const STEEL_DD = '#1e293b';
  const STEEL_D = '#334155';
  const STEEL_M = '#475569';
  const STEEL_L = '#64748b';
  const STEEL_HI = '#94a3b8';
  const STEEL_BRIGHT = '#cbd5e1';
  const STEEL_WHITE = '#f1f5f9';
  const CYAN_CORE = '#e0f2fe';
  const CYAN_BRIGHT = '#00e5ff';
  const BRONZE_D = '#78350f';
  const BRONZE_M = '#b45309';

  // ═══════════════════════════════════════════════════════════════════
  // VOLUMINOUS REAR WEAPON HOUSING & REVOLVER MULTI-TUBE ASSEMBLY
  // Based directly on reference artwork:
  // - Cylindrical multi-tube revolver drum / short tubes at rear (x: 4..20, y: 16..24)
  // - Elevated upper rail / cable harness housing (x: 8..17, y: 13..15)
  // - Heavy clamping collars / bands at x: 9 and x: 13
  // - Breech cap & rotary hub at x: 4..6
  // - Front receiver manifold at x: 19..20
  // - Long slender railgun lance barrel (x: 21..44, y: 19..21)
  // - Parallel under-barrel tension rod / brace strut along y: 26 (x: 8..38)
  // - Forward triangular support bracket at x: 36..38 connecting barrel to rod
  // ═══════════════════════════════════════════════════════════════════

  // 1. ELEVATED UPPER RAIL & SIGHT / CABLE HARNESS (y: 13..15, x: 8..17)
  // Top rail edge with specular frost highlight
  for (let x = 9; x <= 16; x++) grid[13][x] = OUT;
  grid[13][10] = STEEL_HI; grid[13][11] = STEEL_BRIGHT; grid[13][12] = STEEL_WHITE;
  grid[13][13] = STEEL_BRIGHT; grid[13][14] = STEEL_HI;

  // Rail body & targeting sensor
  for (let x = 8; x <= 16; x++) {
    grid[14][x] = (x === 8 || x === 16) ? OUT : STEEL_M;
  }
  grid[14][9] = STEEL_HI; grid[14][13] = STEEL_HI; // Strut top anchors
  grid[14][15] = CYAN_BRIGHT; // Targeting emitter / sensor eye

  // Vertical connector struts linking upper rail to cylinder drum
  grid[15][9] = STEEL_D;   grid[15][10] = OUT;
  grid[15][13] = STEEL_D;  grid[15][14] = OUT;
  grid[15][8] = OUT;

  // Flexible power cables curving from backpack/breech into upper assembly
  grid[14][7] = OUT; grid[14][8] = BRONZE_D;
  grid[15][6] = OUT; grid[15][7] = BRONZE_M; grid[15][8] = BRONZE_D;

  // 2. REAR REVOLVER-CYLINDER CLUSTER (Multi-tube rotary drum: x: 4..20, y: 16..24)
  // 3 distinct horizontal cylindrical tube chambers bundled in a revolver arrangement:
  // - Tube 1 (Top chamber): y: 16..17, x: 7..19
  // - Tube 2 (Central main chamber): y: 18..21, x: 4..20
  // - Tube 3 (Bottom chamber): y: 22..24, x: 6..19

  // --- Tube 1 (Top cylinder, y: 16..17) ---
  grid[16][7] = OUT;
  for (let x = 8; x <= 18; x++) {
    grid[16][x] = (x === 9 || x === 13) ? STEEL_BRIGHT : STEEL_HI; // Collar tops vs tube highlight
  }
  grid[16][19] = OUT;

  grid[17][6] = OUT;
  for (let x = 7; x <= 18; x++) {
    grid[17][x] = (x === 9 || x === 13) ? STEEL_M : STEEL_D;
  }
  grid[17][19] = STEEL_DD;

  // Dark longitudinal groove separating Tube 1 and Tube 2
  for (let x = 7; x <= 18; x++) {
    if (x !== 9 && x !== 13) grid[18][x] = SHADOW; // Recessed shadow groove between cylinders
  }

  // --- Tube 2 (Central cylinder / Breech core, y: 18..21) ---
  // Rear breech cap & rotary drum cylinder hub (x: 4..6, y: 18..22)
  grid[18][4] = OUT; grid[18][5] = STEEL_DD; grid[18][6] = STEEL_D;
  grid[19][4] = STEEL_D; grid[19][5] = STEEL_HI; grid[19][6] = STEEL_M;
  grid[20][4] = STEEL_M; grid[20][5] = STEEL_BRIGHT; grid[20][6] = STEEL_HI;
  grid[21][4] = STEEL_D; grid[21][5] = STEEL_HI; grid[21][6] = STEEL_M;
  grid[22][4] = OUT; grid[22][5] = STEEL_DD; grid[22][6] = STEEL_D;
  grid[19][3] = OUT; grid[20][3] = OUT; grid[21][3] = OUT;

  // Central tube body & specular center line
  for (let x = 7; x <= 18; x++) {
    grid[19][x] = (x === 9 || x === 13) ? STEEL_BRIGHT : STEEL_WHITE; // Top specular ridge
    grid[20][x] = (x === 9 || x === 13) ? STEEL_HI : STEEL_BRIGHT;    // Tube center
    grid[21][x] = (x === 9 || x === 13) ? STEEL_M : STEEL_D;          // Under-curve shadow
  }

  // Clamping collars / vertical steel bands at x: 9 and x: 13 (strapping all tubes together!)
  for (let y = 16; y <= 24; y++) {
    grid[y][8] = OUT;
    grid[y][10] = OUT;
    grid[y][12] = OUT;
    grid[y][14] = OUT;
  }

  // Dark longitudinal groove separating Tube 2 and Tube 3
  for (let x = 7; x <= 18; x++) {
    if (x !== 9 && x !== 13) grid[22][x] = SHADOW; // Shadow groove
  }

  // --- Tube 3 (Bottom cylinder, y: 22..24) ---
  grid[22][6] = OUT;
  for (let x = 7; x <= 18; x++) {
    grid[23][x] = (x === 9 || x === 13) ? STEEL_M : STEEL_D;
  }
  grid[23][6] = OUT; grid[23][19] = STEEL_DD;

  for (let x = 7; x <= 18; x++) {
    grid[24][x] = (x === 9 || x === 13) ? STEEL_DD : STEEL_DD;
  }
  grid[24][6] = OUT; grid[24][19] = OUT;
  for (let x = 7; x <= 18; x++) grid[25][x] = OUT;

  // Front manifold block (x: 19..20, y: 17..23) where tubes converge into the barrel
  for (let y = 17; y <= 23; y++) {
    grid[y][19] = (y >= 19 && y <= 21) ? STEEL_HI : STEEL_M;
    grid[y][20] = (y >= 19 && y <= 21) ? STEEL_BRIGHT : STEEL_D;
    grid[y][21] = OUT;
  }

  // 3. ULTRA-SLENDER UNDER-BARREL TENSION ROD / PARALLEL BRACE STRUT (y: 25..26, x: 8..37)
  // Rear diagonal mounting arm dropping down from under the drum (slender 1px)
  grid[25][8] = STEEL_D;
  grid[26][8] = STEEL_M;

  // Ultra-slender 1px polished steel rod along y: 26 (pure 1px line, half perceived thickness!)
  for (let x = 9; x <= 37; x++) {
    grid[26][x] = (x % 3 === 0) ? STEEL_BRIGHT : STEEL_HI; // Slender 1px polished steel wire
  }

  // Slender 1px forward triangular support bracket at x: 37 connecting barrel (y: 21) down to tension rod (y: 26)
  grid[22][37] = OUT;
  grid[23][37] = STEEL_D;
  grid[24][37] = STEEL_M;
  grid[25][37] = STEEL_HI;
  grid[26][37] = STEEL_BRIGHT;

  // 4. MAIN SLENDER RAILGUN LANCE BARREL (y: 19..21, x: 21..44)
  for (let x = 21; x <= 44; x++) {
    grid[19][x] = (x % 3 === 0) ? OUT : ((x % 4 === 0) ? STEEL_BRIGHT : STEEL_HI);
    grid[20][x] = (x % 4 === 0) ? STEEL_WHITE : STEEL_HI;
    grid[21][x] = (x % 2 === 0) ? STEEL_D : OUT;
  }
  grid[18][21] = OUT; grid[18][22] = OUT;

  // 5. MUZZLE BRAKE (y: 19..21, x: 44..47)
  grid[19][45] = OUT; grid[19][46] = OUT;
  grid[20][44] = STEEL_BRIGHT;
  grid[20][45] = CYAN_CORE;
  grid[20][46] = CYAN_BRIGHT;
  grid[20][47] = OUT;
  grid[21][45] = OUT; grid[21][46] = OUT;
}

function _paintHD_Stickman_Legs(grid, phase = 0) {
  const OUT = '#0a0f1d';
  const SHADOW = '#020617';
  const STEEL_DD = '#1e293b';
  const STEEL_D = '#334155';
  const STEEL_M = '#475569';
  const STEEL_L = '#64748b';
  const STEEL_HI = '#94a3b8';
  const STEEL_BRIGHT = '#cbd5e1';
  const STEEL_WHITE = '#f1f5f9';

  // ── ULTRA-FILIGRANE RENDER PRIMITIVES (1px Core + 1px Shadow/Outline) ──

  // Far Leg (Background - 1px deep shadow strut)
  const drawFarThigh = (x0, y0, x1, y1) => {
    const steps = Math.max(1, Math.max(Math.abs(y1 - y0), Math.abs(x1 - x0)));
    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      const y = Math.round(y0 + t * (y1 - y0));
      const cx = Math.round(x0 + t * (x1 - x0));
      grid[y][cx - 1] = OUT;
      grid[y][cx] = STEEL_DD;
      grid[y][cx + 1] = OUT;
    }
  };

  const drawFarShin = (x0, y0, x1, y1) => {
    const steps = Math.max(1, Math.max(Math.abs(y1 - y0), Math.abs(x1 - x0)));
    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      const y = Math.round(y0 + t * (y1 - y0));
      const cx = Math.round(x0 + t * (x1 - x0));
      grid[y][cx - 1] = OUT;
      grid[y][cx] = SHADOW;
      grid[y][cx + 1] = OUT;
    }
  };

  const drawFarKneeDisc = (kx, ky) => {
    // 3x3 circular rotary disc joint in deep shadow
    for (let dy = -1; dy <= 1; dy++) {
      for (let dx = -1; dx <= 1; dx++) {
        grid[ky + dy][kx + dx] = (dx === 0 && dy === 0) ? STEEL_D : STEEL_DD;
      }
    }
    grid[ky - 1][kx - 1] = OUT; grid[ky - 1][kx + 1] = OUT;
    grid[ky + 1][kx - 1] = OUT; grid[ky + 1][kx + 1] = OUT;
  };

  const drawFarFoot = (fx, fy) => {
    // Elongated talon claw in background (longer, not wider - sleek raptor stride!)
    grid[fy][fx - 3] = OUT;
    grid[fy][fx - 2] = SHADOW; // Extended rear heel spur
    grid[fy][fx - 1] = SHADOW;
    grid[fy][fx] = STEEL_DD;
    grid[fy][fx + 1] = STEEL_D; // Forward talon
    grid[fy][fx + 2] = STEEL_D; // Extended forward toe
    grid[fy][fx + 3] = STEEL_M; // Sharp claw tip
    grid[fy][fx + 4] = OUT;
    grid[fy - 1][fx] = STEEL_DD;
  };

  // Near Leg (Foreground - 1px bright specular titanium core + 1px shadow edge)
  const drawNearThigh = (x0, y0, x1, y1) => {
    const steps = Math.max(1, Math.max(Math.abs(y1 - y0), Math.abs(x1 - x0)));
    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      const y = Math.round(y0 + t * (y1 - y0));
      const cx = Math.round(x0 + t * (x1 - x0));
      grid[y][cx - 1] = OUT;
      grid[y][cx] = STEEL_BRIGHT;
      grid[y][cx + 1] = STEEL_M;
      grid[y][cx + 2] = OUT;
    }
  };

  const drawNearShin = (x0, y0, x1, y1) => {
    const steps = Math.max(1, Math.max(Math.abs(y1 - y0), Math.abs(x1 - x0)));
    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      const y = Math.round(y0 + t * (y1 - y0));
      const cx = Math.round(x0 + t * (x1 - x0));
      grid[y][cx - 1] = OUT;
      grid[y][cx] = STEEL_HI;
      grid[y][cx + 1] = STEEL_D;
      grid[y][cx + 2] = OUT;
    }
  };

  const drawNearKneeDisc = (kx, ky) => {
    // Compact 3x3 circular rotary disc joint with center bearing pin
    for (let dy = -1; dy <= 1; dy++) {
      for (let dx = -1; dx <= 1; dx++) {
        grid[ky + dy][kx + dx] = (dx === 0 && dy === 0) ? STEEL_WHITE : STEEL_HI;
      }
    }
    grid[ky - 1][kx - 1] = OUT; grid[ky - 1][kx + 1] = OUT;
    grid[ky + 1][kx - 1] = OUT; grid[ky + 1][kx + 1] = OUT;
    // Slender 1px hydraulic counter-cylinder trailing behind
    grid[ky][kx - 2] = STEEL_BRIGHT;
    grid[ky + 1][kx - 2] = STEEL_M;
  };

  const drawNearFoot = (fx, fy) => {
    // Elongated articulated talon footpad (longer, not wider - sleek raptor stride!)
    grid[fy][fx - 3] = OUT;
    grid[fy][fx - 2] = STEEL_DD; // Extended rear stabilizer spur
    grid[fy][fx - 1] = STEEL_D;
    grid[fy][fx] = STEEL_BRIGHT; // Ankle sole
    grid[fy][fx + 1] = STEEL_HI;
    grid[fy][fx + 2] = STEEL_BRIGHT; // Extended forward talon
    grid[fy][fx + 3] = STEEL_HI;
    grid[fy][fx + 4] = STEEL_BRIGHT;
    grid[fy][fx + 5] = STEEL_WHITE; // Extended sharp toe claw tip!
    grid[fy][fx + 6] = OUT;

    grid[fy - 1][fx - 1] = OUT;
    grid[fy - 1][fx] = STEEL_WHITE; // Ankle pivot bearing
    grid[fy - 1][fx + 1] = STEEL_HI;
    grid[fy - 1][fx + 2] = OUT;
  };

  // Narrower hip sockets (x: 19 & 21) raised to y: 24 (+3px longer thighs!)
  const hipFarX = 19, hipFarY = 24;
  const hipNearX = 21, hipNearY = 24;

  // ── 8 AUTHENTIC MECH WALK PHASES WITH PROLONGED THIGHS & FORWARD-BENT KNEES ──
  if (phase === 0) {
    // Stand / Idle: Towering, majestic stance with iconic forward-flexed knees & longer thighs
    drawFarThigh(hipFarX, hipFarY, 17, 34);
    drawFarKneeDisc(17, 34);
    drawFarShin(17, 35, 15, 43);
    drawFarFoot(15, 44);

    drawNearThigh(hipNearX, hipNearY, 29, 34);
    drawNearKneeDisc(29, 34);
    drawNearShin(29, 35, 25, 43);
    drawNearFoot(25, 44);
  } else if (phase === 1) {
    // Phase 1: Near Leg Forward Heel Strike (Contact at x:27) / Far Leg Rear Push-Off (x:13)
    drawFarThigh(hipFarX, hipFarY, 15, 34);
    drawFarKneeDisc(15, 34);
    drawFarShin(15, 35, 13, 43);
    drawFarFoot(13, 44);

    drawNearThigh(hipNearX, hipNearY, 30, 34);
    drawNearKneeDisc(30, 34);
    drawNearShin(30, 35, 27, 43);
    drawNearFoot(27, 44);
  } else if (phase === 2) {
    // Phase 2: Near Leg Load Compression (x:24, knee flexed forward) / Far Leg Toe Lift (x:16, y:40)
    drawFarThigh(hipFarX, hipFarY, 17, 33);
    drawFarKneeDisc(17, 33);
    drawFarShin(17, 34, 16, 39);
    drawFarFoot(16, 40);

    drawNearThigh(hipNearX, hipNearY, 31, 35);
    drawNearKneeDisc(31, 35);
    drawNearShin(31, 36, 24, 43);
    drawNearFoot(24, 44);
  } else if (phase === 3) {
    // Phase 3: Near Leg Mid-Stance Bearing (x:20, vertical pillar under hip) / Far Leg High Step (x:21, y:38)
    drawFarThigh(hipFarX, hipFarY, 23, 29);
    drawFarKneeDisc(23, 29);
    drawFarShin(23, 30, 21, 37);
    drawFarFoot(21, 38);

    drawNearThigh(hipNearX, hipNearY, 26, 35);
    drawNearKneeDisc(26, 35);
    drawNearShin(26, 36, 20, 43);
    drawNearFoot(20, 44);
  } else if (phase === 4) {
    // Phase 4: Near Leg Push-Off Prep (x:17) / Far Leg Forward Extension Reach (x:26, y:41)
    drawFarThigh(hipFarX, hipFarY, 28, 32);
    drawFarKneeDisc(28, 32);
    drawFarShin(28, 33, 26, 40);
    drawFarFoot(26, 41);

    drawNearThigh(hipNearX, hipNearY, 20, 35);
    drawNearKneeDisc(20, 35);
    drawNearShin(20, 36, 17, 43);
    drawNearFoot(17, 44);
  } else if (phase === 5) {
    // Phase 5: Far Leg Forward Heel Strike (Contact at x:27) / Near Leg Rear Push-Off (x:13)
    drawFarThigh(hipFarX, hipFarY, 28, 34);
    drawFarKneeDisc(28, 34);
    drawFarShin(28, 35, 27, 43);
    drawFarFoot(27, 44);

    drawNearThigh(hipNearX, hipNearY, 16, 34);
    drawNearKneeDisc(16, 34);
    drawNearShin(16, 35, 13, 43);
    drawNearFoot(13, 44);
  } else if (phase === 6) {
    // Phase 6: Far Leg Load Compression (x:24) / Near Leg Toe Lift (x:16, y:40)
    drawFarThigh(hipFarX, hipFarY, 29, 35);
    drawFarKneeDisc(29, 35);
    drawFarShin(29, 36, 24, 43);
    drawFarFoot(24, 44);

    drawNearThigh(hipNearX, hipNearY, 18, 33);
    drawNearKneeDisc(18, 33);
    drawNearShin(18, 34, 16, 39);
    drawNearFoot(16, 40);
  } else if (phase === 7) {
    // Phase 7: Far Leg Mid-Stance Bearing (x:20) / Near Leg High Step (x:21, y:38)
    drawFarThigh(hipFarX, hipFarY, 24, 35);
    drawFarKneeDisc(24, 35);
    drawFarShin(24, 36, 20, 43);
    drawFarFoot(20, 44);

    drawNearThigh(hipNearX, hipNearY, 25, 29);
    drawNearKneeDisc(25, 29);
    drawNearShin(25, 30, 21, 37);
    drawNearFoot(21, 38);
  } else if (phase === 8) {
    // Phase 8: Far Leg Push-Off Prep (x:17) / Near Leg Forward Extension Reach (x:26, y:41)
    drawFarThigh(hipFarX, hipFarY, 18, 35);
    drawFarKneeDisc(18, 35);
    drawFarShin(18, 36, 17, 43);
    drawFarFoot(17, 44);

    drawNearThigh(hipNearX, hipNearY, 30, 32);
    drawNearKneeDisc(30, 32);
    drawNearShin(30, 33, 26, 40);
    drawNearFoot(26, 41);
  } else if (phase === 9) {
    // Phase 9: Dedicated Kneeling Pose for collapse & obstacle
    // Far Leg folded back in shadow
    drawFarThigh(hipFarX, hipFarY, 17, 37);
    drawFarKneeDisc(17, 37);
    drawFarShin(17, 38, 14, 44);
    drawFarFoot(13, 45);

    // Near Leg folded forward in kneel: knee on ground, shin bent back
    drawNearThigh(hipNearX, hipNearY, 30, 42);
    drawNearKneeDisc(30, 42);
    for (let x = 18; x <= 29; x++) {
      grid[43][x] = STEEL_HI;
      grid[44][x] = STEEL_D;
      grid[45][x] = OUT;
    }
    drawNearFoot(18, 44);
  }
}

function _paintHD_Stickman_Obstacle(grid, variation = 1) {
  if (variation === 2) {
    _paintHD_Stickman_Obstacle_V2(grid);
    return;
  }
  if (variation === 3) {
    _paintHD_Stickman_Obstacle_V3(grid);
    return;
  }

  // CRITICAL: Permanent destroyed wreck - Pose 1: The Canonical Sentinel Kneel.
  // 1:1 identical ultra-filigrane 48x48 robot in dramatic collapsed kneeling pose!
  // Preserves ALL contours: slender 1px nape antennas, slumped B1 snout, 7px pauldron,
  // open skeletal spine, long railgun lance planted diagonally into dirt, 3x3 circular knee joints!
  // ZERO white pixels (#ffffff, #fff, #f1f5f9), ZERO glowing cyan (#00e5ff, #00f0ff, #e0f2fe).
  // Dead cold ash optics (#020617, #0f172a)!
  const OUT = '#0a0f1d';
  const SHADOW = '#020617';
  const STEEL_DD = '#1e293b';
  const STEEL_D = '#334155';
  const STEEL_M = '#475569';
  const STEEL_L = '#64748b';
  const STEEL_HI = '#94a3b8';
  const CHAR_SOOT = '#0f172a';

  // 1. Dual Head Antennas (anchored firmly into collapsed skull; 0 white, 0 cyan)
  // Rear antenna (x: 23, y: 6..13 anchored continuously into rear skull plate at y: 13..15)
  grid[6][23] = STEEL_HI;
  grid[7][23] = STEEL_L;
  grid[8][23] = STEEL_M;
  grid[9][23] = STEEL_D;
  grid[10][23] = STEEL_D;
  grid[11][23] = STEEL_DD;
  grid[12][23] = STEEL_DD;
  grid[13][23] = OUT;
  grid[12][22] = OUT; grid[13][22] = OUT; // Nape bracket socket

  // Forward antenna (x: 26, y: 8..13 rooted directly into cranial top plate)
  grid[8][26] = STEEL_HI;
  grid[9][26] = STEEL_L;
  grid[10][26] = STEEL_M;
  grid[11][26] = STEEL_D;
  grid[12][26] = STEEL_DD;
  grid[13][26] = OUT;

  // 2. Slumped Humanoid Robotic Skull (compact profile, tilted forward, y: 13..19, x: 23..30)
  for (let x = 24; x <= 28; x++) grid[13][x] = OUT;
  for (let x = 24; x <= 29; x++) grid[14][x] = STEEL_D;
  for (let x = 23; x <= 30; x++) grid[15][x] = STEEL_M;
  for (let x = 23; x <= 30; x++) grid[16][x] = STEEL_D;
  for (let x = 24; x <= 29; x++) grid[17][x] = STEEL_DD;
  for (let x = 25; x <= 28; x++) grid[18][x] = STEEL_DD;
  for (let x = 25; x <= 28; x++) grid[19][x] = OUT;
  grid[14][23] = OUT; grid[14][30] = OUT;
  grid[15][22] = OUT; grid[15][31] = OUT;
  grid[16][22] = OUT; grid[16][31] = OUT;
  grid[17][23] = OUT; grid[17][30] = OUT;
  grid[18][24] = OUT; grid[18][29] = OUT;

  // Dead Optics: cold, dark, burnt sensor lenses (0 cyan, 0 white)
  grid[15][27] = CHAR_SOOT; grid[15][28] = SHADOW;
  grid[16][29] = CHAR_SOOT; grid[16][30] = SHADOW;
  grid[17][27] = SHADOW;

  // Slumped 2px neck connecting to shoulder
  for (let y = 16; y <= 20; y++) {
    const t = (y - 16) / 4;
    const nx = Math.round(26 - t * 4);
    grid[y][nx - 1] = OUT;
    grid[y][nx] = STEEL_DD;
    grid[y][nx + 1] = STEEL_D;
    grid[y][nx + 2] = OUT;
  }

  // 3. Compact Shoulder Pauldron (slumped at y: 18..24, x: 16..23 - 7px dome)
  for (let x = 18; x <= 22; x++) grid[18][x] = OUT;
  for (let y = 19; y <= 23; y++) {
    grid[y][16] = OUT;
    for (let x = 17; x <= 22; x++) {
      grid[y][x] = (y === 19) ? STEEL_M : (y <= 21 ? STEEL_D : STEEL_DD);
    }
    grid[y][23] = OUT;
  }
  for (let x = 17; x <= 22; x++) grid[24][x] = OUT;
  // Scorch marks
  grid[20][18] = CHAR_SOOT; grid[21][19] = CHAR_SOOT;

  // Rear power pack
  for (let y = 19; y <= 23; y++) {
    grid[y][13] = OUT;
    grid[y][14] = STEEL_DD;
    grid[y][15] = CHAR_SOOT;
  }

  // 4. Voluminous Revolver Railgun Lance Planted Diagonally into Ground (y: 20..46, x: 7..46)
  // --- A. Elevated Upper Rail Assembly (tilted forward at y: 20..22, x: 11..19) ---
  for (let x = 12; x <= 18; x++) grid[20][x] = OUT;
  grid[20][13] = STEEL_M; grid[20][14] = STEEL_HI; grid[20][15] = STEEL_M;
  for (let x = 11; x <= 19; x++) grid[21][x] = (x === 11 || x === 19) ? OUT : STEEL_D;
  grid[21][17] = CHAR_SOOT; // Dead scope optic lens
  grid[22][13] = STEEL_DD; grid[22][16] = STEEL_DD; // Connector struts

  // --- B. Rear Revolver-Cylinder Cluster (y: 22..28, x: 7..20) ---
  // Rear breech cap & cylinder axis cap (x: 7..9, y: 23..27)
  grid[23][7] = OUT; grid[23][8] = STEEL_DD; grid[23][9] = STEEL_D;
  grid[24][7] = STEEL_DD; grid[24][8] = STEEL_D; grid[24][9] = STEEL_M;
  grid[25][6] = OUT; grid[25][7] = STEEL_D; grid[25][8] = STEEL_M; grid[25][9] = STEEL_HI;
  grid[26][7] = STEEL_DD; grid[26][8] = STEEL_D; grid[26][9] = STEEL_M;
  grid[27][7] = OUT; grid[27][8] = STEEL_DD; grid[27][9] = STEEL_D;

  // Top cylinder tube (y: 22..24, x: 10..19)
  for (let x = 10; x <= 18; x++) {
    grid[22][x] = (x === 12 || x === 16) ? STEEL_M : STEEL_D;
    grid[23][x] = (x === 12 || x === 16) ? STEEL_L : STEEL_M;
  }
  // Longitudinal groove between top & middle tube
  for (let x = 10; x <= 18; x++) {
    if (x !== 12 && x !== 16) grid[24][x] = CHAR_SOOT;
  }

  // Central main cylinder tube (y: 25..26, x: 10..19)
  for (let x = 10; x <= 19; x++) {
    grid[25][x] = (x === 12 || x === 16) ? STEEL_HI : STEEL_L;
    grid[26][x] = (x === 12 || x === 16) ? STEEL_M : STEEL_D;
  }
  // Longitudinal groove between middle & bottom tube
  for (let x = 10; x <= 18; x++) {
    if (x !== 12 && x !== 16) grid[27][x] = SHADOW;
  }

  // Bottom cylinder tube (y: 28, x: 10..18)
  for (let x = 10; x <= 18; x++) {
    grid[28][x] = (x === 12 || x === 16) ? STEEL_D : STEEL_DD;
  }
  for (let x = 9; x <= 19; x++) grid[29][x] = OUT;

  // Clamping collars / vertical bands at x: 12 and x: 16
  for (let y = 22; y <= 28; y++) {
    grid[y][11] = OUT;
    grid[y][13] = OUT;
    grid[y][15] = OUT;
    grid[y][17] = OUT;
  }

  // Front manifold collar at x: 20
  for (let y = 23; y <= 27; y++) {
    grid[y][20] = (y === 25) ? STEEL_M : STEEL_D;
    grid[y][21] = OUT;
  }

  // --- C. Lance Barrel angling diagonally down to dirt (20, 25) -> (44, 43) ---
  const barrelLen = 24;
  for (let i = 0; i <= barrelLen; i++) {
    const t = i / barrelLen;
    const bx = Math.round(20 + t * 24); // 20 -> 44
    const by = Math.round(25 + t * 18); // 25 -> 43
    grid[by - 1][bx] = OUT;
    grid[by][bx] = STEEL_D;
    grid[by + 1][bx] = OUT;
  }

  // Under-barrel tension rod angled below the barrel
  const rodLen = 18;
  for (let i = 0; i <= rodLen; i++) {
    const t = i / rodLen;
    const rx = Math.round(18 + t * 18); // 18 -> 36
    const ry = Math.round(29 + t * 13); // 29 -> 42
    grid[ry][rx] = STEEL_DD;
  }
  grid[39][36] = STEEL_DD; grid[40][36] = STEEL_D; grid[41][36] = STEEL_DD;

  // Sleek muzzle brake buried into the dirt at (43..46, 42..45)
  for (let y = 42; y <= 45; y++) {
    grid[y][43] = STEEL_DD;
    grid[y][44] = STEEL_D;
    grid[y][45] = STEEL_M;
    grid[y][46] = OUT;
  }
  grid[46][44] = OUT; grid[46][45] = OUT;

  // 5. Folded Kneeling Robot Legs (Ground level, y: 26..46, x: 14..36)
  // Narrow Pelvis hub (5px wide)
  for (let y = 26; y <= 30; y++) {
    grid[y][19] = OUT;
    for (let x = 20; x <= 23; x++) grid[y][x] = STEEL_DD;
    grid[y][24] = OUT;
  }

  // Near Leg folded in deep kneel:
  // Slender 1-2px thigh sloping down-forward from hip (21, 27) to knee (30, 42) - longer thigh!
  for (let y = 28; y <= 42; y++) {
    const t = (y - 28) / 14;
    const tx = Math.round(21 + t * 9);
    grid[y][tx - 1] = OUT;
    grid[y][tx] = STEEL_D;
    grid[y][tx + 1] = STEEL_M;
    grid[y][tx + 2] = OUT;
  }

  // Compact 3x3 rotary knee joint planted on the ground at (30, 42)
  for (let dy = -1; dy <= 1; dy++) {
    for (let dx = -1; dx <= 1; dx++) {
      grid[42 + dy][30 + dx] = (dx === 0 && dy === 0) ? STEEL_HI : STEEL_M;
    }
  }
  grid[41][29] = OUT; grid[41][31] = OUT;
  grid[43][29] = OUT; grid[43][31] = OUT;

  // Slender Shin & Elongated Foot folded back underneath from knee (30, 43) to ankle/spur (17, 44)
  for (let x = 18; x <= 29; x++) {
    grid[43][x] = STEEL_D;
    grid[44][x] = STEEL_DD;
    grid[45][x] = OUT;
  }
  grid[44][17] = STEEL_D; // Elongated rear heel spur
  grid[44][16] = OUT;
  grid[42][18] = OUT; grid[43][17] = OUT;

  // Far Leg (background, tucked under in deep shadow)
  for (let y = 28; y <= 40; y++) {
    const t = (y - 28) / 12;
    const fx = Math.round(19 - t * 3);
    grid[y][fx - 1] = OUT;
    grid[y][fx] = SHADOW;
    grid[y][fx + 1] = OUT;
  }
  for (let x = 14; x <= 18; x++) {
    grid[42][x] = SHADOW;
    grid[43][x] = STEEL_DD;
    grid[44][x] = OUT;
  }
}

function _paintHD_Stickman_Obstacle_V2(grid) {
  // CRITICAL: Variation 2: The Recoil Slump
  // Mech took a fatal chest impact: slumped lower/backward, snapped rear antenna,
  // railgun lance unseated and lying flatter along the turf, wider knee sprawl.
  const OUT = '#0a0f1d';
  const SHADOW = '#020617';
  const STEEL_DD = '#1e293b';
  const STEEL_D = '#334155';
  const STEEL_M = '#475569';
  const STEEL_L = '#64748b';
  const STEEL_HI = '#94a3b8';
  const CHAR_SOOT = '#0f172a';

  // 1. Antennas (anchored into drooped skull; rear snapped jagged stub, front bent antenna)
  // Rear broken stub (x: 23, y: 12..16 anchored into skull back rim at y: 16)
  grid[12][23] = CHAR_SOOT;
  grid[13][23] = STEEL_D;
  grid[14][23] = STEEL_DD;
  grid[15][23] = STEEL_DD;
  grid[16][23] = OUT;

  // Forward bent antenna (x: 25..26, y: 10..16 anchored into cranial cap at y: 16)
  grid[10][25] = STEEL_HI;
  grid[11][25] = STEEL_L;
  grid[12][26] = STEEL_M;
  grid[13][26] = STEEL_D;
  grid[14][26] = STEEL_DD;
  grid[15][26] = STEEL_DD;
  grid[16][26] = OUT;

  // 2. Drooped Lower Humanoid Skull (drooped lower towards the dirt, y: 16..22, x: 23..30)
  for (let x = 24; x <= 28; x++) grid[16][x] = OUT;
  for (let x = 24; x <= 29; x++) grid[17][x] = STEEL_D;
  for (let x = 23; x <= 30; x++) grid[18][x] = STEEL_M;
  for (let x = 23; x <= 30; x++) grid[19][x] = STEEL_D;
  for (let x = 24; x <= 29; x++) grid[20][x] = STEEL_DD;
  for (let x = 25; x <= 28; x++) grid[21][x] = STEEL_DD;
  for (let x = 25; x <= 28; x++) grid[22][x] = OUT;
  grid[17][23] = OUT; grid[17][30] = OUT;
  grid[18][22] = OUT; grid[18][31] = OUT;
  grid[19][22] = OUT; grid[19][31] = OUT;
  grid[20][23] = OUT; grid[20][30] = OUT;
  grid[21][24] = OUT; grid[21][29] = OUT;

  // Dead Optics (ash/soot, 0 cyan, 0 white)
  grid[18][26] = CHAR_SOOT; grid[18][27] = SHADOW;
  grid[19][28] = CHAR_SOOT; grid[19][29] = SHADOW;
  grid[20][26] = SHADOW;

  // Drooped neck connecting to shoulder
  for (let y = 19; y <= 23; y++) {
    const t = (y - 19) / 4;
    const nx = Math.round(25 - t * 5); // 25 -> 20
    grid[y][nx - 1] = OUT;
    grid[y][nx] = STEEL_DD;
    grid[y][nx + 1] = STEEL_D;
    grid[y][nx + 2] = OUT;
  }

  // 3. Compact Shoulder Pauldron (slumped back slightly at y: 20..26, x: 15..22)
  for (let x = 17; x <= 21; x++) grid[20][x] = OUT;
  for (let y = 21; y <= 25; y++) {
    grid[y][15] = OUT;
    for (let x = 16; x <= 21; x++) {
      grid[y][x] = (y === 21) ? STEEL_M : (y <= 23 ? STEEL_D : STEEL_DD);
    }
    grid[y][22] = OUT;
  }
  for (let x = 16; x <= 21; x++) grid[26][x] = OUT;
  // Heavy scorch crater on pauldron front
  grid[22][17] = CHAR_SOOT; grid[23][18] = CHAR_SOOT; grid[23][17] = SHADOW;

  // Rear power pack
  for (let y = 21; y <= 25; y++) {
    grid[y][12] = OUT;
    grid[y][13] = STEEL_DD;
    grid[y][14] = CHAR_SOOT;
  }

  // 4. Low-Lying Dislodged Voluminous Revolver Railgun Lance (resting flatter along dirt, y: 25..45, x: 4..46)
  // --- A. Low Upper Rail Assembly (y: 25..27, x: 9..17) ---
  for (let x = 10; x <= 16; x++) grid[25][x] = OUT;
  grid[25][11] = STEEL_M; grid[25][12] = STEEL_HI; grid[25][13] = STEEL_M;
  for (let x = 9; x <= 17; x++) grid[26][x] = (x === 9 || x === 17) ? OUT : STEEL_D;
  grid[26][15] = CHAR_SOOT; // Dead scope
  grid[27][10] = STEEL_DD; grid[27][14] = STEEL_DD;

  // --- B. Revolver Drum (y: 27..33, x: 4..20) ---
  // Rear breech cap at x: 4..7, y: 28..32
  grid[28][5] = OUT; grid[28][6] = STEEL_DD; grid[28][7] = STEEL_D;
  grid[29][4] = OUT; grid[29][5] = STEEL_DD; grid[29][6] = STEEL_D; grid[29][7] = STEEL_M;
  grid[30][4] = OUT; grid[30][5] = STEEL_D;  grid[30][6] = STEEL_M; grid[30][7] = STEEL_HI;
  grid[31][4] = OUT; grid[31][5] = STEEL_DD; grid[31][6] = STEEL_D; grid[31][7] = STEEL_M;
  grid[32][5] = OUT; grid[32][6] = STEEL_DD; grid[32][7] = STEEL_D;

  // Top cylinder (y: 27..29, x: 8..18)
  for (let x = 8; x <= 18; x++) {
    grid[27][x] = (x === 10 || x === 14) ? STEEL_M : STEEL_D;
    grid[28][x] = (x === 10 || x === 14) ? STEEL_L : STEEL_M;
  }
  for (let x = 8; x <= 18; x++) {
    if (x !== 10 && x !== 14) grid[29][x] = CHAR_SOOT;
  }

  // Middle cylinder (y: 30..31, x: 8..19)
  for (let x = 8; x <= 19; x++) {
    grid[30][x] = (x === 10 || x === 14) ? STEEL_HI : STEEL_L;
    grid[31][x] = (x === 10 || x === 14) ? STEEL_M : STEEL_D;
  }
  for (let x = 8; x <= 18; x++) {
    if (x !== 10 && x !== 14) grid[32][x] = SHADOW;
  }

  // Bottom cylinder (y: 33, x: 8..18)
  for (let x = 8; x <= 18; x++) {
    grid[33][x] = (x === 10 || x === 14) ? STEEL_D : STEEL_DD;
  }
  for (let x = 7; x <= 19; x++) grid[34][x] = OUT;

  // Clamping collars
  for (let y = 27; y <= 33; y++) {
    grid[y][9] = OUT;
    grid[y][11] = OUT;
    grid[y][13] = OUT;
    grid[y][15] = OUT;
  }
  for (let y = 28; y <= 32; y++) {
    grid[y][20] = (y === 30) ? STEEL_M : STEEL_D;
    grid[y][21] = OUT;
  }

  // --- C. Flat Lance Barrel angling gently from (19, 29) to (44, 41) ---
  const barrelLen = 25;
  for (let i = 0; i <= barrelLen; i++) {
    const t = i / barrelLen;
    const bx = Math.round(19 + t * 25); // 19 -> 44
    const by = Math.round(29 + t * 12); // 29 -> 41
    grid[by - 1][bx] = OUT;
    grid[by][bx] = STEEL_D;
    grid[by + 1][bx] = OUT;
  }

  // Under-barrel rod for V2
  const rodLen = 19;
  for (let i = 0; i <= rodLen; i++) {
    const t = i / rodLen;
    const rx = Math.round(18 + t * 19); // 18 -> 37
    const ry = Math.round(34 + t * 8);  // 34 -> 42
    grid[ry][rx] = STEEL_DD;
  }
  grid[40][37] = STEEL_DD; grid[41][37] = STEEL_D;

  // Muzzle brake lying along ground at (43..46, 40..43)
  for (let y = 40; y <= 43; y++) {
    grid[y][43] = STEEL_DD;
    grid[y][44] = STEEL_D;
    grid[y][45] = STEEL_M;
    grid[y][46] = OUT;
  }
  grid[44][44] = OUT; grid[44][45] = OUT;

  // 5. Folded Legs (Wider forward knee sprawl)
  // Narrow Pelvis hub (5px wide)
  for (let y = 27; y <= 31; y++) {
    grid[y][18] = OUT;
    for (let x = 19; x <= 22; x++) grid[y][x] = STEEL_DD;
    grid[y][23] = OUT;
  }

  // Near Leg folded in wider kneel: thigh slopes from (20, 28) to (33, 42) - longer thigh!
  for (let y = 29; y <= 42; y++) {
    const t = (y - 29) / 13;
    const tx = Math.round(20 + t * 13); // 20 -> 33
    grid[y][tx - 1] = OUT;
    grid[y][tx] = STEEL_D;
    grid[y][tx + 1] = STEEL_M;
    grid[y][tx + 2] = OUT;
  }

  // Knee joint planted at (33, 42)
  for (let dy = -1; dy <= 1; dy++) {
    for (let dx = -1; dx <= 1; dx++) {
      grid[42 + dy][33 + dx] = (dx === 0 && dy === 0) ? STEEL_HI : STEEL_M;
    }
  }
  grid[41][32] = OUT; grid[41][34] = OUT;
  grid[43][32] = OUT; grid[43][34] = OUT;

  // Shin & Elongated Foot folded back underneath from knee (33, 43) to ankle/spur (19, 44)
  for (let x = 20; x <= 32; x++) {
    grid[43][x] = STEEL_D;
    grid[44][x] = STEEL_DD;
    grid[45][x] = OUT;
  }
  grid[44][19] = STEEL_D; // Elongated rear heel spur
  grid[44][18] = OUT;
  grid[42][22] = OUT; grid[43][21] = OUT;

  // Far Leg sprawled backward in deep shadow (x: 11..16, y: 31..44)
  for (let y = 31; y <= 41; y++) {
    const t = (y - 31) / 10;
    const fx = Math.round(18 - t * 5); // 18 -> 13
    grid[y][fx - 1] = OUT;
    grid[y][fx] = SHADOW;
    grid[y][fx + 1] = OUT;
  }
  for (let x = 11; x <= 16; x++) {
    grid[42][x] = SHADOW;
    grid[43][x] = STEEL_DD;
    grid[44][x] = OUT;
  }
}

function _paintHD_Stickman_Obstacle_V3(grid) {
  // CRITICAL: Variation 3: The Steep Tripod Impalement / Forward Collapse
  // Walker dove hard forward; railgun lance drove straight & steep into the ground like a spear,
  // propping the carcass; snout rested directly on breech; compact tucked legs; forward-swept antennas.
  const OUT = '#0a0f1d';
  const SHADOW = '#020617';
  const STEEL_DD = '#1e293b';
  const STEEL_D = '#334155';
  const STEEL_M = '#475569';
  const STEEL_L = '#64748b';
  const STEEL_HI = '#94a3b8';
  const CHAR_SOOT = '#0f172a';

  // 1. Antennas (Swept forward with steep pitch; anchored solidly into skull)
  // Rear antenna (x: 26, y: 6..12 anchored into occipital plate at y: 12..13)
  grid[6][26] = STEEL_HI;
  grid[7][26] = STEEL_L;
  grid[8][26] = STEEL_M;
  grid[9][26] = STEEL_D;
  grid[10][26] = STEEL_DD;
  grid[11][26] = STEEL_DD;
  grid[12][26] = OUT;

  // Forward antenna tilted forward (x: 28..29, y: 7..12 anchored into cranial top plate at y: 12)
  grid[7][29] = STEEL_HI;
  grid[8][29] = STEEL_L;
  grid[9][28] = STEEL_M;
  grid[10][28] = STEEL_D;
  grid[11][28] = STEEL_DD;
  grid[12][28] = OUT;

  // 2. Pitched-Forward Humanoid Skull Rested on Breech (y: 12..18, x: 26..33)
  for (let x = 27; x <= 31; x++) grid[12][x] = OUT;
  for (let x = 27; x <= 32; x++) grid[13][x] = STEEL_D;
  for (let x = 26; x <= 33; x++) grid[14][x] = STEEL_M;
  for (let x = 26; x <= 33; x++) grid[15][x] = STEEL_D;
  for (let x = 27; x <= 32; x++) grid[16][x] = STEEL_DD;
  for (let x = 28; x <= 31; x++) grid[17][x] = STEEL_DD;
  for (let x = 28; x <= 31; x++) grid[18][x] = OUT;
  grid[13][26] = OUT; grid[13][33] = OUT;
  grid[14][25] = OUT; grid[14][34] = OUT;
  grid[15][25] = OUT; grid[15][34] = OUT;
  grid[16][26] = OUT; grid[16][33] = OUT;
  grid[17][27] = OUT; grid[17][32] = OUT;

  // Dead Optics (cold dark soot, 0 cyan, 0 white)
  grid[14][29] = CHAR_SOOT; grid[14][30] = SHADOW;
  grid[15][31] = CHAR_SOOT; grid[15][32] = SHADOW;
  grid[16][29] = SHADOW;

  // Neck connecting to forward pauldron
  for (let y = 15; y <= 19; y++) {
    const t = (y - 15) / 4;
    const nx = Math.round(27 - t * 4); // 27 -> 23
    grid[y][nx - 1] = OUT;
    grid[y][nx] = STEEL_DD;
    grid[y][nx + 1] = STEEL_D;
    grid[y][nx + 2] = OUT;
  }

  // 3. Compact Shoulder Pauldron (pitched forward 2px at y: 17..23, x: 18..25)
  for (let x = 20; x <= 24; x++) grid[17][x] = OUT;
  for (let y = 18; y <= 22; y++) {
    grid[y][18] = OUT;
    for (let x = 19; x <= 24; x++) {
      grid[y][x] = (y === 18) ? STEEL_M : (y <= 20 ? STEEL_D : STEEL_DD);
    }
    grid[y][25] = OUT;
  }
  for (let x = 19; x <= 24; x++) grid[23][x] = OUT;
  // Scorch marks
  grid[19][20] = CHAR_SOOT; grid[20][21] = CHAR_SOOT;

  // Exposed skeletal spine & rear pack
  for (let y = 18; y <= 22; y++) {
    grid[y][15] = OUT;
    grid[y][16] = STEEL_DD;
    grid[y][17] = CHAR_SOOT;
  }

  // 4. Steep Tripod Voluminous Revolver Railgun Lance (impaled deep at ~56° angle into dirt at x: 35..38, y: 43..46)
  // --- A. Upper Rail Assembly (y: 16..18, x: 14..21) ---
  for (let x = 15; x <= 20; x++) grid[16][x] = OUT;
  grid[16][16] = STEEL_M; grid[16][17] = STEEL_HI; grid[16][18] = STEEL_M;
  for (let x = 14; x <= 21; x++) grid[17][x] = (x === 14 || x === 21) ? OUT : STEEL_D;
  grid[17][19] = CHAR_SOOT;
  grid[18][15] = STEEL_DD; grid[18][18] = STEEL_DD;

  // --- B. Tilted Revolver Drum (y: 18..24, x: 10..23) ---
  // Rear breech cap at x: 10..12, y: 19..23
  grid[19][10] = OUT; grid[19][11] = STEEL_DD; grid[19][12] = STEEL_D;
  grid[20][9] = OUT;  grid[20][10] = STEEL_DD; grid[20][11] = STEEL_D; grid[20][12] = STEEL_M;
  grid[21][9] = OUT;  grid[21][10] = STEEL_D;  grid[21][11] = STEEL_M; grid[21][12] = STEEL_HI;
  grid[22][9] = OUT;  grid[22][10] = STEEL_DD; grid[22][11] = STEEL_D; grid[22][12] = STEEL_M;
  grid[23][10] = OUT; grid[23][11] = STEEL_DD; grid[23][12] = STEEL_D;

  // Top cylinder (y: 18..20, x: 13..21)
  for (let x = 13; x <= 21; x++) {
    grid[18][x] = (x === 15 || x === 19) ? STEEL_M : STEEL_D;
    grid[19][x] = (x === 15 || x === 19) ? STEEL_L : STEEL_M;
  }
  for (let x = 13; x <= 21; x++) {
    if (x !== 15 && x !== 19) grid[20][x] = CHAR_SOOT;
  }

  // Middle cylinder (y: 20..22, x: 13..22)
  for (let x = 13; x <= 22; x++) {
    grid[21][x] = (x === 15 || x === 19) ? STEEL_HI : STEEL_L;
    grid[22][x] = (x === 15 || x === 19) ? STEEL_M : STEEL_D;
  }
  for (let x = 13; x <= 21; x++) {
    if (x !== 15 && x !== 19) grid[23][x] = SHADOW;
  }

  // Bottom cylinder (y: 23..24, x: 13..21)
  for (let x = 13; x <= 21; x++) {
    grid[24][x] = (x === 15 || x === 19) ? STEEL_D : STEEL_DD;
  }
  for (let x = 12; x <= 22; x++) grid[25][x] = OUT;

  // Clamping collars
  for (let y = 18; y <= 24; y++) {
    grid[y][14] = OUT;
    grid[y][16] = OUT;
    grid[y][18] = OUT;
    grid[y][20] = OUT;
  }
  for (let y = 19; y <= 23; y++) {
    grid[y][23] = (y === 21) ? STEEL_M : STEEL_D;
    grid[y][24] = OUT;
  }

  // --- C. Steep lance barrel plunging from (22, 22) down to (37, 44) ---
  const barrelLen = 22;
  for (let i = 0; i <= barrelLen; i++) {
    const t = i / barrelLen;
    const bx = Math.round(22 + t * 15); // 22 -> 37
    const by = Math.round(22 + t * 22); // 22 -> 44
    grid[by - 1][bx] = OUT;
    grid[by][bx] = STEEL_D;
    grid[by + 1][bx] = OUT;
  }

  // Under-barrel rod along steep plunge
  const rodLen = 16;
  for (let i = 0; i <= rodLen; i++) {
    const t = i / rodLen;
    const rx = Math.round(20 + t * 14); // 20 -> 34
    const ry = Math.round(26 + t * 18); // 26 -> 44
    grid[ry][rx] = STEEL_DD;
  }
  grid[42][34] = STEEL_DD; grid[43][34] = STEEL_D;

  // Steep buried muzzle brake at (35..38, 43..46)
  for (let y = 43; y <= 46; y++) {
    grid[y][35] = STEEL_DD;
    grid[y][36] = STEEL_D;
    grid[y][37] = STEEL_M;
    grid[y][38] = OUT;
  }
  grid[47][36] = OUT; grid[47][37] = OUT;

  // 5. Compact Tucked Knees (Tightly drawn up under the hull)
  // Narrow Pelvis hub (5px wide)
  for (let y = 25; y <= 29; y++) {
    grid[y][18] = OUT;
    for (let x = 19; x <= 22; x++) grid[y][x] = STEEL_DD;
    grid[y][23] = OUT;
  }

  // Near Leg compact kneel: thigh slopes from (21, 27) down to (27, 42) - longer thigh!
  for (let y = 28; y <= 42; y++) {
    const t = (y - 28) / 14;
    const tx = Math.round(21 + t * 6); // 21 -> 27
    grid[y][tx - 1] = OUT;
    grid[y][tx] = STEEL_D;
    grid[y][tx + 1] = STEEL_M;
    grid[y][tx + 2] = OUT;
  }

  // Knee joint planted at (27, 42)
  for (let dy = -1; dy <= 1; dy++) {
    for (let dx = -1; dx <= 1; dx++) {
      grid[42 + dy][27 + dx] = (dx === 0 && dy === 0) ? STEEL_HI : STEEL_M;
    }
  }
  grid[41][26] = OUT; grid[41][28] = OUT;
  grid[43][26] = OUT; grid[43][28] = OUT;

  // Shin & Elongated Foot folded underneath from knee (27, 43) to ankle/spur (16, 44)
  for (let x = 17; x <= 26; x++) {
    grid[43][x] = STEEL_D;
    grid[44][x] = STEEL_DD;
    grid[45][x] = OUT;
  }
  grid[44][16] = STEEL_D; // Elongated rear heel spur
  grid[44][15] = OUT;
  grid[42][17] = OUT; grid[43][16] = OUT;

  // Far Leg tightly tucked in shadow (x: 14..18, y: 27..43)
  for (let y = 27; y <= 39; y++) {
    const t = (y - 27) / 12;
    const fx = Math.round(18 - t * 3);
    grid[y][fx - 1] = OUT;
    grid[y][fx] = SHADOW;
    grid[y][fx + 1] = OUT;
  }
  for (let x = 14; x <= 18; x++) {
    grid[42][x] = SHADOW;
    grid[43][x] = STEEL_DD;
    grid[44][x] = OUT;
  }
}

function getHD_Stickman_Torso() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Torso(grid);
  return { grid, gridSize: g };
}

function getHD_Stickman_Chassis() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Chassis(grid);
  return { grid, gridSize: g };
}

function getHD_Stickman_Cannon() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Cannon(grid);
  return { grid, gridSize: g };
}

function getHD_Stickman_Legs() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, 0);
  return { grid, gridSize: g };
}

function getHD_Stickman_Legs_Walk1() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, 1);
  return { grid, gridSize: g };
}

function getHD_Stickman_Legs_Walk2() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, 2);
  return { grid, gridSize: g };
}

function getHD_Stickman_Legs_Walk3() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, 3);
  return { grid, gridSize: g };
}

function getHD_Stickman_Legs_Walk4() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, 4);
  return { grid, gridSize: g };
}

function getHD_Stickman_Legs_Walk5() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, 5);
  return { grid, gridSize: g };
}

function getHD_Stickman_Legs_Walk6() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, 6);
  return { grid, gridSize: g };
}

function getHD_Stickman_Legs_Walk7() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, 7);
  return { grid, gridSize: g };
}

function getHD_Stickman_Legs_Walk8() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, 8);
  return { grid, gridSize: g };
}

function getHD_Stickman_Legs_Kneeling() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, 9);
  return { grid, gridSize: g };
}

function getHD_Stickman_Obstacle() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Obstacle(grid, 1);
  return { grid, gridSize: g };
}

function getHD_Stickman_Obstacle_1() {
  return getHD_Stickman_Obstacle();
}

function getHD_Stickman_Obstacle_2() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Obstacle(grid, 2);
  return { grid, gridSize: g };
}

function getHD_Stickman_Obstacle_3() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Obstacle(grid, 3);
  return { grid, gridSize: g };
}

function getHD_Stickman() {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, 0);
  _paintHD_Stickman_Chassis(grid);
  _paintHD_Stickman_Torso(grid);
  const cannonGrid = makeGrid48();
  _paintHD_Stickman_Cannon(cannonGrid);
  // Underslung mount: shift cannon down by 2px so shoulder dome is clearly visible above the weapon
  for (let y = 0; y < 48; y++) {
    for (let x = 0; x < 48; x++) {
      const col = cannonGrid[y][x];
      if (col && y + 2 < 48) {
        grid[y + 2][x] = col;
      }
    }
  }
  return { grid, gridSize: g };
}

function _composeStickmanWalk(walkNum) {
  const g = 48, grid = makeGrid48();
  _paintHD_Stickman_Legs(grid, walkNum);
  _paintHD_Stickman_Chassis(grid);
  _paintHD_Stickman_Torso(grid);
  const cannonGrid = makeGrid48();
  _paintHD_Stickman_Cannon(cannonGrid);
  for (let y = 0; y < 48; y++) {
    for (let x = 0; x < 48; x++) {
      const col = cannonGrid[y][x];
      if (col && y + 2 < 48) {
        grid[y + 2][x] = col;
      }
    }
  }
  return { grid, gridSize: g };
}
function getHD_Stickman_Walk1() { return _composeStickmanWalk(1); }
function getHD_Stickman_Walk2() { return _composeStickmanWalk(2); }
function getHD_Stickman_Walk3() { return _composeStickmanWalk(3); }
function getHD_Stickman_Walk4() { return _composeStickmanWalk(4); }
function getHD_Stickman_Walk5() { return _composeStickmanWalk(5); }
function getHD_Stickman_Walk6() { return _composeStickmanWalk(6); }
function getHD_Stickman_Walk7() { return _composeStickmanWalk(7); }
function getHD_Stickman_Walk8() { return _composeStickmanWalk(8); }

// ── FAITHFUL HD HOT HAND (24x24) ──────────────────────────────
function _paintHD_HotHand_Hair(grid, mode = 0) {
  const D_AMBER = '#78350f';
  const M_AMBER = '#b45309';
  const GOLD_DK = '#d97706';
  const GOLD_MD = '#f59e0b';
  const GOLD_LT = '#fbbf24';
  const SHINE   = '#fef08a';

  if (mode === 1) {
    // Sprint 1: Aerodynamic low-wave trailing locks flowing in slipstream
    // Anchored seamlessly to helmet back at rows 3..5, cols 8..9
    grid[2][5] = GOLD_LT; grid[2][6] = GOLD_MD; grid[2][7] = GOLD_MD; grid[2][8] = M_AMBER;
    grid[3][1] = GOLD_LT; grid[3][2] = SHINE;   grid[3][3] = GOLD_LT; grid[3][4] = GOLD_MD;
    grid[3][5] = GOLD_MD; grid[3][6] = GOLD_DK; grid[3][7] = M_AMBER; grid[3][8] = D_AMBER; grid[3][9] = D_AMBER;
    grid[4][0] = GOLD_MD; grid[4][1] = GOLD_LT; grid[4][2] = SHINE;   grid[4][3] = GOLD_LT;
    grid[4][4] = GOLD_MD; grid[4][5] = GOLD_DK; grid[4][6] = M_AMBER; grid[4][7] = M_AMBER; grid[4][8] = D_AMBER; grid[4][9] = D_AMBER;
    grid[5][1] = M_AMBER; grid[5][2] = GOLD_DK; grid[5][3] = GOLD_MD; grid[5][4] = GOLD_DK;
    grid[5][5] = D_AMBER; grid[5][6] = D_AMBER; grid[5][7] = D_AMBER; grid[5][8] = D_AMBER;
    grid[6][3] = D_AMBER; grid[6][4] = D_AMBER;
  } else if (mode === 2) {
    // Sprint 2: High-crest rippling locks lifted into the airstream
    // Anchored seamlessly to helmet back at rows 3..5, cols 8..9
    grid[1][4] = GOLD_LT; grid[1][5] = SHINE;   grid[1][6] = GOLD_LT;
    grid[2][2] = GOLD_LT; grid[2][3] = SHINE;   grid[2][4] = GOLD_LT; grid[2][5] = GOLD_MD; grid[2][6] = GOLD_DK; grid[2][7] = GOLD_MD; grid[2][8] = M_AMBER;
    grid[3][1] = GOLD_MD; grid[3][2] = GOLD_LT; grid[3][3] = GOLD_MD; grid[3][4] = GOLD_DK; grid[3][5] = M_AMBER; grid[3][6] = GOLD_DK; grid[3][7] = M_AMBER; grid[3][8] = D_AMBER; grid[3][9] = D_AMBER;
    grid[4][2] = M_AMBER; grid[4][3] = GOLD_DK; grid[4][4] = M_AMBER; grid[4][5] = D_AMBER; grid[4][6] = M_AMBER; grid[4][7] = D_AMBER; grid[4][8] = D_AMBER; grid[4][9] = D_AMBER;
    grid[5][4] = D_AMBER; grid[5][5] = D_AMBER; grid[5][6] = D_AMBER; grid[5][7] = D_AMBER; grid[5][8] = D_AMBER;
  } else if (mode === 3) {
    // Whip: Explosive centrifugal flare / upward combat whip
    // Anchored seamlessly to helmet back at rows 3..5, cols 8..9
    grid[0][6] = SHINE;   grid[0][7] = GOLD_LT;
    grid[1][4] = GOLD_LT; grid[1][5] = SHINE;   grid[1][6] = GOLD_LT; grid[1][7] = GOLD_MD;
    grid[2][2] = GOLD_LT; grid[2][3] = SHINE;   grid[2][4] = GOLD_LT; grid[2][5] = GOLD_MD; grid[2][6] = GOLD_DK; grid[2][7] = GOLD_MD; grid[2][8] = M_AMBER;
    grid[3][2] = GOLD_MD; grid[3][3] = GOLD_LT; grid[3][4] = GOLD_MD; grid[3][5] = GOLD_DK; grid[3][6] = M_AMBER; grid[3][7] = D_AMBER; grid[3][8] = D_AMBER; grid[3][9] = D_AMBER;
    grid[4][3] = M_AMBER; grid[4][4] = GOLD_DK; grid[4][5] = M_AMBER; grid[4][6] = D_AMBER; grid[4][7] = D_AMBER; grid[4][8] = D_AMBER; grid[4][9] = D_AMBER;
    grid[5][5] = D_AMBER; grid[5][6] = D_AMBER; grid[5][7] = D_AMBER; grid[5][8] = D_AMBER;
  } else {
    // Mode 0: Standing / cascading idle locks
    grid[3][8] = M_AMBER; grid[3][9] = D_AMBER;
    grid[4][6] = GOLD_MD; grid[4][7] = GOLD_LT; grid[4][8] = GOLD_MD; grid[4][9] = M_AMBER;
    grid[5][5] = GOLD_MD; grid[5][6] = SHINE;   grid[5][7] = GOLD_LT; grid[5][8] = GOLD_MD; grid[5][9] = D_AMBER;
    grid[6][4] = GOLD_DK; grid[6][5] = GOLD_MD; grid[6][6] = GOLD_LT; grid[6][7] = GOLD_MD; grid[6][8] = M_AMBER;
    grid[7][3] = GOLD_DK; grid[7][4] = GOLD_MD; grid[7][5] = SHINE;   grid[7][6] = GOLD_LT; grid[7][7] = M_AMBER;
    grid[8][2] = M_AMBER; grid[8][3] = GOLD_DK; grid[8][4] = GOLD_MD; grid[8][5] = GOLD_DK; grid[8][6] = D_AMBER;
    grid[9][2] = D_AMBER; grid[9][3] = M_AMBER; grid[9][4] = GOLD_DK; grid[9][5] = M_AMBER;
    grid[10][2] = D_AMBER; grid[10][3] = M_AMBER; grid[10][4] = D_AMBER;
    grid[11][3] = D_AMBER;
  }
}

function _paintHD_HotHand_Torso(grid) {
  const C_BLACK = '#050811';
  const C_SLATE = '#0f172a';
  const C_DARK  = '#1e293b';
  const C_MID   = '#334155';
  const C_RIM   = '#475569';

  const RED_GLW = '#ef4444';
  const AMB_GLW = '#f97316';
  const ORG_VIS = '#fbbf24';
  const W_VIS   = '#fef08a';

  grid[2][10] = C_SLATE; grid[2][11] = C_DARK;  grid[2][12] = C_MID;   grid[2][13] = C_SLATE;
  grid[3][9]  = C_SLATE; grid[3][10] = C_DARK;  grid[3][11] = C_MID;   grid[3][12] = C_RIM;   grid[3][13] = C_DARK;  grid[3][14] = C_SLATE;
  grid[4][9]  = C_BLACK; grid[4][10] = C_DARK;  grid[4][11] = RED_GLW; grid[4][12] = AMB_GLW; grid[4][13] = ORG_VIS; grid[4][14] = W_VIS;
  grid[5][9]  = C_BLACK; grid[5][10] = C_SLATE; grid[5][11] = C_DARK;  grid[5][12] = AMB_GLW; grid[5][13] = C_DARK;  grid[5][14] = C_BLACK;
  grid[6][10] = C_BLACK; grid[6][11] = C_SLATE; grid[6][12] = C_DARK;  grid[6][13] = C_BLACK;

  grid[6][8]  = C_SLATE; grid[6][9]  = C_DARK;
  grid[7][7]  = C_SLATE; grid[7][8]  = C_DARK;  grid[7][9]  = C_MID;   grid[7][10] = C_DARK;  grid[7][11] = C_SLATE; grid[7][12] = C_MID; grid[7][13] = C_DARK; grid[7][14] = C_SLATE;

  grid[8][7]  = C_BLACK; grid[8][8]  = C_DARK;  grid[8][9]  = C_MID;   grid[8][10] = RED_GLW; grid[8][11] = C_DARK;  grid[8][12] = C_MID;  grid[8][13] = C_RIM;  grid[8][14] = C_SLATE;
  grid[9][7]  = C_BLACK; grid[9][8]  = C_SLATE; grid[9][9]  = C_DARK;  grid[9][10] = C_MID;   grid[9][11] = RED_GLW; grid[9][12] = C_DARK; grid[9][13] = C_MID;  grid[9][14] = C_BLACK;
  
  grid[10][8] = C_BLACK; grid[10][9] = C_SLATE; grid[10][10] = C_DARK; grid[10][11] = C_MID;  grid[10][12] = C_DARK; grid[10][13] = C_BLACK;
  grid[11][8] = C_BLACK; grid[11][9] = 'TEAM';  grid[11][10] = C_DARK; grid[11][11] = C_DARK; grid[11][12] = 'TEAM'; grid[11][13] = C_BLACK;
  grid[12][8] = C_BLACK; grid[12][9] = 'TEAM';  grid[12][10] = C_MID;  grid[12][11] = C_DARK; grid[12][12] = 'TEAM'; grid[12][13] = C_BLACK;
  grid[13][9] = C_BLACK; grid[13][10] = C_SLATE; grid[13][11] = C_DARK; grid[13][12] = C_SLATE; grid[13][13] = C_BLACK;
}

function _paintHD_HotHand_Arm_Rear(grid) {
  // Tactical left arm in athletic runner / guard posture (drawn behind torso)
  const C_BLACK = '#050811';
  const C_SLATE = '#0f172a';
  const C_DARK  = '#1e293b';
  const C_MID   = '#334155';
  const C_RIM   = '#475569';
  const RED_GLW = '#ef4444';

  grid[7][8]   = C_SLATE; grid[7][9]   = C_DARK;
  grid[8][7]   = C_BLACK; grid[8][8]   = C_DARK;  grid[8][9]   = C_MID;
  grid[9][6]   = C_BLACK; grid[9][7]   = C_DARK;  grid[9][8]   = C_MID;   grid[9][9]   = C_RIM;
  grid[10][6]  = C_BLACK; grid[10][7]  = RED_GLW; grid[10][8]  = C_MID;   grid[10][9]  = C_DARK;
  grid[11][5]  = C_BLACK; grid[11][6]  = C_DARK;  grid[11][7]  = C_MID;   grid[11][8]  = C_DARK;
  grid[12][5]  = C_BLACK; grid[12][6]  = C_SLATE; grid[12][7]  = C_DARK;  grid[12][8]  = C_MID;
  grid[13][6]  = C_BLACK; grid[13][7]  = C_BLACK; grid[13][8]  = C_BLACK;
}

function _paintHD_HotHand_Arm_Guard(grid) {
  grid[8][12]  = '#1e293b'; grid[8][13]  = '#334155';
  grid[9][13]  = '#ff0033'; grid[9][14]  = '#ff5500';
  grid[10][13] = '#ff0033'; grid[10][14] = '#ff5500'; grid[10][15] = '#ffaa00'; grid[10][16] = '#ffffff';
  grid[11][13] = '#ff5500'; grid[11][14] = '#ffaa00'; grid[11][15] = '#ffffff'; grid[11][16] = '#ffea00';
  grid[12][14] = '#ff5500'; grid[12][15] = '#ffaa00'; grid[12][16] = '#ff5500';
}

function _paintHD_HotHand_Arm_Jab(grid) {
  grid[8][11]  = '#1e293b'; grid[8][12]  = '#334155';
  grid[8][13]  = '#ff0033'; grid[8][14]  = '#ff5500'; grid[8][15]  = '#ffaa00'; grid[8][16] = '#ff5500';
  grid[9][12]  = '#334155'; grid[9][13]  = '#ff0033'; grid[9][14]  = '#ff5500'; grid[9][15] = '#ffaa00';
  grid[9][16]  = '#ffea00'; grid[9][17]  = '#ffffff'; grid[9][18]  = '#ffffff'; grid[9][19] = '#ffea00'; grid[9][20] = '#ffaa00';
  grid[10][13] = '#ff0033'; grid[10][14] = '#ff5500'; grid[10][15] = '#ffaa00'; grid[10][16] = '#ffffff';
  grid[10][17] = '#ffea00'; grid[10][18] = '#ffaa00'; grid[10][19] = '#ff5500';
}

function _paintHD_HotHand_Arm_Uppercut(grid) {
  grid[3][14] = '#ffea00'; grid[3][15] = '#ffffff'; grid[3][16] = '#ffffff'; grid[3][17] = '#ffea00';
  grid[4][13] = '#ff5500'; grid[4][14] = '#ffaa00'; grid[4][15] = '#ffffff'; grid[4][16] = '#ffaa00';
  grid[5][13] = '#ff0033'; grid[5][14] = '#ff5500'; grid[5][15] = '#ffaa00';
  grid[6][12] = '#334155'; grid[6][13] = '#ff0033'; grid[6][14] = '#ff5500';
  grid[7][11] = '#1e293b'; grid[7][12] = '#334155'; grid[7][13] = '#ff0033';
  grid[8][10] = '#0f172a'; grid[8][11] = '#1e293b';
}

function _paintHD_HotHand_Arm_Slam(grid) {
  grid[11][12] = '#1e293b'; grid[11][13] = '#334155';
  grid[12][13] = '#ff0033'; grid[12][14] = '#ff5500';
  grid[13][13] = '#ff0033'; grid[13][14] = '#ff5500'; grid[13][15] = '#ffaa00';
  grid[14][14] = '#ff5500'; grid[14][15] = '#ffaa00'; grid[14][16] = '#ffffff'; grid[14][17] = '#ffea00';
  grid[15][14] = '#ffaa00'; grid[15][15] = '#ffffff'; grid[15][16] = '#ffffff'; grid[15][17] = '#ffaa00';
  grid[16][14] = '#ff5500'; grid[16][15] = '#ffaa00'; grid[16][16] = '#ff5500';
}

function _paintHD_HotHand_Legs(grid) {
  const C_BLACK = '#050811';
  const C_SLATE = '#0f172a';
  const C_DARK  = '#1e293b';
  const C_MID   = '#334155';
  const C_RIM   = '#475569';
  const RED_GLW = '#ef4444';

  grid[13][9]  = C_BLACK; grid[13][10] = C_SLATE; grid[13][11] = C_DARK;  grid[13][12] = C_BLACK;
  grid[14][8]  = C_BLACK; grid[14][9]  = C_DARK;  grid[14][10] = C_MID;   grid[14][11] = C_DARK;  grid[14][12] = C_SLATE; grid[14][13] = C_BLACK;

  grid[15][10] = C_DARK;  grid[15][11] = C_MID;   grid[15][12] = C_DARK;
  grid[16][11] = C_SLATE; grid[16][12] = C_MID;   grid[16][13] = C_DARK;
  grid[17][11] = C_DARK;  grid[17][12] = RED_GLW; grid[17][13] = C_MID;
  grid[18][11] = C_DARK;  grid[18][12] = C_MID;   grid[18][13] = C_SLATE;
  grid[19][11] = C_SLATE; grid[19][12] = C_DARK;  grid[19][13] = C_MID;
  grid[20][11] = C_BLACK; grid[20][12] = C_SLATE; grid[20][13] = C_DARK;
  grid[21][11] = C_BLACK; grid[21][12] = C_DARK;  grid[21][13] = C_MID;
  grid[22][11] = C_DARK;  grid[22][12] = C_MID;   grid[22][13] = C_RIM;   grid[22][14] = C_BLACK;
  grid[23][10] = C_BLACK; grid[23][11] = C_DARK;  grid[23][12] = C_BLACK; grid[23][13] = C_BLACK; grid[23][14] = C_BLACK;

  grid[15][8]  = C_SLATE; grid[15][9]  = C_DARK;
  grid[16][7]  = C_BLACK; grid[16][8]  = C_SLATE; grid[16][9]  = C_DARK;
  grid[17][7]  = C_BLACK; grid[17][8]  = C_DARK;
  grid[18][7]  = C_BLACK; grid[18][8]  = C_SLATE;
  grid[19][7]  = C_SLATE; grid[19][8]  = C_DARK;
  grid[20][7]  = C_BLACK; grid[20][8]  = C_SLATE;
  grid[21][6]  = C_BLACK; grid[21][7]  = C_DARK;
  grid[22][6]  = C_DARK;  grid[22][7]  = C_MID;   grid[22][8] = C_BLACK;
  grid[23][5]  = C_BLACK; grid[23][6]  = C_BLACK; grid[23][7] = C_BLACK; grid[23][8] = C_BLACK;
}

function _paintHD_HotHand_Legs_Sprint(grid, frame = 1) {
  const C_BLACK = '#050811';
  const C_SLATE = '#0f172a';
  const C_DARK  = '#1e293b';
  const C_MID   = '#334155';
  const C_RIM   = '#475569';
  const RED_GLW = '#ef4444';

  // Athletic pelvic belt / hip armor (stays centered and solid, seamless with Torso at rows 13..14)
  grid[13][9] = C_BLACK; grid[13][10] = C_SLATE; grid[13][11] = C_DARK; grid[13][12] = C_SLATE; grid[13][13] = C_BLACK;
  grid[14][8] = C_BLACK; grid[14][9]  = C_DARK;  grid[14][10] = C_MID;  grid[14][11] = C_DARK;  grid[14][12] = C_SLATE; grid[14][13] = C_BLACK;

  if (frame === 1) {
    // ── FRAME 1: RIGHT LEG CONTACT (LANDING), LEFT LEG TOE-OFF PUSH WITH BENT KNEE ──
    // Front Leg (Right - foreground with RED_GLW cybernetic knee & shin line)
    // Knee flexed (~145°), landing on ball of foot
    grid[15][11] = C_DARK;  grid[15][12] = C_MID;   grid[15][13] = C_DARK;
    grid[16][12] = C_DARK;  grid[16][13] = C_MID;   grid[16][14] = C_RIM;
    grid[17][13] = C_DARK;  grid[17][14] = RED_GLW; grid[17][15] = C_MID;   grid[17][16] = C_RIM; // flexed knee
    grid[18][14] = C_SLATE; grid[18][15] = RED_GLW; grid[18][16] = C_MID;   grid[18][17] = C_DARK;
    grid[19][14] = C_BLACK; grid[19][15] = C_DARK;  grid[19][16] = C_MID;   grid[19][17] = C_DARK;
    grid[20][15] = C_BLACK; grid[20][16] = C_DARK;  grid[20][17] = C_MID;
    grid[21][15] = C_BLACK; grid[21][16] = C_DARK;  grid[21][17] = C_MID;   grid[21][18] = C_RIM;
    grid[22][15] = C_BLACK; grid[22][16] = C_DARK;  grid[22][17] = C_MID;   grid[22][18] = C_RIM;
    grid[23][15] = C_BLACK; grid[23][16] = C_BLACK; grid[23][17] = C_BLACK; grid[23][18] = C_BLACK;

    // Rear Leg (Left - background): Pushing off with CLEARLY BENT KNEE, heel lifted!
    grid[15][8]  = C_SLATE; grid[15][9]  = C_DARK;
    grid[16][7]  = C_BLACK; grid[16][8]  = C_DARK;  grid[16][9]  = C_MID;
    grid[17][6]  = C_BLACK; grid[17][7]  = C_DARK;  grid[17][8]  = C_SLATE; // knee joint
    grid[18][5]  = C_BLACK; grid[18][6]  = C_DARK;  grid[18][7]  = C_MID;   // knee flex
    grid[19][5]  = C_BLACK; grid[19][6]  = C_DARK;  grid[19][7]  = C_SLATE; // calf angled
    grid[20][4]  = C_BLACK; grid[20][5]  = C_MID;   grid[20][6]  = C_DARK;
    grid[21][4]  = C_BLACK; grid[21][5]  = C_DARK;
    grid[22][3]  = C_BLACK; grid[22][4]  = C_SLATE; grid[22][5]  = C_BLACK; // toe contact
    grid[23][3]  = C_BLACK; grid[23][4]  = C_BLACK;

  } else if (frame === 2) {
    // ── FRAME 2: RIGHT LEG STANCE (DRIVE UNDER HIP), LEFT LEG HIGH HEEL RECOVERY (BUTT-KICK) ──
    // Front Leg (Right - foreground): Power drive under hip
    grid[15][11] = C_DARK;  grid[15][12] = C_MID;   grid[15][13] = C_DARK;
    grid[16][11] = C_SLATE; grid[16][12] = RED_GLW; grid[16][13] = C_MID;
    grid[17][11] = C_DARK;  grid[17][12] = RED_GLW; grid[17][13] = C_MID;   grid[17][14] = C_DARK;
    grid[18][11] = C_BLACK; grid[18][12] = C_DARK;  grid[18][13] = C_MID;   grid[18][14] = C_RIM;
    grid[19][11] = C_BLACK; grid[19][12] = C_DARK;  grid[19][13] = C_MID;
    grid[20][11] = C_BLACK; grid[20][12] = C_DARK;  grid[20][13] = C_MID;
    grid[21][11] = C_BLACK; grid[21][12] = C_DARK;  grid[21][13] = C_MID;   grid[21][14] = C_RIM;
    grid[22][10] = C_BLACK; grid[22][11] = C_DARK;  grid[22][12] = C_MID;   grid[22][13] = C_RIM;   grid[22][14] = C_BLACK;
    grid[23][10] = C_BLACK; grid[23][11] = C_DARK;  grid[23][12] = C_MID;   grid[23][13] = C_BLACK; grid[23][14] = C_BLACK;

    // Rear Leg (Left - background): Tightly folded knee, heel pulls HIGH up behind hip
    grid[15][8]  = C_SLATE; grid[15][9]  = C_DARK;
    grid[16][7]  = C_BLACK; grid[16][8]  = C_DARK;  grid[16][9]  = C_MID;
    grid[17][7]  = C_BLACK; grid[17][8]  = C_DARK;  grid[17][9]  = C_SLATE; // knee
    grid[15][5]  = C_BLACK; grid[15][6]  = C_DARK;  // heel tucked high!
    grid[16][4]  = C_BLACK; grid[16][5]  = C_MID;   grid[16][6]  = C_DARK;  // foot
    grid[17][5]  = C_BLACK; grid[17][6]  = C_DARK;

  } else if (frame === 3) {
    // ── FRAME 3: AIRBORNE FLIGHT A (Left Knee Drives High Forward, Right Leg Trails with Bent Knee in Air) ──
    // Left Leg (background, HIGH KNEE DRIVE up forward):
    grid[15][11] = C_SLATE; grid[15][12] = C_DARK;  grid[15][13] = C_MID;
    grid[16][12] = C_SLATE; grid[16][13] = C_MID;   grid[16][14] = C_DARK;
    grid[17][13] = C_DARK;  grid[17][14] = C_MID;   grid[17][15] = C_DARK; // high knee apex!
    grid[18][13] = C_BLACK; grid[18][14] = C_DARK;  grid[18][15] = C_MID;
    grid[19][12] = C_BLACK; grid[19][13] = C_DARK;  grid[19][14] = C_MID;
    grid[20][12] = C_BLACK; grid[20][13] = C_DARK;  grid[20][14] = C_BLACK;
    grid[21][11] = C_BLACK; grid[21][12] = C_DARK;  grid[21][13] = C_BLACK;

    // Right Leg (foreground, trailing in air with BENT KNEE, foot lifted high!):
    // Thigh extends back:
    grid[15][9]  = C_DARK;  grid[15][10] = C_MID;   grid[15][11] = C_DARK;
    grid[16][8]  = C_SLATE; grid[16][9]  = RED_GLW; grid[16][10] = C_MID;
    grid[17][7]  = C_DARK;  grid[17][8]  = RED_GLW; grid[17][9]  = C_MID;   // bent knee apex!
    // Lower leg bends UPWARD/BACKWARD from knee:
    grid[17][5]  = C_BLACK; grid[17][6]  = C_DARK;  grid[17][7]  = RED_GLW;
    grid[18][4]  = C_BLACK; grid[18][5]  = C_DARK;  grid[18][6]  = C_MID;
    grid[19][3]  = C_BLACK; grid[19][4]  = C_DARK;  grid[19][5]  = C_SLATE;
    grid[20][3]  = C_BLACK; grid[20][4]  = C_DARK;  // pointed toe in air at row 20!
    // Rows 21, 22, 23 ARE COMPLETELY EMPTY for trailing leg! Rows 22, 23 empty for whole frame!

  } else if (frame === 4) {
    // ── FRAME 4: LEFT LEG CONTACT (LANDING), RIGHT LEG TOE-OFF PUSH WITH BENT KNEE ──
    // Front Leg (Left - background): Contact / touchdown on ball of foot
    grid[15][11] = C_SLATE; grid[15][12] = C_DARK;  grid[15][13] = C_MID;
    grid[16][12] = C_SLATE; grid[16][13] = C_DARK;  grid[16][14] = C_MID;
    grid[17][13] = C_DARK;  grid[17][14] = C_MID;   grid[17][15] = C_DARK; // flexed knee
    grid[18][14] = C_SLATE; grid[18][15] = C_DARK;  grid[18][16] = C_MID;   grid[18][17] = C_DARK;
    grid[19][14] = C_BLACK; grid[19][15] = C_DARK;  grid[19][16] = C_MID;   grid[19][17] = C_DARK;
    grid[20][15] = C_BLACK; grid[20][16] = C_DARK;  grid[20][17] = C_MID;
    grid[21][15] = C_BLACK; grid[21][16] = C_DARK;  grid[21][17] = C_MID;
    grid[22][15] = C_BLACK; grid[22][16] = C_DARK;  grid[22][17] = C_MID;
    grid[23][15] = C_BLACK; grid[23][16] = C_BLACK; grid[23][17] = C_BLACK; grid[23][18] = C_BLACK;

    // Rear Leg (Right - foreground): Pushing off with CLEARLY BENT KNEE & RED_GLW
    grid[15][8]  = C_DARK;  grid[15][9]  = C_MID;
    grid[16][7]  = C_DARK;  grid[16][8]  = RED_GLW; grid[16][9]  = C_MID;
    grid[17][6]  = C_DARK;  grid[17][7]  = RED_GLW; grid[17][8]  = C_RIM;   // knee joint
    grid[18][5]  = C_BLACK; grid[18][6]  = RED_GLW; grid[18][7]  = C_MID;   // knee flex
    grid[19][5]  = C_BLACK; grid[19][6]  = C_DARK;  grid[19][7]  = C_MID;   // calf angled
    grid[20][4]  = C_BLACK; grid[20][5]  = C_MID;   grid[20][6]  = C_RIM;
    grid[21][4]  = C_BLACK; grid[21][5]  = C_DARK;
    grid[22][3]  = C_BLACK; grid[22][4]  = C_DARK;  grid[22][5]  = C_BLACK; // toe contact
    grid[23][3]  = C_BLACK; grid[23][4]  = C_BLACK;

  } else if (frame === 5) {
    // ── FRAME 5: LEFT LEG STANCE (DRIVE UNDER HIP), RIGHT LEG HIGH HEEL RECOVERY (BUTT-KICK) ──
    // Front Leg (Left - background): Power drive under hip
    grid[15][11] = C_SLATE; grid[15][12] = C_DARK;  grid[15][13] = C_MID;
    grid[16][11] = C_DARK;  grid[16][12] = C_MID;   grid[16][13] = C_DARK;
    grid[17][11] = C_SLATE; grid[17][12] = C_MID;   grid[17][13] = C_DARK;
    grid[18][11] = C_BLACK; grid[18][12] = C_DARK;  grid[18][13] = C_MID;
    grid[19][11] = C_BLACK; grid[19][12] = C_DARK;  grid[19][13] = C_MID;
    grid[20][11] = C_BLACK; grid[20][12] = C_DARK;  grid[20][13] = C_MID;
    grid[21][11] = C_BLACK; grid[21][12] = C_DARK;  grid[21][13] = C_MID;
    grid[22][10] = C_BLACK; grid[22][11] = C_DARK;  grid[22][12] = C_MID;   grid[22][13] = C_BLACK;
    grid[23][10] = C_BLACK; grid[23][11] = C_DARK;  grid[23][12] = C_MID;   grid[23][13] = C_BLACK; grid[23][14] = C_BLACK;

    // Rear Leg (Right - foreground): Tightly folded knee, heel pulls HIGH up with RED_GLW
    grid[15][8]  = C_DARK;  grid[15][9]  = C_MID;
    grid[16][7]  = C_DARK;  grid[16][8]  = RED_GLW; grid[16][9]  = C_MID;
    grid[17][7]  = C_DARK;  grid[17][8]  = RED_GLW; grid[17][9]  = C_RIM;   // knee
    grid[15][5]  = C_BLACK; grid[15][6]  = C_DARK;  // heel tucked high!
    grid[16][4]  = C_BLACK; grid[16][5]  = C_MID;   grid[16][6]  = RED_GLW; // foot
    grid[17][5]  = C_BLACK; grid[17][6]  = C_DARK;

  } else {
    // ── FRAME 6: AIRBORNE FLIGHT B (Right Knee Drives High Forward, Left Leg Trails with Bent Knee in Air) ──
    // Right Leg (foreground, HIGH KNEE DRIVE up forward with RED_GLW):
    grid[15][11] = C_DARK;  grid[15][12] = C_MID;   grid[15][13] = C_RIM;
    grid[16][12] = C_DARK;  grid[16][13] = RED_GLW; grid[16][14] = C_MID;   grid[16][15] = C_RIM;
    grid[17][13] = C_DARK;  grid[17][14] = RED_GLW; grid[17][15] = C_MID;   grid[17][16] = C_RIM; // high knee apex!
    grid[18][13] = C_BLACK; grid[18][14] = C_DARK;  grid[18][15] = C_MID;
    grid[19][12] = C_BLACK; grid[19][13] = C_DARK;  grid[19][14] = C_MID;
    grid[20][12] = C_BLACK; grid[20][13] = C_DARK;  grid[20][14] = C_BLACK;
    grid[21][11] = C_BLACK; grid[21][12] = C_DARK;  grid[21][13] = C_BLACK;

    // Left Leg (background, trailing in air with BENT KNEE, foot lifted high!):
    // Thigh extends back:
    grid[15][9]  = C_SLATE; grid[15][10] = C_DARK;
    grid[16][8]  = C_BLACK; grid[16][9]  = C_DARK;  grid[16][10] = C_MID;
    grid[17][7]  = C_BLACK; grid[17][8]  = C_DARK;  grid[17][9]  = C_SLATE; // bent knee apex!
    // Lower leg bends UPWARD/BACKWARD from knee:
    grid[17][5]  = C_BLACK; grid[17][6]  = C_DARK;  grid[17][7]  = C_SLATE;
    grid[18][4]  = C_BLACK; grid[18][5]  = C_DARK;  grid[18][6]  = C_MID;
    grid[19][3]  = C_BLACK; grid[19][4]  = C_DARK;  grid[19][5]  = C_SLATE;
    grid[20][3]  = C_BLACK; grid[20][4]  = C_DARK;  // pointed toe in air at row 20!
    // Rows 21, 22, 23 ARE COMPLETELY EMPTY for trailing leg! Rows 22, 23 empty for whole frame!
  }
}

function _paintHD_HotHand_Legs_Slide(grid) {
  const C_BLACK = '#050811';
  const C_SLATE = '#0f172a';
  const C_DARK  = '#1e293b';
  const C_MID   = '#334155';
  const C_RIM   = '#475569';
  const RED_GLW = '#ef4444';

  grid[15][9]  = C_BLACK; grid[15][10] = C_SLATE; grid[15][11] = C_DARK;
  grid[16][9]  = C_DARK;  grid[16][10] = C_MID;   grid[16][11] = C_DARK;
  grid[17][10] = C_SLATE; grid[17][11] = C_MID;   grid[17][12] = C_DARK;  grid[17][13] = C_BLACK;
  grid[18][11] = C_DARK;  grid[18][12] = RED_GLW; grid[18][13] = C_MID;   grid[18][14] = C_DARK;
  grid[19][12] = C_DARK;  grid[19][13] = C_MID;   grid[19][14] = C_SLATE; grid[19][15] = C_DARK;
  grid[20][12] = C_BLACK; grid[20][13] = C_SLATE; grid[20][14] = C_MID;   grid[20][15] = C_RIM;   grid[20][16] = C_BLACK;
  grid[21][11] = C_BLACK; grid[21][12] = C_DARK;  grid[21][13] = C_MID;   grid[21][14] = C_DARK;  grid[21][15] = C_BLACK;
  grid[22][10] = C_BLACK; grid[22][11] = C_DARK;  grid[22][12] = C_MID;   grid[22][13] = C_BLACK;
  grid[23][10] = C_BLACK; grid[23][11] = C_BLACK; grid[23][12] = C_BLACK;

  grid[18][7]  = C_BLACK; grid[18][8]  = C_DARK;
  grid[19][6]  = C_BLACK; grid[19][7]  = C_DARK;  grid[19][8]  = C_SLATE;
  grid[20][5]  = C_BLACK; grid[20][6]  = C_DARK;  grid[20][7]  = C_MID;
  grid[21][4]  = C_BLACK; grid[21][5]  = C_DARK;  grid[21][6]  = C_SLATE;
  grid[22][3]  = C_BLACK; grid[22][4]  = C_DARK;  grid[22][5]  = C_MID;   grid[22][6]  = C_BLACK;
  grid[23][2]  = C_BLACK; grid[23][3]  = C_BLACK; grid[23][4]  = C_BLACK; grid[23][5]  = C_BLACK;
}

function _paintHD_HotHand_Legs_Roll(grid, frame = 1) {
  const C_BLACK = '#050811';
  const C_SLATE = '#0f172a';
  const C_DARK  = '#1e293b';
  const C_MID   = '#334155';
  const RED_GLW = '#ef4444';

  if (frame === 1) {
    grid[14][9]  = C_BLACK; grid[14][10] = C_DARK;  grid[14][11] = C_MID;   grid[14][12] = C_BLACK;
    grid[15][8]  = C_BLACK; grid[15][9]  = C_DARK;  grid[15][10] = RED_GLW; grid[15][11] = C_MID;   grid[15][12] = C_BLACK;
    grid[16][7]  = C_BLACK; grid[16][8]  = C_DARK;  grid[16][9]  = C_MID;   grid[16][10] = C_DARK;  grid[16][11] = C_BLACK;
    grid[17][6]  = C_BLACK; grid[17][7]  = C_DARK;  grid[17][8]  = C_MID;   grid[17][9]  = C_SLATE;
    grid[18][7]  = C_BLACK; grid[18][8]  = C_DARK;  grid[18][9]  = C_MID;   grid[18][10] = C_BLACK;
    grid[19][8]  = C_BLACK; grid[19][9]  = C_DARK;  grid[19][10] = C_BLACK;
  } else if (frame === 2) {
    grid[11][8]  = C_BLACK; grid[11][9]  = C_DARK;  grid[11][10] = C_MID;   grid[11][11] = C_BLACK;
    grid[12][7]  = C_BLACK; grid[12][8]  = C_DARK;  grid[12][9]  = RED_GLW; grid[12][10] = C_MID;   grid[12][11] = C_BLACK;
    grid[13][6]  = C_BLACK; grid[13][7]  = C_SLATE; grid[13][8]  = C_DARK;  grid[13][9]  = C_MID;   grid[13][10] = C_BLACK;
    grid[14][6]  = C_BLACK; grid[14][7]  = C_DARK;  grid[14][8]  = C_MID;   grid[14][9]  = C_SLATE;
    grid[15][7]  = C_BLACK; grid[15][8]  = C_DARK;  grid[15][9]  = C_BLACK;
  } else if (frame === 3) {
    grid[13][10] = C_BLACK; grid[13][11] = C_DARK;  grid[13][12] = C_MID;   grid[13][13] = C_BLACK;
    grid[14][11] = C_DARK;  grid[14][12] = RED_GLW; grid[14][13] = C_MID;   grid[14][14] = C_BLACK;
    grid[15][12] = C_SLATE; grid[15][13] = C_MID;   grid[15][14] = C_DARK;  grid[15][15] = C_BLACK;
    grid[16][13] = C_BLACK; grid[16][14] = C_DARK;  grid[16][15] = C_MID;   grid[16][16] = C_BLACK;
    grid[17][14] = C_BLACK; grid[17][15] = C_DARK;  grid[17][16] = C_BLACK;
  } else {
    grid[15][10] = C_DARK;  grid[15][11] = C_MID;   grid[15][12] = C_DARK;
    grid[16][11] = C_SLATE; grid[16][12] = C_MID;   grid[16][13] = C_DARK;
    grid[17][11] = C_DARK;  grid[17][12] = RED_GLW; grid[17][13] = C_MID;
    grid[18][12] = C_SLATE; grid[18][13] = C_MID;   grid[18][14] = C_DARK;
    grid[19][12] = C_BLACK; grid[19][13] = C_DARK;  grid[19][14] = C_MID;
    grid[20][12] = C_BLACK; grid[20][13] = C_DARK;  grid[20][14] = C_MID;   grid[20][15] = C_BLACK;
    grid[21][12] = C_BLACK; grid[21][13] = C_DARK;  grid[21][14] = C_MID;   grid[21][15] = C_BLACK;
    grid[22][12] = C_BLACK; grid[22][13] = C_BLACK; grid[22][14] = C_BLACK; grid[22][15] = C_BLACK;
  }
}

function makeHotHandGold(base) {
  const g = 24, grid = makeGrid();
  const bg = base.grid;
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      const c = bg[y][x];
      if (!c) continue;
      if (c === '#050811') grid[y][x] = '#451a03';
      else if (c === '#0f172a') grid[y][x] = '#78350f';
      else if (c === '#1e293b') grid[y][x] = '#b45309';
      else if (c === '#334155') grid[y][x] = '#f59e0b';
      else if (c === '#475569') grid[y][x] = '#fde047';
      else if (c === '#64748b') grid[y][x] = '#fef08a';
      else if (c === '#ef4444') grid[y][x] = '#ffaa00';
      else if (c === '#f97316') grid[y][x] = '#ffea00';
      else grid[y][x] = c;
    }
  }
  return { grid, gridSize: g };
}

function getHD_HotHand_Hair(mode = 0) { const g = 24, grid = makeGrid(); _paintHD_HotHand_Hair(grid, mode); return { grid, gridSize: g }; }
function getHD_HotHand_Hair_Sprint() { return getHD_HotHand_Hair(1); }
function getHD_HotHand_Hair_Sprint1() { return getHD_HotHand_Hair(1); }
function getHD_HotHand_Hair_Sprint2() { return getHD_HotHand_Hair(2); }
function getHD_HotHand_Hair_Whip() { return getHD_HotHand_Hair(3); }

function getHD_HotHand_Torso() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Torso(grid); return { grid, gridSize: g }; }
function getHD_HotHand_Arm_Rear() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Arm_Rear(grid); return { grid, gridSize: g }; }
function getHD_HotHand_Arm_Guard() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Arm_Guard(grid); return { grid, gridSize: g }; }
function getHD_HotHand_Arm_Jab() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Arm_Jab(grid); return { grid, gridSize: g }; }
function getHD_HotHand_Arm_Uppercut() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Arm_Uppercut(grid); return { grid, gridSize: g }; }
function getHD_HotHand_Arm_Slam() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Arm_Slam(grid); return { grid, gridSize: g }; }

function getHD_HotHand_Legs() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs(grid); return { grid, gridSize: g }; }
function getHD_HotHand_Legs_Sprint1() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs_Sprint(grid, 1); return { grid, gridSize: g }; }
function getHD_HotHand_Legs_Sprint2() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs_Sprint(grid, 2); return { grid, gridSize: g }; }
function getHD_HotHand_Legs_Sprint3() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs_Sprint(grid, 3); return { grid, gridSize: g }; }
function getHD_HotHand_Legs_Sprint4() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs_Sprint(grid, 4); return { grid, gridSize: g }; }
function getHD_HotHand_Legs_Sprint5() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs_Sprint(grid, 5); return { grid, gridSize: g }; }
function getHD_HotHand_Legs_Sprint6() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs_Sprint(grid, 6); return { grid, gridSize: g }; }

function getHD_HotHand_Legs_Slide() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs_Slide(grid); return { grid, gridSize: g }; }
function getHD_HotHand_Legs_Roll1() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs_Roll(grid, 1); return { grid, gridSize: g }; }
function getHD_HotHand_Legs_Roll2() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs_Roll(grid, 2); return { grid, gridSize: g }; }
function getHD_HotHand_Legs_Roll3() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs_Roll(grid, 3); return { grid, gridSize: g }; }
function getHD_HotHand_Legs_Roll4() { const g = 24, grid = makeGrid(); _paintHD_HotHand_Legs_Roll(grid, 4); return { grid, gridSize: g }; }

function getHD_HotHand() {
  const g = 24, grid = makeGrid();
  _paintHD_HotHand_Hair(grid, 0);
  _paintHD_HotHand_Legs(grid);
  _paintHD_HotHand_Torso(grid);
  _paintHD_HotHand_Arm_Guard(grid);
  return { grid, gridSize: g };
}

function _composeHotHandSprint(walkNum) {
  const g = 24, grid = makeGrid();
  _paintHD_HotHand_Hair(grid, (walkNum % 2) + 1);
  _paintHD_HotHand_Legs_Sprint(grid, walkNum);
  _paintHD_HotHand_Torso(grid);
  _paintHD_HotHand_Arm_Guard(grid);
  return { grid, gridSize: g };
}
function getHD_HotHand_Sprint1() { return _composeHotHandSprint(1); }
function getHD_HotHand_Sprint2() { return _composeHotHandSprint(2); }
function getHD_HotHand_Sprint3() { return _composeHotHandSprint(3); }
function getHD_HotHand_Sprint4() { return _composeHotHandSprint(4); }
function getHD_HotHand_Sprint5() { return _composeHotHandSprint(5); }
function getHD_HotHand_Sprint6() { return _composeHotHandSprint(6); }

function getHD_HotHandGold_Sprint1() { return makeHotHandGold(getHD_HotHand_Sprint1()); }
function getHD_HotHandGold_Sprint2() { return makeHotHandGold(getHD_HotHand_Sprint2()); }
function getHD_HotHandGold_Sprint3() { return makeHotHandGold(getHD_HotHand_Sprint3()); }
function getHD_HotHandGold_Sprint4() { return makeHotHandGold(getHD_HotHand_Sprint4()); }
function getHD_HotHandGold_Sprint5() { return makeHotHandGold(getHD_HotHand_Sprint5()); }
function getHD_HotHandGold_Sprint6() { return makeHotHandGold(getHD_HotHand_Sprint6()); }

// Gold Edition Getters
function getHD_HotHandGold() { return makeHotHandGold(getHD_HotHand()); }
function getHD_HotHandGold_Torso() { return makeHotHandGold(getHD_HotHand_Torso()); }
function getHD_HotHandGold_Arm_Rear() { return makeHotHandGold(getHD_HotHand_Arm_Rear()); }
function getHD_HotHandGold_Arm_Guard() { return makeHotHandGold(getHD_HotHand_Arm_Guard()); }
function getHD_HotHandGold_Arm_Jab() { return makeHotHandGold(getHD_HotHand_Arm_Jab()); }
function getHD_HotHandGold_Arm_Uppercut() { return makeHotHandGold(getHD_HotHand_Arm_Uppercut()); }
function getHD_HotHandGold_Arm_Slam() { return makeHotHandGold(getHD_HotHand_Arm_Slam()); }
function getHD_HotHandGold_Legs() { return makeHotHandGold(getHD_HotHand_Legs()); }
function getHD_HotHandGold_Legs_Sprint1() { return makeHotHandGold(getHD_HotHand_Legs_Sprint1()); }
function getHD_HotHandGold_Legs_Sprint2() { return makeHotHandGold(getHD_HotHand_Legs_Sprint2()); }
function getHD_HotHandGold_Legs_Sprint3() { return makeHotHandGold(getHD_HotHand_Legs_Sprint3()); }
function getHD_HotHandGold_Legs_Sprint4() { return makeHotHandGold(getHD_HotHand_Legs_Sprint4()); }
function getHD_HotHandGold_Legs_Sprint5() { return makeHotHandGold(getHD_HotHand_Legs_Sprint5()); }
function getHD_HotHandGold_Legs_Sprint6() { return makeHotHandGold(getHD_HotHand_Legs_Sprint6()); }
function getHD_HotHandGold_Legs_Slide() { return makeHotHandGold(getHD_HotHand_Legs_Slide()); }
function getHD_HotHandGold_Legs_Roll1() { return makeHotHandGold(getHD_HotHand_Legs_Roll1()); }
function getHD_HotHandGold_Legs_Roll2() { return makeHotHandGold(getHD_HotHand_Legs_Roll2()); }
function getHD_HotHandGold_Legs_Roll3() { return makeHotHandGold(getHD_HotHand_Legs_Roll3()); }
function getHD_HotHandGold_Legs_Roll4() { return makeHotHandGold(getHD_HotHand_Legs_Roll4()); }

// ── PINK BERET (24x24 HD Human Slick Soldier) ──────────────────────
// Pure Dynamic Side-Profile Rig (75°-90° angle, facing forward +X).
// Hot pink woolen beret tilted with gleaming gold insignia, handsome profile face,
// open white-gold military coat over chiseled bare chest, flowing coat tails,
// solid 4px legs in white breeches & polished black officer boots,
// heavy 45° rocket launcher with scope & pink heart, poised chrome revolver & rear catwalk arm.

function _paintHD_PinkBeret_Torso(grid) {
  // 1. Sleek, Iconic VIBRANT HOT PINK Military Beret (y: 0..2) - Radiant & Unmistakable!
  // Row 0: Soft puffed woolen crown in saturated hot pink & magenta highlight
  grid[0][5] = '#e11d48'; // rear curve
  grid[0][6] = '#ff1493'; // vibrant electric hot pink
  grid[0][7] = '#ff69b4'; // glowing hot pink crown highlight
  grid[0][8] = '#ff2a85'; // hot pink
  grid[0][9] = '#f43f5e'; // front slope

  // Row 1: Full woolen drape with small golden insignia crest accent
  grid[1][4] = '#be123c'; // rear drape fold
  grid[1][5] = '#e11d48';
  grid[1][6] = '#ff007f'; // pure electric hot pink
  grid[1][7] = '#ff1493'; // hot pink
  grid[1][8] = '#ff2a85'; // hot pink
  grid[1][9] = '#fde047'; // Gold Military Crest Pin (accent on fold)
  grid[1][10] = '#ff1493'; // front drape lip

  // Row 2: Headband & Nape Hair
  grid[2][4] = '#451a03'; // Dark hair at nape
  grid[2][5] = '#9f1239'; // beret fold shadow
  grid[2][6] = '#0f172a'; grid[2][7] = '#0f172a'; grid[2][8] = '#1e293b'; // Snug leather headband
  grid[2][9] = '#ff2a85'; // beret overhang over brow

  // 2. Chiseled Aristocratic Model Face with DESIGNER WHITE SUNGLASSES (y: 2..4)
  grid[2][10] = '#fed7aa'; // Sleek brow / forehead

  // Row 3: Hair temple, BOLD WHITE SUNGLASSES & Sharp Model Nose
  grid[3][4] = '#451a03'; grid[3][5] = '#78350f'; // Dark hair
  grid[3][6] = '#ffffff'; grid[3][7] = '#ffffff'; // WHITE SUNGLASSES: Temple arm & hinge
  grid[3][8] = '#ffffff'; // WHITE SUNGLASSES: Solid bold white frame
  grid[3][9] = '#bae6fd'; // Crystalline ice-blue lens reflection
  grid[3][10] = '#ffffff'; // WHITE SUNGLASSES: Front rim edge
  grid[3][11] = '#fed7aa'; // Sharp aristocratic nose tip!

  // Row 4: Jawline, WHITE SUNGLASSES bottom frame, Sleek Retro Mustache & Closed Mouth
  grid[4][4] = '#451a03'; grid[4][5] = '#78350f'; // Hair nape
  grid[4][6] = '#fba772'; grid[4][7] = '#fed7aa'; // Cheekbone / jaw corner
  grid[4][8] = '#ffffff'; // WHITE SUNGLASSES: Bottom frame contour
  grid[4][9] = '#1e293b'; grid[4][10] = '#1e293b'; // Sleek trimmed mustache over closed mouth line (ends at x: 10, NO downward beak hook at x: 11!)

  // 3. ELEGANT, ATHLETIC SWAN NECK WITH SHARP JAWLINE UNDERCUT (y: 5..6) - No "Dicker Hals"!
  // Row 5: Slender 3-pixel athletic neck column (x: 6..8) with clear undercut beneath chin (x: 9..11 empty air!)
  grid[5][5] = '#451a03'; // Nape hairline
  grid[5][6] = '#ffffff'; // Pristine white high officer collar back
  grid[5][7] = '#fed7aa'; // Slender neck column
  grid[5][8] = '#fba772'; // Sternocleidomastoid throat contour
  // Air under chin at x: 9..11 guarantees clear, sharp profile angle!

  // Row 6: Lower Neck & High Officer Collar Rim
  grid[6][5] = '#cbd5e1'; grid[6][6] = '#ffffff'; // White collar back
  grid[6][7] = '#facc15'; // Gold collar rim
  grid[6][8] = '#fed7aa'; // Throat base
  grid[6][9] = '#ffffff'; // Front collar point

  // 4. LOWERED ATHLETIC SHOULDERS & EPAULETTES (y: 7..8) - Clean anatomical silhouette!
  // Row 7: Clavicles & Epaulette Top Slope (Clean front, ends at x: 9)
  grid[7][5] = '#cbd5e1'; // Luminous coat back slope (no soot/charcoal!)
  grid[7][6] = '#ca8a04'; grid[7][7] = '#fde047'; grid[7][8] = '#facc15'; grid[7][9] = '#ca8a04'; // Epaulette

  // Row 8: Broad Deltoid Epaulette & Upper Chest (Clean front, ends cleanly at x: 10 - NO JUTTING BEAK!)
  grid[8][4] = '#cbd5e1'; grid[8][5] = '#e2e8f0'; // Luminous coat back
  grid[8][6] = '#ca8a04'; grid[8][7] = '#fde047'; grid[8][8] = '#facc15'; // Epaulette cap
  grid[8][9] = '#ffffff'; // White jacket lapel
  grid[8][10] = '#fed7aa'; // Firm upper chest

  // 5. ADONIS TORSO (Smooth, sculptural pectoral shelf & slim waist, y: 9..11)
  // Row 9: Proud Muscular Chest (Pecs) - Ends cleanly at x: 10! ZERO PROTRUSION!
  grid[9][4] = '#94a3b8'; grid[9][5] = '#cbd5e1'; // Coat back in soft periwinkle ambient shadow
  grid[9][6] = '#cbd5e1'; grid[9][7] = '#ffffff'; grid[9][8] = '#facc15'; // White lapel with gold edge
  grid[9][9] = '#fed7aa'; grid[9][10] = '#fba772'; // Sculptural chest apex (clean 2px width at x: 9..10)

  // Row 10: Toned Serratus & Upper Abs (Ends cleanly at x: 10)
  grid[10][4] = '#cbd5e1'; grid[10][5] = '#e2e8f0'; // Coat back (sleek at x: 4, no protrusion!)
  grid[10][6] = '#cbd5e1'; grid[10][7] = '#facc15'; // Lapel
  grid[10][8] = '#fed7aa'; grid[10][9] = '#fba772'; grid[10][10] = '#fba772'; // Defined abs in warm natural skin tone

  // Row 11: Narrow Waist & Lower Six-Pack Abs (Ends cleanly at x: 9)
  grid[11][4] = '#cbd5e1'; grid[11][5] = '#e2e8f0'; // Coat back (sleek at x: 4)
  grid[11][6] = '#cbd5e1'; grid[11][7] = '#facc15'; // Lapel
  grid[11][8] = '#fba772'; grid[11][9] = '#fba772'; // Tapered waist contour

  // 6. High Narrow Gold Officer Belt (y: 12..13) - Ends cleanly at x: 9! NO LOWER PROTRUSION!
  grid[12][4] = '#334155'; grid[12][5] = '#475569';
  grid[12][6] = '#ca8a04'; grid[12][7] = '#fde047'; grid[12][8] = '#facc15'; grid[12][9] = '#ca8a04';
  grid[13][4] = '#1e293b'; grid[13][5] = '#334155';
  grid[13][6] = '#ca8a04'; grid[13][7] = '#facc15'; grid[13][8] = '#ca8a04'; grid[13][9] = '#1e293b';
}

function _paintHD_PinkBeret_Torso_Turn(grid) {
  // 🎖️ PINK BERET 3/4 HEAD TURN (Nonchalant Runway Dance Groove)
  // Torso & open jacket remain in side profile, while head turns ~30°-45° towards the player.
  // Dual-lens white designer sunglasses reflecting ice-blue light, tilted pink beret with gold crest pin, handsome mustache smirk.

  // 1. Sleek, Iconic VIBRANT HOT PINK Military Beret in 3/4 Perspective (y: 0..2)
  // Row 0: Soft puffed woolen crown tilted 3/4
  grid[0][4] = '#e11d48'; grid[0][5] = '#ff1493'; grid[0][6] = '#ff69b4'; grid[0][7] = '#ff69b4';
  grid[0][8] = '#ff1493'; grid[0][9] = '#ff2a85'; grid[0][10] = '#f43f5e';

  // Row 1: Woolen drape with Centered Gold Military Crest Pin (x: 8)
  grid[1][4] = '#be123c'; grid[1][5] = '#e11d48'; grid[1][6] = '#ff007f'; grid[1][7] = '#ff1493';
  grid[1][8] = '#fde047'; grid[1][9] = '#facc15'; grid[1][10] = '#ff1493'; grid[1][11] = '#be123c';

  // Row 2: Headband, dark hair & brow
  grid[2][4] = '#451a03'; grid[2][5] = '#9f1239'; grid[2][6] = '#0f172a'; grid[2][7] = '#fed7aa';
  grid[2][8] = '#fed7aa'; grid[2][9] = '#fed7aa'; grid[2][10] = '#ff2a85';

  // 2. Chiseled Face with DUAL-LENS DESIGNER WHITE SUNGLASSES in 3/4 View (y: 3..4)
  // Row 3: Both ice-blue crystalline lenses reflecting camera light!
  grid[3][4] = '#451a03'; // left hair temple
  grid[3][5] = '#ffffff'; // left white frame rim
  grid[3][6] = '#bae6fd'; // left ice-blue lens reflection!
  grid[3][7] = '#ffffff'; // bold white frame center bridge
  grid[3][8] = '#bae6fd'; // right ice-blue lens reflection!
  grid[3][9] = '#ffffff'; // right white frame outer rim
  grid[3][10] = '#fed7aa'; // sharp aristocratic cheekbone catchlight

  // Row 4: 3/4 Jawline & Sleek Retro Mustache with subtle playful smirk
  grid[4][4] = '#451a03'; // hair
  grid[4][5] = '#fba772'; // left jaw contour
  grid[4][6] = '#fed7aa'; // cheekbone
  grid[4][7] = '#ffffff'; // white frame bottom bridge accent
  grid[4][8] = '#1e293b'; // trimmed mustache left wing
  grid[4][9] = '#1e293b'; // trimmed mustache center
  grid[4][10] = '#fba772'; // chiseled right jaw edge

  // 3. Swan Neck, High Officer Collar, Deltoids, Adonis Pecs & Belt (y: 5..13)
  // Row 5: Swan neck
  grid[5][5] = '#451a03'; grid[5][6] = '#ffffff'; grid[5][7] = '#fed7aa'; grid[5][8] = '#fba772';

  // Row 6: Officer collar rim
  grid[6][5] = '#cbd5e1'; grid[6][6] = '#ffffff'; grid[6][7] = '#facc15'; grid[6][8] = '#fed7aa'; grid[6][9] = '#ffffff';

  // Row 7: Epaulettes
  grid[7][5] = '#cbd5e1'; grid[7][6] = '#ca8a04'; grid[7][7] = '#fde047'; grid[7][8] = '#facc15'; grid[7][9] = '#ca8a04';

  // Row 8: Broad Deltoid Epaulette & Upper Chest
  grid[8][4] = '#cbd5e1'; grid[8][5] = '#e2e8f0'; grid[8][6] = '#ca8a04'; grid[8][7] = '#fde047'; grid[8][8] = '#facc15';
  grid[8][9] = '#ffffff'; grid[8][10] = '#fed7aa';

  // Row 9: Muscular Pecs
  grid[9][4] = '#94a3b8'; grid[9][5] = '#cbd5e1'; grid[9][6] = '#cbd5e1'; grid[9][7] = '#ffffff'; grid[9][8] = '#facc15';
  grid[9][9] = '#fed7aa'; grid[9][10] = '#fba772';

  // Row 10: Toned Abs
  grid[10][4] = '#cbd5e1'; grid[10][5] = '#e2e8f0'; grid[10][6] = '#cbd5e1'; grid[10][7] = '#facc15';
  grid[10][8] = '#fed7aa'; grid[10][9] = '#fba772'; grid[10][10] = '#fba772';

  // Row 11: Narrow Waist
  grid[11][4] = '#cbd5e1'; grid[11][5] = '#e2e8f0'; grid[11][6] = '#cbd5e1'; grid[11][7] = '#facc15';
  grid[11][8] = '#fba772'; grid[11][9] = '#fba772';

  // Row 12..13: High Narrow Gold Officer Belt
  grid[12][4] = '#334155'; grid[12][5] = '#475569';
  grid[12][6] = '#ca8a04'; grid[12][7] = '#fde047'; grid[12][8] = '#facc15'; grid[12][9] = '#ca8a04';
  grid[13][4] = '#1e293b'; grid[13][5] = '#334155';
  grid[13][6] = '#ca8a04'; grid[13][7] = '#facc15'; grid[13][8] = '#ca8a04'; grid[13][9] = '#1e293b';
}

function _paintHD_PinkBeret_Legs_Crouch(grid) {
  // Solid Pelvis Connection (y: 12..13) - ZERO GAP WITH TORSO, CLEAN AT WAIST (matching belt x: 4..9)
  grid[12][4] = '#334155'; grid[12][5] = '#475569';
  grid[12][6] = '#ca8a04'; grid[12][7] = '#fde047'; grid[12][8] = '#facc15'; grid[12][9] = '#ca8a04';
  grid[13][4] = '#1e293b'; grid[13][5] = '#334155';
  grid[13][6] = '#ca8a04'; grid[13][7] = '#facc15'; grid[13][8] = '#ca8a04'; grid[13][9] = '#1e293b';

  // Rear leg: flexed knee at y: 17..18, x: 3..5
  grid[14][4] = '#94a3b8'; grid[14][5] = '#cbd5e1'; grid[14][6] = '#e2e8f0';
  grid[15][3] = '#94a3b8'; grid[15][4] = '#cbd5e1'; grid[15][5] = '#e2e8f0';
  grid[16][3] = '#94a3b8'; grid[16][4] = '#cbd5e1'; grid[16][5] = '#e2e8f0';
  grid[17][3] = '#94a3b8'; grid[17][4] = '#cbd5e1'; grid[17][5] = '#e2e8f0';
  grid[18][3] = '#1e293b'; grid[18][4] = '#334155'; grid[18][5] = '#475569';
  grid[19][3] = '#0f172a'; grid[19][4] = '#1e293b'; grid[19][5] = '#334155';
  grid[20][3] = '#0f172a'; grid[20][4] = '#1e293b'; grid[20][5] = '#334155';
  grid[21][3] = '#0f172a'; grid[21][4] = '#1e293b'; grid[21][5] = '#0f172a';
  grid[22][3] = '#020617'; grid[22][4] = '#0f172a'; grid[22][5] = '#1e293b';
  grid[23][2] = '#020617'; grid[23][3] = '#0f172a'; grid[23][4] = '#1e293b'; grid[23][5] = '#020617';

  // Front leg: knee crouch flexed forward at y: 17, x: 8..10
  grid[14][7] = '#facc15'; grid[14][8] = '#ffffff'; grid[14][9] = '#f8fafc';
  grid[15][7] = '#facc15'; grid[15][8] = '#ffffff'; grid[15][9] = '#f8fafc';
  grid[16][8] = '#facc15'; grid[16][9] = '#ffffff'; grid[16][10] = '#f8fafc';
  grid[17][8] = '#facc15'; grid[17][9] = '#ffffff'; grid[17][10] = '#cbd5e1';
  grid[18][7] = '#ca8a04'; grid[18][8] = '#fde047'; grid[18][9] = '#ca8a04';
  grid[19][7] = '#1e293b'; grid[19][8] = '#334155'; grid[19][9] = '#1e293b';
  grid[20][7] = '#0f172a'; grid[20][8] = '#1e293b'; grid[20][9] = '#0f172a';
  grid[21][7] = '#0f172a'; grid[21][8] = '#1e293b'; grid[21][9] = '#0f172a';
  grid[22][7] = '#020617'; grid[22][8] = '#0f172a'; grid[22][9] = '#1e293b'; grid[22][10] = '#020617';
  grid[23][7] = '#020617'; grid[23][8] = '#0f172a'; grid[23][9] = '#1e293b'; grid[23][10] = '#0f172a'; grid[23][11] = '#020617';
}

function _paintHD_PinkBeret_Legs_Heave(grid) {
  // Solid Pelvis Connection (y: 12..13) - ZERO GAP WITH TORSO, CLEAN AT WAIST (matching belt x: 4..9)
  grid[12][4] = '#334155'; grid[12][5] = '#475569';
  grid[12][6] = '#ca8a04'; grid[12][7] = '#fde047'; grid[12][8] = '#facc15'; grid[12][9] = '#ca8a04';
  grid[13][4] = '#1e293b'; grid[13][5] = '#334155';
  grid[13][6] = '#ca8a04'; grid[13][7] = '#facc15'; grid[13][8] = '#ca8a04'; grid[13][9] = '#1e293b';

  // Rear leg pushing back: diagonal thrust pillar
  grid[14][4] = '#94a3b8'; grid[14][5] = '#cbd5e1'; grid[14][6] = '#e2e8f0';
  grid[15][3] = '#94a3b8'; grid[15][4] = '#cbd5e1'; grid[15][5] = '#e2e8f0';
  grid[16][3] = '#94a3b8'; grid[16][4] = '#cbd5e1'; grid[16][5] = '#e2e8f0';
  grid[17][2] = '#94a3b8'; grid[17][3] = '#cbd5e1'; grid[17][4] = '#e2e8f0';
  grid[18][2] = '#1e293b'; grid[18][3] = '#334155'; grid[18][4] = '#475569';
  grid[19][2] = '#0f172a'; grid[19][3] = '#1e293b'; grid[19][4] = '#334155';
  grid[20][1] = '#0f172a'; grid[20][2] = '#1e293b'; grid[20][3] = '#0f172a';
  grid[21][1] = '#0f172a'; grid[21][2] = '#1e293b'; grid[21][3] = '#0f172a';
  grid[22][1] = '#020617'; grid[22][2] = '#0f172a'; grid[22][3] = '#1e293b';
  grid[23][0] = '#020617'; grid[23][1] = '#0f172a'; grid[23][2] = '#1e293b'; grid[23][3] = '#020617';

  // Front leg: upward power extension, knee driving forward
  grid[14][7] = '#facc15'; grid[14][8] = '#ffffff'; grid[14][9] = '#f8fafc';
  grid[15][7] = '#facc15'; grid[15][8] = '#ffffff'; grid[15][9] = '#f8fafc';
  grid[16][8] = '#facc15'; grid[16][9] = '#ffffff'; grid[16][10] = '#f8fafc';
  grid[17][8] = '#facc15'; grid[17][9] = '#ffffff'; grid[17][10] = '#cbd5e1';
  grid[18][8] = '#ca8a04'; grid[18][9] = '#fde047'; grid[18][10] = '#ca8a04';
  grid[19][8] = '#1e293b'; grid[19][9] = '#334155'; grid[19][10] = '#1e293b';
  grid[20][8] = '#0f172a'; grid[20][9] = '#1e293b'; grid[20][10] = '#0f172a';
  grid[21][8] = '#0f172a'; grid[21][9] = '#1e293b'; grid[21][10] = '#0f172a';
  grid[22][8] = '#020617'; grid[22][9] = '#0f172a'; grid[22][10] = '#1e293b'; grid[22][11] = '#020617';
  grid[23][8] = '#020617'; grid[23][9] = '#0f172a'; grid[23][10] = '#1e293b'; grid[23][11] = '#0f172a'; grid[23][12] = '#020617';
}

function _paintHD_PinkBeret_Legs_Aim(grid) {
  // Solid Pelvis Connection (y: 12..13) - ZERO GAP WITH TORSO, CLEAN AT WAIST (matching belt x: 4..9)
  grid[12][4] = '#334155'; grid[12][5] = '#475569';
  grid[12][6] = '#ca8a04'; grid[12][7] = '#fde047'; grid[12][8] = '#facc15'; grid[12][9] = '#ca8a04';
  grid[13][4] = '#1e293b'; grid[13][5] = '#334155';
  grid[13][6] = '#ca8a04'; grid[13][7] = '#facc15'; grid[13][8] = '#ca8a04'; grid[13][9] = '#1e293b';

  // Rear leg: braced diagonally back (x: 2..5) to counter rocket mass & backblast
  grid[14][4] = '#94a3b8'; grid[14][5] = '#cbd5e1'; grid[14][6] = '#e2e8f0';
  grid[15][3] = '#94a3b8'; grid[15][4] = '#cbd5e1'; grid[15][5] = '#e2e8f0';
  grid[16][3] = '#94a3b8'; grid[16][4] = '#cbd5e1'; grid[16][5] = '#e2e8f0';
  grid[17][2] = '#94a3b8'; grid[17][3] = '#cbd5e1'; grid[17][4] = '#e2e8f0';
  grid[18][2] = '#1e293b'; grid[18][3] = '#334155'; grid[18][4] = '#475569';
  grid[19][2] = '#0f172a'; grid[19][3] = '#1e293b'; grid[19][4] = '#334155';
  grid[20][2] = '#0f172a'; grid[20][3] = '#1e293b'; grid[20][4] = '#0f172a';
  grid[21][2] = '#0f172a'; grid[21][3] = '#1e293b'; grid[21][4] = '#0f172a';
  grid[22][1] = '#020617'; grid[22][2] = '#0f172a'; grid[22][3] = '#1e293b'; grid[22][4] = '#020617';
  grid[23][1] = '#020617'; grid[23][2] = '#0f172a'; grid[23][3] = '#1e293b'; grid[23][4] = '#0f172a'; grid[23][5] = '#020617';

  // Front leg: stepped forward into combat stance (x: 8..11), knee bent forward
  grid[14][7] = '#facc15'; grid[14][8] = '#ffffff'; grid[14][9] = '#f8fafc';
  grid[15][7] = '#facc15'; grid[15][8] = '#ffffff'; grid[15][9] = '#f8fafc';
  grid[16][8] = '#facc15'; grid[16][9] = '#ffffff'; grid[16][10] = '#f8fafc';
  grid[17][8] = '#facc15'; grid[17][9] = '#ffffff'; grid[17][10] = '#cbd5e1';
  grid[18][8] = '#ca8a04'; grid[18][9] = '#fde047'; grid[18][10] = '#ca8a04';
  grid[19][8] = '#1e293b'; grid[19][9] = '#334155'; grid[19][10] = '#1e293b';
  grid[20][8] = '#0f172a'; grid[20][9] = '#1e293b'; grid[20][10] = '#0f172a';
  grid[21][8] = '#0f172a'; grid[21][9] = '#1e293b'; grid[21][10] = '#0f172a';
  grid[22][8] = '#020617'; grid[22][9] = '#0f172a'; grid[22][10] = '#1e293b'; grid[22][11] = '#020617';
  grid[23][8] = '#020617'; grid[23][9] = '#0f172a'; grid[23][10] = '#1e293b'; grid[23][11] = '#0f172a'; grid[23][12] = '#020617';
}

function _paintHD_PinkBeret_Legs(grid, frame = 0) {
  if (frame === 'crouch') {
    _paintHD_PinkBeret_Legs_Crouch(grid);
    return;
  }
  if (frame === 'heave') {
    _paintHD_PinkBeret_Legs_Heave(grid);
    return;
  }
  if (frame === 'aim') {
    _paintHD_PinkBeret_Legs_Aim(grid);
    return;
  }
  // Solid Pelvis Connection (y: 12..13) - ZERO GAP WITH TORSO, CLEAN AT WAIST (matching belt x: 4..9)
  grid[12][4] = '#334155'; grid[12][5] = '#475569';
  grid[12][6] = '#ca8a04'; grid[12][7] = '#fde047'; grid[12][8] = '#facc15'; grid[12][9] = '#ca8a04';

  grid[13][4] = '#1e293b'; grid[13][5] = '#334155';
  grid[13][6] = '#ca8a04'; grid[13][7] = '#facc15'; grid[13][8] = '#ca8a04'; grid[13][9] = '#1e293b';

  if (frame === 0 || frame === 'tap' || frame === 7) {
    // ── STATUESQUE SLIM ADONIS MODEL LEGS (Frame 0: Stand / Frame 'tap': Rhythmic Toe Tap) ──
    // ── REAR LEG (Background, x: 4..6, slender 3px luminous shaded depth, NO dark soot!) ──
    // Long thigh (y: 14..16)
    grid[14][4] = '#94a3b8'; grid[14][5] = '#cbd5e1'; grid[14][6] = '#e2e8f0';
    grid[15][4] = '#94a3b8'; grid[15][5] = '#cbd5e1'; grid[15][6] = '#e2e8f0';
    grid[16][4] = '#94a3b8'; grid[16][5] = '#cbd5e1'; grid[16][6] = '#e2e8f0';
    // Slender knee (y: 17)
    grid[17][4] = '#94a3b8'; grid[17][5] = '#cbd5e1'; grid[17][6] = '#e2e8f0';
    // Tall riding boot shaft (y: 18..21)
    grid[18][4] = '#1e293b'; grid[18][5] = '#334155'; grid[18][6] = '#475569';
    grid[19][4] = '#0f172a'; grid[19][5] = '#1e293b'; grid[19][6] = '#334155';
    grid[20][4] = '#0f172a'; grid[20][5] = '#1e293b'; grid[20][6] = '#334155';
    grid[21][4] = '#0f172a'; grid[21][5] = '#1e293b'; grid[21][6] = '#0f172a';
    // Ankle & Sole (y: 22..23)
    grid[22][4] = '#020617'; grid[22][5] = '#0f172a'; grid[22][6] = '#1e293b';
    grid[23][3] = '#020617'; grid[23][4] = '#0f172a'; grid[23][5] = '#1e293b'; grid[23][6] = '#020617';

    // ── FRONT LEG (Foreground, x: 7..9, slender 3px pristine white breeches & tall black riding boot!) ──
    // Long thigh (y: 14..16) - Ends cleanly at x: 9, perfectly flush with belt! NO BULGE!
    grid[14][7] = '#facc15'; grid[14][8] = '#ffffff'; grid[14][9] = '#f8fafc';
    grid[15][7] = '#facc15'; grid[15][8] = '#ffffff'; grid[15][9] = '#f8fafc';
    grid[16][7] = '#facc15'; grid[16][8] = '#ffffff'; grid[16][9] = '#f8fafc';
    // Slender sculpted knee (y: 17)
    grid[17][7] = '#facc15'; grid[17][8] = '#ffffff'; grid[17][9] = '#cbd5e1';
    // Riding boot gold trim (y: 18)
    grid[18][7] = '#ca8a04'; grid[18][8] = '#fde047'; grid[18][9] = '#ca8a04';
    // Boot shaft (y: 19..20)
    grid[19][7] = '#1e293b'; grid[19][8] = '#334155'; grid[19][9] = '#1e293b';
    grid[20][7] = '#0f172a'; grid[20][8] = '#1e293b'; grid[20][9] = '#0f172a';

    if (frame === 'tap' || frame === 7) {
      // 🎖️ RHYTHMIC TOE TAP: Toe lifted 2px into air, pivoting crisply on grounded heel!
      // Row 21: Instep flex & lifted shoe cap leather shine
      grid[21][7] = '#0f172a'; grid[21][8] = '#1e293b'; grid[21][9] = '#334155'; grid[21][10] = '#1e293b'; grid[21][11] = '#020617';
      // Row 22: Angled sole rising to lifted toe tip outline at (x: 11, y: 22)
      grid[22][7] = '#020617'; grid[22][8] = '#0f172a'; grid[22][9] = '#0f172a'; grid[22][10] = '#1e293b'; grid[22][11] = '#020617';
      // Row 23: Grounded heel contact at x: 7..8, daylight under lifted toe (x: 9..11 empty air!)
      grid[23][7] = '#020617'; grid[23][8] = '#0f172a';
    } else {
      // Stand: Flat grounded sole spanning to (x: 11, y: 23)
      grid[21][7] = '#0f172a'; grid[21][8] = '#1e293b'; grid[21][9] = '#0f172a';
      grid[22][7] = '#020617'; grid[22][8] = '#0f172a'; grid[22][9] = '#1e293b'; grid[22][10] = '#020617';
      grid[23][7] = '#020617'; grid[23][8] = '#0f172a'; grid[23][9] = '#1e293b'; grid[23][10] = '#0f172a'; grid[23][11] = '#020617';
    }
  } else {
    // ── 6-PHASE HIGH-FASHION CATWALK RUNWAY WALK CYCLE (Slim 3px leg profile, luminous white shadows!) ──
    if (frame === 1) {
      // Phase 1: High Catwalk Strut - Front Leg Reaches Forward with Pointed Toe, Rear Leg Pushes Far Back
      grid[14][7]  = '#facc15'; grid[14][8]  = '#ffffff'; grid[14][9]  = '#f8fafc';
      grid[15][8]  = '#facc15'; grid[15][9]  = '#ffffff'; grid[15][10] = '#f8fafc';
      grid[16][9]  = '#facc15'; grid[16][10] = '#ffffff'; grid[16][11] = '#f8fafc';
      grid[17][10] = '#ca8a04'; grid[17][11] = '#fde047'; grid[17][12] = '#ca8a04';
      grid[18][11] = '#1e293b'; grid[18][12] = '#334155'; grid[18][13] = '#1e293b';
      grid[19][11] = '#1e293b'; grid[19][12] = '#334155'; grid[19][13] = '#1e293b';
      grid[20][12] = '#0f172a'; grid[20][13] = '#1e293b'; grid[20][14] = '#0f172a';
      grid[21][12] = '#0f172a'; grid[21][13] = '#1e293b'; grid[21][14] = '#0f172a';
      grid[22][13] = '#020617'; grid[22][14] = '#0f172a'; grid[22][15] = '#020617';
      grid[23][13] = '#020617'; grid[23][14] = '#0f172a'; grid[23][15] = '#1e293b'; grid[23][16] = '#020617';

      // Rear leg pushing far back (luminous white breeches shadow!)
      grid[14][4] = '#94a3b8'; grid[14][5] = '#cbd5e1'; grid[14][6] = '#e2e8f0';
      grid[15][3] = '#94a3b8'; grid[15][4] = '#cbd5e1'; grid[15][5] = '#e2e8f0';
      grid[16][3] = '#94a3b8'; grid[16][4] = '#cbd5e1'; grid[16][5] = '#e2e8f0';
      grid[17][2] = '#94a3b8'; grid[17][3] = '#cbd5e1'; grid[17][4] = '#e2e8f0';
      grid[18][2] = '#1e293b'; grid[18][3] = '#334155'; grid[18][4] = '#1e293b';
      grid[19][1] = '#0f172a'; grid[19][2] = '#1e293b'; grid[19][3] = '#0f172a';
      grid[20][1] = '#0f172a'; grid[20][2] = '#1e293b'; grid[20][3] = '#0f172a';
      grid[21][0] = '#020617'; grid[21][1] = '#0f172a'; grid[21][2] = '#020617';
      grid[22][0] = '#020617'; grid[22][1] = '#0f172a'; grid[22][2] = '#020617';
      grid[23][0] = '#020617'; grid[23][1] = '#0f172a'; grid[23][2] = '#020617';
    } else if (frame === 2) {
      // Phase 2: Catwalk Runway Glide - Front Foot Plants, Rear Leg Bends into Runway Float
      grid[14][7] = '#facc15'; grid[14][8] = '#ffffff'; grid[14][9] = '#f8fafc';
      grid[15][7] = '#facc15'; grid[15][8] = '#ffffff'; grid[15][9] = '#f8fafc';
      grid[16][7] = '#facc15'; grid[16][8] = '#ffffff'; grid[16][9] = '#f8fafc';
      grid[17][7] = '#ca8a04'; grid[17][8] = '#fde047'; grid[17][9] = '#ca8a04';
      grid[18][7] = '#1e293b'; grid[18][8] = '#334155'; grid[18][9] = '#1e293b';
      grid[19][7] = '#1e293b'; grid[19][8] = '#334155'; grid[19][9] = '#1e293b';
      grid[20][7] = '#0f172a'; grid[20][8] = '#1e293b'; grid[20][9] = '#0f172a';
      grid[21][7] = '#0f172a'; grid[21][8] = '#1e293b'; grid[21][9] = '#0f172a';
      grid[22][7] = '#020617'; grid[22][8] = '#0f172a'; grid[22][9] = '#1e293b'; grid[22][10] = '#020617';
      grid[23][7] = '#020617'; grid[23][8] = '#0f172a'; grid[23][9] = '#1e293b'; grid[23][10] = '#0f172a'; grid[23][11] = '#020617';

      grid[14][4] = '#94a3b8'; grid[14][5] = '#cbd5e1'; grid[14][6] = '#e2e8f0';
      grid[15][4] = '#94a3b8'; grid[15][5] = '#cbd5e1'; grid[15][6] = '#e2e8f0';
      grid[16][4] = '#94a3b8'; grid[16][5] = '#cbd5e1'; grid[16][6] = '#e2e8f0';
      grid[17][3] = '#94a3b8'; grid[17][4] = '#cbd5e1'; grid[17][5] = '#e2e8f0';
      grid[18][3] = '#1e293b'; grid[18][4] = '#334155'; grid[18][5] = '#1e293b';
      grid[19][3] = '#0f172a'; grid[19][4] = '#1e293b'; grid[19][5] = '#0f172a';
      grid[20][2] = '#020617'; grid[20][3] = '#0f172a'; grid[20][4] = '#020617';
      grid[21][2] = '#020617'; grid[21][3] = '#0f172a'; grid[21][4] = '#020617';
    } else if (frame === 3) {
      // Phase 3: HIGH RUNWAY KNEE PASS - Left Leg Drives High Up & Forward (Slender lift, max x: 10!)
      grid[14][6] = '#facc15'; grid[14][7] = '#ffffff'; grid[14][8] = '#f8fafc';
      grid[15][6] = '#facc15'; grid[15][7] = '#ffffff'; grid[15][8] = '#f8fafc';
      grid[16][6] = '#facc15'; grid[16][7] = '#ffffff'; grid[16][8] = '#f8fafc';
      grid[17][6] = '#ca8a04'; grid[17][7] = '#fde047'; grid[17][8] = '#ca8a04';
      grid[18][6] = '#1e293b'; grid[18][7] = '#334155'; grid[18][8] = '#1e293b';
      grid[19][6] = '#1e293b'; grid[19][7] = '#334155'; grid[19][8] = '#1e293b';
      grid[20][6] = '#0f172a'; grid[20][7] = '#1e293b'; grid[20][8] = '#0f172a';
      grid[21][6] = '#0f172a'; grid[21][7] = '#1e293b'; grid[21][8] = '#0f172a';
      grid[22][6] = '#020617'; grid[22][7] = '#0f172a'; grid[22][8] = '#1e293b'; grid[22][9] = '#020617';
      grid[23][6] = '#020617'; grid[23][7] = '#0f172a'; grid[23][8] = '#1e293b'; grid[23][9] = '#0f172a'; grid[23][10] = '#020617';

      // Lifted rear knee passing forward (luminous shadow!)
      grid[14][4] = '#94a3b8'; grid[14][5] = '#cbd5e1';
      grid[15][8]  = '#94a3b8'; grid[15][9]  = '#cbd5e1'; grid[15][10] = '#e2e8f0';
      grid[16][8]  = '#94a3b8'; grid[16][9]  = '#cbd5e1'; grid[16][10] = '#e2e8f0';
      grid[17][7]  = '#94a3b8'; grid[17][8]  = '#cbd5e1'; grid[17][9]  = '#e2e8f0';
      grid[18][7]  = '#1e293b'; grid[18][8]  = '#334155'; grid[18][9]  = '#1e293b';
      grid[19][7]  = '#0f172a'; grid[19][8]  = '#1e293b'; grid[19][9]  = '#0f172a';
      grid[20][7]  = '#020617'; grid[20][8]  = '#0f172a'; grid[20][9]  = '#020617';
      grid[21][7]  = '#020617'; grid[21][8]  = '#0f172a'; grid[21][9]  = '#020617';
    } else if (frame === 4) {
      // Phase 4: High Catwalk Strut - Rear Leg Reaches Forward with Pointed Toe, Front Leg Pushes Far Back
      grid[14][7]  = '#94a3b8'; grid[14][8]  = '#cbd5e1'; grid[14][9]  = '#e2e8f0';
      grid[15][8]  = '#94a3b8'; grid[15][9]  = '#cbd5e1'; grid[15][10] = '#e2e8f0';
      grid[16][9]  = '#94a3b8'; grid[16][10] = '#cbd5e1'; grid[16][11] = '#e2e8f0';
      grid[17][10] = '#94a3b8'; grid[17][11] = '#cbd5e1'; grid[17][12] = '#e2e8f0';
      grid[18][11] = '#1e293b'; grid[18][12] = '#334155'; grid[18][13] = '#1e293b';
      grid[19][11] = '#1e293b'; grid[19][12] = '#334155'; grid[19][13] = '#1e293b';
      grid[20][12] = '#0f172a'; grid[20][13] = '#1e293b'; grid[20][14] = '#0f172a';
      grid[21][12] = '#0f172a'; grid[21][13] = '#1e293b'; grid[21][14] = '#0f172a';
      grid[22][13] = '#020617'; grid[22][14] = '#0f172a'; grid[22][15] = '#020617';
      grid[23][13] = '#020617'; grid[23][14] = '#0f172a'; grid[23][15] = '#1e293b'; grid[23][16] = '#020617';

      // Front leg pushing far back (slender 3px)
      grid[14][4] = '#facc15'; grid[14][5] = '#ffffff'; grid[14][6] = '#f8fafc';
      grid[15][3] = '#facc15'; grid[15][4] = '#ffffff'; grid[15][5] = '#f8fafc';
      grid[16][3] = '#facc15'; grid[16][4] = '#ffffff'; grid[16][5] = '#f8fafc';
      grid[17][2] = '#ca8a04'; grid[17][3] = '#fde047'; grid[17][4] = '#ca8a04';
      grid[18][2] = '#1e293b'; grid[18][3] = '#334155'; grid[18][4] = '#1e293b';
      grid[19][1] = '#0f172a'; grid[19][2] = '#1e293b'; grid[19][3] = '#0f172a';
      grid[20][1] = '#0f172a'; grid[20][2] = '#1e293b'; grid[20][3] = '#0f172a';
      grid[21][0] = '#020617'; grid[21][1] = '#0f172a'; grid[21][2] = '#020617';
      grid[22][0] = '#020617'; grid[22][1] = '#0f172a'; grid[22][2] = '#020617';
      grid[23][0] = '#020617'; grid[23][1] = '#0f172a'; grid[23][2] = '#020617';
    } else if (frame === 5) {
      // Phase 5: Catwalk Runway Glide - Rear Foot Plants, Front Leg Bends into Runway Float
      grid[14][7] = '#94a3b8'; grid[14][8] = '#cbd5e1'; grid[14][9] = '#e2e8f0';
      grid[15][7] = '#94a3b8'; grid[15][8] = '#cbd5e1'; grid[15][9] = '#e2e8f0';
      grid[16][7] = '#94a3b8'; grid[16][8] = '#cbd5e1'; grid[16][9] = '#e2e8f0';
      grid[17][7] = '#94a3b8'; grid[17][8] = '#cbd5e1'; grid[17][9] = '#e2e8f0';
      grid[18][7] = '#1e293b'; grid[18][8] = '#334155'; grid[18][9] = '#1e293b';
      grid[19][7] = '#1e293b'; grid[19][8] = '#334155'; grid[19][9] = '#1e293b';
      grid[20][7] = '#0f172a'; grid[20][8] = '#1e293b'; grid[20][9] = '#0f172a';
      grid[21][7] = '#0f172a'; grid[21][8] = '#1e293b'; grid[21][9] = '#0f172a';
      grid[22][7] = '#020617'; grid[22][8] = '#0f172a'; grid[22][9] = '#1e293b'; grid[22][10] = '#020617';
      grid[23][7] = '#020617'; grid[23][8] = '#0f172a'; grid[23][9] = '#1e293b'; grid[23][10] = '#0f172a'; grid[23][11] = '#020617';

      grid[14][4] = '#facc15'; grid[14][5] = '#ffffff'; grid[14][6] = '#f8fafc';
      grid[15][4] = '#facc15'; grid[15][5] = '#ffffff'; grid[15][6] = '#f8fafc';
      grid[16][4] = '#facc15'; grid[16][5] = '#ffffff'; grid[16][6] = '#f8fafc';
      grid[17][3] = '#ca8a04'; grid[17][4] = '#fde047'; grid[17][5] = '#ca8a04';
      grid[18][3] = '#1e293b'; grid[18][4] = '#334155'; grid[18][5] = '#1e293b';
      grid[19][3] = '#0f172a'; grid[19][4] = '#1e293b'; grid[19][5] = '#0f172a';
      grid[20][2] = '#020617'; grid[20][3] = '#0f172a'; grid[20][4] = '#020617';
      grid[21][2] = '#020617'; grid[21][3] = '#0f172a'; grid[21][4] = '#020617';
    } else {
      // Phase 6: HIGH RUNWAY KNEE PASS - Right Leg Drives High Up & Forward (Slender lift, max x: 10!)
      grid[14][6] = '#94a3b8'; grid[14][7] = '#cbd5e1'; grid[14][8] = '#e2e8f0';
      grid[15][6] = '#94a3b8'; grid[15][7] = '#cbd5e1'; grid[15][8] = '#e2e8f0';
      grid[16][6] = '#94a3b8'; grid[16][7] = '#cbd5e1'; grid[16][8] = '#e2e8f0';
      grid[17][6] = '#94a3b8'; grid[17][7] = '#cbd5e1'; grid[17][8] = '#e2e8f0';
      grid[18][6] = '#1e293b'; grid[18][8] = '#334155'; grid[18][9] = '#1e293b';
      grid[19][6] = '#1e293b'; grid[19][7] = '#334155'; grid[19][8] = '#1e293b';
      grid[20][6] = '#0f172a'; grid[20][7] = '#1e293b'; grid[20][8] = '#0f172a';
      grid[21][6] = '#0f172a'; grid[21][7] = '#1e293b'; grid[21][8] = '#0f172a';
      grid[22][6] = '#020617'; grid[22][7] = '#0f172a'; grid[22][8] = '#1e293b'; grid[22][9] = '#020617';
      grid[23][6] = '#020617'; grid[23][7] = '#0f172a'; grid[23][8] = '#1e293b'; grid[23][9] = '#0f172a'; grid[23][10] = '#020617';

      // Front high knee lift (slender 3px)
      grid[14][4] = '#cbd5e1'; grid[14][5] = '#facc15';
      grid[15][8]  = '#facc15'; grid[15][9]  = '#ffffff'; grid[15][10] = '#f8fafc';
      grid[16][8]  = '#facc15'; grid[16][9]  = '#ffffff'; grid[16][10] = '#f8fafc';
      grid[17][7]  = '#ca8a04'; grid[17][8]  = '#fde047'; grid[17][9]  = '#ca8a04';
      grid[18][7]  = '#1e293b'; grid[18][8]  = '#334155'; grid[18][9]  = '#1e293b';
      grid[19][7]  = '#0f172a'; grid[19][8]  = '#1e293b'; grid[19][9]  = '#0f172a';
      grid[20][7]  = '#020617'; grid[20][8]  = '#0f172a'; grid[20][9]  = '#020617';
      grid[21][7]  = '#020617'; grid[21][8]  = '#0f172a'; grid[21][9]  = '#020617';
    }
  }
}

function _paintHD_PinkBeret_Launcher_Carry(grid) {
  // Horizontal Rocket Launcher carried at waist level (y: 11..13) with two-handed support
  grid[11][2] = '#020617'; grid[11][3] = '#0f172a';
  grid[12][1] = '#020617'; grid[12][2] = '#0f172a'; grid[12][3] = '#1e293b';
  grid[13][2] = '#020617'; grid[13][3] = '#0f172a';

  for (let x = 4; x <= 18; x++) {
    grid[11][x] = '#475569';
    grid[12][x] = '#334155';
    grid[13][x] = '#1e293b';
  }
  grid[11][7] = '#94a3b8'; grid[11][8] = '#cbd5e1'; grid[11][15] = '#94a3b8'; grid[11][16] = '#cbd5e1';

  grid[9][11]  = '#38bdf8'; grid[9][12]  = '#0284c7'; grid[9][13]  = '#0f172a';
  grid[10][10] = '#1e293b'; grid[10][11] = '#334155'; grid[10][12] = '#334155'; grid[10][13] = '#0f172a';

  grid[11][11] = '#ff2a85'; grid[11][12] = '#fda4af'; grid[11][13] = '#ff2a85';
  grid[12][12] = '#fb7185';

  grid[11][7] = '#fed7aa'; grid[11][8] = '#fed7aa';
  grid[12][7] = '#fba772'; grid[12][8] = '#fba772';
  grid[13][7] = '#ca8a04'; grid[13][8] = '#facc15';

  grid[13][14] = '#fed7aa'; grid[13][15] = '#fed7aa';
  grid[14][14] = '#fba772'; grid[14][15] = '#fba772';
  grid[14][16] = '#ca8a04'; grid[14][17] = '#facc15';

  grid[10][18] = '#ca8a04'; grid[10][19] = '#facc15';
  grid[11][18] = '#fde047'; grid[11][19] = '#facc15';
  grid[12][18] = '#facc15'; grid[12][19] = '#ca8a04';
  grid[13][18] = '#fde047'; grid[13][19] = '#ca8a04';
  grid[14][18] = '#ca8a04'; grid[14][19] = '#a16207';

  grid[11][20] = '#ff2a85'; grid[11][21] = '#fda4af';
  grid[12][20] = '#ff2a85'; grid[12][21] = '#ffffff';
  grid[13][20] = '#fb7185'; grid[13][21] = '#fda4af';
}

function _paintHD_PinkBeret_Launcher_Lift(grid) {
  // Rising Rocket Launcher angled ~14° upward off waist level (y: 8..14)
  grid[12][2] = '#020617'; grid[12][3] = '#0f172a';
  grid[13][1] = '#020617'; grid[13][2] = '#0f172a'; grid[13][3] = '#1e293b';
  grid[14][2] = '#020617'; grid[14][3] = '#0f172a';

  for (let x = 4; x <= 7; x++) {
    grid[12][x] = '#475569'; grid[13][x] = '#334155'; grid[14][x] = '#1e293b';
  }
  for (let x = 8; x <= 11; x++) {
    grid[11][x] = '#475569'; grid[12][x] = '#334155'; grid[13][x] = '#1e293b';
  }
  for (let x = 12; x <= 15; x++) {
    grid[10][x] = '#475569'; grid[11][x] = '#334155'; grid[12][x] = '#1e293b';
  }
  for (let x = 16; x <= 18; x++) {
    grid[9][x]  = '#475569'; grid[10][x] = '#334155'; grid[11][x] = '#1e293b';
  }

  grid[12][6]  = '#94a3b8'; grid[12][7]  = '#cbd5e1';
  grid[11][10] = '#94a3b8'; grid[11][11] = '#cbd5e1';
  grid[10][14] = '#94a3b8'; grid[10][15] = '#cbd5e1';

  grid[8][11]  = '#38bdf8'; grid[8][12]  = '#0284c7'; grid[8][13]  = '#0f172a';
  grid[9][10]  = '#1e293b'; grid[9][11]  = '#334155'; grid[9][12]  = '#334155'; grid[9][13]  = '#0f172a';

  grid[10][11] = '#ff2a85'; grid[10][12] = '#fda4af'; grid[10][13] = '#ff2a85';
  grid[11][12] = '#fb7185';

  grid[11][7]  = '#fed7aa'; grid[11][8]  = '#fed7aa';
  grid[12][7]  = '#fba772'; grid[12][8]  = '#fba772';
  grid[13][7]  = '#ca8a04'; grid[13][8]  = '#facc15';

  grid[12][14] = '#fed7aa'; grid[12][15] = '#fed7aa';
  grid[13][14] = '#fba772'; grid[13][15] = '#fba772';
  grid[13][16] = '#ca8a04'; grid[13][17] = '#facc15';

  grid[8][18]  = '#ca8a04'; grid[8][19]  = '#facc15';
  grid[9][18]  = '#ca8a04'; grid[9][19]  = '#fde047'; grid[9][20]  = '#ca8a04';
  grid[10][18] = '#fde047'; grid[10][19] = '#facc15'; grid[10][20] = '#ca8a04';
  grid[11][18] = '#facc15'; grid[11][19] = '#ca8a04';
  grid[12][18] = '#ca8a04'; grid[12][19] = '#a16207';

  grid[9][21]  = '#ff2a85'; grid[9][22]  = '#fda4af';
  grid[10][20] = '#ff2a85'; grid[10][21] = '#ffffff'; grid[10][22] = '#fda4af';
  grid[11][20] = '#fb7185'; grid[11][21] = '#fda4af';
}

function _paintHD_PinkBeret_Launcher_Heave(grid) {
  // Rising Rocket Launcher heaved up at ~26.5° slope (y: 5..14)
  grid[13][1] = '#020617'; grid[13][2] = '#0f172a'; grid[13][3] = '#1e293b';
  grid[14][0] = '#020617'; grid[14][1] = '#0f172a'; grid[14][2] = '#1e293b'; grid[14][3] = '#334155';
  grid[15][1] = '#020617'; grid[15][2] = '#0f172a'; grid[15][3] = '#1e293b';

  for (let y = 12; y >= 6; y--) {
    const xc = 4 + 2 * (12 - y);
    grid[y][xc - 1] = '#94a3b8';
    grid[y][xc]     = '#475569';
    grid[y][xc + 1] = '#334155';
    grid[y][xc + 2] = '#1e293b';
  }

  grid[6][11]  = '#38bdf8'; grid[6][12]  = '#0284c7'; grid[6][13]  = '#0f172a';
  grid[7][10]  = '#1e293b'; grid[7][11]  = '#334155'; grid[7][12]  = '#334155';

  grid[8][11]  = '#ff2a85'; grid[8][12]  = '#fda4af'; grid[8][13]  = '#ff2a85';
  grid[9][12]  = '#fb7185';

  grid[10][8]  = '#fed7aa'; grid[10][9]  = '#fed7aa';
  grid[11][8]  = '#fba772'; grid[11][9]  = '#fba772';
  grid[12][7]  = '#ca8a04'; grid[12][8]  = '#facc15';

  grid[8][14]  = '#fed7aa'; grid[8][15]  = '#fed7aa';
  grid[9][14]  = '#fba772'; grid[9][15]  = '#fba772';
  grid[10][14] = '#ca8a04'; grid[10][15] = '#facc15';

  grid[4][18]  = '#ca8a04'; grid[4][19]  = '#facc15';
  grid[5][17]  = '#ca8a04'; grid[5][18]  = '#fde047'; grid[5][19]  = '#facc15'; grid[5][20]  = '#ca8a04';
  grid[6][17]  = '#ca8a04'; grid[6][18]  = '#facc15'; grid[6][19]  = '#ca8a04';

  grid[3][20]  = '#ff2a85'; grid[3][21]  = '#fda4af';
  grid[4][20]  = '#ff2a85'; grid[4][21]  = '#ffffff'; grid[4][22]  = '#fda4af';
}

function _paintHD_PinkBeret_Launcher_Mount(grid) {
  // Rising Rocket Launcher angled ~36.8° upward cresting onto shoulder (y: 1..15)
  grid[13][2] = '#020617'; grid[13][3] = '#0f172a';
  grid[14][1] = '#020617'; grid[14][2] = '#0f172a'; grid[14][3] = '#1e293b'; grid[14][4] = '#334155';
  grid[15][1] = '#020617'; grid[15][2] = '#0f172a'; grid[15][3] = '#1e293b';

  const xCenters = { 12: 4, 11: 5, 10: 7, 9: 8, 8: 9, 7: 11, 6: 12, 5: 14, 4: 15 };
  for (let y = 12; y >= 4; y--) {
    const xc = xCenters[y];
    grid[y][xc - 2] = '#0f172a';
    grid[y][xc - 1] = '#94a3b8';
    grid[y][xc]     = '#475569';
    grid[y][xc + 1] = '#334155';
    grid[y][xc + 2] = '#1e293b';
  }

  grid[5][10] = '#38bdf8'; grid[5][11] = '#0284c7'; grid[5][12] = '#0f172a';
  grid[6][9]  = '#1e293b'; grid[6][10] = '#334155'; grid[6][11] = '#334155';

  grid[7][10] = '#ff2a85'; grid[7][11] = '#fda4af'; grid[7][12] = '#ff2a85';
  grid[8][11] = '#fb7185';

  grid[9][8]   = '#fed7aa'; grid[9][9]   = '#fed7aa';
  grid[10][8]  = '#fba772'; grid[10][9]  = '#fba772';
  grid[11][7]  = '#ca8a04'; grid[11][8]  = '#facc15';

  grid[7][12]  = '#fed7aa'; grid[7][13]  = '#fed7aa';
  grid[8][12]  = '#fba772'; grid[8][13]  = '#fba772';
  grid[9][12]  = '#ca8a04'; grid[9][13]  = '#facc15';

  grid[2][16] = '#ca8a04'; grid[2][17] = '#facc15';
  grid[3][15] = '#ca8a04'; grid[3][16] = '#fde047'; grid[3][17] = '#facc15'; grid[3][18] = '#ca8a04';
  grid[4][15] = '#ca8a04'; grid[4][16] = '#facc15'; grid[4][17] = '#ca8a04';

  grid[1][18] = '#ff2a85'; grid[1][19] = '#fda4af';
  grid[2][18] = '#ff2a85'; grid[2][19] = '#ffffff'; grid[2][20] = '#fda4af';
}

function _paintHD_PinkBeret_Launcher_Aim45(grid) {
  // Straight 45° Rocket Launcher resting naturally on lowered shoulder at y: 8, x: 7
  // Base line: xc = 16 - y
  grid[15][1] = '#020617'; grid[15][2] = '#0f172a'; grid[15][3] = '#1e293b';
  grid[14][1] = '#020617'; grid[14][2] = '#0f172a'; grid[14][3] = '#1e293b'; grid[14][4] = '#334155';
  grid[13][1] = '#020617'; grid[13][2] = '#0f172a'; grid[13][3] = '#1e293b';

  for (let y = 12; y >= 3; y--) {
    const xc = 16 - y;
    grid[y][xc - 2] = '#0f172a';
    grid[y][xc - 1] = '#1e293b';
    grid[y][xc]     = '#334155';
    grid[y][xc + 1] = '#475569';
    grid[y][xc + 2] = '#94a3b8';
  }

  // Scope (y: 4..5, x: 9..12)
  grid[4][9]  = '#38bdf8'; grid[4][10] = '#0284c7'; grid[4][11] = '#0f172a';
  grid[5][8]  = '#1e293b'; grid[5][9]  = '#334155';
  grid[3][9]  = '#0f172a'; grid[3][10] = '#1e293b';

  // Pink heart decal (y: 6..7, x: 9..11)
  grid[6][9]  = '#ff2a85'; grid[6][10] = '#fda4af';
  grid[7][8]  = '#ff2a85'; grid[7][9]  = '#fb7185'; grid[7][10] = '#ff2a85';

  // Handgrip (y: 8..9, x: 8..10)
  grid[8][8]  = '#fed7aa'; grid[8][9]  = '#fba772';
  grid[9][8]  = '#fed7aa'; grid[9][9]  = '#fba772';

  // Muzzle Collar (y: 2, xc = 14)
  grid[2][12] = '#ca8a04'; grid[2][13] = '#facc15'; grid[2][14] = '#fde047'; grid[2][15] = '#facc15'; grid[2][16] = '#ca8a04';
  // Muzzle Lip (y: 1, xc = 15)
  grid[1][13] = '#ca8a04'; grid[1][14] = '#facc15'; grid[1][15] = '#fde047'; grid[1][16] = '#facc15'; grid[1][17] = '#ca8a04';

  // Rocket Warhead Tip (y: 0..1, x: 15..17)
  grid[1][15] = '#ff2a85'; grid[1][16] = '#fda4af';
  grid[0][15] = '#ff2a85'; grid[0][16] = '#fda4af'; grid[0][17] = '#ffffff';
}

function _paintHD_PinkBeret_Arm_Rear(grid) {
  // Left / Rear Arm in Pristine White-Gold Sleeve with Luminous Ambient Shading (y: 8..15)
  // Shoulder socket
  grid[8][4]  = '#cbd5e1'; grid[8][5]  = '#e2e8f0';
  // Slender upper arm along rear ribcage (y: 9..11)
  grid[9][4]  = '#94a3b8'; grid[9][5]  = '#cbd5e1';
  grid[10][4] = '#94a3b8'; grid[10][5] = '#cbd5e1';
  grid[11][4] = '#94a3b8'; grid[11][5] = '#cbd5e1';
  // Forearm & Gold Cuff (y: 12..13)
  grid[12][4] = '#cbd5e1'; grid[12][5] = '#ca8a04';
  grid[13][4] = '#ca8a04'; grid[13][5] = '#facc15';
  // Poised Runway Hand tucked along rear thigh (y: 14..15)
  grid[14][4] = '#fba772'; grid[14][5] = '#fed7aa';
  grid[15][4] = '#fba772'; grid[15][5] = '#fed7aa';
}

function _paintHD_PinkBeret_Pistol(grid) {
  // Front Arm (Relaxed, Shortened Forearm & Hand for proportionate top-model anatomy, Elevated Chrome Revolver)
  // 1. Shoulder Socket under epaulette (y: 8, x: 6..8)
  grid[8][6] = '#ca8a04'; grid[8][7] = '#fde047'; grid[8][8] = '#facc15';

  // 2. Athletic Upper Arm bicep (y: 9..10, x: 6..8)
  grid[9][6] = '#ca8a04'; grid[9][7] = '#ffffff'; grid[9][8] = '#f8fafc';
  grid[10][6] = '#94a3b8'; grid[10][7] = '#ffffff'; grid[10][8] = '#f8fafc';

  // 3. Relaxed Elbow Joint (y: 11, x: 6..8) - gentle open angle!
  grid[11][6] = '#94a3b8'; grid[11][7] = '#cbd5e1'; grid[11][8] = '#facc15';

  // 4. Shortened Forearm white sleeve: x: 7..10
  grid[11][9] = '#cbd5e1'; grid[11][10] = '#ffffff';
  grid[12][7] = '#94a3b8'; grid[12][8] = '#cbd5e1'; grid[12][9] = '#ffffff';

  // 5. Shortened Gold Officer Cuff at wrist (y: 11..12, x: 10..11) - neat 1-2px cuff!
  grid[11][11] = '#fde047';
  grid[12][10] = '#ca8a04'; grid[12][11] = '#facc15';

  // 6. Compact Hand gripping revolver firmly (y: 11..14, x: 12)
  grid[11][12] = '#fed7aa'; // Web of thumb resting against rear frame tang
  grid[12][12] = '#fed7aa'; // Wrapped knuckles & fingers on front of grip
  grid[13][12] = '#fba772'; // Lower palm shadow
  grid[14][12] = '#0f172a'; // Walnut grip base peeking out below hand

  // 7. Revolver Frame, Hammer, Cylinder & Trigger Guard shifted 1px rearward (y: 8..12, x: 12..13)
  grid[8][12]  = '#1e293b'; // Cocked hammer sits squarely above thumb web at x: 12!
  grid[9][12]  = '#334155'; grid[9][13]  = '#94a3b8'; // Top strap
  grid[10][12] = '#475569'; grid[10][13] = '#64748b'; // Cylinder
  grid[11][13] = '#ca8a04'; // Gold trigger guard
  grid[12][13] = '#ca8a04'; // Gold trigger guard loop in front of fingers

  // 8. Elevated Barrel (y: 9..10, x: 14..17) - Sits clearly ABOVE the hand! Daylight beneath at y: 11..12 (NO SABER LOOK!)
  for (let x = 14; x <= 17; x++) {
    grid[9][x]  = '#f8fafc';
    grid[10][x] = '#94a3b8';
  }
  grid[9][15] = '#ffffff'; grid[9][16] = '#ffffff'; // Top chrome glint
  grid[10][14] = '#475569'; grid[10][15] = '#64748b'; // Underlug near cylinder
  // Gold Muzzle Crown (x: 18) - shifted 1px rearward into hand
  grid[9][18]  = '#fde047';
  grid[10][18] = '#ca8a04';
}

function _paintHD_PinkBeret_Kiss(grid) {
  // Blowing Kiss Gesture for Death Animation: Full sculpted arm reaching up to kiss fingertips at mustache/lips
  // 1. Shoulder socket
  grid[8][6] = '#ca8a04'; grid[8][7] = '#fde047'; grid[8][8] = '#facc15';
  // 2. Upper bicep
  grid[7][7] = '#ffffff'; grid[7][8] = '#f8fafc'; grid[7][9] = '#cbd5e1';
  // 3. Elbow
  grid[6][7] = '#cbd5e1'; grid[6][8] = '#facc15'; grid[6][9] = '#ffffff';
  // 4. Forearm
  grid[5][8] = '#cbd5e1'; grid[5][9] = '#ffffff'; grid[5][10] = '#f8fafc';
  // 5. Gold Officer Cuff
  grid[5][10] = '#facc15'; grid[5][11] = '#ca8a04';
  // 6. Fingertips gracefully touching mustache / lips at y: 4, x: 10..12
  grid[4][10] = '#fed7aa'; grid[4][11] = '#fed7aa'; grid[4][12] = '#fba772';
}

function _paintHD_PinkBeret_Front_Turn(grid) {
  // 3/4 Intermediate Turn between Side Profile and Frontal View
  // Hot Pink Beret (y: 0..2)
  for (let x = 6; x <= 14; x++) grid[0][x] = '#ff1493';
  grid[0][8] = '#ff69b4'; grid[0][9] = '#ff69b4';
  grid[0][5] = '#e11d48'; grid[0][15] = '#f43f5e';

  for (let x = 5; x <= 15; x++) grid[1][x] = '#ff1493';
  grid[1][5] = '#be123c'; grid[1][8] = '#fde047'; // Gold military crest pin!
  grid[1][15] = '#ff007f';

  grid[2][5] = '#451a03'; // dark hair
  grid[2][6] = '#1e293b'; grid[2][7] = '#fed7aa'; grid[2][8] = '#fed7aa';
  grid[2][9] = '#fed7aa'; grid[2][10] = '#fed7aa'; grid[2][11] = '#fed7aa';
  grid[2][12] = '#ff1493'; grid[2][13] = '#ff007f'; grid[2][14] = '#be123c';

  // 3/4 White Sunglasses (y: 3)
  grid[3][5] = '#451a03';
  grid[3][6] = '#ffffff'; grid[3][7] = '#ffffff';
  grid[3][8] = '#bae6fd'; // left lens (narrower in 3/4 perspective)
  grid[3][9] = '#ffffff'; grid[3][10] = '#ffffff'; // bridge
  grid[3][11] = '#bae6fd'; // right lens
  grid[3][12] = '#ffffff'; grid[3][13] = '#ffffff';
  grid[3][14] = '#451a03';

  // Cheeks & Retro Mustache (y: 4)
  grid[4][5] = '#fed7aa'; grid[4][6] = '#fba772';
  grid[4][7] = '#ffffff'; grid[4][8] = '#ffffff';
  grid[4][9] = '#1e293b'; grid[4][10] = '#fed7aa'; grid[4][11] = '#1e293b'; // retro mustache
  grid[4][12] = '#ffffff'; grid[4][13] = '#ffffff';
  grid[4][14] = '#fba772'; grid[4][15] = '#fed7aa';

  // Puckered Kiss Lips Forming & Jaw (y: 5)
  grid[5][6] = '#fed7aa'; grid[5][7] = '#fba772';
  grid[5][9] = '#fed7aa';
  grid[5][10] = '#ff2a85'; grid[5][11] = '#fda4af'; // puckered Kussmund starting to form!
  grid[5][12] = '#fba772'; grid[5][13] = '#fed7aa';

  // Neck & High White Officer Collar (y: 6)
  grid[6][6] = '#cbd5e1'; grid[6][7] = '#ffffff';
  grid[6][8] = '#facc15'; // gold collar rim
  grid[6][9] = '#fed7aa'; grid[6][10] = '#fba772';
  grid[6][11] = '#facc15'; grid[6][12] = '#ffffff';

  // Epaulettes & Shoulders (y: 7)
  grid[7][4] = '#ca8a04'; grid[7][5] = '#fde047'; grid[7][6] = '#facc15';
  grid[7][7] = '#cbd5e1'; grid[7][8] = '#ffffff'; grid[7][9] = '#facc15'; // Left lapel
  grid[7][10] = '#fed7aa'; // Bare hollow of throat
  grid[7][11] = '#facc15'; grid[7][12] = '#ffffff'; grid[7][13] = '#fde047'; grid[7][14] = '#ca8a04'; // Right lapel & epaulette

  // Open White Jacket & Bare Muscular Chest in 3/4 Perspective (y: 8..11)
  // Row 8: Muscular Pectorals (Pecs) in 3/4 angle
  grid[8][5] = '#cbd5e1'; grid[8][6] = '#ffffff'; grid[8][7] = '#ffffff';
  grid[8][8] = '#facc15'; // gold lapel edge / button
  grid[8][9] = '#fed7aa'; // Broad left pec highlight
  grid[8][10] = '#fba772'; // Pectoral cleavage
  grid[8][11] = '#fed7aa'; // Right pec
  grid[8][12] = '#facc15'; // gold lapel edge
  grid[8][13] = '#ffffff';

  // Row 9: Lower Pecs & Sternum
  grid[9][5] = '#cbd5e1'; grid[9][6] = '#ffffff'; grid[9][7] = '#ffffff';
  grid[9][8] = '#fde047'; // gold button
  grid[9][9] = '#fed7aa'; // Left pec lower shelf
  grid[9][10] = '#ea580c'; // Deep sternum / pec cleft
  grid[9][11] = '#fba772'; // Right pec lower contour
  grid[9][12] = '#fde047'; // gold button
  grid[9][13] = '#ffffff';

  // Row 10: Toned Six-Pack Abs (Upper)
  grid[10][5] = '#94a3b8'; grid[10][6] = '#cbd5e1'; grid[10][7] = '#ffffff';
  grid[10][8] = '#facc15'; // lapel
  grid[10][9] = '#fed7aa'; // Left ab block
  grid[10][10] = '#fba772'; // Vertical ab cleft
  grid[10][11] = '#fed7aa'; // Right ab block
  grid[10][12] = '#facc15'; // lapel
  grid[10][13] = '#ffffff';

  // Row 11: Narrow Adonis Waist & Lower Abs
  grid[11][6] = '#94a3b8'; grid[11][7] = '#cbd5e1';
  grid[11][8] = '#facc15'; // lapel
  grid[11][9] = '#fed7aa'; // Lower abs
  grid[11][10] = '#ea580c'; // Navel & core shadow
  grid[11][11] = '#fba772'; // Lower right ab
  grid[11][12] = '#facc15'; // lapel
  grid[11][13] = '#cbd5e1';

  // Officer Leather Belt & Radiant Gold Buckle (y: 12..13)
  grid[12][6] = '#cbd5e1'; grid[12][7] = '#ffffff';
  grid[12][8] = '#78350f'; grid[12][9] = '#fde047'; grid[12][10] = '#facc15'; // buckle
  grid[12][11] = '#78350f'; grid[12][12] = '#451a03'; grid[12][13] = '#ffffff';

  grid[13][6] = '#cbd5e1'; grid[13][7] = '#ffffff';
  grid[13][8] = '#451a03'; grid[13][9] = '#ca8a04'; grid[13][10] = '#ca8a04';
  grid[13][11] = '#451a03'; grid[13][12] = '#291003'; grid[13][13] = '#ffffff';

  // Right Arm (Screen Left) turning
  grid[8][4] = '#cbd5e1'; grid[8][5] = '#ffffff';
  grid[9][3] = '#94a3b8'; grid[9][4] = '#ffffff';
  grid[10][3] = '#94a3b8'; grid[10][4] = '#cbd5e1';
  grid[11][4] = '#ca8a04'; grid[11][5] = '#facc15';
  grid[12][5] = '#fed7aa'; grid[12][6] = '#fba772';

  // Left Arm (Screen Right) reaching up towards face
  grid[8][14] = '#ffffff'; grid[8][15] = '#cbd5e1';
  grid[9][13] = '#cbd5e1'; grid[9][14] = '#ffffff';
  grid[8][12] = '#ca8a04'; grid[8][13] = '#facc15';
  grid[7][11] = '#fed7aa'; grid[7][12] = '#fba772';

  // Legs in 3/4 turn (y: 14..23)
  for (let y = 14; y <= 16; y++) {
    grid[y][6] = '#94a3b8'; grid[y][7] = '#cbd5e1'; grid[y][8] = '#ffffff';
    grid[y][10] = '#cbd5e1'; grid[y][11] = '#ffffff'; grid[y][12] = '#f8fafc';
  }
  grid[17][6] = '#94a3b8'; grid[17][7] = '#cbd5e1'; grid[17][8] = '#f1f5f9';
  grid[17][10] = '#94a3b8'; grid[17][11] = '#cbd5e1'; grid[17][12] = '#f1f5f9';

  grid[18][6] = '#ca8a04'; grid[18][7] = '#fde047'; grid[18][8] = '#ca8a04';
  grid[18][10] = '#ca8a04'; grid[18][11] = '#fde047'; grid[18][12] = '#ca8a04';

  for (let y = 19; y <= 21; y++) {
    grid[y][6] = '#0f172a'; grid[y][7] = '#1e293b'; grid[y][8] = '#334155';
    grid[y][10] = '#0f172a'; grid[y][11] = '#1e293b'; grid[y][12] = '#334155';
  }
  grid[22][6] = '#020617'; grid[22][7] = '#0f172a'; grid[22][8] = '#1e293b';
  grid[22][10] = '#020617'; grid[22][11] = '#0f172a'; grid[22][12] = '#1e293b';

  grid[23][5] = '#020617'; grid[23][6] = '#0f172a'; grid[23][7] = '#1e293b'; grid[23][8] = '#020617';
  grid[23][10] = '#020617'; grid[23][11] = '#0f172a'; grid[23][12] = '#1e293b'; grid[23][13] = '#020617';
}

function _paintHD_PinkBeret_Front_Base(grid) {
  // Shared base for Frontal Poses: Athletic Adonis Hero with Hot Pink Beret & Open White Uniform
  // 1. Sleek Iconic Hot Pink Military Beret (y: 0..2) - Compact noble head (width x: 7..16)
  grid[0][8] = '#ff1493'; grid[0][9] = '#ff69b4'; grid[0][10] = '#ff69b4'; grid[0][11] = '#ff1493'; grid[0][12] = '#ff2a85'; grid[0][13] = '#f43f5e';
  grid[1][7] = '#be123c'; grid[1][8] = '#e11d48'; grid[1][9] = '#fde047'; // Gold Crest Pin!
  grid[1][10] = '#ff1493'; grid[1][11] = '#ff2a85'; grid[1][12] = '#ff2a85'; grid[1][13] = '#ff1493'; grid[1][14] = '#ff2a85'; grid[1][15] = '#e11d48';
  grid[2][7] = '#451a03'; grid[2][8] = '#0f172a'; grid[2][9] = '#0f172a'; grid[2][10] = '#1e293b'; grid[2][11] = '#1e293b'; grid[2][12] = '#0f172a'; grid[2][13] = '#ff2a85'; grid[2][14] = '#ff2a85'; grid[2][15] = '#451a03';

  // 2. THE NEW FACE: Designer Aviator Sunglasses with Dark Polarized Lenses (Row 3)
  grid[3][6] = '#ffffff'; grid[3][7] = '#ffffff';
  grid[3][8] = '#1e293b'; grid[3][9] = '#0f172a'; grid[3][10] = '#1e293b'; // Left dark polarized lens
  grid[3][11] = '#fde047'; // Gold bridge rivet!
  grid[3][12] = '#1e293b'; grid[3][13] = '#0f172a'; grid[3][14] = '#1e293b'; // Right dark polarized lens
  grid[3][15] = '#ffffff'; grid[3][16] = '#ffffff';

  // Row 4: Lower Aviator Lenses, Cheek Contours & Trimmed Retro Mustache
  grid[4][7] = '#fba772';
  grid[4][8] = '#0f172a'; grid[4][9] = '#1e293b';
  grid[4][10] = '#1e293b'; grid[4][11] = '#fed7aa'; grid[4][12] = '#fed7aa'; grid[4][13] = '#1e293b'; // Retro mustache
  grid[4][14] = '#1e293b'; grid[4][15] = '#0f172a';
  grid[4][16] = '#fba772';

  // Row 5: Chiseled Jaw & Puckered Kussmund (Rich Hot Pink Pucker with Peach-Pink Highlight!)
  grid[5][8] = '#fed7aa'; grid[5][9] = '#fba772'; grid[5][10] = '#fed7aa';
  grid[5][11] = '#ff2a85'; grid[5][12] = '#fda4af'; // juicy puckered kiss mouth (Kussmund)!
  grid[5][13] = '#fed7aa'; grid[5][14] = '#fba772'; grid[5][15] = '#fed7aa';

  // Row 6: Athletic Neck & High White Officer Collar
  grid[6][10] = '#facc15'; grid[6][11] = '#fed7aa'; grid[6][12] = '#fba772'; grid[6][13] = '#facc15';

  // Row 7: BROAD ATHLETIC SHOULDERS & RADIANT GOLD EPAULETTES (x: 4..19!) - Heroic V-Taper!
  grid[7][4] = '#ca8a04'; grid[7][5] = '#fde047'; grid[7][6] = '#facc15';
  grid[7][7] = '#cbd5e1'; grid[7][8] = '#ffffff'; grid[7][9] = '#facc15'; // Left lapel
  grid[7][10] = '#fed7aa'; grid[7][11] = '#fed7aa'; grid[7][12] = '#fba772'; grid[7][13] = '#fed7aa'; // Bare hollow of throat
  grid[7][14] = '#facc15'; grid[7][15] = '#ffffff'; grid[7][16] = '#cbd5e1'; // Right lapel
  grid[7][17] = '#facc15'; grid[7][18] = '#fde047'; grid[7][19] = '#ca8a04'; // Right epaulette

  // Rows 8..11: ADONIS TORSO — Sculpted Pectorals, Sternal Cleft & Six-Pack Abs
  // Row 8: Wide Pectorals (Pecs)
  grid[8][5] = '#cbd5e1'; grid[8][6] = '#ffffff'; grid[8][7] = '#ffffff'; grid[8][8] = '#f8fafc';
  grid[8][9] = '#facc15'; // Gold button
  grid[8][10] = '#fed7aa'; grid[8][11] = '#fba772'; grid[8][12] = '#fba772'; grid[8][13] = '#fed7aa'; // Muscular pecs
  grid[8][14] = '#facc15'; // Gold button
  grid[8][15] = '#f8fafc'; grid[8][16] = '#ffffff'; grid[8][17] = '#ffffff'; grid[8][18] = '#cbd5e1';

  // Row 9: Lower Pec Shelf & Deep Sternal Definition
  grid[9][6] = '#cbd5e1'; grid[9][7] = '#ffffff'; grid[9][8] = '#ffffff';
  grid[9][9] = '#facc15'; // Gold button
  grid[9][10] = '#fba772'; grid[9][11] = '#ea580c'; grid[9][12] = '#ea580c'; grid[9][13] = '#fba772'; // Deep cleft!
  grid[9][14] = '#facc15'; // Gold button
  grid[9][15] = '#ffffff'; grid[9][16] = '#ffffff'; grid[9][17] = '#cbd5e1';

  // Row 10: Toned Six-Pack Abs (Upper Tier)
  grid[10][6] = '#cbd5e1'; grid[10][7] = '#ffffff'; grid[10][8] = '#cbd5e1';
  grid[10][9] = '#facc15';
  grid[10][10] = '#fed7aa'; grid[10][11] = '#fba772'; grid[10][12] = '#fba772'; grid[10][13] = '#fed7aa';
  grid[10][14] = '#facc15';
  grid[10][15] = '#cbd5e1'; grid[10][16] = '#ffffff'; grid[10][17] = '#cbd5e1';

  // Row 11: Narrow Adonis Waist, Lower Abs & Navel
  grid[11][7] = '#cbd5e1'; grid[11][8] = '#ffffff';
  grid[11][9] = '#facc15';
  grid[11][10] = '#fed7aa'; grid[11][11] = '#ea580c'; grid[11][12] = '#fba772'; grid[11][13] = '#fed7aa';
  grid[11][14] = '#facc15';
  grid[11][15] = '#ffffff'; grid[11][16] = '#cbd5e1';

  // Officer Leather Belt & Radiant Gold Buckle (y: 12..13)
  for (let y = 12; y <= 13; y++) {
    grid[y][7] = '#cbd5e1'; grid[y][8] = '#ffffff';
    grid[y][9] = '#451a03'; grid[y][10] = '#78350f';
    grid[y][11] = '#fde047'; grid[y][12] = '#facc15';
    grid[y][13] = '#78350f'; grid[y][14] = '#451a03';
    grid[y][15] = '#ffffff'; grid[y][16] = '#cbd5e1';
  }

  // Muscular Right Arm Akimbo on Hip (y: 8..13, x: 2..6)
  grid[8][3] = '#94a3b8'; grid[8][4] = '#ffffff';
  grid[9][2] = '#64748b'; grid[9][3] = '#ffffff'; grid[9][4] = '#cbd5e1';
  grid[10][2] = '#64748b'; grid[10][3] = '#cbd5e1'; grid[10][4] = '#ffffff';
  grid[11][3] = '#ca8a04'; grid[11][4] = '#facc15'; // gold cuff
  grid[12][4] = '#fed7aa'; grid[12][5] = '#fed7aa'; grid[12][6] = '#fba772'; // resting hand on hip
  grid[13][5] = '#fed7aa'; grid[13][6] = '#fed7aa';

  // Statuesque Legs (y: 14..23)
  for (let y = 14; y <= 16; y++) {
    grid[y][8] = '#ffffff'; grid[y][9] = '#f8fafc'; grid[y][10] = '#cbd5e1';
    grid[y][13] = '#cbd5e1'; grid[y][14] = '#ffffff'; grid[y][15] = '#f8fafc';
  }
  grid[17][8] = '#f1f5f9'; grid[17][9] = '#cbd5e1'; grid[17][10] = '#94a3b8';
  grid[17][13] = '#94a3b8'; grid[17][14] = '#cbd5e1'; grid[17][15] = '#f1f5f9';

  grid[18][8] = '#ca8a04'; grid[18][9] = '#fde047'; grid[18][10] = '#ca8a04';
  grid[18][13] = '#ca8a04'; grid[18][14] = '#fde047'; grid[18][15] = '#ca8a04';

  for (let y = 19; y <= 21; y++) {
    grid[y][8] = '#1e293b'; grid[y][9] = '#334155'; grid[y][10] = '#0f172a';
    grid[y][13] = '#0f172a'; grid[y][14] = '#334155'; grid[y][15] = '#1e293b';
  }
  grid[22][8] = '#0f172a'; grid[22][9] = '#1e293b'; grid[22][10] = '#020617';
  grid[22][13] = '#020617'; grid[22][14] = '#1e293b'; grid[22][15] = '#0f172a';

  grid[23][7] = '#020617'; grid[23][8] = '#0f172a'; grid[23][9] = '#1e293b'; grid[23][10] = '#020617';
  grid[23][13] = '#020617'; grid[23][14] = '#1e293b'; grid[23][15] = '#0f172a'; grid[23][16] = '#020617';
}

function _paintHD_PinkBeret_Front_Kiss(grid) {
  // Stage 2: Hand kissing puckered lips!
  _paintHD_PinkBeret_Front_Base(grid);
  grid[8][17] = '#ffffff'; grid[8][18] = '#cbd5e1';
  grid[9][16] = '#cbd5e1'; grid[9][17] = '#ffffff';
  grid[8][15] = '#ffffff'; grid[7][15] = '#ffffff';
  grid[6][14] = '#facc15'; grid[6][15] = '#ca8a04'; // gold cuff
  grid[5][12] = '#fda4af'; grid[5][13] = '#fed7aa'; grid[5][14] = '#fba772'; // kissing fingertips touching puckered lips
}

function _paintHD_PinkBeret_Front_Wink(grid) {
  // Stage 3 & 4 (FINAL FRAME): Hand blown open towards player, Kussmund pursed blowing heart!
  _paintHD_PinkBeret_Front_Base(grid);
  grid[8][17] = '#ffffff'; grid[8][18] = '#cbd5e1';
  grid[9][16] = '#cbd5e1'; grid[9][17] = '#ffffff'; grid[9][18] = '#94a3b8';
  grid[9][15] = '#ca8a04'; grid[9][14] = '#facc15'; // gold cuff at wrist
  // Cupped palm & fingertips blowing kiss up toward player
  grid[8][14] = '#fed7aa'; grid[8][15] = '#fba772'; grid[8][16] = '#fba772';
  grid[7][13] = '#fed7aa'; grid[7][14] = '#fed7aa'; grid[7][15] = '#fba772';
  grid[6][13] = '#fed7aa'; grid[6][14] = '#fba772'; // graceful fingertips pointing toward player
}

function makePinkBeretGold(base) {
  const g = 24, grid = makeGrid();
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      const c = base.grid[y][x];
      if (!c) continue;
      // White uniform -> Lustrous Platinum Gold
      if (c === '#ffffff' || c === '#f8fafc') grid[y][x] = '#fef08a';
      else if (c === '#f1f5f9' || c === '#e2e8f0') grid[y][x] = '#fde047';
      else if (c === '#cbd5e1') grid[y][x] = '#eab308';
      else if (c === '#94a3b8') grid[y][x] = '#ca8a04';
      // Steel / launcher / dark metals -> Deep Obsidian Violet
      else if (c === '#64748b') grid[y][x] = '#7e22ce';
      else if (c === '#475569') grid[y][x] = '#581c87';
      else if (c === '#334155') grid[y][x] = '#3b0764';
      else if (c === '#1e293b') grid[y][x] = '#2e1065';
      else if (c === '#0f172a' || c === '#020617') grid[y][x] = '#1e1b4b';
      // Beret Pink -> Metallic Rose Gold / Ruby
      else if (c === '#ff2a85') grid[y][x] = '#f43f5e';
      else if (c === '#fb7185') grid[y][x] = '#fb7185';
      else if (c === '#fda4af') grid[y][x] = '#fecdd3';
      else if (c === '#f43f5e') grid[y][x] = '#e11d48';
      else if (c === '#e11d48') grid[y][x] = '#be123c';
      else if (c === '#be123c') grid[y][x] = '#9f1239';
      else if (c === '#9f1239') grid[y][x] = '#881337';
      // Gold trim stays brilliant warm gold
      else if (c === '#facc15') grid[y][x] = '#facc15';
      else if (c === '#fde047') grid[y][x] = '#fef08a';
      else if (c === '#ca8a04') grid[y][x] = '#a16207';
      else grid[y][x] = c;
    }
  }
  return { grid, gridSize: g };
}

function getHD_PinkBeret_Torso() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Torso(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Torso_Turn() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Torso_Turn(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Legs(frame = 0) { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Legs(grid, frame); return { grid, gridSize: g }; }
function getHD_PinkBeret_Legs_Stand() { return getHD_PinkBeret_Legs(0); }
function getHD_PinkBeret_Legs_Tap() { return getHD_PinkBeret_Legs('tap'); }
function getHD_PinkBeret_Legs_Crouch() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Legs_Crouch(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Legs_Heave() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Legs_Heave(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Legs_Aim() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Legs_Aim(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Legs_Walk1() { return getHD_PinkBeret_Legs(1); }
function getHD_PinkBeret_Legs_Walk2() { return getHD_PinkBeret_Legs(2); }
function getHD_PinkBeret_Legs_Walk3() { return getHD_PinkBeret_Legs(3); }
function getHD_PinkBeret_Legs_Walk4() { return getHD_PinkBeret_Legs(4); }
function getHD_PinkBeret_Legs_Walk5() { return getHD_PinkBeret_Legs(5); }
function getHD_PinkBeret_Legs_Walk6() { return getHD_PinkBeret_Legs(6); }
function getHD_PinkBeret_Launcher_Carry() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Launcher_Carry(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Launcher_Lift() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Launcher_Lift(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Launcher_Heave() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Launcher_Heave(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Launcher_Mount() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Launcher_Mount(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Launcher_Aim45() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Launcher_Aim45(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Arm_Rear() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Arm_Rear(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Pistol() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Pistol(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Kiss() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Kiss(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Front_Turn() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Front_Turn(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Front_Kiss() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Front_Kiss(grid); return { grid, gridSize: g }; }
function getHD_PinkBeret_Front_Wink() { const g = 24, grid = makeGrid(); _paintHD_PinkBeret_Front_Wink(grid); return { grid, gridSize: g }; }

function getHD_PinkBeret() {
  const g = 24, grid = makeGrid();
  _paintHD_PinkBeret_Legs(grid, 0);
  _paintHD_PinkBeret_Torso(grid);
  _paintHD_PinkBeret_Launcher_Aim45(grid);
  return { grid, gridSize: g };
}

// Gold Getters
function getHD_PinkBeretGold() { return makePinkBeretGold(getHD_PinkBeret()); }
function getHD_PinkBeretGold_Torso() { return makePinkBeretGold(getHD_PinkBeret_Torso()); }
function getHD_PinkBeretGold_Torso_Turn() { return makePinkBeretGold(getHD_PinkBeret_Torso_Turn()); }
function getHD_PinkBeretGold_Legs() { return makePinkBeretGold(getHD_PinkBeret_Legs(0)); }
function getHD_PinkBeretGold_Legs_Stand() { return makePinkBeretGold(getHD_PinkBeret_Legs_Stand()); }
function getHD_PinkBeretGold_Legs_Tap() { return makePinkBeretGold(getHD_PinkBeret_Legs_Tap()); }
function getHD_PinkBeretGold_Legs_Crouch() { return makePinkBeretGold(getHD_PinkBeret_Legs_Crouch()); }
function getHD_PinkBeretGold_Legs_Heave() { return makePinkBeretGold(getHD_PinkBeret_Legs_Heave()); }
function getHD_PinkBeretGold_Legs_Aim() { return makePinkBeretGold(getHD_PinkBeret_Legs_Aim()); }
function getHD_PinkBeretGold_Legs_Walk1() { return makePinkBeretGold(getHD_PinkBeret_Legs_Walk1()); }
function getHD_PinkBeretGold_Legs_Walk2() { return makePinkBeretGold(getHD_PinkBeret_Legs_Walk2()); }
function getHD_PinkBeretGold_Legs_Walk3() { return makePinkBeretGold(getHD_PinkBeret_Legs_Walk3()); }
function getHD_PinkBeretGold_Legs_Walk4() { return makePinkBeretGold(getHD_PinkBeret_Legs_Walk4()); }
function getHD_PinkBeretGold_Legs_Walk5() { return makePinkBeretGold(getHD_PinkBeret_Legs_Walk5()); }
function getHD_PinkBeretGold_Legs_Walk6() { return makePinkBeretGold(getHD_PinkBeret_Legs_Walk6()); }
function getHD_PinkBeretGold_Launcher_Carry() { return makePinkBeretGold(getHD_PinkBeret_Launcher_Carry()); }
function getHD_PinkBeretGold_Launcher_Lift() { return makePinkBeretGold(getHD_PinkBeret_Launcher_Lift()); }
function getHD_PinkBeretGold_Launcher_Heave() { return makePinkBeretGold(getHD_PinkBeret_Launcher_Heave()); }
function getHD_PinkBeretGold_Launcher_Mount() { return makePinkBeretGold(getHD_PinkBeret_Launcher_Mount()); }
function getHD_PinkBeretGold_Launcher_Aim45() { return makePinkBeretGold(getHD_PinkBeret_Launcher_Aim45()); }
function getHD_PinkBeretGold_Arm_Rear() { return makePinkBeretGold(getHD_PinkBeret_Arm_Rear()); }
function getHD_PinkBeretGold_Pistol() { return makePinkBeretGold(getHD_PinkBeret_Pistol()); }
function getHD_PinkBeretGold_Kiss() { return makePinkBeretGold(getHD_PinkBeret_Kiss()); }
function getHD_PinkBeretGold_Front_Turn() { return makePinkBeretGold(getHD_PinkBeret_Front_Turn()); }
function getHD_PinkBeretGold_Front_Kiss() { return makePinkBeretGold(getHD_PinkBeret_Front_Kiss()); }
function getHD_PinkBeretGold_Front_Wink() { return makePinkBeretGold(getHD_PinkBeret_Front_Wink()); }

// ─────────────────────────────────────────────────────────────
// PINK BERET 48×48 UHD NATIVE RELAUNCH SPRITES (RLE ENCODED)
// ─────────────────────────────────────────────────────────────
const _UHD_PB_PALETTE = ["#020617", "#0284c7", "#0f172a", "#14532d", "#1e293b", "#323437", "#334155", "#365314", "#38bdf8", "#3f6212", "#451a03", "#475569", "#4d7c0f", "#554c57", "#58575d", "#63322b", "#64748b", "#65a30d", "#701a75", "#78350f", "#831843", "#84cc16", "#92400e", "#94a3b8", "#9a3412", "#9d174d", "#be185d", "#bef264", "#c2410c", "#ca8a04", "#cbd5e1", "#db2777", "#ea580c", "#f1f5f9", "#f43f5e", "#f8fafc", "#f97316", "#facc15", "#fba772", "#fda4af", "#fde047", "#fed7aa", "#fef08a", "#ff2a85", "#ffedd5", "#ffffff", "#bae6fd", "#be123c", "#ff69b4", "#e0f2fe"];
const _UHD_PB_GOLD_PALETTE = ["#1e1b4b", "#0284c7", "#1e1b4b", "#854d0e", "#2e1065", "#1e1b4b", "#3b0764", "#365314", "#38bdf8", "#854d0e", "#451a03", "#581c87", "#854d0e", "#1e1b4b", "#1e1b4b", "#63322b", "#7e22ce", "#854d0e", "#701a75", "#78350f", "#831843", "#84cc16", "#92400e", "#ca8a04", "#9a3412", "#9d174d", "#be185d", "#bef264", "#b45309", "#ca8a04", "#eab308", "#ffd700", "#d97706", "#fde047", "#ffd700", "#fef08a", "#f97316", "#fde047", "#facc15", "#ffd700", "#fde047", "#fef08a", "#ffffff", "#ffd700", "#ffedd5", "#fef08a", "#38bdf8", "#9f1239", "#fecdd3", "#ffffff"];

function _decodeUHD_PB(palette, rle) {
  const g = 48, grid = [];
  for (let y = 0; y < 48; y++) grid.push(new Array(48).fill(null));
  let pos = 0;
  for (let i = 0; i < rle.length; i += 2) {
    const palIdx = rle[i];
    const count = rle[i + 1];
    const color = palIdx === 0 ? null : palette[palIdx - 1];
    for (let c = 0; c < count; c++) {
      const y = Math.floor(pos / 48);
      const x = pos % 48;
      if (y < 48) grid[y][x] = color;
      pos++;
    }
  }
  return { grid, gridSize: g };
}

const _UHD_PB_STAND_RLE = [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 0, 41, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 46, 2, 29, 1, 46, 5, 3, 1, 24, 1, 41, 1, 0, 35, 24, 1, 0, 1, 3, 1, 42, 1, 29, 1, 46, 5, 3, 1, 0, 42, 46, 5, 3, 1, 0, 40, 3, 1, 31, 2, 46, 5, 3, 1, 0, 38, 31, 4, 34, 1, 46, 5, 0, 38, 24, 1, 31, 4, 46, 5, 0, 37, 3, 1, 31, 5, 46, 5, 0, 35, 41, 1, 3, 1, 31, 5, 0, 1, 46, 5, 0, 35, 24, 1, 3, 1, 31, 4, 3, 1, 0, 1, 46, 5, 24, 1, 0, 31, 41, 1, 0, 3, 41, 1, 31, 3, 3, 1, 0, 2, 3, 1, 46, 4, 3, 1, 0, 30, 41, 1, 43, 1, 41, 1, 24, 2, 38, 1, 3, 1, 31, 1, 0, 1, 3, 1, 0, 3, 46, 5, 0, 31, 30, 1, 0, 2, 3, 2, 46, 1, 41, 1, 43, 1, 0, 4, 3, 1, 46, 4, 3, 1, 0, 29, 30, 1, 3, 1, 5, 1, 0, 2, 6, 1, 38, 1, 41, 1, 30, 1, 3, 1, 0, 4, 46, 3, 31, 1, 0, 31, 3, 1, 5, 1, 7, 1, 0, 1, 1, 4, 41, 1, 0, 3, 41, 1, 34, 1, 46, 3, 0, 33, 3, 1, 5, 5, 3, 1, 0, 1, 3, 1, 46, 5, 3, 1, 0, 34, 1, 5, 3, 2, 5, 1, 38, 2, 7, 6, 3, 1, 0, 36, 38, 1, 3, 1, 5, 2, 7, 8, 3, 1, 0, 36, 1, 3, 3, 1, 1, 7, 3, 1, 0, 14];
const _UHD_PB_TORSO_RLE = [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 0, 39, 30, 1, 46, 3, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 37, 3, 1, 46, 1, 41, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 37, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 37, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 37, 3, 1, 46, 3, 33, 5, 16, 1, 39, 1, 0, 37, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 37, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 37, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 0, 37, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 0, 37, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 37, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 37, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 1027];
const _UHD_PB_TORSO_TURN_RLE = [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 0, 39, 30, 1, 46, 3, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 37, 3, 1, 46, 1, 41, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 37, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 37, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 37, 3, 1, 46, 3, 33, 5, 16, 1, 39, 1, 0, 37, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 37, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 37, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 0, 37, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 0, 37, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 37, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 37, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 1027];
const _UHD_PB_LEGS_STAND_RLE = [0, 1169, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 37, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 34, 3, 1, 31, 1, 46, 1, 0, 1, 3, 1, 46, 2, 29, 1, 46, 5, 3, 1, 24, 1, 41, 1, 0, 35, 24, 1, 0, 1, 3, 1, 42, 1, 29, 1, 46, 5, 3, 1, 0, 42, 46, 5, 3, 1, 0, 40, 3, 1, 31, 2, 46, 5, 3, 1, 0, 38, 31, 4, 34, 1, 46, 5, 0, 38, 24, 1, 31, 4, 46, 5, 0, 37, 3, 1, 31, 5, 46, 5, 0, 35, 41, 1, 3, 1, 31, 5, 0, 1, 46, 5, 0, 35, 24, 1, 3, 1, 31, 4, 3, 1, 0, 1, 46, 5, 24, 1, 0, 31, 41, 1, 0, 3, 41, 1, 31, 3, 3, 1, 0, 2, 3, 1, 46, 4, 3, 1, 0, 30, 41, 1, 43, 1, 41, 1, 24, 2, 38, 1, 3, 1, 31, 1, 0, 1, 3, 1, 0, 3, 46, 5, 0, 31, 30, 1, 0, 2, 3, 2, 46, 1, 41, 1, 43, 1, 0, 4, 3, 1, 46, 4, 3, 1, 0, 29, 30, 1, 3, 1, 5, 1, 0, 2, 6, 1, 38, 1, 41, 1, 30, 1, 3, 1, 0, 4, 46, 3, 31, 1, 0, 31, 3, 1, 5, 1, 7, 1, 0, 1, 1, 4, 41, 1, 0, 3, 41, 1, 34, 1, 46, 3, 0, 33, 3, 1, 5, 5, 3, 1, 0, 1, 3, 1, 46, 5, 3, 1, 0, 34, 1, 5, 3, 2, 5, 1, 38, 2, 7, 6, 3, 1, 0, 36, 38, 1, 3, 1, 5, 2, 7, 8, 3, 1, 0, 36, 1, 3, 3, 1, 1, 7, 3, 1, 0, 14];
const _UHD_PB_LEGS_TAP_RLE = [0, 1169, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 37, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 34, 3, 1, 31, 1, 46, 1, 0, 1, 3, 1, 46, 2, 29, 1, 46, 5, 3, 1, 24, 1, 41, 1, 0, 35, 24, 1, 0, 1, 3, 1, 42, 1, 29, 1, 46, 5, 3, 1, 0, 41, 3, 1, 31, 1, 36, 4, 34, 1, 3, 1, 0, 39, 3, 2, 31, 1, 36, 4, 34, 1, 3, 1, 0, 38, 31, 2, 3, 1, 31, 1, 36, 4, 34, 1, 3, 1, 0, 38, 24, 1, 31, 1, 3, 1, 31, 1, 36, 4, 34, 1, 3, 1, 0, 37, 3, 1, 31, 2, 3, 1, 31, 1, 36, 4, 34, 1, 3, 1, 0, 35, 41, 1, 3, 1, 31, 3, 3, 1, 24, 1, 36, 4, 3, 1, 0, 36, 24, 1, 3, 1, 31, 2, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 0, 34, 41, 1, 0, 3, 41, 1, 31, 2, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 0, 33, 41, 1, 43, 1, 41, 1, 24, 2, 38, 1, 3, 1, 31, 1, 3, 1, 5, 1, 7, 1, 12, 1, 7, 1, 3, 1, 0, 35, 30, 1, 0, 2, 3, 2, 46, 1, 41, 1, 3, 1, 5, 1, 7, 1, 12, 1, 7, 1, 3, 1, 0, 34, 30, 1, 3, 1, 5, 1, 0, 2, 6, 1, 38, 1, 41, 1, 3, 1, 5, 1, 7, 1, 12, 1, 7, 1, 3, 1, 0, 35, 3, 1, 5, 1, 7, 1, 0, 1, 1, 3, 3, 1, 5, 1, 7, 1, 12, 1, 7, 1, 5, 1, 3, 1, 0, 36, 3, 1, 5, 5, 0, 1, 3, 1, 1, 1, 7, 1, 12, 1, 7, 1, 3, 1, 0, 36, 1, 5, 0, 3, 3, 1, 1, 3, 3, 1, 0, 115];
const _UHD_PB_LEGS_DANCE1_RLE = _UHD_PB_LEGS_STAND_RLE;
const _UHD_PB_LEGS_DANCE2_RLE = _UHD_PB_LEGS_TAP_RLE;
const _UHD_PB_LEGS_DANCE3_RLE = [0, 1169, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 37, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 34, 3, 1, 31, 1, 46, 1, 0, 1, 3, 1, 46, 2, 29, 1, 46, 5, 3, 1, 24, 1, 41, 1, 0, 35, 24, 1, 0, 1, 3, 1, 42, 1, 29, 1, 46, 5, 3, 1, 0, 42, 46, 5, 3, 1, 0, 40, 3, 1, 31, 2, 46, 5, 3, 1, 0, 38, 31, 4, 34, 1, 46, 5, 0, 38, 24, 1, 31, 4, 46, 5, 0, 37, 3, 1, 31, 5, 46, 5, 0, 35, 41, 1, 3, 1, 31, 5, 0, 1, 46, 5, 0, 35, 24, 1, 3, 1, 31, 4, 3, 1, 0, 1, 46, 5, 24, 1, 0, 31, 41, 1, 0, 3, 41, 1, 31, 3, 3, 1, 0, 2, 3, 1, 46, 4, 3, 1, 0, 30, 41, 1, 43, 1, 41, 1, 24, 2, 38, 1, 3, 1, 31, 1, 0, 1, 3, 1, 0, 3, 46, 5, 0, 31, 30, 1, 0, 2, 3, 2, 46, 1, 41, 1, 43, 1, 0, 4, 3, 1, 46, 4, 3, 1, 0, 29, 30, 1, 3, 1, 5, 1, 0, 2, 6, 1, 38, 1, 41, 1, 30, 1, 3, 1, 0, 4, 46, 3, 31, 1, 0, 31, 3, 1, 5, 1, 7, 1, 0, 1, 1, 4, 41, 1, 0, 3, 41, 1, 34, 1, 46, 3, 0, 33, 3, 1, 5, 5, 3, 1, 0, 1, 3, 1, 46, 5, 3, 1, 0, 34, 1, 5, 3, 2, 5, 1, 38, 2, 7, 6, 3, 1, 0, 36, 3, 1, 5, 11, 3, 1, 0, 35, 3, 1, 1, 11, 3, 1, 0, 14];
const _UHD_PB_LEGS_DANCE4_RLE = [0, 1169, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 7, 34, 1, 3, 1, 0, 37, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 37, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 34, 3, 1, 31, 1, 46, 1, 0, 1, 3, 1, 46, 2, 29, 1, 46, 5, 3, 1, 24, 1, 41, 1, 0, 35, 24, 1, 0, 1, 3, 1, 42, 1, 29, 1, 46, 5, 3, 1, 0, 42, 46, 5, 3, 1, 0, 40, 3, 1, 31, 2, 46, 5, 3, 1, 0, 38, 31, 4, 34, 1, 46, 5, 0, 38, 24, 1, 31, 4, 46, 5, 0, 37, 3, 1, 31, 5, 46, 5, 0, 35, 41, 1, 3, 1, 31, 5, 0, 1, 46, 5, 0, 35, 24, 1, 3, 1, 31, 4, 3, 1, 0, 1, 46, 5, 24, 1, 0, 31, 41, 1, 0, 3, 41, 1, 31, 3, 3, 1, 0, 2, 3, 1, 46, 4, 3, 1, 0, 30, 41, 1, 43, 1, 41, 1, 24, 2, 38, 1, 3, 1, 31, 1, 0, 1, 3, 1, 0, 3, 46, 5, 0, 31, 30, 1, 0, 2, 3, 2, 46, 1, 41, 1, 43, 1, 0, 4, 3, 1, 46, 4, 3, 1, 0, 29, 30, 1, 3, 1, 5, 1, 7, 1, 3, 1, 6, 1, 38, 1, 41, 1, 30, 1, 3, 1, 0, 4, 46, 3, 31, 1, 0, 31, 3, 2, 5, 1, 7, 1, 12, 1, 3, 1, 1, 2, 41, 1, 0, 3, 41, 1, 34, 1, 46, 3, 0, 33, 3, 1, 1, 1, 7, 1, 3, 1, 0, 4, 3, 1, 46, 5, 3, 1, 0, 34, 3, 1, 1, 2, 3, 1, 0, 2, 3, 1, 5, 1, 38, 2, 7, 6, 3, 1, 0, 37, 3, 1, 5, 2, 7, 8, 3, 1, 0, 36, 1, 3, 3, 1, 1, 7, 3, 1, 0, 14];
const _UHD_PB_GUNFIRE_RLE = [0, 69, 21, 1, 32, 3, 21, 1, 0, 40, 21, 1, 27, 1, 32, 3, 35, 2, 27, 1, 21, 1, 0, 37, 21, 1, 27, 7, 32, 1, 27, 1, 21, 1, 0, 36, 19, 1, 21, 1, 26, 7, 41, 1, 43, 1, 30, 1, 0, 36, 19, 2, 21, 7, 38, 1, 41, 1, 30, 1, 0, 37, 19, 1, 3, 8, 19, 1, 0, 40, 11, 1, 39, 1, 42, 1, 45, 1, 42, 1, 45, 1, 42, 2, 39, 1, 3, 1, 0, 38, 39, 2, 5, 2, 46, 2, 5, 2, 3, 1, 0, 39, 42, 1, 33, 1, 39, 1, 42, 2, 45, 1, 42, 2, 39, 1, 3, 1, 0, 37, 46, 1, 39, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 2, 39, 1, 3, 1, 0, 38, 31, 1, 33, 2, 39, 1, 12, 1, 3, 3, 12, 1, 39, 1, 3, 1, 0, 34, 30, 1, 38, 1, 41, 1, 0, 1, 33, 2, 39, 2, 42, 2, 39, 1, 3, 1, 0, 36, 30, 1, 38, 1, 41, 1, 30, 1, 29, 2, 39, 2, 3, 3, 29, 1, 0, 36, 38, 1, 41, 1, 38, 1, 30, 1, 38, 1, 46, 2, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 34, 30, 1, 38, 1, 30, 1, 38, 1, 30, 1, 46, 3, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 38, 1, 41, 1, 38, 1, 0, 7, 3, 1, 5, 1, 7, 1, 24, 1, 31, 1, 34, 1, 46, 1, 31, 1, 3, 1, 0, 16, 46, 4, 41, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 31, 1, 46, 2, 36, 1, 3, 1, 0, 4, 30, 1, 38, 1, 5, 1, 7, 1, 12, 1, 3, 1, 7, 1, 31, 1, 34, 1, 31, 1, 38, 1, 3, 1, 0, 14, 3, 1, 46, 6, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 24, 1, 31, 1, 38, 1, 41, 1, 3, 1, 42, 1, 45, 1, 42, 2, 30, 1, 46, 1, 3, 1, 5, 2, 30, 1, 3, 1, 7, 2, 12, 1, 3, 1, 0, 15, 46, 5, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 3, 39, 1, 42, 1, 45, 1, 42, 1, 39, 1, 3, 1, 24, 1, 31, 1, 46, 1, 36, 1, 3, 2, 7, 1, 3, 1, 0, 16, 3, 1, 46, 7, 33, 5, 16, 1, 39, 1, 0, 3, 33, 1, 39, 2, 33, 1, 3, 2, 24, 1, 31, 1, 46, 2, 36, 1, 3, 1, 0, 18, 3, 1, 46, 5, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 11, 3, 1, 31, 1, 46, 1, 3, 1, 0, 18, 3, 2, 46, 3, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 11, 3, 1, 24, 1, 31, 1, 3, 1, 0, 18, 3, 1, 39, 3, 0, 2, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 0, 12, 3, 1, 7, 1, 3, 1, 0, 18, 3, 1, 39, 3, 0, 2, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 0, 33, 3, 1, 39, 3, 0, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 34, 1, 46, 1, 34, 1, 3, 1, 0, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 33, 31, 1, 46, 2, 3, 1, 0, 6, 38, 1, 30, 1, 0, 2, 46, 1, 0, 33, 24, 1, 31, 1, 3, 1, 46, 2, 20, 3, 30, 1, 38, 1, 41, 1, 20, 1, 46, 2, 3, 1, 0, 35, 3, 1, 46, 2, 20, 3, 30, 1, 38, 1, 41, 1, 20, 1, 46, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 1, 31, 1, 24, 1, 3, 1, 31, 1, 46, 1, 36, 1, 46, 1, 31, 1, 3, 1, 0, 35, 3, 1, 17, 1, 24, 1, 31, 1, 24, 1, 3, 2, 31, 1, 46, 1, 36, 1, 46, 1, 31, 1, 3, 1, 0, 35, 3, 1, 17, 1, 24, 1, 31, 1, 24, 1, 3, 1, 0, 1, 3, 1, 31, 1, 46, 1, 36, 1, 46, 1, 31, 1, 3, 1, 0, 34, 3, 1, 17, 1, 24, 1, 31, 1, 24, 1, 3, 1, 0, 2, 3, 1, 31, 1, 46, 1, 36, 1, 46, 1, 31, 1, 3, 1, 0, 32, 3, 1, 17, 1, 24, 1, 31, 1, 24, 1, 3, 1, 0, 3, 3, 1, 31, 1, 46, 1, 36, 1, 46, 1, 31, 1, 3, 1, 0, 31, 3, 1, 17, 1, 24, 1, 31, 1, 24, 1, 3, 1, 0, 4, 3, 1, 31, 1, 46, 1, 36, 1, 46, 1, 31, 1, 3, 1, 0, 31, 3, 1, 17, 1, 24, 1, 31, 1, 24, 1, 3, 1, 0, 5, 3, 1, 31, 1, 46, 1, 36, 1, 46, 3, 0, 30, 3, 1, 17, 1, 24, 1, 31, 1, 24, 1, 3, 1, 0, 6, 3, 1, 31, 1, 46, 1, 36, 2, 31, 1, 3, 1, 0, 27, 3, 1, 30, 6, 3, 1, 0, 6, 3, 1, 38, 2, 41, 1, 38, 3, 3, 1, 0, 26, 3, 1, 1, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 8, 3, 1, 5, 1, 7, 1, 12, 1, 7, 1, 5, 1, 3, 1, 0, 27, 3, 1, 1, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 8, 3, 1, 5, 1, 7, 1, 12, 1, 7, 1, 5, 1, 3, 1, 0, 26, 3, 1, 1, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 9, 3, 1, 5, 1, 7, 1, 12, 1, 7, 1, 5, 1, 3, 1, 0, 26, 3, 1, 1, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 9, 3, 1, 5, 1, 7, 1, 12, 1, 7, 1, 5, 1, 3, 1, 0, 26, 3, 1, 1, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 10, 3, 1, 5, 1, 7, 1, 12, 1, 7, 1, 5, 1, 3, 1, 0, 25, 3, 1, 1, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 10, 3, 1, 5, 1, 7, 1, 12, 1, 7, 1, 5, 1, 3, 1, 0, 24, 3, 1, 1, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 11, 3, 1, 5, 1, 7, 1, 12, 1, 7, 1, 5, 1, 3, 1, 0, 23, 3, 1, 5, 6, 3, 1, 0, 8, 3, 1, 5, 2, 7, 5, 5, 1, 3, 1, 0, 21, 3, 1, 1, 8, 3, 1, 0, 7, 3, 1, 1, 8, 3, 1, 0, 21, 3, 1, 1, 8, 3, 1, 0, 7, 3, 1, 1, 8, 3, 1, 0, 16];
const _UHD_PB_FRONT_KISS_RLE = [0, 66, 49, 12, 0, 44, 44, 4, 0, 39, 38, 1, 0, 4, 44, 4, 0, 38, 30, 1, 41, 1, 38, 1, 0, 2, 44, 6, 0, 34, 44, 3, 30, 1, 38, 1, 30, 1, 44, 1, 0, 45, 30, 1, 0, 1, 48, 8, 0, 34, 11, 1, 3, 12, 11, 1, 0, 34, 46, 6, 41, 1, 38, 1, 46, 6, 0, 34, 46, 1, 3, 2, 5, 2, 3, 1, 30, 2, 3, 1, 5, 2, 3, 2, 46, 1, 0, 34, 46, 1, 3, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 2, 3, 1, 5, 1, 7, 1, 5, 1, 3, 1, 46, 1, 0, 34, 46, 1, 3, 2, 5, 2, 3, 1, 0, 2, 3, 1, 5, 2, 3, 2, 46, 1, 0, 35, 39, 2, 42, 8, 39, 2, 0, 38, 3, 3, 39, 2, 3, 3, 0, 39, 39, 3, 0, 1, 44, 1, 40, 1, 46, 1, 36, 1, 46, 1, 39, 1, 0, 38, 39, 4, 44, 1, 40, 1, 44, 1, 46, 1, 36, 1, 30, 1, 38, 1, 0, 39, 39, 1, 42, 4, 39, 1, 0, 1, 30, 1, 38, 1, 41, 1, 46, 1, 0, 35, 38, 1, 41, 1, 33, 1, 39, 4, 33, 1, 41, 1, 38, 1, 31, 1, 46, 2, 0, 25, 30, 1, 38, 1, 41, 2, 38, 1, 30, 1, 46, 1, 38, 1, 39, 3, 42, 8, 39, 3, 38, 1, 31, 1, 46, 2, 41, 2, 38, 1, 30, 1, 0, 18, 30, 1, 38, 1, 41, 2, 38, 1, 30, 1, 46, 1, 38, 1, 39, 2, 42, 4, 33, 2, 42, 4, 39, 2, 38, 1, 31, 1, 46, 2, 41, 2, 38, 1, 30, 1, 0, 19, 46, 2, 31, 1, 0, 2, 46, 1, 38, 1, 39, 2, 42, 4, 29, 2, 42, 4, 39, 2, 38, 1, 31, 1, 46, 4, 0, 21, 46, 2, 31, 1, 0, 2, 46, 1, 38, 1, 39, 2, 33, 4, 29, 2, 33, 4, 39, 2, 38, 1, 46, 1, 0, 1, 31, 1, 46, 2, 0, 21, 46, 2, 31, 1, 0, 3, 46, 1, 38, 1, 39, 2, 42, 3, 33, 2, 42, 3, 39, 2, 38, 1, 46, 1, 0, 2, 31, 1, 46, 2, 0, 20, 46, 2, 31, 2, 0, 3, 46, 1, 38, 1, 39, 2, 42, 3, 33, 2, 42, 3, 39, 2, 38, 1, 46, 1, 0, 25, 46, 2, 31, 1, 0, 5, 46, 1, 38, 1, 39, 1, 42, 3, 33, 1, 29, 1, 42, 3, 39, 1, 38, 1, 46, 1, 0, 26, 30, 1, 38, 1, 41, 1, 0, 6, 46, 1, 38, 1, 39, 1, 42, 3, 33, 1, 42, 3, 38, 1, 46, 1, 0, 28, 39, 1, 42, 1, 39, 1, 0, 5, 20, 4, 30, 1, 41, 1, 38, 1, 41, 1, 30, 1, 20, 3, 0, 29, 39, 1, 42, 1, 0, 5, 20, 4, 30, 1, 41, 1, 38, 1, 41, 1, 30, 1, 20, 3, 0, 36, 31, 1, 46, 3, 31, 1, 30, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 38, 5, 0, 2, 38, 5, 0, 35, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 33, 1, 16, 0, 16];
const _UHD_PB_FRONT_WINK_RLE = [0, 66, 49, 12, 0, 44, 44, 4, 0, 39, 38, 1, 0, 4, 44, 4, 0, 38, 30, 1, 41, 1, 38, 1, 0, 2, 44, 6, 0, 34, 44, 3, 30, 1, 38, 1, 30, 1, 44, 1, 0, 45, 30, 1, 0, 1, 48, 8, 0, 34, 11, 1, 3, 12, 11, 1, 0, 34, 46, 6, 41, 1, 38, 1, 46, 3, 41, 1, 46, 2, 0, 34, 46, 1, 3, 2, 5, 2, 3, 1, 30, 2, 3, 1, 5, 1, 41, 1, 46, 1, 41, 1, 46, 1, 0, 34, 46, 1, 3, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 2, 3, 1, 5, 1, 7, 1, 41, 1, 3, 1, 46, 1, 0, 34, 46, 1, 3, 2, 5, 2, 3, 1, 0, 2, 3, 1, 5, 2, 3, 2, 46, 1, 0, 35, 39, 2, 42, 8, 39, 2, 0, 38, 3, 3, 39, 2, 3, 3, 0, 39, 39, 3, 0, 1, 44, 1, 40, 1, 44, 1, 0, 1, 39, 1, 36, 1, 46, 2, 0, 36, 39, 4, 44, 1, 40, 1, 44, 1, 39, 2, 46, 1, 36, 1, 46, 2, 0, 37, 39, 1, 42, 4, 39, 1, 0, 2, 46, 2, 36, 1, 46, 1, 0, 34, 38, 1, 41, 1, 33, 1, 39, 4, 33, 1, 41, 1, 38, 1, 0, 2, 30, 1, 38, 1, 41, 1, 0, 23, 30, 1, 38, 1, 41, 2, 38, 1, 30, 1, 46, 1, 38, 1, 39, 3, 42, 8, 39, 3, 38, 1, 31, 1, 46, 2, 41, 2, 38, 1, 30, 1, 0, 18, 30, 1, 38, 1, 41, 2, 38, 1, 30, 1, 46, 1, 38, 1, 39, 2, 42, 4, 33, 2, 42, 4, 39, 2, 38, 1, 31, 1, 46, 2, 41, 2, 38, 1, 30, 1, 0, 19, 46, 2, 31, 1, 0, 2, 46, 1, 38, 1, 39, 2, 42, 4, 29, 2, 42, 4, 39, 2, 38, 1, 46, 1, 0, 1, 31, 1, 46, 2, 0, 21, 46, 2, 31, 1, 0, 2, 46, 1, 38, 1, 39, 2, 33, 4, 29, 2, 33, 4, 39, 2, 38, 1, 46, 1, 0, 1, 31, 1, 46, 2, 0, 21, 46, 2, 31, 1, 0, 3, 46, 1, 38, 1, 39, 2, 42, 3, 33, 2, 42, 3, 39, 2, 38, 1, 46, 1, 0, 25, 46, 2, 31, 2, 0, 3, 46, 1, 38, 1, 39, 2, 42, 3, 33, 2, 42, 3, 39, 2, 38, 1, 46, 1, 0, 25, 46, 2, 31, 1, 0, 5, 46, 1, 38, 1, 39, 1, 42, 3, 33, 1, 29, 1, 42, 3, 39, 1, 38, 1, 46, 1, 0, 26, 30, 1, 38, 1, 41, 1, 0, 6, 46, 1, 38, 1, 39, 1, 42, 3, 33, 1, 42, 3, 38, 1, 46, 1, 0, 28, 39, 1, 42, 1, 39, 1, 0, 5, 20, 4, 30, 1, 41, 1, 38, 1, 41, 1, 30, 1, 20, 3, 0, 29, 39, 1, 42, 1, 0, 5, 20, 4, 30, 1, 41, 1, 38, 1, 41, 1, 30, 1, 20, 3, 0, 36, 31, 1, 46, 3, 31, 1, 30, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 38, 5, 0, 2, 38, 5, 0, 35, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 33, 1, 16, 0, 16];
const _UHD_PB_FRONT_TURN_RLE = [0, 66, 49, 12, 0, 44, 44, 4, 0, 39, 38, 1, 0, 4, 44, 4, 0, 38, 30, 1, 41, 1, 38, 1, 0, 2, 44, 6, 0, 34, 44, 3, 30, 1, 38, 1, 30, 1, 44, 1, 0, 45, 30, 1, 0, 1, 48, 8, 0, 34, 11, 1, 3, 12, 11, 1, 0, 34, 46, 6, 41, 1, 38, 1, 46, 6, 0, 34, 46, 1, 3, 2, 5, 2, 3, 1, 30, 2, 3, 1, 5, 2, 3, 2, 46, 1, 0, 34, 46, 1, 3, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 2, 3, 1, 5, 1, 7, 1, 5, 1, 3, 1, 46, 1, 0, 34, 46, 1, 3, 2, 5, 2, 3, 1, 0, 2, 3, 1, 5, 2, 3, 2, 46, 1, 0, 35, 39, 2, 42, 8, 39, 2, 0, 38, 3, 3, 39, 2, 3, 3, 0, 39, 39, 3, 0, 1, 44, 1, 40, 1, 44, 1, 0, 1, 39, 2, 0, 38, 39, 4, 44, 1, 40, 1, 44, 1, 39, 3, 0, 40, 39, 1, 42, 4, 39, 1, 0, 40, 38, 1, 41, 1, 33, 1, 39, 4, 33, 1, 46, 1, 36, 1, 46, 1, 0, 27, 30, 1, 38, 1, 41, 2, 38, 1, 30, 1, 46, 1, 38, 1, 39, 3, 42, 8, 46, 1, 36, 1, 46, 1, 38, 1, 46, 1, 30, 1, 38, 1, 41, 2, 38, 1, 30, 1, 0, 18, 30, 1, 38, 1, 41, 2, 38, 1, 30, 1, 46, 1, 38, 1, 39, 2, 42, 4, 33, 2, 42, 4, 30, 1, 38, 1, 41, 1, 46, 2, 38, 1, 41, 2, 38, 1, 30, 1, 0, 19, 46, 2, 31, 1, 0, 2, 46, 1, 38, 1, 39, 2, 42, 4, 29, 2, 42, 4, 39, 2, 31, 1, 46, 2, 31, 1, 46, 2, 0, 21, 46, 2, 31, 1, 0, 2, 46, 1, 38, 1, 39, 2, 33, 4, 29, 2, 33, 4, 39, 2, 38, 1, 46, 1, 0, 1, 31, 1, 46, 2, 0, 21, 46, 2, 31, 1, 0, 3, 46, 1, 38, 1, 39, 2, 42, 3, 33, 2, 42, 3, 39, 2, 38, 1, 46, 1, 0, 25, 46, 2, 31, 2, 0, 3, 46, 1, 38, 1, 39, 2, 42, 3, 33, 2, 42, 3, 39, 2, 38, 1, 46, 1, 0, 25, 46, 2, 31, 1, 0, 5, 46, 1, 38, 1, 39, 1, 42, 3, 33, 1, 29, 1, 42, 3, 39, 1, 38, 1, 46, 1, 0, 26, 30, 1, 38, 1, 41, 1, 0, 6, 46, 1, 38, 1, 39, 1, 42, 3, 33, 1, 42, 3, 38, 1, 46, 1, 0, 28, 39, 1, 42, 1, 39, 1, 0, 5, 20, 4, 30, 1, 41, 1, 38, 1, 41, 1, 30, 1, 20, 3, 0, 29, 39, 1, 42, 1, 0, 5, 20, 4, 30, 1, 41, 1, 38, 1, 41, 1, 30, 1, 20, 3, 0, 36, 31, 1, 46, 3, 31, 1, 30, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 31, 1, 46, 3, 31, 1, 0, 2, 31, 1, 46, 3, 31, 1, 0, 36, 38, 5, 0, 2, 38, 5, 0, 35, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 34, 3, 1, 5, 4, 3, 1, 0, 2, 3, 1, 5, 4, 3, 1, 0, 33, 1, 16, 0, 16];
const _UHD_PB_RPG7_AIM_RLE = [0,69,21,1,32,3,21,1,0,15,3,1,36,1,3,1,0,22,21,1,27,1,32,3,35,2,27,1,21,1,0,13,3,1,31,1,36,1,3,1,0,20,21,1,27,7,32,1,27,1,21,1,0,10,3,1,8,1,13,1,18,1,28,1,3,1,0,20,19,1,21,1,26,7,41,1,43,1,30,1,0,8,3,1,8,1,13,1,18,1,22,1,28,1,3,1,0,21,19,2,21,7,38,1,41,1,30,1,0,7,3,1,8,1,13,1,18,1,22,1,28,1,18,1,3,1,0,22,19,1,3,8,19,1,0,6,3,1,8,1,13,1,18,1,22,1,28,1,18,1,13,1,3,1,0,25,11,1,39,1,42,1,45,1,42,1,45,1,42,2,39,1,3,1,0,3,3,1,8,1,3,1,13,1,18,1,22,1,28,1,13,1,3,1,0,26,39,2,5,2,46,2,5,2,3,1,0,4,3,1,8,1,13,1,18,1,22,1,28,1,3,1,0,28,42,1,33,1,39,1,42,2,45,1,42,2,39,1,3,1,0,2,3,1,8,1,13,1,18,1,22,1,3,1,0,29,46,1,39,1,33,1,39,1,42,1,45,1,42,2,39,1,3,1,0,2,3,1,8,1,13,1,7,1,12,1,3,1,0,30,31,1,33,2,39,1,12,1,3,3,12,1,39,1,3,1,2,1,9,1,5,1,7,1,12,1,3,1,7,1,3,1,0,26,30,1,38,1,41,1,0,1,33,2,39,2,42,2,39,1,3,1,0,1,3,1,2,1,5,1,7,1,12,1,3,1,0,29,30,1,38,1,41,1,30,1,29,2,39,2,3,3,29,1,0,1,3,1,5,1,7,1,12,1,3,1,0,30,38,1,41,1,38,1,30,1,38,1,46,2,42,2,20,1,23,1,42,1,3,1,5,1,7,1,12,1,3,1,0,31,30,1,38,1,30,1,38,1,30,1,46,3,20,1,23,1,20,1,3,1,20,1,25,1,29,1,3,1,0,33,46,4,41,1,38,1,41,1,23,1,20,1,46,2,38,1,41,1,3,1,0,33,3,1,46,6,39,1,42,1,3,1,46,2,33,1,29,1,3,1,0,33,46,5,41,1,38,1,39,1,42,1,39,1,3,1,31,1,38,1,41,1,0,33,3,1,46,7,33,5,16,1,39,1,0,33,3,1,46,5,41,1,38,1,39,1,42,1,39,1,42,1,39,1,38,1,41,1,0,33,3,2,46,3,3,1,46,2,39,1,42,1,39,1,42,1,39,1,29,1,39,1,0,33,3,1,39,3,0,1,3,1,41,1,38,1,33,5,38,1,41,1,0,33,3,1,39,3,3,1,5,1,46,2,39,1,42,1,39,1,42,1,39,1,33,1,39,1,0,33,3,1,39,3,5,1,3,1,41,1,38,1,39,1,42,1,29,1,42,1,39,1,38,1,41,1,0,33,34,1,46,1,34,1,3,1,7,1,46,2,3,3,41,1,43,1,3,2,41,1,0,33,31,1,46,2,3,1,7,1,12,1,3,1,0,3,38,1,30,1,0,2,46,1,0,32,3,1,24,1,31,1,34,1,46,1,12,1,3,1,0,39,3,1,5,1,1,1,3,1,46,1,3,1,46,1,3,1,46,2,38,4,46,3,3,1,0,29,3,1,12,1,7,1,1,1,3,1,46,1,3,1,46,1,3,1,46,2,30,4,46,3,3,1,0,34,3,2,46,5,3,1,24,1,31,1,46,1,36,1,46,1,3,1,0,35,3,1,46,4,3,2,24,1,31,1,46,1,36,1,46,1,3,1,0,35,3,1,31,2,24,2,3,1,24,1,31,1,46,2,36,1,34,1,3,1,0,34,3,1,31,2,24,2,17,1,3,1,24,1,31,1,46,2,36,1,34,1,3,1,0,34,3,1,31,2,24,2,17,1,3,2,24,1,31,1,46,2,36,1,34,1,3,1,0,32,3,1,31,2,24,2,17,1,3,1,0,2,3,1,24,1,31,1,46,2,36,1,46,1,3,1,0,31,3,1,31,2,24,2,17,1,3,1,0,3,3,1,24,1,31,1,46,2,36,1,34,1,3,1,0,29,3,1,31,2,24,2,17,1,3,1,0,5,3,1,24,1,31,1,46,1,36,1,46,1,34,1,3,1,0,28,3,1,31,2,24,2,17,1,3,1,0,6,3,1,24,1,31,1,46,1,36,1,46,1,34,1,3,1,0,26,3,1,31,2,24,2,17,1,3,1,0,7,3,1,31,2,46,1,36,1,46,1,34,1,3,1,0,26,3,1,31,2,24,2,17,1,3,1,0,7,3,1,31,2,46,1,36,1,46,1,34,1,3,1,0,26,3,1,31,2,24,2,17,1,3,1,0,7,3,1,31,2,46,1,36,1,46,1,34,1,3,1,0,26,3,1,31,2,24,2,17,1,3,1,0,7,3,1,31,2,46,1,36,1,46,1,34,1,3,1,0,25,3,1,5,1,30,2,5,4,3,1,0,6,3,1,24,1,31,1,46,2,34,1,31,1,3,1,0,24,30,1,3,1,5,8,3,1,0,5,3,1,24,2,31,3,24,1,3,1,0,25,1,3,3,1,1,5,3,1,0,3,3,1,5,1,38,2,7,6,3,1,0,36,38,1,3,1,5,2,7,8,3,1,0,36,1,3,3,1,1,7,3,1,0,13];
const _UHD_PB_RPG7_FIRE_RLE = [0,69,21,1,32,3,21,1,0,40,21,1,27,1,32,3,35,2,27,1,21,1,0,37,21,1,27,7,32,1,27,1,21,1,0,36,19,1,21,1,26,7,41,1,43,1,30,1,0,36,19,2,21,7,38,1,41,1,30,1,0,37,19,1,3,8,19,1,0,40,11,1,39,1,42,1,45,1,42,1,45,1,42,2,39,1,3,1,0,38,39,2,5,2,46,2,5,2,3,1,0,39,42,1,33,1,39,1,42,2,45,1,42,2,39,1,3,1,0,4,46,1,41,1,0,31,46,1,39,1,33,1,39,1,42,1,45,1,42,2,39,1,3,1,0,2,3,1,8,1,46,1,41,1,37,1,3,1,0,30,31,1,33,2,39,1,12,1,3,3,12,1,39,1,3,1,2,1,9,1,5,1,7,1,12,1,3,1,7,1,3,1,0,26,30,1,38,1,41,1,0,1,33,2,39,2,42,2,39,1,3,1,0,1,3,1,2,1,5,1,7,1,12,1,3,1,0,29,30,1,38,1,41,1,30,1,29,2,39,2,3,3,29,1,0,1,3,1,5,1,7,1,12,1,3,1,0,30,38,1,41,1,38,1,30,1,38,1,46,2,42,2,20,1,23,1,42,1,3,1,5,1,7,1,12,1,3,1,0,31,30,1,38,1,30,1,38,1,30,1,46,3,20,1,23,1,20,1,3,1,20,1,25,1,29,1,3,1,0,33,46,4,41,1,38,1,41,1,23,1,20,1,46,2,38,1,41,1,3,1,0,33,3,1,46,6,39,1,42,1,3,1,46,2,33,1,29,1,3,1,0,33,46,5,41,1,38,1,39,1,42,1,39,1,3,1,31,1,38,1,41,1,0,33,3,1,46,7,33,5,16,1,39,1,0,33,3,1,46,5,41,1,38,1,39,1,42,1,39,1,42,1,39,1,38,1,41,1,0,33,3,2,46,3,3,1,46,2,39,1,42,1,39,1,42,1,39,1,29,1,39,1,0,33,3,1,39,3,0,1,3,1,41,1,38,1,33,5,38,1,41,1,0,33,3,1,39,3,3,1,5,1,46,2,39,1,42,1,39,1,42,1,39,1,33,1,39,1,0,33,3,1,39,3,5,1,3,1,41,1,38,1,39,1,42,1,29,1,42,1,39,1,38,1,41,1,0,33,34,1,46,1,34,1,3,1,7,1,46,2,3,3,41,1,43,1,3,2,41,1,0,33,31,1,46,2,3,1,7,1,12,1,3,1,0,3,38,1,30,1,0,2,46,1,0,32,3,1,24,1,31,1,34,1,46,1,12,1,3,1,0,39,3,1,5,1,1,1,3,1,46,1,3,1,46,1,3,1,46,2,38,4,46,3,3,1,0,26,37,1,41,1,43,1,46,1,12,1,7,1,1,1,3,1,46,1,3,1,46,1,3,1,46,2,30,4,46,3,3,1,0,24,37,1,41,1,46,2,43,1,37,1,0,4,3,2,46,5,3,1,24,1,31,1,46,1,36,1,46,1,3,1,0,23,37,1,41,1,46,1,43,2,37,1,3,1,0,5,3,1,46,4,3,2,24,1,31,1,46,1,36,1,46,1,3,1,0,22,37,1,41,1,46,1,43,1,37,1,3,1,0,7,3,1,31,2,24,2,3,1,24,1,31,1,46,2,36,1,34,1,3,1,0,21,3,1,37,1,41,1,43,1,37,1,3,1,0,7,3,1,31,2,24,2,17,1,3,1,24,1,31,1,46,2,36,1,34,1,3,1,0,20,3,1,37,1,41,1,37,1,3,1,0,9,3,1,31,2,24,2,17,1,3,2,24,1,31,1,46,2,36,1,34,1,3,1,0,19,3,1,37,1,3,1,0,10,3,1,31,2,24,2,17,1,3,1,0,2,3,1,24,1,31,1,46,2,36,1,46,1,3,1,0,31,3,1,31,2,24,2,17,1,3,1,0,3,3,1,24,1,31,1,46,2,36,1,34,1,3,1,0,29,3,1,31,2,24,2,17,1,3,1,0,5,3,1,24,1,31,1,46,1,36,1,46,1,34,1,3,1,0,28,3,1,31,2,24,2,17,1,3,1,0,6,3,1,24,1,31,1,46,1,36,1,46,1,34,1,3,1,0,26,3,1,31,2,24,2,17,1,3,1,0,7,3,1,31,2,46,1,36,1,46,1,34,1,3,1,0,26,3,1,31,2,24,2,17,1,3,1,0,7,3,1,31,2,46,1,36,1,46,1,34,1,3,1,0,26,3,1,31,2,24,2,17,1,3,1,0,7,3,1,31,2,46,1,36,1,46,1,34,1,3,1,0,26,3,1,31,2,24,2,17,1,3,1,0,7,3,1,31,2,46,1,36,1,46,1,34,1,3,1,0,25,3,1,5,1,30,2,5,4,3,1,0,6,3,1,24,1,31,1,46,2,34,1,31,1,3,1,0,24,30,1,3,1,5,8,3,1,0,5,3,1,24,2,31,3,24,1,3,1,0,25,1,3,3,1,1,5,3,1,0,3,3,1,5,1,38,2,7,6,3,1,0,36,38,1,3,1,5,2,7,8,3,1,0,36,1,3,3,1,1,7,3,1,0,13];
const _UHD_PB_LAUNCHER_PROP_RLE = [0,981,3,1,9,2,3,1,0,43,3,1,7,1,5,2,3,1,0,31,3,2,0,5,3,1,0,6,3,2,0,4,3,1,0,27,3,1,5,2,0,1,3,3,38,1,3,12,38,1,3,9,0,18,3,1,7,2,3,1,7,3,41,1,10,2,18,1,10,2,18,1,10,2,18,1,10,2,18,1,41,1,7,8,5,1,3,1,0,17,3,1,5,2,0,1,5,3,30,1,4,12,30,1,5,8,3,1,0,18,3,2,0,2,3,3,30,1,3,12,30,1,3,8,0,26,3,1,0,7,3,2,0,3,3,1,0,42,10,1,3,1,0,46,4,1,3,1,0,46,3,1,0,840];
const _UHD_PB_LAUNCHER_CARRY_RLE = [0,603,3,1,38,2,24,2,3,1,0,42,3,1,24,4,3,1,0,42,3,2,31,1,24,1,3,2,0,28,3,1,38,1,41,1,46,2,3,1,0,8,3,1,31,1,24,1,3,1,0,30,3,1,46,4,3,1,0,6,3,1,31,1,24,1,3,2,0,31,3,3,46,1,36,1,3,1,0,5,3,1,31,1,24,1,3,1,0,36,3,2,46,1,36,1,3,1,0,2,3,1,39,1,42,1,3,1,0,39,3,2,39,1,42,1,3,1,39,1,42,1,3,1,0,42,3,3,39,1,42,1,3,1,0,31,3,2,0,5,3,1,0,2,3,1,39,1,42,1,3,3,39,1,42,1,3,1,38,1,41,1,0,27,3,1,5,2,0,1,3,3,38,1,3,1,38,1,41,1,42,1,3,7,46,1,36,1,3,9,44,1,40,1,0,16,3,1,7,2,3,1,7,3,41,1,3,1,46,1,31,1,3,1,10,1,18,1,10,2,18,1,10,1,3,1,31,1,24,1,3,1,7,7,5,1,32,1,44,1,40,1,3,1,0,14,3,1,5,2,0,1,5,3,30,1,3,1,31,1,3,1,4,9,30,1,5,8,3,1,32,1,44,1,3,1,0,15,3,2,0,2,3,3,30,1,3,12,30,1,3,8,0,26,3,1,0,7,3,2,0,3,3,1,0,42,10,1,3,1,0,46,4,1,3,1,0,46,3,1,0,887];
const _UHD_PB_WALK_ARMED_RLE = [[0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 38, 1, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 2, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 24, 1, 3, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 12, 1, 46, 1, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 24, 1, 3, 1, 0, 29, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 38, 1, 41, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 3, 0, 30, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 7, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 24, 30, 1, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 25, 3, 9, 0, 53, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 10], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 38, 1, 3, 1, 0, 29, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 38, 2, 3, 1, 0, 28, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 34, 1, 3, 2, 0, 29, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 46, 1, 24, 1, 3, 1, 0, 29, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 3, 1, 12, 1, 46, 1, 3, 1, 0, 27, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 12, 1, 24, 1, 3, 1, 0, 27, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 2, 38, 1, 41, 1, 3, 1, 0, 27, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 1, 3, 2, 0, 29, 3, 1, 31, 1, 36, 1, 24, 1, 3, 4, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 31, 1, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 8, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 10], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 37, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 2, 0, 29, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 38, 2, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 34, 1, 3, 2, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 46, 1, 24, 1, 3, 1, 0, 28, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 36, 1, 3, 1, 12, 1, 46, 1, 3, 1, 0, 26, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 31, 1, 3, 1, 12, 1, 24, 1, 3, 1, 0, 25, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 2, 38, 1, 41, 1, 3, 1, 0, 25, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 9, 3, 1, 0, 2, 3, 2, 0, 26, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 3, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 3, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 30, 1, 3, 1, 5, 1, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 5, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 5, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 13], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 32, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 3, 2, 0, 30, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 2, 3, 2, 0, 26, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 42, 2, 38, 2, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 0, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 1, 3, 1, 5, 1, 34, 1, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 0, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 5, 1, 36, 1, 46, 1, 24, 1, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 2, 36, 2, 34, 1, 46, 1, 12, 1, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 1, 3, 1, 5, 1, 31, 1, 46, 1, 24, 1, 12, 1, 38, 1, 3, 1, 0, 21, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 1, 3, 1, 5, 1, 3, 1, 12, 1, 24, 1, 41, 1, 3, 1, 0, 21, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 9, 3, 1, 0, 5, 3, 3, 0, 22, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 3, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 4, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 5, 1, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 5, 8, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 8, 0, 29, 3, 1, 7, 7, 3, 1, 0, 38, 38, 1, 3, 1, 7, 7, 3, 1, 0, 39, 3, 9, 0, 22], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 1, 3, 1, 0, 32, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 45, 1, 42, 2, 3, 3, 0, 27, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 3, 38, 3, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 4, 3, 1, 5, 1, 34, 1, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 2, 3, 1, 5, 1, 36, 1, 46, 1, 24, 1, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 2, 3, 1, 36, 2, 34, 1, 46, 1, 12, 1, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 1, 3, 1, 5, 1, 31, 1, 46, 1, 24, 1, 12, 1, 38, 1, 3, 1, 0, 21, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 3, 3, 1, 5, 1, 3, 1, 12, 1, 24, 1, 41, 1, 3, 1, 0, 20, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 5, 3, 3, 0, 21, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 8, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 27, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 26, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 7, 3, 1, 0, 4, 30, 1, 3, 1, 5, 1, 3, 1, 0, 30, 38, 1, 3, 1, 7, 7, 3, 1, 0, 5, 3, 1, 5, 8, 3, 1, 0, 24, 3, 9, 0, 6, 3, 9, 0, 12], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 39, 38, 1, 46, 2, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 6, 3, 3, 0, 26, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 4, 16, 1, 39, 2, 42, 5, 38, 3, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 39, 6, 3, 1, 5, 1, 34, 1, 46, 1, 34, 1, 46, 1, 34, 1, 3, 1, 0, 18, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 33, 2, 39, 3, 3, 1, 5, 1, 12, 1, 46, 1, 24, 1, 46, 1, 24, 1, 38, 1, 41, 1, 3, 1, 0, 16, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 25, 2, 33, 3, 3, 1, 5, 1, 36, 1, 12, 1, 3, 1, 12, 1, 3, 1, 0, 19, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 3, 0, 2, 3, 1, 5, 1, 36, 2, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 4, 3, 1, 5, 1, 31, 1, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 5, 3, 2, 0, 23, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 38, 1, 3, 1, 5, 1, 3, 1, 0, 9, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 7, 7, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 7, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 60], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 7, 38, 3, 3, 1, 0, 23, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 33, 5, 16, 1, 39, 2, 42, 4, 39, 2, 3, 1, 5, 1, 34, 1, 46, 1, 34, 1, 46, 1, 34, 1, 3, 1, 0, 18, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 39, 6, 3, 1, 5, 1, 12, 1, 46, 1, 24, 1, 46, 1, 24, 1, 38, 1, 41, 1, 3, 1, 0, 17, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 33, 2, 39, 1, 33, 3, 3, 1, 5, 1, 36, 1, 12, 1, 3, 1, 12, 1, 3, 1, 0, 19, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 25, 2, 33, 2, 3, 3, 5, 1, 36, 2, 3, 1, 0, 21, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 3, 0, 3, 3, 1, 5, 1, 31, 1, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 6, 3, 2, 0, 24, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 30, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 34, 3, 1, 31, 1, 3, 1, 0, 1, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 36, 38, 1, 3, 1, 5, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 37, 3, 1, 7, 8, 3, 2, 0, 39, 3, 9, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 63], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 5, 3, 3, 0, 25, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 42, 5, 38, 3, 3, 1, 0, 23, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 39, 5, 3, 1, 5, 1, 34, 1, 46, 1, 34, 1, 46, 1, 34, 1, 3, 1, 0, 19, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 33, 1, 39, 3, 3, 1, 5, 1, 12, 1, 46, 1, 24, 1, 46, 1, 24, 1, 38, 1, 41, 1, 3, 1, 0, 17, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 25, 1, 33, 3, 3, 1, 5, 1, 36, 1, 12, 1, 3, 1, 12, 1, 3, 1, 0, 20, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 2, 0, 2, 3, 1, 5, 1, 36, 2, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 4, 3, 1, 5, 1, 31, 1, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 5, 3, 2, 0, 25, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 46, 1, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 3, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 5, 7, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 7, 3, 1, 0, 39, 3, 9, 0, 3, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 11], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 1, 3, 1, 0, 32, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 45, 1, 42, 3, 3, 3, 0, 26, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 4, 38, 3, 3, 1, 0, 25, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 5, 3, 1, 5, 1, 34, 1, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 3, 3, 1, 5, 1, 36, 1, 46, 1, 24, 1, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 3, 3, 1, 36, 2, 34, 1, 46, 1, 12, 1, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 2, 3, 1, 5, 1, 31, 1, 46, 1, 24, 1, 12, 1, 38, 1, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 4, 3, 1, 5, 1, 3, 1, 12, 1, 24, 1, 41, 1, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 6, 3, 3, 0, 22, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 7, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 24, 30, 1, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 25, 3, 9, 0, 53, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 10], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 31, 3, 1, 25, 1, 33, 2, 39, 1, 42, 2, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 3, 2, 0, 30, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 2, 3, 2, 0, 28, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 42, 2, 38, 2, 3, 1, 0, 27, 3, 1, 33, 2, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 1, 3, 1, 5, 1, 34, 1, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 5, 1, 36, 1, 46, 1, 24, 1, 3, 1, 0, 26, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 2, 36, 2, 34, 1, 46, 1, 12, 1, 3, 1, 0, 26, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 4, 41, 1, 43, 1, 3, 2, 41, 1, 0, 1, 3, 1, 5, 1, 31, 1, 46, 1, 24, 1, 12, 1, 38, 1, 3, 1, 0, 25, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 1, 3, 1, 5, 1, 3, 1, 12, 1, 24, 1, 41, 1, 3, 1, 0, 24, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 5, 3, 3, 0, 25, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 8, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 10], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 37, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 2, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 38, 2, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 34, 1, 3, 2, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 12, 1, 46, 1, 24, 1, 3, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 36, 1, 3, 1, 12, 1, 46, 1, 3, 1, 0, 29, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 2, 12, 1, 24, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 6, 3, 1, 5, 1, 3, 1, 38, 1, 41, 1, 3, 1, 0, 29, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 2, 3, 2, 0, 31, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 36, 3, 1, 31, 1, 3, 2, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 30, 1, 3, 1, 5, 1, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 5, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 5, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 13], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 38, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 2, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 46, 1, 24, 1, 3, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 41, 1, 43, 1, 3, 2, 41, 1, 3, 1, 12, 1, 46, 1, 3, 1, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 12, 1, 24, 1, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 5, 3, 2, 38, 1, 41, 1, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 5, 3, 1, 0, 1, 3, 2, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 37, 3, 1, 31, 1, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 5, 1, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 5, 8, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 8, 0, 29, 3, 1, 7, 7, 3, 1, 0, 38, 38, 1, 3, 1, 7, 7, 3, 1, 0, 39, 3, 9, 0, 22], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 2, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 41, 1, 43, 1, 3, 2, 41, 1, 46, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 2, 0, 34, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 3, 3, 1, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 4, 3, 3, 0, 36, 3, 2, 31, 1, 3, 1, 46, 5, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 27, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 26, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 7, 3, 1, 0, 4, 30, 1, 3, 1, 5, 1, 3, 1, 0, 30, 38, 1, 3, 1, 7, 7, 3, 1, 0, 5, 3, 1, 5, 8, 3, 1, 0, 24, 3, 9, 0, 6, 3, 9, 0, 12], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 46, 2, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 2, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 0, 37, 3, 2, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 43, 1, 3, 2, 41, 1, 3, 1, 0, 36, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 36, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 3, 2, 0, 37, 3, 2, 31, 1, 36, 1, 24, 1, 3, 1, 46, 3, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 3, 1, 36, 1, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 38, 1, 3, 1, 5, 1, 3, 1, 0, 9, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 7, 7, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 7, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 60], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 33, 5, 16, 1, 39, 1, 3, 1, 0, 34, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 41, 1, 43, 1, 3, 2, 41, 1, 3, 1, 0, 35, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 35, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 3, 3, 2, 0, 37, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 4, 3, 1, 0, 38, 3, 2, 31, 1, 3, 1, 46, 5, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 36, 38, 1, 3, 1, 5, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 37, 3, 1, 7, 8, 3, 2, 0, 39, 3, 9, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 63], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 4, 41, 1, 43, 1, 3, 2, 41, 1, 46, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 2, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 6, 3, 1, 38, 1, 41, 1, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 3, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 35, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 5, 7, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 7, 3, 1, 0, 39, 3, 9, 0, 3, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 11], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 38, 1, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 2, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 24, 1, 3, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 12, 1, 46, 1, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 24, 1, 3, 1, 0, 29, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 38, 1, 41, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 3, 0, 30, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 7, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 24, 30, 1, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 25, 3, 9, 0, 53, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 10], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 38, 1, 3, 1, 0, 29, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 38, 2, 3, 1, 0, 28, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 34, 1, 3, 2, 0, 29, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 46, 1, 24, 1, 3, 1, 0, 29, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 3, 1, 12, 1, 46, 1, 3, 1, 0, 27, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 12, 1, 24, 1, 3, 1, 0, 27, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 2, 38, 1, 41, 1, 3, 1, 0, 27, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 1, 3, 2, 0, 29, 3, 1, 31, 1, 36, 1, 24, 1, 3, 4, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 31, 1, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 8, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 10], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 37, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 2, 0, 29, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 38, 2, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 34, 1, 3, 2, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 46, 1, 24, 1, 3, 1, 0, 28, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 36, 1, 3, 1, 12, 1, 46, 1, 3, 1, 0, 26, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 31, 1, 3, 1, 12, 1, 24, 1, 3, 1, 0, 25, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 2, 38, 1, 41, 1, 3, 1, 0, 25, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 9, 3, 1, 0, 2, 3, 2, 0, 26, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 3, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 3, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 30, 1, 3, 1, 5, 1, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 5, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 5, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 13], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 32, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 3, 2, 0, 30, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 2, 3, 2, 0, 26, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 42, 2, 38, 2, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 0, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 1, 3, 1, 5, 1, 34, 1, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 0, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 5, 1, 36, 1, 46, 1, 24, 1, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 2, 36, 2, 34, 1, 46, 1, 12, 1, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 1, 3, 1, 5, 1, 31, 1, 46, 1, 24, 1, 12, 1, 38, 1, 3, 1, 0, 21, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 1, 3, 1, 5, 1, 3, 1, 12, 1, 24, 1, 41, 1, 3, 1, 0, 21, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 9, 3, 1, 0, 5, 3, 3, 0, 22, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 3, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 4, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 5, 1, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 5, 8, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 8, 0, 29, 3, 1, 7, 7, 3, 1, 0, 38, 38, 1, 3, 1, 7, 7, 3, 1, 0, 39, 3, 9, 0, 22], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 1, 3, 1, 0, 32, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 45, 1, 42, 2, 3, 3, 0, 27, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 3, 38, 3, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 4, 3, 1, 5, 1, 34, 1, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 2, 3, 1, 5, 1, 36, 1, 46, 1, 24, 1, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 2, 3, 1, 36, 2, 34, 1, 46, 1, 12, 1, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 1, 3, 1, 5, 1, 31, 1, 46, 1, 24, 1, 12, 1, 38, 1, 3, 1, 0, 21, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 3, 3, 1, 5, 1, 3, 1, 12, 1, 24, 1, 41, 1, 3, 1, 0, 20, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 5, 3, 3, 0, 21, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 8, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 27, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 26, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 7, 3, 1, 0, 4, 30, 1, 3, 1, 5, 1, 3, 1, 0, 30, 38, 1, 3, 1, 7, 7, 3, 1, 0, 5, 3, 1, 5, 8, 3, 1, 0, 24, 3, 9, 0, 6, 3, 9, 0, 12], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 39, 38, 1, 46, 2, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 6, 3, 3, 0, 26, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 4, 16, 1, 39, 2, 42, 5, 38, 3, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 39, 6, 3, 1, 5, 1, 34, 1, 46, 1, 34, 1, 46, 1, 34, 1, 3, 1, 0, 18, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 33, 2, 39, 3, 3, 1, 5, 1, 12, 1, 46, 1, 24, 1, 46, 1, 24, 1, 38, 1, 41, 1, 3, 1, 0, 16, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 25, 2, 33, 3, 3, 1, 5, 1, 36, 1, 12, 1, 3, 1, 12, 1, 3, 1, 0, 19, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 3, 0, 2, 3, 1, 5, 1, 36, 2, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 4, 3, 1, 5, 1, 31, 1, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 5, 3, 2, 0, 23, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 38, 1, 3, 1, 5, 1, 3, 1, 0, 9, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 7, 7, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 7, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 60], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 7, 38, 3, 3, 1, 0, 23, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 33, 5, 16, 1, 39, 2, 42, 4, 39, 2, 3, 1, 5, 1, 34, 1, 46, 1, 34, 1, 46, 1, 34, 1, 3, 1, 0, 18, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 39, 6, 3, 1, 5, 1, 12, 1, 46, 1, 24, 1, 46, 1, 24, 1, 38, 1, 41, 1, 3, 1, 0, 17, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 33, 2, 39, 1, 33, 3, 3, 1, 5, 1, 36, 1, 12, 1, 3, 1, 12, 1, 3, 1, 0, 19, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 25, 2, 33, 2, 3, 3, 5, 1, 36, 2, 3, 1, 0, 21, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 3, 0, 3, 3, 1, 5, 1, 31, 1, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 6, 3, 2, 0, 24, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 30, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 34, 3, 1, 31, 1, 3, 1, 0, 1, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 36, 38, 1, 3, 1, 5, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 37, 3, 1, 7, 8, 3, 2, 0, 39, 3, 9, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 63], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 5, 3, 3, 0, 25, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 42, 5, 38, 3, 3, 1, 0, 23, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 39, 5, 3, 1, 5, 1, 34, 1, 46, 1, 34, 1, 46, 1, 34, 1, 3, 1, 0, 19, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 33, 1, 39, 3, 3, 1, 5, 1, 12, 1, 46, 1, 24, 1, 46, 1, 24, 1, 38, 1, 41, 1, 3, 1, 0, 17, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 25, 1, 33, 3, 3, 1, 5, 1, 36, 1, 12, 1, 3, 1, 12, 1, 3, 1, 0, 20, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 2, 0, 2, 3, 1, 5, 1, 36, 2, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 4, 3, 1, 5, 1, 31, 1, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 5, 3, 2, 0, 25, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 46, 1, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 3, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 5, 7, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 7, 3, 1, 0, 39, 3, 9, 0, 3, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 11], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 1, 3, 1, 0, 32, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 45, 1, 42, 3, 3, 3, 0, 26, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 4, 38, 3, 3, 1, 0, 25, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 5, 3, 1, 5, 1, 34, 1, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 3, 3, 1, 5, 1, 36, 1, 46, 1, 24, 1, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 3, 3, 1, 36, 2, 34, 1, 46, 1, 12, 1, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 2, 3, 1, 5, 1, 31, 1, 46, 1, 24, 1, 12, 1, 38, 1, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 4, 3, 1, 5, 1, 3, 1, 12, 1, 24, 1, 41, 1, 3, 1, 0, 22, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 6, 3, 3, 0, 22, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 7, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 24, 30, 1, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 25, 3, 9, 0, 53, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 10], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 31, 3, 1, 25, 1, 33, 2, 39, 1, 42, 2, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 3, 2, 0, 30, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 2, 3, 2, 0, 28, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 42, 2, 38, 2, 3, 1, 0, 27, 3, 1, 33, 2, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 1, 3, 1, 5, 1, 34, 1, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 5, 1, 36, 1, 46, 1, 24, 1, 3, 1, 0, 26, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 2, 36, 2, 34, 1, 46, 1, 12, 1, 3, 1, 0, 26, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 4, 41, 1, 43, 1, 3, 2, 41, 1, 0, 1, 3, 1, 5, 1, 31, 1, 46, 1, 24, 1, 12, 1, 38, 1, 3, 1, 0, 25, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 1, 3, 1, 5, 1, 3, 1, 12, 1, 24, 1, 41, 1, 3, 1, 0, 24, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 5, 3, 3, 0, 25, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 8, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 10], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 37, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 2, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 38, 2, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 34, 1, 3, 2, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 12, 1, 46, 1, 24, 1, 3, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 36, 1, 3, 1, 12, 1, 46, 1, 3, 1, 0, 29, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 2, 12, 1, 24, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 6, 3, 1, 5, 1, 3, 1, 38, 1, 41, 1, 3, 1, 0, 29, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 2, 3, 2, 0, 31, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 36, 3, 1, 31, 1, 3, 2, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 30, 1, 3, 1, 5, 1, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 5, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 5, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 13], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 38, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 2, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 46, 1, 24, 1, 3, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 41, 1, 43, 1, 3, 2, 41, 1, 3, 1, 12, 1, 46, 1, 3, 1, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 12, 1, 24, 1, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 5, 3, 2, 38, 1, 41, 1, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 5, 3, 1, 0, 1, 3, 2, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 37, 3, 1, 31, 1, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 5, 1, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 5, 8, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 8, 0, 29, 3, 1, 7, 7, 3, 1, 0, 38, 38, 1, 3, 1, 7, 7, 3, 1, 0, 39, 3, 9, 0, 22], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 2, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 41, 1, 43, 1, 3, 2, 41, 1, 46, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 2, 0, 34, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 3, 3, 1, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 4, 3, 3, 0, 36, 3, 2, 31, 1, 3, 1, 46, 5, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 27, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 26, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 7, 3, 1, 0, 4, 30, 1, 3, 1, 5, 1, 3, 1, 0, 30, 38, 1, 3, 1, 7, 7, 3, 1, 0, 5, 3, 1, 5, 8, 3, 1, 0, 24, 3, 9, 0, 6, 3, 9, 0, 12], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 46, 2, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 2, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 0, 37, 3, 2, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 43, 1, 3, 2, 41, 1, 3, 1, 0, 36, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 36, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 3, 2, 0, 37, 3, 2, 31, 1, 36, 1, 24, 1, 3, 1, 46, 3, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 3, 1, 36, 1, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 38, 1, 3, 1, 5, 1, 3, 1, 0, 9, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 7, 7, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 7, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 60], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 33, 5, 16, 1, 39, 1, 3, 1, 0, 34, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 41, 1, 43, 1, 3, 2, 41, 1, 3, 1, 0, 35, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 35, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 3, 3, 2, 0, 37, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 4, 3, 1, 0, 38, 3, 2, 31, 1, 3, 1, 46, 5, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 36, 38, 1, 3, 1, 5, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 37, 3, 1, 7, 8, 3, 2, 0, 39, 3, 9, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 63], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 4, 41, 1, 43, 1, 3, 2, 41, 1, 46, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 2, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 6, 3, 1, 38, 1, 41, 1, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 3, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 35, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 5, 7, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 7, 3, 1, 0, 39, 3, 9, 0, 3, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 11]];
const _UHD_PB_WALK_UNARMED_RLE = [[0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 38, 1, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 38, 1, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 30, 1, 3, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 7, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 24, 30, 1, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 25, 3, 9, 0, 53, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 10], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 38, 1, 3, 1, 0, 29, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 38, 2, 3, 1, 0, 28, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 30, 1, 38, 1, 3, 1, 0, 29, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 30, 2, 3, 1, 0, 29, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 3, 2, 0, 29, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 30, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 4, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 31, 1, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 8, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 10], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 37, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 2, 0, 29, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 38, 2, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 30, 1, 38, 1, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 30, 2, 3, 1, 0, 28, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 3, 0, 28, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 9, 3, 1, 0, 30, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 3, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 3, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 30, 1, 3, 1, 5, 1, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 5, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 5, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 13], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 3, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 1, 38, 1, 3, 2, 0, 26, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 42, 1, 38, 3, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 0, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 1, 30, 2, 38, 1, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 0, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 1, 30, 3, 3, 1, 0, 25, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 5, 0, 26, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 9, 3, 1, 0, 30, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 3, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 4, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 5, 1, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 5, 8, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 8, 0, 29, 3, 1, 7, 7, 3, 1, 0, 38, 38, 1, 3, 1, 7, 7, 3, 1, 0, 39, 3, 9, 0, 22], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 42, 2, 3, 4, 0, 27, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 3, 38, 3, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 4, 30, 3, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 3, 30, 3, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 2, 3, 4, 0, 25, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 8, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 27, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 26, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 7, 3, 1, 0, 4, 30, 1, 3, 1, 5, 1, 3, 1, 0, 30, 38, 1, 3, 1, 7, 7, 3, 1, 0, 5, 3, 1, 5, 8, 3, 1, 0, 24, 3, 9, 0, 6, 3, 9, 0, 12], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 39, 38, 1, 46, 2, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 9, 0, 26, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 4, 16, 1, 39, 1, 42, 5, 38, 4, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 2, 39, 3, 38, 2, 30, 2, 3, 1, 0, 22, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 6, 30, 4, 3, 1, 0, 21, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 33, 5, 30, 1, 3, 3, 0, 22, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 5, 0, 27, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 38, 1, 3, 1, 5, 1, 3, 1, 0, 9, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 7, 7, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 7, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 60], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 42, 5, 38, 4, 3, 1, 0, 23, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 33, 5, 16, 1, 39, 1, 42, 6, 38, 2, 30, 2, 3, 1, 0, 22, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 39, 6, 30, 4, 3, 1, 0, 22, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 5, 33, 2, 30, 2, 3, 2, 0, 22, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 33, 3, 3, 4, 0, 25, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 2, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 30, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 34, 3, 1, 31, 1, 3, 1, 0, 1, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 36, 38, 1, 3, 1, 5, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 37, 3, 1, 7, 8, 3, 2, 0, 39, 3, 9, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 63], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 8, 0, 25, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 42, 4, 38, 4, 3, 1, 0, 23, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 1, 39, 3, 38, 2, 30, 2, 3, 1, 0, 23, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 5, 30, 4, 3, 1, 0, 22, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 33, 4, 30, 1, 3, 3, 0, 23, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 4, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 46, 1, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 3, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 5, 7, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 7, 3, 1, 0, 39, 3, 9, 0, 3, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 11], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 42, 3, 3, 4, 0, 26, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 3, 38, 4, 3, 1, 0, 25, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 4, 30, 4, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 3, 30, 4, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 3, 3, 4, 0, 25, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 7, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 24, 30, 1, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 25, 3, 9, 0, 53, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 10], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 25, 1, 33, 2, 39, 1, 42, 2, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 3, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 1, 38, 1, 3, 2, 0, 28, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 42, 1, 38, 3, 3, 1, 0, 27, 3, 1, 33, 2, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 1, 30, 2, 38, 1, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 1, 30, 3, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 5, 0, 29, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 4, 41, 1, 43, 1, 3, 2, 41, 1, 0, 34, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 32, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 8, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 10], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 37, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 2, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 38, 2, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 30, 1, 38, 1, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 30, 3, 3, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 3, 3, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 6, 3, 1, 0, 34, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 35, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 36, 3, 1, 31, 1, 3, 2, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 30, 1, 3, 1, 5, 1, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 5, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 5, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 13], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 38, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 38, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 30, 2, 3, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 41, 1, 43, 1, 3, 2, 41, 1, 3, 2, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 5, 3, 1, 0, 35, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 5, 3, 1, 0, 36, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 37, 3, 1, 31, 1, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 5, 1, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 5, 8, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 8, 0, 29, 3, 1, 7, 7, 3, 1, 0, 38, 38, 1, 3, 1, 7, 7, 3, 1, 0, 39, 3, 9, 0, 22], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 2, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 41, 1, 43, 1, 3, 2, 41, 1, 0, 36, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 35, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 3, 3, 1, 0, 38, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 4, 3, 1, 0, 38, 3, 2, 31, 1, 3, 1, 46, 5, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 27, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 26, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 7, 3, 1, 0, 4, 30, 1, 3, 1, 5, 1, 3, 1, 0, 30, 38, 1, 3, 1, 7, 7, 3, 1, 0, 5, 3, 1, 5, 8, 3, 1, 0, 24, 3, 9, 0, 6, 3, 9, 0, 12], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 46, 2, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 2, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 0, 37, 3, 2, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 37, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 43, 1, 3, 2, 41, 1, 0, 37, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 36, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 3, 1, 0, 38, 3, 2, 31, 1, 36, 1, 24, 1, 3, 1, 46, 3, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 3, 1, 36, 1, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 38, 1, 3, 1, 5, 1, 3, 1, 0, 9, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 7, 7, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 7, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 60], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 33, 5, 16, 1, 39, 1, 3, 1, 0, 34, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 41, 1, 43, 1, 3, 2, 41, 1, 0, 36, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 35, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 3, 3, 1, 0, 38, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 4, 3, 1, 0, 38, 3, 2, 31, 1, 3, 1, 46, 5, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 36, 38, 1, 3, 1, 5, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 37, 3, 1, 7, 8, 3, 2, 0, 39, 3, 9, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 63], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 4, 41, 1, 43, 1, 3, 2, 41, 1, 0, 34, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 32, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 6, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 34, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 35, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 5, 7, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 7, 3, 1, 0, 39, 3, 9, 0, 3, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 11], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 38, 1, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 38, 1, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 30, 1, 3, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 7, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 24, 30, 1, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 25, 3, 9, 0, 53, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 10], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 38, 1, 3, 1, 0, 29, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 38, 2, 3, 1, 0, 28, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 30, 1, 38, 1, 3, 1, 0, 29, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 30, 2, 3, 1, 0, 29, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 3, 2, 0, 29, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 30, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 4, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 31, 1, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 8, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 10], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 37, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 2, 0, 29, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 38, 2, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 30, 1, 38, 1, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 30, 2, 3, 1, 0, 28, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 3, 0, 28, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 9, 3, 1, 0, 30, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 3, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 3, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 30, 1, 3, 1, 5, 1, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 5, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 5, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 13], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 3, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 1, 38, 1, 3, 2, 0, 26, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 42, 1, 38, 3, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 0, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 1, 30, 2, 38, 1, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 0, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 1, 30, 3, 3, 1, 0, 25, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 5, 0, 26, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 9, 3, 1, 0, 30, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 3, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 3, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 4, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 5, 1, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 5, 8, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 8, 0, 29, 3, 1, 7, 7, 3, 1, 0, 38, 38, 1, 3, 1, 7, 7, 3, 1, 0, 39, 3, 9, 0, 22], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 42, 2, 3, 4, 0, 27, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 3, 38, 3, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 4, 30, 3, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 3, 30, 3, 3, 1, 0, 23, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 2, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 2, 3, 4, 0, 25, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 36, 8, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 27, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 26, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 7, 3, 1, 0, 4, 30, 1, 3, 1, 5, 1, 3, 1, 0, 30, 38, 1, 3, 1, 7, 7, 3, 1, 0, 5, 3, 1, 5, 8, 3, 1, 0, 24, 3, 9, 0, 6, 3, 9, 0, 12], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 39, 38, 1, 46, 2, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 9, 0, 26, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 4, 16, 1, 39, 1, 42, 5, 38, 4, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 2, 39, 3, 38, 2, 30, 2, 3, 1, 0, 22, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 6, 30, 4, 3, 1, 0, 21, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 33, 5, 30, 1, 3, 3, 0, 22, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 5, 0, 27, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 2, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 29, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 31, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 0, 1, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 38, 1, 3, 1, 5, 1, 3, 1, 0, 9, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 7, 7, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 7, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 60], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 42, 5, 38, 4, 3, 1, 0, 23, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 33, 5, 16, 1, 39, 1, 42, 6, 38, 2, 30, 2, 3, 1, 0, 22, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 39, 6, 30, 4, 3, 1, 0, 22, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 5, 33, 2, 30, 2, 3, 2, 0, 22, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 33, 3, 3, 4, 0, 25, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 2, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 30, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 46, 2, 42, 1, 46, 5, 3, 1, 0, 34, 3, 1, 31, 1, 3, 1, 0, 1, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 36, 38, 1, 3, 1, 5, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 37, 3, 1, 7, 8, 3, 2, 0, 39, 3, 9, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 63], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 8, 0, 25, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 42, 4, 38, 4, 3, 1, 0, 23, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 1, 39, 3, 38, 2, 30, 2, 3, 1, 0, 23, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 5, 30, 4, 3, 1, 0, 22, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 41, 1, 38, 1, 33, 5, 38, 1, 41, 1, 33, 4, 30, 1, 3, 3, 0, 23, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 3, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 4, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 3, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 30, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 46, 1, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 31, 1, 3, 1, 0, 3, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 5, 7, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 7, 3, 1, 0, 39, 3, 9, 0, 3, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 11], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 42, 3, 3, 4, 0, 26, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 3, 38, 4, 3, 1, 0, 25, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 4, 30, 4, 3, 1, 0, 24, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 3, 30, 4, 3, 1, 0, 24, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 3, 3, 4, 0, 25, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 2, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 8, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 32, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 2, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 7, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 24, 30, 1, 3, 1, 5, 7, 3, 1, 0, 6, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 25, 3, 9, 0, 53, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 10], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 25, 1, 33, 2, 39, 1, 42, 2, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 3, 1, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 42, 1, 38, 1, 3, 2, 0, 28, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 42, 1, 38, 3, 3, 1, 0, 27, 3, 1, 33, 2, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 33, 5, 38, 1, 41, 1, 39, 1, 30, 2, 38, 1, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 2, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 33, 1, 30, 3, 3, 1, 0, 27, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 5, 0, 29, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 4, 41, 1, 43, 1, 3, 2, 41, 1, 0, 34, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 32, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 33, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 1, 24, 1, 3, 2, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 31, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 28, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 6, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 8, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 10], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 37, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 2, 0, 31, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 38, 2, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 30, 1, 38, 1, 3, 1, 0, 30, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 30, 3, 3, 1, 0, 31, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 3, 41, 1, 43, 1, 3, 2, 41, 1, 3, 3, 0, 31, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 6, 3, 1, 0, 34, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 35, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 1, 42, 1, 46, 5, 3, 1, 0, 36, 3, 1, 31, 1, 3, 2, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 37, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 30, 1, 3, 1, 5, 1, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 5, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 5, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 9, 3, 1, 0, 36, 38, 1, 3, 1, 7, 9, 3, 1, 0, 37, 3, 11, 0, 13], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 46, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 38, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 38, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 30, 2, 3, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 2, 41, 1, 43, 1, 3, 2, 41, 1, 3, 2, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 5, 3, 1, 0, 35, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 5, 3, 1, 0, 36, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 37, 3, 1, 31, 1, 3, 2, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 5, 1, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 5, 8, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 8, 0, 29, 3, 1, 7, 7, 3, 1, 0, 38, 38, 1, 3, 1, 7, 7, 3, 1, 0, 39, 3, 9, 0, 22], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 2, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 41, 1, 43, 1, 3, 2, 41, 1, 0, 36, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 35, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 3, 3, 1, 0, 38, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 4, 3, 1, 0, 38, 3, 2, 31, 1, 3, 1, 46, 5, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 37, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 1, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 33, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 27, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 6, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 26, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 7, 7, 3, 1, 0, 4, 30, 1, 3, 1, 5, 1, 3, 1, 0, 30, 38, 1, 3, 1, 7, 7, 3, 1, 0, 5, 3, 1, 5, 8, 3, 1, 0, 24, 3, 9, 0, 6, 3, 9, 0, 12], [0, 115, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 46, 2, 42, 2, 20, 1, 23, 1, 42, 1, 46, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 33, 5, 16, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 34, 3, 2, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 0, 36, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 0, 37, 3, 2, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 37, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 43, 1, 3, 2, 41, 1, 0, 37, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 36, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 2, 3, 1, 0, 38, 3, 2, 31, 1, 36, 1, 24, 1, 3, 1, 46, 3, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 3, 1, 36, 1, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 1, 3, 1, 0, 38, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 31, 2, 3, 1, 0, 36, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 35, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 24, 2, 31, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 32, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 31, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 3, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 28, 38, 1, 3, 1, 5, 1, 3, 1, 0, 9, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 29, 3, 1, 7, 7, 3, 1, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 30, 3, 7, 0, 4, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 60], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 3, 1, 0, 34, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 3, 1, 0, 34, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 33, 5, 16, 1, 39, 1, 3, 1, 0, 34, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 34, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 33, 3, 38, 1, 41, 1, 3, 1, 0, 35, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 36, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 41, 1, 43, 1, 3, 2, 41, 1, 0, 36, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 35, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 36, 3, 3, 1, 0, 38, 3, 1, 31, 1, 36, 1, 24, 1, 3, 1, 46, 4, 3, 1, 0, 38, 3, 2, 31, 1, 3, 1, 46, 5, 3, 1, 0, 38, 3, 1, 46, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 41, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 40, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 39, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 2, 0, 36, 38, 1, 3, 1, 5, 1, 3, 1, 0, 1, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 37, 3, 1, 7, 8, 3, 2, 0, 39, 3, 9, 0, 40, 3, 1, 5, 9, 3, 1, 0, 36, 30, 1, 3, 1, 5, 9, 3, 1, 0, 37, 3, 11, 0, 63], [0, 67, 21, 1, 44, 6, 21, 1, 0, 38, 21, 1, 44, 4, 40, 2, 44, 2, 48, 1, 21, 1, 0, 35, 21, 1, 44, 5, 40, 2, 44, 3, 48, 1, 21, 1, 0, 34, 19, 1, 21, 1, 48, 6, 30, 1, 38, 1, 41, 1, 48, 1, 21, 1, 0, 35, 19, 2, 21, 5, 48, 1, 38, 1, 41, 1, 38, 1, 48, 1, 21, 1, 0, 36, 19, 1, 3, 10, 19, 1, 0, 37, 3, 1, 39, 1, 42, 1, 36, 1, 46, 1, 36, 1, 41, 1, 36, 1, 46, 1, 36, 1, 3, 1, 0, 37, 3, 1, 38, 1, 5, 1, 7, 2, 5, 1, 36, 1, 5, 1, 7, 1, 5, 1, 3, 1, 0, 37, 3, 1, 39, 1, 5, 3, 3, 1, 42, 1, 5, 2, 3, 2, 0, 37, 3, 1, 39, 1, 42, 1, 39, 2, 42, 1, 45, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 37, 3, 1, 33, 1, 39, 1, 42, 1, 11, 2, 40, 1, 44, 1, 11, 1, 33, 1, 3, 1, 0, 38, 3, 1, 33, 1, 39, 2, 42, 1, 33, 1, 42, 1, 39, 1, 33, 1, 3, 1, 0, 39, 3, 1, 33, 2, 39, 3, 33, 1, 3, 1, 0, 40, 38, 1, 36, 1, 33, 1, 39, 2, 42, 1, 33, 1, 36, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 2, 20, 1, 23, 1, 20, 1, 23, 1, 29, 2, 0, 33, 3, 1, 31, 1, 41, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 41, 1, 23, 1, 20, 1, 39, 1, 20, 1, 38, 1, 41, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 29, 1, 0, 33, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 33, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 46, 1, 33, 5, 16, 1, 39, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 2, 42, 1, 3, 1, 41, 1, 38, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 38, 1, 41, 1, 0, 32, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 29, 1, 39, 1, 0, 33, 3, 1, 25, 1, 33, 1, 39, 1, 42, 1, 45, 1, 42, 1, 3, 1, 33, 5, 38, 1, 41, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 46, 1, 39, 1, 42, 1, 39, 1, 42, 1, 39, 1, 33, 1, 39, 1, 3, 1, 0, 32, 3, 1, 33, 1, 39, 1, 42, 2, 39, 1, 3, 1, 38, 1, 39, 1, 42, 1, 29, 1, 42, 1, 39, 1, 38, 1, 41, 1, 3, 1, 0, 33, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 4, 41, 1, 43, 1, 3, 2, 41, 1, 0, 34, 3, 1, 33, 1, 39, 1, 42, 1, 39, 1, 3, 1, 46, 1, 38, 1, 46, 1, 38, 1, 30, 1, 46, 1, 31, 1, 46, 1, 3, 1, 0, 32, 3, 1, 30, 1, 38, 1, 41, 1, 38, 1, 30, 1, 3, 1, 36, 6, 3, 1, 0, 34, 3, 1, 31, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 34, 3, 1, 24, 1, 36, 1, 46, 1, 36, 1, 31, 1, 3, 1, 42, 1, 46, 5, 3, 1, 0, 35, 3, 1, 31, 1, 36, 1, 24, 1, 3, 3, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 39, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 38, 3, 1, 17, 1, 24, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 36, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 35, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 34, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 33, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 32, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 1, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 31, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 30, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 3, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 29, 3, 1, 17, 1, 24, 2, 31, 2, 3, 1, 0, 5, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 27, 3, 1, 5, 7, 3, 1, 0, 4, 3, 1, 31, 1, 36, 2, 46, 1, 36, 2, 3, 1, 0, 26, 30, 1, 3, 1, 5, 7, 3, 1, 0, 39, 3, 9, 0, 3, 38, 1, 3, 1, 7, 1, 3, 1, 0, 45, 3, 1, 7, 8, 3, 1, 0, 11]];

function getUHD_PinkBeret(isGold = false) {
  return getUHD_PinkBeret_Stand(isGold);
}
function getUHD_PinkBeret_Stand(isGold = false) {
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_STAND_RLE);
}
function getUHD_PinkBeret_Torso(isGold = false) {
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_TORSO_RLE);
}
function getUHD_PinkBeret_Torso_Turn(isGold = false) {
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_TORSO_TURN_RLE);
}
function getUHD_PinkBeret_Legs(frame = 0, isGold = false) {
  const pal = isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE;
  if (frame === 'tap' || frame === 'dance2') return _decodeUHD_PB(pal, _UHD_PB_LEGS_DANCE2_RLE);
  if (frame === 'dance1') return _decodeUHD_PB(pal, _UHD_PB_LEGS_DANCE1_RLE);
  if (frame === 'dance3') return _decodeUHD_PB(pal, _UHD_PB_LEGS_DANCE3_RLE);
  if (frame === 'dance4') return _decodeUHD_PB(pal, _UHD_PB_LEGS_DANCE4_RLE);
  if (typeof frame === 'number' && frame >= 1 && frame <= 8) return _decodeUHD_PB(pal, _UHD_PB_LEGS_WALK_RLE[frame - 1]);
  return _decodeUHD_PB(pal, _UHD_PB_LEGS_STAND_RLE);
}
function getUHD_PinkBeret_Legs_Stand(isGold = false) {
  return getUHD_PinkBeret_Legs(0, isGold);
}
function getUHD_PinkBeret_Legs_Tap(isGold = false) {
  return getUHD_PinkBeret_Legs('tap', isGold);
}
function getUHD_PinkBeret_Legs_Dance1(isGold = false) {
  return getUHD_PinkBeret_Legs('dance1', isGold);
}
function getUHD_PinkBeret_Legs_Dance2(isGold = false) {
  return getUHD_PinkBeret_Legs('dance2', isGold);
}
function getUHD_PinkBeret_Legs_Dance3(isGold = false) {
  return getUHD_PinkBeret_Legs('dance3', isGold);
}
function getUHD_PinkBeret_Legs_Dance4(isGold = false) {
  return getUHD_PinkBeret_Legs('dance4', isGold);
}
function getUHD_PinkBeret_Walk_Armed(frame = 1, isGold = false) {
  const numFrames = _UHD_PB_WALK_ARMED_RLE.length;
  const idx = Math.max(0, Math.min(numFrames - 1, (frame - 1) % numFrames));
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_WALK_ARMED_RLE[idx]);
}
function getUHD_PinkBeret_Walk(frame = 1, isGold = false) {
  const numFrames = _UHD_PB_WALK_UNARMED_RLE.length;
  const idx = Math.max(0, Math.min(numFrames - 1, (frame - 1) % numFrames));
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_WALK_UNARMED_RLE[idx]);
}
function getUHD_PinkBeret_Front_Kiss(isGold = false) {
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_FRONT_KISS_RLE);
}
function getUHD_PinkBeret_Front_Wink(isGold = false) {
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_FRONT_WINK_RLE);
}
function getUHD_PinkBeret_Front_Turn(isGold = false) {
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_FRONT_TURN_RLE);
}
function getUHD_PinkBeretGold_Front_Kiss() { return getUHD_PinkBeret_Front_Kiss(true); }
function getUHD_PinkBeretGold_Front_Wink() { return getUHD_PinkBeret_Front_Wink(true); }
function getUHD_PinkBeretGold_Front_Turn() { return getUHD_PinkBeret_Front_Turn(true); }

function getUHD_PinkBeret_Gunfire(isGold = false) {
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_GUNFIRE_RLE);
}
function getUHD_PinkBeret_Launcher_Aim45(isGold = false) {
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_RPG7_AIM_RLE);
}
function getUHD_PinkBeret_Launcher_Fire(isGold = false) {
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_RPG7_FIRE_RLE);
}
function getUHD_PinkBeret_Launcher_Prop(isGold = false) {
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_LAUNCHER_PROP_RLE);
}
function getUHD_PinkBeret_Launcher_Carry(isGold = false) {
  return _decodeUHD_PB(isGold ? _UHD_PB_GOLD_PALETTE : _UHD_PB_PALETTE, _UHD_PB_LAUNCHER_CARRY_RLE);
}

// Gold Getters
function getUHD_PinkBeretGold() { return getUHD_PinkBeret(true); }
function getUHD_PinkBeretGold_Stand() { return getUHD_PinkBeret_Stand(true); }
function getUHD_PinkBeretGold_Torso() { return getUHD_PinkBeret_Torso(true); }
function getUHD_PinkBeretGold_Torso_Turn() { return getUHD_PinkBeret_Torso_Turn(true); }
function getUHD_PinkBeretGold_Legs(f = 0) { return getUHD_PinkBeret_Legs(f, true); }
function getUHD_PinkBeretGold_Legs_Stand() { return getUHD_PinkBeret_Legs_Stand(true); }
function getUHD_PinkBeretGold_Legs_Tap() { return getUHD_PinkBeret_Legs_Tap(true); }
function getUHD_PinkBeretGold_Legs_Dance1() { return getUHD_PinkBeret_Legs_Dance1(true); }
function getUHD_PinkBeretGold_Legs_Dance2() { return getUHD_PinkBeret_Legs_Dance2(true); }
function getUHD_PinkBeretGold_Legs_Dance3() { return getUHD_PinkBeret_Legs_Dance3(true); }
function getUHD_PinkBeretGold_Legs_Dance4() { return getUHD_PinkBeret_Legs_Dance4(true); }
function getUHD_PinkBeretGold_Walk_Armed(f = 1) { return getUHD_PinkBeret_Walk_Armed(f, true); }
function getUHD_PinkBeretGold_Walk(f = 1) { return getUHD_PinkBeret_Walk(f, true); }
function getUHD_PinkBeretGold_Gunfire() { return getUHD_PinkBeret_Gunfire(true); }
function getUHD_PinkBeretGold_Launcher_Aim45() { return getUHD_PinkBeret_Launcher_Aim45(true); }
function getUHD_PinkBeretGold_Launcher_Fire() { return getUHD_PinkBeret_Launcher_Fire(true); }
function getUHD_PinkBeretGold_Launcher_Prop() { return getUHD_PinkBeret_Launcher_Prop(true); }
function getUHD_PinkBeretGold_Launcher_Carry() { return getUHD_PinkBeret_Launcher_Carry(true); }


// ── HUMAN HACKER (24x24 HD CYBER-MYSTIC & 8-ARM DEITY) ───────────

function _paintHD_Hacker_LotusLegs(grid) {
  // Saffron draped lotus legs hovering in Padmasana (y: 15..23, x: 3..14)
  // Wrapped hips and lap drapery
  grid[15][3]  = '#7c2d12'; grid[15][4]  = '#ea580c'; grid[15][5]  = '#f97316'; grid[15][6]  = '#ea580c'; grid[15][7]  = '#f97316'; grid[15][8]  = '#fb923c'; grid[15][9]  = '#ea580c';
  grid[16][3]  = '#431407'; grid[16][4]  = '#7c2d12'; grid[16][5]  = '#ea580c'; grid[16][6]  = '#f97316'; grid[16][7]  = '#fb923c'; grid[16][8]  = '#f97316'; grid[16][9]  = '#ea580c'; grid[16][10] = '#c2410c';
  grid[16][11] = '#1e293b'; grid[16][12] = '#334155'; // tucked cyber-knee

  // Front folded crossed shins & cyber-foot clamp with LED
  grid[17][3]  = '#431407'; grid[17][4]  = '#7c2d12'; grid[17][5]  = '#c2410c'; grid[17][6]  = '#ea580c'; grid[17][7]  = '#f97316'; grid[17][8]  = '#fb923c'; grid[17][9]  = '#ea580c';
  grid[17][10] = '#1e293b'; grid[17][11] = '#64748b'; grid[17][12] = '#94a3b8'; grid[17][13] = '#00f0ff'; // cyber-foot LED

  grid[18][4]  = '#431407'; grid[18][5]  = '#7c2d12'; grid[18][6]  = '#ea580c'; grid[18][7]  = '#f97316'; grid[18][8]  = '#ea580c'; grid[18][9]  = '#7c2d12';
  grid[18][10] = '#1e293b'; grid[18][11] = '#334155';

  // Hanging saffron cloth tail dropping below the knees (y: 19..23)
  grid[19][7]  = '#ea580c'; grid[19][8]  = '#f97316'; grid[19][9]  = '#ea580c'; grid[19][10] = '#7c2d12';
  grid[20][8]  = '#ea580c'; grid[20][9]  = '#f97316'; grid[20][10] = '#c2410c';
  grid[21][8]  = '#c2410c'; grid[21][9]  = '#ea580c'; grid[21][10] = '#7c2d12';
  grid[22][9]  = '#7c2d12'; grid[22][10] = '#431407';
  grid[23][9]  = '#431407';
}

function _paintHD_Hacker_Torso(grid) {
  // Exposed Slender Cyber-Spine & Biomechanical Ribcage (x: 4..10, y: 7..15) - NOT covered in orange!
  // 1. Main High Shoulder Joint Socket at upper back/shoulder (x: 7..8, y: 7..8)
  grid[7][7]  = '#1e293b'; grid[7][8]  = '#475569';
  grid[8][6]  = '#1e293b'; grid[8][7]  = '#ca8a04'; grid[8][8]  = '#64748b'; // circular joint with copper core

  // 2. Spine & Exposed Metallic Ribs (y: 9..13) - pure dark metal & bronze ribs, NO orange!
  grid[9][4]  = '#0f172a'; grid[9][5]  = '#1e293b'; grid[9][6]  = '#334155'; grid[9][7]  = '#b45309'; grid[9][8]  = '#d97706'; grid[9][9]  = '#334155';
  grid[10][4] = '#0f172a'; grid[10][5] = '#00f0ff'; grid[10][6] = '#1e293b'; grid[10][7] = '#334155'; grid[10][8] = '#b45309'; grid[10][9] = '#d97706'; grid[10][10] = '#1e293b'; // cyan spine LED + bronze rib 2
  grid[11][4] = '#0f172a'; grid[11][5] = '#1e293b'; grid[11][6] = '#334155'; grid[11][7] = '#1e293b'; grid[11][8] = '#ca8a04'; grid[11][9] = '#334155';
  grid[12][4] = '#0f172a'; grid[12][5] = '#facc15'; grid[12][6] = '#1e293b'; grid[12][7] = 'TEAM';    grid[12][8] = 'TEAM';    grid[12][9] = '#334155'; // amber LED + team badge
  grid[13][4] = '#0f172a'; grid[13][5] = '#1e293b'; grid[13][6] = '#334155'; grid[13][7] = '#1e293b'; grid[13][8] = '#334155'; grid[13][9] = '#7c2d12'; grid[13][10] = '#ea580c'; // slender waist where sash begins

  // 3. Lower Saffron Sash Wrap around hips/waistline only (y: 14..15)
  grid[14][4] = '#7c2d12'; grid[14][5] = '#ea580c'; grid[14][6] = '#c2410c'; grid[14][7] = '#ea580c'; grid[14][8] = '#f97316'; grid[14][9] = '#c2410c'; grid[14][10] = '#7c2d12';
  grid[15][4] = '#431407'; grid[15][5] = '#7c2d12'; grid[15][6] = '#ea580c'; grid[15][7] = '#f97316'; grid[15][8] = '#ea580c'; grid[15][9] = '#7c2d12';
}

function _paintHD_Hacker_Head(grid) {
  // Golden Conical Ushnisha / Stupa crown on head (y: 0..4, x: 7..11)
  grid[0][9]  = '#fde047';
  grid[1][8]  = '#facc15'; grid[1][9]  = '#fde047'; grid[1][10] = '#ca8a04';
  grid[2][7]  = '#ca8a04'; grid[2][8]  = '#facc15'; grid[2][9]  = '#fde047'; grid[2][10] = '#facc15'; grid[2][11] = '#a16207';
  grid[3][7]  = '#ca8a04'; grid[3][8]  = '#facc15'; grid[3][9]  = '#fde047'; grid[3][10] = '#facc15'; grid[3][11] = '#ca8a04'; grid[3][12] = '#854d0e';
  grid[4][7]  = '#854d0e'; grid[4][8]  = '#ca8a04'; grid[4][9]  = '#facc15'; grid[4][10] = '#ca8a04'; grid[4][11] = '#854d0e';

  // VR Cyber-Visor & Headset (y: 4..6, x: 5..13)
  grid[4][5]  = '#0f172a'; grid[4][6]  = '#1e293b'; grid[4][12] = '#0284c7'; grid[4][13] = '#00f0ff';
  grid[5][5]  = '#0f172a'; grid[5][6]  = '#1e293b'; grid[5][7]  = '#334155'; grid[5][8]  = '#ec4899'; // magenta sensor LED dot
  grid[5][9]  = '#1e293b'; grid[5][10] = '#0284c7'; grid[5][11] = '#00f0ff'; grid[5][12] = '#38bdf8'; grid[5][13] = '#ffffff'; // glowing neon visor
  grid[6][6]  = '#0f172a'; grid[6][7]  = '#ca8a04'; grid[6][8]  = '#facc15'; // gold earpiece ring
  grid[6][9]  = '#1e293b'; grid[6][10] = '#fed7aa'; grid[6][11] = '#fed7aa'; grid[6][12] = '#fba772'; // synthetic face

  // Slender cyber-neck and profile chin (y: 7..8, x: 7..11)
  grid[7][7]  = '#0f172a'; grid[7][8]  = '#334155'; grid[7][9]  = '#1e293b'; grid[7][10] = '#fed7aa'; grid[7][11] = '#fba772';
  grid[8][7]  = '#0f172a'; grid[8][8]  = '#334155'; grid[8][9]  = '#475569';
}

function _paintHD_Hacker_Kranz_Base(grid) {
  // Radiating Shiva Kranz halo arms behind the spine & colorful trailing cyber-cables
  // Arm 1: Upper Rear (reaching back-up with pointing finger)
  grid[8][5]  = '#334155'; grid[7][4]  = '#475569'; grid[6][3]  = '#64748b';
  grid[5][3]  = '#ca8a04'; grid[4][2]  = '#94a3b8'; grid[3][2]  = '#cbd5e1';
  grid[2][2]  = '#f8fafc'; grid[1][2]  = '#00f0ff';

  // Arm 3: Mid Rear (horizontally back with mudra bead)
  grid[10][4] = '#334155'; grid[10][3] = '#475569'; grid[9][2]  = '#ca8a04';
  grid[9][1]  = '#94a3b8'; grid[8][1]  = '#cbd5e1'; grid[8][0]  = '#00f0ff';

  // Arm 5: Lower Rear (down-back cable guide)
  grid[12][4] = '#334155'; grid[13][3] = '#475569'; grid[14][2] = '#ca8a04';
  grid[15][1] = '#94a3b8'; grid[16][1] = '#00f0ff';

  // Trailing organic cable roots from headset/spine (Green, Blue, Red, White)
  grid[6][5]  = '#10b981'; grid[7][4]  = '#10b981'; grid[8][3]  = '#10b981'; // green wire
  grid[7][5]  = '#00f0ff'; grid[8][4]  = '#00f0ff'; grid[9][3]  = '#00f0ff'; // blue wire
  grid[8][5]  = '#ef4444'; grid[9][4]  = '#ef4444'; grid[10][3] = '#ef4444'; // red wire
  grid[7][6]  = '#f8fafc'; grid[8][6]  = '#f8fafc';                          // white wire
}

function _paintHD_Hacker_Kranz_UpperArm(grid) {
  // Articulated Upper Arm: High pointing cyber-arm with natural shoulder, elbow, forearm & pointing finger
  // Shoulder socket & upper arm angling forward-down:
  grid[7][8]   = '#334155';
  grid[8][9]   = '#475569'; grid[8][10]  = '#64748b';
  // Circular elbow joint:
  grid[9][11]  = '#ca8a04'; grid[9][12]  = '#475569';
  // Slender forearm angling up-forward:
  grid[8][13]  = '#64748b'; grid[7][14]  = '#94a3b8'; grid[6][15]  = '#cbd5e1';
  // Hand with extended pointing index finger (👉) & cyan emitter tip:
  grid[5][16]  = '#94a3b8';
  grid[4][17]  = '#f8fafc'; grid[3][18]  = '#ffffff'; grid[3][19]  = '#00f0ff';
}

function _paintHD_Hacker_Kranz_MidArm(grid) {
  // Articulated Mid Arm: Horizontal pointing cyber-arm with natural elbow, pointing hand & suspended terminal modules
  // Socket & upper arm:
  grid[9][7]   = '#334155'; grid[9][8]   = '#475569';
  // Elbow joint:
  grid[10][9]  = '#ca8a04'; grid[10][10] = '#475569';
  // Horizontal forearm:
  grid[10][11] = '#64748b'; grid[10][12] = '#94a3b8'; grid[10][13] = '#cbd5e1';
  // Hand with extended pointing index finger (👉):
  grid[10][14] = '#94a3b8'; grid[10][15] = '#cbd5e1'; grid[10][16] = '#f8fafc'; grid[10][17] = '#00f0ff';

  // Suspended floating HUD terminal modules (connected by thin data wire):
  grid[11][17] = '#334155'; grid[12][17] = '#38bdf8'; grid[13][17] = '#334155';
  grid[13][18] = '#0f172a'; grid[13][19] = '#00f0ff'; // terminal 1 screen
  grid[14][18] = '#1e293b'; grid[14][19] = '#10b981'; // terminal 1 data
  grid[15][17] = '#334155';
  grid[16][17] = '#0f172a'; grid[16][18] = '#ec4899'; // terminal 2 screen
  grid[17][17] = '#1e293b'; grid[17][18] = '#00f0ff';
}

function _paintHD_Hacker_ArmKranz(grid) {
  // Composite 6 Shiva Wreath Arms (Kranz) radiating in sacred arc behind torso & head
  _paintHD_Hacker_Kranz_Base(grid);
  _paintHD_Hacker_Kranz_UpperArm(grid);
  _paintHD_Hacker_Kranz_MidArm(grid);
}

function _paintHD_Hacker_Arms_Idle(grid) {
  // Front Arm in Meditative Gyana Mudra: Upper arm along chest, horizontal forearm, thumb & index touching in circle
  // Upper arm hanging down from chest:
  grid[9][9]   = '#475569'; grid[10][9]  = '#64748b'; grid[11][9]  = '#334155';
  // Elbow resting above lap:
  grid[12][9]  = '#ca8a04'; grid[12][10] = '#475569';
  // Horizontal forearm:
  grid[13][10] = '#64748b'; grid[13][11] = '#94a3b8'; grid[13][12] = '#cbd5e1';
  // Hand in Gyana Mudra with glowing cyan focus bead inside circle:
  grid[13][13] = '#94a3b8'; grid[13][14] = '#cbd5e1'; grid[13][15] = '#64748b';
  grid[14][13] = '#64748b'; grid[14][14] = '#00f0ff'; grid[14][15] = '#94a3b8';
  grid[14][16] = '#cbd5e1'; grid[14][17] = '#f8fafc'; // extended fingers
}

function _paintHD_Hacker_Arms_Typing(grid, frame = 0) {
  // 2 Animated Active Front Arms in rapid alternating typing flurry
  const f = frame % 2;
  if (f === 0) {
    // Upper arm striking high key
    grid[9][11]  = '#64748b'; grid[9][12]  = '#94a3b8'; grid[9][13]  = '#cbd5e1';
    grid[9][14]  = '#f8fafc'; grid[9][15]  = '#00f0ff';
    // Lower arm striking mid key
    grid[12][10] = '#475569'; grid[12][11] = '#64748b'; grid[12][12] = '#94a3b8';
    grid[12][13] = '#cbd5e1'; grid[12][14] = '#ffffff';
  } else {
    // Upper arm hovering high
    grid[8][11]  = '#64748b'; grid[8][12]  = '#94a3b8'; grid[8][13]  = '#cbd5e1';
    grid[8][14]  = '#cbd5e1'; grid[8][15]  = '#00f0ff';
    // Lower arm striking low key
    grid[13][10] = '#475569'; grid[13][11] = '#64748b'; grid[13][12] = '#94a3b8';
    grid[13][13] = '#ffffff'; grid[13][14] = '#00f0ff';
  }
}

function _paintHD_Hacker_HoloKeyboard(grid, frame = 0) {
  // Luminous floating cyber-keyboard matrix (y: 8..14, x: 16..22)
  const f = frame % 2;
  // Holo projection emitter ring
  grid[8][16]  = '#00f0ff'; grid[8][17]  = '#38bdf8';
  grid[9][17]  = f === 0 ? '#10b981' : '#00f0ff'; grid[9][18]  = '#34d399'; grid[9][19]  = f === 0 ? '#00f0ff' : '#ffffff';
  grid[10][16] = '#0284c7'; grid[10][17] = '#00f0ff'; grid[10][18] = '#10b981'; grid[10][19] = f === 0 ? '#ffffff' : '#34d399'; grid[10][20] = '#00f0ff';
  grid[11][17] = f === 0 ? '#00f0ff' : '#10b981'; grid[11][18] = '#ffffff'; grid[11][19] = '#00f0ff'; grid[11][20] = f === 0 ? '#34d399' : '#00f0ff';
  grid[12][16] = '#00f0ff'; grid[12][17] = '#10b981'; grid[12][18] = f === 0 ? '#ffffff' : '#10b981'; grid[12][19] = '#00f0ff';
  grid[13][17] = '#38bdf8'; grid[13][18] = '#00f0ff';
}

function _paintHD_Hacker_Frontal(grid) {
  // Perfectly Symmetrical 8-Armed Cyber Deity (Showroom, Menus, Arsenal)
  // 1. Golden Ushnisha Conical Stupa Crest (y: 0..3, x: 9..14)
  grid[0][11] = '#fde047'; grid[0][12] = '#fde047';
  grid[1][10] = '#ca8a04'; grid[1][11] = '#facc15'; grid[1][12] = '#facc15'; grid[1][13] = '#ca8a04';
  grid[2][9]  = '#ca8a04'; grid[2][10] = '#facc15'; grid[2][11] = '#fde047'; grid[2][12] = '#fde047'; grid[2][13] = '#facc15'; grid[2][14] = '#ca8a04';
  grid[3][8]  = '#854d0e'; grid[3][9]  = '#ca8a04'; grid[3][10] = '#facc15'; grid[3][11] = '#fde047'; grid[3][12] = '#fde047'; grid[3][13] = '#facc15'; grid[3][14] = '#ca8a04'; grid[3][15] = '#854d0e';

  // 2. Head & Symmetrical Neon Cyber-Visor (y: 4..6, x: 9..14)
  grid[4][9]  = '#0284c7'; grid[4][10] = '#00f0ff'; grid[4][11] = '#ffffff'; grid[4][12] = '#ffffff'; grid[4][13] = '#00f0ff'; grid[4][14] = '#0284c7';
  grid[5][8]  = '#0f172a'; grid[5][9]  = '#ec4899'; grid[5][10] = '#00f0ff'; grid[5][11] = '#00f0ff'; grid[5][12] = '#00f0ff'; grid[5][13] = '#00f0ff'; grid[5][14] = '#ec4899'; grid[5][15] = '#0f172a';
  grid[6][10] = '#1e293b'; grid[6][11] = '#fed7aa'; grid[6][12] = '#fed7aa'; grid[6][13] = '#1e293b';

  // 3. Central Symmetrical Cyber-Chest (Exposed metallic chassis & bronze ribs, NO orange!)
  grid[7][9]  = '#334155'; grid[7][10] = '#475569'; grid[7][11] = '#00f0ff'; grid[7][12] = '#00f0ff'; grid[7][13] = '#475569'; grid[7][14] = '#334155'; // reactor core
  grid[8][8]  = '#1e293b'; grid[8][9]  = '#ca8a04'; grid[8][10] = '#334155'; grid[8][11] = '#00f0ff'; grid[8][12] = '#00f0ff'; grid[8][13] = '#334155'; grid[8][14] = '#ca8a04'; grid[8][15] = '#1e293b';
  grid[9][8]  = '#334155'; grid[9][9]  = '#b45309'; grid[9][10] = '#d97706'; grid[9][11] = '#334155'; grid[9][12] = '#334155'; grid[9][13] = '#d97706'; grid[9][14] = '#b45309'; grid[9][15] = '#334155';
  grid[10][8] = '#1e293b'; grid[10][9] = '#334155'; grid[10][10] = '#b45309'; grid[10][11] = '#d97706'; grid[10][12] = '#d97706'; grid[10][13] = '#b45309'; grid[10][14] = '#334155'; grid[10][15] = '#1e293b';
  grid[11][8] = '#334155'; grid[11][9] = '#1e293b'; grid[11][10] = 'TEAM';    grid[11][11] = '#ca8a04'; grid[11][12] = '#ca8a04'; grid[11][13] = 'TEAM';    grid[11][14] = '#1e293b'; grid[11][15] = '#334155';
  grid[12][8] = '#1e293b'; grid[12][9] = '#334155'; grid[12][10] = '#1e293b'; grid[12][11] = '#facc15'; grid[12][12] = '#facc15'; grid[12][13] = '#1e293b'; grid[12][14] = '#334155'; grid[12][15] = '#1e293b';
  
  // Waist Sash Wrap: Saffron orange begins only here at waistline (y: 13..15)
  grid[13][7] = '#7c2d12'; grid[13][8] = '#ea580c'; grid[13][9] = '#f97316'; grid[13][10] = '#ea580c'; grid[13][11] = '#f97316'; grid[13][12] = '#f97316'; grid[13][13] = '#ea580c'; grid[13][14] = '#f97316'; grid[13][15] = '#ea580c'; grid[13][16] = '#7c2d12';
  grid[14][7] = '#431407'; grid[14][8] = '#7c2d12'; grid[14][9] = '#ea580c'; grid[14][10] = '#f97316'; grid[14][11] = '#fb923c'; grid[14][12] = '#fb923c'; grid[14][13] = '#f97316'; grid[14][14] = '#ea580c'; grid[14][15] = '#7c2d12'; grid[14][16] = '#431407';
  grid[15][8] = '#431407'; grid[15][9] = '#7c2d12'; grid[15][10] = '#ea580c'; grid[15][11] = '#f97316'; grid[15][12] = '#f97316'; grid[15][13] = '#ea580c'; grid[15][14] = '#7c2d12'; grid[15][15] = '#431407';

  // 4. Symmetrical Saffron Lotus Legs (y: 16..21, x: 4..19)
  for (let x = 6; x <= 17; x++) {
    grid[16][x] = '#f97316';
    grid[17][x] = '#ea580c';
  }
  grid[16][10] = '#fb923c'; grid[16][11] = '#fdba74'; grid[16][12] = '#fdba74'; grid[16][13] = '#fb923c';
  grid[17][5]  = '#7c2d12'; grid[17][6]  = '#ea580c'; grid[17][17] = '#ea580c'; grid[17][18] = '#7c2d12';
  grid[18][4]  = '#64748b'; grid[18][5]  = '#94a3b8'; grid[18][6]  = '#ea580c'; grid[18][17] = '#ea580c'; grid[18][18] = '#94a3b8'; grid[18][19] = '#64748b'; // dual cyber-feet
  grid[18][7]  = '#f97316'; grid[18][8]  = '#fb923c'; grid[18][15] = '#fb923c'; grid[18][16] = '#f97316';
  grid[19][5]  = '#00f0ff'; grid[19][6]  = '#7c2d12'; grid[19][17] = '#7c2d12'; grid[19][18] = '#00f0ff'; // foot LEDs
  for (let x = 7; x <= 16; x++) grid[19][x] = '#7c2d12';
  for (let x = 8; x <= 15; x++) grid[20][x] = '#431407';

  // 5. 8 Symmetrical Radiating Cyber-Arms
  // Pair 1 & 2: Upward Reaching Mudra / Antenna Arms (y: 2..6, x: 4..8 and 15..19)
  grid[6][8]  = '#475569'; grid[6][15] = '#475569';
  grid[5][7]  = '#64748b'; grid[5][16] = '#64748b';
  grid[4][6]  = '#94a3b8'; grid[4][17] = '#94a3b8';
  grid[3][5]  = '#cbd5e1'; grid[3][18] = '#cbd5e1';
  grid[2][5]  = '#00f0ff'; grid[2][18] = '#00f0ff'; // cyan Mudra tip

  // Pair 3 & 4: Outstretched Typing Arms (y: 7..10, x: 2..7 and 16..21)
  grid[7][7]  = '#334155'; grid[7][16] = '#334155';
  grid[8][6]  = '#475569'; grid[8][17] = '#475569';
  grid[8][5]  = '#64748b'; grid[8][18] = '#64748b';
  grid[9][4]  = '#94a3b8'; grid[9][19] = '#94a3b8';
  grid[9][3]  = '#cbd5e1'; grid[9][20] = '#cbd5e1';
  grid[9][2]  = '#00f0ff'; grid[9][21] = '#00f0ff'; // typing sparks

  // Pair 5 & 6: Lower Reaching Cable-Guide Arms (y: 11..14, x: 3..7 and 16..20)
  grid[11][6] = '#334155'; grid[11][17] = '#334155';
  grid[12][5] = '#475569'; grid[12][18] = '#475569';
  grid[13][4] = '#64748b'; grid[13][19] = '#64748b';
  grid[14][3] = '#94a3b8'; grid[14][20] = '#94a3b8';
  grid[14][2] = '#00f0ff'; grid[14][21] = '#00f0ff';

  // Pair 7 & 8: Inner Meditative Lap Hands (y: 14..15, x: 10..13)
  grid[14][10] = '#94a3b8'; grid[14][11] = '#cbd5e1'; grid[14][12] = '#cbd5e1'; grid[14][13] = '#94a3b8';
  grid[15][11] = '#00f0ff'; grid[15][12] = '#00f0ff'; // central focus bead
}

function _paintHD_Hacker_Debris(grid) {
  // Slumped Broken Torso & Visor Smoke/Debris (Death State, based on death.jpeg)
  // Slumped head with shattered visor (rows 9..14, shifted right)
  grid[9][13]  = '#ca8a04'; grid[9][14]  = '#facc15'; grid[9][15]  = '#ca8a04';
  grid[10][13] = '#1e293b'; grid[10][14] = '#ff003c'; grid[10][15] = '#0284c7'; grid[10][16] = '#0f172a'; // cracked visor & red glitch error
  grid[11][12] = '#0f172a'; grid[11][13] = '#334155'; grid[11][14] = '#fed7aa'; grid[11][15] = '#1e293b';

  // Broken collapsed robe & cyber-core
  grid[12][9]  = '#7c2d12'; grid[12][10] = '#ea580c'; grid[12][11] = '#334155'; grid[12][12] = '#475569'; grid[12][13] = '#1e293b';
  grid[13][8]  = '#431407'; grid[13][9]  = '#7c2d12'; grid[13][10] = '#ea580c'; grid[13][11] = '#f97316'; grid[13][12] = '#7c2d12';
  grid[14][7]  = '#431407'; grid[14][8]  = '#7c2d12'; grid[14][9]  = '#ea580c'; grid[14][10] = '#c2410c'; grid[14][11] = '#431407';

  // Ground pool of frayed cable ends & sparks
  grid[17][3]  = '#ef4444'; grid[17][4]  = '#0f172a'; grid[17][5]  = '#00f0ff'; grid[17][6]  = '#facc15'; // severed copper/data lines
  grid[18][2]  = '#0f172a'; grid[18][3]  = '#facc15'; grid[18][4]  = '#0f172a'; grid[18][5]  = '#1e293b'; grid[18][6]  = '#00f0ff';
  grid[19][2]  = '#0f172a'; grid[19][4]  = '#334155'; grid[19][7]  = '#f97316';

  // Detached fallen cyber-arm lying on ground at right
  grid[19][16] = '#475569'; grid[19][17] = '#64748b'; grid[19][18] = '#94a3b8';
  grid[20][17] = '#334155'; grid[20][18] = '#cbd5e1'; grid[20][19] = '#f8fafc'; grid[20][20] = '#00f0ff';
}

function makeHackerGold(base) {
  const g = 24, grid = makeGrid();
  const bg = base.grid;
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      const c = bg[y][x];
      if (!c) continue;
      if (c === '#431407') grid[y][x] = '#451a03';
      else if (c === '#7c2d12') grid[y][x] = '#78350f';
      else if (c === '#c2410c') grid[y][x] = '#92400e';
      else if (c === '#ea580c') grid[y][x] = '#b45309';
      else if (c === '#f97316') grid[y][x] = '#d97706';
      else if (c === '#fb923c') grid[y][x] = '#f59e0b';
      else if (c === '#fdba74') grid[y][x] = '#fde047';
      else if (c === '#ca8a04') grid[y][x] = '#b45309';
      else if (c === '#eab308') grid[y][x] = '#f59e0b';
      else if (c === '#facc15') grid[y][x] = '#fde047';
      else if (c === '#fde047') grid[y][x] = '#fef08a';
      else grid[y][x] = c;
    }
  }
  return { grid, gridSize: g };
}

function getHD_Hacker_Kranz_Base() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_Kranz_Base(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker_Kranz_UpperArm() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_Kranz_UpperArm(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker_Kranz_MidArm() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_Kranz_MidArm(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker_ArmKranz() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_ArmKranz(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker_Legs() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_LotusLegs(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker_Torso() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_Torso(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker_Head() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_Head(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker_Body() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_LotusLegs(grid);
  _paintHD_Hacker_Torso(grid);
  _paintHD_Hacker_Head(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker_Arms_Idle() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_Arms_Idle(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker_Arms_Typing(frame = 0) {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_Arms_Typing(grid, frame);
  return { grid, gridSize: g };
}

function getHD_Hacker_Keyboard(frame = 0) {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_HoloKeyboard(grid, frame);
  return { grid, gridSize: g };
}

function getHD_Hacker_Frontal() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_Frontal(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker_Debris() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_Debris(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker() {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_ArmKranz(grid);
  _paintHD_Hacker_LotusLegs(grid);
  _paintHD_Hacker_Torso(grid);
  _paintHD_Hacker_Head(grid);
  _paintHD_Hacker_Arms_Idle(grid);
  return { grid, gridSize: g };
}

function getHD_Hacker_Typing(frame = 0) {
  const g = 24, grid = makeGrid();
  _paintHD_Hacker_ArmKranz(grid);
  _paintHD_Hacker_LotusLegs(grid);
  _paintHD_Hacker_Torso(grid);
  _paintHD_Hacker_Head(grid);
  _paintHD_Hacker_Arms_Typing(grid, frame);
  _paintHD_Hacker_HoloKeyboard(grid, frame);
  return { grid, gridSize: g };
}

function getHD_HackerGold() { return makeHackerGold(getHD_Hacker()); }
function getHD_HackerGold_Kranz_Base() { return makeHackerGold(getHD_Hacker_Kranz_Base()); }
function getHD_HackerGold_Kranz_UpperArm() { return makeHackerGold(getHD_Hacker_Kranz_UpperArm()); }
function getHD_HackerGold_Kranz_MidArm() { return makeHackerGold(getHD_Hacker_Kranz_MidArm()); }
function getHD_HackerGold_ArmKranz() { return makeHackerGold(getHD_Hacker_ArmKranz()); }
function getHD_HackerGold_Legs() { return makeHackerGold(getHD_Hacker_Legs()); }
function getHD_HackerGold_Torso() { return makeHackerGold(getHD_Hacker_Torso()); }
function getHD_HackerGold_Head() { return makeHackerGold(getHD_Hacker_Head()); }
function getHD_HackerGold_Body() { return makeHackerGold(getHD_Hacker_Body()); }
function getHD_HackerGold_Arms_Idle() { return makeHackerGold(getHD_Hacker_Arms_Idle()); }
function getHD_HackerGold_Arms_Typing(frame = 0) { return makeHackerGold(getHD_Hacker_Arms_Typing(frame)); }
function getHD_HackerGold_Typing(frame = 0) { return makeHackerGold(getHD_Hacker_Typing(frame)); }
function getHD_HackerGold_Keyboard(frame = 0) { return makeHackerGold(getHD_Hacker_Keyboard(frame)); }
function getHD_HackerGold_Frontal() { return makeHackerGold(getHD_Hacker_Frontal()); }
function getHD_HackerGold_Debris() { return makeHackerGold(getHD_Hacker_Debris()); }

// ─────────────────────────────────────────────────────────────
// PINK BERET V2 (36×36 TIER M SPRITE FORGE V1) — LEGACY-SAFE
// 1. V2_AutoRig: Preserves the initial auto-rigged snapshot state as legacy
// 2. V2 (New Workflow): True Multi-Layer Anatomy Rig (Torso + Swinging Arms +
//    6 Hand-Crafted Walk Legs + 5-Stage RPG-7 Shouldering & Firing Sequence)
// ─────────────────────────────────────────────────────────────
const _V2_PB_36_PALETTE = ["#0f172a","#831843","#be185d","#9d174d","#451a03","#334155","#fba772","#f43f5e","#78350f","#92400e","#475569","#94a3b8","#ffffff","#cbd5e1","#ca8a04","#c2410c","#facc15","#ffedd5","#fef08a","#eab308","#fed7aa","#f1f5f9","#fde047","#1e293b","#f8fafc","#ea580c","#365314"];
const _V2_PB_36_GOLD_PALETTE = ["#1e1b4b","#831843","#be185d","#9d174d","#451a03","#3b0764","#facc15","#ffd700","#78350f","#92400e","#581c87","#ca8a04","#fef08a","#eab308","#ca8a04","#b45309","#fde047","#ffedd5","#ffffff","#d97706","#fef08a","#fde047","#fde047","#2e1065","#fef08a","#f97316","#854d0e"];

const _V2_PB_36_WALK_RLE = [0,53,1,4,0,31,1,1,2,4,1,1,0,29,1,1,2,1,3,2,4,2,2,1,1,1,0,28,1,2,5,1,1,1,5,2,1,2,0,28,1,2,6,1,7,1,6,1,7,1,6,1,1,1,0,28,1,1,2,1,8,1,7,1,9,1,10,1,6,1,1,1,0,28,1,2,11,1,8,1,5,1,11,1,12,1,1,2,0,25,1,3,12,1,2,1,9,1,8,2,13,1,14,1,12,1,1,1,0,23,1,1,15,3,7,1,8,1,16,1,2,1,14,1,13,2,7,1,1,1,0,22,1,1,10,1,17,2,13,1,18,1,10,1,8,2,10,1,13,2,7,1,10,1,1,1,0,21,1,1,7,1,17,2,13,1,7,1,10,3,9,1,12,1,13,1,7,1,15,1,1,1,0,20,1,1,14,1,13,2,19,1,13,1,15,1,10,2,9,1,10,1,15,1,7,3,6,1,1,1,0,18,1,1,12,1,13,3,19,2,20,1,10,4,21,1,8,1,7,2,12,1,1,1,0,18,1,1,22,1,13,1,14,1,12,1,11,1,19,1,20,1,16,1,8,3,23,1,10,1,7,1,21,1,14,1,1,1,0,18,1,1,14,1,7,2,16,1,1,1,18,1,7,1,8,2,16,2,23,1,9,1,6,1,11,1,1,1,0,20,1,1,8,1,7,2,12,1,18,1,7,1,8,1,7,1,8,1,10,1,19,1,7,1,1,2,0,22,1,1,2,1,22,1,13,1,14,1,7,1,8,4,21,1,13,1,1,1,0,24,1,2,22,1,14,1,18,1,5,1,9,1,5,1,24,1,25,1,14,1,1,1,0,25,1,1,12,1,13,1,21,1,13,4,21,1,13,1,1,1,0,25,1,1,13,2,21,1,13,2,22,1,13,1,21,1,13,1,12,1,1,1,0,24,1,1,21,1,13,1,21,1,13,1,22,1,12,1,13,1,21,1,13,1,12,1,1,1,0,25,1,1,7,2,13,1,14,1,12,1,13,1,7,1,15,1,1,1,0,26,1,1,13,3,12,1,14,1,13,2,14,1,1,1,0,25,1,1,6,1,13,3,1,1,12,1,13,2,14,1,1,1,0,25,1,1,14,1,13,2,12,1,1,1,6,1,13,2,12,1,1,1,0,24,1,2,13,3,24,1,1,1,12,1,13,2,12,1,1,1,0,24,1,2,13,3,1,2,12,1,13,2,12,1,1,1,0,24,1,1,11,1,13,2,14,1,1,2,11,1,13,2,12,1,1,1,0,24,1,1,12,1,13,2,11,1,1,2,24,1,13,2,12,1,1,1,0,24,1,1,14,1,13,2,1,1,0,2,1,1,13,2,25,1,1,1,0,24,1,1,12,1,13,1,14,1,1,1,0,1,1,1,15,1,13,1,22,1,25,1,12,1,1,1,0,22,1,1,5,1,23,1,17,1,15,1,1,1,0,1,1,1,10,2,13,2,23,1,20,1,1,1,0,21,1,1,5,1,15,2,9,1,1,1,0,2,1,1,11,1,12,2,15,2,1,1,0,22,1,4,0,4,1,5,0,47];
const _V2_PB_36_GUNFIRE_RLE = [0,50,1,5,0,30,1,1,5,1,2,3,5,1,1,1,0,28,1,1,2,1,3,5,1,1,0,28,1,1,5,1,2,1,4,1,2,2,5,1,1,1,0,28,1,2,5,2,9,1,10,1,8,1,1,1,0,28,1,1,5,1,8,1,21,1,7,1,1,1,7,1,1,1,0,28,1,2,11,1,16,1,7,1,5,1,1,2,0,26,1,3,19,1,7,1,9,1,5,1,10,1,12,1,1,3,0,23,1,1,10,1,15,1,20,1,23,1,13,1,18,1,2,1,9,1,14,1,20,1,5,1,1,5,0,19,1,1,15,1,17,2,13,3,7,2,9,1,23,1,6,1,11,2,12,2,5,1,1,1,0,18,1,1,15,1,17,1,19,1,13,3,10,2,9,1,18,1,12,2,11,1,24,1,1,1,24,1,1,1,0,18,1,1,15,1,19,1,18,1,13,2,18,1,7,2,13,4,12,1,1,3,0,19,1,1,17,1,15,1,7,1,25,1,13,1,21,1,7,2,21,1,13,3,1,2,0,22,1,1,15,1,18,1,22,1,21,1,12,1,9,3,11,1,12,2,1,1,0,24,1,1,12,1,13,2,19,1,7,1,8,1,10,1,7,1,11,1,1,1,0,26,1,1,13,3,16,1,8,1,10,1,7,1,8,1,1,1,0,25,1,2,13,2,19,1,16,1,7,1,10,1,21,1,7,1,1,1,0,25,1,1,14,1,13,2,21,1,5,3,21,1,18,1,14,1,1,1,0,24,1,1,13,3,18,1,13,5,22,1,1,1,0,24,1,1,13,3,18,1,13,4,14,1,22,1,1,1,0,23,1,1,11,1,13,3,18,1,13,4,12,1,1,1,0,25,1,1,7,1,13,7,1,1,0,27,1,1,14,1,18,1,13,5,1,1,0,27,1,1,13,3,22,1,13,3,1,1,0,26,1,1,11,1,13,3,12,1,13,2,14,1,1,1,0,26,1,1,14,1,13,3,12,1,13,2,14,1,1,1,0,26,1,1,13,4,12,1,13,2,14,1,1,1,0,26,1,1,13,3,14,1,1,1,14,1,13,1,12,1,1,1,0,26,1,1,22,1,13,2,1,2,13,3,1,2,0,24,1,1,10,1,13,3,10,1,15,1,17,1,13,3,9,1,1,1,0,22,1,1,23,1,15,1,18,1,13,2,1,2,20,1,18,1,13,1,19,1,17,1,10,1,1,1,0,22,1,2,21,1,13,1,19,1,23,1,1,1,6,2,1,1,24,2,1,1,0,24,1,1,10,1,20,3,1,3,0,1,1,2,0,26,1,4,0,56];
const _V2_PB_36_LAUNCHER_FIRE_RLE = [0,52,1,5,0,30,1,1,5,1,2,4,1,1,0,28,1,1,5,1,3,4,8,1,5,1,1,1,0,17,1,2,0,8,1,1,2,1,4,2,2,3,1,1,0,17,1,1,26,2,1,1,0,7,1,2,5,3,10,1,9,1,1,1,0,17,1,1,26,3,1,1,0,6,1,1,5,1,7,1,21,1,1,1,7,1,11,1,1,1,0,17,1,1,20,1,19,1,17,1,26,1,1,1,0,6,1,1,11,1,7,2,5,1,1,2,0,1,1,2,0,2,1,3,0,9,1,1,23,1,19,1,13,1,20,1,1,7,6,1,10,1,9,1,1,9,5,1,9,1,27,1,1,1,0,8,1,1,13,3,12,1,6,2,24,1,5,1,9,2,16,2,5,1,9,2,24,1,1,5,9,1,10,3,15,2,1,1,0,7,1,1,13,3,12,1,1,3,5,1,9,1,5,1,9,2,5,1,1,8,5,6,1,1,0,7,1,1,17,1,19,2,26,1,1,3,15,1,20,2,19,3,12,1,18,2,9,1,12,1,13,1,12,1,1,7,0,8,1,1,26,1,17,1,20,1,26,1,1,1,0,1,1,1,12,1,23,1,19,1,13,1,21,1,7,1,13,2,14,1,5,1,7,1,13,2,11,1,1,1,0,13,1,1,26,2,1,2,0,2,1,1,12,1,13,2,8,1,7,2,13,2,11,1,5,1,15,1,14,1,13,1,8,1,5,1,1,1,0,13,1,2,0,4,1,1,12,1,13,1,7,4,10,1,9,1,16,2,15,1,11,1,8,1,7,1,8,1,1,1,0,20,1,1,22,1,8,1,7,1,8,1,7,3,8,2,15,1,12,1,16,1,7,1,8,1,1,1,0,20,1,1,11,1,10,2,12,1,19,1,15,1,7,1,8,1,16,1,15,1,1,1,6,1,9,1,5,1,1,1,0,21,1,2,14,1,13,1,19,1,10,1,8,2,16,1,10,1,1,4,0,23,1,1,13,2,21,1,8,2,7,1,10,1,12,2,1,1,0,24,1,1,14,1,13,2,10,1,6,1,1,1,9,2,12,1,21,1,1,1,0,24,1,1,13,3,18,1,13,5,12,2,1,1,0,22,1,1,14,1,13,2,7,1,13,7,12,1,1,1,0,22,1,1,15,1,13,2,21,1,13,8,12,1,1,1,0,22,1,1,7,1,23,1,13,3,1,1,12,1,13,5,11,1,1,1,0,20,1,1,6,1,13,4,12,1,1,2,11,1,22,1,13,4,1,1,0,20,1,1,12,1,13,3,12,1,1,1,0,2,1,2,12,1,13,3,1,2,0,18,1,1,11,1,13,3,14,1,1,1,0,4,1,1,6,1,13,3,6,1,1,1,0,18,1,1,22,1,13,2,22,1,1,1,0,5,1,1,6,1,13,3,11,1,1,1,0,17,1,1,6,1,13,2,22,1,12,1,1,1,0,6,1,1,13,3,11,1,1,1,0,17,1,1,12,1,13,1,25,1,12,1,1,1,0,7,1,1,14,1,13,2,12,1,1,1,0,16,1,1,20,1,13,2,14,1,1,1,0,8,1,1,12,1,13,2,12,1,1,1,0,14,1,1,0,1,1,2,14,2,12,1,1,1,0,7,1,1,23,1,12,1,13,1,22,1,14,1,1,2,0,12,1,1,11,1,1,2,11,1,19,2,10,1,1,1,0,8,1,1,5,1,7,1,13,2,17,1,15,1,1,1,0,11,1,1,11,2,12,1,1,1,15,2,9,1,1,1,0,9,1,1,11,1,12,1,15,2,9,1,1,1,0,12,1,7,0,11,1,5,0,43];
const _V2_PB_36_DANCE_RLE = [0,51,1,5,0,30,1,1,5,1,2,4,1,1,0,26,1,2,0,1,1,1,4,1,3,4,2,1,1,1,0,24,1,1,12,2,1,3,2,4,1,1,0,3,1,3,0,18,1,1,11,1,13,2,12,1,1,1,11,1,12,1,11,1,10,1,9,1,1,4,12,1,14,1,12,1,1,1,0,17,1,1,14,1,25,1,22,1,12,1,1,1,10,1,7,1,6,1,12,1,11,1,1,1,6,1,8,1,7,2,13,1,14,1,12,1,1,1,0,15,1,1,10,1,7,1,12,1,11,1,1,1,11,2,8,1,5,1,1,1,9,1,7,1,13,1,12,1,7,1,11,1,12,1,11,1,1,1,0,15,1,1,9,1,7,2,6,1,15,3,19,1,11,1,10,1,9,1,11,1,21,1,13,1,12,1,6,1,1,3,0,16,1,1,10,1,7,2,14,1,18,1,20,1,7,1,13,1,12,1,8,1,10,1,12,1,22,2,12,1,1,1,0,19,1,1,10,1,7,1,12,1,13,3,19,3,10,3,7,1,6,1,1,1,0,21,1,1,6,1,14,1,22,1,25,1,13,2,18,2,9,3,10,2,1,1,0,22,1,4,12,1,13,1,19,2,10,1,9,3,15,1,1,1,0,25,1,1,11,1,22,1,19,1,7,1,10,1,8,1,7,1,11,1,12,1,15,1,1,1,0,23,1,2,12,1,13,1,19,1,11,1,8,1,7,1,8,1,11,1,14,2,12,1,1,1,0,20,1,2,12,1,14,1,13,2,11,1,8,2,7,1,8,1,11,1,14,3,12,1,1,1,0,18,1,1,12,1,25,1,13,2,21,1,12,1,11,1,7,2,8,2,9,1,14,4,12,1,1,1,0,16,1,1,12,1,13,3,12,1,14,2,1,1,11,1,9,1,16,1,10,1,24,1,14,5,6,1,1,1,0,15,1,1,21,1,13,2,15,1,14,2,12,1,14,1,12,1,11,1,12,1,7,1,12,1,14,1,12,1,15,1,10,1,15,1,27,1,1,1,0,15,1,1,7,1,13,1,7,1,1,1,11,1,21,1,12,1,13,4,25,1,12,1,9,1,1,5,0,16,1,1,10,1,18,1,15,1,1,2,11,2,25,1,13,3,14,1,12,1,1,1,0,22,1,1,10,1,1,1,0,2,1,2,14,1,13,3,12,2,1,1,0,23,1,1,0,4,1,1,12,1,13,3,14,1,11,1,1,1,0,29,1,1,22,1,13,2,14,1,6,1,1,1,0,28,1,1,11,1,12,1,13,2,14,1,1,1,0,27,1,2,11,1,14,1,12,1,25,1,13,1,14,1,1,1,0,26,1,1,20,1,11,1,14,2,12,1,25,1,13,2,1,1,0,26,1,1,9,1,12,1,14,2,12,1,22,1,13,2,11,1,1,1,0,24,1,2,15,1,12,1,14,1,11,1,1,1,12,1,13,2,12,1,1,1,0,25,1,1,6,1,13,1,12,1,1,1,0,1,1,1,13,2,22,1,1,1,0,25,1,1,11,1,19,1,7,1,1,1,0,1,1,1,14,1,13,1,22,1,11,1,1,1,0,25,1,1,15,2,9,1,1,1,23,1,12,1,22,1,14,1,12,1,1,2,0,25,1,4,17,1,5,1,7,1,13,1,18,1,20,1,10,1,1,1,0,28,1,1,24,1,11,1,12,1,15,2,9,1,1,1,0,29,1,6,0,48];

function _decodeV2_PB36(palette, rle) {
  const g = 36, grid = makeGrid36();
  let pos = 0;
  for (let i = 0; i < rle.length; i += 2) {
    const palIdx = rle[i];
    const count = rle[i + 1];
    const color = palIdx === 0 ? null : palette[palIdx - 1];
    for (let c = 0; c < count; c++) {
      const y = Math.floor(pos / 36);
      const x = pos % 36;
      if (y < 36) grid[y][x] = color;
      pos++;
    }
  }
  return { grid, gridSize: g };
}

// ── 1. PRESERVED LEGACY STATE: V2_AutoRig (First End-to-End Snapshot) ──
function _paintV2_PB36_AutoRigLeg(grid, hipX, kneeX, footX, liftY, isFront, isGold = false) {
  const OUT = isGold ? '#1e1b4b' : '#0f172a';
  const W_HI = isGold ? '#fef08a' : '#ffffff';
  const W_MID = isGold ? '#fde047' : '#f1f5f9';
  const W_SHD = isGold ? '#eab308' : '#cbd5e1';
  const W_DRK = isGold ? '#ca8a04' : '#94a3b8';
  const G_HI = isGold ? '#ffffff' : '#fde047';
  const G_MID = isGold ? '#fde047' : '#facc15';
  const G_DRK = '#ca8a04';
  const LTHR = '#78350f';

  const hipY = 19;
  const kneeY = 26 - Math.round(liftY * 0.45);
  const ankleY = Math.min(31, 31 - liftY);
  const mainC = isFront ? W_HI : W_MID;
  const sideC = isFront ? W_SHD : W_DRK;

  for (let y = hipY; y <= kneeY; y++) {
    const t = (y - hipY) / Math.max(1, kneeY - hipY);
    const cx = Math.round(hipX + (kneeX - hipX) * t);
    if (y >= 0 && y < 36) {
      if (cx - 2 >= 0) grid[y][cx - 2] = OUT;
      if (cx - 1 >= 0) grid[y][cx - 1] = sideC;
      if (cx >= 0 && cx < 36) grid[y][cx] = mainC;
      if (cx + 1 < 36) grid[y][cx + 1] = mainC;
      if (cx + 2 < 36) grid[y][cx + 2] = OUT;
    }
  }
  for (let y = kneeY; y <= ankleY; y++) {
    const t = (y - kneeY) / Math.max(1, ankleY - kneeY);
    const cx = Math.round(kneeX + (footX - kneeX) * t);
    if (y >= 0 && y < 36) {
      if (cx - 2 >= 0) grid[y][cx - 2] = OUT;
      if (cx - 1 >= 0) grid[y][cx - 1] = sideC;
      if (cx >= 0 && cx < 36) grid[y][cx] = mainC;
      if (cx + 1 < 36) grid[y][cx + 1] = (y === ankleY ? G_DRK : mainC);
      if (cx + 2 < 36) grid[y][cx + 2] = OUT;
    }
  }
  const b1 = ankleY + 1, b2 = ankleY + 2, b3 = ankleY + 3;
  const fx = Math.round(footX);
  if (b1 < 36) {
    if (fx - 3 >= 0) grid[b1][fx - 3] = OUT;
    if (fx - 2 >= 0) grid[b1][fx - 2] = G_HI;
    if (fx - 1 >= 0) grid[b1][fx - 1] = LTHR;
    if (fx < 36) grid[b1][fx] = mainC;
    if (fx + 1 < 36) grid[b1][fx + 1] = G_HI;
    if (fx + 2 < 36) grid[b1][fx + 2] = G_MID;
    if (fx + 3 < 36) grid[b1][fx + 3] = OUT;
  }
  if (b2 < 36) {
    if (fx - 2 >= 0) grid[b2][fx - 2] = OUT;
    if (fx - 1 >= 0) grid[b2][fx - 1] = G_DRK;
    if (fx < 36) grid[b2][fx] = W_DRK;
    if (fx + 1 < 36) grid[b2][fx + 1] = G_DRK;
    if (fx + 2 < 36) grid[b2][fx + 2] = G_MID;
    if (fx + 3 < 36) grid[b2][fx + 3] = OUT;
  }
  if (b3 < 36) {
    for (let sx = fx - 2; sx <= fx + 2; sx++) {
      if (sx >= 0 && sx < 36) grid[b3][sx] = OUT;
    }
  }
}

function getHD_PinkBeret_V2_AutoRig_Stand(isGold = false) {
  return _decodeV2_PB36(isGold ? _V2_PB_36_GOLD_PALETTE : _V2_PB_36_PALETTE, _V2_PB_36_WALK_RLE);
}
function getHD_PinkBeret_V2_AutoRig_Walk(frame = 1, isGold = false) {
  const phase8 = ((Math.max(1, frame) - 1) % 8);
  if (phase8 === 0) return getHD_PinkBeret_V2_AutoRig_Stand(isGold);
  const full = getHD_PinkBeret_V2_AutoRig_Stand(isGold).grid;
  const grid = makeGrid36();
  const theta = (phase8 / 8) * Math.PI * 2;
  const s = Math.sin(theta), c = Math.cos(theta);
  const fFootX = 17.5 + s * 4.5, fKneeX = 18.0 + s * 2.8 + Math.max(0, c) * 1.4, fLift = Math.max(0, Math.round(c * 2.5));
  const rFootX = 17.5 - s * 4.5, rKneeX = 17.0 - s * 2.8 + Math.max(0, -c) * 1.4, rLift = Math.max(0, Math.round(-c * 2.5));
  if (s >= 0) {
    _paintV2_PB36_AutoRigLeg(grid, 15.5, rKneeX, rFootX, rLift, false, isGold);
    _paintV2_PB36_ArticulatedLeg_LegacyAlias(grid, 19.5, fKneeX, fFootX, fLift, true, isGold);
  } else {
    _paintV2_PB36_AutoRigLeg(grid, 19.5, fKneeX, fFootX, fLift, false, isGold);
    _paintV2_PB36_AutoRigLeg(grid, 15.5, rKneeX, rFootX, rLift, true, isGold);
  }
  const bobY = (phase8 === 2 || phase8 === 6) ? -1 : 0;
  for (let y = 0; y <= 18; y++) {
    const dy = y + bobY;
    if (dy >= 0 && dy < 36) {
      for (let x = 0; x < 36; x++) if (full[y][x]) grid[dy][x] = full[y][x];
    }
  }
  return { grid, gridSize: 36 };
}
function _paintV2_PB36_ArticulatedLeg_LegacyAlias(grid, hipX, kneeX, footX, liftY, isFront, isGold) {
  return _paintV2_PB36_AutoRigLeg(grid, hipX, kneeX, footX, liftY, isFront, isGold);
}

// ── 2. NEW WORKFLOW: TRUE 36×36 MULTI-PART LAYER RIG (PinkBeret_V2_*) ──
// Combines the exact visual DNA of your 36x36 AI blueprint (2.5D ~70° torso, pink beret,
// white sunglasses, mustache, open white-gold parade jacket, hairy chest & gold-tipped white boots)
// with dedicated anatomical layers:
// - Torso (rows 1..19, with clean armless sides so front & rear arms swing freely!)
// - Arm_Rear (swinging in counter-phase behind the torso)
// - Pistol (sculpted front arm in white parade sleeve + gold cuff + chrome pistol)
// - 6 Hand-Crafted Catwalk Leg Phases (Walk1..6) + Crouch + Heave + Aim + Tap + Stand
// - 5-Stage RPG-7 Shouldering & Firing Sequence (Carry -> Lift -> Heave -> Mount -> Aim45 -> Fire)

export function isPinkBeretV2Enabled() {
  if (typeof window !== 'undefined') {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('pb') === 'v2') return true;
      if (params.get('pb') === 'legacy' || params.get('pb') === 'uhd') return false;
    } catch (_) {}
    try {
      if (window.localStorage && window.localStorage.getItem('ucg_pb_sprite') === 'v2') {
        return true;
      }
    } catch (_) {}
  }
  return false;
}

export function setPinkBeretV2Enabled(enabled) {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem('ucg_pb_sprite', enabled ? 'v2' : 'uhd');
    } catch (_) {}
    window.dispatchEvent(new CustomEvent('ucg_hd_mode_changed', { detail: { pbV2: !!enabled } }));
  }
}

function _recolorV2Gold36(base) {
  const g = 36, grid = makeGrid36();
  for (let y = 0; y < g; y++) {
    for (let x = 0; x < g; x++) {
      const c = base.grid[y][x];
      if (!c) continue;
      if (c === '#ffffff' || c === '#f8fafc') grid[y][x] = '#fef08a';
      else if (c === '#f1f5f9' || c === '#e2e8f0') grid[y][x] = '#fde047';
      else if (c === '#cbd5e1') grid[y][x] = '#eab308';
      else if (c === '#94a3b8') grid[y][x] = '#ca8a04';
      else if (c === '#0f172a' || c === '#020617') grid[y][x] = '#1e1b4b';
      else if (c === '#1e293b') grid[y][x] = '#2e1065';
      else if (c === '#334155') grid[y][x] = '#3b0764';
      else if (c === '#475569') grid[y][x] = '#581c87';
      else grid[y][x] = c;
    }
  }
  return { grid, gridSize: g };
}

function _paintV2_PB36_Torso(grid, isTurn = false) {
  // Uses your exact 36x36 Walk head & torso (rows 1..18, cols 11..23),
  // with the static arms stripped at the outer edges (cols 9..11 and 23..25)
  // so the articulated Rear Arm and Front Arm/Pistol/RPG layers can animate cleanly!
  const base = _decodeV2_PB36(_V2_PB_36_PALETTE, _V2_PB_36_WALK_RLE).grid;
  for (let y = 1; y <= 18; y++) {
    for (let x = 11; x <= 23; x++) {
      // Keep head (y<=7) intact; for torso (y 8..17) keep core body cols 11..22
      if (y >= 11 && (x < 12 || x > 22)) continue;
      if (base[y][x]) grid[y][x] = base[y][x];
    }
  }
  // Ensure crisp 1px dark outer contour around the torso core (cols 12..22)
  grid[8][13] = '#0f172a'; grid[8][22] = '#0f172a';
  grid[9][12] = '#0f172a'; grid[9][22] = '#0f172a';
  for (let y = 10; y <= 17; y++) {
    if (!grid[y][11]) grid[y][11] = '#0f172a';
    if (!grid[y][22]) grid[y][22] = '#0f172a';
  }
  // White sunglasses highlight & dual lenses in 2.5D (~70°)
  grid[4][16] = '#ffffff'; grid[4][17] = '#334155'; grid[4][18] = '#ffffff'; grid[4][19] = '#334155'; grid[4][20] = '#ffffff';
  grid[5][16] = '#ffffff'; grid[5][17] = '#0f172a'; grid[5][18] = '#fba772'; grid[5][19] = '#0f172a'; grid[5][20] = '#ffffff';
  // Handlebar mustache
  grid[6][17] = '#451a03'; grid[6][18] = '#451a03'; grid[6][19] = '#78350f'; grid[6][20] = '#451a03';

  if (isTurn) {
    // 3/4 Camera Head Turn during Waiting Groove: shift sunglasses & beret badge 1px toward viewer
    grid[2][18] = '#fde047'; grid[2][19] = '#facc15'; // gold beret badge centered
    grid[4][15] = '#ffffff'; grid[4][16] = '#38bdf8'; grid[4][17] = '#ffffff'; grid[4][18] = '#38bdf8'; grid[4][19] = '#ffffff';
    grid[5][15] = '#ffffff'; grid[5][16] = '#0f172a'; grid[5][17] = '#fed7aa'; grid[5][18] = '#0f172a'; grid[5][19] = '#ffffff';
    grid[6][16] = '#451a03'; grid[6][17] = '#ff2a85'; grid[6][18] = '#451a03'; // cheeky smirk
  }
}

function _paintV2_PB36_Arm_Rear(grid) {
  // Rear (Left) Arm in white short-sleeve parade uniform + bare forearm + white parade glove
  // Pivot at rear shoulder (x: 12, y: 10 in 36x36 space)
  grid[9][10]  = '#0f172a'; grid[9][11]  = '#ca8a04'; grid[9][12]  = '#facc15';
  grid[10][9]  = '#0f172a'; grid[10][10] = '#cbd5e1'; grid[10][11] = '#ffffff'; grid[10][12] = '#0f172a';
  grid[11][9]  = '#0f172a'; grid[11][10] = '#94a3b8'; grid[11][11] = '#cbd5e1'; grid[11][12] = '#0f172a';
  // Muscular bare forearm
  grid[12][9]  = '#0f172a'; grid[12][10] = '#92400e'; grid[12][11] = '#fba772'; grid[12][12] = '#0f172a';
  grid[13][9]  = '#0f172a'; grid[13][10] = '#92400e'; grid[13][11] = '#fba772'; grid[13][12] = '#0f172a';
  grid[14][9]  = '#0f172a'; grid[14][10] = '#ca8a04'; grid[14][11] = '#facc15'; grid[14][12] = '#0f172a'; // gold cuff
  // White parade glove
  grid[15][9]  = '#0f172a'; grid[15][10] = '#cbd5e1'; grid[15][11] = '#ffffff'; grid[15][12] = '#0f172a';
  grid[16][9]  = '#0f172a'; grid[16][10] = '#94a3b8'; grid[16][11] = '#cbd5e1'; grid[16][12] = '#0f172a';
  grid[17][10] = '#0f172a'; grid[17][11] = '#0f172a';
}

function _paintV2_PB36_Pistol(grid) {
  // Front Arm + Heavy Chrome Pistol (extracted & refined from your Gunfire 36x36 design!)
  // Pivot at front shoulder (x: 14, y: 10 in 36x36 space)
  // 1. Gold Epaulette & White Sleeve Cap (y: 9..12, x: 12..16)
  grid[9][12]  = '#0f172a'; grid[9][13]  = '#ca8a04'; grid[9][14]  = '#facc15'; grid[9][15]  = '#fde047';
  grid[10][12] = '#0f172a'; grid[10][13] = '#ca8a04'; grid[10][14] = '#ffffff'; grid[10][15] = '#f8fafc'; grid[10][16] = '#0f172a';
  grid[11][12] = '#0f172a'; grid[11][13] = '#cbd5e1'; grid[11][14] = '#ffffff'; grid[11][15] = '#cbd5e1'; grid[11][16] = '#0f172a';
  // 2. Forearm & White Parade Glove extending forward (y: 11..13, x: 16..22)
  grid[11][16] = '#fba772'; grid[11][17] = '#fed7aa'; grid[11][18] = '#facc15'; grid[11][19] = '#ffffff'; grid[11][20] = '#ffffff'; grid[11][21] = '#cbd5e1';
  grid[12][15] = '#0f172a'; grid[12][16] = '#92400e'; grid[12][17] = '#fba772'; grid[12][18] = '#ca8a04'; grid[12][19] = '#cbd5e1'; grid[12][20] = '#ffffff'; grid[12][21] = '#94a3b8';
  grid[13][16] = '#0f172a'; grid[13][17] = '#0f172a'; grid[13][18] = '#0f172a'; grid[13][19] = '#0f172a'; grid[13][20] = '#0f172a'; grid[13][21] = '#0f172a';
  // 3. Heavy Chrome Semi-Automatic Pistol / Revolver (y: 9..12, x: 21..28, muzzle at x=28, y=10)
  grid[8][21]  = '#0f172a'; grid[8][22]  = '#0f172a'; grid[8][23]  = '#0f172a'; grid[8][24]  = '#0f172a'; grid[8][25]  = '#0f172a'; grid[8][26]  = '#0f172a'; grid[8][27]  = '#0f172a';
  grid[9][21]  = '#0f172a'; grid[9][22]  = '#334155'; grid[9][23]  = '#ffffff'; grid[9][24]  = '#ffffff'; grid[9][25]  = '#f8fafc'; grid[9][26]  = '#ffffff'; grid[9][27]  = '#fde047'; grid[9][28]  = '#0f172a';
  grid[10][21] = '#1e293b'; grid[10][22] = '#475569'; grid[10][23] = '#94a3b8'; grid[10][24] = '#64748b'; grid[10][25] = '#94a3b8'; grid[10][26] = '#475569'; grid[10][27] = '#ca8a04'; grid[10][28] = '#0f172a';
  grid[11][22] = '#451a03'; grid[11][23] = '#ca8a04'; grid[11][24] = '#0f172a'; grid[11][25] = '#0f172a'; grid[11][26] = '#0f172a'; grid[11][27] = '#0f172a';
  grid[12][22] = '#451a03'; grid[12][23] = '#0f172a';
}

// Helper for sculpting a 5px-wide tailored white parade trouser leg + gold-tipped boot with spur
function _sculptV2_PB36_TrouserBoot(grid, hipX, kneeX, kneeY, footX, footY, toeLift, isFront) {
  const OUT = '#0f172a';
  const W_MAIN = isFront ? '#ffffff' : '#f1f5f9';
  const W_HI   = '#ffffff';
  const W_SHD  = isFront ? '#cbd5e1' : '#94a3b8';
  const W_DEEP = isFront ? '#94a3b8' : '#475569';
  const G_HI   = '#fde047';
  const G_MID  = '#facc15';
  const G_DRK  = '#ca8a04';
  const LTHR   = '#78350f';

  const hipY = 19;
  const bootTopY = footY - 3;

  // 1. Tailored Parade Thigh (hipY .. kneeY)
  for (let y = hipY; y <= kneeY; y++) {
    const t = (y - hipY) / Math.max(1, kneeY - hipY);
    const cx = Math.round(hipX + (kneeX - hipX) * t);
    if (y < 19 || y >= 35) continue;
    grid[y][cx - 2] = OUT;
    grid[y][cx - 1] = W_SHD;
    grid[y][cx]     = W_MAIN;
    grid[y][cx + 1] = W_HI;
    grid[y][cx + 2] = OUT;
  }

  // 2. Tailored Calf / Shin (kneeY .. bootTopY)
  for (let y = kneeY; y <= bootTopY; y++) {
    const t = (y - kneeY) / Math.max(1, bootTopY - kneeY);
    const cx = Math.round(kneeX + (footX - kneeX) * t);
    if (y < 19 || y >= 35) continue;
    grid[y][cx - 2] = OUT;
    grid[y][cx - 1] = W_DEEP;
    grid[y][cx]     = W_MAIN;
    grid[y][cx + 1] = W_MAIN;
    grid[y][cx + 2] = OUT;
  }

  // 3. White-Gold Parade Boot with Golden Toe-Cap, Leather Heel & Spur (bootTopY+1 .. footY)
  const fx = Math.round(footX);
  const y1 = bootTopY + 1;
  const y2 = bootTopY + 2;
  const y3 = footY;

  if (y1 >= 19 && y1 < 35) {
    grid[y1][fx - 2] = OUT;
    grid[y1][fx - 1] = G_DRK; // gold boot cuff rim
    grid[y1][fx]     = W_MAIN;
    grid[y1][fx + 1] = W_HI;
    grid[y1][fx + 2] = W_SHD;
    grid[y1][fx + 3] = OUT;
  }
  if (y2 >= 19 && y2 < 35) {
    const toeY = y2 - (toeLift > 0 ? 1 : 0);
    grid[y2][fx - 3] = OUT;
    grid[y2][fx - 2] = G_HI; // golden cowboy spur!
    grid[y2][fx - 1] = LTHR;
    grid[y2][fx]     = W_MAIN;
    grid[y2][fx + 1] = W_MAIN;
    if (toeY >= 19 && toeY < 35) {
      grid[toeY][fx + 2] = G_HI; // golden toe cap
      grid[toeY][fx + 3] = G_MID;
      grid[toeY][fx + 4] = OUT;
    }
  }
  if (y3 >= 19 && y3 < 35) {
    grid[y3][fx - 2] = OUT;
    grid[y3][fx - 1] = LTHR; // heel
    grid[y3][fx]     = OUT;
    if (toeLift === 0) {
      grid[y3][fx + 1] = G_DRK;
      grid[y3][fx + 2] = G_DRK;
      grid[y3][fx + 3] = OUT;
      if (y3 + 1 < 36) {
        for (let sx = fx - 2; sx <= fx + 3; sx++) grid[y3 + 1][sx] = OUT;
      }
    } else if (y3 + 1 < 36) {
      grid[y3 + 1][fx - 2] = OUT;
      grid[y3 + 1][fx - 1] = OUT;
    }
  }
}

function _paintV2_PB36_PelvisBelt(grid) {
  // Seamless Pelvis & Officer Belt Connection at y: 18..21 (matches your Walk JSON waist!)
  const base = _decodeV2_PB36(_V2_PB_36_PALETTE, _V2_PB_36_WALK_RLE).grid;
  for (let y = 18; y <= 21; y++) {
    for (let x = 13; x <= 23; x++) {
      if (base[y][x]) grid[y][x] = base[y][x];
    }
  }
}

function _paintV2_PB36_Legs(grid, frame = 0) {
  const walkBase = _decodeV2_PB36(_V2_PB_36_PALETTE, _V2_PB_36_WALK_RLE).grid;
  const lnchBase = _decodeV2_PB36(_V2_PB_36_PALETTE, _V2_PB_36_LAUNCHER_FIRE_RLE).grid;
  const danceBase = _decodeV2_PB36(_V2_PB_36_PALETTE, _V2_PB_36_DANCE_RLE).grid;

  if (frame === 0 || frame === 'stand' || frame === 1 || frame === 'dance1') {
    // Frame 0 / Walk 1: Uses your exact 36x36 Walk trousers & gold-tipped boots (rows 18..34)!
    for (let y = 18; y <= 34; y++) {
      for (let x = 0; x < 36; x++) {
        if (walkBase[y][x]) grid[y][x] = walkBase[y][x];
      }
    }
    return;
  }

  if (frame === 'aim') {
    // Wide Braced Tripod RPG-7 Stance: Uses your exact 36x36 Launcher_Fire braced legs (rows 18..34)!
    for (let y = 18; y <= 34; y++) {
      for (let x = 0; x < 36; x++) {
        if (lnchBase[y][x]) grid[y][x] = lnchBase[y][x];
      }
    }
    return;
  }

  if (frame === 'dance2') {
    // MJ Knee Pop & Groove: Uses your exact 36x36 Dance lower body (rows 18..34)!
    for (let y = 18; y <= 34; y++) {
      for (let x = 0; x < 36; x++) {
        if (danceBase[y][x]) grid[y][x] = danceBase[y][x];
      }
    }
    return;
  }

  _paintV2_PB36_PelvisBelt(grid);

  if (frame === 'tap') {
    // Rhythmic Toe Tap: Rear leg planted at x=14, Front leg heel planted at x=20 with toe lifted!
    _sculptV2_PB36_TrouserBoot(grid, 15, 14, 26, 14, 33, 0, false);
    _sculptV2_PB36_TrouserBoot(grid, 20, 20, 26, 20, 33, 1, true);
    return;
  }

  if (frame === 'crouch') {
    // RPG Stage 2 (Knee Flexion & Load Compression before upward heave): knees bent forward/out, dipped 1px
    _sculptV2_PB36_TrouserBoot(grid, 15, 13, 26, 12, 33, 0, false);
    _sculptV2_PB36_TrouserBoot(grid, 20, 22, 26, 20, 33, 0, true);
    return;
  }

  if (frame === 'heave') {
    // RPG Stage 3 (Upward Leg Drive): Rear leg thrusts back to x=10, front leg drives tall at x=21
    _sculptV2_PB36_TrouserBoot(grid, 15, 12, 26, 10, 33, 0, false);
    _sculptV2_PB36_TrouserBoot(grid, 20, 21, 26, 21, 33, 0, true);
    return;
  }

  if (frame === 'dance3') {
    _sculptV2_PB36_TrouserBoot(grid, 15, 13, 26, 12, 33, 0, false);
    _sculptV2_PB36_TrouserBoot(grid, 20, 22, 26, 23, 33, 0, true);
    return;
  }

  if (frame === 'dance4') {
    _sculptV2_PB36_TrouserBoot(grid, 15, 14, 25, 13, 32, 1, false);
    _sculptV2_PB36_TrouserBoot(grid, 20, 20, 26, 20, 33, 0, true);
    return;
  }

  // ── 6-PHASE HAND-CRAFTED CATWALK RUNWAY STRIDE (Frames 1..6) ──
  // Frame 1 is handled above (exact Walk JSON). Below are Frames 2..6:
  if (frame === 2) {
    // Phase 2: Front foot extends & plants forward (x=23), rear foot pushes off behind (x=11, heel lifted)
    _sculptV2_PB36_TrouserBoot(grid, 15, 13, 26, 11, 32, 0, false);
    _sculptV2_PB36_TrouserBoot(grid, 20, 22, 26, 23, 33, 0, true);
  } else if (frame === 3) {
    // Phase 3: Rear leg swings forward with bent knee (knee=19, foot=16 lifted at y=31), front leg supports at x=19
    _sculptV2_PB36_TrouserBoot(grid, 20, 19, 26, 19, 33, 0, true);
    _sculptV2_PB36_TrouserBoot(grid, 16, 19, 25, 16, 31, 1, false);
  } else if (frame === 4) {
    // Phase 4: Counter-Stride! Rear leg (Left) leads forward (x=22), Front leg (Right) trails behind (x=12)
    _sculptV2_PB36_TrouserBoot(grid, 19, 15, 26, 12, 33, 0, true);
    _sculptV2_PB36_TrouserBoot(grid, 16, 20, 26, 22, 33, 1, false);
  } else if (frame === 5) {
    // Phase 5: Rear leg planted forward (x=21), Front leg bends & lifts behind (knee=16, foot=13 at y=31)
    _sculptV2_PB36_TrouserBoot(grid, 16, 20, 26, 21, 33, 0, false);
    _sculptV2_PB36_TrouserBoot(grid, 19, 16, 25, 13, 31, 0, true);
  } else {
    // Phase 6: High Runway Knee Pass! Front leg drives high forward (knee=21, foot=19 at y=31) over supporting rear leg (x=16)
    _sculptV2_PB36_TrouserBoot(grid, 16, 16, 26, 16, 33, 0, false);
    _sculptV2_PB36_TrouserBoot(grid, 20, 21, 25, 19, 31, 1, true);
  }
}

// Helper to draw the RPG-7 Tube + Olive PG-7 Warhead + Gloved Hands at any angle (Carry -> Lift -> Heave -> Mount)
function _paintV2_PB36_LauncherAtSlope(grid, centerY, slopePerCol, withBackblast = false) {
  const OUT  = '#0f172a';
  const WOOD = '#92400e';
  const W_DK = '#451a03';
  const W_HI = '#c2410c';
  const STL  = '#475569';
  const S_HI = '#94a3b8';
  const OLV1 = '#365314';
  const OLV2 = '#65a30d';
  const OLV3 = '#84cc16';
  const G_HI = '#fde047';
  const G_MD = '#ca8a04';

  // Tube spans from x=9 (flared exhaust nozzle) to x=26 (front collar), warhead x=27..31
  for (let x = 9; x <= 26; x++) {
    const cy = Math.round(centerY - (x - 18) * slopePerCol);
    if (cy < 2 || cy >= 34) continue;
    const isNozzle = (x <= 11);
    const isWood = (x >= 13 && x <= 21);
    if (isNozzle) {
      grid[cy - 2][x] = OUT;
      grid[cy - 1][x] = S_HI;
      grid[cy][x]     = STL;
      grid[cy + 1][x] = '#1e293b';
      grid[cy + 2][x] = OUT;
    } else {
      grid[cy - 1][x] = OUT;
      grid[cy][x]     = isWood ? W_HI : S_HI;
      grid[cy + 1][x] = isWood ? WOOD : STL;
      grid[cy + 2][x] = isWood ? W_DK : OUT;
    }
  }

  // Optical Sight & Carrying Handle above x=18..20
  const sightY = Math.round(centerY - 2);
  if (sightY >= 2) {
    grid[sightY][18] = OUT; grid[sightY][19] = '#38bdf8'; grid[sightY][20] = OUT;
  }

  // Olive-Green PG-7 Rocket Warhead at x=27..31
  for (let x = 27; x <= 31; x++) {
    const cy = Math.round(centerY - (x - 18) * slopePerCol);
    if (cy < 2 || cy >= 34) continue;
    if (x <= 29) {
      grid[cy - 2][x] = OUT;
      grid[cy - 1][x] = OLV3;
      grid[cy][x]     = OLV2;
      grid[cy + 1][x] = OLV1;
      grid[cy + 2][x] = OUT;
    } else if (x === 30) {
      grid[cy - 1][x] = OUT;
      grid[cy][x]     = G_HI;
      grid[cy + 1][x] = G_MD;
      grid[cy + 2][x] = OUT;
    } else {
      grid[cy][x]     = OUT;
      grid[cy + 1][x] = OUT;
    }
  }

  // White Parade Gloved Hands gripping launcher at x=15..16 and x=22..23
  for (const gx of [15, 22]) {
    const gy = Math.round(centerY - (gx - 18) * slopePerCol) + 2;
    if (gy < 34) {
      grid[gy][gx]     = '#ffffff'; grid[gy][gx + 1]     = '#cbd5e1';
      grid[gy + 1][gx] = '#facc15'; grid[gy + 1][gx + 1] = '#ca8a04'; // gold glove cuff
    }
  }

  if (withBackblast) {
    const lnchBase = _decodeV2_PB36(_V2_PB_36_PALETTE, _V2_PB_36_LAUNCHER_FIRE_RLE).grid;
    for (let y = 4; y <= 14; y++) {
      for (let x = 0; x <= 8; x++) {
        if (lnchBase[y][x]) grid[y][x] = lnchBase[y][x];
      }
    }
  }
}

function getHD_PinkBeret_V2_Torso(isGold = false) {
  const grid = makeGrid36();
  _paintV2_PB36_Torso(grid, false);
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Torso_Turn(isGold = false) {
  const grid = makeGrid36();
  _paintV2_PB36_Torso(grid, true);
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Arm_Rear(isGold = false) {
  const grid = makeGrid36();
  _paintV2_PB36_Arm_Rear(grid);
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Pistol(isGold = false) {
  const grid = makeGrid36();
  _paintV2_PB36_Pistol(grid);
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Legs(frame = 0, isGold = false) {
  const grid = makeGrid36();
  _paintV2_PB36_Legs(grid, frame);
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Launcher_Carry(isGold = false) {
  // Stage 1: Carried horizontally at waist/hip level (y=16, slope 0.0)
  const grid = makeGrid36();
  _paintV2_PB36_LauncherAtSlope(grid, 16, 0.0, false);
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Launcher_Lift(isGold = false) {
  // Stage 2: Lifting off hip at ~12° upward angle (y=14.5, slope 0.12)
  const grid = makeGrid36();
  _paintV2_PB36_LauncherAtSlope(grid, 14.5, 0.12, false);
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Launcher_Heave(isGold = false) {
  // Stage 3: Power heave across chest height at ~22° (y=12.5, slope 0.18)
  const grid = makeGrid36();
  _paintV2_PB36_LauncherAtSlope(grid, 12.5, 0.18, false);
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Launcher_Mount(isGold = false) {
  // Stage 4: Cresting onto shoulder at ~30° (y=10.5, slope 0.22)
  const grid = makeGrid36();
  _paintV2_PB36_LauncherAtSlope(grid, 10.5, 0.22, false);
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Launcher_Aim45(isGold = false) {
  // Stage 5: Settled on right shoulder (extracts the exact RPG-7 & arms from your Launcher_Fire JSON without backblast!)
  const fired = _decodeV2_PB36(_V2_PB_36_PALETTE, _V2_PB_36_LAUNCHER_FIRE_RLE).grid;
  const grid = makeGrid36();
  for (let y = 7; y <= 14; y++) {
    for (let x = 9; x <= 31; x++) {
      // Keep the RPG tube, warhead, and gripping hands while leaving face/chest open
      if (y >= 12 && x >= 14 && x <= 20) continue;
      if (fired[y][x]) grid[y][x] = fired[y][x];
    }
  }
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Launcher_Fire(isGold = false) {
  // Stage 6: The Shot! Full RPG-7 + fiery left backblast plume from your Launcher_Fire JSON
  const fired = _decodeV2_PB36(_V2_PB_36_PALETTE, _V2_PB_36_LAUNCHER_FIRE_RLE).grid;
  const grid = makeGrid36();
  for (let y = 4; y <= 14; y++) {
    for (let x = 0; x <= 31; x++) {
      if (y >= 12 && x >= 14 && x <= 20) continue;
      if (fired[y][x]) grid[y][x] = fired[y][x];
    }
  }
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Launcher_Prop(isGold = false) {
  // Standalone RPG-7 tube for ballistic discard toss
  const fired = _decodeV2_PB36(_V2_PB_36_PALETTE, _V2_PB_36_LAUNCHER_FIRE_RLE).grid;
  const grid = makeGrid36();
  for (let y = 7; y <= 11; y++) {
    for (let x = 9; x <= 31; x++) {
      if (fired[y][x]) grid[y + 7][x - 2] = fired[y][x];
    }
  }
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Stand(isGold = false) {
  // Composite Stand (Rear Arm + Stand Legs + Torso + Pistol)
  const grid = makeGrid36();
  _paintV2_PB36_Arm_Rear(grid);
  _paintV2_PB36_Legs(grid, 0);
  _paintV2_PB36_Torso(grid, false);
  _paintV2_PB36_Pistol(grid);
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Gunfire(isGold = false) {
  // Full Gunfire composite (uses your exact 36x36 Gunfire snapshot!)
  return _decodeV2_PB36(isGold ? _V2_PB_36_GOLD_PALETTE : _V2_PB_36_PALETTE, _V2_PB_36_GUNFIRE_RLE);
}

function getHD_PinkBeret_V2_Walk_Armed(frame = 1, isGold = false) {
  // Composite 6-phase Walk (for callers requesting a single baked frame)
  const phase6 = ((Math.max(1, frame) - 1) % 6) + 1;
  const grid = makeGrid36();
  _paintV2_PB36_Arm_Rear(grid);
  _paintV2_PB36_Legs(grid, phase6);
  _paintV2_PB36_Torso(grid, false);
  _paintV2_PB36_Pistol(grid);
  const res = { grid, gridSize: 36 };
  return isGold ? _recolorV2Gold36(res) : res;
}

function getHD_PinkBeret_V2_Rocket(isGold = false) {
  return _decodeV2_PB36(isGold ? _V2_PB_36_GOLD_PALETTE : _V2_PB_36_PALETTE, _V2_PB_36_LAUNCHER_FIRE_RLE);
}

// ── PINK BERET UHD NATIVE RELAUNCH & V2 SPRITE MAP ─────────────────
const _UHD_PB_SPRITE_MAP = {
  'PinkBeret_V2_Rocket': () => getHD_PinkBeret_V2_Rocket(false),
  'PinkBeretGold_V2_Rocket': () => getHD_PinkBeret_V2_Rocket(true),
  'PinkBeret_UHD_Rocket': getUHD_PinkBeret_Launcher_Aim45,
  'PinkBeretGold_UHD_Rocket': getUHD_PinkBeretGold_Launcher_Aim45,
  'PinkBeret_Rocket': () => getHD_PinkBeret_V2_Rocket(false),
  // 1. Preserved Legacy Snapshot of the first Auto-Rig (PinkBeret_V2_AutoRig_*)
  'PinkBeret_V2_AutoRig': () => getHD_PinkBeret_V2_AutoRig_Stand(false),
  'PinkBeret_V2_AutoRig_Stand': () => getHD_PinkBeret_V2_AutoRig_Stand(false),
  'PinkBeret_V2_AutoRig_Walk1': () => getHD_PinkBeret_V2_AutoRig_Walk(1, false),
  'PinkBeret_V2_AutoRig_Walk2': () => getHD_PinkBeret_V2_AutoRig_Walk(2, false),
  'PinkBeret_V2_AutoRig_Walk3': () => getHD_PinkBeret_V2_AutoRig_Walk(3, false),
  'PinkBeret_V2_AutoRig_Walk4': () => getHD_PinkBeret_V2_AutoRig_Walk(4, false),
  'PinkBeret_V2_AutoRig_Walk5': () => getHD_PinkBeret_V2_AutoRig_Walk(5, false),
  'PinkBeret_V2_AutoRig_Walk6': () => getHD_PinkBeret_V2_AutoRig_Walk(6, false),
  'PinkBeret_V2_AutoRig_Walk7': () => getHD_PinkBeret_V2_AutoRig_Walk(7, false),
  'PinkBeret_V2_AutoRig_Walk8': () => getHD_PinkBeret_V2_AutoRig_Walk(8, false),

  // 2. Pink Beret V2 (36x36 Tier M — True Multi-Layer Anatomy Rig)
  'PinkBeret_V2': () => getHD_PinkBeret_V2_Stand(false),
  'PinkBeret_V2_Stand': () => getHD_PinkBeret_V2_Stand(false),
  'PinkBeret_V2_Torso': () => getHD_PinkBeret_V2_Torso(false),
  'PinkBeret_V2_Torso_Turn': () => getHD_PinkBeret_V2_Torso_Turn(false),
  'PinkBeret_V2_Arm_Rear': () => getHD_PinkBeret_V2_Arm_Rear(false),
  'PinkBeret_V2_Pistol': () => getHD_PinkBeret_V2_Pistol(false),
  'PinkBeret_V2_Legs': () => getHD_PinkBeret_V2_Legs(0, false),
  'PinkBeret_V2_Legs_Stand': () => getHD_PinkBeret_V2_Legs(0, false),
  'PinkBeret_V2_Legs_Tap': () => getHD_PinkBeret_V2_Legs('tap', false),
  'PinkBeret_V2_Legs_Crouch': () => getHD_PinkBeret_V2_Legs('crouch', false),
  'PinkBeret_V2_Legs_Heave': () => getHD_PinkBeret_V2_Legs('heave', false),
  'PinkBeret_V2_Legs_Aim': () => getHD_PinkBeret_V2_Legs('aim', false),
  'PinkBeret_V2_Legs_Walk1': () => getHD_PinkBeret_V2_Legs(1, false),
  'PinkBeret_V2_Legs_Walk2': () => getHD_PinkBeret_V2_Legs(2, false),
  'PinkBeret_V2_Legs_Walk3': () => getHD_PinkBeret_V2_Legs(3, false),
  'PinkBeret_V2_Legs_Walk4': () => getHD_PinkBeret_V2_Legs(4, false),
  'PinkBeret_V2_Legs_Walk5': () => getHD_PinkBeret_V2_Legs(5, false),
  'PinkBeret_V2_Legs_Walk6': () => getHD_PinkBeret_V2_Legs(6, false),
  'PinkBeret_V2_Legs_Dance1': () => getHD_PinkBeret_V2_Legs('dance1', false),
  'PinkBeret_V2_Legs_Dance2': () => getHD_PinkBeret_V2_Legs('dance2', false),
  'PinkBeret_V2_Legs_Dance3': () => getHD_PinkBeret_V2_Legs('dance3', false),
  'PinkBeret_V2_Legs_Dance4': () => getHD_PinkBeret_V2_Legs('dance4', false),
  'PinkBeret_V2_Gunfire': () => getHD_PinkBeret_V2_Gunfire(false),
  'PinkBeret_V2_Launcher_Carry': () => getHD_PinkBeret_V2_Launcher_Carry(false),
  'PinkBeret_V2_Launcher_Lift': () => getHD_PinkBeret_V2_Launcher_Lift(false),
  'PinkBeret_V2_Launcher_Heave': () => getHD_PinkBeret_V2_Launcher_Heave(false),
  'PinkBeret_V2_Launcher_Mount': () => getHD_PinkBeret_V2_Launcher_Mount(false),
  'PinkBeret_V2_Launcher_Aim45': () => getHD_PinkBeret_V2_Launcher_Aim45(false),
  'PinkBeret_V2_Launcher_Fire': () => getHD_PinkBeret_V2_Launcher_Fire(false),
  'PinkBeret_V2_Launcher_Prop': () => getHD_PinkBeret_V2_Launcher_Prop(false),

  'PinkBeretGold_V2': () => getHD_PinkBeret_V2_Stand(true),
  'PinkBeretGold_V2_Stand': () => getHD_PinkBeret_V2_Stand(true),
  'PinkBeretGold_V2_Torso': () => getHD_PinkBeret_V2_Torso(true),
  'PinkBeretGold_V2_Torso_Turn': () => getHD_PinkBeret_V2_Torso_Turn(true),
  'PinkBeretGold_V2_Arm_Rear': () => getHD_PinkBeret_V2_Arm_Rear(true),
  'PinkBeretGold_V2_Pistol': () => getHD_PinkBeret_V2_Pistol(true),
  'PinkBeretGold_V2_Legs': () => getHD_PinkBeret_V2_Legs(0, true),
  'PinkBeretGold_V2_Legs_Stand': () => getHD_PinkBeret_V2_Legs(0, true),
  'PinkBeretGold_V2_Legs_Tap': () => getHD_PinkBeret_V2_Legs('tap', true),
  'PinkBeretGold_V2_Legs_Crouch': () => getHD_PinkBeret_V2_Legs('crouch', true),
  'PinkBeretGold_V2_Legs_Heave': () => getHD_PinkBeret_V2_Legs('heave', true),
  'PinkBeretGold_V2_Legs_Aim': () => getHD_PinkBeret_V2_Legs('aim', true),
  'PinkBeretGold_V2_Legs_Walk1': () => getHD_PinkBeret_V2_Legs(1, true),
  'PinkBeretGold_V2_Legs_Walk2': () => getHD_PinkBeret_V2_Legs(2, true),
  'PinkBeretGold_V2_Legs_Walk3': () => getHD_PinkBeret_V2_Legs(3, true),
  'PinkBeretGold_V2_Legs_Walk4': () => getHD_PinkBeret_V2_Legs(4, true),
  'PinkBeretGold_V2_Legs_Walk5': () => getHD_PinkBeret_V2_Legs(5, true),
  'PinkBeretGold_V2_Legs_Walk6': () => getHD_PinkBeret_V2_Legs(6, true),
  'PinkBeretGold_V2_Legs_Dance1': () => getHD_PinkBeret_V2_Legs('dance1', true),
  'PinkBeretGold_V2_Legs_Dance2': () => getHD_PinkBeret_V2_Legs('dance2', true),
  'PinkBeretGold_V2_Legs_Dance3': () => getHD_PinkBeret_V2_Legs('dance3', true),
  'PinkBeretGold_V2_Legs_Dance4': () => getHD_PinkBeret_V2_Legs('dance4', true),
  'PinkBeretGold_V2_Gunfire': () => getHD_PinkBeret_V2_Gunfire(true),
  'PinkBeretGold_V2_Launcher_Carry': () => getHD_PinkBeret_V2_Launcher_Carry(true),
  'PinkBeretGold_V2_Launcher_Lift': () => getHD_PinkBeret_V2_Launcher_Lift(true),
  'PinkBeretGold_V2_Launcher_Heave': () => getHD_PinkBeret_V2_Launcher_Heave(true),
  'PinkBeretGold_V2_Launcher_Mount': () => getHD_PinkBeret_V2_Launcher_Mount(true),
  'PinkBeretGold_V2_Launcher_Aim45': () => getHD_PinkBeret_V2_Launcher_Aim45(true),
  'PinkBeretGold_V2_Launcher_Fire': () => getHD_PinkBeret_V2_Launcher_Fire(true),
  'PinkBeretGold_V2_Launcher_Prop': () => getHD_PinkBeret_V2_Launcher_Prop(true),

  'PinkBeret': getUHD_PinkBeret,
  'PinkBeretGold': getUHD_PinkBeretGold,
  'PinkBeret_UHD': getUHD_PinkBeret,
  'PinkBeret_UHD_Stand': getUHD_PinkBeret_Stand,
  'PinkBeret_UHD_Torso': getUHD_PinkBeret_Torso,
  'PinkBeret_UHD_Torso_Turn': getUHD_PinkBeret_Torso_Turn,
  'PinkBeret_UHD_Legs': () => getUHD_PinkBeret_Legs(0),
  'PinkBeret_UHD_Legs_Stand': () => getUHD_PinkBeret_Legs(0),
  'PinkBeret_UHD_Legs_Tap': () => getUHD_PinkBeret_Legs('tap'),
  'PinkBeret_UHD_Legs_Dance1': () => getUHD_PinkBeret_Legs('dance1'),
  'PinkBeret_UHD_Legs_Dance2': () => getUHD_PinkBeret_Legs('dance2'),
  'PinkBeret_UHD_Legs_Dance3': () => getUHD_PinkBeret_Legs('dance3'),
  'PinkBeret_UHD_Legs_Dance4': () => getUHD_PinkBeret_Legs('dance4'),
  'PinkBeret_UHD_Launcher_Carry': getUHD_PinkBeret_Launcher_Carry,
  'PinkBeret_UHD_Launcher_Aim45': getUHD_PinkBeret_Launcher_Aim45,
  'PinkBeret_UHD_Launcher_Fire': getUHD_PinkBeret_Launcher_Fire,
  'PinkBeret_UHD_Launcher_Prop': getUHD_PinkBeret_Launcher_Prop,
  'PinkBeret_UHD_Gunfire': getUHD_PinkBeret_Gunfire,
  'PinkBeret_UHD_Front_Kiss': getUHD_PinkBeret_Front_Kiss,
  'PinkBeret_UHD_Front_Wink': getUHD_PinkBeret_Front_Wink,
  'PinkBeret_UHD_Front_Turn': getUHD_PinkBeret_Front_Turn,

  'PinkBeretGold_UHD': getUHD_PinkBeretGold,
  'PinkBeretGold_UHD_Stand': getUHD_PinkBeretGold_Stand,
  'PinkBeretGold_UHD_Torso': getUHD_PinkBeretGold_Torso,
  'PinkBeretGold_UHD_Torso_Turn': getUHD_PinkBeretGold_Torso_Turn,
  'PinkBeretGold_UHD_Legs': () => getUHD_PinkBeretGold_Legs(0),
  'PinkBeretGold_UHD_Legs_Stand': () => getUHD_PinkBeretGold_Legs_Stand(),
  'PinkBeretGold_UHD_Legs_Tap': () => getUHD_PinkBeretGold_Legs_Tap(),
  'PinkBeretGold_UHD_Legs_Dance1': () => getUHD_PinkBeretGold_Legs_Dance1(),
  'PinkBeretGold_UHD_Legs_Dance2': () => getUHD_PinkBeretGold_Legs_Dance2(),
  'PinkBeretGold_UHD_Legs_Dance3': () => getUHD_PinkBeretGold_Legs_Dance3(),
  'PinkBeretGold_UHD_Legs_Dance4': () => getUHD_PinkBeretGold_Legs_Dance4(),
  'PinkBeretGold_UHD_Launcher_Carry': getUHD_PinkBeretGold_Launcher_Carry,
  'PinkBeretGold_UHD_Launcher_Aim45': getUHD_PinkBeretGold_Launcher_Aim45,
  'PinkBeretGold_UHD_Launcher_Fire': getUHD_PinkBeretGold_Launcher_Fire,
  'PinkBeretGold_UHD_Launcher_Prop': getUHD_PinkBeretGold_Launcher_Prop,
  'PinkBeretGold_UHD_Gunfire': getUHD_PinkBeretGold_Gunfire,
  'PinkBeretGold_UHD_Front_Kiss': getUHD_PinkBeretGold_Front_Kiss,
  'PinkBeretGold_UHD_Front_Wink': getUHD_PinkBeretGold_Front_Wink,
  'PinkBeretGold_UHD_Front_Turn': getUHD_PinkBeretGold_Front_Turn,

  // Non-colliding standalone UHD keys directly accessible in HD mode
  'PinkBeret_Stand': getUHD_PinkBeret_Stand,
  'PinkBeret_Gunfire': getUHD_PinkBeret_Gunfire,
  'PinkBeret_Launcher_Fire': getUHD_PinkBeret_Launcher_Fire,
  'PinkBeret_Launcher_Aim45': getUHD_PinkBeret_Launcher_Aim45,
  'PinkBeret_Launcher_Prop': getUHD_PinkBeret_Launcher_Prop,
  'PinkBeret_Launcher_Carry': getUHD_PinkBeret_Launcher_Carry,
  'PinkBeret_Front_Kiss': getUHD_PinkBeret_Front_Kiss,
  'PinkBeret_Front_Wink': getUHD_PinkBeret_Front_Wink,
  'PinkBeret_Front_Turn': getUHD_PinkBeret_Front_Turn,
  'PinkBeret_Legs_Dance1': () => getUHD_PinkBeret_Legs('dance1'),
  'PinkBeret_Legs_Dance2': () => getUHD_PinkBeret_Legs('dance2'),
  'PinkBeret_Legs_Dance3': () => getUHD_PinkBeret_Legs('dance3'),
  'PinkBeret_Legs_Dance4': () => getUHD_PinkBeret_Legs('dance4'),

  'PinkBeretGold_Stand': getUHD_PinkBeretGold_Stand,
  'PinkBeretGold_Gunfire': getUHD_PinkBeretGold_Gunfire,
  'PinkBeretGold_Launcher_Fire': getUHD_PinkBeretGold_Launcher_Fire,
  'PinkBeretGold_Launcher_Aim45': getUHD_PinkBeretGold_Launcher_Aim45,
  'PinkBeretGold_Launcher_Prop': getUHD_PinkBeretGold_Launcher_Prop,
  'PinkBeretGold_Launcher_Carry': getUHD_PinkBeretGold_Launcher_Carry,
  'PinkBeretGold_Front_Kiss': getUHD_PinkBeretGold_Front_Kiss,
  'PinkBeretGold_Front_Wink': getUHD_PinkBeretGold_Front_Wink,
  'PinkBeretGold_Front_Turn': getUHD_PinkBeretGold_Front_Turn,
  'PinkBeretGold_Legs_Dance1': () => getUHD_PinkBeretGold_Legs_Dance1(),
  'PinkBeretGold_Legs_Dance2': () => getUHD_PinkBeretGold_Legs_Dance2(),
  'PinkBeretGold_Legs_Dance3': () => getUHD_PinkBeretGold_Legs_Dance3(),
  'PinkBeretGold_Legs_Dance4': () => getUHD_PinkBeretGold_Legs_Dance4()
};

for (let _i = 1; _i <= 32; _i++) {
  const _idx = _i;
  _UHD_PB_SPRITE_MAP[`PinkBeret_V2_Walk_Armed${_idx}`] = () => getHD_PinkBeret_V2_Walk_Armed(_idx, false);
  _UHD_PB_SPRITE_MAP[`PinkBeret_V2_Walk${_idx}`] = () => getHD_PinkBeret_V2_Walk_Armed(_idx, false);
  _UHD_PB_SPRITE_MAP[`PinkBeretGold_V2_Walk_Armed${_idx}`] = () => getHD_PinkBeret_V2_Walk_Armed(_idx, true);
  _UHD_PB_SPRITE_MAP[`PinkBeretGold_V2_Walk${_idx}`] = () => getHD_PinkBeret_V2_Walk_Armed(_idx, true);
  _UHD_PB_SPRITE_MAP[`PinkBeret_UHD_Walk_Armed${_idx}`] = () => getUHD_PinkBeret_Walk_Armed(_idx);
  _UHD_PB_SPRITE_MAP[`PinkBeret_UHD_Walk${_idx}`] = () => getUHD_PinkBeret_Walk(_idx);
  _UHD_PB_SPRITE_MAP[`PinkBeretGold_UHD_Walk_Armed${_idx}`] = () => getUHD_PinkBeretGold_Walk_Armed(_idx);
  _UHD_PB_SPRITE_MAP[`PinkBeretGold_UHD_Walk${_idx}`] = () => getUHD_PinkBeretGold_Walk(_idx);
  _UHD_PB_SPRITE_MAP[`PinkBeret_Walk_Armed${_idx}`] = () => getUHD_PinkBeret_Walk_Armed(_idx);
  _UHD_PB_SPRITE_MAP[`PinkBeret_Walk${_idx}`] = () => getUHD_PinkBeret_Walk(_idx);
  _UHD_PB_SPRITE_MAP[`PinkBeretGold_Walk_Armed${_idx}`] = () => getUHD_PinkBeretGold_Walk_Armed(_idx);
  _UHD_PB_SPRITE_MAP[`PinkBeretGold_Walk${_idx}`] = () => getUHD_PinkBeretGold_Walk(_idx);
}

// ── HD SPRITE REGISTRY MAP ────────────────────────────────────
// Maps unitType keys used by the engine to their corresponding 24x24 HD generators
const HD_SPRITE_REGISTRY = {
  ..._UHD_PB_SPRITE_MAP,
  // Human Hacker (24x24 HD Cyber-Mystic & 8-Armed Shiva Deity)
  'Hacker': getHD_Hacker,
  'Hacker_Kranz_Base': getHD_Hacker_Kranz_Base,
  'Hacker_Kranz_UpperArm': getHD_Hacker_Kranz_UpperArm,
  'Hacker_Kranz_MidArm': getHD_Hacker_Kranz_MidArm,
  'Hacker_ArmKranz': getHD_Hacker_ArmKranz,
  'Hacker_Legs': getHD_Hacker_Legs,
  'Hacker_Legs_Stand': getHD_Hacker_Legs,
  'Hacker_Torso': getHD_Hacker_Torso,
  'Hacker_Head': getHD_Hacker_Head,
  'Hacker_Body': getHD_Hacker_Body,
  'Hacker_Arms_Idle': getHD_Hacker_Arms_Idle,
  'Hacker_Arms_Typing': getHD_Hacker_Arms_Typing,
  'Hacker_Arms_Typing_0': () => getHD_Hacker_Arms_Typing(0),
  'Hacker_Arms_Typing_1': () => getHD_Hacker_Arms_Typing(1),
  'Hacker_Typing': getHD_Hacker_Typing,
  'Hacker_Keyboard': getHD_Hacker_Keyboard,
  'Hacker_Frontal': getHD_Hacker_Frontal,
  'Hacker_Debris': getHD_Hacker_Debris,

  // Human Hacker Gold Edition
  'HackerGold': getHD_HackerGold,
  'HackerGold_Kranz_Base': getHD_HackerGold_Kranz_Base,
  'HackerGold_Kranz_UpperArm': getHD_HackerGold_Kranz_UpperArm,
  'HackerGold_Kranz_MidArm': getHD_HackerGold_Kranz_MidArm,
  'HackerGold_ArmKranz': getHD_HackerGold_ArmKranz,
  'HackerGold_Legs': getHD_HackerGold_Legs,
  'HackerGold_Legs_Stand': getHD_HackerGold_Legs,
  'HackerGold_Torso': getHD_HackerGold_Torso,
  'HackerGold_Head': getHD_HackerGold_Head,
  'HackerGold_Body': getHD_HackerGold_Body,
  'HackerGold_Arms_Idle': getHD_HackerGold_Arms_Idle,
  'HackerGold_Arms_Typing': getHD_HackerGold_Arms_Typing,
  'HackerGold_Arms_Typing_0': () => getHD_HackerGold_Arms_Typing(0),
  'HackerGold_Arms_Typing_1': () => getHD_HackerGold_Arms_Typing(1),
  'HackerGold_Typing': getHD_HackerGold_Typing,
  'HackerGold_Keyboard': getHD_HackerGold_Keyboard,
  'HackerGold_Frontal': getHD_HackerGold_Frontal,
  'HackerGold_Debris': getHD_HackerGold_Debris,

  // Pink Beret (48x48 UHD Native Relaunch as default, 24x24 HD Classic Preserved)
  'PinkBeret': getUHD_PinkBeret,
  'PinkBeret_Torso': getHD_PinkBeret_Torso,
  'PinkBeret_Torso_Turn': getHD_PinkBeret_Torso_Turn,
  'PinkBeret_Arm_Rear': getHD_PinkBeret_Arm_Rear,
  'PinkBeret_Legs': getHD_PinkBeret_Legs,
  'PinkBeret_Legs_Stand': getHD_PinkBeret_Legs_Stand,
  'PinkBeret_Legs_Tap': getHD_PinkBeret_Legs_Tap,
  'PinkBeret_Legs_Crouch': getHD_PinkBeret_Legs_Crouch,
  'PinkBeret_Legs_Heave': getHD_PinkBeret_Legs_Heave,
  'PinkBeret_Legs_Aim': getHD_PinkBeret_Legs_Aim,
  'PinkBeret_Legs_Walk1': getHD_PinkBeret_Legs_Walk1,
  'PinkBeret_Legs_Walk2': getHD_PinkBeret_Legs_Walk2,
  'PinkBeret_Legs_Walk3': getHD_PinkBeret_Legs_Walk3,
  'PinkBeret_Legs_Walk4': getHD_PinkBeret_Legs_Walk4,
  'PinkBeret_Legs_Walk5': getHD_PinkBeret_Legs_Walk5,
  'PinkBeret_Legs_Walk6': getHD_PinkBeret_Legs_Walk6,
  'PinkBeret_Launcher_Carry': getHD_PinkBeret_Launcher_Carry,
  'PinkBeret_Launcher_Lift': getHD_PinkBeret_Launcher_Lift,
  'PinkBeret_Launcher_Heave': getHD_PinkBeret_Launcher_Heave,
  'PinkBeret_Launcher_Mount': getHD_PinkBeret_Launcher_Mount,
  'PinkBeret_Launcher_Aim45': getHD_PinkBeret_Launcher_Aim45,
  'PinkBeret_Launcher_Prop': getHD_PinkBeret_Launcher_Carry,
  'PinkBeret_Pistol': getHD_PinkBeret_Pistol,
  'PinkBeret_Kiss': getHD_PinkBeret_Kiss,
  'PinkBeret_Front_Turn': getHD_PinkBeret_Front_Turn,
  'PinkBeret_Front_Kiss': getHD_PinkBeret_Front_Kiss,
  'PinkBeret_Front_Wink': getHD_PinkBeret_Front_Wink,

  // Pink Beret Classic Aliases (Explicit non-overriding access)
  'PinkBeret_Classic': getHD_PinkBeret,
  'PinkBeret_Classic_Torso': getHD_PinkBeret_Torso,
  'PinkBeret_Classic_Torso_Turn': getHD_PinkBeret_Torso_Turn,
  'PinkBeret_Classic_Arm_Rear': getHD_PinkBeret_Arm_Rear,
  'PinkBeret_Classic_Legs': getHD_PinkBeret_Legs,
  'PinkBeret_Classic_Legs_Stand': getHD_PinkBeret_Legs_Stand,
  'PinkBeret_Classic_Legs_Tap': getHD_PinkBeret_Legs_Tap,
  'PinkBeret_Classic_Legs_Crouch': getHD_PinkBeret_Legs_Crouch,
  'PinkBeret_Classic_Legs_Heave': getHD_PinkBeret_Legs_Heave,
  'PinkBeret_Classic_Legs_Aim': getHD_PinkBeret_Legs_Aim,
  'PinkBeret_Classic_Legs_Walk1': getHD_PinkBeret_Legs_Walk1,
  'PinkBeret_Classic_Legs_Walk2': getHD_PinkBeret_Legs_Walk2,
  'PinkBeret_Classic_Legs_Walk3': getHD_PinkBeret_Legs_Walk3,
  'PinkBeret_Classic_Legs_Walk4': getHD_PinkBeret_Legs_Walk4,
  'PinkBeret_Classic_Legs_Walk5': getHD_PinkBeret_Legs_Walk5,
  'PinkBeret_Classic_Legs_Walk6': getHD_PinkBeret_Legs_Walk6,
  'PinkBeret_Classic_Launcher_Carry': getHD_PinkBeret_Launcher_Carry,
  'PinkBeret_Classic_Launcher_Lift': getHD_PinkBeret_Launcher_Lift,
  'PinkBeret_Classic_Launcher_Heave': getHD_PinkBeret_Launcher_Heave,
  'PinkBeret_Classic_Launcher_Mount': getHD_PinkBeret_Launcher_Mount,
  'PinkBeret_Classic_Launcher_Aim45': getHD_PinkBeret_Launcher_Aim45,
  'PinkBeret_Classic_Launcher_Prop': getHD_PinkBeret_Launcher_Carry,
  'PinkBeret_Classic_Pistol': getHD_PinkBeret_Pistol,
  'PinkBeret_Classic_Kiss': getHD_PinkBeret_Kiss,
  'PinkBeret_Classic_Front_Turn': getHD_PinkBeret_Front_Turn,
  'PinkBeret_Classic_Front_Kiss': getHD_PinkBeret_Front_Kiss,
  'PinkBeret_Classic_Front_Wink': getHD_PinkBeret_Front_Wink,

  // Pink Beret Gold Edition (48x48 UHD Native Relaunch as default, 24x24 HD Classic Preserved)
  'PinkBeretGold': getUHD_PinkBeretGold,
  'PinkBeretGold_Torso': getHD_PinkBeretGold_Torso,
  'PinkBeretGold_Torso_Turn': getHD_PinkBeretGold_Torso_Turn,
  'PinkBeretGold_Arm_Rear': getHD_PinkBeretGold_Arm_Rear,
  'PinkBeretGold_Legs': getHD_PinkBeretGold_Legs,
  'PinkBeretGold_Legs_Stand': getHD_PinkBeretGold_Legs_Stand,
  'PinkBeretGold_Legs_Tap': getHD_PinkBeretGold_Legs_Tap,
  'PinkBeretGold_Legs_Crouch': getHD_PinkBeretGold_Legs_Crouch,
  'PinkBeretGold_Legs_Heave': getHD_PinkBeretGold_Legs_Heave,
  'PinkBeretGold_Legs_Aim': getHD_PinkBeretGold_Legs_Aim,
  'PinkBeretGold_Legs_Walk1': getHD_PinkBeretGold_Legs_Walk1,
  'PinkBeretGold_Legs_Walk2': getHD_PinkBeretGold_Legs_Walk2,
  'PinkBeretGold_Legs_Walk3': getHD_PinkBeretGold_Legs_Walk3,
  'PinkBeretGold_Legs_Walk4': getHD_PinkBeretGold_Legs_Walk4,
  'PinkBeretGold_Legs_Walk5': getHD_PinkBeretGold_Legs_Walk5,
  'PinkBeretGold_Legs_Walk6': getHD_PinkBeretGold_Legs_Walk6,
  'PinkBeretGold_Launcher_Carry': getHD_PinkBeretGold_Launcher_Carry,
  'PinkBeretGold_Launcher_Lift': getHD_PinkBeretGold_Launcher_Lift,
  'PinkBeretGold_Launcher_Heave': getHD_PinkBeretGold_Launcher_Heave,
  'PinkBeretGold_Launcher_Mount': getHD_PinkBeretGold_Launcher_Mount,
  'PinkBeretGold_Launcher_Aim45': getHD_PinkBeretGold_Launcher_Aim45,
  'PinkBeretGold_Launcher_Prop': getHD_PinkBeretGold_Launcher_Carry,
  'PinkBeretGold_Pistol': getHD_PinkBeretGold_Pistol,
  'PinkBeretGold_Kiss': getHD_PinkBeretGold_Kiss,
  'PinkBeretGold_Front_Turn': getHD_PinkBeretGold_Front_Turn,
  'PinkBeretGold_Front_Kiss': getHD_PinkBeretGold_Front_Kiss,
  'PinkBeretGold_Front_Wink': getHD_PinkBeretGold_Front_Wink,

  // Pink Beret Gold Classic Aliases
  'PinkBeretGold_Classic': getHD_PinkBeretGold,
  'PinkBeretGold_Classic_Torso': getHD_PinkBeretGold_Torso,
  'PinkBeretGold_Classic_Torso_Turn': getHD_PinkBeretGold_Torso_Turn,
  'PinkBeretGold_Classic_Arm_Rear': getHD_PinkBeretGold_Arm_Rear,
  'PinkBeretGold_Classic_Legs': getHD_PinkBeretGold_Legs,
  'PinkBeretGold_Classic_Legs_Stand': getHD_PinkBeretGold_Legs_Stand,
  'PinkBeretGold_Classic_Legs_Tap': getHD_PinkBeretGold_Legs_Tap,
  'PinkBeretGold_Classic_Legs_Crouch': getHD_PinkBeretGold_Legs_Crouch,
  'PinkBeretGold_Classic_Legs_Heave': getHD_PinkBeretGold_Legs_Heave,
  'PinkBeretGold_Classic_Legs_Aim': getHD_PinkBeretGold_Legs_Aim,
  'PinkBeretGold_Classic_Legs_Walk1': getHD_PinkBeretGold_Legs_Walk1,
  'PinkBeretGold_Classic_Legs_Walk2': getHD_PinkBeretGold_Legs_Walk2,
  'PinkBeretGold_Classic_Legs_Walk3': getHD_PinkBeretGold_Legs_Walk3,
  'PinkBeretGold_Classic_Legs_Walk4': getHD_PinkBeretGold_Legs_Walk4,
  'PinkBeretGold_Classic_Legs_Walk5': getHD_PinkBeretGold_Legs_Walk5,
  'PinkBeretGold_Classic_Legs_Walk6': getHD_PinkBeretGold_Legs_Walk6,
  'PinkBeretGold_Classic_Launcher_Carry': getHD_PinkBeretGold_Launcher_Carry,
  'PinkBeretGold_Classic_Launcher_Lift': getHD_PinkBeretGold_Launcher_Lift,
  'PinkBeretGold_Classic_Launcher_Heave': getHD_PinkBeretGold_Launcher_Heave,
  'PinkBeretGold_Classic_Launcher_Mount': getHD_PinkBeretGold_Launcher_Mount,
  'PinkBeretGold_Classic_Launcher_Aim45': getHD_PinkBeretGold_Launcher_Aim45,
  'PinkBeretGold_Classic_Launcher_Prop': getHD_PinkBeretGold_Launcher_Carry,
  'PinkBeretGold_Classic_Pistol': getHD_PinkBeretGold_Pistol,
  'PinkBeretGold_Classic_Kiss': getHD_PinkBeretGold_Kiss,
  'PinkBeretGold_Classic_Front_Turn': getHD_PinkBeretGold_Front_Turn,
  'PinkBeretGold_Classic_Front_Kiss': getHD_PinkBeretGold_Front_Kiss,
  'PinkBeretGold_Classic_Front_Wink': getHD_PinkBeretGold_Front_Wink,
  // Hot Hand (24x24 HD Human Cyber Infiltrator)
  'HotHand': getHD_HotHand,
  'HotHand_Torso': getHD_HotHand_Torso,
  'HotHand_Hair': getHD_HotHand_Hair,
  'HotHand_Hair_Sprint': getHD_HotHand_Hair_Sprint,
  'HotHand_Hair_Sprint1': getHD_HotHand_Hair_Sprint1,
  'HotHand_Hair_Sprint2': getHD_HotHand_Hair_Sprint2,
  'HotHand_Hair_Whip': getHD_HotHand_Hair_Whip,
  'HotHand_Arm': getHD_HotHand_Arm_Guard,
  'HotHand_Arm_Rear': getHD_HotHand_Arm_Rear,
  'HotHand_Arm_Guard': getHD_HotHand_Arm_Guard,
  'HotHand_Arm_Jab': getHD_HotHand_Arm_Jab,
  'HotHand_Arm_Uppercut': getHD_HotHand_Arm_Uppercut,
  'HotHand_Arm_Slam': getHD_HotHand_Arm_Slam,
  'HotHand_Legs': getHD_HotHand_Legs,
  'HotHand_Legs_Stand': getHD_HotHand_Legs,
  'HotHand_Legs_Sprint1': getHD_HotHand_Legs_Sprint1,
  'HotHand_Legs_Sprint2': getHD_HotHand_Legs_Sprint2,
  'HotHand_Legs_Sprint3': getHD_HotHand_Legs_Sprint3,
  'HotHand_Legs_Sprint4': getHD_HotHand_Legs_Sprint4,
  'HotHand_Legs_Sprint5': getHD_HotHand_Legs_Sprint5,
  'HotHand_Legs_Sprint6': getHD_HotHand_Legs_Sprint6,
  'HotHand_Legs_Slide': getHD_HotHand_Legs_Slide,
  'HotHand_Legs_Roll1': getHD_HotHand_Legs_Roll1,
  'HotHand_Legs_Roll2': getHD_HotHand_Legs_Roll2,
  'HotHand_Legs_Roll3': getHD_HotHand_Legs_Roll3,
  'HotHand_Legs_Roll4': getHD_HotHand_Legs_Roll4,

  // Hot Hand Gold Edition
  'HotHandGold': getHD_HotHandGold,
  'HotHandGold_Torso': getHD_HotHandGold_Torso,
  'HotHandGold_Hair': getHD_HotHand_Hair,
  'HotHandGold_Hair_Sprint': getHD_HotHand_Hair_Sprint,
  'HotHandGold_Hair_Sprint1': getHD_HotHand_Hair_Sprint1,
  'HotHandGold_Hair_Sprint2': getHD_HotHand_Hair_Sprint2,
  'HotHandGold_Hair_Whip': getHD_HotHand_Hair_Whip,
  'HotHandGold_Arm': getHD_HotHandGold_Arm_Guard,
  'HotHandGold_Arm_Rear': getHD_HotHandGold_Arm_Rear,
  'HotHandGold_Arm_Guard': getHD_HotHandGold_Arm_Guard,
  'HotHandGold_Arm_Jab': getHD_HotHandGold_Arm_Jab,
  'HotHandGold_Arm_Uppercut': getHD_HotHandGold_Arm_Uppercut,
  'HotHandGold_Arm_Slam': getHD_HotHandGold_Arm_Slam,
  'HotHandGold_Legs': getHD_HotHandGold_Legs,
  'HotHandGold_Legs_Stand': getHD_HotHandGold_Legs,
  'HotHandGold_Legs_Sprint1': getHD_HotHandGold_Legs_Sprint1,
  'HotHandGold_Legs_Sprint2': getHD_HotHandGold_Legs_Sprint2,
  'HotHandGold_Legs_Sprint3': getHD_HotHandGold_Legs_Sprint3,
  'HotHandGold_Legs_Sprint4': getHD_HotHandGold_Legs_Sprint4,
  'HotHandGold_Legs_Sprint5': getHD_HotHandGold_Legs_Sprint5,
  'HotHandGold_Legs_Sprint6': getHD_HotHandGold_Legs_Sprint6,
  'HotHandGold_Legs_Slide': getHD_HotHandGold_Legs_Slide,
  'HotHandGold_Legs_Roll1': getHD_HotHandGold_Legs_Roll1,
  'HotHandGold_Legs_Roll2': getHD_HotHandGold_Legs_Roll2,
  'HotHandGold_Legs_Roll3': getHD_HotHandGold_Legs_Roll3,
  'HotHandGold_Legs_Roll4': getHD_HotHandGold_Legs_Roll4,
  'HotHand_Sprint1': getHD_HotHand_Sprint1,
  'HotHand_Sprint2': getHD_HotHand_Sprint2,
  'HotHand_Sprint3': getHD_HotHand_Sprint3,
  'HotHand_Sprint4': getHD_HotHand_Sprint4,
  'HotHand_Sprint5': getHD_HotHand_Sprint5,
  'HotHand_Sprint6': getHD_HotHand_Sprint6,
  'HotHandGold_Sprint1': getHD_HotHandGold_Sprint1,
  'HotHandGold_Sprint2': getHD_HotHandGold_Sprint2,
  'HotHandGold_Sprint3': getHD_HotHandGold_Sprint3,
  'HotHandGold_Sprint4': getHD_HotHandGold_Sprint4,
  'HotHandGold_Sprint5': getHD_HotHandGold_Sprint5,
  'HotHandGold_Sprint6': getHD_HotHandGold_Sprint6,

  // Marine
  'Marine_Legs': getHD_Marine_Legs,
  'Marine_Legs_Stand': getHD_Marine_Legs,
  'Marine_Legs_Walk1': getHD_Marine_Legs_Walk1,
  'Marine_Legs_Walk2': getHD_Marine_Legs_Walk2,
  'Marine_Legs_Walk3': getHD_Marine_Legs_Walk3,
  'Marine_Legs_Walk4': getHD_Marine_Legs_Walk4,
  'Marine_Legs_Walk5': getHD_Marine_Legs_Walk5,
  'Marine_Legs_Walk6': getHD_Marine_Legs_Walk6,
  'Marine_Torso': getHD_Marine_Torso,
  'MarineBlack_Torso': getHD_MarineBlack_Torso,
  'MarineGold_Legs': getHD_MarineGold_Legs,
  'MarineGold_Legs_Stand': getHD_MarineGold_Legs,
  'MarineGold_Legs_Walk1': getHD_MarineGold_Legs_Walk1,
  'MarineGold_Legs_Walk2': getHD_MarineGold_Legs_Walk2,
  'MarineGold_Legs_Walk3': getHD_MarineGold_Legs_Walk3,
  'MarineGold_Legs_Walk4': getHD_MarineGold_Legs_Walk4,
  'MarineGold_Legs_Walk5': getHD_MarineGold_Legs_Walk5,
  'MarineGold_Legs_Walk6': getHD_MarineGold_Legs_Walk6,
  'MarineGold_Torso': getHD_MarineGold_Torso,
  'MarineGold_Gun': getHD_Marine_Gun,
  'Marine_Gun': getHD_Marine_Gun,
  'Marine': getHD_Marine,

  // HyperMarine
  'HyperMarine_Legs': getHD_HyperMarine_Legs,
  'HyperMarine_Legs_Stand': getHD_HyperMarine_Legs,
  'HyperMarine_Legs_Walk1': getHD_HyperMarine_Legs_Walk1,
  'HyperMarine_Legs_Walk2': getHD_HyperMarine_Legs_Walk2,
  'HyperMarine_Legs_Walk3': getHD_HyperMarine_Legs_Walk3,
  'HyperMarine_Legs_Walk4': getHD_HyperMarine_Legs_Walk4,
  'HyperMarine_Legs_Walk5': getHD_HyperMarine_Legs_Walk5,
  'HyperMarine_Legs_Walk6': getHD_HyperMarine_Legs_Walk6,
  'HyperMarine_Torso': getHD_HyperMarine_Torso,
  'HyperMarine_Gun': getHD_HyperMarine_Gun,
  'HyperMarine': getHD_HyperMarine,

  // DevilPatrol
  'DevilPatrol_Legs': getHD_DevilPatrol_Legs,
  'DevilPatrol_Legs_Stand': getHD_DevilPatrol_Legs,
  'DevilPatrol_Legs_Walk1': getHD_DevilPatrol_Legs_Walk1,
  'DevilPatrol_Legs_Walk2': getHD_DevilPatrol_Legs_Walk2,
  'DevilPatrol_Legs_Walk3': getHD_DevilPatrol_Legs_Walk3,
  'DevilPatrol_Legs_Walk4': getHD_DevilPatrol_Legs_Walk4,
  'DevilPatrol_Legs_Walk5': getHD_DevilPatrol_Legs_Walk2,
  'DevilPatrol_Legs_Walk6': getHD_DevilPatrol_Legs_Walk3,
  'DevilPatrol_Torso': getHD_DevilPatrol_Torso,
  'DevilPatrol_Gun': getHD_DevilPatrol_Gun,
  'DevilPatrol': getHD_DevilPatrol,
  'DevilPatrol_Walk1': getHD_DevilPatrol_Walk1,
  'DevilPatrol_Walk2': getHD_DevilPatrol_Walk2,
  'DevilPatrol_Walk3': getHD_DevilPatrol_Walk3,
  'DevilPatrol_Walk4': getHD_DevilPatrol_Walk4,
  'DevilPatrol_Walk5': getHD_DevilPatrol_Walk5,
  'DevilPatrol_Walk6': getHD_DevilPatrol_Walk6,

  // HyperDevilPatrol
  'HyperDevilPatrol_Legs': getHD_HyperDevilPatrol_Legs,
  'HyperDevilPatrol_Legs_Stand': getHD_HyperDevilPatrol_Legs,
  'HyperDevilPatrol_Torso': getHD_HyperDevilPatrol_Torso,
  'HyperDevilPatrol_Gun': getHD_HyperDevilPatrol_Gun,
  'HyperDevilPatrol': getHD_HyperDevilPatrol,

  // Shade
  'Shade_Legs': getHD_Shade_Legs,
  'Shade_Legs_Stand': getHD_Shade_Legs,
  'Shade_Legs_Walk1': getHD_Shade_Legs_Walk1,
  'Shade_Legs_Walk2': getHD_Shade_Legs_Walk2,
  'Shade_Legs_Walk3': getHD_Shade_Legs_Walk3,
  'Shade_Legs_Walk4': getHD_Shade_Legs_Walk4,
  'Shade_Legs_Walk5': getHD_Shade_Legs_Walk5,
  'Shade_Legs_Walk6': getHD_Shade_Legs_Walk6,
  'Shade_Torso': getHD_Shade_Torso,
  'Shade_Gun': getHD_Shade_Gun,
  'Shade': getHD_Shade,

  // HyperShade
  'HyperShade_Legs': getHD_HyperShade_Legs,
  'HyperShade_Legs_Stand': getHD_HyperShade_Legs,
  'HyperShade_Legs_Walk1': getHD_HyperShade_Legs_Walk1,
  'HyperShade_Legs_Walk2': getHD_HyperShade_Legs_Walk2,
  'HyperShade_Legs_Walk3': getHD_HyperShade_Legs_Walk3,
  'HyperShade_Legs_Walk4': getHD_HyperShade_Legs_Walk4,
  'HyperShade_Legs_Walk5': getHD_HyperShade_Legs_Walk5,
  'HyperShade_Legs_Walk6': getHD_HyperShade_Legs_Walk6,
  'HyperShade_Torso': getHD_HyperShade_Torso,
  'HyperShade_Gun': getHD_HyperShade_Gun,
  'HyperShade': getHD_HyperShade,

  // TeslaWalker
  'TeslaWalker_Legs': getHD_TeslaWalker_Legs,
  'TeslaWalker_Legs_Stand': getHD_TeslaWalker_Legs,
  'TeslaWalker_Legs_Walk1': getHD_TeslaWalker_Legs_Walk1,
  'TeslaWalker_Legs_Walk2': getHD_TeslaWalker_Legs_Walk2,
  'TeslaWalker_Legs_Walk3': getHD_TeslaWalker_Legs_Walk3,
  'TeslaWalker_Legs_Walk4': getHD_TeslaWalker_Legs_Walk4,
  'TeslaWalker_Chassis': getHD_TeslaWalker_Chassis,
  'TeslaWalker_Tesla': getHD_TeslaWalker_Tesla,
  'TeslaWalker': getHD_TeslaWalker,
  'TeslaWalker_Walk1': getHD_TeslaWalker_Walk1,
  'TeslaWalker_Walk2': getHD_TeslaWalker_Walk2,
  'TeslaWalker_Walk3': getHD_TeslaWalker_Walk3,
  'TeslaWalker_Walk4': getHD_TeslaWalker_Walk4,

  // HyperTeslaWalker
  'HyperTeslaWalker_Legs': getHD_HyperTeslaWalker_Legs,
  'HyperTeslaWalker_Legs_Stand': getHD_HyperTeslaWalker_Legs,
  'HyperTeslaWalker_Legs_Walk1': getHD_HyperTeslaWalker_Legs_Walk1,
  'HyperTeslaWalker_Legs_Walk2': getHD_HyperTeslaWalker_Legs_Walk2,
  'HyperTeslaWalker_Legs_Walk3': getHD_HyperTeslaWalker_Legs_Walk3,
  'HyperTeslaWalker_Legs_Walk4': getHD_HyperTeslaWalker_Legs_Walk4,
  'HyperTeslaWalker_Chassis': getHD_HyperTeslaWalker_Chassis,
  'HyperTeslaWalker_Tail': getHD_HyperTeslaWalker_Tail,
  'HyperTeslaWalker_Claw': getHD_HyperTeslaWalker_Claw,
  'HyperTeslaWalker_Claw_Rest': getHD_HyperTeslaWalker_Claw,
  'HyperTeslaWalker_Claw_Grab': getHD_HyperTeslaWalker_Claw_Grab,
  'HyperTeslaWalker_Claw_Lift': getHD_HyperTeslaWalker_Claw_Lift,
  'HyperTeslaWalker': getHD_HyperTeslaWalker,

  // WheelieBomber
  'WheelieBomber_Bike': () => getHD_WheelieBomber_Bike(0),
  'WheelieBomber_Bike_Stand': () => getHD_WheelieBomber_Bike(0),
  'WheelieBomber_Bike_Roll1': getHD_WheelieBomber_Bike_Roll1,
  'WheelieBomber_Bike_Roll2': getHD_WheelieBomber_Bike_Roll2,
  'WheelieBomber_Bike_Roll3': getHD_WheelieBomber_Bike_Roll3,
  'WheelieBomber_Bike_Wheelie1': () => getHD_WheelieBomber_Bike_Wheelie1(0),
  'WheelieBomber_Bike_Wheelie1_Roll1': getHD_WheelieBomber_Bike_Wheelie1_Roll1,
  'WheelieBomber_Bike_Wheelie1_Roll2': getHD_WheelieBomber_Bike_Wheelie1_Roll2,
  'WheelieBomber_Bike_Wheelie1_Roll3': getHD_WheelieBomber_Bike_Wheelie1_Roll3,
  'WheelieBomber_Bike_Wheelie2': () => getHD_WheelieBomber_Bike_Wheelie2(0),
  'WheelieBomber_Bike_Wheelie2_Roll1': getHD_WheelieBomber_Bike_Wheelie2_Roll1,
  'WheelieBomber_Bike_Wheelie2_Roll2': getHD_WheelieBomber_Bike_Wheelie2_Roll2,
  'WheelieBomber_Bike_Wheelie2_Roll3': getHD_WheelieBomber_Bike_Wheelie2_Roll3,
  'WheelieBomber_Rider': getHD_WheelieBomber_Rider,
  'WheelieBomber': getHD_WheelieBomber,

  // Panzer
  'Panzer_Chassis': () => getHD_Panzer_Chassis(0),
  'Panzer_Chassis_Stand': () => getHD_Panzer_Chassis(0),
  'Panzer_Chassis_Roll1': getHD_Panzer_Chassis_Roll1,
  'Panzer_Chassis_Roll2': getHD_Panzer_Chassis_Roll2,
  'Panzer_Chassis_Roll3': getHD_Panzer_Chassis_Roll3,
  'Panzer_Roll1': getHD_Panzer_Roll1,
  'Panzer_Roll2': getHD_Panzer_Roll2,
  'Panzer_Roll3': getHD_Panzer_Roll3,
  'Panzer_Turret': getHD_Panzer_Turret,
  'Panzer': getHD_Panzer,

  // SiegeTank (Panzer Aliases)
  'SiegeTank_Chassis': () => getHD_Panzer_Chassis(0),
  'SiegeTank_Chassis_Stand': () => getHD_Panzer_Chassis(0),
  'SiegeTank_Chassis_Roll1': getHD_Panzer_Chassis_Roll1,
  'SiegeTank_Chassis_Roll2': getHD_Panzer_Chassis_Roll2,
  'SiegeTank_Chassis_Roll3': getHD_Panzer_Chassis_Roll3,
  'SiegeTank_Roll1': getHD_Panzer_Roll1,
  'SiegeTank_Roll2': getHD_Panzer_Roll2,
  'SiegeTank_Roll3': getHD_Panzer_Roll3,
  'SiegeTank_Turret': getHD_Panzer_Turret,
  'SiegeTank': getHD_Panzer,

  // Hyper Panzer
  'HyperPanzer_Chassis': () => getHD_HyperPanzer_Chassis(0),
  'HyperPanzer_Chassis_Stand': () => getHD_HyperPanzer_Chassis(0),
  'HyperPanzer_Chassis_Roll1': getHD_HyperPanzer_Chassis_Roll1,
  'HyperPanzer_Chassis_Roll2': getHD_HyperPanzer_Chassis_Roll2,
  'HyperPanzer_Chassis_Roll3': getHD_HyperPanzer_Chassis_Roll3,
  'HyperPanzer_Roll1': getHD_HyperPanzer_Roll1,
  'HyperPanzer_Roll2': getHD_HyperPanzer_Roll2,
  'HyperPanzer_Roll3': getHD_HyperPanzer_Roll3,
  'HyperPanzer_Turret': getHD_HyperPanzer_Turret,
  'HyperPanzer_Turret_Straight': getHD_HyperPanzer_Turret_Straight,
  'HyperPanzer_Turret_Left': getHD_HyperPanzer_Turret_Left,
  'HyperPanzer_Turret_Right': getHD_HyperPanzer_Turret_Right,
  'HyperPanzer_Turret_Up': getHD_HyperPanzer_Turret_Up,
  'HyperPanzer_Turret_Down': getHD_HyperPanzer_Turret_Down,
  'HyperPanzer': getHD_HyperPanzer,

  // Hyper Panzer Aliases
  'Hyper_Panzer_Chassis': () => getHD_HyperPanzer_Chassis(0),
  'Hyper_Panzer_Chassis_Stand': () => getHD_HyperPanzer_Chassis(0),
  'Hyper_Panzer_Chassis_Roll1': getHD_HyperPanzer_Chassis_Roll1,
  'Hyper_Panzer_Chassis_Roll2': getHD_HyperPanzer_Chassis_Roll2,
  'Hyper_Panzer_Chassis_Roll3': getHD_HyperPanzer_Chassis_Roll3,
  'Hyper_Panzer_Roll1': getHD_HyperPanzer_Roll1,
  'Hyper_Panzer_Roll2': getHD_HyperPanzer_Roll2,
  'Hyper_Panzer_Roll3': getHD_HyperPanzer_Roll3,
  'Hyper_Panzer_Turret': getHD_HyperPanzer_Turret,
  'Hyper_Panzer_Turret_Straight': getHD_HyperPanzer_Turret_Straight,
  'Hyper_Panzer_Turret_Left': getHD_HyperPanzer_Turret_Left,
  'Hyper_Panzer_Turret_Right': getHD_HyperPanzer_Turret_Right,
  'Hyper_Panzer_Turret_Up': getHD_HyperPanzer_Turret_Up,
  'Hyper_Panzer_Turret_Down': getHD_HyperPanzer_Turret_Down,
  'Hyper_Panzer': getHD_HyperPanzer,

  // Orchestra
  'Orchestra_Chassis': () => getHD_Orchestra_Chassis(0),
  'Orchestra_Chassis_Stand': () => getHD_Orchestra_Chassis(0),
  'Orchestra_Chassis_Roll1': getHD_Orchestra_Chassis_Roll1,
  'Orchestra_Chassis_Roll2': getHD_Orchestra_Chassis_Roll2,
  'Orchestra_Chassis_Roll3': getHD_Orchestra_Chassis_Roll3,
  'Orchestra_Chassis_Roll4': getHD_Orchestra_Chassis_Roll4,
  'Orchestra_Chassis_Roll5': getHD_Orchestra_Chassis_Roll5,
  'Orchestra_Chassis_Roll6': getHD_Orchestra_Chassis_Roll6,
  'Orchestra_Roll1': getHD_Orchestra_Roll1,
  'Orchestra_Roll2': getHD_Orchestra_Roll2,
  'Orchestra_Roll3': getHD_Orchestra_Roll3,
  'Orchestra_Roll4': getHD_Orchestra_Roll4,
  'Orchestra_Roll5': getHD_Orchestra_Roll5,
  'Orchestra_Roll6': getHD_Orchestra_Roll6,
  'Orchestra_Aim': getHD_Orchestra_Aim,
  'Orchestra_Launcher': getHD_Orchestra_Launcher,
  'Orchestra': getHD_Orchestra,

  // TheSalvageCompany
  'TheSalvageCompany_Chassis': () => getHD_TheSalvageCompany_Chassis(0),
  'TheSalvageCompany_Chassis_Stand': () => getHD_TheSalvageCompany_Chassis(0),
  'TheSalvageCompany_Chassis_Roll1': getHD_TheSalvageCompany_Chassis_Roll1,
  'TheSalvageCompany_Chassis_Roll2': getHD_TheSalvageCompany_Chassis_Roll2,
  'TheSalvageCompany_Chassis_Roll3': getHD_TheSalvageCompany_Chassis_Roll3,
  'TheSalvageCompany_Chassis_Roll4': getHD_TheSalvageCompany_Chassis_Roll4,
  'TheSalvageCompany_Chassis_Roll5': getHD_TheSalvageCompany_Chassis_Roll5,
  'TheSalvageCompany_Chassis_Roll6': getHD_TheSalvageCompany_Chassis_Roll6,
  'TheSalvageCompany_Roll1': getHD_TheSalvageCompany_Roll1,
  'TheSalvageCompany_Roll2': getHD_TheSalvageCompany_Roll2,
  'TheSalvageCompany_Roll3': getHD_TheSalvageCompany_Roll3,
  'TheSalvageCompany_Roll4': getHD_TheSalvageCompany_Roll4,
  'TheSalvageCompany_Roll5': getHD_TheSalvageCompany_Roll5,
  'TheSalvageCompany_Roll6': getHD_TheSalvageCompany_Roll6,
  'TheSalvageCompany_Arm_Rest': getHD_TheSalvageCompany_Arm_Rest,
  'TheSalvageCompany_Arm_Reach': getHD_TheSalvageCompany_Arm_Reach,
  'TheSalvageCompany_Arm_Grab': getHD_TheSalvageCompany_Arm_Grab,
  'TheSalvageCompany_Arm_Lift': getHD_TheSalvageCompany_Arm_Lift,
  'TheSalvageCompany_Arm_Dump': getHD_TheSalvageCompany_Arm_Dump,
  'TheSalvageCompany_Arm_Raise': getHD_TheSalvageCompany_Arm_Raise,
  'TheSalvageCompany_Arm_SwingFwd': getHD_TheSalvageCompany_Arm_SwingFwd,
  'TheSalvageCompany_Arm_Lower': getHD_TheSalvageCompany_Arm_Lower,
  'TheSalvageCompany_Arm_SwingBack': getHD_TheSalvageCompany_Arm_SwingBack,
  'TheSalvageCompany_Arm_Hover': getHD_TheSalvageCompany_Arm_Hover,
  'TheSalvageCompany_Arm_Fold': getHD_TheSalvageCompany_Arm_Fold,
  'TheSalvageCompany': getHD_TheSalvageCompany,

  // Rocketship
  'Rocketship': getHD_Rocketship,

  // A9Piranha
  'A9Piranha_Hull': getHD_A9Piranha_Hull,
  'A9Piranha_Rotor': getHD_A9Piranha_Rotor,
  'A9Piranha': getHD_A9Piranha,
  'A9Piranha_Spin1': getHD_A9Piranha_Spin1,
  'A9Piranha_Spin2': getHD_A9Piranha_Spin2,
  'A9Piranha_Spin3': getHD_A9Piranha_Spin3,
  'A9Piranha_Spin4': getHD_A9Piranha_Spin4,

  // A9Pigeon
  'A9Pigeon_Hull': getHD_A9Pigeon_Hull,
  'A9Pigeon_Engine_Horiz': getHD_A9Pigeon_Engine_Horiz,
  'A9Pigeon_Engine_Diag': getHD_A9Pigeon_Engine_Diag,
  'A9Pigeon_Engine_Vert': getHD_A9Pigeon_Engine_Vert,
  'A9Pigeon_Gatling_Spin1': getHD_A9Pigeon_Gatling_Spin1,
  'A9Pigeon_Gatling_Spin2': getHD_A9Pigeon_Gatling_Spin2,
  'A9Pigeon_Bomb': getHD_A9Pigeon_Bomb,
  'A9Pigeon_Bird_Flap1': getHD_A9Pigeon_Bird_Flap1,
  'A9Pigeon_Bird_Flap2': getHD_A9Pigeon_Bird_Flap2,
  'A9Pigeon_Bird_Flap3': getHD_A9Pigeon_Bird_Flap3,
  'A9Pigeon_Bird_BackFlap1': getHD_A9Pigeon_Bird_BackFlap1,
  'A9Pigeon_Bird_BackFlap2': getHD_A9Pigeon_Bird_BackFlap2,
  'A9Pigeon_Bird_BackFlap3': getHD_A9Pigeon_Bird_BackFlap3,
  'A9Pigeon_Bird_Perched': getHD_A9Pigeon_Bird_Perched,
  'A9Pigeon_Bird_Peck': getHD_A9Pigeon_Bird_Peck,
  'A9Pigeon_Pilot_Flap1': getHD_A9Pigeon_Pilot_Flap1,
  'A9Pigeon_Pilot_Flap2': getHD_A9Pigeon_Pilot_Flap2,
  'A9Pigeon_Pilot_Flap3': getHD_A9Pigeon_Pilot_Flap3,
  'A9Pigeon_Pilot_BackFlap1': getHD_A9Pigeon_Pilot_BackFlap1,
  'A9Pigeon_Pilot_BackFlap2': getHD_A9Pigeon_Pilot_BackFlap2,
  'A9Pigeon_Pilot_BackFlap3': getHD_A9Pigeon_Pilot_BackFlap3,
  'A9Pigeon_Pilot_Perched': getHD_A9Pigeon_Pilot_Perched,
  'A9Pigeon_Pilot_Peck': getHD_A9Pigeon_Pilot_Peck,
  'A9Pigeon_Bird_Threat1': getHD_A9Pigeon_Bird_Threat1,
  'A9Pigeon_Bird_Threat2': getHD_A9Pigeon_Bird_Threat2,
  'A9Pigeon_Bird_Threat_Puff': getHD_A9Pigeon_Bird_Threat_Puff,
  'A9Pigeon_Bird_Threat_Bob': getHD_A9Pigeon_Bird_Threat_Bob,
  'A9Pigeon_Bird_Threat_WingStretch': getHD_A9Pigeon_Bird_Threat_WingStretch,
  'A9Pigeon_Bird_Threat_Alert': getHD_A9Pigeon_Bird_Threat_Alert,
  'A9Pigeon_Pilot_Threat1': getHD_A9Pigeon_Pilot_Threat1,
  'A9Pigeon_Pilot_Threat2': getHD_A9Pigeon_Pilot_Threat2,
  'A9Pigeon_Pilot_Threat_Puff': getHD_A9Pigeon_Pilot_Threat_Puff,
  'A9Pigeon_Pilot_Threat_Bob': getHD_A9Pigeon_Pilot_Threat_Bob,
  'A9Pigeon_Pilot_Threat_WingStretch': getHD_A9Pigeon_Pilot_Threat_WingStretch,
  'A9Pigeon_Pilot_Threat_Alert': getHD_A9Pigeon_Pilot_Threat_Alert,
  'A9Pigeon': getHD_A9Pigeon,
  'A9_Pigeon': getHD_A9Pigeon,
  'A9 Pigeon': getHD_A9Pigeon,

  // A9Grizzly
  'A9Grizzly_Chassis': () => getHD_A9Grizzly_Chassis(0),
  'A9Grizzly_Chassis_Stand': () => getHD_A9Grizzly_Chassis(0),
  'A9Grizzly_Chassis_Roll1': getHD_A9Grizzly_Chassis_Roll1,
  'A9Grizzly_Chassis_Roll2': getHD_A9Grizzly_Chassis_Roll2,
  'A9Grizzly_Chassis_Roll3': getHD_A9Grizzly_Chassis_Roll3,
  'A9Grizzly_Chassis_Roll4': getHD_A9Grizzly_Chassis_Roll4,
  'A9Grizzly_Chassis_Roll5': getHD_A9Grizzly_Chassis_Roll5,
  'A9Grizzly_Chassis_Roll6': getHD_A9Grizzly_Chassis_Roll6,
  'A9Grizzly_Chassis_Roll7': getHD_A9Grizzly_Chassis_Roll7,
  'A9Grizzly_Chassis_Roll8': getHD_A9Grizzly_Chassis_Roll8,
  'A9Grizzly_Roll1': getHD_A9Grizzly_Roll1,
  'A9Grizzly_Roll2': getHD_A9Grizzly_Roll2,
  'A9Grizzly_Roll3': getHD_A9Grizzly_Roll3,
  'A9Grizzly_Roll4': getHD_A9Grizzly_Roll4,
  'A9Grizzly_Roll5': getHD_A9Grizzly_Roll5,
  'A9Grizzly_Roll6': getHD_A9Grizzly_Roll6,
  'A9Grizzly_Roll7': getHD_A9Grizzly_Roll7,
  'A9Grizzly_Roll8': getHD_A9Grizzly_Roll8,
  'A9Grizzly_Radar': () => getHD_A9Grizzly_Radar(0),
  'A9Grizzly_Radar_Rot1': getHD_A9Grizzly_Radar_Rot1,
  'A9Grizzly_Radar_Rot2': getHD_A9Grizzly_Radar_Rot2,
  'A9Grizzly_Radar_Rot3': getHD_A9Grizzly_Radar_Rot3,
  'A9Grizzly_Radar_Rot4': getHD_A9Grizzly_Radar_Rot4,
  'A9Grizzly_Radar_Rot5': getHD_A9Grizzly_Radar_Rot5,
  'A9Grizzly_Radar_Rot6': getHD_A9Grizzly_Radar_Rot6,
  'A9Grizzly_Turret': getHD_A9Grizzly_Turret,
  'A9Grizzly': getHD_A9Grizzly,
  'A9_Grizzly': getHD_A9Grizzly,
  'A9 Grizzly': getHD_A9Grizzly,

  // DeployableCannon
  'DeployableCannon_Base': getHD_DeployableCannon_Base,
  'DeployableCannon_Turret': getHD_DeployableCannon_Turret,
  'DeployableCannon': getHD_DeployableCannon,
  'Deployable_Cannon': getHD_DeployableCannon,
  'Deployable Cannon': getHD_DeployableCannon,

  // Parachutes
  'Marine_Parachute': getHD_Marine_Parachute,
  'MarineGold_Parachute': getHD_MarineGold_Parachute,
  'Shade_Parachute': getHD_Shade_Parachute,

  // Sul Enforcer Vulture
  'EnforcerVulture': getHD_EnforcerVulture,
  'Enforcer_Vulture': getHD_EnforcerVulture,
  'Enforcer Vulture': getHD_EnforcerVulture,
  'EnforcerVulture_Body': getHD_EnforcerVulture_Body,
  'EnforcerVulture_Head': getHD_EnforcerVulture_Head,

  // Sul Looting Vulture
  'LootingVulture': getHD_LootingVulture,
  'Looting_Vulture': getHD_LootingVulture,
  'Looting Vulture': getHD_LootingVulture,
  'LootingVulture_Body': getHD_LootingVulture_Body,
  'LootingVulture_Pyramid': getHD_LootingVulture_Pyramid,
  'LootingVulture_Head': getHD_LootingVulture_Head,
  'LootingVulture_Tail': getHD_LootingVulture_Tail,

  // Sul Parasite Vulture
  'ParasiteVulture': getHD_ParasiteVulture,
  'Parasite_Vulture': getHD_ParasiteVulture,
  'Parasite Vulture': getHD_ParasiteVulture,
  'ParasiteVulture_Flap1': getHD_ParasiteVulture_Flap1,
  'ParasiteVulture_Flap2': getHD_ParasiteVulture_Flap2,
  'ParasiteVulture_Flap3': getHD_ParasiteVulture_Flap3,
  'ParasiteVulture_Empty_Flap1': getHD_ParasiteVulture_Empty_Flap1,
  'ParasiteVulture_Empty_Flap2': getHD_ParasiteVulture_Empty_Flap2,
  'ParasiteVulture_Empty_Flap3': getHD_ParasiteVulture_Empty_Flap3,
  'ParasiteVulture_Empty': () => getHD_ParasiteVulture(false),
  'Parasite_Vulture_Empty': () => getHD_ParasiteVulture(false),
  'Parasite Vulture Empty': () => getHD_ParasiteVulture(false),
  'ParasiteVulture_Body': getHD_ParasiteVulture_Body,
  'ParasiteVulture_Body_Empty': getHD_ParasiteVulture_Body_Empty,
  'ParasiteVulture_Wing': getHD_ParasiteVulture_Wing,
  'ParasiteVulture_Wing_Injured': getHD_ParasiteVulture_Wing_Injured,
  'ParasiteVulture_Head': getHD_ParasiteVulture_Head,
  'ParasiteVulture_Head_Injured': getHD_ParasiteVulture_Head_Injured,
  'ParasiteVulture_Parasite': getHD_ParasiteVulture_Parasite,

  // Sul Anti Shade
  'AntiShade': getHD_AntiShade,
  'Anti_Shade': getHD_AntiShade,
  'Anti Shade': getHD_AntiShade,
  'AntiShade_Walk1': getHD_AntiShade_Walk1,
  'AntiShade_Walk2': getHD_AntiShade_Walk2,
  'AntiShade_Walk3': getHD_AntiShade_Walk3,
  'AntiShade_Walk4': getHD_AntiShade_Walk4,
  'AntiShade_Walk5': getHD_AntiShade_Walk5,
  'AntiShade_Walk6': getHD_AntiShade_Walk6,
  'AntiShade_Torso': getHD_AntiShade_Torso,
  'AntiShade_Base': getHD_AntiShade_Base,
  'AntiShade_Base_Stand': getHD_AntiShade_Base,
  'AntiShade_Base_Walk1': getHD_AntiShade_Base_Walk1,
  'AntiShade_Base_Walk2': getHD_AntiShade_Base_Walk2,
  'AntiShade_Base_Walk3': getHD_AntiShade_Base_Walk3,
  'AntiShade_Base_Walk4': getHD_AntiShade_Base_Walk4,
  'AntiShade_Base_Walk5': getHD_AntiShade_Base_Walk5,
  'AntiShade_Base_Walk6': getHD_AntiShade_Base_Walk6,
  'AntiShade_Blade': getHD_AntiShade_Blade,

  // Sul Pulp
  'Pulp': getHD_Pulp,
  'Pulp_Body': getHD_Pulp_Body,
  'Pulp_Torso': getHD_Pulp_Body,
  'Pulp_Head': getHD_Pulp_Head,
  'Pulp_Weapon': getHD_Pulp_Weapon,
  'Pulp_Legs': getHD_Pulp_Legs_Walk1,
  'Pulp_Legs_Stand': getHD_Pulp_Legs_Walk1,
  'Pulp_Legs_Walk1': getHD_Pulp_Legs_Walk1,
  'Pulp_Legs_Walk2': getHD_Pulp_Legs_Walk2,
  'Pulp_Legs_Walk3': getHD_Pulp_Legs_Walk3,
  'Pulp_Legs_Walk4': getHD_Pulp_Legs_Walk4,
  'Pulp_Legs_Walk5': getHD_Pulp_Legs_Walk5,
  'Pulp_Legs_Walk6': getHD_Pulp_Legs_Walk6,
  'Pulp_Hop1': getHD_Pulp_Hop1,
  'Pulp_Hop2': getHD_Pulp_Hop2,
  'Pulp_Hop3': getHD_Pulp_Hop3,
  'Pulp_Hop4': getHD_Pulp_Hop4,
  'Pulp_Hop5': getHD_Pulp_Hop5,
  'Pulp_Hop6': getHD_Pulp_Hop6,

  // Sul Preserver Lock (48x48 UHD Tier L Hexapod Titan)
  'PreserverLock': () => getHD_PreserverLock(0),
  'Preserver_Lock': () => getHD_PreserverLock(0),
  'Preserver Lock': () => getHD_PreserverLock(0),
  'PreserverLock_Walk1': getHD_PreserverLock_Walk1,
  'PreserverLock_Walk2': getHD_PreserverLock_Walk2,
  'PreserverLock_Walk3': getHD_PreserverLock_Walk3,
  'PreserverLock_Walk4': getHD_PreserverLock_Walk4,
  'PreserverLock_Carapace': getHD_PreserverLock_Carapace,
  'PreserverLock_Tower': () => getHD_PreserverLock_Tower(0),
  'PreserverLock_Tower_Stand': getHD_PreserverLock_Tower_Stand,
  'PreserverLock_Tower_Walk1': getHD_PreserverLock_Tower_Walk1,
  'PreserverLock_Tower_Walk2': getHD_PreserverLock_Tower_Walk2,
  'PreserverLock_Tower_Walk3': getHD_PreserverLock_Tower_Walk3,
  'PreserverLock_Tower_Walk4': getHD_PreserverLock_Tower_Walk4,
  'PreserverLock_Legs': getHD_PreserverLock_Legs_Stand,
  'PreserverLock_Legs_Stand': getHD_PreserverLock_Legs_Stand,
  'PreserverLock_Legs_Walk1': getHD_PreserverLock_Legs_Walk1,
  'PreserverLock_Legs_Walk2': getHD_PreserverLock_Legs_Walk2,
  'PreserverLock_Legs_Walk3': getHD_PreserverLock_Legs_Walk3,
  'PreserverLock_Legs_Walk4': getHD_PreserverLock_Legs_Walk4,
  'PreserverLock_Body': () => getHD_PreserverLock_Body(0),
  'PreserverLock_Body_Walk1': getHD_PreserverLock_Body_Walk1,
  'PreserverLock_Body_Walk2': getHD_PreserverLock_Body_Walk2,
  'PreserverLock_Body_Walk3': getHD_PreserverLock_Body_Walk3,
  'PreserverLock_Body_Walk4': getHD_PreserverLock_Body_Walk4,

  // Sul Bastion Lock (36×36 HD Tier M)
  'BastionLock': () => getHD_BastionLock(0),
  'Bastion_Lock': () => getHD_BastionLock(0),
  'Bastion Lock': () => getHD_BastionLock(0),
  'BastionLock_Walk1': getHD_BastionLock_Walk1,
  'BastionLock_Walk2': getHD_BastionLock_Walk2,
  'BastionLock_Walk3': getHD_BastionLock_Walk3,
  'BastionLock_Walk4': getHD_BastionLock_Walk4,
  'BastionLock_Deployed': getHD_BastionLock_Deployed,
  'BastionLock_Body': () => getHD_BastionLock_Body(false),
  'BastionLock_Body_Deployed': () => getHD_BastionLock_Body(true),
  'BastionLock_Shield_Back': () => getHD_BastionLock_Shield_Back(false),
  'BastionLock_Shield_Back_Deployed': () => getHD_BastionLock_Shield_Back(true),
  'BastionLock_Shield_Front': () => getHD_BastionLock_Shield_Front(false),
  'BastionLock_Shield_Front_Deployed': () => getHD_BastionLock_Shield_Front(true),
  'BastionLock_Legs': getHD_BastionLock_Legs_Stand,
  'BastionLock_Legs_Stand': getHD_BastionLock_Legs_Stand,
  'BastionLock_Legs_Walk1': getHD_BastionLock_Legs_Walk1,
  'BastionLock_Legs_Walk2': getHD_BastionLock_Legs_Walk2,
  'BastionLock_Legs_Walk3': getHD_BastionLock_Legs_Walk3,
  'BastionLock_Legs_Walk4': getHD_BastionLock_Legs_Walk4,

  // Human Stickman (48×48 UHD Native Relaunch)
  'Stickman': getHD_Stickman,
  'Stickman_Walk1': getHD_Stickman_Walk1,
  'Stickman_Walk2': getHD_Stickman_Walk2,
  'Stickman_Walk3': getHD_Stickman_Walk3,
  'Stickman_Walk4': getHD_Stickman_Walk4,
  'Stickman_Walk5': getHD_Stickman_Walk5,
  'Stickman_Walk6': getHD_Stickman_Walk6,
  'Stickman_Walk7': getHD_Stickman_Walk7,
  'Stickman_Walk8': getHD_Stickman_Walk8,
  'Stickman_Legs': getHD_Stickman_Legs,
  'Stickman_Legs_Stand': getHD_Stickman_Legs,
  'Stickman_Legs_Walk1': getHD_Stickman_Legs_Walk1,
  'Stickman_Legs_Walk2': getHD_Stickman_Legs_Walk2,
  'Stickman_Legs_Walk3': getHD_Stickman_Legs_Walk3,
  'Stickman_Legs_Walk4': getHD_Stickman_Legs_Walk4,
  'Stickman_Legs_Walk5': getHD_Stickman_Legs_Walk5,
  'Stickman_Legs_Walk6': getHD_Stickman_Legs_Walk6,
  'Stickman_Legs_Walk7': getHD_Stickman_Legs_Walk7,
  'Stickman_Legs_Walk8': getHD_Stickman_Legs_Walk8,
  'Stickman_Legs_Kneeling': getHD_Stickman_Legs_Kneeling,
  'Stickman_Chassis': getHD_Stickman_Chassis,
  'Stickman_Torso': getHD_Stickman_Torso,
  'Stickman_Cannon': getHD_Stickman_Cannon,
  'Stickman_Obstacle': getHD_Stickman_Obstacle,
  'Stickman_Obstacle_1': getHD_Stickman_Obstacle_1,
  'Stickman_Obstacle_2': getHD_Stickman_Obstacle_2,
  'Stickman_Obstacle_3': getHD_Stickman_Obstacle_3,
  'Stickman_Kneeling': getHD_Stickman_Obstacle,
  'Stickman_Kneeling_1': getHD_Stickman_Obstacle_1,
  'Stickman_Kneeling_2': getHD_Stickman_Obstacle_2,
  'Stickman_Kneeling_3': getHD_Stickman_Obstacle_3
};

// ── UHD (48x48) SCALING ALGORITHMS & REGISTRY ─────────────────

export function upscaleGrid2x(data) {
  if (!data || !data.grid) return null;
  const { grid, gridSize } = data;
  const newG = gridSize * 2;
  const newGrid = Array.from({ length: newG }, () => Array(newG).fill(null));
  for (let y = 0; y < gridSize; y++) {
    for (let x = 0; x < gridSize; x++) {
      const c = grid[y][x];
      if (!c) continue;
      newGrid[y * 2][x * 2] = c;
      newGrid[y * 2][x * 2 + 1] = c;
      newGrid[y * 2 + 1][x * 2] = c;
      newGrid[y * 2 + 1][x * 2 + 1] = c;
    }
  }
  return { grid: newGrid, gridSize: newG };
}

export function upscaleGridEPX(data) {
  if (!data || !data.grid) return null;
  const { grid, gridSize } = data;
  const newG = gridSize * 2;
  const newGrid = Array.from({ length: newG }, () => Array(newG).fill(null));
  for (let y = 0; y < gridSize; y++) {
    for (let x = 0; x < gridSize; x++) {
      const P = grid[y][x];
      const A = y > 0 ? grid[y - 1][x] : null;
      const B = x < gridSize - 1 ? grid[y][x + 1] : null;
      const C = y < gridSize - 1 ? grid[y + 1][x] : null;
      const D = x > 0 ? grid[y][x - 1] : null;

      let p1 = P, p2 = P, p3 = P, p4 = P;
      if (C === D && C !== A && D !== B && C) p3 = C;
      if (D === A && D !== C && A !== B && D) p1 = D;
      if (A === B && A !== D && B !== C && A) p2 = A;
      if (B === C && B !== A && C !== D && B) p4 = B;

      newGrid[y * 2][x * 2] = p1;
      newGrid[y * 2][x * 2 + 1] = p2;
      newGrid[y * 2 + 1][x * 2] = p3;
      newGrid[y * 2 + 1][x * 2 + 1] = p4;
    }
  }
  return { grid: newGrid, gridSize: newG };
}

let _uhdEnabledOverride = null;
// isHDEnabled()/isUHDEnabled() sit on the per-blit hot path
// (buildSpriteBitmap() runs ~4x per unit per frame). Their inputs - the URL
// query string and localStorage - cannot change during a page's lifetime
// except through setHDEnabled()/setUHDEnabled() below, so the resolved value
// is memoised (only once `window` exists, so node test runs that import this
// module before defining a window stay correct).
let _uhdResolved = null;

export function isUHDEnabled() {
  if (_uhdEnabledOverride !== null) return _uhdEnabledOverride;
  if (_uhdResolved !== null) return _uhdResolved;
  const v = _resolveUHDEnabled();
  if (typeof window !== 'undefined' && window.location) _uhdResolved = v;
  return v;
}

function _resolveUHDEnabled() {
  if (typeof window !== 'undefined' && window.location) {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.has('uhd')) {
        const v = params.get('uhd');
        if (v === '0' || v === 'false') return false;
        if (v === '1' || v === 'true' || v === '' || v === 'smooth' || v === 'nearest') return true;
      }
      if (params.get('res') === '48' || params.get('marine48') === '1' || params.get('sprites') === 'uhd') {
        return true;
      }
    } catch (_) {}
    try {
      if (window.localStorage) {
        const stored = window.localStorage.getItem('ucg_sprites_uhd');
        if (stored === '0') return false;
        if (stored === '1') return true;
      }
    } catch (_) {}
  }
  return false;
}

export function setUHDEnabled(enabled) {
  _uhdEnabledOverride = !!enabled;
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem('ucg_sprites_uhd', _uhdEnabledOverride ? '1' : '0');
    } catch (_) {}
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('ucg_hd_mode_changed', { detail: { uhd: _uhdEnabledOverride } }));
  }
}

export function getUHDFilter() {
  if (typeof window !== 'undefined' && window.location) {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('uhd') === 'nearest' || params.get('filter') === 'nearest') return 'nearest';
    } catch (_) {}
  }
  return 'smooth';
}

function getUHD_Marine_Torso() {
  const base = getHD_Marine_Torso();
  return getUHDFilter() === 'nearest' ? upscaleGrid2x(base) : upscaleGridEPX(base);
}
function getUHD_Marine_Gun() {
  const base = getHD_Marine_Gun();
  return getUHDFilter() === 'nearest' ? upscaleGrid2x(base) : upscaleGridEPX(base);
}
function getUHD_Marine_Legs() {
  const base = getHD_Marine_Legs();
  return getUHDFilter() === 'nearest' ? upscaleGrid2x(base) : upscaleGridEPX(base);
}
function getUHD_Marine_Legs_Walk1() {
  const base = getHD_Marine_Legs_Walk1();
  return getUHDFilter() === 'nearest' ? upscaleGrid2x(base) : upscaleGridEPX(base);
}
function getUHD_Marine_Legs_Walk2() {
  const base = getHD_Marine_Legs_Walk2();
  return getUHDFilter() === 'nearest' ? upscaleGrid2x(base) : upscaleGridEPX(base);
}
function getUHD_Marine_Legs_Walk3() {
  const base = getHD_Marine_Legs_Walk3();
  return getUHDFilter() === 'nearest' ? upscaleGrid2x(base) : upscaleGridEPX(base);
}
function getUHD_Marine_Legs_Walk4() {
  const base = getHD_Marine_Legs_Walk4();
  return getUHDFilter() === 'nearest' ? upscaleGrid2x(base) : upscaleGridEPX(base);
}
function getUHD_Marine_Legs_Walk5() {
  const base = getHD_Marine_Legs_Walk5();
  return getUHDFilter() === 'nearest' ? upscaleGrid2x(base) : upscaleGridEPX(base);
}
function getUHD_Marine_Legs_Walk6() {
  const base = getHD_Marine_Legs_Walk6();
  return getUHDFilter() === 'nearest' ? upscaleGrid2x(base) : upscaleGridEPX(base);
}
function getUHD_Marine() {
  const base = getHD_Marine();
  return getUHDFilter() === 'nearest' ? upscaleGrid2x(base) : upscaleGridEPX(base);
}
function getUHD_Marine_Parachute() {
  const base = getHD_Marine_Parachute();
  return getUHDFilter() === 'nearest' ? upscaleGrid2x(base) : upscaleGridEPX(base);
}

const UHD_SPRITE_REGISTRY = {
  ..._UHD_PB_SPRITE_MAP,
  'Marine': getUHD_Marine,
  'Marine_Torso': getUHD_Marine_Torso,
  'Marine_Gun': getUHD_Marine_Gun,
  'Marine_Legs': getUHD_Marine_Legs,
  'Marine_Legs_Walk1': getUHD_Marine_Legs_Walk1,
  'Marine_Legs_Walk2': getUHD_Marine_Legs_Walk2,
  'Marine_Legs_Walk3': getUHD_Marine_Legs_Walk3,
  'Marine_Legs_Walk4': getUHD_Marine_Legs_Walk4,
  'Marine_Legs_Walk5': getUHD_Marine_Legs_Walk5,
  'Marine_Legs_Walk6': getUHD_Marine_Legs_Walk6,
  'Marine_Parachute': getUHD_Marine_Parachute,

  // The Salvage Company (48x48 UHD Native Relaunch)
  'TheSalvageCompany': getHD_TheSalvageCompany,
  'TheSalvageCompany_Chassis': () => getHD_TheSalvageCompany_Chassis(0),
  'TheSalvageCompany_Chassis_Stand': () => getHD_TheSalvageCompany_Chassis(0),
  'TheSalvageCompany_Chassis_Roll1': getHD_TheSalvageCompany_Chassis_Roll1,
  'TheSalvageCompany_Chassis_Roll2': getHD_TheSalvageCompany_Chassis_Roll2,
  'TheSalvageCompany_Chassis_Roll3': getHD_TheSalvageCompany_Chassis_Roll3,
  'TheSalvageCompany_Chassis_Roll4': getHD_TheSalvageCompany_Chassis_Roll4,
  'TheSalvageCompany_Chassis_Roll5': getHD_TheSalvageCompany_Chassis_Roll5,
  'TheSalvageCompany_Chassis_Roll6': getHD_TheSalvageCompany_Chassis_Roll6,
  'TheSalvageCompany_Arm_Rest': getHD_TheSalvageCompany_Arm_Rest,
  'TheSalvageCompany_Arm_Reach': getHD_TheSalvageCompany_Arm_Reach,
  'TheSalvageCompany_Arm_Grab': getHD_TheSalvageCompany_Arm_Grab,
  'TheSalvageCompany_Arm_Lift': getHD_TheSalvageCompany_Arm_Lift,
  'TheSalvageCompany_Arm_Dump': getHD_TheSalvageCompany_Arm_Dump,
  // Pink Beret (48x48 UHD Native Relaunch)
  'PinkBeret': getUHD_PinkBeret,
  'PinkBeret_Stand': getUHD_PinkBeret_Stand,
  'PinkBeret_Torso': getUHD_PinkBeret_Torso,
  'PinkBeret_Torso_Turn': getUHD_PinkBeret_Torso_Turn,
  'PinkBeret_Legs': () => getUHD_PinkBeret_Legs(0),
  'PinkBeret_Legs_Stand': () => getUHD_PinkBeret_Legs(0),
  'PinkBeret_Legs_Tap': () => getUHD_PinkBeret_Legs('tap'),
  'PinkBeret_Legs_Dance1': () => getUHD_PinkBeret_Legs('dance1'),
  'PinkBeret_Legs_Dance2': () => getUHD_PinkBeret_Legs('dance2'),
  'PinkBeret_Legs_Dance3': () => getUHD_PinkBeret_Legs('dance3'),
  'PinkBeret_Legs_Dance4': () => getUHD_PinkBeret_Legs('dance4'),
  'PinkBeret_Legs_Walk1': () => getUHD_PinkBeret_Walk_Armed(1),
  'PinkBeret_Legs_Walk2': () => getUHD_PinkBeret_Walk_Armed(2),
  'PinkBeret_Legs_Walk3': () => getUHD_PinkBeret_Walk_Armed(3),
  'PinkBeret_Legs_Walk4': () => getUHD_PinkBeret_Walk_Armed(4),
  'PinkBeret_Legs_Walk5': () => getUHD_PinkBeret_Walk_Armed(5),
  'PinkBeret_Legs_Walk6': () => getUHD_PinkBeret_Walk_Armed(6),
  'PinkBeret_Legs_Walk7': () => getUHD_PinkBeret_Walk_Armed(7),
  'PinkBeret_Legs_Walk8': () => getUHD_PinkBeret_Walk_Armed(8),
  'PinkBeret_Walk_Armed1': () => getUHD_PinkBeret_Walk_Armed(1),
  'PinkBeret_Walk_Armed2': () => getUHD_PinkBeret_Walk_Armed(2),
  'PinkBeret_Walk_Armed3': () => getUHD_PinkBeret_Walk_Armed(3),
  'PinkBeret_Walk_Armed4': () => getUHD_PinkBeret_Walk_Armed(4),
  'PinkBeret_Walk_Armed5': () => getUHD_PinkBeret_Walk_Armed(5),
  'PinkBeret_Walk_Armed6': () => getUHD_PinkBeret_Walk_Armed(6),
  'PinkBeret_Walk_Armed7': () => getUHD_PinkBeret_Walk_Armed(7),
  'PinkBeret_Walk_Armed8': () => getUHD_PinkBeret_Walk_Armed(8),
  'PinkBeret_Walk_Armed9': () => getUHD_PinkBeret_Walk_Armed(9),
  'PinkBeret_Walk_Armed10': () => getUHD_PinkBeret_Walk_Armed(10),
  'PinkBeret_Walk_Armed11': () => getUHD_PinkBeret_Walk_Armed(11),
  'PinkBeret_Walk_Armed12': () => getUHD_PinkBeret_Walk_Armed(12),
  'PinkBeret_Walk_Armed13': () => getUHD_PinkBeret_Walk_Armed(13),
  'PinkBeret_Walk_Armed14': () => getUHD_PinkBeret_Walk_Armed(14),
  'PinkBeret_Walk_Armed15': () => getUHD_PinkBeret_Walk_Armed(15),
  'PinkBeret_Walk_Armed16': () => getUHD_PinkBeret_Walk_Armed(16),
  'PinkBeret_Walk_Armed17': () => getUHD_PinkBeret_Walk_Armed(17),
  'PinkBeret_Walk_Armed18': () => getUHD_PinkBeret_Walk_Armed(18),
  'PinkBeret_Walk_Armed19': () => getUHD_PinkBeret_Walk_Armed(19),
  'PinkBeret_Walk_Armed20': () => getUHD_PinkBeret_Walk_Armed(20),
  'PinkBeret_Walk_Armed21': () => getUHD_PinkBeret_Walk_Armed(21),
  'PinkBeret_Walk_Armed22': () => getUHD_PinkBeret_Walk_Armed(22),
  'PinkBeret_Walk_Armed23': () => getUHD_PinkBeret_Walk_Armed(23),
  'PinkBeret_Walk_Armed24': () => getUHD_PinkBeret_Walk_Armed(24),
  'PinkBeret_Walk_Armed25': () => getUHD_PinkBeret_Walk_Armed(25),
  'PinkBeret_Walk_Armed26': () => getUHD_PinkBeret_Walk_Armed(26),
  'PinkBeret_Walk_Armed27': () => getUHD_PinkBeret_Walk_Armed(27),
  'PinkBeret_Walk_Armed28': () => getUHD_PinkBeret_Walk_Armed(28),
  'PinkBeret_Walk_Armed29': () => getUHD_PinkBeret_Walk_Armed(29),
  'PinkBeret_Walk_Armed30': () => getUHD_PinkBeret_Walk_Armed(30),
  'PinkBeret_Walk_Armed31': () => getUHD_PinkBeret_Walk_Armed(31),
  'PinkBeret_Walk_Armed32': () => getUHD_PinkBeret_Walk_Armed(32),
  'PinkBeret_Walk1': () => getUHD_PinkBeret_Walk(1),
  'PinkBeret_Walk2': () => getUHD_PinkBeret_Walk(2),
  'PinkBeret_Walk3': () => getUHD_PinkBeret_Walk(3),
  'PinkBeret_Walk4': () => getUHD_PinkBeret_Walk(4),
  'PinkBeret_Walk5': () => getUHD_PinkBeret_Walk(5),
  'PinkBeret_Walk6': () => getUHD_PinkBeret_Walk(6),
  'PinkBeret_Walk7': () => getUHD_PinkBeret_Walk(7),
  'PinkBeret_Walk8': () => getUHD_PinkBeret_Walk(8),
  'PinkBeret_Walk9': () => getUHD_PinkBeret_Walk(9),
  'PinkBeret_Walk10': () => getUHD_PinkBeret_Walk(10),
  'PinkBeret_Walk11': () => getUHD_PinkBeret_Walk(11),
  'PinkBeret_Walk12': () => getUHD_PinkBeret_Walk(12),
  'PinkBeret_Walk13': () => getUHD_PinkBeret_Walk(13),
  'PinkBeret_Walk14': () => getUHD_PinkBeret_Walk(14),
  'PinkBeret_Walk15': () => getUHD_PinkBeret_Walk(15),
  'PinkBeret_Walk16': () => getUHD_PinkBeret_Walk(16),
  'PinkBeret_Walk17': () => getUHD_PinkBeret_Walk(17),
  'PinkBeret_Walk18': () => getUHD_PinkBeret_Walk(18),
  'PinkBeret_Walk19': () => getUHD_PinkBeret_Walk(19),
  'PinkBeret_Walk20': () => getUHD_PinkBeret_Walk(20),
  'PinkBeret_Walk21': () => getUHD_PinkBeret_Walk(21),
  'PinkBeret_Walk22': () => getUHD_PinkBeret_Walk(22),
  'PinkBeret_Walk23': () => getUHD_PinkBeret_Walk(23),
  'PinkBeret_Walk24': () => getUHD_PinkBeret_Walk(24),
  'PinkBeret_Walk25': () => getUHD_PinkBeret_Walk(25),
  'PinkBeret_Walk26': () => getUHD_PinkBeret_Walk(26),
  'PinkBeret_Walk27': () => getUHD_PinkBeret_Walk(27),
  'PinkBeret_Walk28': () => getUHD_PinkBeret_Walk(28),
  'PinkBeret_Walk29': () => getUHD_PinkBeret_Walk(29),
  'PinkBeret_Walk30': () => getUHD_PinkBeret_Walk(30),
  'PinkBeret_Walk31': () => getUHD_PinkBeret_Walk(31),
  'PinkBeret_Walk32': () => getUHD_PinkBeret_Walk(32),
  'PinkBeret_Gunfire': getUHD_PinkBeret_Gunfire,
  'PinkBeret_Launcher_Aim45': getUHD_PinkBeret_Launcher_Aim45,
  'PinkBeret_Launcher_Fire': getUHD_PinkBeret_Launcher_Fire,
  'PinkBeret_Launcher_Prop': getUHD_PinkBeret_Launcher_Prop,
  'PinkBeret_Launcher_Carry': getUHD_PinkBeret_Launcher_Carry,
  'PinkBeret_Front_Kiss': getUHD_PinkBeret_Front_Kiss,
  'PinkBeret_Front_Wink': getUHD_PinkBeret_Front_Wink,
  'PinkBeret_Front_Turn': getUHD_PinkBeret_Front_Turn,

  // Pink Beret Gold (48x48 UHD Native Relaunch)
  'PinkBeretGold': getUHD_PinkBeretGold,
  'PinkBeretGold_Stand': getUHD_PinkBeretGold_Stand,
  'PinkBeretGold_Torso': getUHD_PinkBeretGold_Torso,
  'PinkBeretGold_Torso_Turn': getUHD_PinkBeretGold_Torso_Turn,
  'PinkBeretGold_Legs': () => getUHD_PinkBeretGold_Legs(0),
  'PinkBeretGold_Legs_Stand': () => getUHD_PinkBeretGold_Legs(0),
  'PinkBeretGold_Legs_Tap': () => getUHD_PinkBeretGold_Legs('tap'),
  'PinkBeretGold_Legs_Dance1': () => getUHD_PinkBeretGold_Legs_Dance1(),
  'PinkBeretGold_Legs_Dance2': () => getUHD_PinkBeretGold_Legs_Dance2(),
  'PinkBeretGold_Legs_Dance3': () => getUHD_PinkBeretGold_Legs_Dance3(),
  'PinkBeretGold_Legs_Dance4': () => getUHD_PinkBeretGold_Legs_Dance4(),
  'PinkBeretGold_Legs_Walk1': () => getUHD_PinkBeretGold_Walk_Armed(1),
  'PinkBeretGold_Legs_Walk2': () => getUHD_PinkBeretGold_Walk_Armed(2),
  'PinkBeretGold_Legs_Walk3': () => getUHD_PinkBeretGold_Walk_Armed(3),
  'PinkBeretGold_Legs_Walk4': () => getUHD_PinkBeretGold_Walk_Armed(4),
  'PinkBeretGold_Legs_Walk5': () => getUHD_PinkBeretGold_Walk_Armed(5),
  'PinkBeretGold_Legs_Walk6': () => getUHD_PinkBeretGold_Walk_Armed(6),
  'PinkBeretGold_Legs_Walk7': () => getUHD_PinkBeretGold_Walk_Armed(7),
  'PinkBeretGold_Legs_Walk8': () => getUHD_PinkBeretGold_Walk_Armed(8),
  'PinkBeretGold_Walk_Armed1': () => getUHD_PinkBeretGold_Walk_Armed(1),
  'PinkBeretGold_Walk_Armed2': () => getUHD_PinkBeretGold_Walk_Armed(2),
  'PinkBeretGold_Walk_Armed3': () => getUHD_PinkBeretGold_Walk_Armed(3),
  'PinkBeretGold_Walk_Armed4': () => getUHD_PinkBeretGold_Walk_Armed(4),
  'PinkBeretGold_Walk_Armed5': () => getUHD_PinkBeretGold_Walk_Armed(5),
  'PinkBeretGold_Walk_Armed6': () => getUHD_PinkBeretGold_Walk_Armed(6),
  'PinkBeretGold_Walk_Armed7': () => getUHD_PinkBeretGold_Walk_Armed(7),
  'PinkBeretGold_Walk_Armed8': () => getUHD_PinkBeretGold_Walk_Armed(8),
  'PinkBeretGold_Walk_Armed9': () => getUHD_PinkBeretGold_Walk_Armed(9),
  'PinkBeretGold_Walk_Armed10': () => getUHD_PinkBeretGold_Walk_Armed(10),
  'PinkBeretGold_Walk_Armed11': () => getUHD_PinkBeretGold_Walk_Armed(11),
  'PinkBeretGold_Walk_Armed12': () => getUHD_PinkBeretGold_Walk_Armed(12),
  'PinkBeretGold_Walk_Armed13': () => getUHD_PinkBeretGold_Walk_Armed(13),
  'PinkBeretGold_Walk_Armed14': () => getUHD_PinkBeretGold_Walk_Armed(14),
  'PinkBeretGold_Walk_Armed15': () => getUHD_PinkBeretGold_Walk_Armed(15),
  'PinkBeretGold_Walk_Armed16': () => getUHD_PinkBeretGold_Walk_Armed(16),
  'PinkBeretGold_Walk_Armed17': () => getUHD_PinkBeretGold_Walk_Armed(17),
  'PinkBeretGold_Walk_Armed18': () => getUHD_PinkBeretGold_Walk_Armed(18),
  'PinkBeretGold_Walk_Armed19': () => getUHD_PinkBeretGold_Walk_Armed(19),
  'PinkBeretGold_Walk_Armed20': () => getUHD_PinkBeretGold_Walk_Armed(20),
  'PinkBeretGold_Walk_Armed21': () => getUHD_PinkBeretGold_Walk_Armed(21),
  'PinkBeretGold_Walk_Armed22': () => getUHD_PinkBeretGold_Walk_Armed(22),
  'PinkBeretGold_Walk_Armed23': () => getUHD_PinkBeretGold_Walk_Armed(23),
  'PinkBeretGold_Walk_Armed24': () => getUHD_PinkBeretGold_Walk_Armed(24),
  'PinkBeretGold_Walk_Armed25': () => getUHD_PinkBeretGold_Walk_Armed(25),
  'PinkBeretGold_Walk_Armed26': () => getUHD_PinkBeretGold_Walk_Armed(26),
  'PinkBeretGold_Walk_Armed27': () => getUHD_PinkBeretGold_Walk_Armed(27),
  'PinkBeretGold_Walk_Armed28': () => getUHD_PinkBeretGold_Walk_Armed(28),
  'PinkBeretGold_Walk_Armed29': () => getUHD_PinkBeretGold_Walk_Armed(29),
  'PinkBeretGold_Walk_Armed30': () => getUHD_PinkBeretGold_Walk_Armed(30),
  'PinkBeretGold_Walk_Armed31': () => getUHD_PinkBeretGold_Walk_Armed(31),
  'PinkBeretGold_Walk_Armed32': () => getUHD_PinkBeretGold_Walk_Armed(32),
  'PinkBeretGold_Walk1': () => getUHD_PinkBeretGold_Walk(1),
  'PinkBeretGold_Walk2': () => getUHD_PinkBeretGold_Walk(2),
  'PinkBeretGold_Walk3': () => getUHD_PinkBeretGold_Walk(3),
  'PinkBeretGold_Walk4': () => getUHD_PinkBeretGold_Walk(4),
  'PinkBeretGold_Walk5': () => getUHD_PinkBeretGold_Walk(5),
  'PinkBeretGold_Walk6': () => getUHD_PinkBeretGold_Walk(6),
  'PinkBeretGold_Walk7': () => getUHD_PinkBeretGold_Walk(7),
  'PinkBeretGold_Walk8': () => getUHD_PinkBeretGold_Walk(8),
  'PinkBeretGold_Walk9': () => getUHD_PinkBeretGold_Walk(9),
  'PinkBeretGold_Walk10': () => getUHD_PinkBeretGold_Walk(10),
  'PinkBeretGold_Walk11': () => getUHD_PinkBeretGold_Walk(11),
  'PinkBeretGold_Walk12': () => getUHD_PinkBeretGold_Walk(12),
  'PinkBeretGold_Walk13': () => getUHD_PinkBeretGold_Walk(13),
  'PinkBeretGold_Walk14': () => getUHD_PinkBeretGold_Walk(14),
  'PinkBeretGold_Walk15': () => getUHD_PinkBeretGold_Walk(15),
  'PinkBeretGold_Walk16': () => getUHD_PinkBeretGold_Walk(16),
  'PinkBeretGold_Walk17': () => getUHD_PinkBeretGold_Walk(17),
  'PinkBeretGold_Walk18': () => getUHD_PinkBeretGold_Walk(18),
  'PinkBeretGold_Walk19': () => getUHD_PinkBeretGold_Walk(19),
  'PinkBeretGold_Walk20': () => getUHD_PinkBeretGold_Walk(20),
  'PinkBeretGold_Walk21': () => getUHD_PinkBeretGold_Walk(21),
  'PinkBeretGold_Walk22': () => getUHD_PinkBeretGold_Walk(22),
  'PinkBeretGold_Walk23': () => getUHD_PinkBeretGold_Walk(23),
  'PinkBeretGold_Walk24': () => getUHD_PinkBeretGold_Walk(24),
  'PinkBeretGold_Walk25': () => getUHD_PinkBeretGold_Walk(25),
  'PinkBeretGold_Walk26': () => getUHD_PinkBeretGold_Walk(26),
  'PinkBeretGold_Walk27': () => getUHD_PinkBeretGold_Walk(27),
  'PinkBeretGold_Walk28': () => getUHD_PinkBeretGold_Walk(28),
  'PinkBeretGold_Walk29': () => getUHD_PinkBeretGold_Walk(29),
  'PinkBeretGold_Walk30': () => getUHD_PinkBeretGold_Walk(30),
  'PinkBeretGold_Walk31': () => getUHD_PinkBeretGold_Walk(31),
  'PinkBeretGold_Walk32': () => getUHD_PinkBeretGold_Walk(32),
  'PinkBeretGold_Gunfire': getUHD_PinkBeretGold_Gunfire,
  'PinkBeretGold_Launcher_Aim45': getUHD_PinkBeretGold_Launcher_Aim45,
  'PinkBeretGold_Launcher_Fire': getUHD_PinkBeretGold_Launcher_Fire,
  'PinkBeretGold_Launcher_Prop': getUHD_PinkBeretGold_Launcher_Prop,
  'PinkBeretGold_Launcher_Carry': getUHD_PinkBeretGold_Launcher_Carry,
  'PinkBeretGold_Front_Kiss': getUHD_PinkBeretGold_Front_Kiss,
  'PinkBeretGold_Front_Wink': getUHD_PinkBeretGold_Front_Wink,
  'PinkBeretGold_Front_Turn': getUHD_PinkBeretGold_Front_Turn
};

// ── RUNTIME HD MODE CONTROLLER ────────────────────────────────
let _hdEnabledOverride = null;
let _hdResolved = null; // memoised URL/localStorage resolution, see _uhdResolved

export function isHDEnabled() {
  if (_hdEnabledOverride !== null) return _hdEnabledOverride;
  if (_hdResolved !== null) return _hdResolved;
  const v = _resolveHDEnabled();
  if (typeof window !== 'undefined' && window.location) _hdResolved = v;
  return v;
}

function _resolveHDEnabled() {
  if (typeof window !== 'undefined' && window.location) {
    try {
      const params = new URLSearchParams(window.location.search);
      // Explicit opt-out to SD legacy mode
      if (params.has('sd')) {
        const v = params.get('sd');
        if (v === '1' || v === 'true' || v === '') return false;
        if (v === '0' || v === 'false') return true;
      }
      if (params.get('sprites') === 'sd') return false;

      // Explicit ?hd override (?hd=0 forces SD, ?hd=1 forces HD)
      if (params.has('hd')) {
        const v = params.get('hd');
        if (v === '0' || v === 'false') return false;
        if (v === '1' || v === 'true' || v === '') return true;
      }
      if (params.get('sprites') === 'hd') return true;
    } catch (_) {}
    try {
      if (window.localStorage) {
        const stored = window.localStorage.getItem('ucg_sprites_hd');
        if (stored === '0') return false;
        if (stored === '1') return true;
      }
    } catch (_) {}
  }
  // Default is HD (24×24) project-wide
  return true;
}

export function setHDEnabled(enabled) {
  _hdEnabledOverride = !!enabled;
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem('ucg_sprites_hd', _hdEnabledOverride ? '1' : '0');
    } catch (_) {}
  }
  // Clear cached canvases so active bitmaps immediately re-render in the chosen mode
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('ucg_hd_mode_changed', { detail: { hd: _hdEnabledOverride } }));
  }
}

export function hasHDSprite(unitType) {
  if (isUHDEnabled() && Object.prototype.hasOwnProperty.call(UHD_SPRITE_REGISTRY, unitType)) return true;
  if (Object.prototype.hasOwnProperty.call(HD_SPRITE_REGISTRY, unitType)) return true;
  return Object.prototype.hasOwnProperty.call(UHD_SPRITE_REGISTRY, unitType);
}

export function getHDSpriteGrid(unitType) {
  if (isUHDEnabled() && Object.prototype.hasOwnProperty.call(UHD_SPRITE_REGISTRY, unitType)) {
    return UHD_SPRITE_REGISTRY[unitType]();
  }
  if (Object.prototype.hasOwnProperty.call(HD_SPRITE_REGISTRY, unitType)) {
    return HD_SPRITE_REGISTRY[unitType]();
  }
  if (Object.prototype.hasOwnProperty.call(UHD_SPRITE_REGISTRY, unitType)) {
    return UHD_SPRITE_REGISTRY[unitType]();
  }
  return null;
}

export {
  makeGrid, makeGrid24, makeGrid36, makeGrid48, HD_SPRITE_REGISTRY, UHD_SPRITE_REGISTRY,
  getHD_Hacker, getHD_Hacker_Frontal,
  getHD_PreserverLock, getHD_PreserverLock_Carapace, getHD_PreserverLock_Tower, getHD_PreserverLock_Legs, getHD_PreserverLock_Body,
  getHD_BastionLock, getHD_BastionLock_Deployed, getHD_BastionLock_Body, getHD_BastionLock_Shield_Back, getHD_BastionLock_Shield_Front,
  getHD_BastionLock_Legs, getHD_BastionLock_Legs_Stand, getHD_BastionLock_Legs_Walk1, getHD_BastionLock_Legs_Walk2, getHD_BastionLock_Legs_Walk3, getHD_BastionLock_Legs_Walk4,
  getHD_PinkBeret, getHD_PinkBeret_Torso, getHD_PinkBeret_Torso_Turn, getHD_PinkBeret_Arm_Rear,
  getHD_PinkBeret_Legs, getHD_PinkBeret_Legs_Stand, getHD_PinkBeret_Legs_Tap, getHD_PinkBeret_Legs_Crouch,
  getHD_PinkBeret_Legs_Heave, getHD_PinkBeret_Legs_Aim,
  getHD_PinkBeret_Legs_Walk1, getHD_PinkBeret_Legs_Walk2, getHD_PinkBeret_Legs_Walk3,
  getHD_PinkBeret_Legs_Walk4, getHD_PinkBeret_Legs_Walk5, getHD_PinkBeret_Legs_Walk6,
  getHD_PinkBeret_Launcher_Carry, getHD_PinkBeret_Launcher_Lift, getHD_PinkBeret_Launcher_Heave,
  getHD_PinkBeret_Launcher_Mount, getHD_PinkBeret_Launcher_Aim45, getHD_PinkBeret_Pistol,
  getHD_PinkBeret_Kiss, getHD_PinkBeret_Front_Turn, getHD_PinkBeret_Front_Kiss, getHD_PinkBeret_Front_Wink,
  getHD_PinkBeretGold, getHD_PinkBeretGold_Torso, getHD_PinkBeretGold_Torso_Turn, getHD_PinkBeretGold_Arm_Rear,
  getHD_PinkBeretGold_Legs, getHD_PinkBeretGold_Legs_Stand, getHD_PinkBeretGold_Legs_Tap, getHD_PinkBeretGold_Legs_Crouch,
  getHD_PinkBeretGold_Legs_Heave, getHD_PinkBeretGold_Legs_Aim,
  getHD_PinkBeretGold_Legs_Walk1, getHD_PinkBeretGold_Legs_Walk2, getHD_PinkBeretGold_Legs_Walk3,
  getHD_PinkBeretGold_Legs_Walk4, getHD_PinkBeretGold_Legs_Walk5, getHD_PinkBeretGold_Legs_Walk6,
  getHD_PinkBeretGold_Launcher_Carry, getHD_PinkBeretGold_Launcher_Lift, getHD_PinkBeretGold_Launcher_Heave,
  getHD_PinkBeretGold_Launcher_Mount, getHD_PinkBeretGold_Launcher_Aim45, getHD_PinkBeretGold_Pistol,
  getHD_PinkBeretGold_Kiss, getHD_PinkBeretGold_Front_Turn, getHD_PinkBeretGold_Front_Kiss, getHD_PinkBeretGold_Front_Wink,
  getUHD_PinkBeret, getUHD_PinkBeret_Stand, getUHD_PinkBeret_Torso, getUHD_PinkBeret_Torso_Turn,
  getUHD_PinkBeret_Legs, getUHD_PinkBeret_Legs_Stand, getUHD_PinkBeret_Legs_Tap, getUHD_PinkBeret_Legs_Dance1, getUHD_PinkBeret_Legs_Dance2, getUHD_PinkBeret_Legs_Dance3, getUHD_PinkBeret_Legs_Dance4,
  getUHD_PinkBeret_Front_Kiss, getUHD_PinkBeret_Front_Wink, getUHD_PinkBeret_Front_Turn,
  getUHD_PinkBeretGold_Front_Kiss, getUHD_PinkBeretGold_Front_Wink, getUHD_PinkBeretGold_Front_Turn,
  getUHD_PinkBeret_Walk, getUHD_PinkBeret_Walk_Armed, getUHD_PinkBeret_Gunfire,
  getUHD_PinkBeret_Launcher_Aim45, getUHD_PinkBeret_Launcher_Fire, getUHD_PinkBeret_Launcher_Prop, getUHD_PinkBeret_Launcher_Carry,
  getUHD_PinkBeretGold, getUHD_PinkBeretGold_Stand, getUHD_PinkBeretGold_Torso, getUHD_PinkBeretGold_Torso_Turn,
  getUHD_PinkBeretGold_Legs, getUHD_PinkBeretGold_Legs_Stand, getUHD_PinkBeretGold_Legs_Tap,
  getUHD_PinkBeretGold_Walk, getUHD_PinkBeretGold_Walk_Armed, getUHD_PinkBeretGold_Gunfire,
  getUHD_PinkBeretGold_Launcher_Aim45, getUHD_PinkBeretGold_Launcher_Fire, getUHD_PinkBeretGold_Launcher_Prop, getUHD_PinkBeretGold_Launcher_Carry,
  getHD_PinkBeret_V2_Stand, getHD_PinkBeret_V2_Torso, getHD_PinkBeret_V2_Torso_Turn,
  getHD_PinkBeret_V2_Legs, getHD_PinkBeret_V2_Walk_Armed, getHD_PinkBeret_V2_Gunfire,
  getHD_PinkBeret_V2_Launcher_Aim45, getHD_PinkBeret_V2_Launcher_Fire, getHD_PinkBeret_V2_Launcher_Prop
};
